/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  date: any;
  interval: any;
  jsonb: any;
  numeric: any;
  time: any;
  timestamp: any;
  timestamptz: any;
  unit_type: any;
  uuid: any;
};

export type ActivateSubscriptionInput = {
  account_id: Scalars['String'];
  id: Scalars['String'];
};

export type ActivateSubscriptionOutput = {
  __typename?: 'ActivateSubscriptionOutput';
  status: Scalars['String'];
  sucess: Scalars['Boolean'];
};

export type AuthDashboardTokenOutput = {
  __typename?: 'AuthDashboardTokenOutput';
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  cpf_cnpj?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  dashboard_token: Scalars['String'];
  district?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  token: Scalars['String'];
  zip_code?: Maybe<Scalars['String']>;
};

export type AuthSignInOrSignUpInput = {
  authCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  source: Scalars['String'];
  teamId?: InputMaybe<Scalars['Int']>;
};

export type AuthSignInOrSignUpOutput = {
  __typename?: 'AuthSignInOrSignUpOutput';
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  cpf_cnpj?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  dashboard_token?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  mode: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  passwordless: Scalars['Boolean'];
  phone?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  team_id: Scalars['Int'];
  team_name: Scalars['String'];
  token?: Maybe<Scalars['String']>;
  two_factor_authentication: Scalars['Boolean'];
  zip_code?: Maybe<Scalars['String']>;
};

export type AuthSigninInput = {
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  source: Scalars['String'];
};

export type AuthSigninOutput = {
  __typename?: 'AuthSigninOutput';
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  cpf_cnpj?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  passwordless: Scalars['Boolean'];
  phone?: Maybe<Scalars['String']>;
  refresh_token: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  team_id: Scalars['Int'];
  token: Scalars['String'];
  two_factor_authentication: Scalars['Boolean'];
  zip_code?: Maybe<Scalars['String']>;
};

export type AuthVerifyCodeInput = {
  code: Scalars['String'];
  user_id: Scalars['Int'];
};

export type AuthVerifyTokenOutput = {
  __typename?: 'AuthVerifyTokenOutput';
  token: Scalars['String'];
  verified: Scalars['Boolean'];
};

export type AvailableNumbersInput = {
  contains?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type AvailableNumbersOutput = {
  __typename?: 'AvailableNumbersOutput';
  addressRequirements?: Maybe<Scalars['String']>;
  beta?: Maybe<Scalars['Boolean']>;
  friendlyName?: Maybe<Scalars['String']>;
  isoCountry?: Maybe<Scalars['String']>;
  lata?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Int']>;
  locality?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rateCenter?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type ChargeBankSlipInput = {
  city: Scalars['String'];
  complement?: InputMaybe<Scalars['String']>;
  cpf_cnpj: Scalars['String'];
  customer_id: Scalars['String'];
  district: Scalars['String'];
  email: Scalars['String'];
  invoice_id: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['String'];
  phone: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
  zip_code: Scalars['String'];
};

export type ChargeBankSlipOutput = {
  __typename?: 'ChargeBankSlipOutput';
  identification: Scalars['String'];
  invoice_id: Scalars['String'];
  pdf: Scalars['String'];
  success: Scalars['Boolean'];
  url: Scalars['String'];
};

export type ChargeCreditCardInput = {
  customer_id: Scalars['String'];
  customer_payment_method_id: Scalars['String'];
  invoice_id: Scalars['String'];
};

export type ChargeCreditCardOutput = {
  __typename?: 'ChargeCreditCardOutput';
  LR: Scalars['String'];
  info_message: Scalars['String'];
  invoice_id: Scalars['String'];
  message: Scalars['String'];
  pdf: Scalars['String'];
  status: Scalars['String'];
  success: Scalars['Boolean'];
  url: Scalars['String'];
};

export type ContactAuthInput = {
  contact_id?: InputMaybe<Scalars['Int']>;
  uuid: Scalars['String'];
};

export type ContactAuthOutput = {
  __typename?: 'ContactAuthOutput';
  authenticated: Scalars['Boolean'];
  contact_name?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  keys?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_pic?: Maybe<Scalars['String']>;
};

export type CreateCustomerInput = {
  city: Scalars['String'];
  complement?: InputMaybe<Scalars['String']>;
  cpf_cnpj: Scalars['String'];
  district: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['String'];
  phone: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
  zip_code: Scalars['String'];
};

export type CreateCustomerOutput = {
  __typename?: 'CreateCustomerOutput';
  customer_id: Scalars['String'];
  email: Scalars['String'];
  user?: Maybe<Users>;
};

export type CreateCustomerPaymentMethodInput = {
  customer_id: Scalars['String'];
  cvc: Scalars['String'];
  expiry_month: Scalars['String'];
  expiry_year: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  number: Scalars['String'];
};

export type CreateCustomerPaymentMethodOutput = {
  __typename?: 'CreateCustomerPaymentMethodOutput';
  customer_payment_method_id: Scalars['String'];
};

export type CreateSubscriptionInput = {
  customer_id: Scalars['String'];
  discount?: InputMaybe<Scalars['String']>;
  plan_identifier: Scalars['String'];
  subitems_stringified?: InputMaybe<Scalars['String']>;
};

export type CreateSubscriptionOutput = {
  __typename?: 'CreateSubscriptionOutput';
  customer_id: Scalars['String'];
  id: Scalars['String'];
  invoice_due_date?: Maybe<Scalars['String']>;
  invoice_id?: Maybe<Scalars['String']>;
  invoice_secure_url?: Maybe<Scalars['String']>;
  invoice_status?: Maybe<Scalars['String']>;
  invoice_total?: Maybe<Scalars['String']>;
  plan_identifier: Scalars['String'];
  subitems_stringified?: Maybe<Scalars['String']>;
  subscription?: Maybe<Subscriptions>;
  user?: Maybe<Users>;
};

export type CsvDataRow = {
  __typename?: 'CsvDataRow';
  email?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  manager?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  send_contact_invite?: Maybe<Scalars['Boolean']>;
  send_manager_invite?: Maybe<Scalars['Boolean']>;
};

export type CsvDataRowInput = {
  email?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  manager?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  send_contact_invite?: InputMaybe<Scalars['Boolean']>;
  send_manager_invite?: InputMaybe<Scalars['Boolean']>;
};

export type CsvManagerRow = {
  email: Scalars['String'];
  group?: InputMaybe<Scalars['String']>;
  invite?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CsvRuleRow = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  policy: Scalars['String'];
  risk?: InputMaybe<Scalars['String']>;
  rule: Scalars['String'];
};

export type CurrentUser = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
};

export type Diff = {
  __typename?: 'Diff';
  new?: Maybe<Scalars['String']>;
  old?: Maybe<Scalars['String']>;
};

export type DiffConflict = {
  __typename?: 'DiffConflict';
  contact?: Maybe<DiffContact>;
  csvDataRows?: Maybe<Array<Maybe<CsvDataRow>>>;
  type?: Maybe<Scalars['String']>;
};

export type DiffContact = {
  __typename?: 'DiffContact';
  disabled?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type DiffManagerRow = {
  __typename?: 'DiffManagerRow';
  action: Scalars['String'];
  email: Scalars['String'];
  group?: Maybe<Diff>;
  invite?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Diff>;
  phone?: Maybe<Diff>;
};

export type DiffRow = {
  __typename?: 'DiffRow';
  action?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  group?: Maybe<Diff>;
  manager?: Maybe<Scalars['String']>;
  name?: Maybe<Diff>;
  phone?: Maybe<Diff>;
  send_contact_invite?: Maybe<Scalars['Boolean']>;
  send_manager_invite?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type DiffRuleRow = {
  __typename?: 'DiffRuleRow';
  action: Scalars['String'];
  description?: Maybe<Diff>;
  name?: Maybe<Diff>;
  policy?: Maybe<Diff>;
  risk?: Maybe<Diff>;
  rule?: Maybe<Diff>;
};

export type DiffUser = {
  __typename?: 'DiffUser';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type ExistingRule = {
  __typename?: 'ExistingRule';
  created_at: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  enable: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  policy_id?: Maybe<Scalars['Int']>;
  policy_name?: Maybe<Scalars['String']>;
  risk: Scalars['String'];
  rule: Scalars['String'];
  updated_at: Scalars['String'];
};

export type GetCustomerOutput = {
  __typename?: 'GetCustomerOutput';
  city: Scalars['String'];
  complement?: Maybe<Scalars['String']>;
  cpf_cnpj: Scalars['String'];
  district: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
  user?: Maybe<Users>;
  zip_code: Scalars['String'];
};

export type GetMessagesAnalysisInput = {
  agentIdentifier: Scalars['String'];
  agentPhone: Scalars['String'];
  analysisType?: InputMaybe<Scalars['String']>;
  complianceId: Scalars['Int'];
  contactPhone: Scalars['String'];
  endDate: Scalars['Int'];
  startDate: Scalars['Int'];
};

export type GetMessagesAnalysisOutput = {
  __typename?: 'GetMessagesAnalysisOutput';
  messagesAnalised?: Maybe<Scalars['String']>;
};

export type ImportCsvDiffOutput = {
  __typename?: 'ImportCsvDiffOutput';
  diffConflicts: Array<Maybe<DiffConflict>>;
  diffRows: Array<Maybe<DiffRow>>;
  groupsToCreate: Array<Maybe<Scalars['String']>>;
  usersToInsert: Array<Maybe<DiffUser>>;
};

export type ImportCsvManagersDiffOutput = {
  __typename?: 'ImportCsvManagersDiffOutput';
  diffManagerRows: Array<Maybe<DiffManagerRow>>;
};

export type ImportCsvManagersOutput = {
  __typename?: 'ImportCsvManagersOutput';
  success: Scalars['Boolean'];
};

export type ImportCsvOutput = {
  __typename?: 'ImportCsvOutput';
  success: Scalars['Boolean'];
};

export type ImportCsvRelevantContactsDiffOutput = {
  __typename?: 'ImportCsvRelevantContactsDiffOutput';
  relevantContactsDiff: Array<RelevantContactDiff>;
};

export type ImportCsvRelevantContactsOutput = {
  __typename?: 'ImportCsvRelevantContactsOutput';
  success: Scalars['Boolean'];
};

export type ImportCsvRulesDiffOutput = {
  __typename?: 'ImportCsvRulesDiffOutput';
  diffRuleRows: Array<DiffRuleRow>;
  policiesToInsert: Array<Scalars['String']>;
  rulesToInsert: Array<Scalars['String']>;
};

export type ImportCsvRulesOutput = {
  __typename?: 'ImportCsvRulesOutput';
  disabledRules: Array<Scalars['Int']>;
  insertedRules: Array<ExistingRule>;
};

export type InsertComplianceContactsInput = {
  compliance_id: Scalars['Int'];
  deleted?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type InsertComplianceContactsOutput = {
  __typename?: 'InsertComplianceContactsOutput';
  inserted_compliance_contacts: Array<InsertedComplianceContact>;
};

export type InsertedComplianceContact = {
  __typename?: 'InsertedComplianceContact';
  created_at: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invite_counter: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updated_at: Scalars['String'];
};

export type InsertedUser = {
  __typename?: 'InsertedUser';
  email: Scalars['String'];
  id: Scalars['Int'];
  invited?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type InvitingUser = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
};

export type LambdasScanContactMessagesInput = {
  contact_id: Scalars['Int'];
  days?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Scalars['Boolean']>;
  minutes?: InputMaybe<Scalars['Int']>;
  seconds?: InputMaybe<Scalars['Int']>;
};

export type LambdasScanContactMessagesOutput = {
  __typename?: 'LambdasScanContactMessagesOutput';
  contact_id: Scalars['Int'];
  new_messages?: Maybe<Scalars['Int']>;
  phone: Scalars['String'];
};

export type LogoutOutput = {
  __typename?: 'LogoutOutput';
  logout: Scalars['Boolean'];
};

export type NewSessionInput = {
  forceCloud: Scalars['Boolean'];
  project_name?: InputMaybe<Scalars['String']>;
  reconnect?: InputMaybe<Scalars['Boolean']>;
  uuid: Scalars['String'];
};

export type NewSessionOutput = {
  __typename?: 'NewSessionOutput';
  message: Scalars['String'];
};

export type PlanOutput = {
  __typename?: 'PlanOutput';
  created_at: Scalars['String'];
  currency: Scalars['String'];
  id: Scalars['String'];
  identifier: Scalars['String'];
  interval: Scalars['Int'];
  interval_type: Scalars['String'];
  max_cycles: Scalars['Int'];
  name: Scalars['String'];
  payable_with: Scalars['String'];
  updated_at: Scalars['String'];
  value_cents: Scalars['Int'];
};

export type RefreshJwtOutput = {
  __typename?: 'RefreshJwtOutput';
  token?: Maybe<Scalars['String']>;
};

export type RefreshWosOutput = {
  __typename?: 'RefreshWosOutput';
  token: Scalars['String'];
};

export type ReinviteContact = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type ReinviteContactsOutput = {
  __typename?: 'ReinviteContactsOutput';
  deleted?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invite_counter?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type RelevantContactDiff = {
  __typename?: 'RelevantContactDiff';
  action: Scalars['String'];
  name?: Maybe<Diff>;
  phone?: Maybe<Diff>;
  tags?: Maybe<Diff>;
};

export type RelevantContactsCsvRow = {
  name?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  tags?: InputMaybe<Scalars['String']>;
};

export type ResetPasswordInput = {
  confirm_new_password: Scalars['String'];
  hash: Scalars['String'];
  new_password: Scalars['String'];
};

export type ResetPasswordOutput = {
  __typename?: 'ResetPasswordOutput';
  email: Scalars['String'];
  id: Scalars['Int'];
};

export type ScanContactMessagesInput = {
  contact_id: Scalars['Int'];
  kind: Scalars['String'];
};

export type ScanContactMessagesOutput = {
  __typename?: 'ScanContactMessagesOutput';
  message: Scalars['String'];
};

export type ScanPageOpenInput = {
  uuid?: InputMaybe<Scalars['uuid']>;
};

export type ScanPageOpenOutput = {
  __typename?: 'ScanPageOpenOutput';
  success?: Maybe<Scalars['Boolean']>;
};

export type ScanQrcodeInput = {
  uuid?: InputMaybe<Scalars['uuid']>;
};

export type ScanQrcodeOutput = {
  __typename?: 'ScanQrcodeOutput';
  success?: Maybe<Scalars['Boolean']>;
};

export type ScanResult = {
  __typename?: 'ScanResult';
  success: Scalars['Boolean'];
};

export type SendWhatsAppAuthCodeInput = {
  mode: Scalars['String'];
  phone: Scalars['String'];
  user_id: Scalars['Int'];
};

export type SendWhatsAppAuthCodeOutput = {
  __typename?: 'SendWhatsAppAuthCodeOutput';
  error?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status: Scalars['String'];
};

export type SigninInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type SigninOutput = {
  __typename?: 'SigninOutput';
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  cpf_cnpj?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  refresh_token: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  team_id: Scalars['Int'];
  token: Scalars['String'];
  zip_code?: Maybe<Scalars['String']>;
};

export type SignupInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cpf_cnpj?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  source: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};

export type SignupOutput = {
  __typename?: 'SignupOutput';
  email: Scalars['String'];
  id: Scalars['Int'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInput = {
  city?: InputMaybe<Scalars['String']>;
  complement?: InputMaybe<Scalars['String']>;
  cpf_cnpj?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip_code?: InputMaybe<Scalars['String']>;
};

export type UpdateUserOutput = {
  __typename?: 'UpdateUserOutput';
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  cpf_cnpj?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip_code?: Maybe<Scalars['String']>;
};

export type UsersInsert = {
  email: Scalars['String'];
  invite?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  role_id: Scalars['Int'];
  team_id: Scalars['Int'];
};

export type UsersInsertOutput = {
  __typename?: 'UsersInsertOutput';
  inserted_users: Array<InsertedUser>;
};

export type UsersInvite = {
  email: Scalars['String'];
  team_id: Scalars['Int'];
};

export type UsersInviteOutput = {
  __typename?: 'UsersInviteOutput';
  invited_users: Array<Scalars['String']>;
};

export type VerifyWhatsAppInput = {
  mode: Scalars['String'];
  phone: Scalars['String'];
  token: Scalars['String'];
};

export type VerifyWhatsAppOutput = {
  __typename?: 'VerifyWhatsAppOutput';
  error?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status: Scalars['String'];
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "browser_sessions" */
export type Browser_Sessions = {
  __typename?: 'browser_sessions';
  browser_id: Scalars['uuid'];
  /** An object relationship */
  contact: Web_Contacts;
  contact_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "browser_sessions" */
export type Browser_Sessions_Aggregate = {
  __typename?: 'browser_sessions_aggregate';
  aggregate?: Maybe<Browser_Sessions_Aggregate_Fields>;
  nodes: Array<Browser_Sessions>;
};

/** aggregate fields of "browser_sessions" */
export type Browser_Sessions_Aggregate_Fields = {
  __typename?: 'browser_sessions_aggregate_fields';
  avg?: Maybe<Browser_Sessions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Browser_Sessions_Max_Fields>;
  min?: Maybe<Browser_Sessions_Min_Fields>;
  stddev?: Maybe<Browser_Sessions_Stddev_Fields>;
  stddev_pop?: Maybe<Browser_Sessions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Browser_Sessions_Stddev_Samp_Fields>;
  sum?: Maybe<Browser_Sessions_Sum_Fields>;
  var_pop?: Maybe<Browser_Sessions_Var_Pop_Fields>;
  var_samp?: Maybe<Browser_Sessions_Var_Samp_Fields>;
  variance?: Maybe<Browser_Sessions_Variance_Fields>;
};


/** aggregate fields of "browser_sessions" */
export type Browser_Sessions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Browser_Sessions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Browser_Sessions_Avg_Fields = {
  __typename?: 'browser_sessions_avg_fields';
  contact_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "browser_sessions". All fields are combined with a logical 'AND'. */
export type Browser_Sessions_Bool_Exp = {
  _and?: InputMaybe<Array<Browser_Sessions_Bool_Exp>>;
  _not?: InputMaybe<Browser_Sessions_Bool_Exp>;
  _or?: InputMaybe<Array<Browser_Sessions_Bool_Exp>>;
  browser_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact?: InputMaybe<Web_Contacts_Bool_Exp>;
  contact_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "browser_sessions" */
export enum Browser_Sessions_Constraint {
  /** unique or primary key constraint on columns "browser_id" */
  BrowserSessionsBrowserIdKey = 'browser_sessions_browser_id_key',
  /** unique or primary key constraint on columns "contact_id" */
  BrowserSessionsContactIdKey = 'browser_sessions_contact_id_key',
  /** unique or primary key constraint on columns "id" */
  BrowserSessionsPkey = 'browser_sessions_pkey'
}

/** input type for incrementing numeric columns in table "browser_sessions" */
export type Browser_Sessions_Inc_Input = {
  contact_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "browser_sessions" */
export type Browser_Sessions_Insert_Input = {
  browser_id?: InputMaybe<Scalars['uuid']>;
  contact?: InputMaybe<Web_Contacts_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Browser_Sessions_Max_Fields = {
  __typename?: 'browser_sessions_max_fields';
  browser_id?: Maybe<Scalars['uuid']>;
  contact_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Browser_Sessions_Min_Fields = {
  __typename?: 'browser_sessions_min_fields';
  browser_id?: Maybe<Scalars['uuid']>;
  contact_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "browser_sessions" */
export type Browser_Sessions_Mutation_Response = {
  __typename?: 'browser_sessions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Browser_Sessions>;
};

/** input type for inserting object relation for remote table "browser_sessions" */
export type Browser_Sessions_Obj_Rel_Insert_Input = {
  data: Browser_Sessions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Browser_Sessions_On_Conflict>;
};

/** on_conflict condition type for table "browser_sessions" */
export type Browser_Sessions_On_Conflict = {
  constraint: Browser_Sessions_Constraint;
  update_columns?: Array<Browser_Sessions_Update_Column>;
  where?: InputMaybe<Browser_Sessions_Bool_Exp>;
};

/** Ordering options when selecting data from "browser_sessions". */
export type Browser_Sessions_Order_By = {
  browser_id?: InputMaybe<Order_By>;
  contact?: InputMaybe<Web_Contacts_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: browser_sessions */
export type Browser_Sessions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "browser_sessions" */
export enum Browser_Sessions_Select_Column {
  /** column name */
  BrowserId = 'browser_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "browser_sessions" */
export type Browser_Sessions_Set_Input = {
  browser_id?: InputMaybe<Scalars['uuid']>;
  contact_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Browser_Sessions_Stddev_Fields = {
  __typename?: 'browser_sessions_stddev_fields';
  contact_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Browser_Sessions_Stddev_Pop_Fields = {
  __typename?: 'browser_sessions_stddev_pop_fields';
  contact_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Browser_Sessions_Stddev_Samp_Fields = {
  __typename?: 'browser_sessions_stddev_samp_fields';
  contact_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "browser_sessions" */
export type Browser_Sessions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Browser_Sessions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Browser_Sessions_Stream_Cursor_Value_Input = {
  browser_id?: InputMaybe<Scalars['uuid']>;
  contact_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Browser_Sessions_Sum_Fields = {
  __typename?: 'browser_sessions_sum_fields';
  contact_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "browser_sessions" */
export enum Browser_Sessions_Update_Column {
  /** column name */
  BrowserId = 'browser_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Id = 'id'
}

export type Browser_Sessions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Browser_Sessions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Browser_Sessions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Browser_Sessions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Browser_Sessions_Var_Pop_Fields = {
  __typename?: 'browser_sessions_var_pop_fields';
  contact_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Browser_Sessions_Var_Samp_Fields = {
  __typename?: 'browser_sessions_var_samp_fields';
  contact_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Browser_Sessions_Variance_Fields = {
  __typename?: 'browser_sessions_variance_fields';
  contact_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "chat_list" */
export type Chat_List = {
  __typename?: 'chat_list';
  archived: Scalars['Boolean'];
  /** An object relationship */
  contact?: Maybe<Contact_List>;
  id: Scalars['Int'];
  is_group: Scalars['Boolean'];
  last_message_is_from_me: Scalars['Boolean'];
  last_message_key?: Maybe<Scalars['String']>;
  last_message_text?: Maybe<Scalars['String']>;
  last_message_timestamp: Scalars['Int'];
  last_message_type?: Maybe<Scalars['String']>;
  muted: Scalars['Boolean'];
  name: Scalars['String'];
  phone: Scalars['String'];
  pinned: Scalars['Boolean'];
  /** An object relationship */
  session: Ws_Sessions;
  session_uuid: Scalars['uuid'];
  unread_count: Scalars['Int'];
};

/** aggregated selection of "chat_list" */
export type Chat_List_Aggregate = {
  __typename?: 'chat_list_aggregate';
  aggregate?: Maybe<Chat_List_Aggregate_Fields>;
  nodes: Array<Chat_List>;
};

export type Chat_List_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Chat_List_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Chat_List_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Chat_List_Aggregate_Bool_Exp_Count>;
};

export type Chat_List_Aggregate_Bool_Exp_Bool_And = {
  arguments: Chat_List_Select_Column_Chat_List_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Chat_List_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Chat_List_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Chat_List_Select_Column_Chat_List_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Chat_List_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Chat_List_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Chat_List_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Chat_List_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "chat_list" */
export type Chat_List_Aggregate_Fields = {
  __typename?: 'chat_list_aggregate_fields';
  avg?: Maybe<Chat_List_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Chat_List_Max_Fields>;
  min?: Maybe<Chat_List_Min_Fields>;
  stddev?: Maybe<Chat_List_Stddev_Fields>;
  stddev_pop?: Maybe<Chat_List_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Chat_List_Stddev_Samp_Fields>;
  sum?: Maybe<Chat_List_Sum_Fields>;
  var_pop?: Maybe<Chat_List_Var_Pop_Fields>;
  var_samp?: Maybe<Chat_List_Var_Samp_Fields>;
  variance?: Maybe<Chat_List_Variance_Fields>;
};


/** aggregate fields of "chat_list" */
export type Chat_List_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_List_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "chat_list" */
export type Chat_List_Aggregate_Order_By = {
  avg?: InputMaybe<Chat_List_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chat_List_Max_Order_By>;
  min?: InputMaybe<Chat_List_Min_Order_By>;
  stddev?: InputMaybe<Chat_List_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Chat_List_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Chat_List_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Chat_List_Sum_Order_By>;
  var_pop?: InputMaybe<Chat_List_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Chat_List_Var_Samp_Order_By>;
  variance?: InputMaybe<Chat_List_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "chat_list" */
export type Chat_List_Arr_Rel_Insert_Input = {
  data: Array<Chat_List_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Chat_List_On_Conflict>;
};

/** aggregate avg on columns */
export type Chat_List_Avg_Fields = {
  __typename?: 'chat_list_avg_fields';
  id?: Maybe<Scalars['Float']>;
  last_message_timestamp?: Maybe<Scalars['Float']>;
  unread_count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "chat_list" */
export type Chat_List_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  last_message_timestamp?: InputMaybe<Order_By>;
  unread_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "chat_list". All fields are combined with a logical 'AND'. */
export type Chat_List_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_List_Bool_Exp>>;
  _not?: InputMaybe<Chat_List_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_List_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  contact?: InputMaybe<Contact_List_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_group?: InputMaybe<Boolean_Comparison_Exp>;
  last_message_is_from_me?: InputMaybe<Boolean_Comparison_Exp>;
  last_message_key?: InputMaybe<String_Comparison_Exp>;
  last_message_text?: InputMaybe<String_Comparison_Exp>;
  last_message_timestamp?: InputMaybe<Int_Comparison_Exp>;
  last_message_type?: InputMaybe<String_Comparison_Exp>;
  muted?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  pinned?: InputMaybe<Boolean_Comparison_Exp>;
  session?: InputMaybe<Ws_Sessions_Bool_Exp>;
  session_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  unread_count?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat_list" */
export enum Chat_List_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChatListPkey = 'chat_list_pkey',
  /** unique or primary key constraint on columns "phone", "session_uuid" */
  ChatListSessionUuidPhoneKey = 'chat_list_session_uuid_phone_key'
}

/** input type for incrementing numeric columns in table "chat_list" */
export type Chat_List_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  last_message_timestamp?: InputMaybe<Scalars['Int']>;
  unread_count?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "chat_list" */
export type Chat_List_Insert_Input = {
  archived?: InputMaybe<Scalars['Boolean']>;
  contact?: InputMaybe<Contact_List_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_group?: InputMaybe<Scalars['Boolean']>;
  last_message_is_from_me?: InputMaybe<Scalars['Boolean']>;
  last_message_key?: InputMaybe<Scalars['String']>;
  last_message_text?: InputMaybe<Scalars['String']>;
  last_message_timestamp?: InputMaybe<Scalars['Int']>;
  last_message_type?: InputMaybe<Scalars['String']>;
  muted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  session?: InputMaybe<Ws_Sessions_Obj_Rel_Insert_Input>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  unread_count?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Chat_List_Max_Fields = {
  __typename?: 'chat_list_max_fields';
  id?: Maybe<Scalars['Int']>;
  last_message_key?: Maybe<Scalars['String']>;
  last_message_text?: Maybe<Scalars['String']>;
  last_message_timestamp?: Maybe<Scalars['Int']>;
  last_message_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  session_uuid?: Maybe<Scalars['uuid']>;
  unread_count?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "chat_list" */
export type Chat_List_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  last_message_key?: InputMaybe<Order_By>;
  last_message_text?: InputMaybe<Order_By>;
  last_message_timestamp?: InputMaybe<Order_By>;
  last_message_type?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  session_uuid?: InputMaybe<Order_By>;
  unread_count?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Chat_List_Min_Fields = {
  __typename?: 'chat_list_min_fields';
  id?: Maybe<Scalars['Int']>;
  last_message_key?: Maybe<Scalars['String']>;
  last_message_text?: Maybe<Scalars['String']>;
  last_message_timestamp?: Maybe<Scalars['Int']>;
  last_message_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  session_uuid?: Maybe<Scalars['uuid']>;
  unread_count?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "chat_list" */
export type Chat_List_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  last_message_key?: InputMaybe<Order_By>;
  last_message_text?: InputMaybe<Order_By>;
  last_message_timestamp?: InputMaybe<Order_By>;
  last_message_type?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  session_uuid?: InputMaybe<Order_By>;
  unread_count?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "chat_list" */
export type Chat_List_Mutation_Response = {
  __typename?: 'chat_list_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat_List>;
};

/** on_conflict condition type for table "chat_list" */
export type Chat_List_On_Conflict = {
  constraint: Chat_List_Constraint;
  update_columns?: Array<Chat_List_Update_Column>;
  where?: InputMaybe<Chat_List_Bool_Exp>;
};

/** Ordering options when selecting data from "chat_list". */
export type Chat_List_Order_By = {
  archived?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contact_List_Order_By>;
  id?: InputMaybe<Order_By>;
  is_group?: InputMaybe<Order_By>;
  last_message_is_from_me?: InputMaybe<Order_By>;
  last_message_key?: InputMaybe<Order_By>;
  last_message_text?: InputMaybe<Order_By>;
  last_message_timestamp?: InputMaybe<Order_By>;
  last_message_type?: InputMaybe<Order_By>;
  muted?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  pinned?: InputMaybe<Order_By>;
  session?: InputMaybe<Ws_Sessions_Order_By>;
  session_uuid?: InputMaybe<Order_By>;
  unread_count?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat_list */
export type Chat_List_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "chat_list" */
export enum Chat_List_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Id = 'id',
  /** column name */
  IsGroup = 'is_group',
  /** column name */
  LastMessageIsFromMe = 'last_message_is_from_me',
  /** column name */
  LastMessageKey = 'last_message_key',
  /** column name */
  LastMessageText = 'last_message_text',
  /** column name */
  LastMessageTimestamp = 'last_message_timestamp',
  /** column name */
  LastMessageType = 'last_message_type',
  /** column name */
  Muted = 'muted',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  SessionUuid = 'session_uuid',
  /** column name */
  UnreadCount = 'unread_count'
}

/** select "chat_list_aggregate_bool_exp_bool_and_arguments_columns" columns of table "chat_list" */
export enum Chat_List_Select_Column_Chat_List_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  IsGroup = 'is_group',
  /** column name */
  LastMessageIsFromMe = 'last_message_is_from_me',
  /** column name */
  Muted = 'muted',
  /** column name */
  Pinned = 'pinned'
}

/** select "chat_list_aggregate_bool_exp_bool_or_arguments_columns" columns of table "chat_list" */
export enum Chat_List_Select_Column_Chat_List_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  IsGroup = 'is_group',
  /** column name */
  LastMessageIsFromMe = 'last_message_is_from_me',
  /** column name */
  Muted = 'muted',
  /** column name */
  Pinned = 'pinned'
}

/** input type for updating data in table "chat_list" */
export type Chat_List_Set_Input = {
  archived?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_group?: InputMaybe<Scalars['Boolean']>;
  last_message_is_from_me?: InputMaybe<Scalars['Boolean']>;
  last_message_key?: InputMaybe<Scalars['String']>;
  last_message_text?: InputMaybe<Scalars['String']>;
  last_message_timestamp?: InputMaybe<Scalars['Int']>;
  last_message_type?: InputMaybe<Scalars['String']>;
  muted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  unread_count?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Chat_List_Stddev_Fields = {
  __typename?: 'chat_list_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  last_message_timestamp?: Maybe<Scalars['Float']>;
  unread_count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "chat_list" */
export type Chat_List_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  last_message_timestamp?: InputMaybe<Order_By>;
  unread_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Chat_List_Stddev_Pop_Fields = {
  __typename?: 'chat_list_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  last_message_timestamp?: Maybe<Scalars['Float']>;
  unread_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "chat_list" */
export type Chat_List_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  last_message_timestamp?: InputMaybe<Order_By>;
  unread_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Chat_List_Stddev_Samp_Fields = {
  __typename?: 'chat_list_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  last_message_timestamp?: Maybe<Scalars['Float']>;
  unread_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "chat_list" */
export type Chat_List_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  last_message_timestamp?: InputMaybe<Order_By>;
  unread_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "chat_list" */
export type Chat_List_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_List_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_List_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_group?: InputMaybe<Scalars['Boolean']>;
  last_message_is_from_me?: InputMaybe<Scalars['Boolean']>;
  last_message_key?: InputMaybe<Scalars['String']>;
  last_message_text?: InputMaybe<Scalars['String']>;
  last_message_timestamp?: InputMaybe<Scalars['Int']>;
  last_message_type?: InputMaybe<Scalars['String']>;
  muted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  unread_count?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Chat_List_Sum_Fields = {
  __typename?: 'chat_list_sum_fields';
  id?: Maybe<Scalars['Int']>;
  last_message_timestamp?: Maybe<Scalars['Int']>;
  unread_count?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "chat_list" */
export type Chat_List_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  last_message_timestamp?: InputMaybe<Order_By>;
  unread_count?: InputMaybe<Order_By>;
};

/** update columns of table "chat_list" */
export enum Chat_List_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Id = 'id',
  /** column name */
  IsGroup = 'is_group',
  /** column name */
  LastMessageIsFromMe = 'last_message_is_from_me',
  /** column name */
  LastMessageKey = 'last_message_key',
  /** column name */
  LastMessageText = 'last_message_text',
  /** column name */
  LastMessageTimestamp = 'last_message_timestamp',
  /** column name */
  LastMessageType = 'last_message_type',
  /** column name */
  Muted = 'muted',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  SessionUuid = 'session_uuid',
  /** column name */
  UnreadCount = 'unread_count'
}

export type Chat_List_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Chat_List_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Chat_List_Set_Input>;
  /** filter the rows which have to be updated */
  where: Chat_List_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Chat_List_Var_Pop_Fields = {
  __typename?: 'chat_list_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  last_message_timestamp?: Maybe<Scalars['Float']>;
  unread_count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "chat_list" */
export type Chat_List_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  last_message_timestamp?: InputMaybe<Order_By>;
  unread_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Chat_List_Var_Samp_Fields = {
  __typename?: 'chat_list_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  last_message_timestamp?: Maybe<Scalars['Float']>;
  unread_count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "chat_list" */
export type Chat_List_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  last_message_timestamp?: InputMaybe<Order_By>;
  unread_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Chat_List_Variance_Fields = {
  __typename?: 'chat_list_variance_fields';
  id?: Maybe<Scalars['Float']>;
  last_message_timestamp?: Maybe<Scalars['Float']>;
  unread_count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "chat_list" */
export type Chat_List_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  last_message_timestamp?: InputMaybe<Order_By>;
  unread_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "compliance" */
export type Compliance = {
  __typename?: 'compliance';
  /** An array relationship */
  compliance_contacts: Array<Compliance_Contacts_Raw>;
  /** An aggregate relationship */
  compliance_contacts_aggregate: Compliance_Contacts_Raw_Aggregate;
  /** An array relationship */
  compliance_events: Array<Compliance_Events>;
  /** An aggregate relationship */
  compliance_events_aggregate: Compliance_Events_Aggregate;
  /** An array relationship */
  compliance_groups: Array<Compliance_Groups>;
  /** An aggregate relationship */
  compliance_groups_aggregate: Compliance_Groups_Aggregate;
  /** An array relationship */
  compliance_policies: Array<Compliance_Policies>;
  /** An aggregate relationship */
  compliance_policies_aggregate: Compliance_Policies_Aggregate;
  /** An array relationship */
  compliance_rules: Array<Compliance_Rules>;
  /** An aggregate relationship */
  compliance_rules_aggregate: Compliance_Rules_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "compliance" */
export type ComplianceCompliance_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Raw_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
};


/** columns and relationships of "compliance" */
export type ComplianceCompliance_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Raw_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
};


/** columns and relationships of "compliance" */
export type ComplianceCompliance_EventsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


/** columns and relationships of "compliance" */
export type ComplianceCompliance_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


/** columns and relationships of "compliance" */
export type ComplianceCompliance_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Groups_Order_By>>;
  where?: InputMaybe<Compliance_Groups_Bool_Exp>;
};


/** columns and relationships of "compliance" */
export type ComplianceCompliance_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Groups_Order_By>>;
  where?: InputMaybe<Compliance_Groups_Bool_Exp>;
};


/** columns and relationships of "compliance" */
export type ComplianceCompliance_PoliciesArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Policies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Policies_Order_By>>;
  where?: InputMaybe<Compliance_Policies_Bool_Exp>;
};


/** columns and relationships of "compliance" */
export type ComplianceCompliance_Policies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Policies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Policies_Order_By>>;
  where?: InputMaybe<Compliance_Policies_Bool_Exp>;
};


/** columns and relationships of "compliance" */
export type ComplianceCompliance_RulesArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Rules_Order_By>>;
  where?: InputMaybe<Compliance_Rules_Bool_Exp>;
};


/** columns and relationships of "compliance" */
export type ComplianceCompliance_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Rules_Order_By>>;
  where?: InputMaybe<Compliance_Rules_Bool_Exp>;
};


/** columns and relationships of "compliance" */
export type ComplianceMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "compliance" */
export type Compliance_Aggregate = {
  __typename?: 'compliance_aggregate';
  aggregate?: Maybe<Compliance_Aggregate_Fields>;
  nodes: Array<Compliance>;
};

export type Compliance_Aggregate_Bool_Exp = {
  count?: InputMaybe<Compliance_Aggregate_Bool_Exp_Count>;
};

export type Compliance_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Compliance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Compliance_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance" */
export type Compliance_Aggregate_Fields = {
  __typename?: 'compliance_aggregate_fields';
  avg?: Maybe<Compliance_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Max_Fields>;
  min?: Maybe<Compliance_Min_Fields>;
  stddev?: Maybe<Compliance_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Sum_Fields>;
  var_pop?: Maybe<Compliance_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Variance_Fields>;
};


/** aggregate fields of "compliance" */
export type Compliance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance" */
export type Compliance_Aggregate_Order_By = {
  avg?: InputMaybe<Compliance_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Compliance_Max_Order_By>;
  min?: InputMaybe<Compliance_Min_Order_By>;
  stddev?: InputMaybe<Compliance_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Compliance_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Compliance_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Compliance_Sum_Order_By>;
  var_pop?: InputMaybe<Compliance_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Compliance_Var_Samp_Order_By>;
  variance?: InputMaybe<Compliance_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Compliance_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "compliance" */
export type Compliance_Arr_Rel_Insert_Input = {
  data: Array<Compliance_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Compliance_On_Conflict>;
};

/** aggregate avg on columns */
export type Compliance_Avg_Fields = {
  __typename?: 'compliance_avg_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "compliance" */
export type Compliance_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "compliance". All fields are combined with a logical 'AND'. */
export type Compliance_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Bool_Exp>>;
  compliance_contacts?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
  compliance_contacts_aggregate?: InputMaybe<Compliance_Contacts_Raw_Aggregate_Bool_Exp>;
  compliance_events?: InputMaybe<Compliance_Events_Bool_Exp>;
  compliance_events_aggregate?: InputMaybe<Compliance_Events_Aggregate_Bool_Exp>;
  compliance_groups?: InputMaybe<Compliance_Groups_Bool_Exp>;
  compliance_groups_aggregate?: InputMaybe<Compliance_Groups_Aggregate_Bool_Exp>;
  compliance_policies?: InputMaybe<Compliance_Policies_Bool_Exp>;
  compliance_policies_aggregate?: InputMaybe<Compliance_Policies_Aggregate_Bool_Exp>;
  compliance_rules?: InputMaybe<Compliance_Rules_Bool_Exp>;
  compliance_rules_aggregate?: InputMaybe<Compliance_Rules_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance" */
export enum Compliance_Constraint {
  /** unique or primary key constraint on columns "id" */
  CompliancePkey = 'compliance_pkey'
}

/** columns and relationships of "compliance_contacts" */
export type Compliance_Contacts = {
  __typename?: 'compliance_contacts';
  /** An object relationship */
  compliance?: Maybe<Compliance>;
  /** An array relationship */
  compliance_events: Array<Compliance_Events>;
  /** An aggregate relationship */
  compliance_events_aggregate: Compliance_Events_Aggregate;
  /** An object relationship */
  compliance_group_contact?: Maybe<Compliance_Group_Contacts>;
  compliance_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  compliance_messages: Array<Compliance_Messages>;
  /** An aggregate relationship */
  compliance_messages_aggregate: Compliance_Messages_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invite_counter?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ws_session?: Maybe<Ws_Sessions>;
  ws_session_ref?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "compliance_contacts" */
export type Compliance_ContactsCompliance_EventsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


/** columns and relationships of "compliance_contacts" */
export type Compliance_ContactsCompliance_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


/** columns and relationships of "compliance_contacts" */
export type Compliance_ContactsCompliance_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Bool_Exp>;
};


/** columns and relationships of "compliance_contacts" */
export type Compliance_ContactsCompliance_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Bool_Exp>;
};


/** columns and relationships of "compliance_contacts" */
export type Compliance_ContactsTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "compliance_contacts" */
export type Compliance_Contacts_Aggregate = {
  __typename?: 'compliance_contacts_aggregate';
  aggregate?: Maybe<Compliance_Contacts_Aggregate_Fields>;
  nodes: Array<Compliance_Contacts>;
};

/** aggregate fields of "compliance_contacts" */
export type Compliance_Contacts_Aggregate_Fields = {
  __typename?: 'compliance_contacts_aggregate_fields';
  avg?: Maybe<Compliance_Contacts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Contacts_Max_Fields>;
  min?: Maybe<Compliance_Contacts_Min_Fields>;
  stddev?: Maybe<Compliance_Contacts_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Contacts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Contacts_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Contacts_Sum_Fields>;
  var_pop?: Maybe<Compliance_Contacts_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Contacts_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Contacts_Variance_Fields>;
};


/** aggregate fields of "compliance_contacts" */
export type Compliance_Contacts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Compliance_Contacts_Append_Input = {
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Compliance_Contacts_Avg_Fields = {
  __typename?: 'compliance_contacts_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invite_counter?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_contacts". All fields are combined with a logical 'AND'. */
export type Compliance_Contacts_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Contacts_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Contacts_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Contacts_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_events?: InputMaybe<Compliance_Events_Bool_Exp>;
  compliance_events_aggregate?: InputMaybe<Compliance_Events_Aggregate_Bool_Exp>;
  compliance_group_contact?: InputMaybe<Compliance_Group_Contacts_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  compliance_messages?: InputMaybe<Compliance_Messages_Bool_Exp>;
  compliance_messages_aggregate?: InputMaybe<Compliance_Messages_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  invite_counter?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ws_session?: InputMaybe<Ws_Sessions_Bool_Exp>;
  ws_session_ref?: InputMaybe<Uuid_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Compliance_Contacts_Delete_At_Path_Input = {
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Compliance_Contacts_Delete_Elem_Input = {
  tags?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Compliance_Contacts_Delete_Key_Input = {
  tags?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "compliance_contacts" */
export type Compliance_Contacts_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  invite_counter?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "compliance_contacts" */
export type Compliance_Contacts_Insert_Input = {
  compliance?: InputMaybe<Compliance_Obj_Rel_Insert_Input>;
  compliance_events?: InputMaybe<Compliance_Events_Arr_Rel_Insert_Input>;
  compliance_group_contact?: InputMaybe<Compliance_Group_Contacts_Obj_Rel_Insert_Input>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  compliance_messages?: InputMaybe<Compliance_Messages_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  invite_counter?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  ws_session?: InputMaybe<Ws_Sessions_Obj_Rel_Insert_Input>;
  ws_session_ref?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Compliance_Contacts_Max_Fields = {
  __typename?: 'compliance_contacts_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invite_counter?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  ws_session_ref?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Compliance_Contacts_Min_Fields = {
  __typename?: 'compliance_contacts_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invite_counter?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  ws_session_ref?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "compliance_contacts" */
export type Compliance_Contacts_Mutation_Response = {
  __typename?: 'compliance_contacts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Contacts>;
};

/** Ordering options when selecting data from "compliance_contacts". */
export type Compliance_Contacts_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_events_aggregate?: InputMaybe<Compliance_Events_Aggregate_Order_By>;
  compliance_group_contact?: InputMaybe<Compliance_Group_Contacts_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  compliance_messages_aggregate?: InputMaybe<Compliance_Messages_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite_counter?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  ws_session?: InputMaybe<Ws_Sessions_Order_By>;
  ws_session_ref?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Compliance_Contacts_Prepend_Input = {
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "compliance_contacts_raw" */
export type Compliance_Contacts_Raw = {
  __typename?: 'compliance_contacts_raw';
  /** An object relationship */
  compliance: Compliance;
  /** An object relationship */
  compliance_contacts_stats?: Maybe<Compliance_Contacts_Stats>;
  /** An object relationship */
  compliance_contacts_status?: Maybe<Compliance_Contacts_Status>;
  /** An array relationship */
  compliance_events: Array<Compliance_Events>;
  /** An aggregate relationship */
  compliance_events_aggregate: Compliance_Events_Aggregate;
  /** An object relationship */
  compliance_group_contact?: Maybe<Compliance_Group_Contacts>;
  compliance_id: Scalars['Int'];
  /** An array relationship */
  compliance_messages: Array<Compliance_Messages>;
  /** An aggregate relationship */
  compliance_messages_aggregate: Compliance_Messages_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invite_counter: Scalars['Int'];
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  tags?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  ws_session?: Maybe<Ws_Sessions>;
  ws_session_ref?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "compliance_contacts_raw" */
export type Compliance_Contacts_RawCompliance_EventsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


/** columns and relationships of "compliance_contacts_raw" */
export type Compliance_Contacts_RawCompliance_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


/** columns and relationships of "compliance_contacts_raw" */
export type Compliance_Contacts_RawCompliance_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Bool_Exp>;
};


/** columns and relationships of "compliance_contacts_raw" */
export type Compliance_Contacts_RawCompliance_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Bool_Exp>;
};


/** columns and relationships of "compliance_contacts_raw" */
export type Compliance_Contacts_RawMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "compliance_contacts_raw" */
export type Compliance_Contacts_RawTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Aggregate = {
  __typename?: 'compliance_contacts_raw_aggregate';
  aggregate?: Maybe<Compliance_Contacts_Raw_Aggregate_Fields>;
  nodes: Array<Compliance_Contacts_Raw>;
};

export type Compliance_Contacts_Raw_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Compliance_Contacts_Raw_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Compliance_Contacts_Raw_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Compliance_Contacts_Raw_Aggregate_Bool_Exp_Count>;
};

export type Compliance_Contacts_Raw_Aggregate_Bool_Exp_Bool_And = {
  arguments: Compliance_Contacts_Raw_Select_Column_Compliance_Contacts_Raw_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Compliance_Contacts_Raw_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Compliance_Contacts_Raw_Select_Column_Compliance_Contacts_Raw_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Compliance_Contacts_Raw_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Compliance_Contacts_Raw_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Aggregate_Fields = {
  __typename?: 'compliance_contacts_raw_aggregate_fields';
  avg?: Maybe<Compliance_Contacts_Raw_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Contacts_Raw_Max_Fields>;
  min?: Maybe<Compliance_Contacts_Raw_Min_Fields>;
  stddev?: Maybe<Compliance_Contacts_Raw_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Contacts_Raw_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Contacts_Raw_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Contacts_Raw_Sum_Fields>;
  var_pop?: Maybe<Compliance_Contacts_Raw_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Contacts_Raw_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Contacts_Raw_Variance_Fields>;
};


/** aggregate fields of "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Contacts_Raw_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Aggregate_Order_By = {
  avg?: InputMaybe<Compliance_Contacts_Raw_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Compliance_Contacts_Raw_Max_Order_By>;
  min?: InputMaybe<Compliance_Contacts_Raw_Min_Order_By>;
  stddev?: InputMaybe<Compliance_Contacts_Raw_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Compliance_Contacts_Raw_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Compliance_Contacts_Raw_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Compliance_Contacts_Raw_Sum_Order_By>;
  var_pop?: InputMaybe<Compliance_Contacts_Raw_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Compliance_Contacts_Raw_Var_Samp_Order_By>;
  variance?: InputMaybe<Compliance_Contacts_Raw_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Compliance_Contacts_Raw_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Arr_Rel_Insert_Input = {
  data: Array<Compliance_Contacts_Raw_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Compliance_Contacts_Raw_On_Conflict>;
};

/** aggregate avg on columns */
export type Compliance_Contacts_Raw_Avg_Fields = {
  __typename?: 'compliance_contacts_raw_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invite_counter?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Avg_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite_counter?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "compliance_contacts_raw". All fields are combined with a logical 'AND'. */
export type Compliance_Contacts_Raw_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Contacts_Raw_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Contacts_Raw_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_contacts_stats?: InputMaybe<Compliance_Contacts_Stats_Bool_Exp>;
  compliance_contacts_status?: InputMaybe<Compliance_Contacts_Status_Bool_Exp>;
  compliance_events?: InputMaybe<Compliance_Events_Bool_Exp>;
  compliance_events_aggregate?: InputMaybe<Compliance_Events_Aggregate_Bool_Exp>;
  compliance_group_contact?: InputMaybe<Compliance_Group_Contacts_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  compliance_messages?: InputMaybe<Compliance_Messages_Bool_Exp>;
  compliance_messages_aggregate?: InputMaybe<Compliance_Messages_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  invite_counter?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ws_session?: InputMaybe<Ws_Sessions_Bool_Exp>;
  ws_session_ref?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance_contacts_raw" */
export enum Compliance_Contacts_Raw_Constraint {
  /** unique or primary key constraint on columns "compliance_id", "email" */
  ComplianceContactsComplianceIdEmailKey = 'compliance_contacts_compliance_id_email_key',
  /** unique or primary key constraint on columns "phone", "compliance_id" */
  ComplianceContactsComplianceIdPhoneKey = 'compliance_contacts_compliance_id_phone_key',
  /** unique or primary key constraint on columns "ws_session_ref", "compliance_id" */
  ComplianceContactsComplianceIdWsContactRefKey = 'compliance_contacts_compliance_id_ws_contact_ref_key',
  /** unique or primary key constraint on columns "id" */
  ComplianceContactsPkey = 'compliance_contacts_pkey',
  /** unique or primary key constraint on columns "ws_session_ref" */
  ComplianceContactsRawWsSessionRefKey = 'compliance_contacts_raw_ws_session_ref_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Compliance_Contacts_Raw_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Compliance_Contacts_Raw_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Compliance_Contacts_Raw_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  invite_counter?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Insert_Input = {
  compliance?: InputMaybe<Compliance_Obj_Rel_Insert_Input>;
  compliance_contacts_stats?: InputMaybe<Compliance_Contacts_Stats_Obj_Rel_Insert_Input>;
  compliance_contacts_status?: InputMaybe<Compliance_Contacts_Status_Obj_Rel_Insert_Input>;
  compliance_events?: InputMaybe<Compliance_Events_Arr_Rel_Insert_Input>;
  compliance_group_contact?: InputMaybe<Compliance_Group_Contacts_Obj_Rel_Insert_Input>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  compliance_messages?: InputMaybe<Compliance_Messages_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  invite_counter?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  ws_session?: InputMaybe<Ws_Sessions_Obj_Rel_Insert_Input>;
  ws_session_ref?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Compliance_Contacts_Raw_Max_Fields = {
  __typename?: 'compliance_contacts_raw_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invite_counter?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  ws_session_ref?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Max_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite_counter?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  ws_session_ref?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Compliance_Contacts_Raw_Min_Fields = {
  __typename?: 'compliance_contacts_raw_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invite_counter?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  ws_session_ref?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Min_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite_counter?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  ws_session_ref?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Mutation_Response = {
  __typename?: 'compliance_contacts_raw_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Contacts_Raw>;
};

/** input type for inserting object relation for remote table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Obj_Rel_Insert_Input = {
  data: Compliance_Contacts_Raw_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Compliance_Contacts_Raw_On_Conflict>;
};

/** on_conflict condition type for table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_On_Conflict = {
  constraint: Compliance_Contacts_Raw_Constraint;
  update_columns?: Array<Compliance_Contacts_Raw_Update_Column>;
  where?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance_contacts_raw". */
export type Compliance_Contacts_Raw_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_contacts_stats?: InputMaybe<Compliance_Contacts_Stats_Order_By>;
  compliance_contacts_status?: InputMaybe<Compliance_Contacts_Status_Order_By>;
  compliance_events_aggregate?: InputMaybe<Compliance_Events_Aggregate_Order_By>;
  compliance_group_contact?: InputMaybe<Compliance_Group_Contacts_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  compliance_messages_aggregate?: InputMaybe<Compliance_Messages_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite_counter?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  ws_session?: InputMaybe<Ws_Sessions_Order_By>;
  ws_session_ref?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance_contacts_raw */
export type Compliance_Contacts_Raw_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Compliance_Contacts_Raw_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "compliance_contacts_raw" */
export enum Compliance_Contacts_Raw_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  InviteCounter = 'invite_counter',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  Status = 'status',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WsSessionRef = 'ws_session_ref'
}

/** select "compliance_contacts_raw_aggregate_bool_exp_bool_and_arguments_columns" columns of table "compliance_contacts_raw" */
export enum Compliance_Contacts_Raw_Select_Column_Compliance_Contacts_Raw_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** select "compliance_contacts_raw_aggregate_bool_exp_bool_or_arguments_columns" columns of table "compliance_contacts_raw" */
export enum Compliance_Contacts_Raw_Select_Column_Compliance_Contacts_Raw_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** input type for updating data in table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Set_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  invite_counter?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  ws_session_ref?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Compliance_Contacts_Raw_Stddev_Fields = {
  __typename?: 'compliance_contacts_raw_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invite_counter?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Stddev_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite_counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Contacts_Raw_Stddev_Pop_Fields = {
  __typename?: 'compliance_contacts_raw_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invite_counter?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Stddev_Pop_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite_counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Contacts_Raw_Stddev_Samp_Fields = {
  __typename?: 'compliance_contacts_raw_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invite_counter?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Stddev_Samp_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite_counter?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Contacts_Raw_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Contacts_Raw_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  invite_counter?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  ws_session_ref?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Compliance_Contacts_Raw_Sum_Fields = {
  __typename?: 'compliance_contacts_raw_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  invite_counter?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Sum_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite_counter?: InputMaybe<Order_By>;
};

/** update columns of table "compliance_contacts_raw" */
export enum Compliance_Contacts_Raw_Update_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  InviteCounter = 'invite_counter',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  Status = 'status',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WsSessionRef = 'ws_session_ref'
}

export type Compliance_Contacts_Raw_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Compliance_Contacts_Raw_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Compliance_Contacts_Raw_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Compliance_Contacts_Raw_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Compliance_Contacts_Raw_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Contacts_Raw_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Compliance_Contacts_Raw_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Contacts_Raw_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Contacts_Raw_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Contacts_Raw_Var_Pop_Fields = {
  __typename?: 'compliance_contacts_raw_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invite_counter?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Var_Pop_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite_counter?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Compliance_Contacts_Raw_Var_Samp_Fields = {
  __typename?: 'compliance_contacts_raw_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invite_counter?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Var_Samp_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite_counter?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Compliance_Contacts_Raw_Variance_Fields = {
  __typename?: 'compliance_contacts_raw_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invite_counter?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "compliance_contacts_raw" */
export type Compliance_Contacts_Raw_Variance_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite_counter?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_contacts" */
export enum Compliance_Contacts_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  InviteCounter = 'invite_counter',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  Status = 'status',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WsSessionRef = 'ws_session_ref'
}

/** input type for updating data in table "compliance_contacts" */
export type Compliance_Contacts_Set_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  invite_counter?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  ws_session_ref?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "compliance_contacts_stats" */
export type Compliance_Contacts_Stats = {
  __typename?: 'compliance_contacts_stats';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_id?: Maybe<Scalars['Int']>;
  interval_elapsed?: Maybe<Scalars['interval']>;
  status?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  ws_session_id?: Maybe<Scalars['Int']>;
  ws_session_ref?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "compliance_contacts_stats" */
export type Compliance_Contacts_Stats_Aggregate = {
  __typename?: 'compliance_contacts_stats_aggregate';
  aggregate?: Maybe<Compliance_Contacts_Stats_Aggregate_Fields>;
  nodes: Array<Compliance_Contacts_Stats>;
};

/** aggregate fields of "compliance_contacts_stats" */
export type Compliance_Contacts_Stats_Aggregate_Fields = {
  __typename?: 'compliance_contacts_stats_aggregate_fields';
  avg?: Maybe<Compliance_Contacts_Stats_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Contacts_Stats_Max_Fields>;
  min?: Maybe<Compliance_Contacts_Stats_Min_Fields>;
  stddev?: Maybe<Compliance_Contacts_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Contacts_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Contacts_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Contacts_Stats_Sum_Fields>;
  var_pop?: Maybe<Compliance_Contacts_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Contacts_Stats_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Contacts_Stats_Variance_Fields>;
};


/** aggregate fields of "compliance_contacts_stats" */
export type Compliance_Contacts_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Contacts_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Contacts_Stats_Avg_Fields = {
  __typename?: 'compliance_contacts_stats_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_contacts_stats". All fields are combined with a logical 'AND'. */
export type Compliance_Contacts_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Contacts_Stats_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Contacts_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Contacts_Stats_Bool_Exp>>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  contact_id?: InputMaybe<Int_Comparison_Exp>;
  interval_elapsed?: InputMaybe<Interval_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ws_session_id?: InputMaybe<Int_Comparison_Exp>;
  ws_session_ref?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "compliance_contacts_stats" */
export type Compliance_Contacts_Stats_Insert_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  contact_id?: InputMaybe<Scalars['Int']>;
  interval_elapsed?: InputMaybe<Scalars['interval']>;
  status?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  ws_session_id?: InputMaybe<Scalars['Int']>;
  ws_session_ref?: InputMaybe<Scalars['uuid']>;
};

export type Compliance_Contacts_Stats_Interval_Args = {
  end_date?: InputMaybe<Scalars['date']>;
  start_date?: InputMaybe<Scalars['date']>;
};

export type Compliance_Contacts_Stats_Json_Interval_Args = {
  end_date?: InputMaybe<Scalars['date']>;
  start_date?: InputMaybe<Scalars['date']>;
};

/** columns and relationships of "compliance_contacts_stats_json_setof" */
export type Compliance_Contacts_Stats_Json_Setof = {
  __typename?: 'compliance_contacts_stats_json_setof';
  compliance_id: Scalars['Int'];
  contact_id: Scalars['Int'];
  status: Scalars['jsonb'];
};


/** columns and relationships of "compliance_contacts_stats_json_setof" */
export type Compliance_Contacts_Stats_Json_SetofStatusArgs = {
  path?: InputMaybe<Scalars['String']>;
};

export type Compliance_Contacts_Stats_Json_Setof_Aggregate = {
  __typename?: 'compliance_contacts_stats_json_setof_aggregate';
  aggregate?: Maybe<Compliance_Contacts_Stats_Json_Setof_Aggregate_Fields>;
  nodes: Array<Compliance_Contacts_Stats_Json_Setof>;
};

/** aggregate fields of "compliance_contacts_stats_json_setof" */
export type Compliance_Contacts_Stats_Json_Setof_Aggregate_Fields = {
  __typename?: 'compliance_contacts_stats_json_setof_aggregate_fields';
  avg?: Maybe<Compliance_Contacts_Stats_Json_Setof_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Contacts_Stats_Json_Setof_Max_Fields>;
  min?: Maybe<Compliance_Contacts_Stats_Json_Setof_Min_Fields>;
  stddev?: Maybe<Compliance_Contacts_Stats_Json_Setof_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Contacts_Stats_Json_Setof_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Contacts_Stats_Json_Setof_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Contacts_Stats_Json_Setof_Sum_Fields>;
  var_pop?: Maybe<Compliance_Contacts_Stats_Json_Setof_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Contacts_Stats_Json_Setof_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Contacts_Stats_Json_Setof_Variance_Fields>;
};


/** aggregate fields of "compliance_contacts_stats_json_setof" */
export type Compliance_Contacts_Stats_Json_Setof_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Compliance_Contacts_Stats_Json_Setof_Append_Input = {
  status?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Compliance_Contacts_Stats_Json_Setof_Avg_Fields = {
  __typename?: 'compliance_contacts_stats_json_setof_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_contacts_stats_json_setof". All fields are combined with a logical 'AND'. */
export type Compliance_Contacts_Stats_Json_Setof_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Bool_Exp>>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  contact_id?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Compliance_Contacts_Stats_Json_Setof_Delete_At_Path_Input = {
  status?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Compliance_Contacts_Stats_Json_Setof_Delete_Elem_Input = {
  status?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Compliance_Contacts_Stats_Json_Setof_Delete_Key_Input = {
  status?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "compliance_contacts_stats_json_setof" */
export type Compliance_Contacts_Stats_Json_Setof_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  contact_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "compliance_contacts_stats_json_setof" */
export type Compliance_Contacts_Stats_Json_Setof_Insert_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  contact_id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Compliance_Contacts_Stats_Json_Setof_Max_Fields = {
  __typename?: 'compliance_contacts_stats_json_setof_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Compliance_Contacts_Stats_Json_Setof_Min_Fields = {
  __typename?: 'compliance_contacts_stats_json_setof_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "compliance_contacts_stats_json_setof" */
export type Compliance_Contacts_Stats_Json_Setof_Mutation_Response = {
  __typename?: 'compliance_contacts_stats_json_setof_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Contacts_Stats_Json_Setof>;
};

/** Ordering options when selecting data from "compliance_contacts_stats_json_setof". */
export type Compliance_Contacts_Stats_Json_Setof_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Compliance_Contacts_Stats_Json_Setof_Prepend_Input = {
  status?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "compliance_contacts_stats_json_setof" */
export enum Compliance_Contacts_Stats_Json_Setof_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "compliance_contacts_stats_json_setof" */
export type Compliance_Contacts_Stats_Json_Setof_Set_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  contact_id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type Compliance_Contacts_Stats_Json_Setof_Stddev_Fields = {
  __typename?: 'compliance_contacts_stats_json_setof_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Contacts_Stats_Json_Setof_Stddev_Pop_Fields = {
  __typename?: 'compliance_contacts_stats_json_setof_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Contacts_Stats_Json_Setof_Stddev_Samp_Fields = {
  __typename?: 'compliance_contacts_stats_json_setof_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_contacts_stats_json_setof" */
export type Compliance_Contacts_Stats_Json_Setof_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Contacts_Stats_Json_Setof_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Contacts_Stats_Json_Setof_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  contact_id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type Compliance_Contacts_Stats_Json_Setof_Sum_Fields = {
  __typename?: 'compliance_contacts_stats_json_setof_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_id?: Maybe<Scalars['Int']>;
};

export type Compliance_Contacts_Stats_Json_Setof_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Contacts_Stats_Json_Setof_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Contacts_Stats_Json_Setof_Var_Pop_Fields = {
  __typename?: 'compliance_contacts_stats_json_setof_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Contacts_Stats_Json_Setof_Var_Samp_Fields = {
  __typename?: 'compliance_contacts_stats_json_setof_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Contacts_Stats_Json_Setof_Variance_Fields = {
  __typename?: 'compliance_contacts_stats_json_setof_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Compliance_Contacts_Stats_Max_Fields = {
  __typename?: 'compliance_contacts_stats_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  ws_session_id?: Maybe<Scalars['Int']>;
  ws_session_ref?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Compliance_Contacts_Stats_Min_Fields = {
  __typename?: 'compliance_contacts_stats_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  ws_session_id?: Maybe<Scalars['Int']>;
  ws_session_ref?: Maybe<Scalars['uuid']>;
};

/** input type for inserting object relation for remote table "compliance_contacts_stats" */
export type Compliance_Contacts_Stats_Obj_Rel_Insert_Input = {
  data: Compliance_Contacts_Stats_Insert_Input;
};

/** Ordering options when selecting data from "compliance_contacts_stats". */
export type Compliance_Contacts_Stats_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  interval_elapsed?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  ws_session_id?: InputMaybe<Order_By>;
  ws_session_ref?: InputMaybe<Order_By>;
};

/** columns and relationships of "compliance_contacts_stats_overall" */
export type Compliance_Contacts_Stats_Overall = {
  __typename?: 'compliance_contacts_stats_overall';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_id?: Maybe<Scalars['Int']>;
  interval_elapsed?: Maybe<Scalars['interval']>;
  status?: Maybe<Scalars['String']>;
  ws_session_id?: Maybe<Scalars['Int']>;
  ws_session_ref?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "compliance_contacts_stats_overall" */
export type Compliance_Contacts_Stats_Overall_Aggregate = {
  __typename?: 'compliance_contacts_stats_overall_aggregate';
  aggregate?: Maybe<Compliance_Contacts_Stats_Overall_Aggregate_Fields>;
  nodes: Array<Compliance_Contacts_Stats_Overall>;
};

/** aggregate fields of "compliance_contacts_stats_overall" */
export type Compliance_Contacts_Stats_Overall_Aggregate_Fields = {
  __typename?: 'compliance_contacts_stats_overall_aggregate_fields';
  avg?: Maybe<Compliance_Contacts_Stats_Overall_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Contacts_Stats_Overall_Max_Fields>;
  min?: Maybe<Compliance_Contacts_Stats_Overall_Min_Fields>;
  stddev?: Maybe<Compliance_Contacts_Stats_Overall_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Contacts_Stats_Overall_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Contacts_Stats_Overall_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Contacts_Stats_Overall_Sum_Fields>;
  var_pop?: Maybe<Compliance_Contacts_Stats_Overall_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Contacts_Stats_Overall_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Contacts_Stats_Overall_Variance_Fields>;
};


/** aggregate fields of "compliance_contacts_stats_overall" */
export type Compliance_Contacts_Stats_Overall_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Contacts_Stats_Overall_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Contacts_Stats_Overall_Avg_Fields = {
  __typename?: 'compliance_contacts_stats_overall_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_contacts_stats_overall". All fields are combined with a logical 'AND'. */
export type Compliance_Contacts_Stats_Overall_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Contacts_Stats_Overall_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Contacts_Stats_Overall_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Contacts_Stats_Overall_Bool_Exp>>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  contact_id?: InputMaybe<Int_Comparison_Exp>;
  interval_elapsed?: InputMaybe<Interval_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  ws_session_id?: InputMaybe<Int_Comparison_Exp>;
  ws_session_ref?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Compliance_Contacts_Stats_Overall_Max_Fields = {
  __typename?: 'compliance_contacts_stats_overall_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  ws_session_id?: Maybe<Scalars['Int']>;
  ws_session_ref?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Compliance_Contacts_Stats_Overall_Min_Fields = {
  __typename?: 'compliance_contacts_stats_overall_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  ws_session_id?: Maybe<Scalars['Int']>;
  ws_session_ref?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "compliance_contacts_stats_overall". */
export type Compliance_Contacts_Stats_Overall_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  interval_elapsed?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  ws_session_id?: InputMaybe<Order_By>;
  ws_session_ref?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_contacts_stats_overall" */
export enum Compliance_Contacts_Stats_Overall_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  IntervalElapsed = 'interval_elapsed',
  /** column name */
  Status = 'status',
  /** column name */
  WsSessionId = 'ws_session_id',
  /** column name */
  WsSessionRef = 'ws_session_ref'
}

/** aggregate stddev on columns */
export type Compliance_Contacts_Stats_Overall_Stddev_Fields = {
  __typename?: 'compliance_contacts_stats_overall_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Contacts_Stats_Overall_Stddev_Pop_Fields = {
  __typename?: 'compliance_contacts_stats_overall_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Contacts_Stats_Overall_Stddev_Samp_Fields = {
  __typename?: 'compliance_contacts_stats_overall_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_contacts_stats_overall" */
export type Compliance_Contacts_Stats_Overall_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Contacts_Stats_Overall_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Contacts_Stats_Overall_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  contact_id?: InputMaybe<Scalars['Int']>;
  interval_elapsed?: InputMaybe<Scalars['interval']>;
  status?: InputMaybe<Scalars['String']>;
  ws_session_id?: InputMaybe<Scalars['Int']>;
  ws_session_ref?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Compliance_Contacts_Stats_Overall_Sum_Fields = {
  __typename?: 'compliance_contacts_stats_overall_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_id?: Maybe<Scalars['Int']>;
  ws_session_id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Compliance_Contacts_Stats_Overall_Var_Pop_Fields = {
  __typename?: 'compliance_contacts_stats_overall_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Contacts_Stats_Overall_Var_Samp_Fields = {
  __typename?: 'compliance_contacts_stats_overall_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Contacts_Stats_Overall_Variance_Fields = {
  __typename?: 'compliance_contacts_stats_overall_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** select columns of table "compliance_contacts_stats" */
export enum Compliance_Contacts_Stats_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  IntervalElapsed = 'interval_elapsed',
  /** column name */
  Status = 'status',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  WsSessionId = 'ws_session_id',
  /** column name */
  WsSessionRef = 'ws_session_ref'
}

/** columns and relationships of "compliance_contacts_stats_setof" */
export type Compliance_Contacts_Stats_Setof = {
  __typename?: 'compliance_contacts_stats_setof';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['interval']>;
};

export type Compliance_Contacts_Stats_Setof_Aggregate = {
  __typename?: 'compliance_contacts_stats_setof_aggregate';
  aggregate?: Maybe<Compliance_Contacts_Stats_Setof_Aggregate_Fields>;
  nodes: Array<Compliance_Contacts_Stats_Setof>;
};

/** aggregate fields of "compliance_contacts_stats_setof" */
export type Compliance_Contacts_Stats_Setof_Aggregate_Fields = {
  __typename?: 'compliance_contacts_stats_setof_aggregate_fields';
  avg?: Maybe<Compliance_Contacts_Stats_Setof_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Contacts_Stats_Setof_Max_Fields>;
  min?: Maybe<Compliance_Contacts_Stats_Setof_Min_Fields>;
  stddev?: Maybe<Compliance_Contacts_Stats_Setof_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Contacts_Stats_Setof_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Contacts_Stats_Setof_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Contacts_Stats_Setof_Sum_Fields>;
  var_pop?: Maybe<Compliance_Contacts_Stats_Setof_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Contacts_Stats_Setof_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Contacts_Stats_Setof_Variance_Fields>;
};


/** aggregate fields of "compliance_contacts_stats_setof" */
export type Compliance_Contacts_Stats_Setof_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Contacts_Stats_Setof_Avg_Fields = {
  __typename?: 'compliance_contacts_stats_setof_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_contacts_stats_setof". All fields are combined with a logical 'AND'. */
export type Compliance_Contacts_Stats_Setof_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Contacts_Stats_Setof_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Bool_Exp>>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  contact_id?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  time?: InputMaybe<Interval_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "compliance_contacts_stats_setof" */
export type Compliance_Contacts_Stats_Setof_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  contact_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "compliance_contacts_stats_setof" */
export type Compliance_Contacts_Stats_Setof_Insert_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  contact_id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['interval']>;
};

/** aggregate max on columns */
export type Compliance_Contacts_Stats_Setof_Max_Fields = {
  __typename?: 'compliance_contacts_stats_setof_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Compliance_Contacts_Stats_Setof_Min_Fields = {
  __typename?: 'compliance_contacts_stats_setof_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "compliance_contacts_stats_setof" */
export type Compliance_Contacts_Stats_Setof_Mutation_Response = {
  __typename?: 'compliance_contacts_stats_setof_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Contacts_Stats_Setof>;
};

/** Ordering options when selecting data from "compliance_contacts_stats_setof". */
export type Compliance_Contacts_Stats_Setof_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_contacts_stats_setof" */
export enum Compliance_Contacts_Stats_Setof_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Status = 'status',
  /** column name */
  Time = 'time'
}

/** input type for updating data in table "compliance_contacts_stats_setof" */
export type Compliance_Contacts_Stats_Setof_Set_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  contact_id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['interval']>;
};

/** aggregate stddev on columns */
export type Compliance_Contacts_Stats_Setof_Stddev_Fields = {
  __typename?: 'compliance_contacts_stats_setof_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Contacts_Stats_Setof_Stddev_Pop_Fields = {
  __typename?: 'compliance_contacts_stats_setof_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Contacts_Stats_Setof_Stddev_Samp_Fields = {
  __typename?: 'compliance_contacts_stats_setof_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_contacts_stats_setof" */
export type Compliance_Contacts_Stats_Setof_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Contacts_Stats_Setof_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Contacts_Stats_Setof_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  contact_id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['interval']>;
};

/** aggregate sum on columns */
export type Compliance_Contacts_Stats_Setof_Sum_Fields = {
  __typename?: 'compliance_contacts_stats_setof_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_id?: Maybe<Scalars['Int']>;
};

export type Compliance_Contacts_Stats_Setof_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Contacts_Stats_Setof_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Contacts_Stats_Setof_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Contacts_Stats_Setof_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Contacts_Stats_Setof_Var_Pop_Fields = {
  __typename?: 'compliance_contacts_stats_setof_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Contacts_Stats_Setof_Var_Samp_Fields = {
  __typename?: 'compliance_contacts_stats_setof_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Contacts_Stats_Setof_Variance_Fields = {
  __typename?: 'compliance_contacts_stats_setof_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Compliance_Contacts_Stats_Stddev_Fields = {
  __typename?: 'compliance_contacts_stats_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Contacts_Stats_Stddev_Pop_Fields = {
  __typename?: 'compliance_contacts_stats_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Contacts_Stats_Stddev_Samp_Fields = {
  __typename?: 'compliance_contacts_stats_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_contacts_stats" */
export type Compliance_Contacts_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Contacts_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Contacts_Stats_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  contact_id?: InputMaybe<Scalars['Int']>;
  interval_elapsed?: InputMaybe<Scalars['interval']>;
  status?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  ws_session_id?: InputMaybe<Scalars['Int']>;
  ws_session_ref?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Compliance_Contacts_Stats_Sum_Fields = {
  __typename?: 'compliance_contacts_stats_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_id?: Maybe<Scalars['Int']>;
  ws_session_id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Compliance_Contacts_Stats_Var_Pop_Fields = {
  __typename?: 'compliance_contacts_stats_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Contacts_Stats_Var_Samp_Fields = {
  __typename?: 'compliance_contacts_stats_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Contacts_Stats_Variance_Fields = {
  __typename?: 'compliance_contacts_stats_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  contact_id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "compliance_contacts_status" */
export type Compliance_Contacts_Status = {
  __typename?: 'compliance_contacts_status';
  email?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  manager_email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "compliance_contacts_status" */
export type Compliance_Contacts_Status_Aggregate = {
  __typename?: 'compliance_contacts_status_aggregate';
  aggregate?: Maybe<Compliance_Contacts_Status_Aggregate_Fields>;
  nodes: Array<Compliance_Contacts_Status>;
};

/** aggregate fields of "compliance_contacts_status" */
export type Compliance_Contacts_Status_Aggregate_Fields = {
  __typename?: 'compliance_contacts_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Compliance_Contacts_Status_Max_Fields>;
  min?: Maybe<Compliance_Contacts_Status_Min_Fields>;
};


/** aggregate fields of "compliance_contacts_status" */
export type Compliance_Contacts_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Contacts_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "compliance_contacts_status". All fields are combined with a logical 'AND'. */
export type Compliance_Contacts_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Contacts_Status_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Contacts_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Contacts_Status_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  group?: InputMaybe<String_Comparison_Exp>;
  manager_email?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "compliance_contacts_status" */
export type Compliance_Contacts_Status_Insert_Input = {
  email?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  manager_email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Compliance_Contacts_Status_Max_Fields = {
  __typename?: 'compliance_contacts_status_max_fields';
  email?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  manager_email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Compliance_Contacts_Status_Min_Fields = {
  __typename?: 'compliance_contacts_status_min_fields';
  email?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  manager_email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** input type for inserting object relation for remote table "compliance_contacts_status" */
export type Compliance_Contacts_Status_Obj_Rel_Insert_Input = {
  data: Compliance_Contacts_Status_Insert_Input;
};

/** Ordering options when selecting data from "compliance_contacts_status". */
export type Compliance_Contacts_Status_Order_By = {
  email?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  manager_email?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_contacts_status" */
export enum Compliance_Contacts_Status_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Group = 'group',
  /** column name */
  ManagerEmail = 'manager_email',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  Status = 'status',
  /** column name */
  Uuid = 'uuid'
}

/** Streaming cursor of the table "compliance_contacts_status" */
export type Compliance_Contacts_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Contacts_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Contacts_Status_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  manager_email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Compliance_Contacts_Stddev_Fields = {
  __typename?: 'compliance_contacts_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invite_counter?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Contacts_Stddev_Pop_Fields = {
  __typename?: 'compliance_contacts_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invite_counter?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Contacts_Stddev_Samp_Fields = {
  __typename?: 'compliance_contacts_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invite_counter?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_contacts" */
export type Compliance_Contacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Contacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Contacts_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  invite_counter?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  ws_session_ref?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Compliance_Contacts_Sum_Fields = {
  __typename?: 'compliance_contacts_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  invite_counter?: Maybe<Scalars['Int']>;
};

export type Compliance_Contacts_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Compliance_Contacts_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Compliance_Contacts_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Compliance_Contacts_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Compliance_Contacts_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Contacts_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Compliance_Contacts_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Contacts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Contacts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Contacts_Var_Pop_Fields = {
  __typename?: 'compliance_contacts_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invite_counter?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Contacts_Var_Samp_Fields = {
  __typename?: 'compliance_contacts_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invite_counter?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Contacts_Variance_Fields = {
  __typename?: 'compliance_contacts_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invite_counter?: Maybe<Scalars['Float']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Compliance_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Compliance_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Compliance_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "compliance_events" */
export type Compliance_Events = {
  __typename?: 'compliance_events';
  comment?: Maybe<Scalars['String']>;
  /** An object relationship */
  compliance: Compliance;
  /** An object relationship */
  compliance_contact: Compliance_Contacts_Raw;
  compliance_contact_id: Scalars['Int'];
  compliance_id: Scalars['Int'];
  /** An object relationship */
  compliance_message?: Maybe<Compliance_Messages>;
  compliance_message_id: Scalars['Int'];
  /** An object relationship */
  compliance_rule: Compliance_Rules;
  compliance_rule_id: Scalars['Int'];
  created_at?: Maybe<Scalars['timestamptz']>;
  data?: Maybe<Scalars['jsonb']>;
  id: Scalars['Int'];
  message_unix_timestamp?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "compliance_events" */
export type Compliance_EventsDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "compliance_events" */
export type Compliance_Events_Aggregate = {
  __typename?: 'compliance_events_aggregate';
  aggregate?: Maybe<Compliance_Events_Aggregate_Fields>;
  nodes: Array<Compliance_Events>;
};

export type Compliance_Events_Aggregate_Bool_Exp = {
  count?: InputMaybe<Compliance_Events_Aggregate_Bool_Exp_Count>;
};

export type Compliance_Events_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Compliance_Events_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance_events" */
export type Compliance_Events_Aggregate_Fields = {
  __typename?: 'compliance_events_aggregate_fields';
  avg?: Maybe<Compliance_Events_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Events_Max_Fields>;
  min?: Maybe<Compliance_Events_Min_Fields>;
  stddev?: Maybe<Compliance_Events_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Events_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Events_Sum_Fields>;
  var_pop?: Maybe<Compliance_Events_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Events_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Events_Variance_Fields>;
};


/** aggregate fields of "compliance_events" */
export type Compliance_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance_events" */
export type Compliance_Events_Aggregate_Order_By = {
  avg?: InputMaybe<Compliance_Events_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Compliance_Events_Max_Order_By>;
  min?: InputMaybe<Compliance_Events_Min_Order_By>;
  stddev?: InputMaybe<Compliance_Events_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Compliance_Events_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Compliance_Events_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Compliance_Events_Sum_Order_By>;
  var_pop?: InputMaybe<Compliance_Events_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Compliance_Events_Var_Samp_Order_By>;
  variance?: InputMaybe<Compliance_Events_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Compliance_Events_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "compliance_events" */
export type Compliance_Events_Arr_Rel_Insert_Input = {
  data: Array<Compliance_Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Compliance_Events_On_Conflict>;
};

/** aggregate avg on columns */
export type Compliance_Events_Avg_Fields = {
  __typename?: 'compliance_events_avg_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  compliance_message_id?: Maybe<Scalars['Float']>;
  compliance_rule_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  message_unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "compliance_events" */
export type Compliance_Events_Avg_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  compliance_message_id?: InputMaybe<Order_By>;
  compliance_rule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_unix_timestamp?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "compliance_events". All fields are combined with a logical 'AND'. */
export type Compliance_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Events_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Events_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_contact?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
  compliance_contact_id?: InputMaybe<Int_Comparison_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  compliance_message?: InputMaybe<Compliance_Messages_Bool_Exp>;
  compliance_message_id?: InputMaybe<Int_Comparison_Exp>;
  compliance_rule?: InputMaybe<Compliance_Rules_Bool_Exp>;
  compliance_rule_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  message_unix_timestamp?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "compliance_events_classification_goals" */
export type Compliance_Events_Classification_Goals = {
  __typename?: 'compliance_events_classification_goals';
  /** An object relationship */
  compliance: Compliance;
  compliance_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  enable: Scalars['Boolean'];
  high: Scalars['Int'];
  low: Scalars['Int'];
  moderate: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "compliance_events_classification_goals" */
export type Compliance_Events_Classification_Goals_Aggregate = {
  __typename?: 'compliance_events_classification_goals_aggregate';
  aggregate?: Maybe<Compliance_Events_Classification_Goals_Aggregate_Fields>;
  nodes: Array<Compliance_Events_Classification_Goals>;
};

/** aggregate fields of "compliance_events_classification_goals" */
export type Compliance_Events_Classification_Goals_Aggregate_Fields = {
  __typename?: 'compliance_events_classification_goals_aggregate_fields';
  avg?: Maybe<Compliance_Events_Classification_Goals_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Events_Classification_Goals_Max_Fields>;
  min?: Maybe<Compliance_Events_Classification_Goals_Min_Fields>;
  stddev?: Maybe<Compliance_Events_Classification_Goals_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Events_Classification_Goals_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Events_Classification_Goals_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Events_Classification_Goals_Sum_Fields>;
  var_pop?: Maybe<Compliance_Events_Classification_Goals_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Events_Classification_Goals_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Events_Classification_Goals_Variance_Fields>;
};


/** aggregate fields of "compliance_events_classification_goals" */
export type Compliance_Events_Classification_Goals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Events_Classification_Goals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Events_Classification_Goals_Avg_Fields = {
  __typename?: 'compliance_events_classification_goals_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  moderate?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_events_classification_goals". All fields are combined with a logical 'AND'. */
export type Compliance_Events_Classification_Goals_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Events_Classification_Goals_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Events_Classification_Goals_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Events_Classification_Goals_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  enable?: InputMaybe<Boolean_Comparison_Exp>;
  high?: InputMaybe<Int_Comparison_Exp>;
  low?: InputMaybe<Int_Comparison_Exp>;
  moderate?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance_events_classification_goals" */
export enum Compliance_Events_Classification_Goals_Constraint {
  /** unique or primary key constraint on columns "compliance_id" */
  ComplianceEventsClassificationGoalsPkey = 'compliance_events_classification_goals_pkey'
}

/** input type for incrementing numeric columns in table "compliance_events_classification_goals" */
export type Compliance_Events_Classification_Goals_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  high?: InputMaybe<Scalars['Int']>;
  low?: InputMaybe<Scalars['Int']>;
  moderate?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "compliance_events_classification_goals" */
export type Compliance_Events_Classification_Goals_Insert_Input = {
  compliance?: InputMaybe<Compliance_Obj_Rel_Insert_Input>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  enable?: InputMaybe<Scalars['Boolean']>;
  high?: InputMaybe<Scalars['Int']>;
  low?: InputMaybe<Scalars['Int']>;
  moderate?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Compliance_Events_Classification_Goals_Max_Fields = {
  __typename?: 'compliance_events_classification_goals_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  high?: Maybe<Scalars['Int']>;
  low?: Maybe<Scalars['Int']>;
  moderate?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Compliance_Events_Classification_Goals_Min_Fields = {
  __typename?: 'compliance_events_classification_goals_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  high?: Maybe<Scalars['Int']>;
  low?: Maybe<Scalars['Int']>;
  moderate?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "compliance_events_classification_goals" */
export type Compliance_Events_Classification_Goals_Mutation_Response = {
  __typename?: 'compliance_events_classification_goals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Events_Classification_Goals>;
};

/** on_conflict condition type for table "compliance_events_classification_goals" */
export type Compliance_Events_Classification_Goals_On_Conflict = {
  constraint: Compliance_Events_Classification_Goals_Constraint;
  update_columns?: Array<Compliance_Events_Classification_Goals_Update_Column>;
  where?: InputMaybe<Compliance_Events_Classification_Goals_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance_events_classification_goals". */
export type Compliance_Events_Classification_Goals_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  enable?: InputMaybe<Order_By>;
  high?: InputMaybe<Order_By>;
  low?: InputMaybe<Order_By>;
  moderate?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance_events_classification_goals */
export type Compliance_Events_Classification_Goals_Pk_Columns_Input = {
  compliance_id: Scalars['Int'];
};

/** select columns of table "compliance_events_classification_goals" */
export enum Compliance_Events_Classification_Goals_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Enable = 'enable',
  /** column name */
  High = 'high',
  /** column name */
  Low = 'low',
  /** column name */
  Moderate = 'moderate',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "compliance_events_classification_goals" */
export type Compliance_Events_Classification_Goals_Set_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  enable?: InputMaybe<Scalars['Boolean']>;
  high?: InputMaybe<Scalars['Int']>;
  low?: InputMaybe<Scalars['Int']>;
  moderate?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Compliance_Events_Classification_Goals_Stddev_Fields = {
  __typename?: 'compliance_events_classification_goals_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  moderate?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Events_Classification_Goals_Stddev_Pop_Fields = {
  __typename?: 'compliance_events_classification_goals_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  moderate?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Events_Classification_Goals_Stddev_Samp_Fields = {
  __typename?: 'compliance_events_classification_goals_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  moderate?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_events_classification_goals" */
export type Compliance_Events_Classification_Goals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Events_Classification_Goals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Events_Classification_Goals_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  enable?: InputMaybe<Scalars['Boolean']>;
  high?: InputMaybe<Scalars['Int']>;
  low?: InputMaybe<Scalars['Int']>;
  moderate?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Compliance_Events_Classification_Goals_Sum_Fields = {
  __typename?: 'compliance_events_classification_goals_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  high?: Maybe<Scalars['Int']>;
  low?: Maybe<Scalars['Int']>;
  moderate?: Maybe<Scalars['Int']>;
};

/** update columns of table "compliance_events_classification_goals" */
export enum Compliance_Events_Classification_Goals_Update_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Enable = 'enable',
  /** column name */
  High = 'high',
  /** column name */
  Low = 'low',
  /** column name */
  Moderate = 'moderate',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Compliance_Events_Classification_Goals_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Events_Classification_Goals_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Events_Classification_Goals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Events_Classification_Goals_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Events_Classification_Goals_Var_Pop_Fields = {
  __typename?: 'compliance_events_classification_goals_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  moderate?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Events_Classification_Goals_Var_Samp_Fields = {
  __typename?: 'compliance_events_classification_goals_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  moderate?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Events_Classification_Goals_Variance_Fields = {
  __typename?: 'compliance_events_classification_goals_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  moderate?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "compliance_events_classification_resumes" */
export type Compliance_Events_Classification_Resumes = {
  __typename?: 'compliance_events_classification_resumes';
  /** An object relationship */
  compliance: Compliance;
  compliance_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  data: Scalars['jsonb'];
  final_date: Scalars['bigint'];
  id: Scalars['Int'];
  initial_date: Scalars['bigint'];
  uuid: Scalars['uuid'];
};


/** columns and relationships of "compliance_events_classification_resumes" */
export type Compliance_Events_Classification_ResumesDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "compliance_events_classification_resumes" */
export type Compliance_Events_Classification_Resumes_Aggregate = {
  __typename?: 'compliance_events_classification_resumes_aggregate';
  aggregate?: Maybe<Compliance_Events_Classification_Resumes_Aggregate_Fields>;
  nodes: Array<Compliance_Events_Classification_Resumes>;
};

/** aggregate fields of "compliance_events_classification_resumes" */
export type Compliance_Events_Classification_Resumes_Aggregate_Fields = {
  __typename?: 'compliance_events_classification_resumes_aggregate_fields';
  avg?: Maybe<Compliance_Events_Classification_Resumes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Events_Classification_Resumes_Max_Fields>;
  min?: Maybe<Compliance_Events_Classification_Resumes_Min_Fields>;
  stddev?: Maybe<Compliance_Events_Classification_Resumes_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Events_Classification_Resumes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Events_Classification_Resumes_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Events_Classification_Resumes_Sum_Fields>;
  var_pop?: Maybe<Compliance_Events_Classification_Resumes_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Events_Classification_Resumes_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Events_Classification_Resumes_Variance_Fields>;
};


/** aggregate fields of "compliance_events_classification_resumes" */
export type Compliance_Events_Classification_Resumes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Events_Classification_Resumes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Compliance_Events_Classification_Resumes_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Compliance_Events_Classification_Resumes_Avg_Fields = {
  __typename?: 'compliance_events_classification_resumes_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  final_date?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  initial_date?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_events_classification_resumes". All fields are combined with a logical 'AND'. */
export type Compliance_Events_Classification_Resumes_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Events_Classification_Resumes_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Events_Classification_Resumes_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Events_Classification_Resumes_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  final_date?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  initial_date?: InputMaybe<Bigint_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance_events_classification_resumes" */
export enum Compliance_Events_Classification_Resumes_Constraint {
  /** unique or primary key constraint on columns "id" */
  ComplianceEventsClassificationResumesPkey = 'compliance_events_classification_resumes_pkey',
  /** unique or primary key constraint on columns "uuid" */
  ComplianceEventsClassificationResumesUuidKey = 'compliance_events_classification_resumes_uuid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Compliance_Events_Classification_Resumes_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Compliance_Events_Classification_Resumes_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Compliance_Events_Classification_Resumes_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "compliance_events_classification_resumes" */
export type Compliance_Events_Classification_Resumes_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  final_date?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['Int']>;
  initial_date?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "compliance_events_classification_resumes" */
export type Compliance_Events_Classification_Resumes_Insert_Input = {
  compliance?: InputMaybe<Compliance_Obj_Rel_Insert_Input>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  final_date?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['Int']>;
  initial_date?: InputMaybe<Scalars['bigint']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Compliance_Events_Classification_Resumes_Max_Fields = {
  __typename?: 'compliance_events_classification_resumes_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  final_date?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['Int']>;
  initial_date?: Maybe<Scalars['bigint']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Compliance_Events_Classification_Resumes_Min_Fields = {
  __typename?: 'compliance_events_classification_resumes_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  final_date?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['Int']>;
  initial_date?: Maybe<Scalars['bigint']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "compliance_events_classification_resumes" */
export type Compliance_Events_Classification_Resumes_Mutation_Response = {
  __typename?: 'compliance_events_classification_resumes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Events_Classification_Resumes>;
};

/** on_conflict condition type for table "compliance_events_classification_resumes" */
export type Compliance_Events_Classification_Resumes_On_Conflict = {
  constraint: Compliance_Events_Classification_Resumes_Constraint;
  update_columns?: Array<Compliance_Events_Classification_Resumes_Update_Column>;
  where?: InputMaybe<Compliance_Events_Classification_Resumes_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance_events_classification_resumes". */
export type Compliance_Events_Classification_Resumes_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  final_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_date?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance_events_classification_resumes */
export type Compliance_Events_Classification_Resumes_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Compliance_Events_Classification_Resumes_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "compliance_events_classification_resumes" */
export enum Compliance_Events_Classification_Resumes_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  FinalDate = 'final_date',
  /** column name */
  Id = 'id',
  /** column name */
  InitialDate = 'initial_date',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "compliance_events_classification_resumes" */
export type Compliance_Events_Classification_Resumes_Set_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  final_date?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['Int']>;
  initial_date?: InputMaybe<Scalars['bigint']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Compliance_Events_Classification_Resumes_Stddev_Fields = {
  __typename?: 'compliance_events_classification_resumes_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  final_date?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  initial_date?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Events_Classification_Resumes_Stddev_Pop_Fields = {
  __typename?: 'compliance_events_classification_resumes_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  final_date?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  initial_date?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Events_Classification_Resumes_Stddev_Samp_Fields = {
  __typename?: 'compliance_events_classification_resumes_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  final_date?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  initial_date?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_events_classification_resumes" */
export type Compliance_Events_Classification_Resumes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Events_Classification_Resumes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Events_Classification_Resumes_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  final_date?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['Int']>;
  initial_date?: InputMaybe<Scalars['bigint']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Compliance_Events_Classification_Resumes_Sum_Fields = {
  __typename?: 'compliance_events_classification_resumes_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  final_date?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['Int']>;
  initial_date?: Maybe<Scalars['bigint']>;
};

/** update columns of table "compliance_events_classification_resumes" */
export enum Compliance_Events_Classification_Resumes_Update_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  FinalDate = 'final_date',
  /** column name */
  Id = 'id',
  /** column name */
  InitialDate = 'initial_date',
  /** column name */
  Uuid = 'uuid'
}

export type Compliance_Events_Classification_Resumes_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Compliance_Events_Classification_Resumes_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Compliance_Events_Classification_Resumes_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Compliance_Events_Classification_Resumes_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Compliance_Events_Classification_Resumes_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Events_Classification_Resumes_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Compliance_Events_Classification_Resumes_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Events_Classification_Resumes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Events_Classification_Resumes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Events_Classification_Resumes_Var_Pop_Fields = {
  __typename?: 'compliance_events_classification_resumes_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  final_date?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  initial_date?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Events_Classification_Resumes_Var_Samp_Fields = {
  __typename?: 'compliance_events_classification_resumes_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  final_date?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  initial_date?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Events_Classification_Resumes_Variance_Fields = {
  __typename?: 'compliance_events_classification_resumes_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  final_date?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  initial_date?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "compliance_events" */
export enum Compliance_Events_Constraint {
  /** unique or primary key constraint on columns "compliance_message_id", "compliance_rule_id", "compliance_id", "compliance_contact_id" */
  ComplianceEventsComplianceRuleIdComplianceContactIdComp = 'compliance_events_compliance_rule_id_compliance_contact_id_comp',
  /** unique or primary key constraint on columns "id" */
  ComplianceEventsPkey = 'compliance_events_pkey'
}

/** columns and relationships of "compliance_events_daily" */
export type Compliance_Events_Daily = {
  __typename?: 'compliance_events_daily';
  /** An object relationship */
  compliance?: Maybe<Compliance>;
  compliance_id?: Maybe<Scalars['Int']>;
  day?: Maybe<Scalars['timestamptz']>;
  event_count?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "compliance_events_daily" */
export type Compliance_Events_Daily_Aggregate = {
  __typename?: 'compliance_events_daily_aggregate';
  aggregate?: Maybe<Compliance_Events_Daily_Aggregate_Fields>;
  nodes: Array<Compliance_Events_Daily>;
};

/** aggregate fields of "compliance_events_daily" */
export type Compliance_Events_Daily_Aggregate_Fields = {
  __typename?: 'compliance_events_daily_aggregate_fields';
  avg?: Maybe<Compliance_Events_Daily_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Events_Daily_Max_Fields>;
  min?: Maybe<Compliance_Events_Daily_Min_Fields>;
  stddev?: Maybe<Compliance_Events_Daily_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Events_Daily_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Events_Daily_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Events_Daily_Sum_Fields>;
  var_pop?: Maybe<Compliance_Events_Daily_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Events_Daily_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Events_Daily_Variance_Fields>;
};


/** aggregate fields of "compliance_events_daily" */
export type Compliance_Events_Daily_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Events_Daily_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Events_Daily_Avg_Fields = {
  __typename?: 'compliance_events_daily_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_events_daily". All fields are combined with a logical 'AND'. */
export type Compliance_Events_Daily_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Events_Daily_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Events_Daily_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Events_Daily_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  day?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_count?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Compliance_Events_Daily_Max_Fields = {
  __typename?: 'compliance_events_daily_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  day?: Maybe<Scalars['timestamptz']>;
  event_count?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Compliance_Events_Daily_Min_Fields = {
  __typename?: 'compliance_events_daily_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  day?: Maybe<Scalars['timestamptz']>;
  event_count?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "compliance_events_daily". */
export type Compliance_Events_Daily_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  event_count?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_events_daily" */
export enum Compliance_Events_Daily_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  Day = 'day',
  /** column name */
  EventCount = 'event_count'
}

/** aggregate stddev on columns */
export type Compliance_Events_Daily_Stddev_Fields = {
  __typename?: 'compliance_events_daily_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Events_Daily_Stddev_Pop_Fields = {
  __typename?: 'compliance_events_daily_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Events_Daily_Stddev_Samp_Fields = {
  __typename?: 'compliance_events_daily_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_events_daily" */
export type Compliance_Events_Daily_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Events_Daily_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Events_Daily_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  day?: InputMaybe<Scalars['timestamptz']>;
  event_count?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Compliance_Events_Daily_Sum_Fields = {
  __typename?: 'compliance_events_daily_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Compliance_Events_Daily_Var_Pop_Fields = {
  __typename?: 'compliance_events_daily_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Events_Daily_Var_Samp_Fields = {
  __typename?: 'compliance_events_daily_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Events_Daily_Variance_Fields = {
  __typename?: 'compliance_events_daily_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Compliance_Events_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Compliance_Events_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Compliance_Events_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "compliance_events_hourly" */
export type Compliance_Events_Hourly = {
  __typename?: 'compliance_events_hourly';
  /** An object relationship */
  compliance?: Maybe<Compliance>;
  compliance_id: Scalars['Int'];
  event_count?: Maybe<Scalars['bigint']>;
  hour: Scalars['timestamptz'];
};

/** aggregated selection of "compliance_events_hourly" */
export type Compliance_Events_Hourly_Aggregate = {
  __typename?: 'compliance_events_hourly_aggregate';
  aggregate?: Maybe<Compliance_Events_Hourly_Aggregate_Fields>;
  nodes: Array<Compliance_Events_Hourly>;
};

/** aggregate fields of "compliance_events_hourly" */
export type Compliance_Events_Hourly_Aggregate_Fields = {
  __typename?: 'compliance_events_hourly_aggregate_fields';
  avg?: Maybe<Compliance_Events_Hourly_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Events_Hourly_Max_Fields>;
  min?: Maybe<Compliance_Events_Hourly_Min_Fields>;
  stddev?: Maybe<Compliance_Events_Hourly_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Events_Hourly_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Events_Hourly_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Events_Hourly_Sum_Fields>;
  var_pop?: Maybe<Compliance_Events_Hourly_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Events_Hourly_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Events_Hourly_Variance_Fields>;
};


/** aggregate fields of "compliance_events_hourly" */
export type Compliance_Events_Hourly_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Events_Hourly_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Events_Hourly_Avg_Fields = {
  __typename?: 'compliance_events_hourly_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_events_hourly". All fields are combined with a logical 'AND'. */
export type Compliance_Events_Hourly_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Events_Hourly_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Events_Hourly_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Events_Hourly_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  event_count?: InputMaybe<Bigint_Comparison_Exp>;
  hour?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance_events_hourly" */
export enum Compliance_Events_Hourly_Constraint {
  /** unique or primary key constraint on columns "hour", "compliance_id" */
  ComplianceEventsHourlyPkey = 'compliance_events_hourly_pkey'
}

/** input type for incrementing numeric columns in table "compliance_events_hourly" */
export type Compliance_Events_Hourly_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  event_count?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "compliance_events_hourly" */
export type Compliance_Events_Hourly_Insert_Input = {
  compliance?: InputMaybe<Compliance_Obj_Rel_Insert_Input>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  event_count?: InputMaybe<Scalars['bigint']>;
  hour?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Compliance_Events_Hourly_Max_Fields = {
  __typename?: 'compliance_events_hourly_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['bigint']>;
  hour?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Compliance_Events_Hourly_Min_Fields = {
  __typename?: 'compliance_events_hourly_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['bigint']>;
  hour?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "compliance_events_hourly" */
export type Compliance_Events_Hourly_Mutation_Response = {
  __typename?: 'compliance_events_hourly_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Events_Hourly>;
};

/** on_conflict condition type for table "compliance_events_hourly" */
export type Compliance_Events_Hourly_On_Conflict = {
  constraint: Compliance_Events_Hourly_Constraint;
  update_columns?: Array<Compliance_Events_Hourly_Update_Column>;
  where?: InputMaybe<Compliance_Events_Hourly_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance_events_hourly". */
export type Compliance_Events_Hourly_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  event_count?: InputMaybe<Order_By>;
  hour?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance_events_hourly */
export type Compliance_Events_Hourly_Pk_Columns_Input = {
  compliance_id: Scalars['Int'];
  hour: Scalars['timestamptz'];
};

/** select columns of table "compliance_events_hourly" */
export enum Compliance_Events_Hourly_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  EventCount = 'event_count',
  /** column name */
  Hour = 'hour'
}

/** input type for updating data in table "compliance_events_hourly" */
export type Compliance_Events_Hourly_Set_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  event_count?: InputMaybe<Scalars['bigint']>;
  hour?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Compliance_Events_Hourly_Stddev_Fields = {
  __typename?: 'compliance_events_hourly_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Events_Hourly_Stddev_Pop_Fields = {
  __typename?: 'compliance_events_hourly_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Events_Hourly_Stddev_Samp_Fields = {
  __typename?: 'compliance_events_hourly_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_events_hourly" */
export type Compliance_Events_Hourly_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Events_Hourly_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Events_Hourly_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  event_count?: InputMaybe<Scalars['bigint']>;
  hour?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Compliance_Events_Hourly_Sum_Fields = {
  __typename?: 'compliance_events_hourly_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['bigint']>;
};

/** update columns of table "compliance_events_hourly" */
export enum Compliance_Events_Hourly_Update_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  EventCount = 'event_count',
  /** column name */
  Hour = 'hour'
}

export type Compliance_Events_Hourly_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Events_Hourly_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Events_Hourly_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Events_Hourly_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Events_Hourly_Var_Pop_Fields = {
  __typename?: 'compliance_events_hourly_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Events_Hourly_Var_Samp_Fields = {
  __typename?: 'compliance_events_hourly_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Events_Hourly_Variance_Fields = {
  __typename?: 'compliance_events_hourly_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "compliance_events" */
export type Compliance_Events_Inc_Input = {
  compliance_contact_id?: InputMaybe<Scalars['Int']>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  compliance_message_id?: InputMaybe<Scalars['Int']>;
  compliance_rule_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  message_unix_timestamp?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "compliance_events" */
export type Compliance_Events_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  compliance?: InputMaybe<Compliance_Obj_Rel_Insert_Input>;
  compliance_contact?: InputMaybe<Compliance_Contacts_Raw_Obj_Rel_Insert_Input>;
  compliance_contact_id?: InputMaybe<Scalars['Int']>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  compliance_message?: InputMaybe<Compliance_Messages_Obj_Rel_Insert_Input>;
  compliance_message_id?: InputMaybe<Scalars['Int']>;
  compliance_rule?: InputMaybe<Compliance_Rules_Obj_Rel_Insert_Input>;
  compliance_rule_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  message_unix_timestamp?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Compliance_Events_Max_Fields = {
  __typename?: 'compliance_events_max_fields';
  comment?: Maybe<Scalars['String']>;
  compliance_contact_id?: Maybe<Scalars['Int']>;
  compliance_id?: Maybe<Scalars['Int']>;
  compliance_message_id?: Maybe<Scalars['Int']>;
  compliance_rule_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  message_unix_timestamp?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "compliance_events" */
export type Compliance_Events_Max_Order_By = {
  comment?: InputMaybe<Order_By>;
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  compliance_message_id?: InputMaybe<Order_By>;
  compliance_rule_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_unix_timestamp?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Compliance_Events_Min_Fields = {
  __typename?: 'compliance_events_min_fields';
  comment?: Maybe<Scalars['String']>;
  compliance_contact_id?: Maybe<Scalars['Int']>;
  compliance_id?: Maybe<Scalars['Int']>;
  compliance_message_id?: Maybe<Scalars['Int']>;
  compliance_rule_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  message_unix_timestamp?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "compliance_events" */
export type Compliance_Events_Min_Order_By = {
  comment?: InputMaybe<Order_By>;
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  compliance_message_id?: InputMaybe<Order_By>;
  compliance_rule_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_unix_timestamp?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** columns and relationships of "compliance_events_monthly" */
export type Compliance_Events_Monthly = {
  __typename?: 'compliance_events_monthly';
  /** An object relationship */
  compliance?: Maybe<Compliance>;
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
  month?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "compliance_events_monthly" */
export type Compliance_Events_Monthly_Aggregate = {
  __typename?: 'compliance_events_monthly_aggregate';
  aggregate?: Maybe<Compliance_Events_Monthly_Aggregate_Fields>;
  nodes: Array<Compliance_Events_Monthly>;
};

/** aggregate fields of "compliance_events_monthly" */
export type Compliance_Events_Monthly_Aggregate_Fields = {
  __typename?: 'compliance_events_monthly_aggregate_fields';
  avg?: Maybe<Compliance_Events_Monthly_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Events_Monthly_Max_Fields>;
  min?: Maybe<Compliance_Events_Monthly_Min_Fields>;
  stddev?: Maybe<Compliance_Events_Monthly_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Events_Monthly_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Events_Monthly_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Events_Monthly_Sum_Fields>;
  var_pop?: Maybe<Compliance_Events_Monthly_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Events_Monthly_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Events_Monthly_Variance_Fields>;
};


/** aggregate fields of "compliance_events_monthly" */
export type Compliance_Events_Monthly_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Events_Monthly_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Events_Monthly_Avg_Fields = {
  __typename?: 'compliance_events_monthly_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_events_monthly". All fields are combined with a logical 'AND'. */
export type Compliance_Events_Monthly_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Events_Monthly_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Events_Monthly_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Events_Monthly_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  event_count?: InputMaybe<Numeric_Comparison_Exp>;
  month?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Compliance_Events_Monthly_Max_Fields = {
  __typename?: 'compliance_events_monthly_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
  month?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Compliance_Events_Monthly_Min_Fields = {
  __typename?: 'compliance_events_monthly_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
  month?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "compliance_events_monthly". */
export type Compliance_Events_Monthly_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  event_count?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_events_monthly" */
export enum Compliance_Events_Monthly_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  EventCount = 'event_count',
  /** column name */
  Month = 'month'
}

/** aggregate stddev on columns */
export type Compliance_Events_Monthly_Stddev_Fields = {
  __typename?: 'compliance_events_monthly_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Events_Monthly_Stddev_Pop_Fields = {
  __typename?: 'compliance_events_monthly_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Events_Monthly_Stddev_Samp_Fields = {
  __typename?: 'compliance_events_monthly_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_events_monthly" */
export type Compliance_Events_Monthly_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Events_Monthly_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Events_Monthly_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  event_count?: InputMaybe<Scalars['numeric']>;
  month?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Compliance_Events_Monthly_Sum_Fields = {
  __typename?: 'compliance_events_monthly_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Compliance_Events_Monthly_Var_Pop_Fields = {
  __typename?: 'compliance_events_monthly_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Events_Monthly_Var_Samp_Fields = {
  __typename?: 'compliance_events_monthly_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Events_Monthly_Variance_Fields = {
  __typename?: 'compliance_events_monthly_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** response of any mutation on the table "compliance_events" */
export type Compliance_Events_Mutation_Response = {
  __typename?: 'compliance_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Events>;
};

/** on_conflict condition type for table "compliance_events" */
export type Compliance_Events_On_Conflict = {
  constraint: Compliance_Events_Constraint;
  update_columns?: Array<Compliance_Events_Update_Column>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance_events". */
export type Compliance_Events_Order_By = {
  comment?: InputMaybe<Order_By>;
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_contact?: InputMaybe<Compliance_Contacts_Raw_Order_By>;
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  compliance_message?: InputMaybe<Compliance_Messages_Order_By>;
  compliance_message_id?: InputMaybe<Order_By>;
  compliance_rule?: InputMaybe<Compliance_Rules_Order_By>;
  compliance_rule_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_unix_timestamp?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance_events */
export type Compliance_Events_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Compliance_Events_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "compliance_events" */
export enum Compliance_Events_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  ComplianceContactId = 'compliance_contact_id',
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  ComplianceMessageId = 'compliance_message_id',
  /** column name */
  ComplianceRuleId = 'compliance_rule_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  MessageUnixTimestamp = 'message_unix_timestamp',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "compliance_events" */
export type Compliance_Events_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  compliance_contact_id?: InputMaybe<Scalars['Int']>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  compliance_message_id?: InputMaybe<Scalars['Int']>;
  compliance_rule_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  message_unix_timestamp?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "compliance_events_status_hourly" */
export type Compliance_Events_Status_Hourly = {
  __typename?: 'compliance_events_status_hourly';
  /** An object relationship */
  compliance?: Maybe<Compliance>;
  compliance_id: Scalars['Int'];
  event_count?: Maybe<Scalars['bigint']>;
  hour: Scalars['timestamptz'];
  status: Scalars['String'];
};

/** aggregated selection of "compliance_events_status_hourly" */
export type Compliance_Events_Status_Hourly_Aggregate = {
  __typename?: 'compliance_events_status_hourly_aggregate';
  aggregate?: Maybe<Compliance_Events_Status_Hourly_Aggregate_Fields>;
  nodes: Array<Compliance_Events_Status_Hourly>;
};

/** aggregate fields of "compliance_events_status_hourly" */
export type Compliance_Events_Status_Hourly_Aggregate_Fields = {
  __typename?: 'compliance_events_status_hourly_aggregate_fields';
  avg?: Maybe<Compliance_Events_Status_Hourly_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Events_Status_Hourly_Max_Fields>;
  min?: Maybe<Compliance_Events_Status_Hourly_Min_Fields>;
  stddev?: Maybe<Compliance_Events_Status_Hourly_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Events_Status_Hourly_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Events_Status_Hourly_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Events_Status_Hourly_Sum_Fields>;
  var_pop?: Maybe<Compliance_Events_Status_Hourly_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Events_Status_Hourly_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Events_Status_Hourly_Variance_Fields>;
};


/** aggregate fields of "compliance_events_status_hourly" */
export type Compliance_Events_Status_Hourly_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Events_Status_Hourly_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Events_Status_Hourly_Avg_Fields = {
  __typename?: 'compliance_events_status_hourly_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_events_status_hourly". All fields are combined with a logical 'AND'. */
export type Compliance_Events_Status_Hourly_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Events_Status_Hourly_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Events_Status_Hourly_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Events_Status_Hourly_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  event_count?: InputMaybe<Bigint_Comparison_Exp>;
  hour?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance_events_status_hourly" */
export enum Compliance_Events_Status_Hourly_Constraint {
  /** unique or primary key constraint on columns "hour", "compliance_id", "status" */
  ComplianceEventsStatusHourlyPkey = 'compliance_events_status_hourly_pkey'
}

/** input type for incrementing numeric columns in table "compliance_events_status_hourly" */
export type Compliance_Events_Status_Hourly_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  event_count?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "compliance_events_status_hourly" */
export type Compliance_Events_Status_Hourly_Insert_Input = {
  compliance?: InputMaybe<Compliance_Obj_Rel_Insert_Input>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  event_count?: InputMaybe<Scalars['bigint']>;
  hour?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Compliance_Events_Status_Hourly_Max_Fields = {
  __typename?: 'compliance_events_status_hourly_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['bigint']>;
  hour?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Compliance_Events_Status_Hourly_Min_Fields = {
  __typename?: 'compliance_events_status_hourly_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['bigint']>;
  hour?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "compliance_events_status_hourly" */
export type Compliance_Events_Status_Hourly_Mutation_Response = {
  __typename?: 'compliance_events_status_hourly_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Events_Status_Hourly>;
};

/** on_conflict condition type for table "compliance_events_status_hourly" */
export type Compliance_Events_Status_Hourly_On_Conflict = {
  constraint: Compliance_Events_Status_Hourly_Constraint;
  update_columns?: Array<Compliance_Events_Status_Hourly_Update_Column>;
  where?: InputMaybe<Compliance_Events_Status_Hourly_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance_events_status_hourly". */
export type Compliance_Events_Status_Hourly_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  event_count?: InputMaybe<Order_By>;
  hour?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance_events_status_hourly */
export type Compliance_Events_Status_Hourly_Pk_Columns_Input = {
  compliance_id: Scalars['Int'];
  hour: Scalars['timestamptz'];
  status: Scalars['String'];
};

/** select columns of table "compliance_events_status_hourly" */
export enum Compliance_Events_Status_Hourly_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  EventCount = 'event_count',
  /** column name */
  Hour = 'hour',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "compliance_events_status_hourly" */
export type Compliance_Events_Status_Hourly_Set_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  event_count?: InputMaybe<Scalars['bigint']>;
  hour?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Compliance_Events_Status_Hourly_Stddev_Fields = {
  __typename?: 'compliance_events_status_hourly_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Events_Status_Hourly_Stddev_Pop_Fields = {
  __typename?: 'compliance_events_status_hourly_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Events_Status_Hourly_Stddev_Samp_Fields = {
  __typename?: 'compliance_events_status_hourly_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_events_status_hourly" */
export type Compliance_Events_Status_Hourly_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Events_Status_Hourly_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Events_Status_Hourly_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  event_count?: InputMaybe<Scalars['bigint']>;
  hour?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Compliance_Events_Status_Hourly_Sum_Fields = {
  __typename?: 'compliance_events_status_hourly_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['bigint']>;
};

/** update columns of table "compliance_events_status_hourly" */
export enum Compliance_Events_Status_Hourly_Update_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  EventCount = 'event_count',
  /** column name */
  Hour = 'hour',
  /** column name */
  Status = 'status'
}

export type Compliance_Events_Status_Hourly_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Events_Status_Hourly_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Events_Status_Hourly_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Events_Status_Hourly_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Events_Status_Hourly_Var_Pop_Fields = {
  __typename?: 'compliance_events_status_hourly_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Events_Status_Hourly_Var_Samp_Fields = {
  __typename?: 'compliance_events_status_hourly_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Events_Status_Hourly_Variance_Fields = {
  __typename?: 'compliance_events_status_hourly_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "compliance_events_status_total" */
export type Compliance_Events_Status_Total = {
  __typename?: 'compliance_events_status_total';
  /** An object relationship */
  compliance?: Maybe<Compliance>;
  compliance_id?: Maybe<Scalars['Int']>;
  event_status_count?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregated selection of "compliance_events_status_total" */
export type Compliance_Events_Status_Total_Aggregate = {
  __typename?: 'compliance_events_status_total_aggregate';
  aggregate?: Maybe<Compliance_Events_Status_Total_Aggregate_Fields>;
  nodes: Array<Compliance_Events_Status_Total>;
};

/** aggregate fields of "compliance_events_status_total" */
export type Compliance_Events_Status_Total_Aggregate_Fields = {
  __typename?: 'compliance_events_status_total_aggregate_fields';
  avg?: Maybe<Compliance_Events_Status_Total_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Events_Status_Total_Max_Fields>;
  min?: Maybe<Compliance_Events_Status_Total_Min_Fields>;
  stddev?: Maybe<Compliance_Events_Status_Total_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Events_Status_Total_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Events_Status_Total_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Events_Status_Total_Sum_Fields>;
  var_pop?: Maybe<Compliance_Events_Status_Total_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Events_Status_Total_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Events_Status_Total_Variance_Fields>;
};


/** aggregate fields of "compliance_events_status_total" */
export type Compliance_Events_Status_Total_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Events_Status_Total_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Events_Status_Total_Avg_Fields = {
  __typename?: 'compliance_events_status_total_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_status_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_events_status_total". All fields are combined with a logical 'AND'. */
export type Compliance_Events_Status_Total_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Events_Status_Total_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Events_Status_Total_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Events_Status_Total_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  event_status_count?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Compliance_Events_Status_Total_Max_Fields = {
  __typename?: 'compliance_events_status_total_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_status_count?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Compliance_Events_Status_Total_Min_Fields = {
  __typename?: 'compliance_events_status_total_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_status_count?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "compliance_events_status_total". */
export type Compliance_Events_Status_Total_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  event_status_count?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_events_status_total" */
export enum Compliance_Events_Status_Total_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  EventStatusCount = 'event_status_count',
  /** column name */
  Status = 'status'
}

/** aggregate stddev on columns */
export type Compliance_Events_Status_Total_Stddev_Fields = {
  __typename?: 'compliance_events_status_total_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_status_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Events_Status_Total_Stddev_Pop_Fields = {
  __typename?: 'compliance_events_status_total_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_status_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Events_Status_Total_Stddev_Samp_Fields = {
  __typename?: 'compliance_events_status_total_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_status_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_events_status_total" */
export type Compliance_Events_Status_Total_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Events_Status_Total_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Events_Status_Total_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  event_status_count?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Compliance_Events_Status_Total_Sum_Fields = {
  __typename?: 'compliance_events_status_total_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_status_count?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Compliance_Events_Status_Total_Var_Pop_Fields = {
  __typename?: 'compliance_events_status_total_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_status_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Events_Status_Total_Var_Samp_Fields = {
  __typename?: 'compliance_events_status_total_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_status_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Events_Status_Total_Variance_Fields = {
  __typename?: 'compliance_events_status_total_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_status_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Compliance_Events_Stddev_Fields = {
  __typename?: 'compliance_events_stddev_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  compliance_message_id?: Maybe<Scalars['Float']>;
  compliance_rule_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  message_unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "compliance_events" */
export type Compliance_Events_Stddev_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  compliance_message_id?: InputMaybe<Order_By>;
  compliance_rule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Events_Stddev_Pop_Fields = {
  __typename?: 'compliance_events_stddev_pop_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  compliance_message_id?: Maybe<Scalars['Float']>;
  compliance_rule_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  message_unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "compliance_events" */
export type Compliance_Events_Stddev_Pop_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  compliance_message_id?: InputMaybe<Order_By>;
  compliance_rule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Events_Stddev_Samp_Fields = {
  __typename?: 'compliance_events_stddev_samp_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  compliance_message_id?: Maybe<Scalars['Float']>;
  compliance_rule_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  message_unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "compliance_events" */
export type Compliance_Events_Stddev_Samp_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  compliance_message_id?: InputMaybe<Order_By>;
  compliance_rule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_unix_timestamp?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "compliance_events" */
export type Compliance_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Events_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  compliance_contact_id?: InputMaybe<Scalars['Int']>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  compliance_message_id?: InputMaybe<Scalars['Int']>;
  compliance_rule_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  message_unix_timestamp?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Compliance_Events_Sum_Fields = {
  __typename?: 'compliance_events_sum_fields';
  compliance_contact_id?: Maybe<Scalars['Int']>;
  compliance_id?: Maybe<Scalars['Int']>;
  compliance_message_id?: Maybe<Scalars['Int']>;
  compliance_rule_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  message_unix_timestamp?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "compliance_events" */
export type Compliance_Events_Sum_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  compliance_message_id?: InputMaybe<Order_By>;
  compliance_rule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_unix_timestamp?: InputMaybe<Order_By>;
};

/** columns and relationships of "compliance_events_total" */
export type Compliance_Events_Total = {
  __typename?: 'compliance_events_total';
  /** An object relationship */
  compliance?: Maybe<Compliance>;
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "compliance_events_total" */
export type Compliance_Events_Total_Aggregate = {
  __typename?: 'compliance_events_total_aggregate';
  aggregate?: Maybe<Compliance_Events_Total_Aggregate_Fields>;
  nodes: Array<Compliance_Events_Total>;
};

/** aggregate fields of "compliance_events_total" */
export type Compliance_Events_Total_Aggregate_Fields = {
  __typename?: 'compliance_events_total_aggregate_fields';
  avg?: Maybe<Compliance_Events_Total_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Events_Total_Max_Fields>;
  min?: Maybe<Compliance_Events_Total_Min_Fields>;
  stddev?: Maybe<Compliance_Events_Total_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Events_Total_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Events_Total_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Events_Total_Sum_Fields>;
  var_pop?: Maybe<Compliance_Events_Total_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Events_Total_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Events_Total_Variance_Fields>;
};


/** aggregate fields of "compliance_events_total" */
export type Compliance_Events_Total_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Events_Total_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Events_Total_Avg_Fields = {
  __typename?: 'compliance_events_total_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_events_total". All fields are combined with a logical 'AND'. */
export type Compliance_Events_Total_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Events_Total_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Events_Total_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Events_Total_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  event_count?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Compliance_Events_Total_Max_Fields = {
  __typename?: 'compliance_events_total_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Compliance_Events_Total_Min_Fields = {
  __typename?: 'compliance_events_total_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "compliance_events_total". */
export type Compliance_Events_Total_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  event_count?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_events_total" */
export enum Compliance_Events_Total_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  EventCount = 'event_count'
}

/** aggregate stddev on columns */
export type Compliance_Events_Total_Stddev_Fields = {
  __typename?: 'compliance_events_total_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Events_Total_Stddev_Pop_Fields = {
  __typename?: 'compliance_events_total_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Events_Total_Stddev_Samp_Fields = {
  __typename?: 'compliance_events_total_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_events_total" */
export type Compliance_Events_Total_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Events_Total_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Events_Total_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  event_count?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Compliance_Events_Total_Sum_Fields = {
  __typename?: 'compliance_events_total_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Compliance_Events_Total_Var_Pop_Fields = {
  __typename?: 'compliance_events_total_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Events_Total_Var_Samp_Fields = {
  __typename?: 'compliance_events_total_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Events_Total_Variance_Fields = {
  __typename?: 'compliance_events_total_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** update columns of table "compliance_events" */
export enum Compliance_Events_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  ComplianceContactId = 'compliance_contact_id',
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  ComplianceMessageId = 'compliance_message_id',
  /** column name */
  ComplianceRuleId = 'compliance_rule_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  MessageUnixTimestamp = 'message_unix_timestamp',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Compliance_Events_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Compliance_Events_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Compliance_Events_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Compliance_Events_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Compliance_Events_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Events_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Compliance_Events_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Events_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Events_Var_Pop_Fields = {
  __typename?: 'compliance_events_var_pop_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  compliance_message_id?: Maybe<Scalars['Float']>;
  compliance_rule_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  message_unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "compliance_events" */
export type Compliance_Events_Var_Pop_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  compliance_message_id?: InputMaybe<Order_By>;
  compliance_rule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Compliance_Events_Var_Samp_Fields = {
  __typename?: 'compliance_events_var_samp_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  compliance_message_id?: Maybe<Scalars['Float']>;
  compliance_rule_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  message_unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "compliance_events" */
export type Compliance_Events_Var_Samp_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  compliance_message_id?: InputMaybe<Order_By>;
  compliance_rule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Compliance_Events_Variance_Fields = {
  __typename?: 'compliance_events_variance_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  compliance_message_id?: Maybe<Scalars['Float']>;
  compliance_rule_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  message_unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "compliance_events" */
export type Compliance_Events_Variance_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  compliance_message_id?: InputMaybe<Order_By>;
  compliance_rule_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_unix_timestamp?: InputMaybe<Order_By>;
};

/** columns and relationships of "compliance_events_weekly" */
export type Compliance_Events_Weekly = {
  __typename?: 'compliance_events_weekly';
  /** An object relationship */
  compliance?: Maybe<Compliance>;
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
  week?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "compliance_events_weekly" */
export type Compliance_Events_Weekly_Aggregate = {
  __typename?: 'compliance_events_weekly_aggregate';
  aggregate?: Maybe<Compliance_Events_Weekly_Aggregate_Fields>;
  nodes: Array<Compliance_Events_Weekly>;
};

/** aggregate fields of "compliance_events_weekly" */
export type Compliance_Events_Weekly_Aggregate_Fields = {
  __typename?: 'compliance_events_weekly_aggregate_fields';
  avg?: Maybe<Compliance_Events_Weekly_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Events_Weekly_Max_Fields>;
  min?: Maybe<Compliance_Events_Weekly_Min_Fields>;
  stddev?: Maybe<Compliance_Events_Weekly_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Events_Weekly_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Events_Weekly_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Events_Weekly_Sum_Fields>;
  var_pop?: Maybe<Compliance_Events_Weekly_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Events_Weekly_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Events_Weekly_Variance_Fields>;
};


/** aggregate fields of "compliance_events_weekly" */
export type Compliance_Events_Weekly_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Events_Weekly_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Events_Weekly_Avg_Fields = {
  __typename?: 'compliance_events_weekly_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_events_weekly". All fields are combined with a logical 'AND'. */
export type Compliance_Events_Weekly_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Events_Weekly_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Events_Weekly_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Events_Weekly_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  event_count?: InputMaybe<Numeric_Comparison_Exp>;
  week?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Compliance_Events_Weekly_Max_Fields = {
  __typename?: 'compliance_events_weekly_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
  week?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Compliance_Events_Weekly_Min_Fields = {
  __typename?: 'compliance_events_weekly_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
  week?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "compliance_events_weekly". */
export type Compliance_Events_Weekly_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  event_count?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** columns and relationships of "compliance_events_weekly_reports" */
export type Compliance_Events_Weekly_Reports = {
  __typename?: 'compliance_events_weekly_reports';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  event_status?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  policy?: Maybe<Scalars['String']>;
  risk?: Maybe<Scalars['String']>;
  rule?: Maybe<Scalars['String']>;
  rule_name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregated selection of "compliance_events_weekly_reports" */
export type Compliance_Events_Weekly_Reports_Aggregate = {
  __typename?: 'compliance_events_weekly_reports_aggregate';
  aggregate?: Maybe<Compliance_Events_Weekly_Reports_Aggregate_Fields>;
  nodes: Array<Compliance_Events_Weekly_Reports>;
};

/** aggregate fields of "compliance_events_weekly_reports" */
export type Compliance_Events_Weekly_Reports_Aggregate_Fields = {
  __typename?: 'compliance_events_weekly_reports_aggregate_fields';
  avg?: Maybe<Compliance_Events_Weekly_Reports_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Events_Weekly_Reports_Max_Fields>;
  min?: Maybe<Compliance_Events_Weekly_Reports_Min_Fields>;
  stddev?: Maybe<Compliance_Events_Weekly_Reports_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Events_Weekly_Reports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Events_Weekly_Reports_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Events_Weekly_Reports_Sum_Fields>;
  var_pop?: Maybe<Compliance_Events_Weekly_Reports_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Events_Weekly_Reports_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Events_Weekly_Reports_Variance_Fields>;
};


/** aggregate fields of "compliance_events_weekly_reports" */
export type Compliance_Events_Weekly_Reports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Events_Weekly_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Events_Weekly_Reports_Avg_Fields = {
  __typename?: 'compliance_events_weekly_reports_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_events_weekly_reports". All fields are combined with a logical 'AND'. */
export type Compliance_Events_Weekly_Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Events_Weekly_Reports_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Events_Weekly_Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Events_Weekly_Reports_Bool_Exp>>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  event_status?: InputMaybe<String_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  policy?: InputMaybe<String_Comparison_Exp>;
  risk?: InputMaybe<String_Comparison_Exp>;
  rule?: InputMaybe<String_Comparison_Exp>;
  rule_name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Compliance_Events_Weekly_Reports_Max_Fields = {
  __typename?: 'compliance_events_weekly_reports_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  event_status?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  policy?: Maybe<Scalars['String']>;
  risk?: Maybe<Scalars['String']>;
  rule?: Maybe<Scalars['String']>;
  rule_name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Compliance_Events_Weekly_Reports_Min_Fields = {
  __typename?: 'compliance_events_weekly_reports_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  event_status?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  policy?: Maybe<Scalars['String']>;
  risk?: Maybe<Scalars['String']>;
  rule?: Maybe<Scalars['String']>;
  rule_name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "compliance_events_weekly_reports". */
export type Compliance_Events_Weekly_Reports_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  event_status?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  policy?: InputMaybe<Order_By>;
  risk?: InputMaybe<Order_By>;
  rule?: InputMaybe<Order_By>;
  rule_name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_events_weekly_reports" */
export enum Compliance_Events_Weekly_Reports_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactName = 'contact_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EventStatus = 'event_status',
  /** column name */
  Message = 'message',
  /** column name */
  Name = 'name',
  /** column name */
  Policy = 'policy',
  /** column name */
  Risk = 'risk',
  /** column name */
  Rule = 'rule',
  /** column name */
  RuleName = 'rule_name',
  /** column name */
  Status = 'status'
}

/** aggregate stddev on columns */
export type Compliance_Events_Weekly_Reports_Stddev_Fields = {
  __typename?: 'compliance_events_weekly_reports_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Events_Weekly_Reports_Stddev_Pop_Fields = {
  __typename?: 'compliance_events_weekly_reports_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Events_Weekly_Reports_Stddev_Samp_Fields = {
  __typename?: 'compliance_events_weekly_reports_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_events_weekly_reports" */
export type Compliance_Events_Weekly_Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Events_Weekly_Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Events_Weekly_Reports_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  event_status?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['String']>;
  risk?: InputMaybe<Scalars['String']>;
  rule?: InputMaybe<Scalars['String']>;
  rule_name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Compliance_Events_Weekly_Reports_Sum_Fields = {
  __typename?: 'compliance_events_weekly_reports_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Compliance_Events_Weekly_Reports_Var_Pop_Fields = {
  __typename?: 'compliance_events_weekly_reports_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Events_Weekly_Reports_Var_Samp_Fields = {
  __typename?: 'compliance_events_weekly_reports_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Events_Weekly_Reports_Variance_Fields = {
  __typename?: 'compliance_events_weekly_reports_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
};

/** select columns of table "compliance_events_weekly" */
export enum Compliance_Events_Weekly_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  EventCount = 'event_count',
  /** column name */
  Week = 'week'
}

/** aggregate stddev on columns */
export type Compliance_Events_Weekly_Stddev_Fields = {
  __typename?: 'compliance_events_weekly_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Events_Weekly_Stddev_Pop_Fields = {
  __typename?: 'compliance_events_weekly_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Events_Weekly_Stddev_Samp_Fields = {
  __typename?: 'compliance_events_weekly_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_events_weekly" */
export type Compliance_Events_Weekly_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Events_Weekly_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Events_Weekly_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  event_count?: InputMaybe<Scalars['numeric']>;
  week?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Compliance_Events_Weekly_Sum_Fields = {
  __typename?: 'compliance_events_weekly_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Compliance_Events_Weekly_Var_Pop_Fields = {
  __typename?: 'compliance_events_weekly_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Events_Weekly_Var_Samp_Fields = {
  __typename?: 'compliance_events_weekly_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Events_Weekly_Variance_Fields = {
  __typename?: 'compliance_events_weekly_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "compliance_events_yearly" */
export type Compliance_Events_Yearly = {
  __typename?: 'compliance_events_yearly';
  /** An object relationship */
  compliance?: Maybe<Compliance>;
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
  year?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "compliance_events_yearly" */
export type Compliance_Events_Yearly_Aggregate = {
  __typename?: 'compliance_events_yearly_aggregate';
  aggregate?: Maybe<Compliance_Events_Yearly_Aggregate_Fields>;
  nodes: Array<Compliance_Events_Yearly>;
};

/** aggregate fields of "compliance_events_yearly" */
export type Compliance_Events_Yearly_Aggregate_Fields = {
  __typename?: 'compliance_events_yearly_aggregate_fields';
  avg?: Maybe<Compliance_Events_Yearly_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Events_Yearly_Max_Fields>;
  min?: Maybe<Compliance_Events_Yearly_Min_Fields>;
  stddev?: Maybe<Compliance_Events_Yearly_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Events_Yearly_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Events_Yearly_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Events_Yearly_Sum_Fields>;
  var_pop?: Maybe<Compliance_Events_Yearly_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Events_Yearly_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Events_Yearly_Variance_Fields>;
};


/** aggregate fields of "compliance_events_yearly" */
export type Compliance_Events_Yearly_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Events_Yearly_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Events_Yearly_Avg_Fields = {
  __typename?: 'compliance_events_yearly_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_events_yearly". All fields are combined with a logical 'AND'. */
export type Compliance_Events_Yearly_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Events_Yearly_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Events_Yearly_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Events_Yearly_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  event_count?: InputMaybe<Numeric_Comparison_Exp>;
  year?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Compliance_Events_Yearly_Max_Fields = {
  __typename?: 'compliance_events_yearly_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
  year?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Compliance_Events_Yearly_Min_Fields = {
  __typename?: 'compliance_events_yearly_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
  year?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "compliance_events_yearly". */
export type Compliance_Events_Yearly_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  event_count?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_events_yearly" */
export enum Compliance_Events_Yearly_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  EventCount = 'event_count',
  /** column name */
  Year = 'year'
}

/** aggregate stddev on columns */
export type Compliance_Events_Yearly_Stddev_Fields = {
  __typename?: 'compliance_events_yearly_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Events_Yearly_Stddev_Pop_Fields = {
  __typename?: 'compliance_events_yearly_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Events_Yearly_Stddev_Samp_Fields = {
  __typename?: 'compliance_events_yearly_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_events_yearly" */
export type Compliance_Events_Yearly_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Events_Yearly_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Events_Yearly_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  event_count?: InputMaybe<Scalars['numeric']>;
  year?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Compliance_Events_Yearly_Sum_Fields = {
  __typename?: 'compliance_events_yearly_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  event_count?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Compliance_Events_Yearly_Var_Pop_Fields = {
  __typename?: 'compliance_events_yearly_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Events_Yearly_Var_Samp_Fields = {
  __typename?: 'compliance_events_yearly_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Events_Yearly_Variance_Fields = {
  __typename?: 'compliance_events_yearly_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  event_count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "compliance_group_contacts" */
export type Compliance_Group_Contacts = {
  __typename?: 'compliance_group_contacts';
  /** An object relationship */
  compliance_contact?: Maybe<Compliance_Contacts_Raw>;
  compliance_contact_id: Scalars['Int'];
  /** An object relationship */
  compliance_group?: Maybe<Compliance_Groups>;
  compliance_group_id: Scalars['Int'];
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "compliance_group_contacts" */
export type Compliance_Group_Contacts_Aggregate = {
  __typename?: 'compliance_group_contacts_aggregate';
  aggregate?: Maybe<Compliance_Group_Contacts_Aggregate_Fields>;
  nodes: Array<Compliance_Group_Contacts>;
};

export type Compliance_Group_Contacts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Compliance_Group_Contacts_Aggregate_Bool_Exp_Count>;
};

export type Compliance_Group_Contacts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Compliance_Group_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Compliance_Group_Contacts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance_group_contacts" */
export type Compliance_Group_Contacts_Aggregate_Fields = {
  __typename?: 'compliance_group_contacts_aggregate_fields';
  avg?: Maybe<Compliance_Group_Contacts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Group_Contacts_Max_Fields>;
  min?: Maybe<Compliance_Group_Contacts_Min_Fields>;
  stddev?: Maybe<Compliance_Group_Contacts_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Group_Contacts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Group_Contacts_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Group_Contacts_Sum_Fields>;
  var_pop?: Maybe<Compliance_Group_Contacts_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Group_Contacts_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Group_Contacts_Variance_Fields>;
};


/** aggregate fields of "compliance_group_contacts" */
export type Compliance_Group_Contacts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Group_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Aggregate_Order_By = {
  avg?: InputMaybe<Compliance_Group_Contacts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Compliance_Group_Contacts_Max_Order_By>;
  min?: InputMaybe<Compliance_Group_Contacts_Min_Order_By>;
  stddev?: InputMaybe<Compliance_Group_Contacts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Compliance_Group_Contacts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Compliance_Group_Contacts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Compliance_Group_Contacts_Sum_Order_By>;
  var_pop?: InputMaybe<Compliance_Group_Contacts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Compliance_Group_Contacts_Var_Samp_Order_By>;
  variance?: InputMaybe<Compliance_Group_Contacts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Arr_Rel_Insert_Input = {
  data: Array<Compliance_Group_Contacts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Compliance_Group_Contacts_On_Conflict>;
};

/** aggregate avg on columns */
export type Compliance_Group_Contacts_Avg_Fields = {
  __typename?: 'compliance_group_contacts_avg_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Avg_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "compliance_group_contacts". All fields are combined with a logical 'AND'. */
export type Compliance_Group_Contacts_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Group_Contacts_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Group_Contacts_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Group_Contacts_Bool_Exp>>;
  compliance_contact?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
  compliance_contact_id?: InputMaybe<Int_Comparison_Exp>;
  compliance_group?: InputMaybe<Compliance_Groups_Bool_Exp>;
  compliance_group_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance_group_contacts" */
export enum Compliance_Group_Contacts_Constraint {
  /** unique or primary key constraint on columns "compliance_contact_id" */
  ComplianceGroupContactsComplianceContactIdKey = 'compliance_group_contacts_compliance_contact_id_key',
  /** unique or primary key constraint on columns "id" */
  ComplianceGroupMembersPkey = 'compliance_group_members_pkey'
}

/** input type for incrementing numeric columns in table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Inc_Input = {
  compliance_contact_id?: InputMaybe<Scalars['Int']>;
  compliance_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Insert_Input = {
  compliance_contact?: InputMaybe<Compliance_Contacts_Raw_Obj_Rel_Insert_Input>;
  compliance_contact_id?: InputMaybe<Scalars['Int']>;
  compliance_group?: InputMaybe<Compliance_Groups_Obj_Rel_Insert_Input>;
  compliance_group_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Compliance_Group_Contacts_Max_Fields = {
  __typename?: 'compliance_group_contacts_max_fields';
  compliance_contact_id?: Maybe<Scalars['Int']>;
  compliance_group_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Max_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_group_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Compliance_Group_Contacts_Min_Fields = {
  __typename?: 'compliance_group_contacts_min_fields';
  compliance_contact_id?: Maybe<Scalars['Int']>;
  compliance_group_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Min_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_group_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Mutation_Response = {
  __typename?: 'compliance_group_contacts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Group_Contacts>;
};

/** input type for inserting object relation for remote table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Obj_Rel_Insert_Input = {
  data: Compliance_Group_Contacts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Compliance_Group_Contacts_On_Conflict>;
};

/** on_conflict condition type for table "compliance_group_contacts" */
export type Compliance_Group_Contacts_On_Conflict = {
  constraint: Compliance_Group_Contacts_Constraint;
  update_columns?: Array<Compliance_Group_Contacts_Update_Column>;
  where?: InputMaybe<Compliance_Group_Contacts_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance_group_contacts". */
export type Compliance_Group_Contacts_Order_By = {
  compliance_contact?: InputMaybe<Compliance_Contacts_Raw_Order_By>;
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_group?: InputMaybe<Compliance_Groups_Order_By>;
  compliance_group_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance_group_contacts */
export type Compliance_Group_Contacts_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "compliance_group_contacts" */
export enum Compliance_Group_Contacts_Select_Column {
  /** column name */
  ComplianceContactId = 'compliance_contact_id',
  /** column name */
  ComplianceGroupId = 'compliance_group_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Set_Input = {
  compliance_contact_id?: InputMaybe<Scalars['Int']>;
  compliance_group_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Compliance_Group_Contacts_Stddev_Fields = {
  __typename?: 'compliance_group_contacts_stddev_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Stddev_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Group_Contacts_Stddev_Pop_Fields = {
  __typename?: 'compliance_group_contacts_stddev_pop_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Stddev_Pop_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Group_Contacts_Stddev_Samp_Fields = {
  __typename?: 'compliance_group_contacts_stddev_samp_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Stddev_Samp_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Group_Contacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Group_Contacts_Stream_Cursor_Value_Input = {
  compliance_contact_id?: InputMaybe<Scalars['Int']>;
  compliance_group_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Compliance_Group_Contacts_Sum_Fields = {
  __typename?: 'compliance_group_contacts_sum_fields';
  compliance_contact_id?: Maybe<Scalars['Int']>;
  compliance_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Sum_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "compliance_group_contacts" */
export enum Compliance_Group_Contacts_Update_Column {
  /** column name */
  ComplianceContactId = 'compliance_contact_id',
  /** column name */
  ComplianceGroupId = 'compliance_group_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Compliance_Group_Contacts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Group_Contacts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Group_Contacts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Group_Contacts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Group_Contacts_Var_Pop_Fields = {
  __typename?: 'compliance_group_contacts_var_pop_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Var_Pop_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Compliance_Group_Contacts_Var_Samp_Fields = {
  __typename?: 'compliance_group_contacts_var_samp_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Var_Samp_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Compliance_Group_Contacts_Variance_Fields = {
  __typename?: 'compliance_group_contacts_variance_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "compliance_group_contacts" */
export type Compliance_Group_Contacts_Variance_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "compliance_group_users" */
export type Compliance_Group_Users = {
  __typename?: 'compliance_group_users';
  /** An object relationship */
  compliance_group: Compliance_Groups;
  compliance_group_id: Scalars['Int'];
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
};

/** aggregated selection of "compliance_group_users" */
export type Compliance_Group_Users_Aggregate = {
  __typename?: 'compliance_group_users_aggregate';
  aggregate?: Maybe<Compliance_Group_Users_Aggregate_Fields>;
  nodes: Array<Compliance_Group_Users>;
};

export type Compliance_Group_Users_Aggregate_Bool_Exp = {
  count?: InputMaybe<Compliance_Group_Users_Aggregate_Bool_Exp_Count>;
};

export type Compliance_Group_Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Compliance_Group_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Compliance_Group_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance_group_users" */
export type Compliance_Group_Users_Aggregate_Fields = {
  __typename?: 'compliance_group_users_aggregate_fields';
  avg?: Maybe<Compliance_Group_Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Group_Users_Max_Fields>;
  min?: Maybe<Compliance_Group_Users_Min_Fields>;
  stddev?: Maybe<Compliance_Group_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Group_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Group_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Group_Users_Sum_Fields>;
  var_pop?: Maybe<Compliance_Group_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Group_Users_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Group_Users_Variance_Fields>;
};


/** aggregate fields of "compliance_group_users" */
export type Compliance_Group_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Group_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance_group_users" */
export type Compliance_Group_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Compliance_Group_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Compliance_Group_Users_Max_Order_By>;
  min?: InputMaybe<Compliance_Group_Users_Min_Order_By>;
  stddev?: InputMaybe<Compliance_Group_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Compliance_Group_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Compliance_Group_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Compliance_Group_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Compliance_Group_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Compliance_Group_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Compliance_Group_Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "compliance_group_users" */
export type Compliance_Group_Users_Arr_Rel_Insert_Input = {
  data: Array<Compliance_Group_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Compliance_Group_Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Compliance_Group_Users_Avg_Fields = {
  __typename?: 'compliance_group_users_avg_fields';
  compliance_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "compliance_group_users" */
export type Compliance_Group_Users_Avg_Order_By = {
  compliance_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "compliance_group_users". All fields are combined with a logical 'AND'. */
export type Compliance_Group_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Group_Users_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Group_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Group_Users_Bool_Exp>>;
  compliance_group?: InputMaybe<Compliance_Groups_Bool_Exp>;
  compliance_group_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance_group_users" */
export enum Compliance_Group_Users_Constraint {
  /** unique or primary key constraint on columns "user_id", "compliance_group_id" */
  ComplianceGroupUsersComplianceGroupIdUserIdKey = 'compliance_group_users_compliance_group_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  ComplianceGroupUsersPkey = 'compliance_group_users_pkey'
}

/** input type for incrementing numeric columns in table "compliance_group_users" */
export type Compliance_Group_Users_Inc_Input = {
  compliance_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "compliance_group_users" */
export type Compliance_Group_Users_Insert_Input = {
  compliance_group?: InputMaybe<Compliance_Groups_Obj_Rel_Insert_Input>;
  compliance_group_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Compliance_Group_Users_Max_Fields = {
  __typename?: 'compliance_group_users_max_fields';
  compliance_group_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "compliance_group_users" */
export type Compliance_Group_Users_Max_Order_By = {
  compliance_group_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Compliance_Group_Users_Min_Fields = {
  __typename?: 'compliance_group_users_min_fields';
  compliance_group_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "compliance_group_users" */
export type Compliance_Group_Users_Min_Order_By = {
  compliance_group_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "compliance_group_users" */
export type Compliance_Group_Users_Mutation_Response = {
  __typename?: 'compliance_group_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Group_Users>;
};

/** on_conflict condition type for table "compliance_group_users" */
export type Compliance_Group_Users_On_Conflict = {
  constraint: Compliance_Group_Users_Constraint;
  update_columns?: Array<Compliance_Group_Users_Update_Column>;
  where?: InputMaybe<Compliance_Group_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance_group_users". */
export type Compliance_Group_Users_Order_By = {
  compliance_group?: InputMaybe<Compliance_Groups_Order_By>;
  compliance_group_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance_group_users */
export type Compliance_Group_Users_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "compliance_group_users" */
export enum Compliance_Group_Users_Select_Column {
  /** column name */
  ComplianceGroupId = 'compliance_group_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "compliance_group_users" */
export type Compliance_Group_Users_Set_Input = {
  compliance_group_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Compliance_Group_Users_Stddev_Fields = {
  __typename?: 'compliance_group_users_stddev_fields';
  compliance_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "compliance_group_users" */
export type Compliance_Group_Users_Stddev_Order_By = {
  compliance_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Group_Users_Stddev_Pop_Fields = {
  __typename?: 'compliance_group_users_stddev_pop_fields';
  compliance_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "compliance_group_users" */
export type Compliance_Group_Users_Stddev_Pop_Order_By = {
  compliance_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Group_Users_Stddev_Samp_Fields = {
  __typename?: 'compliance_group_users_stddev_samp_fields';
  compliance_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "compliance_group_users" */
export type Compliance_Group_Users_Stddev_Samp_Order_By = {
  compliance_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "compliance_group_users" */
export type Compliance_Group_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Group_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Group_Users_Stream_Cursor_Value_Input = {
  compliance_group_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Compliance_Group_Users_Sum_Fields = {
  __typename?: 'compliance_group_users_sum_fields';
  compliance_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "compliance_group_users" */
export type Compliance_Group_Users_Sum_Order_By = {
  compliance_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "compliance_group_users" */
export enum Compliance_Group_Users_Update_Column {
  /** column name */
  ComplianceGroupId = 'compliance_group_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Compliance_Group_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Group_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Group_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Group_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Group_Users_Var_Pop_Fields = {
  __typename?: 'compliance_group_users_var_pop_fields';
  compliance_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "compliance_group_users" */
export type Compliance_Group_Users_Var_Pop_Order_By = {
  compliance_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Compliance_Group_Users_Var_Samp_Fields = {
  __typename?: 'compliance_group_users_var_samp_fields';
  compliance_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "compliance_group_users" */
export type Compliance_Group_Users_Var_Samp_Order_By = {
  compliance_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Compliance_Group_Users_Variance_Fields = {
  __typename?: 'compliance_group_users_variance_fields';
  compliance_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "compliance_group_users" */
export type Compliance_Group_Users_Variance_Order_By = {
  compliance_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "compliance_groups" */
export type Compliance_Groups = {
  __typename?: 'compliance_groups';
  /** An object relationship */
  compliance: Compliance;
  /** An array relationship */
  compliance_group_contacts: Array<Compliance_Group_Contacts>;
  /** An aggregate relationship */
  compliance_group_contacts_aggregate: Compliance_Group_Contacts_Aggregate;
  /** An array relationship */
  compliance_group_users: Array<Compliance_Group_Users>;
  /** An aggregate relationship */
  compliance_group_users_aggregate: Compliance_Group_Users_Aggregate;
  compliance_id: Scalars['Int'];
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  tags?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "compliance_groups" */
export type Compliance_GroupsCompliance_Group_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Group_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Group_Contacts_Order_By>>;
  where?: InputMaybe<Compliance_Group_Contacts_Bool_Exp>;
};


/** columns and relationships of "compliance_groups" */
export type Compliance_GroupsCompliance_Group_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Group_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Group_Contacts_Order_By>>;
  where?: InputMaybe<Compliance_Group_Contacts_Bool_Exp>;
};


/** columns and relationships of "compliance_groups" */
export type Compliance_GroupsCompliance_Group_UsersArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Group_Users_Order_By>>;
  where?: InputMaybe<Compliance_Group_Users_Bool_Exp>;
};


/** columns and relationships of "compliance_groups" */
export type Compliance_GroupsCompliance_Group_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Group_Users_Order_By>>;
  where?: InputMaybe<Compliance_Group_Users_Bool_Exp>;
};


/** columns and relationships of "compliance_groups" */
export type Compliance_GroupsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "compliance_groups" */
export type Compliance_GroupsTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "compliance_groups" */
export type Compliance_Groups_Aggregate = {
  __typename?: 'compliance_groups_aggregate';
  aggregate?: Maybe<Compliance_Groups_Aggregate_Fields>;
  nodes: Array<Compliance_Groups>;
};

export type Compliance_Groups_Aggregate_Bool_Exp = {
  count?: InputMaybe<Compliance_Groups_Aggregate_Bool_Exp_Count>;
};

export type Compliance_Groups_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Compliance_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Compliance_Groups_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance_groups" */
export type Compliance_Groups_Aggregate_Fields = {
  __typename?: 'compliance_groups_aggregate_fields';
  avg?: Maybe<Compliance_Groups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Groups_Max_Fields>;
  min?: Maybe<Compliance_Groups_Min_Fields>;
  stddev?: Maybe<Compliance_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Groups_Sum_Fields>;
  var_pop?: Maybe<Compliance_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Groups_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Groups_Variance_Fields>;
};


/** aggregate fields of "compliance_groups" */
export type Compliance_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance_groups" */
export type Compliance_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Compliance_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Compliance_Groups_Max_Order_By>;
  min?: InputMaybe<Compliance_Groups_Min_Order_By>;
  stddev?: InputMaybe<Compliance_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Compliance_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Compliance_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Compliance_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Compliance_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Compliance_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Compliance_Groups_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Compliance_Groups_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "compliance_groups" */
export type Compliance_Groups_Arr_Rel_Insert_Input = {
  data: Array<Compliance_Groups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Compliance_Groups_On_Conflict>;
};

/** aggregate avg on columns */
export type Compliance_Groups_Avg_Fields = {
  __typename?: 'compliance_groups_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "compliance_groups" */
export type Compliance_Groups_Avg_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "compliance_groups". All fields are combined with a logical 'AND'. */
export type Compliance_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Groups_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Groups_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_group_contacts?: InputMaybe<Compliance_Group_Contacts_Bool_Exp>;
  compliance_group_contacts_aggregate?: InputMaybe<Compliance_Group_Contacts_Aggregate_Bool_Exp>;
  compliance_group_users?: InputMaybe<Compliance_Group_Users_Bool_Exp>;
  compliance_group_users_aggregate?: InputMaybe<Compliance_Group_Users_Aggregate_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance_groups" */
export enum Compliance_Groups_Constraint {
  /** unique or primary key constraint on columns "id" */
  ComplianceGroupsPkey = 'compliance_groups_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Compliance_Groups_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Compliance_Groups_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Compliance_Groups_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "compliance_groups" */
export type Compliance_Groups_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "compliance_groups" */
export type Compliance_Groups_Insert_Input = {
  compliance?: InputMaybe<Compliance_Obj_Rel_Insert_Input>;
  compliance_group_contacts?: InputMaybe<Compliance_Group_Contacts_Arr_Rel_Insert_Input>;
  compliance_group_users?: InputMaybe<Compliance_Group_Users_Arr_Rel_Insert_Input>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Compliance_Groups_Max_Fields = {
  __typename?: 'compliance_groups_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "compliance_groups" */
export type Compliance_Groups_Max_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Compliance_Groups_Min_Fields = {
  __typename?: 'compliance_groups_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "compliance_groups" */
export type Compliance_Groups_Min_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "compliance_groups" */
export type Compliance_Groups_Mutation_Response = {
  __typename?: 'compliance_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Groups>;
};

/** input type for inserting object relation for remote table "compliance_groups" */
export type Compliance_Groups_Obj_Rel_Insert_Input = {
  data: Compliance_Groups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Compliance_Groups_On_Conflict>;
};

/** on_conflict condition type for table "compliance_groups" */
export type Compliance_Groups_On_Conflict = {
  constraint: Compliance_Groups_Constraint;
  update_columns?: Array<Compliance_Groups_Update_Column>;
  where?: InputMaybe<Compliance_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance_groups". */
export type Compliance_Groups_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_group_contacts_aggregate?: InputMaybe<Compliance_Group_Contacts_Aggregate_Order_By>;
  compliance_group_users_aggregate?: InputMaybe<Compliance_Group_Users_Aggregate_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance_groups */
export type Compliance_Groups_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Compliance_Groups_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "compliance_groups" */
export enum Compliance_Groups_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "compliance_groups" */
export type Compliance_Groups_Set_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Compliance_Groups_Stddev_Fields = {
  __typename?: 'compliance_groups_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "compliance_groups" */
export type Compliance_Groups_Stddev_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Groups_Stddev_Pop_Fields = {
  __typename?: 'compliance_groups_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "compliance_groups" */
export type Compliance_Groups_Stddev_Pop_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Groups_Stddev_Samp_Fields = {
  __typename?: 'compliance_groups_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "compliance_groups" */
export type Compliance_Groups_Stddev_Samp_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "compliance_groups" */
export type Compliance_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Groups_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Compliance_Groups_Sum_Fields = {
  __typename?: 'compliance_groups_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "compliance_groups" */
export type Compliance_Groups_Sum_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "compliance_groups" */
export enum Compliance_Groups_Update_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Compliance_Groups_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Compliance_Groups_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Compliance_Groups_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Compliance_Groups_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Compliance_Groups_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Groups_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Compliance_Groups_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Groups_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Groups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Groups_Var_Pop_Fields = {
  __typename?: 'compliance_groups_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "compliance_groups" */
export type Compliance_Groups_Var_Pop_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Compliance_Groups_Var_Samp_Fields = {
  __typename?: 'compliance_groups_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "compliance_groups" */
export type Compliance_Groups_Var_Samp_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Compliance_Groups_Variance_Fields = {
  __typename?: 'compliance_groups_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "compliance_groups" */
export type Compliance_Groups_Variance_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

export type Compliance_Groups_With_Events_Args = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['Int']>;
};

/** input type for incrementing numeric columns in table "compliance" */
export type Compliance_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "compliance" */
export type Compliance_Insert_Input = {
  compliance_contacts?: InputMaybe<Compliance_Contacts_Raw_Arr_Rel_Insert_Input>;
  compliance_events?: InputMaybe<Compliance_Events_Arr_Rel_Insert_Input>;
  compliance_groups?: InputMaybe<Compliance_Groups_Arr_Rel_Insert_Input>;
  compliance_policies?: InputMaybe<Compliance_Policies_Arr_Rel_Insert_Input>;
  compliance_rules?: InputMaybe<Compliance_Rules_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Compliance_Max_Fields = {
  __typename?: 'compliance_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "compliance" */
export type Compliance_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** columns and relationships of "compliance_messages" */
export type Compliance_Messages = {
  __typename?: 'compliance_messages';
  body?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  /** An object relationship */
  compliance?: Maybe<Compliance>;
  /** An object relationship */
  compliance_contact?: Maybe<Compliance_Contacts_Raw>;
  compliance_contact_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  compliance_events: Array<Compliance_Events>;
  /** An aggregate relationship */
  compliance_events_aggregate: Compliance_Events_Aggregate;
  compliance_id?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  /** An object relationship */
  from_contact?: Maybe<Ws_Contacts>;
  from_me?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  is_group_msg?: Maybe<Scalars['Boolean']>;
  message_key?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  mime_type?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['String']>;
  /** An object relationship */
  participant_contact?: Maybe<Ws_Contacts>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  to?: Maybe<Scalars['String']>;
  /** An object relationship */
  to_contact?: Maybe<Ws_Contacts>;
  transcription?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unix_timestamp?: Maybe<Scalars['Int']>;
  /** An object relationship */
  ws_session?: Maybe<Ws_Sessions>;
  ws_session_ref?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "compliance_messages" */
export type Compliance_MessagesCompliance_EventsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


/** columns and relationships of "compliance_messages" */
export type Compliance_MessagesCompliance_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


/** columns and relationships of "compliance_messages" */
export type Compliance_MessagesMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "compliance_messages" */
export type Compliance_Messages_Aggregate = {
  __typename?: 'compliance_messages_aggregate';
  aggregate?: Maybe<Compliance_Messages_Aggregate_Fields>;
  nodes: Array<Compliance_Messages>;
};

export type Compliance_Messages_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Compliance_Messages_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Compliance_Messages_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Compliance_Messages_Aggregate_Bool_Exp_Count>;
};

export type Compliance_Messages_Aggregate_Bool_Exp_Bool_And = {
  arguments: Compliance_Messages_Select_Column_Compliance_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Compliance_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Compliance_Messages_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Compliance_Messages_Select_Column_Compliance_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Compliance_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Compliance_Messages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Compliance_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Compliance_Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance_messages" */
export type Compliance_Messages_Aggregate_Fields = {
  __typename?: 'compliance_messages_aggregate_fields';
  avg?: Maybe<Compliance_Messages_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Messages_Max_Fields>;
  min?: Maybe<Compliance_Messages_Min_Fields>;
  stddev?: Maybe<Compliance_Messages_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Messages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Messages_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Messages_Sum_Fields>;
  var_pop?: Maybe<Compliance_Messages_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Messages_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Messages_Variance_Fields>;
};


/** aggregate fields of "compliance_messages" */
export type Compliance_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance_messages" */
export type Compliance_Messages_Aggregate_Order_By = {
  avg?: InputMaybe<Compliance_Messages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Compliance_Messages_Max_Order_By>;
  min?: InputMaybe<Compliance_Messages_Min_Order_By>;
  stddev?: InputMaybe<Compliance_Messages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Compliance_Messages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Compliance_Messages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Compliance_Messages_Sum_Order_By>;
  var_pop?: InputMaybe<Compliance_Messages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Compliance_Messages_Var_Samp_Order_By>;
  variance?: InputMaybe<Compliance_Messages_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "compliance_messages" */
export type Compliance_Messages_Arr_Rel_Insert_Input = {
  data: Array<Compliance_Messages_Insert_Input>;
};

/** aggregate avg on columns */
export type Compliance_Messages_Avg_Fields = {
  __typename?: 'compliance_messages_avg_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "compliance_messages" */
export type Compliance_Messages_Avg_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "compliance_messages". All fields are combined with a logical 'AND'. */
export type Compliance_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Messages_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Messages_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  caption?: InputMaybe<String_Comparison_Exp>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_contact?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
  compliance_contact_id?: InputMaybe<Int_Comparison_Exp>;
  compliance_events?: InputMaybe<Compliance_Events_Bool_Exp>;
  compliance_events_aggregate?: InputMaybe<Compliance_Events_Aggregate_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  from?: InputMaybe<String_Comparison_Exp>;
  from_contact?: InputMaybe<Ws_Contacts_Bool_Exp>;
  from_me?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_group_msg?: InputMaybe<Boolean_Comparison_Exp>;
  message_key?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mime_type?: InputMaybe<String_Comparison_Exp>;
  participant?: InputMaybe<String_Comparison_Exp>;
  participant_contact?: InputMaybe<Ws_Contacts_Bool_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  to?: InputMaybe<String_Comparison_Exp>;
  to_contact?: InputMaybe<Ws_Contacts_Bool_Exp>;
  transcription?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  unix_timestamp?: InputMaybe<Int_Comparison_Exp>;
  ws_session?: InputMaybe<Ws_Sessions_Bool_Exp>;
  ws_session_ref?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "compliance_messages_daily" */
export type Compliance_Messages_Daily = {
  __typename?: 'compliance_messages_daily';
  /** An object relationship */
  compliance?: Maybe<Compliance>;
  compliance_id?: Maybe<Scalars['Int']>;
  day?: Maybe<Scalars['timestamptz']>;
  message_count?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "compliance_messages_daily" */
export type Compliance_Messages_Daily_Aggregate = {
  __typename?: 'compliance_messages_daily_aggregate';
  aggregate?: Maybe<Compliance_Messages_Daily_Aggregate_Fields>;
  nodes: Array<Compliance_Messages_Daily>;
};

/** aggregate fields of "compliance_messages_daily" */
export type Compliance_Messages_Daily_Aggregate_Fields = {
  __typename?: 'compliance_messages_daily_aggregate_fields';
  avg?: Maybe<Compliance_Messages_Daily_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Messages_Daily_Max_Fields>;
  min?: Maybe<Compliance_Messages_Daily_Min_Fields>;
  stddev?: Maybe<Compliance_Messages_Daily_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Messages_Daily_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Messages_Daily_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Messages_Daily_Sum_Fields>;
  var_pop?: Maybe<Compliance_Messages_Daily_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Messages_Daily_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Messages_Daily_Variance_Fields>;
};


/** aggregate fields of "compliance_messages_daily" */
export type Compliance_Messages_Daily_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Messages_Daily_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Messages_Daily_Avg_Fields = {
  __typename?: 'compliance_messages_daily_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_messages_daily". All fields are combined with a logical 'AND'. */
export type Compliance_Messages_Daily_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Messages_Daily_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Messages_Daily_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Messages_Daily_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  day?: InputMaybe<Timestamptz_Comparison_Exp>;
  message_count?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Compliance_Messages_Daily_Max_Fields = {
  __typename?: 'compliance_messages_daily_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  day?: Maybe<Scalars['timestamptz']>;
  message_count?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Compliance_Messages_Daily_Min_Fields = {
  __typename?: 'compliance_messages_daily_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  day?: Maybe<Scalars['timestamptz']>;
  message_count?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "compliance_messages_daily". */
export type Compliance_Messages_Daily_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  message_count?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_messages_daily" */
export enum Compliance_Messages_Daily_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  Day = 'day',
  /** column name */
  MessageCount = 'message_count'
}

/** aggregate stddev on columns */
export type Compliance_Messages_Daily_Stddev_Fields = {
  __typename?: 'compliance_messages_daily_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Messages_Daily_Stddev_Pop_Fields = {
  __typename?: 'compliance_messages_daily_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Messages_Daily_Stddev_Samp_Fields = {
  __typename?: 'compliance_messages_daily_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_messages_daily" */
export type Compliance_Messages_Daily_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Messages_Daily_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Messages_Daily_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  day?: InputMaybe<Scalars['timestamptz']>;
  message_count?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Compliance_Messages_Daily_Sum_Fields = {
  __typename?: 'compliance_messages_daily_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Compliance_Messages_Daily_Var_Pop_Fields = {
  __typename?: 'compliance_messages_daily_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Messages_Daily_Var_Samp_Fields = {
  __typename?: 'compliance_messages_daily_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Messages_Daily_Variance_Fields = {
  __typename?: 'compliance_messages_daily_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "compliance_messages_hourly" */
export type Compliance_Messages_Hourly = {
  __typename?: 'compliance_messages_hourly';
  /** An object relationship */
  compliance?: Maybe<Compliance>;
  compliance_id: Scalars['Int'];
  hour: Scalars['timestamptz'];
  message_count?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "compliance_messages_hourly" */
export type Compliance_Messages_Hourly_Aggregate = {
  __typename?: 'compliance_messages_hourly_aggregate';
  aggregate?: Maybe<Compliance_Messages_Hourly_Aggregate_Fields>;
  nodes: Array<Compliance_Messages_Hourly>;
};

/** aggregate fields of "compliance_messages_hourly" */
export type Compliance_Messages_Hourly_Aggregate_Fields = {
  __typename?: 'compliance_messages_hourly_aggregate_fields';
  avg?: Maybe<Compliance_Messages_Hourly_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Messages_Hourly_Max_Fields>;
  min?: Maybe<Compliance_Messages_Hourly_Min_Fields>;
  stddev?: Maybe<Compliance_Messages_Hourly_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Messages_Hourly_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Messages_Hourly_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Messages_Hourly_Sum_Fields>;
  var_pop?: Maybe<Compliance_Messages_Hourly_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Messages_Hourly_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Messages_Hourly_Variance_Fields>;
};


/** aggregate fields of "compliance_messages_hourly" */
export type Compliance_Messages_Hourly_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Messages_Hourly_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Messages_Hourly_Avg_Fields = {
  __typename?: 'compliance_messages_hourly_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_messages_hourly". All fields are combined with a logical 'AND'. */
export type Compliance_Messages_Hourly_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Messages_Hourly_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Messages_Hourly_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Messages_Hourly_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  hour?: InputMaybe<Timestamptz_Comparison_Exp>;
  message_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance_messages_hourly" */
export enum Compliance_Messages_Hourly_Constraint {
  /** unique or primary key constraint on columns "hour", "compliance_id" */
  ComplianceMessagesHourlyPkey = 'compliance_messages_hourly_pkey'
}

/** input type for incrementing numeric columns in table "compliance_messages_hourly" */
export type Compliance_Messages_Hourly_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  message_count?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "compliance_messages_hourly" */
export type Compliance_Messages_Hourly_Insert_Input = {
  compliance?: InputMaybe<Compliance_Obj_Rel_Insert_Input>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  hour?: InputMaybe<Scalars['timestamptz']>;
  message_count?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Compliance_Messages_Hourly_Max_Fields = {
  __typename?: 'compliance_messages_hourly_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  hour?: Maybe<Scalars['timestamptz']>;
  message_count?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Compliance_Messages_Hourly_Min_Fields = {
  __typename?: 'compliance_messages_hourly_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  hour?: Maybe<Scalars['timestamptz']>;
  message_count?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "compliance_messages_hourly" */
export type Compliance_Messages_Hourly_Mutation_Response = {
  __typename?: 'compliance_messages_hourly_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Messages_Hourly>;
};

/** on_conflict condition type for table "compliance_messages_hourly" */
export type Compliance_Messages_Hourly_On_Conflict = {
  constraint: Compliance_Messages_Hourly_Constraint;
  update_columns?: Array<Compliance_Messages_Hourly_Update_Column>;
  where?: InputMaybe<Compliance_Messages_Hourly_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance_messages_hourly". */
export type Compliance_Messages_Hourly_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  hour?: InputMaybe<Order_By>;
  message_count?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance_messages_hourly */
export type Compliance_Messages_Hourly_Pk_Columns_Input = {
  compliance_id: Scalars['Int'];
  hour: Scalars['timestamptz'];
};

/** select columns of table "compliance_messages_hourly" */
export enum Compliance_Messages_Hourly_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  Hour = 'hour',
  /** column name */
  MessageCount = 'message_count'
}

/** input type for updating data in table "compliance_messages_hourly" */
export type Compliance_Messages_Hourly_Set_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  hour?: InputMaybe<Scalars['timestamptz']>;
  message_count?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Compliance_Messages_Hourly_Stddev_Fields = {
  __typename?: 'compliance_messages_hourly_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Messages_Hourly_Stddev_Pop_Fields = {
  __typename?: 'compliance_messages_hourly_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Messages_Hourly_Stddev_Samp_Fields = {
  __typename?: 'compliance_messages_hourly_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_messages_hourly" */
export type Compliance_Messages_Hourly_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Messages_Hourly_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Messages_Hourly_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  hour?: InputMaybe<Scalars['timestamptz']>;
  message_count?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Compliance_Messages_Hourly_Sum_Fields = {
  __typename?: 'compliance_messages_hourly_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['bigint']>;
};

/** update columns of table "compliance_messages_hourly" */
export enum Compliance_Messages_Hourly_Update_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  Hour = 'hour',
  /** column name */
  MessageCount = 'message_count'
}

export type Compliance_Messages_Hourly_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Messages_Hourly_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Messages_Hourly_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Messages_Hourly_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Messages_Hourly_Var_Pop_Fields = {
  __typename?: 'compliance_messages_hourly_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Messages_Hourly_Var_Samp_Fields = {
  __typename?: 'compliance_messages_hourly_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Messages_Hourly_Variance_Fields = {
  __typename?: 'compliance_messages_hourly_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** input type for inserting data into table "compliance_messages" */
export type Compliance_Messages_Insert_Input = {
  body?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  compliance?: InputMaybe<Compliance_Obj_Rel_Insert_Input>;
  compliance_contact?: InputMaybe<Compliance_Contacts_Raw_Obj_Rel_Insert_Input>;
  compliance_contact_id?: InputMaybe<Scalars['Int']>;
  compliance_events?: InputMaybe<Compliance_Events_Arr_Rel_Insert_Input>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  from_contact?: InputMaybe<Ws_Contacts_Obj_Rel_Insert_Input>;
  from_me?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_group_msg?: InputMaybe<Scalars['Boolean']>;
  message_key?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  mime_type?: InputMaybe<Scalars['String']>;
  participant?: InputMaybe<Scalars['String']>;
  participant_contact?: InputMaybe<Ws_Contacts_Obj_Rel_Insert_Input>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  to?: InputMaybe<Scalars['String']>;
  to_contact?: InputMaybe<Ws_Contacts_Obj_Rel_Insert_Input>;
  transcription?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  unix_timestamp?: InputMaybe<Scalars['Int']>;
  ws_session?: InputMaybe<Ws_Sessions_Obj_Rel_Insert_Input>;
  ws_session_ref?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Compliance_Messages_Max_Fields = {
  __typename?: 'compliance_messages_max_fields';
  body?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  compliance_contact_id?: Maybe<Scalars['Int']>;
  compliance_id?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  message_key?: Maybe<Scalars['String']>;
  mime_type?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  to?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unix_timestamp?: Maybe<Scalars['Int']>;
  ws_session_ref?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "compliance_messages" */
export type Compliance_Messages_Max_Order_By = {
  body?: InputMaybe<Order_By>;
  caption?: InputMaybe<Order_By>;
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_key?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
  participant?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
  transcription?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
  ws_session_ref?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Compliance_Messages_Min_Fields = {
  __typename?: 'compliance_messages_min_fields';
  body?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  compliance_contact_id?: Maybe<Scalars['Int']>;
  compliance_id?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  message_key?: Maybe<Scalars['String']>;
  mime_type?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  to?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unix_timestamp?: Maybe<Scalars['Int']>;
  ws_session_ref?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "compliance_messages" */
export type Compliance_Messages_Min_Order_By = {
  body?: InputMaybe<Order_By>;
  caption?: InputMaybe<Order_By>;
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_key?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
  participant?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
  transcription?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
  ws_session_ref?: InputMaybe<Order_By>;
};

/** columns and relationships of "compliance_messages_monthly" */
export type Compliance_Messages_Monthly = {
  __typename?: 'compliance_messages_monthly';
  /** An object relationship */
  compliance?: Maybe<Compliance>;
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
  month?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "compliance_messages_monthly" */
export type Compliance_Messages_Monthly_Aggregate = {
  __typename?: 'compliance_messages_monthly_aggregate';
  aggregate?: Maybe<Compliance_Messages_Monthly_Aggregate_Fields>;
  nodes: Array<Compliance_Messages_Monthly>;
};

/** aggregate fields of "compliance_messages_monthly" */
export type Compliance_Messages_Monthly_Aggregate_Fields = {
  __typename?: 'compliance_messages_monthly_aggregate_fields';
  avg?: Maybe<Compliance_Messages_Monthly_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Messages_Monthly_Max_Fields>;
  min?: Maybe<Compliance_Messages_Monthly_Min_Fields>;
  stddev?: Maybe<Compliance_Messages_Monthly_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Messages_Monthly_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Messages_Monthly_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Messages_Monthly_Sum_Fields>;
  var_pop?: Maybe<Compliance_Messages_Monthly_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Messages_Monthly_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Messages_Monthly_Variance_Fields>;
};


/** aggregate fields of "compliance_messages_monthly" */
export type Compliance_Messages_Monthly_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Messages_Monthly_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Messages_Monthly_Avg_Fields = {
  __typename?: 'compliance_messages_monthly_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_messages_monthly". All fields are combined with a logical 'AND'. */
export type Compliance_Messages_Monthly_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Messages_Monthly_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Messages_Monthly_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Messages_Monthly_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  message_count?: InputMaybe<Numeric_Comparison_Exp>;
  month?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Compliance_Messages_Monthly_Max_Fields = {
  __typename?: 'compliance_messages_monthly_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
  month?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Compliance_Messages_Monthly_Min_Fields = {
  __typename?: 'compliance_messages_monthly_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
  month?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "compliance_messages_monthly". */
export type Compliance_Messages_Monthly_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  message_count?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_messages_monthly" */
export enum Compliance_Messages_Monthly_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  MessageCount = 'message_count',
  /** column name */
  Month = 'month'
}

/** aggregate stddev on columns */
export type Compliance_Messages_Monthly_Stddev_Fields = {
  __typename?: 'compliance_messages_monthly_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Messages_Monthly_Stddev_Pop_Fields = {
  __typename?: 'compliance_messages_monthly_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Messages_Monthly_Stddev_Samp_Fields = {
  __typename?: 'compliance_messages_monthly_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_messages_monthly" */
export type Compliance_Messages_Monthly_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Messages_Monthly_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Messages_Monthly_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  message_count?: InputMaybe<Scalars['numeric']>;
  month?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Compliance_Messages_Monthly_Sum_Fields = {
  __typename?: 'compliance_messages_monthly_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Compliance_Messages_Monthly_Var_Pop_Fields = {
  __typename?: 'compliance_messages_monthly_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Messages_Monthly_Var_Samp_Fields = {
  __typename?: 'compliance_messages_monthly_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Messages_Monthly_Variance_Fields = {
  __typename?: 'compliance_messages_monthly_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** input type for inserting object relation for remote table "compliance_messages" */
export type Compliance_Messages_Obj_Rel_Insert_Input = {
  data: Compliance_Messages_Insert_Input;
};

/** Ordering options when selecting data from "compliance_messages". */
export type Compliance_Messages_Order_By = {
  body?: InputMaybe<Order_By>;
  caption?: InputMaybe<Order_By>;
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_contact?: InputMaybe<Compliance_Contacts_Raw_Order_By>;
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_events_aggregate?: InputMaybe<Compliance_Events_Aggregate_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  from_contact?: InputMaybe<Ws_Contacts_Order_By>;
  from_me?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_group_msg?: InputMaybe<Order_By>;
  message_key?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
  participant?: InputMaybe<Order_By>;
  participant_contact?: InputMaybe<Ws_Contacts_Order_By>;
  timestamp?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
  to_contact?: InputMaybe<Ws_Contacts_Order_By>;
  transcription?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
  ws_session?: InputMaybe<Ws_Sessions_Order_By>;
  ws_session_ref?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_messages" */
export enum Compliance_Messages_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Caption = 'caption',
  /** column name */
  ComplianceContactId = 'compliance_contact_id',
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  From = 'from',
  /** column name */
  FromMe = 'from_me',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGroupMsg = 'is_group_msg',
  /** column name */
  MessageKey = 'message_key',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mime_type',
  /** column name */
  Participant = 'participant',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  To = 'to',
  /** column name */
  Transcription = 'transcription',
  /** column name */
  Type = 'type',
  /** column name */
  UnixTimestamp = 'unix_timestamp',
  /** column name */
  WsSessionRef = 'ws_session_ref'
}

/** select "compliance_messages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "compliance_messages" */
export enum Compliance_Messages_Select_Column_Compliance_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  FromMe = 'from_me',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGroupMsg = 'is_group_msg'
}

/** select "compliance_messages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "compliance_messages" */
export enum Compliance_Messages_Select_Column_Compliance_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  FromMe = 'from_me',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGroupMsg = 'is_group_msg'
}

/** aggregate stddev on columns */
export type Compliance_Messages_Stddev_Fields = {
  __typename?: 'compliance_messages_stddev_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "compliance_messages" */
export type Compliance_Messages_Stddev_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Messages_Stddev_Pop_Fields = {
  __typename?: 'compliance_messages_stddev_pop_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "compliance_messages" */
export type Compliance_Messages_Stddev_Pop_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Messages_Stddev_Samp_Fields = {
  __typename?: 'compliance_messages_stddev_samp_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "compliance_messages" */
export type Compliance_Messages_Stddev_Samp_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "compliance_messages" */
export type Compliance_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Messages_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  compliance_contact_id?: InputMaybe<Scalars['Int']>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  from_me?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_group_msg?: InputMaybe<Scalars['Boolean']>;
  message_key?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  mime_type?: InputMaybe<Scalars['String']>;
  participant?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  to?: InputMaybe<Scalars['String']>;
  transcription?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  unix_timestamp?: InputMaybe<Scalars['Int']>;
  ws_session_ref?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Compliance_Messages_Sum_Fields = {
  __typename?: 'compliance_messages_sum_fields';
  compliance_contact_id?: Maybe<Scalars['Int']>;
  compliance_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  unix_timestamp?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "compliance_messages" */
export type Compliance_Messages_Sum_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** columns and relationships of "compliance_messages_total" */
export type Compliance_Messages_Total = {
  __typename?: 'compliance_messages_total';
  /** An object relationship */
  compliance?: Maybe<Compliance>;
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "compliance_messages_total" */
export type Compliance_Messages_Total_Aggregate = {
  __typename?: 'compliance_messages_total_aggregate';
  aggregate?: Maybe<Compliance_Messages_Total_Aggregate_Fields>;
  nodes: Array<Compliance_Messages_Total>;
};

/** aggregate fields of "compliance_messages_total" */
export type Compliance_Messages_Total_Aggregate_Fields = {
  __typename?: 'compliance_messages_total_aggregate_fields';
  avg?: Maybe<Compliance_Messages_Total_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Messages_Total_Max_Fields>;
  min?: Maybe<Compliance_Messages_Total_Min_Fields>;
  stddev?: Maybe<Compliance_Messages_Total_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Messages_Total_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Messages_Total_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Messages_Total_Sum_Fields>;
  var_pop?: Maybe<Compliance_Messages_Total_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Messages_Total_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Messages_Total_Variance_Fields>;
};


/** aggregate fields of "compliance_messages_total" */
export type Compliance_Messages_Total_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Messages_Total_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Messages_Total_Avg_Fields = {
  __typename?: 'compliance_messages_total_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_messages_total". All fields are combined with a logical 'AND'. */
export type Compliance_Messages_Total_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Messages_Total_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Messages_Total_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Messages_Total_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  message_count?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Compliance_Messages_Total_Max_Fields = {
  __typename?: 'compliance_messages_total_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Compliance_Messages_Total_Min_Fields = {
  __typename?: 'compliance_messages_total_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "compliance_messages_total". */
export type Compliance_Messages_Total_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  message_count?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_messages_total" */
export enum Compliance_Messages_Total_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  MessageCount = 'message_count'
}

/** aggregate stddev on columns */
export type Compliance_Messages_Total_Stddev_Fields = {
  __typename?: 'compliance_messages_total_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Messages_Total_Stddev_Pop_Fields = {
  __typename?: 'compliance_messages_total_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Messages_Total_Stddev_Samp_Fields = {
  __typename?: 'compliance_messages_total_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_messages_total" */
export type Compliance_Messages_Total_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Messages_Total_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Messages_Total_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  message_count?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Compliance_Messages_Total_Sum_Fields = {
  __typename?: 'compliance_messages_total_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Compliance_Messages_Total_Var_Pop_Fields = {
  __typename?: 'compliance_messages_total_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Messages_Total_Var_Samp_Fields = {
  __typename?: 'compliance_messages_total_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Messages_Total_Variance_Fields = {
  __typename?: 'compliance_messages_total_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_pop on columns */
export type Compliance_Messages_Var_Pop_Fields = {
  __typename?: 'compliance_messages_var_pop_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "compliance_messages" */
export type Compliance_Messages_Var_Pop_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Compliance_Messages_Var_Samp_Fields = {
  __typename?: 'compliance_messages_var_samp_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "compliance_messages" */
export type Compliance_Messages_Var_Samp_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Compliance_Messages_Variance_Fields = {
  __typename?: 'compliance_messages_variance_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "compliance_messages" */
export type Compliance_Messages_Variance_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** columns and relationships of "compliance_messages_weekly" */
export type Compliance_Messages_Weekly = {
  __typename?: 'compliance_messages_weekly';
  /** An object relationship */
  compliance?: Maybe<Compliance>;
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
  week?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "compliance_messages_weekly" */
export type Compliance_Messages_Weekly_Aggregate = {
  __typename?: 'compliance_messages_weekly_aggregate';
  aggregate?: Maybe<Compliance_Messages_Weekly_Aggregate_Fields>;
  nodes: Array<Compliance_Messages_Weekly>;
};

/** aggregate fields of "compliance_messages_weekly" */
export type Compliance_Messages_Weekly_Aggregate_Fields = {
  __typename?: 'compliance_messages_weekly_aggregate_fields';
  avg?: Maybe<Compliance_Messages_Weekly_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Messages_Weekly_Max_Fields>;
  min?: Maybe<Compliance_Messages_Weekly_Min_Fields>;
  stddev?: Maybe<Compliance_Messages_Weekly_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Messages_Weekly_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Messages_Weekly_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Messages_Weekly_Sum_Fields>;
  var_pop?: Maybe<Compliance_Messages_Weekly_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Messages_Weekly_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Messages_Weekly_Variance_Fields>;
};


/** aggregate fields of "compliance_messages_weekly" */
export type Compliance_Messages_Weekly_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Messages_Weekly_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Messages_Weekly_Avg_Fields = {
  __typename?: 'compliance_messages_weekly_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_messages_weekly". All fields are combined with a logical 'AND'. */
export type Compliance_Messages_Weekly_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Messages_Weekly_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Messages_Weekly_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Messages_Weekly_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  message_count?: InputMaybe<Numeric_Comparison_Exp>;
  week?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Compliance_Messages_Weekly_Max_Fields = {
  __typename?: 'compliance_messages_weekly_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
  week?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Compliance_Messages_Weekly_Min_Fields = {
  __typename?: 'compliance_messages_weekly_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
  week?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "compliance_messages_weekly". */
export type Compliance_Messages_Weekly_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  message_count?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_messages_weekly" */
export enum Compliance_Messages_Weekly_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  MessageCount = 'message_count',
  /** column name */
  Week = 'week'
}

/** aggregate stddev on columns */
export type Compliance_Messages_Weekly_Stddev_Fields = {
  __typename?: 'compliance_messages_weekly_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Messages_Weekly_Stddev_Pop_Fields = {
  __typename?: 'compliance_messages_weekly_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Messages_Weekly_Stddev_Samp_Fields = {
  __typename?: 'compliance_messages_weekly_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_messages_weekly" */
export type Compliance_Messages_Weekly_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Messages_Weekly_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Messages_Weekly_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  message_count?: InputMaybe<Scalars['numeric']>;
  week?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Compliance_Messages_Weekly_Sum_Fields = {
  __typename?: 'compliance_messages_weekly_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Compliance_Messages_Weekly_Var_Pop_Fields = {
  __typename?: 'compliance_messages_weekly_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Messages_Weekly_Var_Samp_Fields = {
  __typename?: 'compliance_messages_weekly_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Messages_Weekly_Variance_Fields = {
  __typename?: 'compliance_messages_weekly_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "compliance_messages_yearly" */
export type Compliance_Messages_Yearly = {
  __typename?: 'compliance_messages_yearly';
  /** An object relationship */
  compliance?: Maybe<Compliance>;
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
  year?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "compliance_messages_yearly" */
export type Compliance_Messages_Yearly_Aggregate = {
  __typename?: 'compliance_messages_yearly_aggregate';
  aggregate?: Maybe<Compliance_Messages_Yearly_Aggregate_Fields>;
  nodes: Array<Compliance_Messages_Yearly>;
};

/** aggregate fields of "compliance_messages_yearly" */
export type Compliance_Messages_Yearly_Aggregate_Fields = {
  __typename?: 'compliance_messages_yearly_aggregate_fields';
  avg?: Maybe<Compliance_Messages_Yearly_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Messages_Yearly_Max_Fields>;
  min?: Maybe<Compliance_Messages_Yearly_Min_Fields>;
  stddev?: Maybe<Compliance_Messages_Yearly_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Messages_Yearly_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Messages_Yearly_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Messages_Yearly_Sum_Fields>;
  var_pop?: Maybe<Compliance_Messages_Yearly_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Messages_Yearly_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Messages_Yearly_Variance_Fields>;
};


/** aggregate fields of "compliance_messages_yearly" */
export type Compliance_Messages_Yearly_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Messages_Yearly_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Messages_Yearly_Avg_Fields = {
  __typename?: 'compliance_messages_yearly_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_messages_yearly". All fields are combined with a logical 'AND'. */
export type Compliance_Messages_Yearly_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Messages_Yearly_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Messages_Yearly_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Messages_Yearly_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  message_count?: InputMaybe<Numeric_Comparison_Exp>;
  year?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Compliance_Messages_Yearly_Max_Fields = {
  __typename?: 'compliance_messages_yearly_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
  year?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Compliance_Messages_Yearly_Min_Fields = {
  __typename?: 'compliance_messages_yearly_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
  year?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "compliance_messages_yearly". */
export type Compliance_Messages_Yearly_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  message_count?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_messages_yearly" */
export enum Compliance_Messages_Yearly_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  MessageCount = 'message_count',
  /** column name */
  Year = 'year'
}

/** aggregate stddev on columns */
export type Compliance_Messages_Yearly_Stddev_Fields = {
  __typename?: 'compliance_messages_yearly_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Messages_Yearly_Stddev_Pop_Fields = {
  __typename?: 'compliance_messages_yearly_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Messages_Yearly_Stddev_Samp_Fields = {
  __typename?: 'compliance_messages_yearly_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_messages_yearly" */
export type Compliance_Messages_Yearly_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Messages_Yearly_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Messages_Yearly_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  message_count?: InputMaybe<Scalars['numeric']>;
  year?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Compliance_Messages_Yearly_Sum_Fields = {
  __typename?: 'compliance_messages_yearly_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  message_count?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Compliance_Messages_Yearly_Var_Pop_Fields = {
  __typename?: 'compliance_messages_yearly_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Messages_Yearly_Var_Samp_Fields = {
  __typename?: 'compliance_messages_yearly_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Messages_Yearly_Variance_Fields = {
  __typename?: 'compliance_messages_yearly_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  message_count?: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Compliance_Min_Fields = {
  __typename?: 'compliance_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "compliance" */
export type Compliance_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "compliance" */
export type Compliance_Mutation_Response = {
  __typename?: 'compliance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance>;
};

/** input type for inserting object relation for remote table "compliance" */
export type Compliance_Obj_Rel_Insert_Input = {
  data: Compliance_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Compliance_On_Conflict>;
};

/** on_conflict condition type for table "compliance" */
export type Compliance_On_Conflict = {
  constraint: Compliance_Constraint;
  update_columns?: Array<Compliance_Update_Column>;
  where?: InputMaybe<Compliance_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance". */
export type Compliance_Order_By = {
  compliance_contacts_aggregate?: InputMaybe<Compliance_Contacts_Raw_Aggregate_Order_By>;
  compliance_events_aggregate?: InputMaybe<Compliance_Events_Aggregate_Order_By>;
  compliance_groups_aggregate?: InputMaybe<Compliance_Groups_Aggregate_Order_By>;
  compliance_policies_aggregate?: InputMaybe<Compliance_Policies_Aggregate_Order_By>;
  compliance_rules_aggregate?: InputMaybe<Compliance_Rules_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** columns and relationships of "compliance_participants" */
export type Compliance_Participants = {
  __typename?: 'compliance_participants';
  compliance_contact_id?: Maybe<Scalars['Int']>;
  compliance_id?: Maybe<Scalars['Int']>;
  is_group?: Maybe<Scalars['Boolean']>;
  message_body?: Maybe<Scalars['String']>;
  message_caption?: Maybe<Scalars['String']>;
  message_from?: Maybe<Scalars['String']>;
  message_from_me?: Maybe<Scalars['Boolean']>;
  message_id?: Maybe<Scalars['Int']>;
  message_is_deleted?: Maybe<Scalars['Boolean']>;
  message_is_group?: Maybe<Scalars['Boolean']>;
  message_key?: Maybe<Scalars['String']>;
  message_metadata?: Maybe<Scalars['jsonb']>;
  message_timestamp?: Maybe<Scalars['timestamptz']>;
  message_to?: Maybe<Scalars['String']>;
  message_transcription?: Maybe<Scalars['String']>;
  message_type?: Maybe<Scalars['String']>;
  message_unix_timestamp?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_pic?: Maybe<Scalars['String']>;
  ws_session_phone?: Maybe<Scalars['String']>;
};


/** columns and relationships of "compliance_participants" */
export type Compliance_ParticipantsMessage_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "compliance_participants" */
export type Compliance_Participants_Aggregate = {
  __typename?: 'compliance_participants_aggregate';
  aggregate?: Maybe<Compliance_Participants_Aggregate_Fields>;
  nodes: Array<Compliance_Participants>;
};

/** aggregate fields of "compliance_participants" */
export type Compliance_Participants_Aggregate_Fields = {
  __typename?: 'compliance_participants_aggregate_fields';
  avg?: Maybe<Compliance_Participants_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Participants_Max_Fields>;
  min?: Maybe<Compliance_Participants_Min_Fields>;
  stddev?: Maybe<Compliance_Participants_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Participants_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Participants_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Participants_Sum_Fields>;
  var_pop?: Maybe<Compliance_Participants_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Participants_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Participants_Variance_Fields>;
};


/** aggregate fields of "compliance_participants" */
export type Compliance_Participants_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Participants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Participants_Avg_Fields = {
  __typename?: 'compliance_participants_avg_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  message_id?: Maybe<Scalars['Float']>;
  message_unix_timestamp?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_participants". All fields are combined with a logical 'AND'. */
export type Compliance_Participants_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Participants_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Participants_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Participants_Bool_Exp>>;
  compliance_contact_id?: InputMaybe<Int_Comparison_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  is_group?: InputMaybe<Boolean_Comparison_Exp>;
  message_body?: InputMaybe<String_Comparison_Exp>;
  message_caption?: InputMaybe<String_Comparison_Exp>;
  message_from?: InputMaybe<String_Comparison_Exp>;
  message_from_me?: InputMaybe<Boolean_Comparison_Exp>;
  message_id?: InputMaybe<Int_Comparison_Exp>;
  message_is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  message_is_group?: InputMaybe<Boolean_Comparison_Exp>;
  message_key?: InputMaybe<String_Comparison_Exp>;
  message_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  message_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  message_to?: InputMaybe<String_Comparison_Exp>;
  message_transcription?: InputMaybe<String_Comparison_Exp>;
  message_type?: InputMaybe<String_Comparison_Exp>;
  message_unix_timestamp?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  profile_pic?: InputMaybe<String_Comparison_Exp>;
  ws_session_phone?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Compliance_Participants_Max_Fields = {
  __typename?: 'compliance_participants_max_fields';
  compliance_contact_id?: Maybe<Scalars['Int']>;
  compliance_id?: Maybe<Scalars['Int']>;
  message_body?: Maybe<Scalars['String']>;
  message_caption?: Maybe<Scalars['String']>;
  message_from?: Maybe<Scalars['String']>;
  message_id?: Maybe<Scalars['Int']>;
  message_key?: Maybe<Scalars['String']>;
  message_timestamp?: Maybe<Scalars['timestamptz']>;
  message_to?: Maybe<Scalars['String']>;
  message_transcription?: Maybe<Scalars['String']>;
  message_type?: Maybe<Scalars['String']>;
  message_unix_timestamp?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_pic?: Maybe<Scalars['String']>;
  ws_session_phone?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Compliance_Participants_Min_Fields = {
  __typename?: 'compliance_participants_min_fields';
  compliance_contact_id?: Maybe<Scalars['Int']>;
  compliance_id?: Maybe<Scalars['Int']>;
  message_body?: Maybe<Scalars['String']>;
  message_caption?: Maybe<Scalars['String']>;
  message_from?: Maybe<Scalars['String']>;
  message_id?: Maybe<Scalars['Int']>;
  message_key?: Maybe<Scalars['String']>;
  message_timestamp?: Maybe<Scalars['timestamptz']>;
  message_to?: Maybe<Scalars['String']>;
  message_transcription?: Maybe<Scalars['String']>;
  message_type?: Maybe<Scalars['String']>;
  message_unix_timestamp?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_pic?: Maybe<Scalars['String']>;
  ws_session_phone?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "compliance_participants". */
export type Compliance_Participants_Order_By = {
  compliance_contact_id?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  is_group?: InputMaybe<Order_By>;
  message_body?: InputMaybe<Order_By>;
  message_caption?: InputMaybe<Order_By>;
  message_from?: InputMaybe<Order_By>;
  message_from_me?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  message_is_deleted?: InputMaybe<Order_By>;
  message_is_group?: InputMaybe<Order_By>;
  message_key?: InputMaybe<Order_By>;
  message_metadata?: InputMaybe<Order_By>;
  message_timestamp?: InputMaybe<Order_By>;
  message_to?: InputMaybe<Order_By>;
  message_transcription?: InputMaybe<Order_By>;
  message_type?: InputMaybe<Order_By>;
  message_unix_timestamp?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  profile_pic?: InputMaybe<Order_By>;
  ws_session_phone?: InputMaybe<Order_By>;
};

/** select columns of table "compliance_participants" */
export enum Compliance_Participants_Select_Column {
  /** column name */
  ComplianceContactId = 'compliance_contact_id',
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  IsGroup = 'is_group',
  /** column name */
  MessageBody = 'message_body',
  /** column name */
  MessageCaption = 'message_caption',
  /** column name */
  MessageFrom = 'message_from',
  /** column name */
  MessageFromMe = 'message_from_me',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  MessageIsDeleted = 'message_is_deleted',
  /** column name */
  MessageIsGroup = 'message_is_group',
  /** column name */
  MessageKey = 'message_key',
  /** column name */
  MessageMetadata = 'message_metadata',
  /** column name */
  MessageTimestamp = 'message_timestamp',
  /** column name */
  MessageTo = 'message_to',
  /** column name */
  MessageTranscription = 'message_transcription',
  /** column name */
  MessageType = 'message_type',
  /** column name */
  MessageUnixTimestamp = 'message_unix_timestamp',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProfilePic = 'profile_pic',
  /** column name */
  WsSessionPhone = 'ws_session_phone'
}

/** aggregate stddev on columns */
export type Compliance_Participants_Stddev_Fields = {
  __typename?: 'compliance_participants_stddev_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  message_id?: Maybe<Scalars['Float']>;
  message_unix_timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Participants_Stddev_Pop_Fields = {
  __typename?: 'compliance_participants_stddev_pop_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  message_id?: Maybe<Scalars['Float']>;
  message_unix_timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Participants_Stddev_Samp_Fields = {
  __typename?: 'compliance_participants_stddev_samp_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  message_id?: Maybe<Scalars['Float']>;
  message_unix_timestamp?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_participants" */
export type Compliance_Participants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Participants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Participants_Stream_Cursor_Value_Input = {
  compliance_contact_id?: InputMaybe<Scalars['Int']>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  is_group?: InputMaybe<Scalars['Boolean']>;
  message_body?: InputMaybe<Scalars['String']>;
  message_caption?: InputMaybe<Scalars['String']>;
  message_from?: InputMaybe<Scalars['String']>;
  message_from_me?: InputMaybe<Scalars['Boolean']>;
  message_id?: InputMaybe<Scalars['Int']>;
  message_is_deleted?: InputMaybe<Scalars['Boolean']>;
  message_is_group?: InputMaybe<Scalars['Boolean']>;
  message_key?: InputMaybe<Scalars['String']>;
  message_metadata?: InputMaybe<Scalars['jsonb']>;
  message_timestamp?: InputMaybe<Scalars['timestamptz']>;
  message_to?: InputMaybe<Scalars['String']>;
  message_transcription?: InputMaybe<Scalars['String']>;
  message_type?: InputMaybe<Scalars['String']>;
  message_unix_timestamp?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profile_pic?: InputMaybe<Scalars['String']>;
  ws_session_phone?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Compliance_Participants_Sum_Fields = {
  __typename?: 'compliance_participants_sum_fields';
  compliance_contact_id?: Maybe<Scalars['Int']>;
  compliance_id?: Maybe<Scalars['Int']>;
  message_id?: Maybe<Scalars['Int']>;
  message_unix_timestamp?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Compliance_Participants_Var_Pop_Fields = {
  __typename?: 'compliance_participants_var_pop_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  message_id?: Maybe<Scalars['Float']>;
  message_unix_timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Participants_Var_Samp_Fields = {
  __typename?: 'compliance_participants_var_samp_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  message_id?: Maybe<Scalars['Float']>;
  message_unix_timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Participants_Variance_Fields = {
  __typename?: 'compliance_participants_variance_fields';
  compliance_contact_id?: Maybe<Scalars['Float']>;
  compliance_id?: Maybe<Scalars['Float']>;
  message_id?: Maybe<Scalars['Float']>;
  message_unix_timestamp?: Maybe<Scalars['Float']>;
};

/** primary key columns input for table: compliance */
export type Compliance_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "compliance_policies" */
export type Compliance_Policies = {
  __typename?: 'compliance_policies';
  cc_emails?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  compliance: Compliance;
  compliance_id: Scalars['Int'];
  /** An array relationship */
  compliance_rules: Array<Compliance_Rules>;
  /** An aggregate relationship */
  compliance_rules_aggregate: Compliance_Rules_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "compliance_policies" */
export type Compliance_PoliciesCc_EmailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "compliance_policies" */
export type Compliance_PoliciesCompliance_RulesArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Rules_Order_By>>;
  where?: InputMaybe<Compliance_Rules_Bool_Exp>;
};


/** columns and relationships of "compliance_policies" */
export type Compliance_PoliciesCompliance_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Rules_Order_By>>;
  where?: InputMaybe<Compliance_Rules_Bool_Exp>;
};

/** aggregated selection of "compliance_policies" */
export type Compliance_Policies_Aggregate = {
  __typename?: 'compliance_policies_aggregate';
  aggregate?: Maybe<Compliance_Policies_Aggregate_Fields>;
  nodes: Array<Compliance_Policies>;
};

export type Compliance_Policies_Aggregate_Bool_Exp = {
  count?: InputMaybe<Compliance_Policies_Aggregate_Bool_Exp_Count>;
};

export type Compliance_Policies_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Compliance_Policies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Compliance_Policies_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance_policies" */
export type Compliance_Policies_Aggregate_Fields = {
  __typename?: 'compliance_policies_aggregate_fields';
  avg?: Maybe<Compliance_Policies_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Policies_Max_Fields>;
  min?: Maybe<Compliance_Policies_Min_Fields>;
  stddev?: Maybe<Compliance_Policies_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Policies_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Policies_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Policies_Sum_Fields>;
  var_pop?: Maybe<Compliance_Policies_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Policies_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Policies_Variance_Fields>;
};


/** aggregate fields of "compliance_policies" */
export type Compliance_Policies_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Policies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance_policies" */
export type Compliance_Policies_Aggregate_Order_By = {
  avg?: InputMaybe<Compliance_Policies_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Compliance_Policies_Max_Order_By>;
  min?: InputMaybe<Compliance_Policies_Min_Order_By>;
  stddev?: InputMaybe<Compliance_Policies_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Compliance_Policies_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Compliance_Policies_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Compliance_Policies_Sum_Order_By>;
  var_pop?: InputMaybe<Compliance_Policies_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Compliance_Policies_Var_Samp_Order_By>;
  variance?: InputMaybe<Compliance_Policies_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Compliance_Policies_Append_Input = {
  cc_emails?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "compliance_policies" */
export type Compliance_Policies_Arr_Rel_Insert_Input = {
  data: Array<Compliance_Policies_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Compliance_Policies_On_Conflict>;
};

/** aggregate avg on columns */
export type Compliance_Policies_Avg_Fields = {
  __typename?: 'compliance_policies_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "compliance_policies" */
export type Compliance_Policies_Avg_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "compliance_policies". All fields are combined with a logical 'AND'. */
export type Compliance_Policies_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Policies_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Policies_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Policies_Bool_Exp>>;
  cc_emails?: InputMaybe<Jsonb_Comparison_Exp>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  compliance_rules?: InputMaybe<Compliance_Rules_Bool_Exp>;
  compliance_rules_aggregate?: InputMaybe<Compliance_Rules_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance_policies" */
export enum Compliance_Policies_Constraint {
  /** unique or primary key constraint on columns "id" */
  CompliancePoliciesPkey = 'compliance_policies_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Compliance_Policies_Delete_At_Path_Input = {
  cc_emails?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Compliance_Policies_Delete_Elem_Input = {
  cc_emails?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Compliance_Policies_Delete_Key_Input = {
  cc_emails?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "compliance_policies" */
export type Compliance_Policies_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "compliance_policies" */
export type Compliance_Policies_Insert_Input = {
  cc_emails?: InputMaybe<Scalars['jsonb']>;
  compliance?: InputMaybe<Compliance_Obj_Rel_Insert_Input>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  compliance_rules?: InputMaybe<Compliance_Rules_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Compliance_Policies_Max_Fields = {
  __typename?: 'compliance_policies_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "compliance_policies" */
export type Compliance_Policies_Max_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Compliance_Policies_Min_Fields = {
  __typename?: 'compliance_policies_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "compliance_policies" */
export type Compliance_Policies_Min_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "compliance_policies" */
export type Compliance_Policies_Mutation_Response = {
  __typename?: 'compliance_policies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Policies>;
};

/** input type for inserting object relation for remote table "compliance_policies" */
export type Compliance_Policies_Obj_Rel_Insert_Input = {
  data: Compliance_Policies_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Compliance_Policies_On_Conflict>;
};

/** on_conflict condition type for table "compliance_policies" */
export type Compliance_Policies_On_Conflict = {
  constraint: Compliance_Policies_Constraint;
  update_columns?: Array<Compliance_Policies_Update_Column>;
  where?: InputMaybe<Compliance_Policies_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance_policies". */
export type Compliance_Policies_Order_By = {
  cc_emails?: InputMaybe<Order_By>;
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  compliance_rules_aggregate?: InputMaybe<Compliance_Rules_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance_policies */
export type Compliance_Policies_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Compliance_Policies_Prepend_Input = {
  cc_emails?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "compliance_policies" */
export enum Compliance_Policies_Select_Column {
  /** column name */
  CcEmails = 'cc_emails',
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "compliance_policies" */
export type Compliance_Policies_Set_Input = {
  cc_emails?: InputMaybe<Scalars['jsonb']>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Compliance_Policies_Stddev_Fields = {
  __typename?: 'compliance_policies_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "compliance_policies" */
export type Compliance_Policies_Stddev_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Policies_Stddev_Pop_Fields = {
  __typename?: 'compliance_policies_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "compliance_policies" */
export type Compliance_Policies_Stddev_Pop_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Policies_Stddev_Samp_Fields = {
  __typename?: 'compliance_policies_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "compliance_policies" */
export type Compliance_Policies_Stddev_Samp_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "compliance_policies" */
export type Compliance_Policies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Policies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Policies_Stream_Cursor_Value_Input = {
  cc_emails?: InputMaybe<Scalars['jsonb']>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Compliance_Policies_Sum_Fields = {
  __typename?: 'compliance_policies_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "compliance_policies" */
export type Compliance_Policies_Sum_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "compliance_policies" */
export enum Compliance_Policies_Update_Column {
  /** column name */
  CcEmails = 'cc_emails',
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Compliance_Policies_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Compliance_Policies_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Compliance_Policies_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Compliance_Policies_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Compliance_Policies_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Policies_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Compliance_Policies_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Policies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Policies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Policies_Var_Pop_Fields = {
  __typename?: 'compliance_policies_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "compliance_policies" */
export type Compliance_Policies_Var_Pop_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Compliance_Policies_Var_Samp_Fields = {
  __typename?: 'compliance_policies_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "compliance_policies" */
export type Compliance_Policies_Var_Samp_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Compliance_Policies_Variance_Fields = {
  __typename?: 'compliance_policies_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "compliance_policies" */
export type Compliance_Policies_Variance_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Compliance_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "compliance_rules" */
export type Compliance_Rules = {
  __typename?: 'compliance_rules';
  /** An object relationship */
  compliance: Compliance;
  /** An array relationship */
  compliance_events: Array<Compliance_Events>;
  /** An aggregate relationship */
  compliance_events_aggregate: Compliance_Events_Aggregate;
  compliance_id: Scalars['Int'];
  /** An object relationship */
  compliance_policy?: Maybe<Compliance_Policies>;
  compliance_policy_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  enable?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  risk: Scalars['String'];
  rule: Scalars['String'];
  type: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "compliance_rules" */
export type Compliance_RulesCompliance_EventsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


/** columns and relationships of "compliance_rules" */
export type Compliance_RulesCompliance_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};

/** aggregated selection of "compliance_rules" */
export type Compliance_Rules_Aggregate = {
  __typename?: 'compliance_rules_aggregate';
  aggregate?: Maybe<Compliance_Rules_Aggregate_Fields>;
  nodes: Array<Compliance_Rules>;
};

export type Compliance_Rules_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Compliance_Rules_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Compliance_Rules_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Compliance_Rules_Aggregate_Bool_Exp_Count>;
};

export type Compliance_Rules_Aggregate_Bool_Exp_Bool_And = {
  arguments: Compliance_Rules_Select_Column_Compliance_Rules_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Compliance_Rules_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Compliance_Rules_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Compliance_Rules_Select_Column_Compliance_Rules_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Compliance_Rules_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Compliance_Rules_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Compliance_Rules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Compliance_Rules_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "compliance_rules" */
export type Compliance_Rules_Aggregate_Fields = {
  __typename?: 'compliance_rules_aggregate_fields';
  avg?: Maybe<Compliance_Rules_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Rules_Max_Fields>;
  min?: Maybe<Compliance_Rules_Min_Fields>;
  stddev?: Maybe<Compliance_Rules_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Rules_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Rules_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Rules_Sum_Fields>;
  var_pop?: Maybe<Compliance_Rules_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Rules_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Rules_Variance_Fields>;
};


/** aggregate fields of "compliance_rules" */
export type Compliance_Rules_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Rules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "compliance_rules" */
export type Compliance_Rules_Aggregate_Order_By = {
  avg?: InputMaybe<Compliance_Rules_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Compliance_Rules_Max_Order_By>;
  min?: InputMaybe<Compliance_Rules_Min_Order_By>;
  stddev?: InputMaybe<Compliance_Rules_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Compliance_Rules_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Compliance_Rules_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Compliance_Rules_Sum_Order_By>;
  var_pop?: InputMaybe<Compliance_Rules_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Compliance_Rules_Var_Samp_Order_By>;
  variance?: InputMaybe<Compliance_Rules_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "compliance_rules" */
export type Compliance_Rules_Arr_Rel_Insert_Input = {
  data: Array<Compliance_Rules_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Compliance_Rules_On_Conflict>;
};

/** aggregate avg on columns */
export type Compliance_Rules_Avg_Fields = {
  __typename?: 'compliance_rules_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  compliance_policy_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "compliance_rules" */
export type Compliance_Rules_Avg_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  compliance_policy_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "compliance_rules". All fields are combined with a logical 'AND'. */
export type Compliance_Rules_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Rules_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Rules_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Rules_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_events?: InputMaybe<Compliance_Events_Bool_Exp>;
  compliance_events_aggregate?: InputMaybe<Compliance_Events_Aggregate_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  compliance_policy?: InputMaybe<Compliance_Policies_Bool_Exp>;
  compliance_policy_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  enable?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  risk?: InputMaybe<String_Comparison_Exp>;
  rule?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance_rules" */
export enum Compliance_Rules_Constraint {
  /** unique or primary key constraint on columns "id" */
  ComplianceRulesPkey = 'compliance_rules_pkey'
}

/** input type for incrementing numeric columns in table "compliance_rules" */
export type Compliance_Rules_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  compliance_policy_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "compliance_rules" */
export type Compliance_Rules_Insert_Input = {
  compliance?: InputMaybe<Compliance_Obj_Rel_Insert_Input>;
  compliance_events?: InputMaybe<Compliance_Events_Arr_Rel_Insert_Input>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  compliance_policy?: InputMaybe<Compliance_Policies_Obj_Rel_Insert_Input>;
  compliance_policy_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enable?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  risk?: InputMaybe<Scalars['String']>;
  rule?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Compliance_Rules_Max_Fields = {
  __typename?: 'compliance_rules_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  compliance_policy_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  risk?: Maybe<Scalars['String']>;
  rule?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "compliance_rules" */
export type Compliance_Rules_Max_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  compliance_policy_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  risk?: InputMaybe<Order_By>;
  rule?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Compliance_Rules_Min_Fields = {
  __typename?: 'compliance_rules_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  compliance_policy_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  risk?: Maybe<Scalars['String']>;
  rule?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "compliance_rules" */
export type Compliance_Rules_Min_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  compliance_policy_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  risk?: InputMaybe<Order_By>;
  rule?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "compliance_rules" */
export type Compliance_Rules_Mutation_Response = {
  __typename?: 'compliance_rules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Rules>;
};

/** input type for inserting object relation for remote table "compliance_rules" */
export type Compliance_Rules_Obj_Rel_Insert_Input = {
  data: Compliance_Rules_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Compliance_Rules_On_Conflict>;
};

/** on_conflict condition type for table "compliance_rules" */
export type Compliance_Rules_On_Conflict = {
  constraint: Compliance_Rules_Constraint;
  update_columns?: Array<Compliance_Rules_Update_Column>;
  where?: InputMaybe<Compliance_Rules_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance_rules". */
export type Compliance_Rules_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_events_aggregate?: InputMaybe<Compliance_Events_Aggregate_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  compliance_policy?: InputMaybe<Compliance_Policies_Order_By>;
  compliance_policy_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  enable?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  risk?: InputMaybe<Order_By>;
  rule?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance_rules */
export type Compliance_Rules_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "compliance_rules" */
export enum Compliance_Rules_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CompliancePolicyId = 'compliance_policy_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enable = 'enable',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Risk = 'risk',
  /** column name */
  Rule = 'rule',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "compliance_rules_aggregate_bool_exp_bool_and_arguments_columns" columns of table "compliance_rules" */
export enum Compliance_Rules_Select_Column_Compliance_Rules_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Enable = 'enable'
}

/** select "compliance_rules_aggregate_bool_exp_bool_or_arguments_columns" columns of table "compliance_rules" */
export enum Compliance_Rules_Select_Column_Compliance_Rules_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Enable = 'enable'
}

/** input type for updating data in table "compliance_rules" */
export type Compliance_Rules_Set_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  compliance_policy_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enable?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  risk?: InputMaybe<Scalars['String']>;
  rule?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Compliance_Rules_Stddev_Fields = {
  __typename?: 'compliance_rules_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  compliance_policy_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "compliance_rules" */
export type Compliance_Rules_Stddev_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  compliance_policy_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Rules_Stddev_Pop_Fields = {
  __typename?: 'compliance_rules_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  compliance_policy_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "compliance_rules" */
export type Compliance_Rules_Stddev_Pop_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  compliance_policy_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Rules_Stddev_Samp_Fields = {
  __typename?: 'compliance_rules_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  compliance_policy_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "compliance_rules" */
export type Compliance_Rules_Stddev_Samp_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  compliance_policy_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "compliance_rules" */
export type Compliance_Rules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Rules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Rules_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  compliance_policy_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enable?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  risk?: InputMaybe<Scalars['String']>;
  rule?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Compliance_Rules_Sum_Fields = {
  __typename?: 'compliance_rules_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  compliance_policy_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "compliance_rules" */
export type Compliance_Rules_Sum_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  compliance_policy_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "compliance_rules" */
export enum Compliance_Rules_Update_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CompliancePolicyId = 'compliance_policy_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enable = 'enable',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Risk = 'risk',
  /** column name */
  Rule = 'rule',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Compliance_Rules_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Rules_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Rules_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Rules_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Rules_Var_Pop_Fields = {
  __typename?: 'compliance_rules_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  compliance_policy_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "compliance_rules" */
export type Compliance_Rules_Var_Pop_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  compliance_policy_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Compliance_Rules_Var_Samp_Fields = {
  __typename?: 'compliance_rules_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  compliance_policy_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "compliance_rules" */
export type Compliance_Rules_Var_Samp_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  compliance_policy_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Compliance_Rules_Variance_Fields = {
  __typename?: 'compliance_rules_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  compliance_policy_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "compliance_rules" */
export type Compliance_Rules_Variance_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  compliance_policy_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "compliance" */
export enum Compliance_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "compliance" */
export type Compliance_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Compliance_Stddev_Fields = {
  __typename?: 'compliance_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "compliance" */
export type Compliance_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Stddev_Pop_Fields = {
  __typename?: 'compliance_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "compliance" */
export type Compliance_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Stddev_Samp_Fields = {
  __typename?: 'compliance_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "compliance" */
export type Compliance_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "compliance" */
export type Compliance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Compliance_Sum_Fields = {
  __typename?: 'compliance_sum_fields';
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "compliance" */
export type Compliance_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "compliance_tags" */
export type Compliance_Tags = {
  __typename?: 'compliance_tags';
  compliance_id: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** aggregated selection of "compliance_tags" */
export type Compliance_Tags_Aggregate = {
  __typename?: 'compliance_tags_aggregate';
  aggregate?: Maybe<Compliance_Tags_Aggregate_Fields>;
  nodes: Array<Compliance_Tags>;
};

/** aggregate fields of "compliance_tags" */
export type Compliance_Tags_Aggregate_Fields = {
  __typename?: 'compliance_tags_aggregate_fields';
  avg?: Maybe<Compliance_Tags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Compliance_Tags_Max_Fields>;
  min?: Maybe<Compliance_Tags_Min_Fields>;
  stddev?: Maybe<Compliance_Tags_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Tags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Tags_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Tags_Sum_Fields>;
  var_pop?: Maybe<Compliance_Tags_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Tags_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Tags_Variance_Fields>;
};


/** aggregate fields of "compliance_tags" */
export type Compliance_Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Compliance_Tags_Avg_Fields = {
  __typename?: 'compliance_tags_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "compliance_tags". All fields are combined with a logical 'AND'. */
export type Compliance_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Compliance_Tags_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Tags_Bool_Exp>>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "compliance_tags" */
export enum Compliance_Tags_Constraint {
  /** unique or primary key constraint on columns "compliance_id", "name" */
  ComplianceTagsNameComplianceIdKey = 'compliance_tags_name_compliance_id_key',
  /** unique or primary key constraint on columns "id" */
  ComplianceTagsPkey = 'compliance_tags_pkey'
}

/** input type for incrementing numeric columns in table "compliance_tags" */
export type Compliance_Tags_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "compliance_tags" */
export type Compliance_Tags_Insert_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Compliance_Tags_Max_Fields = {
  __typename?: 'compliance_tags_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Compliance_Tags_Min_Fields = {
  __typename?: 'compliance_tags_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "compliance_tags" */
export type Compliance_Tags_Mutation_Response = {
  __typename?: 'compliance_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Tags>;
};

/** on_conflict condition type for table "compliance_tags" */
export type Compliance_Tags_On_Conflict = {
  constraint: Compliance_Tags_Constraint;
  update_columns?: Array<Compliance_Tags_Update_Column>;
  where?: InputMaybe<Compliance_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "compliance_tags". */
export type Compliance_Tags_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: compliance_tags */
export type Compliance_Tags_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "compliance_tags" */
export enum Compliance_Tags_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "compliance_tags" */
export type Compliance_Tags_Set_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Compliance_Tags_Stddev_Fields = {
  __typename?: 'compliance_tags_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Tags_Stddev_Pop_Fields = {
  __typename?: 'compliance_tags_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Tags_Stddev_Samp_Fields = {
  __typename?: 'compliance_tags_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "compliance_tags" */
export type Compliance_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Tags_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Compliance_Tags_Sum_Fields = {
  __typename?: 'compliance_tags_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "compliance_tags" */
export enum Compliance_Tags_Update_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Compliance_Tags_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Tags_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Tags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Tags_Var_Pop_Fields = {
  __typename?: 'compliance_tags_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Compliance_Tags_Var_Samp_Fields = {
  __typename?: 'compliance_tags_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Compliance_Tags_Variance_Fields = {
  __typename?: 'compliance_tags_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** update columns of table "compliance" */
export enum Compliance_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Compliance_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Compliance_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Compliance_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Compliance_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Compliance_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Compliance_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Compliance_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Compliance_Set_Input>;
  /** filter the rows which have to be updated */
  where: Compliance_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Compliance_Var_Pop_Fields = {
  __typename?: 'compliance_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "compliance" */
export type Compliance_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Compliance_Var_Samp_Fields = {
  __typename?: 'compliance_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "compliance" */
export type Compliance_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Compliance_Variance_Fields = {
  __typename?: 'compliance_variance_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "compliance" */
export type Compliance_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** temporary GSK consent table */
export type Consent = {
  __typename?: 'consent';
  agent_uuid: Scalars['uuid'];
  compliance_id: Scalars['Int'];
  consent_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  contact?: Maybe<Ws_Contacts>;
  contact_phone: Scalars['String'];
  created_at: Scalars['timestamptz'];
  crm?: Maybe<Scalars['String']>;
  external_crm?: Maybe<Scalars['String']>;
  external_name?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['jsonb']>;
  pending: Scalars['Boolean'];
  source?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** temporary GSK consent table */
export type ConsentMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "consent" */
export type Consent_Aggregate = {
  __typename?: 'consent_aggregate';
  aggregate?: Maybe<Consent_Aggregate_Fields>;
  nodes: Array<Consent>;
};

export type Consent_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Consent_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Consent_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Consent_Aggregate_Bool_Exp_Count>;
};

export type Consent_Aggregate_Bool_Exp_Bool_And = {
  arguments: Consent_Select_Column_Consent_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Consent_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Consent_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Consent_Select_Column_Consent_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Consent_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Consent_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Consent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Consent_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "consent" */
export type Consent_Aggregate_Fields = {
  __typename?: 'consent_aggregate_fields';
  avg?: Maybe<Consent_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Consent_Max_Fields>;
  min?: Maybe<Consent_Min_Fields>;
  stddev?: Maybe<Consent_Stddev_Fields>;
  stddev_pop?: Maybe<Consent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Consent_Stddev_Samp_Fields>;
  sum?: Maybe<Consent_Sum_Fields>;
  var_pop?: Maybe<Consent_Var_Pop_Fields>;
  var_samp?: Maybe<Consent_Var_Samp_Fields>;
  variance?: Maybe<Consent_Variance_Fields>;
};


/** aggregate fields of "consent" */
export type Consent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Consent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "consent" */
export type Consent_Aggregate_Order_By = {
  avg?: InputMaybe<Consent_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Consent_Max_Order_By>;
  min?: InputMaybe<Consent_Min_Order_By>;
  stddev?: InputMaybe<Consent_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Consent_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Consent_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Consent_Sum_Order_By>;
  var_pop?: InputMaybe<Consent_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Consent_Var_Samp_Order_By>;
  variance?: InputMaybe<Consent_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Consent_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "consent" */
export type Consent_Arr_Rel_Insert_Input = {
  data: Array<Consent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Consent_On_Conflict>;
};

/** aggregate avg on columns */
export type Consent_Avg_Fields = {
  __typename?: 'consent_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "consent" */
export type Consent_Avg_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "consent". All fields are combined with a logical 'AND'. */
export type Consent_Bool_Exp = {
  _and?: InputMaybe<Array<Consent_Bool_Exp>>;
  _not?: InputMaybe<Consent_Bool_Exp>;
  _or?: InputMaybe<Array<Consent_Bool_Exp>>;
  agent_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  consent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  contact?: InputMaybe<Ws_Contacts_Bool_Exp>;
  contact_phone?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crm?: InputMaybe<String_Comparison_Exp>;
  external_crm?: InputMaybe<String_Comparison_Exp>;
  external_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  pending?: InputMaybe<Boolean_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "consent" */
export enum Consent_Constraint {
  /** unique or primary key constraint on columns "contact_phone", "agent_uuid", "compliance_id" */
  ConsentContactPhoneAgentUuidComplianceIdKey = 'consent_contact_phone_agent_uuid_compliance_id_key',
  /** unique or primary key constraint on columns "id" */
  ConsentPkey = 'consent_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Consent_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Consent_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Consent_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "consent" */
export type Consent_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "consent" */
export type Consent_Insert_Input = {
  agent_uuid?: InputMaybe<Scalars['uuid']>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  consent_at?: InputMaybe<Scalars['timestamptz']>;
  contact?: InputMaybe<Ws_Contacts_Obj_Rel_Insert_Input>;
  contact_phone?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  crm?: InputMaybe<Scalars['String']>;
  external_crm?: InputMaybe<Scalars['String']>;
  external_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Consent_Max_Fields = {
  __typename?: 'consent_max_fields';
  agent_uuid?: Maybe<Scalars['uuid']>;
  compliance_id?: Maybe<Scalars['Int']>;
  consent_at?: Maybe<Scalars['timestamptz']>;
  contact_phone?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  crm?: Maybe<Scalars['String']>;
  external_crm?: Maybe<Scalars['String']>;
  external_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "consent" */
export type Consent_Max_Order_By = {
  agent_uuid?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  consent_at?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crm?: InputMaybe<Order_By>;
  external_crm?: InputMaybe<Order_By>;
  external_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Consent_Min_Fields = {
  __typename?: 'consent_min_fields';
  agent_uuid?: Maybe<Scalars['uuid']>;
  compliance_id?: Maybe<Scalars['Int']>;
  consent_at?: Maybe<Scalars['timestamptz']>;
  contact_phone?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  crm?: Maybe<Scalars['String']>;
  external_crm?: Maybe<Scalars['String']>;
  external_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "consent" */
export type Consent_Min_Order_By = {
  agent_uuid?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  consent_at?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crm?: InputMaybe<Order_By>;
  external_crm?: InputMaybe<Order_By>;
  external_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "consent" */
export type Consent_Mutation_Response = {
  __typename?: 'consent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Consent>;
};

/** on_conflict condition type for table "consent" */
export type Consent_On_Conflict = {
  constraint: Consent_Constraint;
  update_columns?: Array<Consent_Update_Column>;
  where?: InputMaybe<Consent_Bool_Exp>;
};

/** Ordering options when selecting data from "consent". */
export type Consent_Order_By = {
  agent_uuid?: InputMaybe<Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  consent_at?: InputMaybe<Order_By>;
  contact?: InputMaybe<Ws_Contacts_Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crm?: InputMaybe<Order_By>;
  external_crm?: InputMaybe<Order_By>;
  external_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  pending?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: consent */
export type Consent_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Consent_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "consent" */
export enum Consent_Select_Column {
  /** column name */
  AgentUuid = 'agent_uuid',
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  ConsentAt = 'consent_at',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crm = 'crm',
  /** column name */
  ExternalCrm = 'external_crm',
  /** column name */
  ExternalName = 'external_name',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Pending = 'pending',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "consent_aggregate_bool_exp_bool_and_arguments_columns" columns of table "consent" */
export enum Consent_Select_Column_Consent_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Pending = 'pending'
}

/** select "consent_aggregate_bool_exp_bool_or_arguments_columns" columns of table "consent" */
export enum Consent_Select_Column_Consent_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Pending = 'pending'
}

/** input type for updating data in table "consent" */
export type Consent_Set_Input = {
  agent_uuid?: InputMaybe<Scalars['uuid']>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  consent_at?: InputMaybe<Scalars['timestamptz']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  crm?: InputMaybe<Scalars['String']>;
  external_crm?: InputMaybe<Scalars['String']>;
  external_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Consent_Stddev_Fields = {
  __typename?: 'consent_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "consent" */
export type Consent_Stddev_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Consent_Stddev_Pop_Fields = {
  __typename?: 'consent_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "consent" */
export type Consent_Stddev_Pop_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Consent_Stddev_Samp_Fields = {
  __typename?: 'consent_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "consent" */
export type Consent_Stddev_Samp_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "consent" */
export type Consent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Consent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Consent_Stream_Cursor_Value_Input = {
  agent_uuid?: InputMaybe<Scalars['uuid']>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  consent_at?: InputMaybe<Scalars['timestamptz']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  crm?: InputMaybe<Scalars['String']>;
  external_crm?: InputMaybe<Scalars['String']>;
  external_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Consent_Sum_Fields = {
  __typename?: 'consent_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "consent" */
export type Consent_Sum_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "consent" */
export enum Consent_Update_Column {
  /** column name */
  AgentUuid = 'agent_uuid',
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  ConsentAt = 'consent_at',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crm = 'crm',
  /** column name */
  ExternalCrm = 'external_crm',
  /** column name */
  ExternalName = 'external_name',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Pending = 'pending',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Consent_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Consent_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Consent_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Consent_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Consent_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Consent_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Consent_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Consent_Set_Input>;
  /** filter the rows which have to be updated */
  where: Consent_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Consent_Var_Pop_Fields = {
  __typename?: 'consent_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "consent" */
export type Consent_Var_Pop_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Consent_Var_Samp_Fields = {
  __typename?: 'consent_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "consent" */
export type Consent_Var_Samp_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Consent_Variance_Fields = {
  __typename?: 'consent_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "consent" */
export type Consent_Variance_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "contact_list" */
export type Contact_List = {
  __typename?: 'contact_list';
  /** An object relationship */
  contact?: Maybe<Ws_Contacts>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  /** An object relationship */
  session: Ws_Sessions;
  session_uuid: Scalars['uuid'];
};

/** aggregated selection of "contact_list" */
export type Contact_List_Aggregate = {
  __typename?: 'contact_list_aggregate';
  aggregate?: Maybe<Contact_List_Aggregate_Fields>;
  nodes: Array<Contact_List>;
};

/** aggregate fields of "contact_list" */
export type Contact_List_Aggregate_Fields = {
  __typename?: 'contact_list_aggregate_fields';
  avg?: Maybe<Contact_List_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Contact_List_Max_Fields>;
  min?: Maybe<Contact_List_Min_Fields>;
  stddev?: Maybe<Contact_List_Stddev_Fields>;
  stddev_pop?: Maybe<Contact_List_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Contact_List_Stddev_Samp_Fields>;
  sum?: Maybe<Contact_List_Sum_Fields>;
  var_pop?: Maybe<Contact_List_Var_Pop_Fields>;
  var_samp?: Maybe<Contact_List_Var_Samp_Fields>;
  variance?: Maybe<Contact_List_Variance_Fields>;
};


/** aggregate fields of "contact_list" */
export type Contact_List_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contact_List_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Contact_List_Avg_Fields = {
  __typename?: 'contact_list_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "contact_list". All fields are combined with a logical 'AND'. */
export type Contact_List_Bool_Exp = {
  _and?: InputMaybe<Array<Contact_List_Bool_Exp>>;
  _not?: InputMaybe<Contact_List_Bool_Exp>;
  _or?: InputMaybe<Array<Contact_List_Bool_Exp>>;
  contact?: InputMaybe<Ws_Contacts_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  session?: InputMaybe<Ws_Sessions_Bool_Exp>;
  session_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "contact_list" */
export enum Contact_List_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContactListPkey = 'contact_list_pkey',
  /** unique or primary key constraint on columns "phone", "session_uuid" */
  ContactListSessionUuidPhoneKey = 'contact_list_session_uuid_phone_key'
}

/** input type for incrementing numeric columns in table "contact_list" */
export type Contact_List_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "contact_list" */
export type Contact_List_Insert_Input = {
  contact?: InputMaybe<Ws_Contacts_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  session?: InputMaybe<Ws_Sessions_Obj_Rel_Insert_Input>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Contact_List_Max_Fields = {
  __typename?: 'contact_list_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  session_uuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Contact_List_Min_Fields = {
  __typename?: 'contact_list_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  session_uuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "contact_list" */
export type Contact_List_Mutation_Response = {
  __typename?: 'contact_list_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Contact_List>;
};

/** input type for inserting object relation for remote table "contact_list" */
export type Contact_List_Obj_Rel_Insert_Input = {
  data: Contact_List_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Contact_List_On_Conflict>;
};

/** on_conflict condition type for table "contact_list" */
export type Contact_List_On_Conflict = {
  constraint: Contact_List_Constraint;
  update_columns?: Array<Contact_List_Update_Column>;
  where?: InputMaybe<Contact_List_Bool_Exp>;
};

/** Ordering options when selecting data from "contact_list". */
export type Contact_List_Order_By = {
  contact?: InputMaybe<Ws_Contacts_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  session?: InputMaybe<Ws_Sessions_Order_By>;
  session_uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contact_list */
export type Contact_List_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "contact_list" */
export enum Contact_List_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  SessionUuid = 'session_uuid'
}

/** input type for updating data in table "contact_list" */
export type Contact_List_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Contact_List_Stddev_Fields = {
  __typename?: 'contact_list_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Contact_List_Stddev_Pop_Fields = {
  __typename?: 'contact_list_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Contact_List_Stddev_Samp_Fields = {
  __typename?: 'contact_list_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "contact_list" */
export type Contact_List_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contact_List_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contact_List_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Contact_List_Sum_Fields = {
  __typename?: 'contact_list_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "contact_list" */
export enum Contact_List_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  SessionUuid = 'session_uuid'
}

export type Contact_List_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Contact_List_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contact_List_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contact_List_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Contact_List_Var_Pop_Fields = {
  __typename?: 'contact_list_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Contact_List_Var_Samp_Fields = {
  __typename?: 'contact_list_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Contact_List_Variance_Fields = {
  __typename?: 'contact_list_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** linked_phone is a personal phone number associated with a Duo, no relationship w/ phone table. */
export type Duo = {
  __typename?: 'duo';
  id: Scalars['Int'];
  linked_phone?: Maybe<Scalars['String']>;
  /** An object relationship */
  phone?: Maybe<Phones>;
  phone_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  product: Products;
  product_name: Scalars['String'];
  /** An object relationship */
  subscription: Subscriptions;
  subscription_uuid: Scalars['uuid'];
  verification_code?: Maybe<Scalars['String']>;
};

/** aggregated selection of "duo" */
export type Duo_Aggregate = {
  __typename?: 'duo_aggregate';
  aggregate?: Maybe<Duo_Aggregate_Fields>;
  nodes: Array<Duo>;
};

export type Duo_Aggregate_Bool_Exp = {
  count?: InputMaybe<Duo_Aggregate_Bool_Exp_Count>;
};

export type Duo_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Duo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Duo_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "duo" */
export type Duo_Aggregate_Fields = {
  __typename?: 'duo_aggregate_fields';
  avg?: Maybe<Duo_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Duo_Max_Fields>;
  min?: Maybe<Duo_Min_Fields>;
  stddev?: Maybe<Duo_Stddev_Fields>;
  stddev_pop?: Maybe<Duo_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Duo_Stddev_Samp_Fields>;
  sum?: Maybe<Duo_Sum_Fields>;
  var_pop?: Maybe<Duo_Var_Pop_Fields>;
  var_samp?: Maybe<Duo_Var_Samp_Fields>;
  variance?: Maybe<Duo_Variance_Fields>;
};


/** aggregate fields of "duo" */
export type Duo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Duo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "duo" */
export type Duo_Aggregate_Order_By = {
  avg?: InputMaybe<Duo_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Duo_Max_Order_By>;
  min?: InputMaybe<Duo_Min_Order_By>;
  stddev?: InputMaybe<Duo_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Duo_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Duo_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Duo_Sum_Order_By>;
  var_pop?: InputMaybe<Duo_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Duo_Var_Samp_Order_By>;
  variance?: InputMaybe<Duo_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "duo" */
export type Duo_Arr_Rel_Insert_Input = {
  data: Array<Duo_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Duo_On_Conflict>;
};

/** aggregate avg on columns */
export type Duo_Avg_Fields = {
  __typename?: 'duo_avg_fields';
  id?: Maybe<Scalars['Float']>;
  phone_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "duo" */
export type Duo_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  phone_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "duo". All fields are combined with a logical 'AND'. */
export type Duo_Bool_Exp = {
  _and?: InputMaybe<Array<Duo_Bool_Exp>>;
  _not?: InputMaybe<Duo_Bool_Exp>;
  _or?: InputMaybe<Array<Duo_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  linked_phone?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<Phones_Bool_Exp>;
  phone_id?: InputMaybe<Int_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  product_name?: InputMaybe<String_Comparison_Exp>;
  subscription?: InputMaybe<Subscriptions_Bool_Exp>;
  subscription_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  verification_code?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "duo" */
export enum Duo_Constraint {
  /** unique or primary key constraint on columns "phone_id" */
  DuoPhoneIdKey = 'duo_phone_id_key',
  /** unique or primary key constraint on columns "id" */
  DuoPkey = 'duo_pkey'
}

/** input type for incrementing numeric columns in table "duo" */
export type Duo_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  phone_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "duo" */
export type Duo_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  linked_phone?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Phones_Obj_Rel_Insert_Input>;
  phone_id?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  product_name?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<Subscriptions_Obj_Rel_Insert_Input>;
  subscription_uuid?: InputMaybe<Scalars['uuid']>;
  verification_code?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Duo_Max_Fields = {
  __typename?: 'duo_max_fields';
  id?: Maybe<Scalars['Int']>;
  linked_phone?: Maybe<Scalars['String']>;
  phone_id?: Maybe<Scalars['Int']>;
  product_name?: Maybe<Scalars['String']>;
  subscription_uuid?: Maybe<Scalars['uuid']>;
  verification_code?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "duo" */
export type Duo_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  linked_phone?: InputMaybe<Order_By>;
  phone_id?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
  subscription_uuid?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Duo_Min_Fields = {
  __typename?: 'duo_min_fields';
  id?: Maybe<Scalars['Int']>;
  linked_phone?: Maybe<Scalars['String']>;
  phone_id?: Maybe<Scalars['Int']>;
  product_name?: Maybe<Scalars['String']>;
  subscription_uuid?: Maybe<Scalars['uuid']>;
  verification_code?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "duo" */
export type Duo_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  linked_phone?: InputMaybe<Order_By>;
  phone_id?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
  subscription_uuid?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "duo" */
export type Duo_Mutation_Response = {
  __typename?: 'duo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Duo>;
};

/** input type for inserting object relation for remote table "duo" */
export type Duo_Obj_Rel_Insert_Input = {
  data: Duo_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Duo_On_Conflict>;
};

/** on_conflict condition type for table "duo" */
export type Duo_On_Conflict = {
  constraint: Duo_Constraint;
  update_columns?: Array<Duo_Update_Column>;
  where?: InputMaybe<Duo_Bool_Exp>;
};

/** Ordering options when selecting data from "duo". */
export type Duo_Order_By = {
  id?: InputMaybe<Order_By>;
  linked_phone?: InputMaybe<Order_By>;
  phone?: InputMaybe<Phones_Order_By>;
  phone_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  product_name?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Subscriptions_Order_By>;
  subscription_uuid?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
};

/** primary key columns input for table: duo */
export type Duo_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "duo" */
export enum Duo_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LinkedPhone = 'linked_phone',
  /** column name */
  PhoneId = 'phone_id',
  /** column name */
  ProductName = 'product_name',
  /** column name */
  SubscriptionUuid = 'subscription_uuid',
  /** column name */
  VerificationCode = 'verification_code'
}

/** input type for updating data in table "duo" */
export type Duo_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  linked_phone?: InputMaybe<Scalars['String']>;
  phone_id?: InputMaybe<Scalars['Int']>;
  product_name?: InputMaybe<Scalars['String']>;
  subscription_uuid?: InputMaybe<Scalars['uuid']>;
  verification_code?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Duo_Stddev_Fields = {
  __typename?: 'duo_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  phone_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "duo" */
export type Duo_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  phone_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Duo_Stddev_Pop_Fields = {
  __typename?: 'duo_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  phone_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "duo" */
export type Duo_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  phone_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Duo_Stddev_Samp_Fields = {
  __typename?: 'duo_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  phone_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "duo" */
export type Duo_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  phone_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "duo" */
export type Duo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Duo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Duo_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  linked_phone?: InputMaybe<Scalars['String']>;
  phone_id?: InputMaybe<Scalars['Int']>;
  product_name?: InputMaybe<Scalars['String']>;
  subscription_uuid?: InputMaybe<Scalars['uuid']>;
  verification_code?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Duo_Sum_Fields = {
  __typename?: 'duo_sum_fields';
  id?: Maybe<Scalars['Int']>;
  phone_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "duo" */
export type Duo_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  phone_id?: InputMaybe<Order_By>;
};

/** update columns of table "duo" */
export enum Duo_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LinkedPhone = 'linked_phone',
  /** column name */
  PhoneId = 'phone_id',
  /** column name */
  ProductName = 'product_name',
  /** column name */
  SubscriptionUuid = 'subscription_uuid',
  /** column name */
  VerificationCode = 'verification_code'
}

export type Duo_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Duo_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Duo_Set_Input>;
  /** filter the rows which have to be updated */
  where: Duo_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Duo_Var_Pop_Fields = {
  __typename?: 'duo_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  phone_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "duo" */
export type Duo_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  phone_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Duo_Var_Samp_Fields = {
  __typename?: 'duo_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  phone_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "duo" */
export type Duo_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  phone_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Duo_Variance_Fields = {
  __typename?: 'duo_variance_fields';
  id?: Maybe<Scalars['Float']>;
  phone_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "duo" */
export type Duo_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  phone_id?: InputMaybe<Order_By>;
};

export type ForgotPasswordOutput = {
  __typename?: 'forgotPasswordOutput';
  message: Scalars['String'];
};

export type GetInvoicesOutput = {
  __typename?: 'getInvoicesOutput';
  advance_fee?: Maybe<Scalars['String']>;
  advance_fee_cents?: Maybe<Scalars['Int']>;
  authorized_at?: Maybe<Scalars['String']>;
  authorized_at_iso?: Maybe<Scalars['String']>;
  bank_slip?: Maybe<Scalars['String']>;
  canceled_at?: Maybe<Scalars['String']>;
  canceled_at_iso?: Maybe<Scalars['String']>;
  cc_emails?: Maybe<Scalars['String']>;
  chargeback_at?: Maybe<Scalars['String']>;
  chargeback_at_iso?: Maybe<Scalars['String']>;
  commission?: Maybe<Scalars['String']>;
  commission_cents?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  created_at_iso?: Maybe<Scalars['String']>;
  credit_card_bin?: Maybe<Scalars['String']>;
  credit_card_brand?: Maybe<Scalars['String']>;
  credit_card_captured_at?: Maybe<Scalars['String']>;
  credit_card_last_4?: Maybe<Scalars['String']>;
  credit_card_tid?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  custom_variables?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  customer_ref?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['String']>;
  discount_cents?: Maybe<Scalars['String']>;
  double_payment_id?: Maybe<Scalars['String']>;
  due_date: Scalars['String'];
  early_payment_discount?: Maybe<Scalars['String']>;
  early_payment_discounts?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expiration_url?: Maybe<Scalars['String']>;
  expired_at?: Maybe<Scalars['String']>;
  expired_at_iso?: Maybe<Scalars['String']>;
  external_reference?: Maybe<Scalars['String']>;
  financial_return_date?: Maybe<Scalars['String']>;
  financial_return_dates?: Maybe<Scalars['String']>;
  fines_on_occurrence_day: Scalars['String'];
  fines_on_occurrence_day_cents: Scalars['Int'];
  first_item_description: Scalars['String'];
  id: Scalars['String'];
  ignore_canceled_email?: Maybe<Scalars['String']>;
  ignore_due_email?: Maybe<Scalars['String']>;
  installments?: Maybe<Scalars['String']>;
  interest?: Maybe<Scalars['String']>;
  items?: Maybe<Scalars['String']>;
  logs?: Maybe<Scalars['String']>;
  max_installments_value?: Maybe<Scalars['String']>;
  notification_url?: Maybe<Scalars['String']>;
  occurrence_date?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['String']>;
  original_payment_id?: Maybe<Scalars['String']>;
  overpaid_cents?: Maybe<Scalars['Int']>;
  paid: Scalars['String'];
  paid_at?: Maybe<Scalars['String']>;
  paid_cents?: Maybe<Scalars['Int']>;
  payable_with?: Maybe<Scalars['String']>;
  payer_address_city?: Maybe<Scalars['String']>;
  payer_address_complement?: Maybe<Scalars['String']>;
  payer_address_country?: Maybe<Scalars['String']>;
  payer_address_district?: Maybe<Scalars['String']>;
  payer_address_number?: Maybe<Scalars['String']>;
  payer_address_state?: Maybe<Scalars['String']>;
  payer_address_street?: Maybe<Scalars['String']>;
  payer_address_zip_code?: Maybe<Scalars['String']>;
  payer_cpf_cnpj?: Maybe<Scalars['String']>;
  payer_email?: Maybe<Scalars['String']>;
  payer_name?: Maybe<Scalars['String']>;
  payer_phone?: Maybe<Scalars['String']>;
  payer_phone_prefix?: Maybe<Scalars['String']>;
  payment_method?: Maybe<Scalars['String']>;
  per_day_interest?: Maybe<Scalars['Boolean']>;
  per_day_interest_value?: Maybe<Scalars['String']>;
  protested_at?: Maybe<Scalars['String']>;
  protested_at_iso?: Maybe<Scalars['String']>;
  refundable?: Maybe<Scalars['String']>;
  refunded_at?: Maybe<Scalars['String']>;
  refunded_at_iso?: Maybe<Scalars['String']>;
  refunded_cents?: Maybe<Scalars['Int']>;
  remaining_captured_cents?: Maybe<Scalars['Int']>;
  return_url?: Maybe<Scalars['String']>;
  secure_id?: Maybe<Scalars['String']>;
  secure_url?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tax_cents?: Maybe<Scalars['String']>;
  taxes_paid?: Maybe<Scalars['String']>;
  taxes_paid_cents?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['String']>;
  total_cents?: Maybe<Scalars['Int']>;
  total_on_occurrence_day: Scalars['String'];
  total_on_occurrence_day_cents: Scalars['Int'];
  total_overpaid?: Maybe<Scalars['String']>;
  total_paid: Scalars['String'];
  total_paid_cents: Scalars['Int'];
  total_refunded?: Maybe<Scalars['String']>;
  transaction_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  variables?: Maybe<Scalars['String']>;
};

export type GetSubscriptionsOutput = {
  __typename?: 'getSubscriptionsOutput';
  active?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['String']>;
  credits?: Maybe<Scalars['Int']>;
  credits_based?: Maybe<Scalars['Int']>;
  credits_cycle?: Maybe<Scalars['Int']>;
  credits_min?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  customer_email?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  customer_ref?: Maybe<Scalars['String']>;
  cycled_at?: Maybe<Scalars['String']>;
  cycles_count?: Maybe<Scalars['Int']>;
  expires_at?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ignore_due_email?: Maybe<Scalars['Boolean']>;
  in_trial?: Maybe<Scalars['Boolean']>;
  invoice_due_date?: Maybe<Scalars['String']>;
  invoice_id?: Maybe<Scalars['String']>;
  invoice_secure_url?: Maybe<Scalars['String']>;
  invoice_status?: Maybe<Scalars['String']>;
  invoice_total?: Maybe<Scalars['String']>;
  max_cycles?: Maybe<Scalars['Int']>;
  payable_with?: Maybe<Scalars['String']>;
  plan_identifier?: Maybe<Scalars['String']>;
  plan_name?: Maybe<Scalars['String']>;
  plan_ref?: Maybe<Scalars['String']>;
  price_cents?: Maybe<Scalars['Int']>;
  subscription?: Maybe<Subscriptions>;
  suspend_on_invoice_expired?: Maybe<Scalars['Boolean']>;
  suspended?: Maybe<Scalars['Boolean']>;
  two_step?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['String']>;
  users?: Maybe<Users>;
};

/** columns and relationships of "groups" */
export type Groups = {
  __typename?: 'groups';
  data: Scalars['jsonb'];
  /** An array relationship */
  groups_users: Array<Groups_Users>;
  /** An aggregate relationship */
  groups_users_aggregate: Groups_Users_Aggregate;
  id: Scalars['Int'];
  name: Scalars['String'];
  parent_group_id: Scalars['Int'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int'];
};


/** columns and relationships of "groups" */
export type GroupsDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "groups" */
export type GroupsGroups_UsersArgs = {
  distinct_on?: InputMaybe<Array<Groups_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Users_Order_By>>;
  where?: InputMaybe<Groups_Users_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsGroups_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Groups_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Users_Order_By>>;
  where?: InputMaybe<Groups_Users_Bool_Exp>;
};

/** aggregated selection of "groups" */
export type Groups_Aggregate = {
  __typename?: 'groups_aggregate';
  aggregate?: Maybe<Groups_Aggregate_Fields>;
  nodes: Array<Groups>;
};

export type Groups_Aggregate_Bool_Exp = {
  count?: InputMaybe<Groups_Aggregate_Bool_Exp_Count>;
};

export type Groups_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Groups_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "groups" */
export type Groups_Aggregate_Fields = {
  __typename?: 'groups_aggregate_fields';
  avg?: Maybe<Groups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Groups_Max_Fields>;
  min?: Maybe<Groups_Min_Fields>;
  stddev?: Maybe<Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Groups_Sum_Fields>;
  var_pop?: Maybe<Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Groups_Var_Samp_Fields>;
  variance?: Maybe<Groups_Variance_Fields>;
};


/** aggregate fields of "groups" */
export type Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "groups" */
export type Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Groups_Max_Order_By>;
  min?: InputMaybe<Groups_Min_Order_By>;
  stddev?: InputMaybe<Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Groups_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Groups_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "groups" */
export type Groups_Arr_Rel_Insert_Input = {
  data: Array<Groups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Groups_On_Conflict>;
};

/** aggregate avg on columns */
export type Groups_Avg_Fields = {
  __typename?: 'groups_avg_fields';
  id?: Maybe<Scalars['Float']>;
  parent_group_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "groups" */
export type Groups_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_group_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "groups". All fields are combined with a logical 'AND'. */
export type Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Groups_Bool_Exp>>;
  _not?: InputMaybe<Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Groups_Bool_Exp>>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  groups_users?: InputMaybe<Groups_Users_Bool_Exp>;
  groups_users_aggregate?: InputMaybe<Groups_Users_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent_group_id?: InputMaybe<Int_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "groups" */
export enum Groups_Constraint {
  /** unique or primary key constraint on columns "id" */
  GroupsPkey = 'groups_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Groups_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Groups_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Groups_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "groups" */
export type Groups_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  parent_group_id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "groups" */
export type Groups_Insert_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  groups_users?: InputMaybe<Groups_Users_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  parent_group_id?: InputMaybe<Scalars['Int']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Groups_Max_Fields = {
  __typename?: 'groups_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_group_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "groups" */
export type Groups_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_group_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Groups_Min_Fields = {
  __typename?: 'groups_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_group_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "groups" */
export type Groups_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_group_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "groups" */
export type Groups_Mutation_Response = {
  __typename?: 'groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Groups>;
};

/** input type for inserting object relation for remote table "groups" */
export type Groups_Obj_Rel_Insert_Input = {
  data: Groups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Groups_On_Conflict>;
};

/** on_conflict condition type for table "groups" */
export type Groups_On_Conflict = {
  constraint: Groups_Constraint;
  update_columns?: Array<Groups_Update_Column>;
  where?: InputMaybe<Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "groups". */
export type Groups_Order_By = {
  data?: InputMaybe<Order_By>;
  groups_users_aggregate?: InputMaybe<Groups_Users_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_group_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: groups */
export type Groups_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Groups_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "groups" */
export enum Groups_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentGroupId = 'parent_group_id',
  /** column name */
  TeamId = 'team_id'
}

/** input type for updating data in table "groups" */
export type Groups_Set_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  parent_group_id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Groups_Stddev_Fields = {
  __typename?: 'groups_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  parent_group_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "groups" */
export type Groups_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_group_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Groups_Stddev_Pop_Fields = {
  __typename?: 'groups_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  parent_group_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "groups" */
export type Groups_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_group_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Groups_Stddev_Samp_Fields = {
  __typename?: 'groups_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  parent_group_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "groups" */
export type Groups_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_group_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "groups" */
export type Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Groups_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  parent_group_id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Groups_Sum_Fields = {
  __typename?: 'groups_sum_fields';
  id?: Maybe<Scalars['Int']>;
  parent_group_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "groups" */
export type Groups_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_group_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "groups" */
export enum Groups_Update_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentGroupId = 'parent_group_id',
  /** column name */
  TeamId = 'team_id'
}

export type Groups_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Groups_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Groups_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Groups_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Groups_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Groups_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Groups_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Groups_Set_Input>;
  /** filter the rows which have to be updated */
  where: Groups_Bool_Exp;
};

/** columns and relationships of "groups_users" */
export type Groups_Users = {
  __typename?: 'groups_users';
  /** An object relationship */
  group: Groups;
  group_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
};

/** aggregated selection of "groups_users" */
export type Groups_Users_Aggregate = {
  __typename?: 'groups_users_aggregate';
  aggregate?: Maybe<Groups_Users_Aggregate_Fields>;
  nodes: Array<Groups_Users>;
};

export type Groups_Users_Aggregate_Bool_Exp = {
  count?: InputMaybe<Groups_Users_Aggregate_Bool_Exp_Count>;
};

export type Groups_Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Groups_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Groups_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "groups_users" */
export type Groups_Users_Aggregate_Fields = {
  __typename?: 'groups_users_aggregate_fields';
  avg?: Maybe<Groups_Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Groups_Users_Max_Fields>;
  min?: Maybe<Groups_Users_Min_Fields>;
  stddev?: Maybe<Groups_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Groups_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Groups_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Groups_Users_Sum_Fields>;
  var_pop?: Maybe<Groups_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Groups_Users_Var_Samp_Fields>;
  variance?: Maybe<Groups_Users_Variance_Fields>;
};


/** aggregate fields of "groups_users" */
export type Groups_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Groups_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "groups_users" */
export type Groups_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Groups_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Groups_Users_Max_Order_By>;
  min?: InputMaybe<Groups_Users_Min_Order_By>;
  stddev?: InputMaybe<Groups_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Groups_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Groups_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Groups_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Groups_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Groups_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Groups_Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "groups_users" */
export type Groups_Users_Arr_Rel_Insert_Input = {
  data: Array<Groups_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Groups_Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Groups_Users_Avg_Fields = {
  __typename?: 'groups_users_avg_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "groups_users" */
export type Groups_Users_Avg_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "groups_users". All fields are combined with a logical 'AND'. */
export type Groups_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Groups_Users_Bool_Exp>>;
  _not?: InputMaybe<Groups_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Groups_Users_Bool_Exp>>;
  group?: InputMaybe<Groups_Bool_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "groups_users" */
export enum Groups_Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  GroupsUsersIdKey = 'groups_users_id_key',
  /** unique or primary key constraint on columns "id" */
  GroupsUsersPkey = 'groups_users_pkey',
  /** unique or primary key constraint on columns "user_id", "group_id" */
  GroupsUsersUserIdGroupIdKey = 'groups_users_user_id_group_id_key'
}

/** input type for incrementing numeric columns in table "groups_users" */
export type Groups_Users_Inc_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "groups_users" */
export type Groups_Users_Insert_Input = {
  group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Groups_Users_Max_Fields = {
  __typename?: 'groups_users_max_fields';
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "groups_users" */
export type Groups_Users_Max_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Groups_Users_Min_Fields = {
  __typename?: 'groups_users_min_fields';
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "groups_users" */
export type Groups_Users_Min_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "groups_users" */
export type Groups_Users_Mutation_Response = {
  __typename?: 'groups_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Groups_Users>;
};

/** on_conflict condition type for table "groups_users" */
export type Groups_Users_On_Conflict = {
  constraint: Groups_Users_Constraint;
  update_columns?: Array<Groups_Users_Update_Column>;
  where?: InputMaybe<Groups_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "groups_users". */
export type Groups_Users_Order_By = {
  group?: InputMaybe<Groups_Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: groups_users */
export type Groups_Users_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "groups_users" */
export enum Groups_Users_Select_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "groups_users" */
export type Groups_Users_Set_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Groups_Users_Stddev_Fields = {
  __typename?: 'groups_users_stddev_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "groups_users" */
export type Groups_Users_Stddev_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Groups_Users_Stddev_Pop_Fields = {
  __typename?: 'groups_users_stddev_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "groups_users" */
export type Groups_Users_Stddev_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Groups_Users_Stddev_Samp_Fields = {
  __typename?: 'groups_users_stddev_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "groups_users" */
export type Groups_Users_Stddev_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "groups_users" */
export type Groups_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Groups_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Groups_Users_Stream_Cursor_Value_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Groups_Users_Sum_Fields = {
  __typename?: 'groups_users_sum_fields';
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "groups_users" */
export type Groups_Users_Sum_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "groups_users" */
export enum Groups_Users_Update_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type Groups_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Groups_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Groups_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Groups_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Groups_Users_Var_Pop_Fields = {
  __typename?: 'groups_users_var_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "groups_users" */
export type Groups_Users_Var_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Groups_Users_Var_Samp_Fields = {
  __typename?: 'groups_users_var_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "groups_users" */
export type Groups_Users_Var_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Groups_Users_Variance_Fields = {
  __typename?: 'groups_users_variance_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "groups_users" */
export type Groups_Users_Variance_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Groups_Var_Pop_Fields = {
  __typename?: 'groups_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  parent_group_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "groups" */
export type Groups_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_group_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Groups_Var_Samp_Fields = {
  __typename?: 'groups_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  parent_group_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "groups" */
export type Groups_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_group_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Groups_Variance_Fields = {
  __typename?: 'groups_variance_fields';
  id?: Maybe<Scalars['Float']>;
  parent_group_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "groups" */
export type Groups_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_group_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "interval". All fields are combined with logical 'AND'. */
export type Interval_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['interval']>;
  _gt?: InputMaybe<Scalars['interval']>;
  _gte?: InputMaybe<Scalars['interval']>;
  _in?: InputMaybe<Array<Scalars['interval']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['interval']>;
  _lte?: InputMaybe<Scalars['interval']>;
  _neq?: InputMaybe<Scalars['interval']>;
  _nin?: InputMaybe<Array<Scalars['interval']>>;
};

/** columns and relationships of "invite_rules" */
export type Invite_Rules = {
  __typename?: 'invite_rules';
  disconnection_period_end?: Maybe<Scalars['timestamp']>;
  disconnection_period_start: Scalars['timestamp'];
  id: Scalars['bigint'];
  invite_time?: Maybe<Scalars['time']>;
  invite_until_accepted: Scalars['Boolean'];
  is_default: Scalars['Boolean'];
  is_disabled: Scalars['Boolean'];
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['bigint']>;
  unit: Scalars['unit_type'];
};

/** aggregated selection of "invite_rules" */
export type Invite_Rules_Aggregate = {
  __typename?: 'invite_rules_aggregate';
  aggregate?: Maybe<Invite_Rules_Aggregate_Fields>;
  nodes: Array<Invite_Rules>;
};

/** aggregate fields of "invite_rules" */
export type Invite_Rules_Aggregate_Fields = {
  __typename?: 'invite_rules_aggregate_fields';
  avg?: Maybe<Invite_Rules_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Invite_Rules_Max_Fields>;
  min?: Maybe<Invite_Rules_Min_Fields>;
  stddev?: Maybe<Invite_Rules_Stddev_Fields>;
  stddev_pop?: Maybe<Invite_Rules_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invite_Rules_Stddev_Samp_Fields>;
  sum?: Maybe<Invite_Rules_Sum_Fields>;
  var_pop?: Maybe<Invite_Rules_Var_Pop_Fields>;
  var_samp?: Maybe<Invite_Rules_Var_Samp_Fields>;
  variance?: Maybe<Invite_Rules_Variance_Fields>;
};


/** aggregate fields of "invite_rules" */
export type Invite_Rules_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invite_Rules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Invite_Rules_Avg_Fields = {
  __typename?: 'invite_rules_avg_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "invite_rules". All fields are combined with a logical 'AND'. */
export type Invite_Rules_Bool_Exp = {
  _and?: InputMaybe<Array<Invite_Rules_Bool_Exp>>;
  _not?: InputMaybe<Invite_Rules_Bool_Exp>;
  _or?: InputMaybe<Array<Invite_Rules_Bool_Exp>>;
  disconnection_period_end?: InputMaybe<Timestamp_Comparison_Exp>;
  disconnection_period_start?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  invite_time?: InputMaybe<Time_Comparison_Exp>;
  invite_until_accepted?: InputMaybe<Boolean_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  is_disabled?: InputMaybe<Boolean_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Bigint_Comparison_Exp>;
  unit?: InputMaybe<Unit_Type_Comparison_Exp>;
};

/** unique or primary key constraints on table "invite_rules" */
export enum Invite_Rules_Constraint {
  /** unique or primary key constraint on columns "id" */
  InviteRulesPkey = 'invite_rules_pkey'
}

/** input type for incrementing numeric columns in table "invite_rules" */
export type Invite_Rules_Inc_Input = {
  team_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "invite_rules" */
export type Invite_Rules_Insert_Input = {
  disconnection_period_end?: InputMaybe<Scalars['timestamp']>;
  disconnection_period_start?: InputMaybe<Scalars['timestamp']>;
  invite_time?: InputMaybe<Scalars['time']>;
  invite_until_accepted?: InputMaybe<Scalars['Boolean']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  is_disabled?: InputMaybe<Scalars['Boolean']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['bigint']>;
  unit?: InputMaybe<Scalars['unit_type']>;
};

/** aggregate max on columns */
export type Invite_Rules_Max_Fields = {
  __typename?: 'invite_rules_max_fields';
  disconnection_period_end?: Maybe<Scalars['timestamp']>;
  disconnection_period_start?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['bigint']>;
  team_id?: Maybe<Scalars['bigint']>;
  unit?: Maybe<Scalars['unit_type']>;
};

/** aggregate min on columns */
export type Invite_Rules_Min_Fields = {
  __typename?: 'invite_rules_min_fields';
  disconnection_period_end?: Maybe<Scalars['timestamp']>;
  disconnection_period_start?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['bigint']>;
  team_id?: Maybe<Scalars['bigint']>;
  unit?: Maybe<Scalars['unit_type']>;
};

/** response of any mutation on the table "invite_rules" */
export type Invite_Rules_Mutation_Response = {
  __typename?: 'invite_rules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invite_Rules>;
};

/** on_conflict condition type for table "invite_rules" */
export type Invite_Rules_On_Conflict = {
  constraint: Invite_Rules_Constraint;
  update_columns?: Array<Invite_Rules_Update_Column>;
  where?: InputMaybe<Invite_Rules_Bool_Exp>;
};

/** Ordering options when selecting data from "invite_rules". */
export type Invite_Rules_Order_By = {
  disconnection_period_end?: InputMaybe<Order_By>;
  disconnection_period_start?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite_time?: InputMaybe<Order_By>;
  invite_until_accepted?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  is_disabled?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invite_rules */
export type Invite_Rules_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** columns and relationships of "invite_rules_recipients" */
export type Invite_Rules_Recipients = {
  __typename?: 'invite_rules_recipients';
  id: Scalars['bigint'];
  invite_rule_id?: Maybe<Scalars['bigint']>;
  send_to: Scalars['String'];
  template: Scalars['String'];
};

/** aggregated selection of "invite_rules_recipients" */
export type Invite_Rules_Recipients_Aggregate = {
  __typename?: 'invite_rules_recipients_aggregate';
  aggregate?: Maybe<Invite_Rules_Recipients_Aggregate_Fields>;
  nodes: Array<Invite_Rules_Recipients>;
};

/** aggregate fields of "invite_rules_recipients" */
export type Invite_Rules_Recipients_Aggregate_Fields = {
  __typename?: 'invite_rules_recipients_aggregate_fields';
  avg?: Maybe<Invite_Rules_Recipients_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Invite_Rules_Recipients_Max_Fields>;
  min?: Maybe<Invite_Rules_Recipients_Min_Fields>;
  stddev?: Maybe<Invite_Rules_Recipients_Stddev_Fields>;
  stddev_pop?: Maybe<Invite_Rules_Recipients_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invite_Rules_Recipients_Stddev_Samp_Fields>;
  sum?: Maybe<Invite_Rules_Recipients_Sum_Fields>;
  var_pop?: Maybe<Invite_Rules_Recipients_Var_Pop_Fields>;
  var_samp?: Maybe<Invite_Rules_Recipients_Var_Samp_Fields>;
  variance?: Maybe<Invite_Rules_Recipients_Variance_Fields>;
};


/** aggregate fields of "invite_rules_recipients" */
export type Invite_Rules_Recipients_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invite_Rules_Recipients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Invite_Rules_Recipients_Avg_Fields = {
  __typename?: 'invite_rules_recipients_avg_fields';
  id?: Maybe<Scalars['Float']>;
  invite_rule_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "invite_rules_recipients". All fields are combined with a logical 'AND'. */
export type Invite_Rules_Recipients_Bool_Exp = {
  _and?: InputMaybe<Array<Invite_Rules_Recipients_Bool_Exp>>;
  _not?: InputMaybe<Invite_Rules_Recipients_Bool_Exp>;
  _or?: InputMaybe<Array<Invite_Rules_Recipients_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  invite_rule_id?: InputMaybe<Bigint_Comparison_Exp>;
  send_to?: InputMaybe<String_Comparison_Exp>;
  template?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "invite_rules_recipients" */
export enum Invite_Rules_Recipients_Constraint {
  /** unique or primary key constraint on columns "id" */
  InviteRulesRecipientsPkey = 'invite_rules_recipients_pkey'
}

/** input type for incrementing numeric columns in table "invite_rules_recipients" */
export type Invite_Rules_Recipients_Inc_Input = {
  invite_rule_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "invite_rules_recipients" */
export type Invite_Rules_Recipients_Insert_Input = {
  invite_rule_id?: InputMaybe<Scalars['bigint']>;
  send_to?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Invite_Rules_Recipients_Max_Fields = {
  __typename?: 'invite_rules_recipients_max_fields';
  id?: Maybe<Scalars['bigint']>;
  invite_rule_id?: Maybe<Scalars['bigint']>;
  send_to?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Invite_Rules_Recipients_Min_Fields = {
  __typename?: 'invite_rules_recipients_min_fields';
  id?: Maybe<Scalars['bigint']>;
  invite_rule_id?: Maybe<Scalars['bigint']>;
  send_to?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "invite_rules_recipients" */
export type Invite_Rules_Recipients_Mutation_Response = {
  __typename?: 'invite_rules_recipients_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invite_Rules_Recipients>;
};

/** on_conflict condition type for table "invite_rules_recipients" */
export type Invite_Rules_Recipients_On_Conflict = {
  constraint: Invite_Rules_Recipients_Constraint;
  update_columns?: Array<Invite_Rules_Recipients_Update_Column>;
  where?: InputMaybe<Invite_Rules_Recipients_Bool_Exp>;
};

/** Ordering options when selecting data from "invite_rules_recipients". */
export type Invite_Rules_Recipients_Order_By = {
  id?: InputMaybe<Order_By>;
  invite_rule_id?: InputMaybe<Order_By>;
  send_to?: InputMaybe<Order_By>;
  template?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invite_rules_recipients */
export type Invite_Rules_Recipients_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "invite_rules_recipients" */
export enum Invite_Rules_Recipients_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InviteRuleId = 'invite_rule_id',
  /** column name */
  SendTo = 'send_to',
  /** column name */
  Template = 'template'
}

/** input type for updating data in table "invite_rules_recipients" */
export type Invite_Rules_Recipients_Set_Input = {
  invite_rule_id?: InputMaybe<Scalars['bigint']>;
  send_to?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Invite_Rules_Recipients_Stddev_Fields = {
  __typename?: 'invite_rules_recipients_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  invite_rule_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Invite_Rules_Recipients_Stddev_Pop_Fields = {
  __typename?: 'invite_rules_recipients_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  invite_rule_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Invite_Rules_Recipients_Stddev_Samp_Fields = {
  __typename?: 'invite_rules_recipients_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  invite_rule_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "invite_rules_recipients" */
export type Invite_Rules_Recipients_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invite_Rules_Recipients_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invite_Rules_Recipients_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  invite_rule_id?: InputMaybe<Scalars['bigint']>;
  send_to?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Invite_Rules_Recipients_Sum_Fields = {
  __typename?: 'invite_rules_recipients_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  invite_rule_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "invite_rules_recipients" */
export enum Invite_Rules_Recipients_Update_Column {
  /** column name */
  InviteRuleId = 'invite_rule_id',
  /** column name */
  SendTo = 'send_to',
  /** column name */
  Template = 'template'
}

export type Invite_Rules_Recipients_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Invite_Rules_Recipients_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invite_Rules_Recipients_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invite_Rules_Recipients_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invite_Rules_Recipients_Var_Pop_Fields = {
  __typename?: 'invite_rules_recipients_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  invite_rule_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Invite_Rules_Recipients_Var_Samp_Fields = {
  __typename?: 'invite_rules_recipients_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  invite_rule_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Invite_Rules_Recipients_Variance_Fields = {
  __typename?: 'invite_rules_recipients_variance_fields';
  id?: Maybe<Scalars['Float']>;
  invite_rule_id?: Maybe<Scalars['Float']>;
};

/** select columns of table "invite_rules" */
export enum Invite_Rules_Select_Column {
  /** column name */
  DisconnectionPeriodEnd = 'disconnection_period_end',
  /** column name */
  DisconnectionPeriodStart = 'disconnection_period_start',
  /** column name */
  Id = 'id',
  /** column name */
  InviteTime = 'invite_time',
  /** column name */
  InviteUntilAccepted = 'invite_until_accepted',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  IsDisabled = 'is_disabled',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Unit = 'unit'
}

/** input type for updating data in table "invite_rules" */
export type Invite_Rules_Set_Input = {
  disconnection_period_end?: InputMaybe<Scalars['timestamp']>;
  disconnection_period_start?: InputMaybe<Scalars['timestamp']>;
  invite_time?: InputMaybe<Scalars['time']>;
  invite_until_accepted?: InputMaybe<Scalars['Boolean']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  is_disabled?: InputMaybe<Scalars['Boolean']>;
  team_id?: InputMaybe<Scalars['bigint']>;
  unit?: InputMaybe<Scalars['unit_type']>;
};

/** aggregate stddev on columns */
export type Invite_Rules_Stddev_Fields = {
  __typename?: 'invite_rules_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Invite_Rules_Stddev_Pop_Fields = {
  __typename?: 'invite_rules_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Invite_Rules_Stddev_Samp_Fields = {
  __typename?: 'invite_rules_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "invite_rules" */
export type Invite_Rules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invite_Rules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invite_Rules_Stream_Cursor_Value_Input = {
  disconnection_period_end?: InputMaybe<Scalars['timestamp']>;
  disconnection_period_start?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['bigint']>;
  invite_time?: InputMaybe<Scalars['time']>;
  invite_until_accepted?: InputMaybe<Scalars['Boolean']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  is_disabled?: InputMaybe<Scalars['Boolean']>;
  team_id?: InputMaybe<Scalars['bigint']>;
  unit?: InputMaybe<Scalars['unit_type']>;
};

/** aggregate sum on columns */
export type Invite_Rules_Sum_Fields = {
  __typename?: 'invite_rules_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  team_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "invite_rules" */
export enum Invite_Rules_Update_Column {
  /** column name */
  DisconnectionPeriodEnd = 'disconnection_period_end',
  /** column name */
  DisconnectionPeriodStart = 'disconnection_period_start',
  /** column name */
  InviteTime = 'invite_time',
  /** column name */
  InviteUntilAccepted = 'invite_until_accepted',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  IsDisabled = 'is_disabled',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Unit = 'unit'
}

export type Invite_Rules_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Invite_Rules_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invite_Rules_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invite_Rules_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invite_Rules_Var_Pop_Fields = {
  __typename?: 'invite_rules_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Invite_Rules_Var_Samp_Fields = {
  __typename?: 'invite_rules_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Invite_Rules_Variance_Fields = {
  __typename?: 'invite_rules_variance_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "license_records" */
export type License_Records = {
  __typename?: 'license_records';
  compliance_id: Scalars['Int'];
  date: Scalars['date'];
  extra: Scalars['Int'];
  id: Scalars['Int'];
  licenses: Scalars['Int'];
  timestamp?: Maybe<Scalars['timestamp']>;
};

/** aggregated selection of "license_records" */
export type License_Records_Aggregate = {
  __typename?: 'license_records_aggregate';
  aggregate?: Maybe<License_Records_Aggregate_Fields>;
  nodes: Array<License_Records>;
};

/** aggregate fields of "license_records" */
export type License_Records_Aggregate_Fields = {
  __typename?: 'license_records_aggregate_fields';
  avg?: Maybe<License_Records_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<License_Records_Max_Fields>;
  min?: Maybe<License_Records_Min_Fields>;
  stddev?: Maybe<License_Records_Stddev_Fields>;
  stddev_pop?: Maybe<License_Records_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<License_Records_Stddev_Samp_Fields>;
  sum?: Maybe<License_Records_Sum_Fields>;
  var_pop?: Maybe<License_Records_Var_Pop_Fields>;
  var_samp?: Maybe<License_Records_Var_Samp_Fields>;
  variance?: Maybe<License_Records_Variance_Fields>;
};


/** aggregate fields of "license_records" */
export type License_Records_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<License_Records_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type License_Records_Avg_Fields = {
  __typename?: 'license_records_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  extra?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  licenses?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "license_records". All fields are combined with a logical 'AND'. */
export type License_Records_Bool_Exp = {
  _and?: InputMaybe<Array<License_Records_Bool_Exp>>;
  _not?: InputMaybe<License_Records_Bool_Exp>;
  _or?: InputMaybe<Array<License_Records_Bool_Exp>>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  extra?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  licenses?: InputMaybe<Int_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "license_records" */
export enum License_Records_Constraint {
  /** unique or primary key constraint on columns "date", "compliance_id" */
  LicenseRecordsComplianceIdDateKey = 'license_records_compliance_id_date_key',
  /** unique or primary key constraint on columns "id" */
  LicenseRecordsPkey = 'license_records_pkey'
}

/** input type for incrementing numeric columns in table "license_records" */
export type License_Records_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  extra?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  licenses?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "license_records" */
export type License_Records_Insert_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  extra?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  licenses?: InputMaybe<Scalars['Int']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type License_Records_Max_Fields = {
  __typename?: 'license_records_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  extra?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  licenses?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type License_Records_Min_Fields = {
  __typename?: 'license_records_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  extra?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  licenses?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "license_records" */
export type License_Records_Mutation_Response = {
  __typename?: 'license_records_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<License_Records>;
};

/** on_conflict condition type for table "license_records" */
export type License_Records_On_Conflict = {
  constraint: License_Records_Constraint;
  update_columns?: Array<License_Records_Update_Column>;
  where?: InputMaybe<License_Records_Bool_Exp>;
};

/** Ordering options when selecting data from "license_records". */
export type License_Records_Order_By = {
  compliance_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  licenses?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: license_records */
export type License_Records_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "license_records" */
export enum License_Records_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  Date = 'date',
  /** column name */
  Extra = 'extra',
  /** column name */
  Id = 'id',
  /** column name */
  Licenses = 'licenses',
  /** column name */
  Timestamp = 'timestamp'
}

/** input type for updating data in table "license_records" */
export type License_Records_Set_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  extra?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  licenses?: InputMaybe<Scalars['Int']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type License_Records_Stddev_Fields = {
  __typename?: 'license_records_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  extra?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  licenses?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type License_Records_Stddev_Pop_Fields = {
  __typename?: 'license_records_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  extra?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  licenses?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type License_Records_Stddev_Samp_Fields = {
  __typename?: 'license_records_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  extra?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  licenses?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "license_records" */
export type License_Records_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: License_Records_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type License_Records_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  extra?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  licenses?: InputMaybe<Scalars['Int']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type License_Records_Sum_Fields = {
  __typename?: 'license_records_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  extra?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  licenses?: Maybe<Scalars['Int']>;
};

/** update columns of table "license_records" */
export enum License_Records_Update_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  Date = 'date',
  /** column name */
  Extra = 'extra',
  /** column name */
  Id = 'id',
  /** column name */
  Licenses = 'licenses',
  /** column name */
  Timestamp = 'timestamp'
}

export type License_Records_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<License_Records_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<License_Records_Set_Input>;
  /** filter the rows which have to be updated */
  where: License_Records_Bool_Exp;
};

/** aggregate var_pop on columns */
export type License_Records_Var_Pop_Fields = {
  __typename?: 'license_records_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  extra?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  licenses?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type License_Records_Var_Samp_Fields = {
  __typename?: 'license_records_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  extra?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  licenses?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type License_Records_Variance_Fields = {
  __typename?: 'license_records_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  extra?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  licenses?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "link" */
export type Link = {
  __typename?: 'link';
  domain_id: Scalars['String'];
  id: Scalars['Int'];
  /** An object relationship */
  link_domain: Link_Domains;
  phone?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  /** An object relationship */
  subscription: Subscriptions;
  subscription_uuid: Scalars['uuid'];
};

/** aggregated selection of "link" */
export type Link_Aggregate = {
  __typename?: 'link_aggregate';
  aggregate?: Maybe<Link_Aggregate_Fields>;
  nodes: Array<Link>;
};

export type Link_Aggregate_Bool_Exp = {
  count?: InputMaybe<Link_Aggregate_Bool_Exp_Count>;
};

export type Link_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Link_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Link_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "link" */
export type Link_Aggregate_Fields = {
  __typename?: 'link_aggregate_fields';
  avg?: Maybe<Link_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Link_Max_Fields>;
  min?: Maybe<Link_Min_Fields>;
  stddev?: Maybe<Link_Stddev_Fields>;
  stddev_pop?: Maybe<Link_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Link_Stddev_Samp_Fields>;
  sum?: Maybe<Link_Sum_Fields>;
  var_pop?: Maybe<Link_Var_Pop_Fields>;
  var_samp?: Maybe<Link_Var_Samp_Fields>;
  variance?: Maybe<Link_Variance_Fields>;
};


/** aggregate fields of "link" */
export type Link_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Link_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "link" */
export type Link_Aggregate_Order_By = {
  avg?: InputMaybe<Link_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Link_Max_Order_By>;
  min?: InputMaybe<Link_Min_Order_By>;
  stddev?: InputMaybe<Link_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Link_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Link_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Link_Sum_Order_By>;
  var_pop?: InputMaybe<Link_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Link_Var_Samp_Order_By>;
  variance?: InputMaybe<Link_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "link" */
export type Link_Arr_Rel_Insert_Input = {
  data: Array<Link_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Link_On_Conflict>;
};

/** aggregate avg on columns */
export type Link_Avg_Fields = {
  __typename?: 'link_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "link" */
export type Link_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "link". All fields are combined with a logical 'AND'. */
export type Link_Bool_Exp = {
  _and?: InputMaybe<Array<Link_Bool_Exp>>;
  _not?: InputMaybe<Link_Bool_Exp>;
  _or?: InputMaybe<Array<Link_Bool_Exp>>;
  domain_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  link_domain?: InputMaybe<Link_Domains_Bool_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  subscription?: InputMaybe<Subscriptions_Bool_Exp>;
  subscription_uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "link" */
export enum Link_Constraint {
  /** unique or primary key constraint on columns "id" */
  LinkPkey = 'link_pkey'
}

/** columns and relationships of "link_domains" */
export type Link_Domains = {
  __typename?: 'link_domains';
  id: Scalars['String'];
  /** An array relationship */
  links: Array<Link>;
  /** An aggregate relationship */
  links_aggregate: Link_Aggregate;
  price: Scalars['Int'];
};


/** columns and relationships of "link_domains" */
export type Link_DomainsLinksArgs = {
  distinct_on?: InputMaybe<Array<Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Order_By>>;
  where?: InputMaybe<Link_Bool_Exp>;
};


/** columns and relationships of "link_domains" */
export type Link_DomainsLinks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Order_By>>;
  where?: InputMaybe<Link_Bool_Exp>;
};

/** aggregated selection of "link_domains" */
export type Link_Domains_Aggregate = {
  __typename?: 'link_domains_aggregate';
  aggregate?: Maybe<Link_Domains_Aggregate_Fields>;
  nodes: Array<Link_Domains>;
};

/** aggregate fields of "link_domains" */
export type Link_Domains_Aggregate_Fields = {
  __typename?: 'link_domains_aggregate_fields';
  avg?: Maybe<Link_Domains_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Link_Domains_Max_Fields>;
  min?: Maybe<Link_Domains_Min_Fields>;
  stddev?: Maybe<Link_Domains_Stddev_Fields>;
  stddev_pop?: Maybe<Link_Domains_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Link_Domains_Stddev_Samp_Fields>;
  sum?: Maybe<Link_Domains_Sum_Fields>;
  var_pop?: Maybe<Link_Domains_Var_Pop_Fields>;
  var_samp?: Maybe<Link_Domains_Var_Samp_Fields>;
  variance?: Maybe<Link_Domains_Variance_Fields>;
};


/** aggregate fields of "link_domains" */
export type Link_Domains_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Link_Domains_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Link_Domains_Avg_Fields = {
  __typename?: 'link_domains_avg_fields';
  price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "link_domains". All fields are combined with a logical 'AND'. */
export type Link_Domains_Bool_Exp = {
  _and?: InputMaybe<Array<Link_Domains_Bool_Exp>>;
  _not?: InputMaybe<Link_Domains_Bool_Exp>;
  _or?: InputMaybe<Array<Link_Domains_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  links?: InputMaybe<Link_Bool_Exp>;
  links_aggregate?: InputMaybe<Link_Aggregate_Bool_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "link_domains" */
export enum Link_Domains_Constraint {
  /** unique or primary key constraint on columns "id" */
  LinkDomainsPkey = 'link_domains_pkey'
}

/** input type for incrementing numeric columns in table "link_domains" */
export type Link_Domains_Inc_Input = {
  price?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "link_domains" */
export type Link_Domains_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<Link_Arr_Rel_Insert_Input>;
  price?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Link_Domains_Max_Fields = {
  __typename?: 'link_domains_max_fields';
  id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Link_Domains_Min_Fields = {
  __typename?: 'link_domains_min_fields';
  id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "link_domains" */
export type Link_Domains_Mutation_Response = {
  __typename?: 'link_domains_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Link_Domains>;
};

/** input type for inserting object relation for remote table "link_domains" */
export type Link_Domains_Obj_Rel_Insert_Input = {
  data: Link_Domains_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Link_Domains_On_Conflict>;
};

/** on_conflict condition type for table "link_domains" */
export type Link_Domains_On_Conflict = {
  constraint: Link_Domains_Constraint;
  update_columns?: Array<Link_Domains_Update_Column>;
  where?: InputMaybe<Link_Domains_Bool_Exp>;
};

/** Ordering options when selecting data from "link_domains". */
export type Link_Domains_Order_By = {
  id?: InputMaybe<Order_By>;
  links_aggregate?: InputMaybe<Link_Aggregate_Order_By>;
  price?: InputMaybe<Order_By>;
};

/** primary key columns input for table: link_domains */
export type Link_Domains_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "link_domains" */
export enum Link_Domains_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price'
}

/** input type for updating data in table "link_domains" */
export type Link_Domains_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Link_Domains_Stddev_Fields = {
  __typename?: 'link_domains_stddev_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Link_Domains_Stddev_Pop_Fields = {
  __typename?: 'link_domains_stddev_pop_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Link_Domains_Stddev_Samp_Fields = {
  __typename?: 'link_domains_stddev_samp_fields';
  price?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "link_domains" */
export type Link_Domains_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Link_Domains_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Link_Domains_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Link_Domains_Sum_Fields = {
  __typename?: 'link_domains_sum_fields';
  price?: Maybe<Scalars['Int']>;
};

/** update columns of table "link_domains" */
export enum Link_Domains_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price'
}

export type Link_Domains_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Link_Domains_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Link_Domains_Set_Input>;
  /** filter the rows which have to be updated */
  where: Link_Domains_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Link_Domains_Var_Pop_Fields = {
  __typename?: 'link_domains_var_pop_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Link_Domains_Var_Samp_Fields = {
  __typename?: 'link_domains_var_samp_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Link_Domains_Variance_Fields = {
  __typename?: 'link_domains_variance_fields';
  price?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "link" */
export type Link_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "link" */
export type Link_Insert_Input = {
  domain_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  link_domain?: InputMaybe<Link_Domains_Obj_Rel_Insert_Input>;
  phone?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<Subscriptions_Obj_Rel_Insert_Input>;
  subscription_uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Link_Max_Fields = {
  __typename?: 'link_max_fields';
  domain_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  subscription_uuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "link" */
export type Link_Max_Order_By = {
  domain_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  subscription_uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Link_Min_Fields = {
  __typename?: 'link_min_fields';
  domain_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  subscription_uuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "link" */
export type Link_Min_Order_By = {
  domain_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  subscription_uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "link" */
export type Link_Mutation_Response = {
  __typename?: 'link_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Link>;
};

/** on_conflict condition type for table "link" */
export type Link_On_Conflict = {
  constraint: Link_Constraint;
  update_columns?: Array<Link_Update_Column>;
  where?: InputMaybe<Link_Bool_Exp>;
};

/** Ordering options when selecting data from "link". */
export type Link_Order_By = {
  domain_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link_domain?: InputMaybe<Link_Domains_Order_By>;
  phone?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Subscriptions_Order_By>;
  subscription_uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: link */
export type Link_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "link" */
export enum Link_Select_Column {
  /** column name */
  DomainId = 'domain_id',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone',
  /** column name */
  Slug = 'slug',
  /** column name */
  SubscriptionUuid = 'subscription_uuid'
}

/** input type for updating data in table "link" */
export type Link_Set_Input = {
  domain_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  subscription_uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Link_Stddev_Fields = {
  __typename?: 'link_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "link" */
export type Link_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Link_Stddev_Pop_Fields = {
  __typename?: 'link_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "link" */
export type Link_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Link_Stddev_Samp_Fields = {
  __typename?: 'link_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "link" */
export type Link_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "link" */
export type Link_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Link_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Link_Stream_Cursor_Value_Input = {
  domain_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  subscription_uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Link_Sum_Fields = {
  __typename?: 'link_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "link" */
export type Link_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "link" */
export enum Link_Update_Column {
  /** column name */
  DomainId = 'domain_id',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone',
  /** column name */
  Slug = 'slug',
  /** column name */
  SubscriptionUuid = 'subscription_uuid'
}

export type Link_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Link_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Link_Set_Input>;
  /** filter the rows which have to be updated */
  where: Link_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Link_Var_Pop_Fields = {
  __typename?: 'link_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "link" */
export type Link_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Link_Var_Samp_Fields = {
  __typename?: 'link_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "link" */
export type Link_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Link_Variance_Fields = {
  __typename?: 'link_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "link" */
export type Link_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "logs" */
export type Logs = {
  __typename?: 'logs';
  created_at: Scalars['timestamptz'];
  data: Scalars['jsonb'];
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  teamId?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "logs" */
export type LogsDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "logs" */
export type Logs_Aggregate = {
  __typename?: 'logs_aggregate';
  aggregate?: Maybe<Logs_Aggregate_Fields>;
  nodes: Array<Logs>;
};

/** aggregate fields of "logs" */
export type Logs_Aggregate_Fields = {
  __typename?: 'logs_aggregate_fields';
  avg?: Maybe<Logs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Logs_Max_Fields>;
  min?: Maybe<Logs_Min_Fields>;
  stddev?: Maybe<Logs_Stddev_Fields>;
  stddev_pop?: Maybe<Logs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Logs_Stddev_Samp_Fields>;
  sum?: Maybe<Logs_Sum_Fields>;
  var_pop?: Maybe<Logs_Var_Pop_Fields>;
  var_samp?: Maybe<Logs_Var_Samp_Fields>;
  variance?: Maybe<Logs_Variance_Fields>;
};


/** aggregate fields of "logs" */
export type Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Logs_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Logs_Avg_Fields = {
  __typename?: 'logs_avg_fields';
  id?: Maybe<Scalars['Float']>;
  teamId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "logs". All fields are combined with a logical 'AND'. */
export type Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Logs_Bool_Exp>>;
  _not?: InputMaybe<Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Logs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  teamId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "logs" */
export enum Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  LogsPkey = 'logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Logs_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Logs_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Logs_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "logs" */
export type Logs_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  teamId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "logs" */
export type Logs_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Logs_Max_Fields = {
  __typename?: 'logs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Logs_Min_Fields = {
  __typename?: 'logs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "logs" */
export type Logs_Mutation_Response = {
  __typename?: 'logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Logs>;
};

/** on_conflict condition type for table "logs" */
export type Logs_On_Conflict = {
  constraint: Logs_Constraint;
  update_columns?: Array<Logs_Update_Column>;
  where?: InputMaybe<Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "logs". */
export type Logs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  teamId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: logs */
export type Logs_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Logs_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "logs" */
export enum Logs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TeamId = 'teamId'
}

/** input type for updating data in table "logs" */
export type Logs_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Logs_Stddev_Fields = {
  __typename?: 'logs_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  teamId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Logs_Stddev_Pop_Fields = {
  __typename?: 'logs_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  teamId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Logs_Stddev_Samp_Fields = {
  __typename?: 'logs_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  teamId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "logs" */
export type Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Logs_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Logs_Sum_Fields = {
  __typename?: 'logs_sum_fields';
  id?: Maybe<Scalars['Int']>;
  teamId?: Maybe<Scalars['Int']>;
};

/** update columns of table "logs" */
export enum Logs_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TeamId = 'teamId'
}

export type Logs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Logs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Logs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Logs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Logs_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Logs_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Logs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Logs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Logs_Var_Pop_Fields = {
  __typename?: 'logs_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  teamId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Logs_Var_Samp_Fields = {
  __typename?: 'logs_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  teamId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Logs_Variance_Fields = {
  __typename?: 'logs_variance_fields';
  id?: Maybe<Scalars['Float']>;
  teamId?: Maybe<Scalars['Float']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  activateSubscription: ActivateSubscriptionOutput;
  authDashboardToken: AuthDashboardTokenOutput;
  authForgotPassword?: Maybe<ForgotPasswordOutput>;
  authSignInOrSignUp: AuthSignInOrSignUpOutput;
  authSignin: AuthSigninOutput;
  authVerifyCode: AuthVerifyTokenOutput;
  authVerifyToken: AuthVerifyTokenOutput;
  browserNewSession: NewSessionOutput;
  browserScanContactMessages: ScanContactMessagesOutput;
  chargeBankSlip?: Maybe<ChargeBankSlipOutput>;
  chargeCreditCard?: Maybe<ChargeCreditCardOutput>;
  createCustomer: CreateCustomerOutput;
  createCustomerPaymentMethod?: Maybe<CreateCustomerPaymentMethodOutput>;
  createSubscription: CreateSubscriptionOutput;
  /** delete data from the table: "browser_sessions" */
  delete_browser_sessions?: Maybe<Browser_Sessions_Mutation_Response>;
  /** delete single row from the table: "browser_sessions" */
  delete_browser_sessions_by_pk?: Maybe<Browser_Sessions>;
  /** delete data from the table: "chat_list" */
  delete_chat_list?: Maybe<Chat_List_Mutation_Response>;
  /** delete single row from the table: "chat_list" */
  delete_chat_list_by_pk?: Maybe<Chat_List>;
  /** delete data from the table: "compliance" */
  delete_compliance?: Maybe<Compliance_Mutation_Response>;
  /** delete single row from the table: "compliance" */
  delete_compliance_by_pk?: Maybe<Compliance>;
  /** delete data from the table: "compliance_contacts" */
  delete_compliance_contacts?: Maybe<Compliance_Contacts_Mutation_Response>;
  /** delete data from the table: "compliance_contacts_raw" */
  delete_compliance_contacts_raw?: Maybe<Compliance_Contacts_Raw_Mutation_Response>;
  /** delete single row from the table: "compliance_contacts_raw" */
  delete_compliance_contacts_raw_by_pk?: Maybe<Compliance_Contacts_Raw>;
  /** delete data from the table: "compliance_contacts_stats_json_setof" */
  delete_compliance_contacts_stats_json_setof?: Maybe<Compliance_Contacts_Stats_Json_Setof_Mutation_Response>;
  /** delete data from the table: "compliance_contacts_stats_setof" */
  delete_compliance_contacts_stats_setof?: Maybe<Compliance_Contacts_Stats_Setof_Mutation_Response>;
  /** delete data from the table: "compliance_events" */
  delete_compliance_events?: Maybe<Compliance_Events_Mutation_Response>;
  /** delete single row from the table: "compliance_events" */
  delete_compliance_events_by_pk?: Maybe<Compliance_Events>;
  /** delete data from the table: "compliance_events_classification_goals" */
  delete_compliance_events_classification_goals?: Maybe<Compliance_Events_Classification_Goals_Mutation_Response>;
  /** delete single row from the table: "compliance_events_classification_goals" */
  delete_compliance_events_classification_goals_by_pk?: Maybe<Compliance_Events_Classification_Goals>;
  /** delete data from the table: "compliance_events_classification_resumes" */
  delete_compliance_events_classification_resumes?: Maybe<Compliance_Events_Classification_Resumes_Mutation_Response>;
  /** delete single row from the table: "compliance_events_classification_resumes" */
  delete_compliance_events_classification_resumes_by_pk?: Maybe<Compliance_Events_Classification_Resumes>;
  /** delete data from the table: "compliance_events_hourly" */
  delete_compliance_events_hourly?: Maybe<Compliance_Events_Hourly_Mutation_Response>;
  /** delete single row from the table: "compliance_events_hourly" */
  delete_compliance_events_hourly_by_pk?: Maybe<Compliance_Events_Hourly>;
  /** delete data from the table: "compliance_events_status_hourly" */
  delete_compliance_events_status_hourly?: Maybe<Compliance_Events_Status_Hourly_Mutation_Response>;
  /** delete single row from the table: "compliance_events_status_hourly" */
  delete_compliance_events_status_hourly_by_pk?: Maybe<Compliance_Events_Status_Hourly>;
  /** delete data from the table: "compliance_group_contacts" */
  delete_compliance_group_contacts?: Maybe<Compliance_Group_Contacts_Mutation_Response>;
  /** delete single row from the table: "compliance_group_contacts" */
  delete_compliance_group_contacts_by_pk?: Maybe<Compliance_Group_Contacts>;
  /** delete data from the table: "compliance_group_users" */
  delete_compliance_group_users?: Maybe<Compliance_Group_Users_Mutation_Response>;
  /** delete single row from the table: "compliance_group_users" */
  delete_compliance_group_users_by_pk?: Maybe<Compliance_Group_Users>;
  /** delete data from the table: "compliance_groups" */
  delete_compliance_groups?: Maybe<Compliance_Groups_Mutation_Response>;
  /** delete single row from the table: "compliance_groups" */
  delete_compliance_groups_by_pk?: Maybe<Compliance_Groups>;
  /** delete data from the table: "compliance_messages_hourly" */
  delete_compliance_messages_hourly?: Maybe<Compliance_Messages_Hourly_Mutation_Response>;
  /** delete single row from the table: "compliance_messages_hourly" */
  delete_compliance_messages_hourly_by_pk?: Maybe<Compliance_Messages_Hourly>;
  /** delete data from the table: "compliance_policies" */
  delete_compliance_policies?: Maybe<Compliance_Policies_Mutation_Response>;
  /** delete single row from the table: "compliance_policies" */
  delete_compliance_policies_by_pk?: Maybe<Compliance_Policies>;
  /** delete data from the table: "compliance_rules" */
  delete_compliance_rules?: Maybe<Compliance_Rules_Mutation_Response>;
  /** delete single row from the table: "compliance_rules" */
  delete_compliance_rules_by_pk?: Maybe<Compliance_Rules>;
  /** delete data from the table: "compliance_tags" */
  delete_compliance_tags?: Maybe<Compliance_Tags_Mutation_Response>;
  /** delete single row from the table: "compliance_tags" */
  delete_compliance_tags_by_pk?: Maybe<Compliance_Tags>;
  /** delete data from the table: "consent" */
  delete_consent?: Maybe<Consent_Mutation_Response>;
  /** delete single row from the table: "consent" */
  delete_consent_by_pk?: Maybe<Consent>;
  /** delete data from the table: "contact_list" */
  delete_contact_list?: Maybe<Contact_List_Mutation_Response>;
  /** delete single row from the table: "contact_list" */
  delete_contact_list_by_pk?: Maybe<Contact_List>;
  /** delete data from the table: "duo" */
  delete_duo?: Maybe<Duo_Mutation_Response>;
  /** delete single row from the table: "duo" */
  delete_duo_by_pk?: Maybe<Duo>;
  /** delete data from the table: "groups" */
  delete_groups?: Maybe<Groups_Mutation_Response>;
  /** delete single row from the table: "groups" */
  delete_groups_by_pk?: Maybe<Groups>;
  /** delete data from the table: "groups_users" */
  delete_groups_users?: Maybe<Groups_Users_Mutation_Response>;
  /** delete single row from the table: "groups_users" */
  delete_groups_users_by_pk?: Maybe<Groups_Users>;
  /** delete data from the table: "invite_rules" */
  delete_invite_rules?: Maybe<Invite_Rules_Mutation_Response>;
  /** delete single row from the table: "invite_rules" */
  delete_invite_rules_by_pk?: Maybe<Invite_Rules>;
  /** delete data from the table: "invite_rules_recipients" */
  delete_invite_rules_recipients?: Maybe<Invite_Rules_Recipients_Mutation_Response>;
  /** delete single row from the table: "invite_rules_recipients" */
  delete_invite_rules_recipients_by_pk?: Maybe<Invite_Rules_Recipients>;
  /** delete data from the table: "license_records" */
  delete_license_records?: Maybe<License_Records_Mutation_Response>;
  /** delete single row from the table: "license_records" */
  delete_license_records_by_pk?: Maybe<License_Records>;
  /** delete data from the table: "link" */
  delete_link?: Maybe<Link_Mutation_Response>;
  /** delete single row from the table: "link" */
  delete_link_by_pk?: Maybe<Link>;
  /** delete data from the table: "link_domains" */
  delete_link_domains?: Maybe<Link_Domains_Mutation_Response>;
  /** delete single row from the table: "link_domains" */
  delete_link_domains_by_pk?: Maybe<Link_Domains>;
  /** delete data from the table: "logs" */
  delete_logs?: Maybe<Logs_Mutation_Response>;
  /** delete single row from the table: "logs" */
  delete_logs_by_pk?: Maybe<Logs>;
  /** delete data from the table: "notifications" */
  delete_notifications?: Maybe<Notifications_Mutation_Response>;
  /** delete single row from the table: "notifications" */
  delete_notifications_by_pk?: Maybe<Notifications>;
  /** delete data from the table: "phone_providers" */
  delete_phone_providers?: Maybe<Phone_Providers_Mutation_Response>;
  /** delete single row from the table: "phone_providers" */
  delete_phone_providers_by_pk?: Maybe<Phone_Providers>;
  /** delete data from the table: "phones" */
  delete_phones?: Maybe<Phones_Mutation_Response>;
  /** delete single row from the table: "phones" */
  delete_phones_by_pk?: Maybe<Phones>;
  /** delete data from the table: "products" */
  delete_products?: Maybe<Products_Mutation_Response>;
  /** delete single row from the table: "products" */
  delete_products_by_pk?: Maybe<Products>;
  /** delete data from the table: "relevant_contacts" */
  delete_relevant_contacts?: Maybe<Relevant_Contacts_Mutation_Response>;
  /** delete single row from the table: "relevant_contacts" */
  delete_relevant_contacts_by_pk?: Maybe<Relevant_Contacts>;
  /** delete data from the table: "relevant_contacts_tags" */
  delete_relevant_contacts_tags?: Maybe<Relevant_Contacts_Tags_Mutation_Response>;
  /** delete single row from the table: "relevant_contacts_tags" */
  delete_relevant_contacts_tags_by_pk?: Maybe<Relevant_Contacts_Tags>;
  /** delete data from the table: "roles" */
  delete_roles?: Maybe<Roles_Mutation_Response>;
  /** delete single row from the table: "roles" */
  delete_roles_by_pk?: Maybe<Roles>;
  /** delete data from the table: "roles_teams" */
  delete_roles_teams?: Maybe<Roles_Teams_Mutation_Response>;
  /** delete single row from the table: "roles_teams" */
  delete_roles_teams_by_pk?: Maybe<Roles_Teams>;
  /** delete data from the table: "roles_users" */
  delete_roles_users?: Maybe<Roles_Users_Mutation_Response>;
  /** delete single row from the table: "roles_users" */
  delete_roles_users_by_pk?: Maybe<Roles_Users>;
  /** delete data from the table: "rollups" */
  delete_rollups?: Maybe<Rollups_Mutation_Response>;
  /** delete single row from the table: "rollups" */
  delete_rollups_by_pk?: Maybe<Rollups>;
  /** delete data from the table: "subscription_providers" */
  delete_subscription_providers?: Maybe<Subscription_Providers_Mutation_Response>;
  /** delete single row from the table: "subscription_providers" */
  delete_subscription_providers_by_pk?: Maybe<Subscription_Providers>;
  /** delete data from the table: "subscriptions" */
  delete_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** delete single row from the table: "subscriptions" */
  delete_subscriptions_by_pk?: Maybe<Subscriptions>;
  /** delete data from the table: "tags" */
  delete_tags?: Maybe<Tags_Mutation_Response>;
  /** delete single row from the table: "tags" */
  delete_tags_by_pk?: Maybe<Tags>;
  /** delete data from the table: "teams" */
  delete_teams?: Maybe<Teams_Mutation_Response>;
  /** delete single row from the table: "teams" */
  delete_teams_by_pk?: Maybe<Teams>;
  /** delete data from the table: "teams_settings" */
  delete_teams_settings?: Maybe<Teams_Settings_Mutation_Response>;
  /** delete single row from the table: "teams_settings" */
  delete_teams_settings_by_pk?: Maybe<Teams_Settings>;
  /** delete data from the table: "teams_templates" */
  delete_teams_templates?: Maybe<Teams_Templates_Mutation_Response>;
  /** delete single row from the table: "teams_templates" */
  delete_teams_templates_by_pk?: Maybe<Teams_Templates>;
  /** delete data from the table: "teams_users" */
  delete_teams_users?: Maybe<Teams_Users_Mutation_Response>;
  /** delete single row from the table: "teams_users" */
  delete_teams_users_by_pk?: Maybe<Teams_Users>;
  /** delete data from the table: "templates" */
  delete_templates?: Maybe<Templates_Mutation_Response>;
  /** delete single row from the table: "templates" */
  delete_templates_by_pk?: Maybe<Templates>;
  /** delete data from the table: "tenant" */
  delete_tenant?: Maybe<Tenant_Mutation_Response>;
  /** delete single row from the table: "tenant" */
  delete_tenant_by_pk?: Maybe<Tenant>;
  /** delete data from the table: "tokens" */
  delete_tokens?: Maybe<Tokens_Mutation_Response>;
  /** delete single row from the table: "tokens" */
  delete_tokens_by_pk?: Maybe<Tokens>;
  /** delete data from the table: "user_auth_codes" */
  delete_user_auth_codes?: Maybe<User_Auth_Codes_Mutation_Response>;
  /** delete single row from the table: "user_auth_codes" */
  delete_user_auth_codes_by_pk?: Maybe<User_Auth_Codes>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "web_contacts" */
  delete_web_contacts?: Maybe<Web_Contacts_Mutation_Response>;
  /** delete single row from the table: "web_contacts" */
  delete_web_contacts_by_pk?: Maybe<Web_Contacts>;
  /** delete data from the table: "web_messages" */
  delete_web_messages?: Maybe<Web_Messages_Mutation_Response>;
  /** delete single row from the table: "web_messages" */
  delete_web_messages_by_pk?: Maybe<Web_Messages>;
  /** delete data from the table: "web_qr_codes" */
  delete_web_qr_codes?: Maybe<Web_Qr_Codes_Mutation_Response>;
  /** delete single row from the table: "web_qr_codes" */
  delete_web_qr_codes_by_pk?: Maybe<Web_Qr_Codes>;
  /** delete data from the table: "whatsapp._messageTomessage_update" */
  delete_whatsapp__messageTomessage_update?: Maybe<Whatsapp__MessageTomessage_Update_Mutation_Response>;
  /** delete data from the table: "whatsapp.chat" */
  delete_whatsapp_chat?: Maybe<Whatsapp_Chat_Mutation_Response>;
  /** delete single row from the table: "whatsapp.chat" */
  delete_whatsapp_chat_by_pk?: Maybe<Whatsapp_Chat>;
  /** delete data from the table: "whatsapp.contact" */
  delete_whatsapp_contact?: Maybe<Whatsapp_Contact_Mutation_Response>;
  /** delete single row from the table: "whatsapp.contact" */
  delete_whatsapp_contact_by_pk?: Maybe<Whatsapp_Contact>;
  /** delete data from the table: "whatsapp.message" */
  delete_whatsapp_message?: Maybe<Whatsapp_Message_Mutation_Response>;
  /** delete single row from the table: "whatsapp.message" */
  delete_whatsapp_message_by_pk?: Maybe<Whatsapp_Message>;
  /** delete data from the table: "whatsapp.message_update" */
  delete_whatsapp_message_update?: Maybe<Whatsapp_Message_Update_Mutation_Response>;
  /** delete single row from the table: "whatsapp.message_update" */
  delete_whatsapp_message_update_by_pk?: Maybe<Whatsapp_Message_Update>;
  /** delete data from the table: "whatsapp.session" */
  delete_whatsapp_session?: Maybe<Whatsapp_Session_Mutation_Response>;
  /** delete single row from the table: "whatsapp.session" */
  delete_whatsapp_session_by_pk?: Maybe<Whatsapp_Session>;
  /** delete data from the table: "whatsapp.session_credential" */
  delete_whatsapp_session_credential?: Maybe<Whatsapp_Session_Credential_Mutation_Response>;
  /** delete single row from the table: "whatsapp.session_credential" */
  delete_whatsapp_session_credential_by_pk?: Maybe<Whatsapp_Session_Credential>;
  /** delete data from the table: "whatsapp.session_history_sync" */
  delete_whatsapp_session_history_sync?: Maybe<Whatsapp_Session_History_Sync_Mutation_Response>;
  /** delete single row from the table: "whatsapp.session_history_sync" */
  delete_whatsapp_session_history_sync_by_pk?: Maybe<Whatsapp_Session_History_Sync>;
  /** delete data from the table: "whatsapp.session_key" */
  delete_whatsapp_session_key?: Maybe<Whatsapp_Session_Key_Mutation_Response>;
  /** delete data from the table: "wos_sync" */
  delete_wos_sync?: Maybe<Wos_Sync_Mutation_Response>;
  /** delete single row from the table: "wos_sync" */
  delete_wos_sync_by_pk?: Maybe<Wos_Sync>;
  /** delete data from the table: "ws_contacts" */
  delete_ws_contacts?: Maybe<Ws_Contacts_Mutation_Response>;
  /** delete single row from the table: "ws_contacts" */
  delete_ws_contacts_by_pk?: Maybe<Ws_Contacts>;
  /** delete data from the table: "ws_history_sync" */
  delete_ws_history_sync?: Maybe<Ws_History_Sync_Mutation_Response>;
  /** delete single row from the table: "ws_history_sync" */
  delete_ws_history_sync_by_pk?: Maybe<Ws_History_Sync>;
  /** delete data from the table: "ws_messages" */
  delete_ws_messages?: Maybe<Ws_Messages_Mutation_Response>;
  /** delete single row from the table: "ws_messages" */
  delete_ws_messages_by_pk?: Maybe<Ws_Messages>;
  /** delete data from the table: "ws_servers" */
  delete_ws_servers?: Maybe<Ws_Servers_Mutation_Response>;
  /** delete single row from the table: "ws_servers" */
  delete_ws_servers_by_pk?: Maybe<Ws_Servers>;
  /** delete data from the table: "ws_sessions" */
  delete_ws_sessions?: Maybe<Ws_Sessions_Mutation_Response>;
  /** delete single row from the table: "ws_sessions" */
  delete_ws_sessions_by_pk?: Maybe<Ws_Sessions>;
  /** delete data from the table: "ws_sessions_credentials" */
  delete_ws_sessions_credentials?: Maybe<Ws_Sessions_Credentials_Mutation_Response>;
  /** delete single row from the table: "ws_sessions_credentials" */
  delete_ws_sessions_credentials_by_pk?: Maybe<Ws_Sessions_Credentials>;
  /** delete data from the table: "ws_sessions_keys" */
  delete_ws_sessions_keys?: Maybe<Ws_Sessions_Keys_Mutation_Response>;
  /** delete single row from the table: "ws_sessions_keys" */
  delete_ws_sessions_keys_by_pk?: Maybe<Ws_Sessions_Keys>;
  /** delete data from the table: "ws_sessions_signal_keys" */
  delete_ws_sessions_signal_keys?: Maybe<Ws_Sessions_Signal_Keys_Mutation_Response>;
  /** delete single row from the table: "ws_sessions_signal_keys" */
  delete_ws_sessions_signal_keys_by_pk?: Maybe<Ws_Sessions_Signal_Keys>;
  /** delete data from the table: "ws_sessions_stats" */
  delete_ws_sessions_stats?: Maybe<Ws_Sessions_Stats_Mutation_Response>;
  /** delete single row from the table: "ws_sessions_stats" */
  delete_ws_sessions_stats_by_pk?: Maybe<Ws_Sessions_Stats>;
  getMessagesAnalysis: GetMessagesAnalysisOutput;
  importCsv?: Maybe<ImportCsvOutput>;
  importCsvDiff?: Maybe<ImportCsvDiffOutput>;
  importCsvManagers?: Maybe<ImportCsvManagersOutput>;
  importCsvManagersDiff?: Maybe<ImportCsvManagersDiffOutput>;
  importCsvRelevantContacts?: Maybe<ImportCsvRelevantContactsOutput>;
  importCsvRelevantContactsDiff?: Maybe<ImportCsvRelevantContactsDiffOutput>;
  importCsvRules?: Maybe<ImportCsvRulesOutput>;
  importCsvRulesDiff?: Maybe<ImportCsvRulesDiffOutput>;
  insertComplianceContacts?: Maybe<InsertComplianceContactsOutput>;
  insertUsers?: Maybe<UsersInsertOutput>;
  /** insert data into the table: "browser_sessions" */
  insert_browser_sessions?: Maybe<Browser_Sessions_Mutation_Response>;
  /** insert a single row into the table: "browser_sessions" */
  insert_browser_sessions_one?: Maybe<Browser_Sessions>;
  /** insert data into the table: "chat_list" */
  insert_chat_list?: Maybe<Chat_List_Mutation_Response>;
  /** insert a single row into the table: "chat_list" */
  insert_chat_list_one?: Maybe<Chat_List>;
  /** insert data into the table: "compliance" */
  insert_compliance?: Maybe<Compliance_Mutation_Response>;
  /** insert data into the table: "compliance_contacts" */
  insert_compliance_contacts?: Maybe<Compliance_Contacts_Mutation_Response>;
  /** insert a single row into the table: "compliance_contacts" */
  insert_compliance_contacts_one?: Maybe<Compliance_Contacts>;
  /** insert data into the table: "compliance_contacts_raw" */
  insert_compliance_contacts_raw?: Maybe<Compliance_Contacts_Raw_Mutation_Response>;
  /** insert a single row into the table: "compliance_contacts_raw" */
  insert_compliance_contacts_raw_one?: Maybe<Compliance_Contacts_Raw>;
  /** insert data into the table: "compliance_contacts_stats_json_setof" */
  insert_compliance_contacts_stats_json_setof?: Maybe<Compliance_Contacts_Stats_Json_Setof_Mutation_Response>;
  /** insert a single row into the table: "compliance_contacts_stats_json_setof" */
  insert_compliance_contacts_stats_json_setof_one?: Maybe<Compliance_Contacts_Stats_Json_Setof>;
  /** insert data into the table: "compliance_contacts_stats_setof" */
  insert_compliance_contacts_stats_setof?: Maybe<Compliance_Contacts_Stats_Setof_Mutation_Response>;
  /** insert a single row into the table: "compliance_contacts_stats_setof" */
  insert_compliance_contacts_stats_setof_one?: Maybe<Compliance_Contacts_Stats_Setof>;
  /** insert data into the table: "compliance_events" */
  insert_compliance_events?: Maybe<Compliance_Events_Mutation_Response>;
  /** insert data into the table: "compliance_events_classification_goals" */
  insert_compliance_events_classification_goals?: Maybe<Compliance_Events_Classification_Goals_Mutation_Response>;
  /** insert a single row into the table: "compliance_events_classification_goals" */
  insert_compliance_events_classification_goals_one?: Maybe<Compliance_Events_Classification_Goals>;
  /** insert data into the table: "compliance_events_classification_resumes" */
  insert_compliance_events_classification_resumes?: Maybe<Compliance_Events_Classification_Resumes_Mutation_Response>;
  /** insert a single row into the table: "compliance_events_classification_resumes" */
  insert_compliance_events_classification_resumes_one?: Maybe<Compliance_Events_Classification_Resumes>;
  /** insert data into the table: "compliance_events_hourly" */
  insert_compliance_events_hourly?: Maybe<Compliance_Events_Hourly_Mutation_Response>;
  /** insert a single row into the table: "compliance_events_hourly" */
  insert_compliance_events_hourly_one?: Maybe<Compliance_Events_Hourly>;
  /** insert a single row into the table: "compliance_events" */
  insert_compliance_events_one?: Maybe<Compliance_Events>;
  /** insert data into the table: "compliance_events_status_hourly" */
  insert_compliance_events_status_hourly?: Maybe<Compliance_Events_Status_Hourly_Mutation_Response>;
  /** insert a single row into the table: "compliance_events_status_hourly" */
  insert_compliance_events_status_hourly_one?: Maybe<Compliance_Events_Status_Hourly>;
  /** insert data into the table: "compliance_group_contacts" */
  insert_compliance_group_contacts?: Maybe<Compliance_Group_Contacts_Mutation_Response>;
  /** insert a single row into the table: "compliance_group_contacts" */
  insert_compliance_group_contacts_one?: Maybe<Compliance_Group_Contacts>;
  /** insert data into the table: "compliance_group_users" */
  insert_compliance_group_users?: Maybe<Compliance_Group_Users_Mutation_Response>;
  /** insert a single row into the table: "compliance_group_users" */
  insert_compliance_group_users_one?: Maybe<Compliance_Group_Users>;
  /** insert data into the table: "compliance_groups" */
  insert_compliance_groups?: Maybe<Compliance_Groups_Mutation_Response>;
  /** insert a single row into the table: "compliance_groups" */
  insert_compliance_groups_one?: Maybe<Compliance_Groups>;
  /** insert data into the table: "compliance_messages_hourly" */
  insert_compliance_messages_hourly?: Maybe<Compliance_Messages_Hourly_Mutation_Response>;
  /** insert a single row into the table: "compliance_messages_hourly" */
  insert_compliance_messages_hourly_one?: Maybe<Compliance_Messages_Hourly>;
  /** insert a single row into the table: "compliance" */
  insert_compliance_one?: Maybe<Compliance>;
  /** insert data into the table: "compliance_policies" */
  insert_compliance_policies?: Maybe<Compliance_Policies_Mutation_Response>;
  /** insert a single row into the table: "compliance_policies" */
  insert_compliance_policies_one?: Maybe<Compliance_Policies>;
  /** insert data into the table: "compliance_rules" */
  insert_compliance_rules?: Maybe<Compliance_Rules_Mutation_Response>;
  /** insert a single row into the table: "compliance_rules" */
  insert_compliance_rules_one?: Maybe<Compliance_Rules>;
  /** insert data into the table: "compliance_tags" */
  insert_compliance_tags?: Maybe<Compliance_Tags_Mutation_Response>;
  /** insert a single row into the table: "compliance_tags" */
  insert_compliance_tags_one?: Maybe<Compliance_Tags>;
  /** insert data into the table: "consent" */
  insert_consent?: Maybe<Consent_Mutation_Response>;
  /** insert a single row into the table: "consent" */
  insert_consent_one?: Maybe<Consent>;
  /** insert data into the table: "contact_list" */
  insert_contact_list?: Maybe<Contact_List_Mutation_Response>;
  /** insert a single row into the table: "contact_list" */
  insert_contact_list_one?: Maybe<Contact_List>;
  /** insert data into the table: "duo" */
  insert_duo?: Maybe<Duo_Mutation_Response>;
  /** insert a single row into the table: "duo" */
  insert_duo_one?: Maybe<Duo>;
  /** insert data into the table: "groups" */
  insert_groups?: Maybe<Groups_Mutation_Response>;
  /** insert a single row into the table: "groups" */
  insert_groups_one?: Maybe<Groups>;
  /** insert data into the table: "groups_users" */
  insert_groups_users?: Maybe<Groups_Users_Mutation_Response>;
  /** insert a single row into the table: "groups_users" */
  insert_groups_users_one?: Maybe<Groups_Users>;
  /** insert data into the table: "invite_rules" */
  insert_invite_rules?: Maybe<Invite_Rules_Mutation_Response>;
  /** insert a single row into the table: "invite_rules" */
  insert_invite_rules_one?: Maybe<Invite_Rules>;
  /** insert data into the table: "invite_rules_recipients" */
  insert_invite_rules_recipients?: Maybe<Invite_Rules_Recipients_Mutation_Response>;
  /** insert a single row into the table: "invite_rules_recipients" */
  insert_invite_rules_recipients_one?: Maybe<Invite_Rules_Recipients>;
  /** insert data into the table: "license_records" */
  insert_license_records?: Maybe<License_Records_Mutation_Response>;
  /** insert a single row into the table: "license_records" */
  insert_license_records_one?: Maybe<License_Records>;
  /** insert data into the table: "link" */
  insert_link?: Maybe<Link_Mutation_Response>;
  /** insert data into the table: "link_domains" */
  insert_link_domains?: Maybe<Link_Domains_Mutation_Response>;
  /** insert a single row into the table: "link_domains" */
  insert_link_domains_one?: Maybe<Link_Domains>;
  /** insert a single row into the table: "link" */
  insert_link_one?: Maybe<Link>;
  /** insert data into the table: "logs" */
  insert_logs?: Maybe<Logs_Mutation_Response>;
  /** insert a single row into the table: "logs" */
  insert_logs_one?: Maybe<Logs>;
  /** insert data into the table: "notifications" */
  insert_notifications?: Maybe<Notifications_Mutation_Response>;
  /** insert a single row into the table: "notifications" */
  insert_notifications_one?: Maybe<Notifications>;
  /** insert data into the table: "phone_providers" */
  insert_phone_providers?: Maybe<Phone_Providers_Mutation_Response>;
  /** insert a single row into the table: "phone_providers" */
  insert_phone_providers_one?: Maybe<Phone_Providers>;
  /** insert data into the table: "phones" */
  insert_phones?: Maybe<Phones_Mutation_Response>;
  /** insert a single row into the table: "phones" */
  insert_phones_one?: Maybe<Phones>;
  /** insert data into the table: "products" */
  insert_products?: Maybe<Products_Mutation_Response>;
  /** insert a single row into the table: "products" */
  insert_products_one?: Maybe<Products>;
  /** insert data into the table: "relevant_contacts" */
  insert_relevant_contacts?: Maybe<Relevant_Contacts_Mutation_Response>;
  /** insert a single row into the table: "relevant_contacts" */
  insert_relevant_contacts_one?: Maybe<Relevant_Contacts>;
  /** insert data into the table: "relevant_contacts_tags" */
  insert_relevant_contacts_tags?: Maybe<Relevant_Contacts_Tags_Mutation_Response>;
  /** insert a single row into the table: "relevant_contacts_tags" */
  insert_relevant_contacts_tags_one?: Maybe<Relevant_Contacts_Tags>;
  /** insert data into the table: "roles" */
  insert_roles?: Maybe<Roles_Mutation_Response>;
  /** insert a single row into the table: "roles" */
  insert_roles_one?: Maybe<Roles>;
  /** insert data into the table: "roles_teams" */
  insert_roles_teams?: Maybe<Roles_Teams_Mutation_Response>;
  /** insert a single row into the table: "roles_teams" */
  insert_roles_teams_one?: Maybe<Roles_Teams>;
  /** insert data into the table: "roles_users" */
  insert_roles_users?: Maybe<Roles_Users_Mutation_Response>;
  /** insert a single row into the table: "roles_users" */
  insert_roles_users_one?: Maybe<Roles_Users>;
  /** insert data into the table: "rollups" */
  insert_rollups?: Maybe<Rollups_Mutation_Response>;
  /** insert a single row into the table: "rollups" */
  insert_rollups_one?: Maybe<Rollups>;
  /** insert data into the table: "subscription_providers" */
  insert_subscription_providers?: Maybe<Subscription_Providers_Mutation_Response>;
  /** insert a single row into the table: "subscription_providers" */
  insert_subscription_providers_one?: Maybe<Subscription_Providers>;
  /** insert data into the table: "subscriptions" */
  insert_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** insert a single row into the table: "subscriptions" */
  insert_subscriptions_one?: Maybe<Subscriptions>;
  /** insert data into the table: "tags" */
  insert_tags?: Maybe<Tags_Mutation_Response>;
  /** insert a single row into the table: "tags" */
  insert_tags_one?: Maybe<Tags>;
  /** insert data into the table: "teams" */
  insert_teams?: Maybe<Teams_Mutation_Response>;
  /** insert a single row into the table: "teams" */
  insert_teams_one?: Maybe<Teams>;
  /** insert data into the table: "teams_settings" */
  insert_teams_settings?: Maybe<Teams_Settings_Mutation_Response>;
  /** insert a single row into the table: "teams_settings" */
  insert_teams_settings_one?: Maybe<Teams_Settings>;
  /** insert data into the table: "teams_templates" */
  insert_teams_templates?: Maybe<Teams_Templates_Mutation_Response>;
  /** insert a single row into the table: "teams_templates" */
  insert_teams_templates_one?: Maybe<Teams_Templates>;
  /** insert data into the table: "teams_users" */
  insert_teams_users?: Maybe<Teams_Users_Mutation_Response>;
  /** insert a single row into the table: "teams_users" */
  insert_teams_users_one?: Maybe<Teams_Users>;
  /** insert data into the table: "templates" */
  insert_templates?: Maybe<Templates_Mutation_Response>;
  /** insert a single row into the table: "templates" */
  insert_templates_one?: Maybe<Templates>;
  /** insert data into the table: "tenant" */
  insert_tenant?: Maybe<Tenant_Mutation_Response>;
  /** insert a single row into the table: "tenant" */
  insert_tenant_one?: Maybe<Tenant>;
  /** insert data into the table: "tokens" */
  insert_tokens?: Maybe<Tokens_Mutation_Response>;
  /** insert a single row into the table: "tokens" */
  insert_tokens_one?: Maybe<Tokens>;
  /** insert data into the table: "user_auth_codes" */
  insert_user_auth_codes?: Maybe<User_Auth_Codes_Mutation_Response>;
  /** insert a single row into the table: "user_auth_codes" */
  insert_user_auth_codes_one?: Maybe<User_Auth_Codes>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "web_contacts" */
  insert_web_contacts?: Maybe<Web_Contacts_Mutation_Response>;
  /** insert a single row into the table: "web_contacts" */
  insert_web_contacts_one?: Maybe<Web_Contacts>;
  /** insert data into the table: "web_messages" */
  insert_web_messages?: Maybe<Web_Messages_Mutation_Response>;
  /** insert a single row into the table: "web_messages" */
  insert_web_messages_one?: Maybe<Web_Messages>;
  /** insert data into the table: "web_qr_codes" */
  insert_web_qr_codes?: Maybe<Web_Qr_Codes_Mutation_Response>;
  /** insert a single row into the table: "web_qr_codes" */
  insert_web_qr_codes_one?: Maybe<Web_Qr_Codes>;
  /** insert data into the table: "whatsapp._messageTomessage_update" */
  insert_whatsapp__messageTomessage_update?: Maybe<Whatsapp__MessageTomessage_Update_Mutation_Response>;
  /** insert a single row into the table: "whatsapp._messageTomessage_update" */
  insert_whatsapp__messageTomessage_update_one?: Maybe<Whatsapp__MessageTomessage_Update>;
  /** insert data into the table: "whatsapp.chat" */
  insert_whatsapp_chat?: Maybe<Whatsapp_Chat_Mutation_Response>;
  /** insert a single row into the table: "whatsapp.chat" */
  insert_whatsapp_chat_one?: Maybe<Whatsapp_Chat>;
  /** insert data into the table: "whatsapp.contact" */
  insert_whatsapp_contact?: Maybe<Whatsapp_Contact_Mutation_Response>;
  /** insert a single row into the table: "whatsapp.contact" */
  insert_whatsapp_contact_one?: Maybe<Whatsapp_Contact>;
  /** insert data into the table: "whatsapp.message" */
  insert_whatsapp_message?: Maybe<Whatsapp_Message_Mutation_Response>;
  /** insert a single row into the table: "whatsapp.message" */
  insert_whatsapp_message_one?: Maybe<Whatsapp_Message>;
  /** insert data into the table: "whatsapp.message_update" */
  insert_whatsapp_message_update?: Maybe<Whatsapp_Message_Update_Mutation_Response>;
  /** insert a single row into the table: "whatsapp.message_update" */
  insert_whatsapp_message_update_one?: Maybe<Whatsapp_Message_Update>;
  /** insert data into the table: "whatsapp.session" */
  insert_whatsapp_session?: Maybe<Whatsapp_Session_Mutation_Response>;
  /** insert data into the table: "whatsapp.session_credential" */
  insert_whatsapp_session_credential?: Maybe<Whatsapp_Session_Credential_Mutation_Response>;
  /** insert a single row into the table: "whatsapp.session_credential" */
  insert_whatsapp_session_credential_one?: Maybe<Whatsapp_Session_Credential>;
  /** insert data into the table: "whatsapp.session_history_sync" */
  insert_whatsapp_session_history_sync?: Maybe<Whatsapp_Session_History_Sync_Mutation_Response>;
  /** insert a single row into the table: "whatsapp.session_history_sync" */
  insert_whatsapp_session_history_sync_one?: Maybe<Whatsapp_Session_History_Sync>;
  /** insert data into the table: "whatsapp.session_key" */
  insert_whatsapp_session_key?: Maybe<Whatsapp_Session_Key_Mutation_Response>;
  /** insert a single row into the table: "whatsapp.session_key" */
  insert_whatsapp_session_key_one?: Maybe<Whatsapp_Session_Key>;
  /** insert a single row into the table: "whatsapp.session" */
  insert_whatsapp_session_one?: Maybe<Whatsapp_Session>;
  /** insert data into the table: "wos_sync" */
  insert_wos_sync?: Maybe<Wos_Sync_Mutation_Response>;
  /** insert a single row into the table: "wos_sync" */
  insert_wos_sync_one?: Maybe<Wos_Sync>;
  /** insert data into the table: "ws_contacts" */
  insert_ws_contacts?: Maybe<Ws_Contacts_Mutation_Response>;
  /** insert a single row into the table: "ws_contacts" */
  insert_ws_contacts_one?: Maybe<Ws_Contacts>;
  /** insert data into the table: "ws_history_sync" */
  insert_ws_history_sync?: Maybe<Ws_History_Sync_Mutation_Response>;
  /** insert a single row into the table: "ws_history_sync" */
  insert_ws_history_sync_one?: Maybe<Ws_History_Sync>;
  /** insert data into the table: "ws_messages" */
  insert_ws_messages?: Maybe<Ws_Messages_Mutation_Response>;
  /** insert a single row into the table: "ws_messages" */
  insert_ws_messages_one?: Maybe<Ws_Messages>;
  /** insert data into the table: "ws_servers" */
  insert_ws_servers?: Maybe<Ws_Servers_Mutation_Response>;
  /** insert a single row into the table: "ws_servers" */
  insert_ws_servers_one?: Maybe<Ws_Servers>;
  /** insert data into the table: "ws_sessions" */
  insert_ws_sessions?: Maybe<Ws_Sessions_Mutation_Response>;
  /** insert data into the table: "ws_sessions_credentials" */
  insert_ws_sessions_credentials?: Maybe<Ws_Sessions_Credentials_Mutation_Response>;
  /** insert a single row into the table: "ws_sessions_credentials" */
  insert_ws_sessions_credentials_one?: Maybe<Ws_Sessions_Credentials>;
  /** insert data into the table: "ws_sessions_keys" */
  insert_ws_sessions_keys?: Maybe<Ws_Sessions_Keys_Mutation_Response>;
  /** insert a single row into the table: "ws_sessions_keys" */
  insert_ws_sessions_keys_one?: Maybe<Ws_Sessions_Keys>;
  /** insert a single row into the table: "ws_sessions" */
  insert_ws_sessions_one?: Maybe<Ws_Sessions>;
  /** insert data into the table: "ws_sessions_signal_keys" */
  insert_ws_sessions_signal_keys?: Maybe<Ws_Sessions_Signal_Keys_Mutation_Response>;
  /** insert a single row into the table: "ws_sessions_signal_keys" */
  insert_ws_sessions_signal_keys_one?: Maybe<Ws_Sessions_Signal_Keys>;
  /** insert data into the table: "ws_sessions_stats" */
  insert_ws_sessions_stats?: Maybe<Ws_Sessions_Stats_Mutation_Response>;
  /** insert a single row into the table: "ws_sessions_stats" */
  insert_ws_sessions_stats_one?: Maybe<Ws_Sessions_Stats>;
  inviteUsers?: Maybe<UsersInviteOutput>;
  lambdasContactAuth?: Maybe<ContactAuthOutput>;
  lambdasScanContactMessages?: Maybe<LambdasScanContactMessagesOutput>;
  /** Open Scan Page Log action */
  logScanPageOpen?: Maybe<ScanPageOpenOutput>;
  logScanQrcode?: Maybe<ScanQrcodeOutput>;
  logout?: Maybe<LogoutOutput>;
  refreshJwtToken?: Maybe<RefreshJwtOutput>;
  /** refreshWosToken */
  refreshWosToken?: Maybe<RefreshWosOutput>;
  reinviteContacts?: Maybe<Array<Maybe<ReinviteContactsOutput>>>;
  rescanComplianceMessages?: Maybe<ScanResult>;
  resetPassword?: Maybe<ResetPasswordOutput>;
  signin?: Maybe<SigninOutput>;
  signup?: Maybe<SignupOutput>;
  twilioSendAuthCode?: Maybe<SendWhatsAppAuthCodeOutput>;
  twilioVerifyWhatsApp?: Maybe<VerifyWhatsAppOutput>;
  updateUser?: Maybe<UpdateUserOutput>;
  /** update data of the table: "browser_sessions" */
  update_browser_sessions?: Maybe<Browser_Sessions_Mutation_Response>;
  /** update single row of the table: "browser_sessions" */
  update_browser_sessions_by_pk?: Maybe<Browser_Sessions>;
  /** update multiples rows of table: "browser_sessions" */
  update_browser_sessions_many?: Maybe<Array<Maybe<Browser_Sessions_Mutation_Response>>>;
  /** update data of the table: "chat_list" */
  update_chat_list?: Maybe<Chat_List_Mutation_Response>;
  /** update single row of the table: "chat_list" */
  update_chat_list_by_pk?: Maybe<Chat_List>;
  /** update multiples rows of table: "chat_list" */
  update_chat_list_many?: Maybe<Array<Maybe<Chat_List_Mutation_Response>>>;
  /** update data of the table: "compliance" */
  update_compliance?: Maybe<Compliance_Mutation_Response>;
  /** update single row of the table: "compliance" */
  update_compliance_by_pk?: Maybe<Compliance>;
  /** update data of the table: "compliance_contacts" */
  update_compliance_contacts?: Maybe<Compliance_Contacts_Mutation_Response>;
  /** update multiples rows of table: "compliance_contacts" */
  update_compliance_contacts_many?: Maybe<Array<Maybe<Compliance_Contacts_Mutation_Response>>>;
  /** update data of the table: "compliance_contacts_raw" */
  update_compliance_contacts_raw?: Maybe<Compliance_Contacts_Raw_Mutation_Response>;
  /** update single row of the table: "compliance_contacts_raw" */
  update_compliance_contacts_raw_by_pk?: Maybe<Compliance_Contacts_Raw>;
  /** update multiples rows of table: "compliance_contacts_raw" */
  update_compliance_contacts_raw_many?: Maybe<Array<Maybe<Compliance_Contacts_Raw_Mutation_Response>>>;
  /** update data of the table: "compliance_contacts_stats_json_setof" */
  update_compliance_contacts_stats_json_setof?: Maybe<Compliance_Contacts_Stats_Json_Setof_Mutation_Response>;
  /** update multiples rows of table: "compliance_contacts_stats_json_setof" */
  update_compliance_contacts_stats_json_setof_many?: Maybe<Array<Maybe<Compliance_Contacts_Stats_Json_Setof_Mutation_Response>>>;
  /** update data of the table: "compliance_contacts_stats_setof" */
  update_compliance_contacts_stats_setof?: Maybe<Compliance_Contacts_Stats_Setof_Mutation_Response>;
  /** update multiples rows of table: "compliance_contacts_stats_setof" */
  update_compliance_contacts_stats_setof_many?: Maybe<Array<Maybe<Compliance_Contacts_Stats_Setof_Mutation_Response>>>;
  /** update data of the table: "compliance_events" */
  update_compliance_events?: Maybe<Compliance_Events_Mutation_Response>;
  /** update single row of the table: "compliance_events" */
  update_compliance_events_by_pk?: Maybe<Compliance_Events>;
  /** update data of the table: "compliance_events_classification_goals" */
  update_compliance_events_classification_goals?: Maybe<Compliance_Events_Classification_Goals_Mutation_Response>;
  /** update single row of the table: "compliance_events_classification_goals" */
  update_compliance_events_classification_goals_by_pk?: Maybe<Compliance_Events_Classification_Goals>;
  /** update multiples rows of table: "compliance_events_classification_goals" */
  update_compliance_events_classification_goals_many?: Maybe<Array<Maybe<Compliance_Events_Classification_Goals_Mutation_Response>>>;
  /** update data of the table: "compliance_events_classification_resumes" */
  update_compliance_events_classification_resumes?: Maybe<Compliance_Events_Classification_Resumes_Mutation_Response>;
  /** update single row of the table: "compliance_events_classification_resumes" */
  update_compliance_events_classification_resumes_by_pk?: Maybe<Compliance_Events_Classification_Resumes>;
  /** update multiples rows of table: "compliance_events_classification_resumes" */
  update_compliance_events_classification_resumes_many?: Maybe<Array<Maybe<Compliance_Events_Classification_Resumes_Mutation_Response>>>;
  /** update data of the table: "compliance_events_hourly" */
  update_compliance_events_hourly?: Maybe<Compliance_Events_Hourly_Mutation_Response>;
  /** update single row of the table: "compliance_events_hourly" */
  update_compliance_events_hourly_by_pk?: Maybe<Compliance_Events_Hourly>;
  /** update multiples rows of table: "compliance_events_hourly" */
  update_compliance_events_hourly_many?: Maybe<Array<Maybe<Compliance_Events_Hourly_Mutation_Response>>>;
  /** update multiples rows of table: "compliance_events" */
  update_compliance_events_many?: Maybe<Array<Maybe<Compliance_Events_Mutation_Response>>>;
  /** update data of the table: "compliance_events_status_hourly" */
  update_compliance_events_status_hourly?: Maybe<Compliance_Events_Status_Hourly_Mutation_Response>;
  /** update single row of the table: "compliance_events_status_hourly" */
  update_compliance_events_status_hourly_by_pk?: Maybe<Compliance_Events_Status_Hourly>;
  /** update multiples rows of table: "compliance_events_status_hourly" */
  update_compliance_events_status_hourly_many?: Maybe<Array<Maybe<Compliance_Events_Status_Hourly_Mutation_Response>>>;
  /** update data of the table: "compliance_group_contacts" */
  update_compliance_group_contacts?: Maybe<Compliance_Group_Contacts_Mutation_Response>;
  /** update single row of the table: "compliance_group_contacts" */
  update_compliance_group_contacts_by_pk?: Maybe<Compliance_Group_Contacts>;
  /** update multiples rows of table: "compliance_group_contacts" */
  update_compliance_group_contacts_many?: Maybe<Array<Maybe<Compliance_Group_Contacts_Mutation_Response>>>;
  /** update data of the table: "compliance_group_users" */
  update_compliance_group_users?: Maybe<Compliance_Group_Users_Mutation_Response>;
  /** update single row of the table: "compliance_group_users" */
  update_compliance_group_users_by_pk?: Maybe<Compliance_Group_Users>;
  /** update multiples rows of table: "compliance_group_users" */
  update_compliance_group_users_many?: Maybe<Array<Maybe<Compliance_Group_Users_Mutation_Response>>>;
  /** update data of the table: "compliance_groups" */
  update_compliance_groups?: Maybe<Compliance_Groups_Mutation_Response>;
  /** update single row of the table: "compliance_groups" */
  update_compliance_groups_by_pk?: Maybe<Compliance_Groups>;
  /** update multiples rows of table: "compliance_groups" */
  update_compliance_groups_many?: Maybe<Array<Maybe<Compliance_Groups_Mutation_Response>>>;
  /** update multiples rows of table: "compliance" */
  update_compliance_many?: Maybe<Array<Maybe<Compliance_Mutation_Response>>>;
  /** update data of the table: "compliance_messages_hourly" */
  update_compliance_messages_hourly?: Maybe<Compliance_Messages_Hourly_Mutation_Response>;
  /** update single row of the table: "compliance_messages_hourly" */
  update_compliance_messages_hourly_by_pk?: Maybe<Compliance_Messages_Hourly>;
  /** update multiples rows of table: "compliance_messages_hourly" */
  update_compliance_messages_hourly_many?: Maybe<Array<Maybe<Compliance_Messages_Hourly_Mutation_Response>>>;
  /** update data of the table: "compliance_policies" */
  update_compliance_policies?: Maybe<Compliance_Policies_Mutation_Response>;
  /** update single row of the table: "compliance_policies" */
  update_compliance_policies_by_pk?: Maybe<Compliance_Policies>;
  /** update multiples rows of table: "compliance_policies" */
  update_compliance_policies_many?: Maybe<Array<Maybe<Compliance_Policies_Mutation_Response>>>;
  /** update data of the table: "compliance_rules" */
  update_compliance_rules?: Maybe<Compliance_Rules_Mutation_Response>;
  /** update single row of the table: "compliance_rules" */
  update_compliance_rules_by_pk?: Maybe<Compliance_Rules>;
  /** update multiples rows of table: "compliance_rules" */
  update_compliance_rules_many?: Maybe<Array<Maybe<Compliance_Rules_Mutation_Response>>>;
  /** update data of the table: "compliance_tags" */
  update_compliance_tags?: Maybe<Compliance_Tags_Mutation_Response>;
  /** update single row of the table: "compliance_tags" */
  update_compliance_tags_by_pk?: Maybe<Compliance_Tags>;
  /** update multiples rows of table: "compliance_tags" */
  update_compliance_tags_many?: Maybe<Array<Maybe<Compliance_Tags_Mutation_Response>>>;
  /** update data of the table: "consent" */
  update_consent?: Maybe<Consent_Mutation_Response>;
  /** update single row of the table: "consent" */
  update_consent_by_pk?: Maybe<Consent>;
  /** update multiples rows of table: "consent" */
  update_consent_many?: Maybe<Array<Maybe<Consent_Mutation_Response>>>;
  /** update data of the table: "contact_list" */
  update_contact_list?: Maybe<Contact_List_Mutation_Response>;
  /** update single row of the table: "contact_list" */
  update_contact_list_by_pk?: Maybe<Contact_List>;
  /** update multiples rows of table: "contact_list" */
  update_contact_list_many?: Maybe<Array<Maybe<Contact_List_Mutation_Response>>>;
  /** update data of the table: "duo" */
  update_duo?: Maybe<Duo_Mutation_Response>;
  /** update single row of the table: "duo" */
  update_duo_by_pk?: Maybe<Duo>;
  /** update multiples rows of table: "duo" */
  update_duo_many?: Maybe<Array<Maybe<Duo_Mutation_Response>>>;
  /** update data of the table: "groups" */
  update_groups?: Maybe<Groups_Mutation_Response>;
  /** update single row of the table: "groups" */
  update_groups_by_pk?: Maybe<Groups>;
  /** update multiples rows of table: "groups" */
  update_groups_many?: Maybe<Array<Maybe<Groups_Mutation_Response>>>;
  /** update data of the table: "groups_users" */
  update_groups_users?: Maybe<Groups_Users_Mutation_Response>;
  /** update single row of the table: "groups_users" */
  update_groups_users_by_pk?: Maybe<Groups_Users>;
  /** update multiples rows of table: "groups_users" */
  update_groups_users_many?: Maybe<Array<Maybe<Groups_Users_Mutation_Response>>>;
  /** update data of the table: "invite_rules" */
  update_invite_rules?: Maybe<Invite_Rules_Mutation_Response>;
  /** update single row of the table: "invite_rules" */
  update_invite_rules_by_pk?: Maybe<Invite_Rules>;
  /** update multiples rows of table: "invite_rules" */
  update_invite_rules_many?: Maybe<Array<Maybe<Invite_Rules_Mutation_Response>>>;
  /** update data of the table: "invite_rules_recipients" */
  update_invite_rules_recipients?: Maybe<Invite_Rules_Recipients_Mutation_Response>;
  /** update single row of the table: "invite_rules_recipients" */
  update_invite_rules_recipients_by_pk?: Maybe<Invite_Rules_Recipients>;
  /** update multiples rows of table: "invite_rules_recipients" */
  update_invite_rules_recipients_many?: Maybe<Array<Maybe<Invite_Rules_Recipients_Mutation_Response>>>;
  /** update data of the table: "license_records" */
  update_license_records?: Maybe<License_Records_Mutation_Response>;
  /** update single row of the table: "license_records" */
  update_license_records_by_pk?: Maybe<License_Records>;
  /** update multiples rows of table: "license_records" */
  update_license_records_many?: Maybe<Array<Maybe<License_Records_Mutation_Response>>>;
  /** update data of the table: "link" */
  update_link?: Maybe<Link_Mutation_Response>;
  /** update single row of the table: "link" */
  update_link_by_pk?: Maybe<Link>;
  /** update data of the table: "link_domains" */
  update_link_domains?: Maybe<Link_Domains_Mutation_Response>;
  /** update single row of the table: "link_domains" */
  update_link_domains_by_pk?: Maybe<Link_Domains>;
  /** update multiples rows of table: "link_domains" */
  update_link_domains_many?: Maybe<Array<Maybe<Link_Domains_Mutation_Response>>>;
  /** update multiples rows of table: "link" */
  update_link_many?: Maybe<Array<Maybe<Link_Mutation_Response>>>;
  /** update data of the table: "logs" */
  update_logs?: Maybe<Logs_Mutation_Response>;
  /** update single row of the table: "logs" */
  update_logs_by_pk?: Maybe<Logs>;
  /** update multiples rows of table: "logs" */
  update_logs_many?: Maybe<Array<Maybe<Logs_Mutation_Response>>>;
  /** update data of the table: "notifications" */
  update_notifications?: Maybe<Notifications_Mutation_Response>;
  /** update single row of the table: "notifications" */
  update_notifications_by_pk?: Maybe<Notifications>;
  /** update multiples rows of table: "notifications" */
  update_notifications_many?: Maybe<Array<Maybe<Notifications_Mutation_Response>>>;
  /** update data of the table: "phone_providers" */
  update_phone_providers?: Maybe<Phone_Providers_Mutation_Response>;
  /** update single row of the table: "phone_providers" */
  update_phone_providers_by_pk?: Maybe<Phone_Providers>;
  /** update multiples rows of table: "phone_providers" */
  update_phone_providers_many?: Maybe<Array<Maybe<Phone_Providers_Mutation_Response>>>;
  /** update data of the table: "phones" */
  update_phones?: Maybe<Phones_Mutation_Response>;
  /** update single row of the table: "phones" */
  update_phones_by_pk?: Maybe<Phones>;
  /** update multiples rows of table: "phones" */
  update_phones_many?: Maybe<Array<Maybe<Phones_Mutation_Response>>>;
  /** update data of the table: "products" */
  update_products?: Maybe<Products_Mutation_Response>;
  /** update single row of the table: "products" */
  update_products_by_pk?: Maybe<Products>;
  /** update multiples rows of table: "products" */
  update_products_many?: Maybe<Array<Maybe<Products_Mutation_Response>>>;
  /** update data of the table: "relevant_contacts" */
  update_relevant_contacts?: Maybe<Relevant_Contacts_Mutation_Response>;
  /** update single row of the table: "relevant_contacts" */
  update_relevant_contacts_by_pk?: Maybe<Relevant_Contacts>;
  /** update multiples rows of table: "relevant_contacts" */
  update_relevant_contacts_many?: Maybe<Array<Maybe<Relevant_Contacts_Mutation_Response>>>;
  /** update data of the table: "relevant_contacts_tags" */
  update_relevant_contacts_tags?: Maybe<Relevant_Contacts_Tags_Mutation_Response>;
  /** update single row of the table: "relevant_contacts_tags" */
  update_relevant_contacts_tags_by_pk?: Maybe<Relevant_Contacts_Tags>;
  /** update multiples rows of table: "relevant_contacts_tags" */
  update_relevant_contacts_tags_many?: Maybe<Array<Maybe<Relevant_Contacts_Tags_Mutation_Response>>>;
  /** update data of the table: "roles" */
  update_roles?: Maybe<Roles_Mutation_Response>;
  /** update single row of the table: "roles" */
  update_roles_by_pk?: Maybe<Roles>;
  /** update multiples rows of table: "roles" */
  update_roles_many?: Maybe<Array<Maybe<Roles_Mutation_Response>>>;
  /** update data of the table: "roles_teams" */
  update_roles_teams?: Maybe<Roles_Teams_Mutation_Response>;
  /** update single row of the table: "roles_teams" */
  update_roles_teams_by_pk?: Maybe<Roles_Teams>;
  /** update multiples rows of table: "roles_teams" */
  update_roles_teams_many?: Maybe<Array<Maybe<Roles_Teams_Mutation_Response>>>;
  /** update data of the table: "roles_users" */
  update_roles_users?: Maybe<Roles_Users_Mutation_Response>;
  /** update single row of the table: "roles_users" */
  update_roles_users_by_pk?: Maybe<Roles_Users>;
  /** update multiples rows of table: "roles_users" */
  update_roles_users_many?: Maybe<Array<Maybe<Roles_Users_Mutation_Response>>>;
  /** update data of the table: "rollups" */
  update_rollups?: Maybe<Rollups_Mutation_Response>;
  /** update single row of the table: "rollups" */
  update_rollups_by_pk?: Maybe<Rollups>;
  /** update multiples rows of table: "rollups" */
  update_rollups_many?: Maybe<Array<Maybe<Rollups_Mutation_Response>>>;
  /** update data of the table: "subscription_providers" */
  update_subscription_providers?: Maybe<Subscription_Providers_Mutation_Response>;
  /** update single row of the table: "subscription_providers" */
  update_subscription_providers_by_pk?: Maybe<Subscription_Providers>;
  /** update multiples rows of table: "subscription_providers" */
  update_subscription_providers_many?: Maybe<Array<Maybe<Subscription_Providers_Mutation_Response>>>;
  /** update data of the table: "subscriptions" */
  update_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** update single row of the table: "subscriptions" */
  update_subscriptions_by_pk?: Maybe<Subscriptions>;
  /** update multiples rows of table: "subscriptions" */
  update_subscriptions_many?: Maybe<Array<Maybe<Subscriptions_Mutation_Response>>>;
  /** update data of the table: "tags" */
  update_tags?: Maybe<Tags_Mutation_Response>;
  /** update single row of the table: "tags" */
  update_tags_by_pk?: Maybe<Tags>;
  /** update multiples rows of table: "tags" */
  update_tags_many?: Maybe<Array<Maybe<Tags_Mutation_Response>>>;
  /** update data of the table: "teams" */
  update_teams?: Maybe<Teams_Mutation_Response>;
  /** update single row of the table: "teams" */
  update_teams_by_pk?: Maybe<Teams>;
  /** update multiples rows of table: "teams" */
  update_teams_many?: Maybe<Array<Maybe<Teams_Mutation_Response>>>;
  /** update data of the table: "teams_settings" */
  update_teams_settings?: Maybe<Teams_Settings_Mutation_Response>;
  /** update single row of the table: "teams_settings" */
  update_teams_settings_by_pk?: Maybe<Teams_Settings>;
  /** update multiples rows of table: "teams_settings" */
  update_teams_settings_many?: Maybe<Array<Maybe<Teams_Settings_Mutation_Response>>>;
  /** update data of the table: "teams_templates" */
  update_teams_templates?: Maybe<Teams_Templates_Mutation_Response>;
  /** update single row of the table: "teams_templates" */
  update_teams_templates_by_pk?: Maybe<Teams_Templates>;
  /** update multiples rows of table: "teams_templates" */
  update_teams_templates_many?: Maybe<Array<Maybe<Teams_Templates_Mutation_Response>>>;
  /** update data of the table: "teams_users" */
  update_teams_users?: Maybe<Teams_Users_Mutation_Response>;
  /** update single row of the table: "teams_users" */
  update_teams_users_by_pk?: Maybe<Teams_Users>;
  /** update multiples rows of table: "teams_users" */
  update_teams_users_many?: Maybe<Array<Maybe<Teams_Users_Mutation_Response>>>;
  /** update data of the table: "templates" */
  update_templates?: Maybe<Templates_Mutation_Response>;
  /** update single row of the table: "templates" */
  update_templates_by_pk?: Maybe<Templates>;
  /** update multiples rows of table: "templates" */
  update_templates_many?: Maybe<Array<Maybe<Templates_Mutation_Response>>>;
  /** update data of the table: "tenant" */
  update_tenant?: Maybe<Tenant_Mutation_Response>;
  /** update single row of the table: "tenant" */
  update_tenant_by_pk?: Maybe<Tenant>;
  /** update multiples rows of table: "tenant" */
  update_tenant_many?: Maybe<Array<Maybe<Tenant_Mutation_Response>>>;
  /** update data of the table: "tokens" */
  update_tokens?: Maybe<Tokens_Mutation_Response>;
  /** update single row of the table: "tokens" */
  update_tokens_by_pk?: Maybe<Tokens>;
  /** update multiples rows of table: "tokens" */
  update_tokens_many?: Maybe<Array<Maybe<Tokens_Mutation_Response>>>;
  /** update data of the table: "user_auth_codes" */
  update_user_auth_codes?: Maybe<User_Auth_Codes_Mutation_Response>;
  /** update single row of the table: "user_auth_codes" */
  update_user_auth_codes_by_pk?: Maybe<User_Auth_Codes>;
  /** update multiples rows of table: "user_auth_codes" */
  update_user_auth_codes_many?: Maybe<Array<Maybe<User_Auth_Codes_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "web_contacts" */
  update_web_contacts?: Maybe<Web_Contacts_Mutation_Response>;
  /** update single row of the table: "web_contacts" */
  update_web_contacts_by_pk?: Maybe<Web_Contacts>;
  /** update multiples rows of table: "web_contacts" */
  update_web_contacts_many?: Maybe<Array<Maybe<Web_Contacts_Mutation_Response>>>;
  /** update data of the table: "web_messages" */
  update_web_messages?: Maybe<Web_Messages_Mutation_Response>;
  /** update single row of the table: "web_messages" */
  update_web_messages_by_pk?: Maybe<Web_Messages>;
  /** update multiples rows of table: "web_messages" */
  update_web_messages_many?: Maybe<Array<Maybe<Web_Messages_Mutation_Response>>>;
  /** update data of the table: "web_qr_codes" */
  update_web_qr_codes?: Maybe<Web_Qr_Codes_Mutation_Response>;
  /** update single row of the table: "web_qr_codes" */
  update_web_qr_codes_by_pk?: Maybe<Web_Qr_Codes>;
  /** update multiples rows of table: "web_qr_codes" */
  update_web_qr_codes_many?: Maybe<Array<Maybe<Web_Qr_Codes_Mutation_Response>>>;
  /** update data of the table: "whatsapp._messageTomessage_update" */
  update_whatsapp__messageTomessage_update?: Maybe<Whatsapp__MessageTomessage_Update_Mutation_Response>;
  /** update multiples rows of table: "whatsapp._messageTomessage_update" */
  update_whatsapp__messageTomessage_update_many?: Maybe<Array<Maybe<Whatsapp__MessageTomessage_Update_Mutation_Response>>>;
  /** update data of the table: "whatsapp.chat" */
  update_whatsapp_chat?: Maybe<Whatsapp_Chat_Mutation_Response>;
  /** update single row of the table: "whatsapp.chat" */
  update_whatsapp_chat_by_pk?: Maybe<Whatsapp_Chat>;
  /** update multiples rows of table: "whatsapp.chat" */
  update_whatsapp_chat_many?: Maybe<Array<Maybe<Whatsapp_Chat_Mutation_Response>>>;
  /** update data of the table: "whatsapp.contact" */
  update_whatsapp_contact?: Maybe<Whatsapp_Contact_Mutation_Response>;
  /** update single row of the table: "whatsapp.contact" */
  update_whatsapp_contact_by_pk?: Maybe<Whatsapp_Contact>;
  /** update multiples rows of table: "whatsapp.contact" */
  update_whatsapp_contact_many?: Maybe<Array<Maybe<Whatsapp_Contact_Mutation_Response>>>;
  /** update data of the table: "whatsapp.message" */
  update_whatsapp_message?: Maybe<Whatsapp_Message_Mutation_Response>;
  /** update single row of the table: "whatsapp.message" */
  update_whatsapp_message_by_pk?: Maybe<Whatsapp_Message>;
  /** update multiples rows of table: "whatsapp.message" */
  update_whatsapp_message_many?: Maybe<Array<Maybe<Whatsapp_Message_Mutation_Response>>>;
  /** update data of the table: "whatsapp.message_update" */
  update_whatsapp_message_update?: Maybe<Whatsapp_Message_Update_Mutation_Response>;
  /** update single row of the table: "whatsapp.message_update" */
  update_whatsapp_message_update_by_pk?: Maybe<Whatsapp_Message_Update>;
  /** update multiples rows of table: "whatsapp.message_update" */
  update_whatsapp_message_update_many?: Maybe<Array<Maybe<Whatsapp_Message_Update_Mutation_Response>>>;
  /** update data of the table: "whatsapp.session" */
  update_whatsapp_session?: Maybe<Whatsapp_Session_Mutation_Response>;
  /** update single row of the table: "whatsapp.session" */
  update_whatsapp_session_by_pk?: Maybe<Whatsapp_Session>;
  /** update data of the table: "whatsapp.session_credential" */
  update_whatsapp_session_credential?: Maybe<Whatsapp_Session_Credential_Mutation_Response>;
  /** update single row of the table: "whatsapp.session_credential" */
  update_whatsapp_session_credential_by_pk?: Maybe<Whatsapp_Session_Credential>;
  /** update multiples rows of table: "whatsapp.session_credential" */
  update_whatsapp_session_credential_many?: Maybe<Array<Maybe<Whatsapp_Session_Credential_Mutation_Response>>>;
  /** update data of the table: "whatsapp.session_history_sync" */
  update_whatsapp_session_history_sync?: Maybe<Whatsapp_Session_History_Sync_Mutation_Response>;
  /** update single row of the table: "whatsapp.session_history_sync" */
  update_whatsapp_session_history_sync_by_pk?: Maybe<Whatsapp_Session_History_Sync>;
  /** update multiples rows of table: "whatsapp.session_history_sync" */
  update_whatsapp_session_history_sync_many?: Maybe<Array<Maybe<Whatsapp_Session_History_Sync_Mutation_Response>>>;
  /** update data of the table: "whatsapp.session_key" */
  update_whatsapp_session_key?: Maybe<Whatsapp_Session_Key_Mutation_Response>;
  /** update multiples rows of table: "whatsapp.session_key" */
  update_whatsapp_session_key_many?: Maybe<Array<Maybe<Whatsapp_Session_Key_Mutation_Response>>>;
  /** update multiples rows of table: "whatsapp.session" */
  update_whatsapp_session_many?: Maybe<Array<Maybe<Whatsapp_Session_Mutation_Response>>>;
  /** update data of the table: "wos_sync" */
  update_wos_sync?: Maybe<Wos_Sync_Mutation_Response>;
  /** update single row of the table: "wos_sync" */
  update_wos_sync_by_pk?: Maybe<Wos_Sync>;
  /** update multiples rows of table: "wos_sync" */
  update_wos_sync_many?: Maybe<Array<Maybe<Wos_Sync_Mutation_Response>>>;
  /** update data of the table: "ws_contacts" */
  update_ws_contacts?: Maybe<Ws_Contacts_Mutation_Response>;
  /** update single row of the table: "ws_contacts" */
  update_ws_contacts_by_pk?: Maybe<Ws_Contacts>;
  /** update multiples rows of table: "ws_contacts" */
  update_ws_contacts_many?: Maybe<Array<Maybe<Ws_Contacts_Mutation_Response>>>;
  /** update data of the table: "ws_history_sync" */
  update_ws_history_sync?: Maybe<Ws_History_Sync_Mutation_Response>;
  /** update single row of the table: "ws_history_sync" */
  update_ws_history_sync_by_pk?: Maybe<Ws_History_Sync>;
  /** update multiples rows of table: "ws_history_sync" */
  update_ws_history_sync_many?: Maybe<Array<Maybe<Ws_History_Sync_Mutation_Response>>>;
  /** update data of the table: "ws_messages" */
  update_ws_messages?: Maybe<Ws_Messages_Mutation_Response>;
  /** update single row of the table: "ws_messages" */
  update_ws_messages_by_pk?: Maybe<Ws_Messages>;
  /** update multiples rows of table: "ws_messages" */
  update_ws_messages_many?: Maybe<Array<Maybe<Ws_Messages_Mutation_Response>>>;
  /** update data of the table: "ws_servers" */
  update_ws_servers?: Maybe<Ws_Servers_Mutation_Response>;
  /** update single row of the table: "ws_servers" */
  update_ws_servers_by_pk?: Maybe<Ws_Servers>;
  /** update multiples rows of table: "ws_servers" */
  update_ws_servers_many?: Maybe<Array<Maybe<Ws_Servers_Mutation_Response>>>;
  /** update data of the table: "ws_sessions" */
  update_ws_sessions?: Maybe<Ws_Sessions_Mutation_Response>;
  /** update single row of the table: "ws_sessions" */
  update_ws_sessions_by_pk?: Maybe<Ws_Sessions>;
  /** update data of the table: "ws_sessions_credentials" */
  update_ws_sessions_credentials?: Maybe<Ws_Sessions_Credentials_Mutation_Response>;
  /** update single row of the table: "ws_sessions_credentials" */
  update_ws_sessions_credentials_by_pk?: Maybe<Ws_Sessions_Credentials>;
  /** update multiples rows of table: "ws_sessions_credentials" */
  update_ws_sessions_credentials_many?: Maybe<Array<Maybe<Ws_Sessions_Credentials_Mutation_Response>>>;
  /** update data of the table: "ws_sessions_keys" */
  update_ws_sessions_keys?: Maybe<Ws_Sessions_Keys_Mutation_Response>;
  /** update single row of the table: "ws_sessions_keys" */
  update_ws_sessions_keys_by_pk?: Maybe<Ws_Sessions_Keys>;
  /** update multiples rows of table: "ws_sessions_keys" */
  update_ws_sessions_keys_many?: Maybe<Array<Maybe<Ws_Sessions_Keys_Mutation_Response>>>;
  /** update multiples rows of table: "ws_sessions" */
  update_ws_sessions_many?: Maybe<Array<Maybe<Ws_Sessions_Mutation_Response>>>;
  /** update data of the table: "ws_sessions_signal_keys" */
  update_ws_sessions_signal_keys?: Maybe<Ws_Sessions_Signal_Keys_Mutation_Response>;
  /** update single row of the table: "ws_sessions_signal_keys" */
  update_ws_sessions_signal_keys_by_pk?: Maybe<Ws_Sessions_Signal_Keys>;
  /** update multiples rows of table: "ws_sessions_signal_keys" */
  update_ws_sessions_signal_keys_many?: Maybe<Array<Maybe<Ws_Sessions_Signal_Keys_Mutation_Response>>>;
  /** update data of the table: "ws_sessions_stats" */
  update_ws_sessions_stats?: Maybe<Ws_Sessions_Stats_Mutation_Response>;
  /** update single row of the table: "ws_sessions_stats" */
  update_ws_sessions_stats_by_pk?: Maybe<Ws_Sessions_Stats>;
  /** update multiples rows of table: "ws_sessions_stats" */
  update_ws_sessions_stats_many?: Maybe<Array<Maybe<Ws_Sessions_Stats_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootActivateSubscriptionArgs = {
  object: ActivateSubscriptionInput;
};


/** mutation root */
export type Mutation_RootAuthDashboardTokenArgs = {
  token: Scalars['String'];
};


/** mutation root */
export type Mutation_RootAuthForgotPasswordArgs = {
  email: Scalars['String'];
};


/** mutation root */
export type Mutation_RootAuthSignInOrSignUpArgs = {
  object: AuthSignInOrSignUpInput;
};


/** mutation root */
export type Mutation_RootAuthSigninArgs = {
  object: AuthSigninInput;
};


/** mutation root */
export type Mutation_RootAuthVerifyCodeArgs = {
  object: AuthVerifyCodeInput;
};


/** mutation root */
export type Mutation_RootAuthVerifyTokenArgs = {
  token: Scalars['String'];
};


/** mutation root */
export type Mutation_RootBrowserNewSessionArgs = {
  object: NewSessionInput;
};


/** mutation root */
export type Mutation_RootBrowserScanContactMessagesArgs = {
  object: ScanContactMessagesInput;
};


/** mutation root */
export type Mutation_RootChargeBankSlipArgs = {
  object: ChargeBankSlipInput;
};


/** mutation root */
export type Mutation_RootChargeCreditCardArgs = {
  object: ChargeCreditCardInput;
};


/** mutation root */
export type Mutation_RootCreateCustomerArgs = {
  object: CreateCustomerInput;
};


/** mutation root */
export type Mutation_RootCreateCustomerPaymentMethodArgs = {
  object: CreateCustomerPaymentMethodInput;
};


/** mutation root */
export type Mutation_RootCreateSubscriptionArgs = {
  object: CreateSubscriptionInput;
};


/** mutation root */
export type Mutation_RootDelete_Browser_SessionsArgs = {
  where: Browser_Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Browser_Sessions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Chat_ListArgs = {
  where: Chat_List_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_List_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ComplianceArgs = {
  where: Compliance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Compliance_ContactsArgs = {
  where: Compliance_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Contacts_RawArgs = {
  where: Compliance_Contacts_Raw_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Contacts_Raw_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Contacts_Stats_Json_SetofArgs = {
  where: Compliance_Contacts_Stats_Json_Setof_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Contacts_Stats_SetofArgs = {
  where: Compliance_Contacts_Stats_Setof_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_EventsArgs = {
  where: Compliance_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Events_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Events_Classification_GoalsArgs = {
  where: Compliance_Events_Classification_Goals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Events_Classification_Goals_By_PkArgs = {
  compliance_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Events_Classification_ResumesArgs = {
  where: Compliance_Events_Classification_Resumes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Events_Classification_Resumes_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Events_HourlyArgs = {
  where: Compliance_Events_Hourly_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Events_Hourly_By_PkArgs = {
  compliance_id: Scalars['Int'];
  hour: Scalars['timestamptz'];
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Events_Status_HourlyArgs = {
  where: Compliance_Events_Status_Hourly_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Events_Status_Hourly_By_PkArgs = {
  compliance_id: Scalars['Int'];
  hour: Scalars['timestamptz'];
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Group_ContactsArgs = {
  where: Compliance_Group_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Group_Contacts_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Group_UsersArgs = {
  where: Compliance_Group_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Group_Users_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Compliance_GroupsArgs = {
  where: Compliance_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Messages_HourlyArgs = {
  where: Compliance_Messages_Hourly_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Messages_Hourly_By_PkArgs = {
  compliance_id: Scalars['Int'];
  hour: Scalars['timestamptz'];
};


/** mutation root */
export type Mutation_RootDelete_Compliance_PoliciesArgs = {
  where: Compliance_Policies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Policies_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Compliance_RulesArgs = {
  where: Compliance_Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Rules_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Compliance_TagsArgs = {
  where: Compliance_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ConsentArgs = {
  where: Consent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Consent_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Contact_ListArgs = {
  where: Contact_List_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contact_List_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_DuoArgs = {
  where: Duo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Duo_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_GroupsArgs = {
  where: Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Groups_UsersArgs = {
  where: Groups_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Groups_Users_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Invite_RulesArgs = {
  where: Invite_Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invite_Rules_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Invite_Rules_RecipientsArgs = {
  where: Invite_Rules_Recipients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invite_Rules_Recipients_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_License_RecordsArgs = {
  where: License_Records_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_License_Records_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_LinkArgs = {
  where: Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Link_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Link_DomainsArgs = {
  where: Link_Domains_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Link_Domains_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_LogsArgs = {
  where: Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Logs_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_NotificationsArgs = {
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notifications_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Phone_ProvidersArgs = {
  where: Phone_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Phone_Providers_By_PkArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_PhonesArgs = {
  where: Phones_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Phones_By_PkArgs = {
  id: Scalars['Int'];
  phone: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ProductsArgs = {
  where: Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Products_By_PkArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Relevant_ContactsArgs = {
  where: Relevant_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Relevant_Contacts_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Relevant_Contacts_TagsArgs = {
  where: Relevant_Contacts_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Relevant_Contacts_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_RolesArgs = {
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Roles_By_PkArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Roles_TeamsArgs = {
  where: Roles_Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Roles_Teams_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Roles_UsersArgs = {
  where: Roles_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Roles_Users_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_RollupsArgs = {
  where: Rollups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rollups_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Subscription_ProvidersArgs = {
  where: Subscription_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Providers_By_PkArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_SubscriptionsArgs = {
  where: Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscriptions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TagsArgs = {
  where: Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TeamsArgs = {
  where: Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Teams_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Teams_SettingsArgs = {
  where: Teams_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Teams_Settings_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Teams_TemplatesArgs = {
  where: Teams_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Teams_Templates_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Teams_UsersArgs = {
  where: Teams_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Teams_Users_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TemplatesArgs = {
  where: Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Templates_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TenantArgs = {
  where: Tenant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenant_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_TokensArgs = {
  where: Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tokens_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Auth_CodesArgs = {
  where: User_Auth_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Auth_Codes_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Web_ContactsArgs = {
  where: Web_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Web_Contacts_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Web_MessagesArgs = {
  where: Web_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Web_Messages_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Web_Qr_CodesArgs = {
  where: Web_Qr_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Web_Qr_Codes_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp__MessageTomessage_UpdateArgs = {
  where: Whatsapp__MessageTomessage_Update_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_ChatArgs = {
  where: Whatsapp_Chat_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Chat_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_ContactArgs = {
  where: Whatsapp_Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Contact_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_MessageArgs = {
  where: Whatsapp_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Message_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Message_UpdateArgs = {
  where: Whatsapp_Message_Update_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Message_Update_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_SessionArgs = {
  where: Whatsapp_Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Session_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Session_CredentialArgs = {
  where: Whatsapp_Session_Credential_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Session_Credential_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Session_History_SyncArgs = {
  where: Whatsapp_Session_History_Sync_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Session_History_Sync_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Whatsapp_Session_KeyArgs = {
  where: Whatsapp_Session_Key_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Wos_SyncArgs = {
  where: Wos_Sync_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Wos_Sync_By_PkArgs = {
  last_event_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ws_ContactsArgs = {
  where: Ws_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ws_Contacts_By_PkArgs = {
  phone: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ws_History_SyncArgs = {
  where: Ws_History_Sync_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ws_History_Sync_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ws_MessagesArgs = {
  where: Ws_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ws_Messages_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Ws_ServersArgs = {
  where: Ws_Servers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ws_Servers_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Ws_SessionsArgs = {
  where: Ws_Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ws_Sessions_By_PkArgs = {
  uuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ws_Sessions_CredentialsArgs = {
  where: Ws_Sessions_Credentials_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ws_Sessions_Credentials_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Ws_Sessions_KeysArgs = {
  where: Ws_Sessions_Keys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ws_Sessions_Keys_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Ws_Sessions_Signal_KeysArgs = {
  where: Ws_Sessions_Signal_Keys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ws_Sessions_Signal_Keys_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Ws_Sessions_StatsArgs = {
  where: Ws_Sessions_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ws_Sessions_Stats_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootGetMessagesAnalysisArgs = {
  object: GetMessagesAnalysisInput;
};


/** mutation root */
export type Mutation_RootImportCsvArgs = {
  complianceId: Scalars['Int'];
  csvDataRows: Array<InputMaybe<CsvDataRowInput>>;
  disableContacts?: InputMaybe<Scalars['Boolean']>;
  roleId: Scalars['Int'];
  teamId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootImportCsvDiffArgs = {
  complianceId: Scalars['Int'];
  csvDataRows: Array<InputMaybe<CsvDataRowInput>>;
};


/** mutation root */
export type Mutation_RootImportCsvManagersArgs = {
  complianceId: Scalars['Int'];
  csvRows: Array<InputMaybe<CsvManagerRow>>;
  roleId: Scalars['Int'];
  teamId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootImportCsvManagersDiffArgs = {
  complianceId: Scalars['Int'];
  csvRows: Array<InputMaybe<CsvManagerRow>>;
};


/** mutation root */
export type Mutation_RootImportCsvRelevantContactsArgs = {
  complianceId: Scalars['Int'];
  relevantContactsCsvRows?: InputMaybe<Array<RelevantContactsCsvRow>>;
  removeContacts?: InputMaybe<Scalars['Boolean']>;
  teamId: Scalars['Int'];
  userId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootImportCsvRelevantContactsDiffArgs = {
  complianceId: Scalars['Int'];
  relevantContactsCsvRows?: InputMaybe<Array<RelevantContactsCsvRow>>;
};


/** mutation root */
export type Mutation_RootImportCsvRulesArgs = {
  complianceId: Scalars['Int'];
  csvRuleRows: Array<InputMaybe<CsvRuleRow>>;
  disableRules: Scalars['Boolean'];
};


/** mutation root */
export type Mutation_RootImportCsvRulesDiffArgs = {
  complianceId: Scalars['Int'];
  csvRuleRows: Array<InputMaybe<CsvRuleRow>>;
};


/** mutation root */
export type Mutation_RootInsertComplianceContactsArgs = {
  compliance_contacts: Array<InsertComplianceContactsInput>;
};


/** mutation root */
export type Mutation_RootInsertUsersArgs = {
  users: Array<UsersInsert>;
};


/** mutation root */
export type Mutation_RootInsert_Browser_SessionsArgs = {
  objects: Array<Browser_Sessions_Insert_Input>;
  on_conflict?: InputMaybe<Browser_Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Browser_Sessions_OneArgs = {
  object: Browser_Sessions_Insert_Input;
  on_conflict?: InputMaybe<Browser_Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_ListArgs = {
  objects: Array<Chat_List_Insert_Input>;
  on_conflict?: InputMaybe<Chat_List_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_List_OneArgs = {
  object: Chat_List_Insert_Input;
  on_conflict?: InputMaybe<Chat_List_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ComplianceArgs = {
  objects: Array<Compliance_Insert_Input>;
  on_conflict?: InputMaybe<Compliance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_ContactsArgs = {
  objects: Array<Compliance_Contacts_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Contacts_OneArgs = {
  object: Compliance_Contacts_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Contacts_RawArgs = {
  objects: Array<Compliance_Contacts_Raw_Insert_Input>;
  on_conflict?: InputMaybe<Compliance_Contacts_Raw_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Contacts_Raw_OneArgs = {
  object: Compliance_Contacts_Raw_Insert_Input;
  on_conflict?: InputMaybe<Compliance_Contacts_Raw_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Contacts_Stats_Json_SetofArgs = {
  objects: Array<Compliance_Contacts_Stats_Json_Setof_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Contacts_Stats_Json_Setof_OneArgs = {
  object: Compliance_Contacts_Stats_Json_Setof_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Contacts_Stats_SetofArgs = {
  objects: Array<Compliance_Contacts_Stats_Setof_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Contacts_Stats_Setof_OneArgs = {
  object: Compliance_Contacts_Stats_Setof_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_EventsArgs = {
  objects: Array<Compliance_Events_Insert_Input>;
  on_conflict?: InputMaybe<Compliance_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Events_Classification_GoalsArgs = {
  objects: Array<Compliance_Events_Classification_Goals_Insert_Input>;
  on_conflict?: InputMaybe<Compliance_Events_Classification_Goals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Events_Classification_Goals_OneArgs = {
  object: Compliance_Events_Classification_Goals_Insert_Input;
  on_conflict?: InputMaybe<Compliance_Events_Classification_Goals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Events_Classification_ResumesArgs = {
  objects: Array<Compliance_Events_Classification_Resumes_Insert_Input>;
  on_conflict?: InputMaybe<Compliance_Events_Classification_Resumes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Events_Classification_Resumes_OneArgs = {
  object: Compliance_Events_Classification_Resumes_Insert_Input;
  on_conflict?: InputMaybe<Compliance_Events_Classification_Resumes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Events_HourlyArgs = {
  objects: Array<Compliance_Events_Hourly_Insert_Input>;
  on_conflict?: InputMaybe<Compliance_Events_Hourly_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Events_Hourly_OneArgs = {
  object: Compliance_Events_Hourly_Insert_Input;
  on_conflict?: InputMaybe<Compliance_Events_Hourly_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Events_OneArgs = {
  object: Compliance_Events_Insert_Input;
  on_conflict?: InputMaybe<Compliance_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Events_Status_HourlyArgs = {
  objects: Array<Compliance_Events_Status_Hourly_Insert_Input>;
  on_conflict?: InputMaybe<Compliance_Events_Status_Hourly_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Events_Status_Hourly_OneArgs = {
  object: Compliance_Events_Status_Hourly_Insert_Input;
  on_conflict?: InputMaybe<Compliance_Events_Status_Hourly_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Group_ContactsArgs = {
  objects: Array<Compliance_Group_Contacts_Insert_Input>;
  on_conflict?: InputMaybe<Compliance_Group_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Group_Contacts_OneArgs = {
  object: Compliance_Group_Contacts_Insert_Input;
  on_conflict?: InputMaybe<Compliance_Group_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Group_UsersArgs = {
  objects: Array<Compliance_Group_Users_Insert_Input>;
  on_conflict?: InputMaybe<Compliance_Group_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Group_Users_OneArgs = {
  object: Compliance_Group_Users_Insert_Input;
  on_conflict?: InputMaybe<Compliance_Group_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_GroupsArgs = {
  objects: Array<Compliance_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Compliance_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Groups_OneArgs = {
  object: Compliance_Groups_Insert_Input;
  on_conflict?: InputMaybe<Compliance_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Messages_HourlyArgs = {
  objects: Array<Compliance_Messages_Hourly_Insert_Input>;
  on_conflict?: InputMaybe<Compliance_Messages_Hourly_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Messages_Hourly_OneArgs = {
  object: Compliance_Messages_Hourly_Insert_Input;
  on_conflict?: InputMaybe<Compliance_Messages_Hourly_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_OneArgs = {
  object: Compliance_Insert_Input;
  on_conflict?: InputMaybe<Compliance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_PoliciesArgs = {
  objects: Array<Compliance_Policies_Insert_Input>;
  on_conflict?: InputMaybe<Compliance_Policies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Policies_OneArgs = {
  object: Compliance_Policies_Insert_Input;
  on_conflict?: InputMaybe<Compliance_Policies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_RulesArgs = {
  objects: Array<Compliance_Rules_Insert_Input>;
  on_conflict?: InputMaybe<Compliance_Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Rules_OneArgs = {
  object: Compliance_Rules_Insert_Input;
  on_conflict?: InputMaybe<Compliance_Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_TagsArgs = {
  objects: Array<Compliance_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Compliance_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Compliance_Tags_OneArgs = {
  object: Compliance_Tags_Insert_Input;
  on_conflict?: InputMaybe<Compliance_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConsentArgs = {
  objects: Array<Consent_Insert_Input>;
  on_conflict?: InputMaybe<Consent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consent_OneArgs = {
  object: Consent_Insert_Input;
  on_conflict?: InputMaybe<Consent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contact_ListArgs = {
  objects: Array<Contact_List_Insert_Input>;
  on_conflict?: InputMaybe<Contact_List_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contact_List_OneArgs = {
  object: Contact_List_Insert_Input;
  on_conflict?: InputMaybe<Contact_List_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DuoArgs = {
  objects: Array<Duo_Insert_Input>;
  on_conflict?: InputMaybe<Duo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Duo_OneArgs = {
  object: Duo_Insert_Input;
  on_conflict?: InputMaybe<Duo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GroupsArgs = {
  objects: Array<Groups_Insert_Input>;
  on_conflict?: InputMaybe<Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Groups_OneArgs = {
  object: Groups_Insert_Input;
  on_conflict?: InputMaybe<Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Groups_UsersArgs = {
  objects: Array<Groups_Users_Insert_Input>;
  on_conflict?: InputMaybe<Groups_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Groups_Users_OneArgs = {
  object: Groups_Users_Insert_Input;
  on_conflict?: InputMaybe<Groups_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invite_RulesArgs = {
  objects: Array<Invite_Rules_Insert_Input>;
  on_conflict?: InputMaybe<Invite_Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invite_Rules_OneArgs = {
  object: Invite_Rules_Insert_Input;
  on_conflict?: InputMaybe<Invite_Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invite_Rules_RecipientsArgs = {
  objects: Array<Invite_Rules_Recipients_Insert_Input>;
  on_conflict?: InputMaybe<Invite_Rules_Recipients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invite_Rules_Recipients_OneArgs = {
  object: Invite_Rules_Recipients_Insert_Input;
  on_conflict?: InputMaybe<Invite_Rules_Recipients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_License_RecordsArgs = {
  objects: Array<License_Records_Insert_Input>;
  on_conflict?: InputMaybe<License_Records_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_License_Records_OneArgs = {
  object: License_Records_Insert_Input;
  on_conflict?: InputMaybe<License_Records_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LinkArgs = {
  objects: Array<Link_Insert_Input>;
  on_conflict?: InputMaybe<Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Link_DomainsArgs = {
  objects: Array<Link_Domains_Insert_Input>;
  on_conflict?: InputMaybe<Link_Domains_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Link_Domains_OneArgs = {
  object: Link_Domains_Insert_Input;
  on_conflict?: InputMaybe<Link_Domains_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Link_OneArgs = {
  object: Link_Insert_Input;
  on_conflict?: InputMaybe<Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LogsArgs = {
  objects: Array<Logs_Insert_Input>;
  on_conflict?: InputMaybe<Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Logs_OneArgs = {
  object: Logs_Insert_Input;
  on_conflict?: InputMaybe<Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationsArgs = {
  objects: Array<Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notifications_OneArgs = {
  object: Notifications_Insert_Input;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Phone_ProvidersArgs = {
  objects: Array<Phone_Providers_Insert_Input>;
  on_conflict?: InputMaybe<Phone_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Phone_Providers_OneArgs = {
  object: Phone_Providers_Insert_Input;
  on_conflict?: InputMaybe<Phone_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PhonesArgs = {
  objects: Array<Phones_Insert_Input>;
  on_conflict?: InputMaybe<Phones_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Phones_OneArgs = {
  object: Phones_Insert_Input;
  on_conflict?: InputMaybe<Phones_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductsArgs = {
  objects: Array<Products_Insert_Input>;
  on_conflict?: InputMaybe<Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_OneArgs = {
  object: Products_Insert_Input;
  on_conflict?: InputMaybe<Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Relevant_ContactsArgs = {
  objects: Array<Relevant_Contacts_Insert_Input>;
  on_conflict?: InputMaybe<Relevant_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Relevant_Contacts_OneArgs = {
  object: Relevant_Contacts_Insert_Input;
  on_conflict?: InputMaybe<Relevant_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Relevant_Contacts_TagsArgs = {
  objects: Array<Relevant_Contacts_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Relevant_Contacts_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Relevant_Contacts_Tags_OneArgs = {
  object: Relevant_Contacts_Tags_Insert_Input;
  on_conflict?: InputMaybe<Relevant_Contacts_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RolesArgs = {
  objects: Array<Roles_Insert_Input>;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_OneArgs = {
  object: Roles_Insert_Input;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_TeamsArgs = {
  objects: Array<Roles_Teams_Insert_Input>;
  on_conflict?: InputMaybe<Roles_Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_Teams_OneArgs = {
  object: Roles_Teams_Insert_Input;
  on_conflict?: InputMaybe<Roles_Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_UsersArgs = {
  objects: Array<Roles_Users_Insert_Input>;
  on_conflict?: InputMaybe<Roles_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_Users_OneArgs = {
  object: Roles_Users_Insert_Input;
  on_conflict?: InputMaybe<Roles_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RollupsArgs = {
  objects: Array<Rollups_Insert_Input>;
  on_conflict?: InputMaybe<Rollups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rollups_OneArgs = {
  object: Rollups_Insert_Input;
  on_conflict?: InputMaybe<Rollups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_ProvidersArgs = {
  objects: Array<Subscription_Providers_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Providers_OneArgs = {
  object: Subscription_Providers_Insert_Input;
  on_conflict?: InputMaybe<Subscription_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubscriptionsArgs = {
  objects: Array<Subscriptions_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscriptions_OneArgs = {
  object: Subscriptions_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TagsArgs = {
  objects: Array<Tags_Insert_Input>;
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tags_OneArgs = {
  object: Tags_Insert_Input;
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TeamsArgs = {
  objects: Array<Teams_Insert_Input>;
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_OneArgs = {
  object: Teams_Insert_Input;
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_SettingsArgs = {
  objects: Array<Teams_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Teams_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_Settings_OneArgs = {
  object: Teams_Settings_Insert_Input;
  on_conflict?: InputMaybe<Teams_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_TemplatesArgs = {
  objects: Array<Teams_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Teams_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_Templates_OneArgs = {
  object: Teams_Templates_Insert_Input;
  on_conflict?: InputMaybe<Teams_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_UsersArgs = {
  objects: Array<Teams_Users_Insert_Input>;
  on_conflict?: InputMaybe<Teams_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_Users_OneArgs = {
  object: Teams_Users_Insert_Input;
  on_conflict?: InputMaybe<Teams_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TemplatesArgs = {
  objects: Array<Templates_Insert_Input>;
  on_conflict?: InputMaybe<Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Templates_OneArgs = {
  object: Templates_Insert_Input;
  on_conflict?: InputMaybe<Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantArgs = {
  objects: Array<Tenant_Insert_Input>;
  on_conflict?: InputMaybe<Tenant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenant_OneArgs = {
  object: Tenant_Insert_Input;
  on_conflict?: InputMaybe<Tenant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TokensArgs = {
  objects: Array<Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tokens_OneArgs = {
  object: Tokens_Insert_Input;
  on_conflict?: InputMaybe<Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Auth_CodesArgs = {
  objects: Array<User_Auth_Codes_Insert_Input>;
  on_conflict?: InputMaybe<User_Auth_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Auth_Codes_OneArgs = {
  object: User_Auth_Codes_Insert_Input;
  on_conflict?: InputMaybe<User_Auth_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Web_ContactsArgs = {
  objects: Array<Web_Contacts_Insert_Input>;
  on_conflict?: InputMaybe<Web_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Web_Contacts_OneArgs = {
  object: Web_Contacts_Insert_Input;
  on_conflict?: InputMaybe<Web_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Web_MessagesArgs = {
  objects: Array<Web_Messages_Insert_Input>;
  on_conflict?: InputMaybe<Web_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Web_Messages_OneArgs = {
  object: Web_Messages_Insert_Input;
  on_conflict?: InputMaybe<Web_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Web_Qr_CodesArgs = {
  objects: Array<Web_Qr_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Web_Qr_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Web_Qr_Codes_OneArgs = {
  object: Web_Qr_Codes_Insert_Input;
  on_conflict?: InputMaybe<Web_Qr_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp__MessageTomessage_UpdateArgs = {
  objects: Array<Whatsapp__MessageTomessage_Update_Insert_Input>;
  on_conflict?: InputMaybe<Whatsapp__MessageTomessage_Update_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp__MessageTomessage_Update_OneArgs = {
  object: Whatsapp__MessageTomessage_Update_Insert_Input;
  on_conflict?: InputMaybe<Whatsapp__MessageTomessage_Update_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_ChatArgs = {
  objects: Array<Whatsapp_Chat_Insert_Input>;
  on_conflict?: InputMaybe<Whatsapp_Chat_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Chat_OneArgs = {
  object: Whatsapp_Chat_Insert_Input;
  on_conflict?: InputMaybe<Whatsapp_Chat_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_ContactArgs = {
  objects: Array<Whatsapp_Contact_Insert_Input>;
  on_conflict?: InputMaybe<Whatsapp_Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Contact_OneArgs = {
  object: Whatsapp_Contact_Insert_Input;
  on_conflict?: InputMaybe<Whatsapp_Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_MessageArgs = {
  objects: Array<Whatsapp_Message_Insert_Input>;
  on_conflict?: InputMaybe<Whatsapp_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Message_OneArgs = {
  object: Whatsapp_Message_Insert_Input;
  on_conflict?: InputMaybe<Whatsapp_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Message_UpdateArgs = {
  objects: Array<Whatsapp_Message_Update_Insert_Input>;
  on_conflict?: InputMaybe<Whatsapp_Message_Update_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Message_Update_OneArgs = {
  object: Whatsapp_Message_Update_Insert_Input;
  on_conflict?: InputMaybe<Whatsapp_Message_Update_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_SessionArgs = {
  objects: Array<Whatsapp_Session_Insert_Input>;
  on_conflict?: InputMaybe<Whatsapp_Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Session_CredentialArgs = {
  objects: Array<Whatsapp_Session_Credential_Insert_Input>;
  on_conflict?: InputMaybe<Whatsapp_Session_Credential_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Session_Credential_OneArgs = {
  object: Whatsapp_Session_Credential_Insert_Input;
  on_conflict?: InputMaybe<Whatsapp_Session_Credential_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Session_History_SyncArgs = {
  objects: Array<Whatsapp_Session_History_Sync_Insert_Input>;
  on_conflict?: InputMaybe<Whatsapp_Session_History_Sync_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Session_History_Sync_OneArgs = {
  object: Whatsapp_Session_History_Sync_Insert_Input;
  on_conflict?: InputMaybe<Whatsapp_Session_History_Sync_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Session_KeyArgs = {
  objects: Array<Whatsapp_Session_Key_Insert_Input>;
  on_conflict?: InputMaybe<Whatsapp_Session_Key_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Session_Key_OneArgs = {
  object: Whatsapp_Session_Key_Insert_Input;
  on_conflict?: InputMaybe<Whatsapp_Session_Key_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Whatsapp_Session_OneArgs = {
  object: Whatsapp_Session_Insert_Input;
  on_conflict?: InputMaybe<Whatsapp_Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wos_SyncArgs = {
  objects: Array<Wos_Sync_Insert_Input>;
  on_conflict?: InputMaybe<Wos_Sync_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wos_Sync_OneArgs = {
  object: Wos_Sync_Insert_Input;
  on_conflict?: InputMaybe<Wos_Sync_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_ContactsArgs = {
  objects: Array<Ws_Contacts_Insert_Input>;
  on_conflict?: InputMaybe<Ws_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_Contacts_OneArgs = {
  object: Ws_Contacts_Insert_Input;
  on_conflict?: InputMaybe<Ws_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_History_SyncArgs = {
  objects: Array<Ws_History_Sync_Insert_Input>;
  on_conflict?: InputMaybe<Ws_History_Sync_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_History_Sync_OneArgs = {
  object: Ws_History_Sync_Insert_Input;
  on_conflict?: InputMaybe<Ws_History_Sync_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_MessagesArgs = {
  objects: Array<Ws_Messages_Insert_Input>;
  on_conflict?: InputMaybe<Ws_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_Messages_OneArgs = {
  object: Ws_Messages_Insert_Input;
  on_conflict?: InputMaybe<Ws_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_ServersArgs = {
  objects: Array<Ws_Servers_Insert_Input>;
  on_conflict?: InputMaybe<Ws_Servers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_Servers_OneArgs = {
  object: Ws_Servers_Insert_Input;
  on_conflict?: InputMaybe<Ws_Servers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_SessionsArgs = {
  objects: Array<Ws_Sessions_Insert_Input>;
  on_conflict?: InputMaybe<Ws_Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_Sessions_CredentialsArgs = {
  objects: Array<Ws_Sessions_Credentials_Insert_Input>;
  on_conflict?: InputMaybe<Ws_Sessions_Credentials_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_Sessions_Credentials_OneArgs = {
  object: Ws_Sessions_Credentials_Insert_Input;
  on_conflict?: InputMaybe<Ws_Sessions_Credentials_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_Sessions_KeysArgs = {
  objects: Array<Ws_Sessions_Keys_Insert_Input>;
  on_conflict?: InputMaybe<Ws_Sessions_Keys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_Sessions_Keys_OneArgs = {
  object: Ws_Sessions_Keys_Insert_Input;
  on_conflict?: InputMaybe<Ws_Sessions_Keys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_Sessions_OneArgs = {
  object: Ws_Sessions_Insert_Input;
  on_conflict?: InputMaybe<Ws_Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_Sessions_Signal_KeysArgs = {
  objects: Array<Ws_Sessions_Signal_Keys_Insert_Input>;
  on_conflict?: InputMaybe<Ws_Sessions_Signal_Keys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_Sessions_Signal_Keys_OneArgs = {
  object: Ws_Sessions_Signal_Keys_Insert_Input;
  on_conflict?: InputMaybe<Ws_Sessions_Signal_Keys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_Sessions_StatsArgs = {
  objects: Array<Ws_Sessions_Stats_Insert_Input>;
  on_conflict?: InputMaybe<Ws_Sessions_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ws_Sessions_Stats_OneArgs = {
  object: Ws_Sessions_Stats_Insert_Input;
  on_conflict?: InputMaybe<Ws_Sessions_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInviteUsersArgs = {
  invitingUser?: InputMaybe<InvitingUser>;
  users: Array<UsersInvite>;
};


/** mutation root */
export type Mutation_RootLambdasContactAuthArgs = {
  object: ContactAuthInput;
};


/** mutation root */
export type Mutation_RootLambdasScanContactMessagesArgs = {
  object: LambdasScanContactMessagesInput;
};


/** mutation root */
export type Mutation_RootLogScanPageOpenArgs = {
  object: ScanPageOpenInput;
};


/** mutation root */
export type Mutation_RootLogScanQrcodeArgs = {
  object: ScanQrcodeInput;
};


/** mutation root */
export type Mutation_RootRefreshJwtTokenArgs = {
  team_id?: InputMaybe<Scalars['Int']>;
};


/** mutation root */
export type Mutation_RootRefreshWosTokenArgs = {
  team_id?: InputMaybe<Scalars['Int']>;
};


/** mutation root */
export type Mutation_RootReinviteContactsArgs = {
  complianceId?: InputMaybe<Scalars['Int']>;
  contacts: Array<ReinviteContact>;
  ignoreConnecteds?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['Int']>;
  useTemporal?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<CurrentUser>;
};


/** mutation root */
export type Mutation_RootRescanComplianceMessagesArgs = {
  minutes?: InputMaybe<Scalars['Int']>;
};


/** mutation root */
export type Mutation_RootResetPasswordArgs = {
  object: ResetPasswordInput;
};


/** mutation root */
export type Mutation_RootSigninArgs = {
  object: SigninInput;
};


/** mutation root */
export type Mutation_RootSignupArgs = {
  object: SignupInput;
};


/** mutation root */
export type Mutation_RootTwilioSendAuthCodeArgs = {
  object: SendWhatsAppAuthCodeInput;
};


/** mutation root */
export type Mutation_RootTwilioVerifyWhatsAppArgs = {
  object: VerifyWhatsAppInput;
};


/** mutation root */
export type Mutation_RootUpdateUserArgs = {
  object: UpdateUserInput;
};


/** mutation root */
export type Mutation_RootUpdate_Browser_SessionsArgs = {
  _inc?: InputMaybe<Browser_Sessions_Inc_Input>;
  _set?: InputMaybe<Browser_Sessions_Set_Input>;
  where: Browser_Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Browser_Sessions_By_PkArgs = {
  _inc?: InputMaybe<Browser_Sessions_Inc_Input>;
  _set?: InputMaybe<Browser_Sessions_Set_Input>;
  pk_columns: Browser_Sessions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Browser_Sessions_ManyArgs = {
  updates: Array<Browser_Sessions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_ListArgs = {
  _inc?: InputMaybe<Chat_List_Inc_Input>;
  _set?: InputMaybe<Chat_List_Set_Input>;
  where: Chat_List_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_List_By_PkArgs = {
  _inc?: InputMaybe<Chat_List_Inc_Input>;
  _set?: InputMaybe<Chat_List_Set_Input>;
  pk_columns: Chat_List_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_List_ManyArgs = {
  updates: Array<Chat_List_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ComplianceArgs = {
  _append?: InputMaybe<Compliance_Append_Input>;
  _delete_at_path?: InputMaybe<Compliance_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Compliance_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Compliance_Delete_Key_Input>;
  _inc?: InputMaybe<Compliance_Inc_Input>;
  _prepend?: InputMaybe<Compliance_Prepend_Input>;
  _set?: InputMaybe<Compliance_Set_Input>;
  where: Compliance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_By_PkArgs = {
  _append?: InputMaybe<Compliance_Append_Input>;
  _delete_at_path?: InputMaybe<Compliance_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Compliance_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Compliance_Delete_Key_Input>;
  _inc?: InputMaybe<Compliance_Inc_Input>;
  _prepend?: InputMaybe<Compliance_Prepend_Input>;
  _set?: InputMaybe<Compliance_Set_Input>;
  pk_columns: Compliance_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_ContactsArgs = {
  _append?: InputMaybe<Compliance_Contacts_Append_Input>;
  _delete_at_path?: InputMaybe<Compliance_Contacts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Compliance_Contacts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Compliance_Contacts_Delete_Key_Input>;
  _inc?: InputMaybe<Compliance_Contacts_Inc_Input>;
  _prepend?: InputMaybe<Compliance_Contacts_Prepend_Input>;
  _set?: InputMaybe<Compliance_Contacts_Set_Input>;
  where: Compliance_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Contacts_ManyArgs = {
  updates: Array<Compliance_Contacts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Contacts_RawArgs = {
  _append?: InputMaybe<Compliance_Contacts_Raw_Append_Input>;
  _delete_at_path?: InputMaybe<Compliance_Contacts_Raw_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Compliance_Contacts_Raw_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Compliance_Contacts_Raw_Delete_Key_Input>;
  _inc?: InputMaybe<Compliance_Contacts_Raw_Inc_Input>;
  _prepend?: InputMaybe<Compliance_Contacts_Raw_Prepend_Input>;
  _set?: InputMaybe<Compliance_Contacts_Raw_Set_Input>;
  where: Compliance_Contacts_Raw_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Contacts_Raw_By_PkArgs = {
  _append?: InputMaybe<Compliance_Contacts_Raw_Append_Input>;
  _delete_at_path?: InputMaybe<Compliance_Contacts_Raw_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Compliance_Contacts_Raw_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Compliance_Contacts_Raw_Delete_Key_Input>;
  _inc?: InputMaybe<Compliance_Contacts_Raw_Inc_Input>;
  _prepend?: InputMaybe<Compliance_Contacts_Raw_Prepend_Input>;
  _set?: InputMaybe<Compliance_Contacts_Raw_Set_Input>;
  pk_columns: Compliance_Contacts_Raw_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Contacts_Raw_ManyArgs = {
  updates: Array<Compliance_Contacts_Raw_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Contacts_Stats_Json_SetofArgs = {
  _append?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Append_Input>;
  _delete_at_path?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Delete_Key_Input>;
  _inc?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Inc_Input>;
  _prepend?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Prepend_Input>;
  _set?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Set_Input>;
  where: Compliance_Contacts_Stats_Json_Setof_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Contacts_Stats_Json_Setof_ManyArgs = {
  updates: Array<Compliance_Contacts_Stats_Json_Setof_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Contacts_Stats_SetofArgs = {
  _inc?: InputMaybe<Compliance_Contacts_Stats_Setof_Inc_Input>;
  _set?: InputMaybe<Compliance_Contacts_Stats_Setof_Set_Input>;
  where: Compliance_Contacts_Stats_Setof_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Contacts_Stats_Setof_ManyArgs = {
  updates: Array<Compliance_Contacts_Stats_Setof_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_EventsArgs = {
  _append?: InputMaybe<Compliance_Events_Append_Input>;
  _delete_at_path?: InputMaybe<Compliance_Events_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Compliance_Events_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Compliance_Events_Delete_Key_Input>;
  _inc?: InputMaybe<Compliance_Events_Inc_Input>;
  _prepend?: InputMaybe<Compliance_Events_Prepend_Input>;
  _set?: InputMaybe<Compliance_Events_Set_Input>;
  where: Compliance_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Events_By_PkArgs = {
  _append?: InputMaybe<Compliance_Events_Append_Input>;
  _delete_at_path?: InputMaybe<Compliance_Events_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Compliance_Events_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Compliance_Events_Delete_Key_Input>;
  _inc?: InputMaybe<Compliance_Events_Inc_Input>;
  _prepend?: InputMaybe<Compliance_Events_Prepend_Input>;
  _set?: InputMaybe<Compliance_Events_Set_Input>;
  pk_columns: Compliance_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Events_Classification_GoalsArgs = {
  _inc?: InputMaybe<Compliance_Events_Classification_Goals_Inc_Input>;
  _set?: InputMaybe<Compliance_Events_Classification_Goals_Set_Input>;
  where: Compliance_Events_Classification_Goals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Events_Classification_Goals_By_PkArgs = {
  _inc?: InputMaybe<Compliance_Events_Classification_Goals_Inc_Input>;
  _set?: InputMaybe<Compliance_Events_Classification_Goals_Set_Input>;
  pk_columns: Compliance_Events_Classification_Goals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Events_Classification_Goals_ManyArgs = {
  updates: Array<Compliance_Events_Classification_Goals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Events_Classification_ResumesArgs = {
  _append?: InputMaybe<Compliance_Events_Classification_Resumes_Append_Input>;
  _delete_at_path?: InputMaybe<Compliance_Events_Classification_Resumes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Compliance_Events_Classification_Resumes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Compliance_Events_Classification_Resumes_Delete_Key_Input>;
  _inc?: InputMaybe<Compliance_Events_Classification_Resumes_Inc_Input>;
  _prepend?: InputMaybe<Compliance_Events_Classification_Resumes_Prepend_Input>;
  _set?: InputMaybe<Compliance_Events_Classification_Resumes_Set_Input>;
  where: Compliance_Events_Classification_Resumes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Events_Classification_Resumes_By_PkArgs = {
  _append?: InputMaybe<Compliance_Events_Classification_Resumes_Append_Input>;
  _delete_at_path?: InputMaybe<Compliance_Events_Classification_Resumes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Compliance_Events_Classification_Resumes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Compliance_Events_Classification_Resumes_Delete_Key_Input>;
  _inc?: InputMaybe<Compliance_Events_Classification_Resumes_Inc_Input>;
  _prepend?: InputMaybe<Compliance_Events_Classification_Resumes_Prepend_Input>;
  _set?: InputMaybe<Compliance_Events_Classification_Resumes_Set_Input>;
  pk_columns: Compliance_Events_Classification_Resumes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Events_Classification_Resumes_ManyArgs = {
  updates: Array<Compliance_Events_Classification_Resumes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Events_HourlyArgs = {
  _inc?: InputMaybe<Compliance_Events_Hourly_Inc_Input>;
  _set?: InputMaybe<Compliance_Events_Hourly_Set_Input>;
  where: Compliance_Events_Hourly_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Events_Hourly_By_PkArgs = {
  _inc?: InputMaybe<Compliance_Events_Hourly_Inc_Input>;
  _set?: InputMaybe<Compliance_Events_Hourly_Set_Input>;
  pk_columns: Compliance_Events_Hourly_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Events_Hourly_ManyArgs = {
  updates: Array<Compliance_Events_Hourly_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Events_ManyArgs = {
  updates: Array<Compliance_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Events_Status_HourlyArgs = {
  _inc?: InputMaybe<Compliance_Events_Status_Hourly_Inc_Input>;
  _set?: InputMaybe<Compliance_Events_Status_Hourly_Set_Input>;
  where: Compliance_Events_Status_Hourly_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Events_Status_Hourly_By_PkArgs = {
  _inc?: InputMaybe<Compliance_Events_Status_Hourly_Inc_Input>;
  _set?: InputMaybe<Compliance_Events_Status_Hourly_Set_Input>;
  pk_columns: Compliance_Events_Status_Hourly_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Events_Status_Hourly_ManyArgs = {
  updates: Array<Compliance_Events_Status_Hourly_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Group_ContactsArgs = {
  _inc?: InputMaybe<Compliance_Group_Contacts_Inc_Input>;
  _set?: InputMaybe<Compliance_Group_Contacts_Set_Input>;
  where: Compliance_Group_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Group_Contacts_By_PkArgs = {
  _inc?: InputMaybe<Compliance_Group_Contacts_Inc_Input>;
  _set?: InputMaybe<Compliance_Group_Contacts_Set_Input>;
  pk_columns: Compliance_Group_Contacts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Group_Contacts_ManyArgs = {
  updates: Array<Compliance_Group_Contacts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Group_UsersArgs = {
  _inc?: InputMaybe<Compliance_Group_Users_Inc_Input>;
  _set?: InputMaybe<Compliance_Group_Users_Set_Input>;
  where: Compliance_Group_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Group_Users_By_PkArgs = {
  _inc?: InputMaybe<Compliance_Group_Users_Inc_Input>;
  _set?: InputMaybe<Compliance_Group_Users_Set_Input>;
  pk_columns: Compliance_Group_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Group_Users_ManyArgs = {
  updates: Array<Compliance_Group_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_GroupsArgs = {
  _append?: InputMaybe<Compliance_Groups_Append_Input>;
  _delete_at_path?: InputMaybe<Compliance_Groups_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Compliance_Groups_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Compliance_Groups_Delete_Key_Input>;
  _inc?: InputMaybe<Compliance_Groups_Inc_Input>;
  _prepend?: InputMaybe<Compliance_Groups_Prepend_Input>;
  _set?: InputMaybe<Compliance_Groups_Set_Input>;
  where: Compliance_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Groups_By_PkArgs = {
  _append?: InputMaybe<Compliance_Groups_Append_Input>;
  _delete_at_path?: InputMaybe<Compliance_Groups_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Compliance_Groups_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Compliance_Groups_Delete_Key_Input>;
  _inc?: InputMaybe<Compliance_Groups_Inc_Input>;
  _prepend?: InputMaybe<Compliance_Groups_Prepend_Input>;
  _set?: InputMaybe<Compliance_Groups_Set_Input>;
  pk_columns: Compliance_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Groups_ManyArgs = {
  updates: Array<Compliance_Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_ManyArgs = {
  updates: Array<Compliance_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Messages_HourlyArgs = {
  _inc?: InputMaybe<Compliance_Messages_Hourly_Inc_Input>;
  _set?: InputMaybe<Compliance_Messages_Hourly_Set_Input>;
  where: Compliance_Messages_Hourly_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Messages_Hourly_By_PkArgs = {
  _inc?: InputMaybe<Compliance_Messages_Hourly_Inc_Input>;
  _set?: InputMaybe<Compliance_Messages_Hourly_Set_Input>;
  pk_columns: Compliance_Messages_Hourly_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Messages_Hourly_ManyArgs = {
  updates: Array<Compliance_Messages_Hourly_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_PoliciesArgs = {
  _append?: InputMaybe<Compliance_Policies_Append_Input>;
  _delete_at_path?: InputMaybe<Compliance_Policies_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Compliance_Policies_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Compliance_Policies_Delete_Key_Input>;
  _inc?: InputMaybe<Compliance_Policies_Inc_Input>;
  _prepend?: InputMaybe<Compliance_Policies_Prepend_Input>;
  _set?: InputMaybe<Compliance_Policies_Set_Input>;
  where: Compliance_Policies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Policies_By_PkArgs = {
  _append?: InputMaybe<Compliance_Policies_Append_Input>;
  _delete_at_path?: InputMaybe<Compliance_Policies_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Compliance_Policies_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Compliance_Policies_Delete_Key_Input>;
  _inc?: InputMaybe<Compliance_Policies_Inc_Input>;
  _prepend?: InputMaybe<Compliance_Policies_Prepend_Input>;
  _set?: InputMaybe<Compliance_Policies_Set_Input>;
  pk_columns: Compliance_Policies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Policies_ManyArgs = {
  updates: Array<Compliance_Policies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_RulesArgs = {
  _inc?: InputMaybe<Compliance_Rules_Inc_Input>;
  _set?: InputMaybe<Compliance_Rules_Set_Input>;
  where: Compliance_Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Rules_By_PkArgs = {
  _inc?: InputMaybe<Compliance_Rules_Inc_Input>;
  _set?: InputMaybe<Compliance_Rules_Set_Input>;
  pk_columns: Compliance_Rules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Rules_ManyArgs = {
  updates: Array<Compliance_Rules_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_TagsArgs = {
  _inc?: InputMaybe<Compliance_Tags_Inc_Input>;
  _set?: InputMaybe<Compliance_Tags_Set_Input>;
  where: Compliance_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Tags_By_PkArgs = {
  _inc?: InputMaybe<Compliance_Tags_Inc_Input>;
  _set?: InputMaybe<Compliance_Tags_Set_Input>;
  pk_columns: Compliance_Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Compliance_Tags_ManyArgs = {
  updates: Array<Compliance_Tags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConsentArgs = {
  _append?: InputMaybe<Consent_Append_Input>;
  _delete_at_path?: InputMaybe<Consent_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Consent_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Consent_Delete_Key_Input>;
  _inc?: InputMaybe<Consent_Inc_Input>;
  _prepend?: InputMaybe<Consent_Prepend_Input>;
  _set?: InputMaybe<Consent_Set_Input>;
  where: Consent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Consent_By_PkArgs = {
  _append?: InputMaybe<Consent_Append_Input>;
  _delete_at_path?: InputMaybe<Consent_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Consent_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Consent_Delete_Key_Input>;
  _inc?: InputMaybe<Consent_Inc_Input>;
  _prepend?: InputMaybe<Consent_Prepend_Input>;
  _set?: InputMaybe<Consent_Set_Input>;
  pk_columns: Consent_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Consent_ManyArgs = {
  updates: Array<Consent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_ListArgs = {
  _inc?: InputMaybe<Contact_List_Inc_Input>;
  _set?: InputMaybe<Contact_List_Set_Input>;
  where: Contact_List_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_List_By_PkArgs = {
  _inc?: InputMaybe<Contact_List_Inc_Input>;
  _set?: InputMaybe<Contact_List_Set_Input>;
  pk_columns: Contact_List_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_List_ManyArgs = {
  updates: Array<Contact_List_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DuoArgs = {
  _inc?: InputMaybe<Duo_Inc_Input>;
  _set?: InputMaybe<Duo_Set_Input>;
  where: Duo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Duo_By_PkArgs = {
  _inc?: InputMaybe<Duo_Inc_Input>;
  _set?: InputMaybe<Duo_Set_Input>;
  pk_columns: Duo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Duo_ManyArgs = {
  updates: Array<Duo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GroupsArgs = {
  _append?: InputMaybe<Groups_Append_Input>;
  _delete_at_path?: InputMaybe<Groups_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Groups_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Groups_Delete_Key_Input>;
  _inc?: InputMaybe<Groups_Inc_Input>;
  _prepend?: InputMaybe<Groups_Prepend_Input>;
  _set?: InputMaybe<Groups_Set_Input>;
  where: Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Groups_By_PkArgs = {
  _append?: InputMaybe<Groups_Append_Input>;
  _delete_at_path?: InputMaybe<Groups_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Groups_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Groups_Delete_Key_Input>;
  _inc?: InputMaybe<Groups_Inc_Input>;
  _prepend?: InputMaybe<Groups_Prepend_Input>;
  _set?: InputMaybe<Groups_Set_Input>;
  pk_columns: Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Groups_ManyArgs = {
  updates: Array<Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Groups_UsersArgs = {
  _inc?: InputMaybe<Groups_Users_Inc_Input>;
  _set?: InputMaybe<Groups_Users_Set_Input>;
  where: Groups_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Groups_Users_By_PkArgs = {
  _inc?: InputMaybe<Groups_Users_Inc_Input>;
  _set?: InputMaybe<Groups_Users_Set_Input>;
  pk_columns: Groups_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Groups_Users_ManyArgs = {
  updates: Array<Groups_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Invite_RulesArgs = {
  _inc?: InputMaybe<Invite_Rules_Inc_Input>;
  _set?: InputMaybe<Invite_Rules_Set_Input>;
  where: Invite_Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invite_Rules_By_PkArgs = {
  _inc?: InputMaybe<Invite_Rules_Inc_Input>;
  _set?: InputMaybe<Invite_Rules_Set_Input>;
  pk_columns: Invite_Rules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invite_Rules_ManyArgs = {
  updates: Array<Invite_Rules_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Invite_Rules_RecipientsArgs = {
  _inc?: InputMaybe<Invite_Rules_Recipients_Inc_Input>;
  _set?: InputMaybe<Invite_Rules_Recipients_Set_Input>;
  where: Invite_Rules_Recipients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invite_Rules_Recipients_By_PkArgs = {
  _inc?: InputMaybe<Invite_Rules_Recipients_Inc_Input>;
  _set?: InputMaybe<Invite_Rules_Recipients_Set_Input>;
  pk_columns: Invite_Rules_Recipients_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invite_Rules_Recipients_ManyArgs = {
  updates: Array<Invite_Rules_Recipients_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_License_RecordsArgs = {
  _inc?: InputMaybe<License_Records_Inc_Input>;
  _set?: InputMaybe<License_Records_Set_Input>;
  where: License_Records_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_License_Records_By_PkArgs = {
  _inc?: InputMaybe<License_Records_Inc_Input>;
  _set?: InputMaybe<License_Records_Set_Input>;
  pk_columns: License_Records_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_License_Records_ManyArgs = {
  updates: Array<License_Records_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LinkArgs = {
  _inc?: InputMaybe<Link_Inc_Input>;
  _set?: InputMaybe<Link_Set_Input>;
  where: Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Link_By_PkArgs = {
  _inc?: InputMaybe<Link_Inc_Input>;
  _set?: InputMaybe<Link_Set_Input>;
  pk_columns: Link_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Link_DomainsArgs = {
  _inc?: InputMaybe<Link_Domains_Inc_Input>;
  _set?: InputMaybe<Link_Domains_Set_Input>;
  where: Link_Domains_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Link_Domains_By_PkArgs = {
  _inc?: InputMaybe<Link_Domains_Inc_Input>;
  _set?: InputMaybe<Link_Domains_Set_Input>;
  pk_columns: Link_Domains_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Link_Domains_ManyArgs = {
  updates: Array<Link_Domains_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Link_ManyArgs = {
  updates: Array<Link_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LogsArgs = {
  _append?: InputMaybe<Logs_Append_Input>;
  _delete_at_path?: InputMaybe<Logs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Logs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Logs_Delete_Key_Input>;
  _inc?: InputMaybe<Logs_Inc_Input>;
  _prepend?: InputMaybe<Logs_Prepend_Input>;
  _set?: InputMaybe<Logs_Set_Input>;
  where: Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Logs_By_PkArgs = {
  _append?: InputMaybe<Logs_Append_Input>;
  _delete_at_path?: InputMaybe<Logs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Logs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Logs_Delete_Key_Input>;
  _inc?: InputMaybe<Logs_Inc_Input>;
  _prepend?: InputMaybe<Logs_Prepend_Input>;
  _set?: InputMaybe<Logs_Set_Input>;
  pk_columns: Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Logs_ManyArgs = {
  updates: Array<Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationsArgs = {
  _append?: InputMaybe<Notifications_Append_Input>;
  _delete_at_path?: InputMaybe<Notifications_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Notifications_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Notifications_Delete_Key_Input>;
  _inc?: InputMaybe<Notifications_Inc_Input>;
  _prepend?: InputMaybe<Notifications_Prepend_Input>;
  _set?: InputMaybe<Notifications_Set_Input>;
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_By_PkArgs = {
  _append?: InputMaybe<Notifications_Append_Input>;
  _delete_at_path?: InputMaybe<Notifications_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Notifications_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Notifications_Delete_Key_Input>;
  _inc?: InputMaybe<Notifications_Inc_Input>;
  _prepend?: InputMaybe<Notifications_Prepend_Input>;
  _set?: InputMaybe<Notifications_Set_Input>;
  pk_columns: Notifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_ManyArgs = {
  updates: Array<Notifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Phone_ProvidersArgs = {
  _inc?: InputMaybe<Phone_Providers_Inc_Input>;
  _set?: InputMaybe<Phone_Providers_Set_Input>;
  where: Phone_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Phone_Providers_By_PkArgs = {
  _inc?: InputMaybe<Phone_Providers_Inc_Input>;
  _set?: InputMaybe<Phone_Providers_Set_Input>;
  pk_columns: Phone_Providers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Phone_Providers_ManyArgs = {
  updates: Array<Phone_Providers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PhonesArgs = {
  _inc?: InputMaybe<Phones_Inc_Input>;
  _set?: InputMaybe<Phones_Set_Input>;
  where: Phones_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Phones_By_PkArgs = {
  _inc?: InputMaybe<Phones_Inc_Input>;
  _set?: InputMaybe<Phones_Set_Input>;
  pk_columns: Phones_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Phones_ManyArgs = {
  updates: Array<Phones_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductsArgs = {
  _inc?: InputMaybe<Products_Inc_Input>;
  _set?: InputMaybe<Products_Set_Input>;
  where: Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Products_By_PkArgs = {
  _inc?: InputMaybe<Products_Inc_Input>;
  _set?: InputMaybe<Products_Set_Input>;
  pk_columns: Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Products_ManyArgs = {
  updates: Array<Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Relevant_ContactsArgs = {
  _inc?: InputMaybe<Relevant_Contacts_Inc_Input>;
  _set?: InputMaybe<Relevant_Contacts_Set_Input>;
  where: Relevant_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Relevant_Contacts_By_PkArgs = {
  _inc?: InputMaybe<Relevant_Contacts_Inc_Input>;
  _set?: InputMaybe<Relevant_Contacts_Set_Input>;
  pk_columns: Relevant_Contacts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Relevant_Contacts_ManyArgs = {
  updates: Array<Relevant_Contacts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Relevant_Contacts_TagsArgs = {
  _inc?: InputMaybe<Relevant_Contacts_Tags_Inc_Input>;
  _set?: InputMaybe<Relevant_Contacts_Tags_Set_Input>;
  where: Relevant_Contacts_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Relevant_Contacts_Tags_By_PkArgs = {
  _inc?: InputMaybe<Relevant_Contacts_Tags_Inc_Input>;
  _set?: InputMaybe<Relevant_Contacts_Tags_Set_Input>;
  pk_columns: Relevant_Contacts_Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Relevant_Contacts_Tags_ManyArgs = {
  updates: Array<Relevant_Contacts_Tags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RolesArgs = {
  _append?: InputMaybe<Roles_Append_Input>;
  _delete_at_path?: InputMaybe<Roles_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Roles_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Roles_Delete_Key_Input>;
  _inc?: InputMaybe<Roles_Inc_Input>;
  _prepend?: InputMaybe<Roles_Prepend_Input>;
  _set?: InputMaybe<Roles_Set_Input>;
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_By_PkArgs = {
  _append?: InputMaybe<Roles_Append_Input>;
  _delete_at_path?: InputMaybe<Roles_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Roles_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Roles_Delete_Key_Input>;
  _inc?: InputMaybe<Roles_Inc_Input>;
  _prepend?: InputMaybe<Roles_Prepend_Input>;
  _set?: InputMaybe<Roles_Set_Input>;
  pk_columns: Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_ManyArgs = {
  updates: Array<Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_TeamsArgs = {
  _inc?: InputMaybe<Roles_Teams_Inc_Input>;
  _set?: InputMaybe<Roles_Teams_Set_Input>;
  where: Roles_Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_Teams_By_PkArgs = {
  _inc?: InputMaybe<Roles_Teams_Inc_Input>;
  _set?: InputMaybe<Roles_Teams_Set_Input>;
  pk_columns: Roles_Teams_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_Teams_ManyArgs = {
  updates: Array<Roles_Teams_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_UsersArgs = {
  _inc?: InputMaybe<Roles_Users_Inc_Input>;
  _set?: InputMaybe<Roles_Users_Set_Input>;
  where: Roles_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_Users_By_PkArgs = {
  _inc?: InputMaybe<Roles_Users_Inc_Input>;
  _set?: InputMaybe<Roles_Users_Set_Input>;
  pk_columns: Roles_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_Users_ManyArgs = {
  updates: Array<Roles_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RollupsArgs = {
  _inc?: InputMaybe<Rollups_Inc_Input>;
  _set?: InputMaybe<Rollups_Set_Input>;
  where: Rollups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rollups_By_PkArgs = {
  _inc?: InputMaybe<Rollups_Inc_Input>;
  _set?: InputMaybe<Rollups_Set_Input>;
  pk_columns: Rollups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rollups_ManyArgs = {
  updates: Array<Rollups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_ProvidersArgs = {
  _inc?: InputMaybe<Subscription_Providers_Inc_Input>;
  _set?: InputMaybe<Subscription_Providers_Set_Input>;
  where: Subscription_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Providers_By_PkArgs = {
  _inc?: InputMaybe<Subscription_Providers_Inc_Input>;
  _set?: InputMaybe<Subscription_Providers_Set_Input>;
  pk_columns: Subscription_Providers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Providers_ManyArgs = {
  updates: Array<Subscription_Providers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SubscriptionsArgs = {
  _inc?: InputMaybe<Subscriptions_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Set_Input>;
  where: Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_By_PkArgs = {
  _inc?: InputMaybe<Subscriptions_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Set_Input>;
  pk_columns: Subscriptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_ManyArgs = {
  updates: Array<Subscriptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TagsArgs = {
  _append?: InputMaybe<Tags_Append_Input>;
  _delete_at_path?: InputMaybe<Tags_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tags_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tags_Delete_Key_Input>;
  _inc?: InputMaybe<Tags_Inc_Input>;
  _prepend?: InputMaybe<Tags_Prepend_Input>;
  _set?: InputMaybe<Tags_Set_Input>;
  where: Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tags_By_PkArgs = {
  _append?: InputMaybe<Tags_Append_Input>;
  _delete_at_path?: InputMaybe<Tags_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tags_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tags_Delete_Key_Input>;
  _inc?: InputMaybe<Tags_Inc_Input>;
  _prepend?: InputMaybe<Tags_Prepend_Input>;
  _set?: InputMaybe<Tags_Set_Input>;
  pk_columns: Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tags_ManyArgs = {
  updates: Array<Tags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TeamsArgs = {
  _append?: InputMaybe<Teams_Append_Input>;
  _delete_at_path?: InputMaybe<Teams_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Teams_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Teams_Delete_Key_Input>;
  _inc?: InputMaybe<Teams_Inc_Input>;
  _prepend?: InputMaybe<Teams_Prepend_Input>;
  _set?: InputMaybe<Teams_Set_Input>;
  where: Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_By_PkArgs = {
  _append?: InputMaybe<Teams_Append_Input>;
  _delete_at_path?: InputMaybe<Teams_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Teams_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Teams_Delete_Key_Input>;
  _inc?: InputMaybe<Teams_Inc_Input>;
  _prepend?: InputMaybe<Teams_Prepend_Input>;
  _set?: InputMaybe<Teams_Set_Input>;
  pk_columns: Teams_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_ManyArgs = {
  updates: Array<Teams_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_SettingsArgs = {
  _append?: InputMaybe<Teams_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Teams_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Teams_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Teams_Settings_Delete_Key_Input>;
  _inc?: InputMaybe<Teams_Settings_Inc_Input>;
  _prepend?: InputMaybe<Teams_Settings_Prepend_Input>;
  _set?: InputMaybe<Teams_Settings_Set_Input>;
  where: Teams_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_Settings_By_PkArgs = {
  _append?: InputMaybe<Teams_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Teams_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Teams_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Teams_Settings_Delete_Key_Input>;
  _inc?: InputMaybe<Teams_Settings_Inc_Input>;
  _prepend?: InputMaybe<Teams_Settings_Prepend_Input>;
  _set?: InputMaybe<Teams_Settings_Set_Input>;
  pk_columns: Teams_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_Settings_ManyArgs = {
  updates: Array<Teams_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_TemplatesArgs = {
  _inc?: InputMaybe<Teams_Templates_Inc_Input>;
  _set?: InputMaybe<Teams_Templates_Set_Input>;
  where: Teams_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_Templates_By_PkArgs = {
  _inc?: InputMaybe<Teams_Templates_Inc_Input>;
  _set?: InputMaybe<Teams_Templates_Set_Input>;
  pk_columns: Teams_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_Templates_ManyArgs = {
  updates: Array<Teams_Templates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_UsersArgs = {
  _inc?: InputMaybe<Teams_Users_Inc_Input>;
  _set?: InputMaybe<Teams_Users_Set_Input>;
  where: Teams_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_Users_By_PkArgs = {
  _inc?: InputMaybe<Teams_Users_Inc_Input>;
  _set?: InputMaybe<Teams_Users_Set_Input>;
  pk_columns: Teams_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_Users_ManyArgs = {
  updates: Array<Teams_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TemplatesArgs = {
  _append?: InputMaybe<Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Templates_Delete_Key_Input>;
  _inc?: InputMaybe<Templates_Inc_Input>;
  _prepend?: InputMaybe<Templates_Prepend_Input>;
  _set?: InputMaybe<Templates_Set_Input>;
  where: Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Templates_By_PkArgs = {
  _append?: InputMaybe<Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Templates_Delete_Key_Input>;
  _inc?: InputMaybe<Templates_Inc_Input>;
  _prepend?: InputMaybe<Templates_Prepend_Input>;
  _set?: InputMaybe<Templates_Set_Input>;
  pk_columns: Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Templates_ManyArgs = {
  updates: Array<Templates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TenantArgs = {
  _set?: InputMaybe<Tenant_Set_Input>;
  where: Tenant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenant_By_PkArgs = {
  _set?: InputMaybe<Tenant_Set_Input>;
  pk_columns: Tenant_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenant_ManyArgs = {
  updates: Array<Tenant_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TokensArgs = {
  _inc?: InputMaybe<Tokens_Inc_Input>;
  _set?: InputMaybe<Tokens_Set_Input>;
  where: Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tokens_By_PkArgs = {
  _inc?: InputMaybe<Tokens_Inc_Input>;
  _set?: InputMaybe<Tokens_Set_Input>;
  pk_columns: Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tokens_ManyArgs = {
  updates: Array<Tokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_CodesArgs = {
  _inc?: InputMaybe<User_Auth_Codes_Inc_Input>;
  _set?: InputMaybe<User_Auth_Codes_Set_Input>;
  where: User_Auth_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_Codes_By_PkArgs = {
  _inc?: InputMaybe<User_Auth_Codes_Inc_Input>;
  _set?: InputMaybe<User_Auth_Codes_Set_Input>;
  pk_columns: User_Auth_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_Codes_ManyArgs = {
  updates: Array<User_Auth_Codes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Web_ContactsArgs = {
  _inc?: InputMaybe<Web_Contacts_Inc_Input>;
  _set?: InputMaybe<Web_Contacts_Set_Input>;
  where: Web_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Web_Contacts_By_PkArgs = {
  _inc?: InputMaybe<Web_Contacts_Inc_Input>;
  _set?: InputMaybe<Web_Contacts_Set_Input>;
  pk_columns: Web_Contacts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Web_Contacts_ManyArgs = {
  updates: Array<Web_Contacts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Web_MessagesArgs = {
  _append?: InputMaybe<Web_Messages_Append_Input>;
  _delete_at_path?: InputMaybe<Web_Messages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Web_Messages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Web_Messages_Delete_Key_Input>;
  _inc?: InputMaybe<Web_Messages_Inc_Input>;
  _prepend?: InputMaybe<Web_Messages_Prepend_Input>;
  _set?: InputMaybe<Web_Messages_Set_Input>;
  where: Web_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Web_Messages_By_PkArgs = {
  _append?: InputMaybe<Web_Messages_Append_Input>;
  _delete_at_path?: InputMaybe<Web_Messages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Web_Messages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Web_Messages_Delete_Key_Input>;
  _inc?: InputMaybe<Web_Messages_Inc_Input>;
  _prepend?: InputMaybe<Web_Messages_Prepend_Input>;
  _set?: InputMaybe<Web_Messages_Set_Input>;
  pk_columns: Web_Messages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Web_Messages_ManyArgs = {
  updates: Array<Web_Messages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Web_Qr_CodesArgs = {
  _inc?: InputMaybe<Web_Qr_Codes_Inc_Input>;
  _set?: InputMaybe<Web_Qr_Codes_Set_Input>;
  where: Web_Qr_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Web_Qr_Codes_By_PkArgs = {
  _inc?: InputMaybe<Web_Qr_Codes_Inc_Input>;
  _set?: InputMaybe<Web_Qr_Codes_Set_Input>;
  pk_columns: Web_Qr_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Web_Qr_Codes_ManyArgs = {
  updates: Array<Web_Qr_Codes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp__MessageTomessage_UpdateArgs = {
  _set?: InputMaybe<Whatsapp__MessageTomessage_Update_Set_Input>;
  where: Whatsapp__MessageTomessage_Update_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp__MessageTomessage_Update_ManyArgs = {
  updates: Array<Whatsapp__MessageTomessage_Update_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_ChatArgs = {
  _inc?: InputMaybe<Whatsapp_Chat_Inc_Input>;
  _set?: InputMaybe<Whatsapp_Chat_Set_Input>;
  where: Whatsapp_Chat_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Chat_By_PkArgs = {
  _inc?: InputMaybe<Whatsapp_Chat_Inc_Input>;
  _set?: InputMaybe<Whatsapp_Chat_Set_Input>;
  pk_columns: Whatsapp_Chat_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Chat_ManyArgs = {
  updates: Array<Whatsapp_Chat_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_ContactArgs = {
  _set?: InputMaybe<Whatsapp_Contact_Set_Input>;
  where: Whatsapp_Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Contact_By_PkArgs = {
  _set?: InputMaybe<Whatsapp_Contact_Set_Input>;
  pk_columns: Whatsapp_Contact_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Contact_ManyArgs = {
  updates: Array<Whatsapp_Contact_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_MessageArgs = {
  _append?: InputMaybe<Whatsapp_Message_Append_Input>;
  _delete_at_path?: InputMaybe<Whatsapp_Message_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Whatsapp_Message_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Whatsapp_Message_Delete_Key_Input>;
  _inc?: InputMaybe<Whatsapp_Message_Inc_Input>;
  _prepend?: InputMaybe<Whatsapp_Message_Prepend_Input>;
  _set?: InputMaybe<Whatsapp_Message_Set_Input>;
  where: Whatsapp_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Message_By_PkArgs = {
  _append?: InputMaybe<Whatsapp_Message_Append_Input>;
  _delete_at_path?: InputMaybe<Whatsapp_Message_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Whatsapp_Message_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Whatsapp_Message_Delete_Key_Input>;
  _inc?: InputMaybe<Whatsapp_Message_Inc_Input>;
  _prepend?: InputMaybe<Whatsapp_Message_Prepend_Input>;
  _set?: InputMaybe<Whatsapp_Message_Set_Input>;
  pk_columns: Whatsapp_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Message_ManyArgs = {
  updates: Array<Whatsapp_Message_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Message_UpdateArgs = {
  _set?: InputMaybe<Whatsapp_Message_Update_Set_Input>;
  where: Whatsapp_Message_Update_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Message_Update_By_PkArgs = {
  _set?: InputMaybe<Whatsapp_Message_Update_Set_Input>;
  pk_columns: Whatsapp_Message_Update_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Message_Update_ManyArgs = {
  updates: Array<Whatsapp_Message_Update_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_SessionArgs = {
  _inc?: InputMaybe<Whatsapp_Session_Inc_Input>;
  _set?: InputMaybe<Whatsapp_Session_Set_Input>;
  where: Whatsapp_Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Session_By_PkArgs = {
  _inc?: InputMaybe<Whatsapp_Session_Inc_Input>;
  _set?: InputMaybe<Whatsapp_Session_Set_Input>;
  pk_columns: Whatsapp_Session_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Session_CredentialArgs = {
  _append?: InputMaybe<Whatsapp_Session_Credential_Append_Input>;
  _delete_at_path?: InputMaybe<Whatsapp_Session_Credential_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Whatsapp_Session_Credential_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Whatsapp_Session_Credential_Delete_Key_Input>;
  _prepend?: InputMaybe<Whatsapp_Session_Credential_Prepend_Input>;
  _set?: InputMaybe<Whatsapp_Session_Credential_Set_Input>;
  where: Whatsapp_Session_Credential_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Session_Credential_By_PkArgs = {
  _append?: InputMaybe<Whatsapp_Session_Credential_Append_Input>;
  _delete_at_path?: InputMaybe<Whatsapp_Session_Credential_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Whatsapp_Session_Credential_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Whatsapp_Session_Credential_Delete_Key_Input>;
  _prepend?: InputMaybe<Whatsapp_Session_Credential_Prepend_Input>;
  _set?: InputMaybe<Whatsapp_Session_Credential_Set_Input>;
  pk_columns: Whatsapp_Session_Credential_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Session_Credential_ManyArgs = {
  updates: Array<Whatsapp_Session_Credential_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Session_History_SyncArgs = {
  _inc?: InputMaybe<Whatsapp_Session_History_Sync_Inc_Input>;
  _set?: InputMaybe<Whatsapp_Session_History_Sync_Set_Input>;
  where: Whatsapp_Session_History_Sync_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Session_History_Sync_By_PkArgs = {
  _inc?: InputMaybe<Whatsapp_Session_History_Sync_Inc_Input>;
  _set?: InputMaybe<Whatsapp_Session_History_Sync_Set_Input>;
  pk_columns: Whatsapp_Session_History_Sync_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Session_History_Sync_ManyArgs = {
  updates: Array<Whatsapp_Session_History_Sync_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Session_KeyArgs = {
  _append?: InputMaybe<Whatsapp_Session_Key_Append_Input>;
  _delete_at_path?: InputMaybe<Whatsapp_Session_Key_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Whatsapp_Session_Key_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Whatsapp_Session_Key_Delete_Key_Input>;
  _prepend?: InputMaybe<Whatsapp_Session_Key_Prepend_Input>;
  _set?: InputMaybe<Whatsapp_Session_Key_Set_Input>;
  where: Whatsapp_Session_Key_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Session_Key_ManyArgs = {
  updates: Array<Whatsapp_Session_Key_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Whatsapp_Session_ManyArgs = {
  updates: Array<Whatsapp_Session_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Wos_SyncArgs = {
  _set?: InputMaybe<Wos_Sync_Set_Input>;
  where: Wos_Sync_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Wos_Sync_By_PkArgs = {
  _set?: InputMaybe<Wos_Sync_Set_Input>;
  pk_columns: Wos_Sync_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Wos_Sync_ManyArgs = {
  updates: Array<Wos_Sync_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_ContactsArgs = {
  _inc?: InputMaybe<Ws_Contacts_Inc_Input>;
  _set?: InputMaybe<Ws_Contacts_Set_Input>;
  where: Ws_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Contacts_By_PkArgs = {
  _inc?: InputMaybe<Ws_Contacts_Inc_Input>;
  _set?: InputMaybe<Ws_Contacts_Set_Input>;
  pk_columns: Ws_Contacts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Contacts_ManyArgs = {
  updates: Array<Ws_Contacts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_History_SyncArgs = {
  _inc?: InputMaybe<Ws_History_Sync_Inc_Input>;
  _set?: InputMaybe<Ws_History_Sync_Set_Input>;
  where: Ws_History_Sync_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_History_Sync_By_PkArgs = {
  _inc?: InputMaybe<Ws_History_Sync_Inc_Input>;
  _set?: InputMaybe<Ws_History_Sync_Set_Input>;
  pk_columns: Ws_History_Sync_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_History_Sync_ManyArgs = {
  updates: Array<Ws_History_Sync_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_MessagesArgs = {
  _append?: InputMaybe<Ws_Messages_Append_Input>;
  _delete_at_path?: InputMaybe<Ws_Messages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ws_Messages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ws_Messages_Delete_Key_Input>;
  _inc?: InputMaybe<Ws_Messages_Inc_Input>;
  _prepend?: InputMaybe<Ws_Messages_Prepend_Input>;
  _set?: InputMaybe<Ws_Messages_Set_Input>;
  where: Ws_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Messages_By_PkArgs = {
  _append?: InputMaybe<Ws_Messages_Append_Input>;
  _delete_at_path?: InputMaybe<Ws_Messages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ws_Messages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ws_Messages_Delete_Key_Input>;
  _inc?: InputMaybe<Ws_Messages_Inc_Input>;
  _prepend?: InputMaybe<Ws_Messages_Prepend_Input>;
  _set?: InputMaybe<Ws_Messages_Set_Input>;
  pk_columns: Ws_Messages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Messages_ManyArgs = {
  updates: Array<Ws_Messages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_ServersArgs = {
  _inc?: InputMaybe<Ws_Servers_Inc_Input>;
  _set?: InputMaybe<Ws_Servers_Set_Input>;
  where: Ws_Servers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Servers_By_PkArgs = {
  _inc?: InputMaybe<Ws_Servers_Inc_Input>;
  _set?: InputMaybe<Ws_Servers_Set_Input>;
  pk_columns: Ws_Servers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Servers_ManyArgs = {
  updates: Array<Ws_Servers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_SessionsArgs = {
  _inc?: InputMaybe<Ws_Sessions_Inc_Input>;
  _set?: InputMaybe<Ws_Sessions_Set_Input>;
  where: Ws_Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Sessions_By_PkArgs = {
  _inc?: InputMaybe<Ws_Sessions_Inc_Input>;
  _set?: InputMaybe<Ws_Sessions_Set_Input>;
  pk_columns: Ws_Sessions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Sessions_CredentialsArgs = {
  _append?: InputMaybe<Ws_Sessions_Credentials_Append_Input>;
  _delete_at_path?: InputMaybe<Ws_Sessions_Credentials_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ws_Sessions_Credentials_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ws_Sessions_Credentials_Delete_Key_Input>;
  _inc?: InputMaybe<Ws_Sessions_Credentials_Inc_Input>;
  _prepend?: InputMaybe<Ws_Sessions_Credentials_Prepend_Input>;
  _set?: InputMaybe<Ws_Sessions_Credentials_Set_Input>;
  where: Ws_Sessions_Credentials_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Sessions_Credentials_By_PkArgs = {
  _append?: InputMaybe<Ws_Sessions_Credentials_Append_Input>;
  _delete_at_path?: InputMaybe<Ws_Sessions_Credentials_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ws_Sessions_Credentials_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ws_Sessions_Credentials_Delete_Key_Input>;
  _inc?: InputMaybe<Ws_Sessions_Credentials_Inc_Input>;
  _prepend?: InputMaybe<Ws_Sessions_Credentials_Prepend_Input>;
  _set?: InputMaybe<Ws_Sessions_Credentials_Set_Input>;
  pk_columns: Ws_Sessions_Credentials_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Sessions_Credentials_ManyArgs = {
  updates: Array<Ws_Sessions_Credentials_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Sessions_KeysArgs = {
  _inc?: InputMaybe<Ws_Sessions_Keys_Inc_Input>;
  _set?: InputMaybe<Ws_Sessions_Keys_Set_Input>;
  where: Ws_Sessions_Keys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Sessions_Keys_By_PkArgs = {
  _inc?: InputMaybe<Ws_Sessions_Keys_Inc_Input>;
  _set?: InputMaybe<Ws_Sessions_Keys_Set_Input>;
  pk_columns: Ws_Sessions_Keys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Sessions_Keys_ManyArgs = {
  updates: Array<Ws_Sessions_Keys_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Sessions_ManyArgs = {
  updates: Array<Ws_Sessions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Sessions_Signal_KeysArgs = {
  _append?: InputMaybe<Ws_Sessions_Signal_Keys_Append_Input>;
  _delete_at_path?: InputMaybe<Ws_Sessions_Signal_Keys_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ws_Sessions_Signal_Keys_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ws_Sessions_Signal_Keys_Delete_Key_Input>;
  _inc?: InputMaybe<Ws_Sessions_Signal_Keys_Inc_Input>;
  _prepend?: InputMaybe<Ws_Sessions_Signal_Keys_Prepend_Input>;
  _set?: InputMaybe<Ws_Sessions_Signal_Keys_Set_Input>;
  where: Ws_Sessions_Signal_Keys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Sessions_Signal_Keys_By_PkArgs = {
  _append?: InputMaybe<Ws_Sessions_Signal_Keys_Append_Input>;
  _delete_at_path?: InputMaybe<Ws_Sessions_Signal_Keys_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ws_Sessions_Signal_Keys_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ws_Sessions_Signal_Keys_Delete_Key_Input>;
  _inc?: InputMaybe<Ws_Sessions_Signal_Keys_Inc_Input>;
  _prepend?: InputMaybe<Ws_Sessions_Signal_Keys_Prepend_Input>;
  _set?: InputMaybe<Ws_Sessions_Signal_Keys_Set_Input>;
  pk_columns: Ws_Sessions_Signal_Keys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Sessions_Signal_Keys_ManyArgs = {
  updates: Array<Ws_Sessions_Signal_Keys_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Sessions_StatsArgs = {
  _inc?: InputMaybe<Ws_Sessions_Stats_Inc_Input>;
  _set?: InputMaybe<Ws_Sessions_Stats_Set_Input>;
  where: Ws_Sessions_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Sessions_Stats_By_PkArgs = {
  _inc?: InputMaybe<Ws_Sessions_Stats_Inc_Input>;
  _set?: InputMaybe<Ws_Sessions_Stats_Set_Input>;
  pk_columns: Ws_Sessions_Stats_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ws_Sessions_Stats_ManyArgs = {
  updates: Array<Ws_Sessions_Stats_Updates>;
};

/** columns and relationships of "notifications" */
export type Notifications = {
  __typename?: 'notifications';
  /** An object relationship */
  compliance: Compliance;
  compliance_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  data?: Maybe<Scalars['jsonb']>;
  description: Scalars['String'];
  id: Scalars['Int'];
  target: Scalars['String'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int'];
  title: Scalars['String'];
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
  uuid: Scalars['uuid'];
};


/** columns and relationships of "notifications" */
export type NotificationsDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "notifications" */
export type Notifications_Aggregate = {
  __typename?: 'notifications_aggregate';
  aggregate?: Maybe<Notifications_Aggregate_Fields>;
  nodes: Array<Notifications>;
};

/** aggregate fields of "notifications" */
export type Notifications_Aggregate_Fields = {
  __typename?: 'notifications_aggregate_fields';
  avg?: Maybe<Notifications_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Notifications_Max_Fields>;
  min?: Maybe<Notifications_Min_Fields>;
  stddev?: Maybe<Notifications_Stddev_Fields>;
  stddev_pop?: Maybe<Notifications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notifications_Stddev_Samp_Fields>;
  sum?: Maybe<Notifications_Sum_Fields>;
  var_pop?: Maybe<Notifications_Var_Pop_Fields>;
  var_samp?: Maybe<Notifications_Var_Samp_Fields>;
  variance?: Maybe<Notifications_Variance_Fields>;
};


/** aggregate fields of "notifications" */
export type Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Notifications_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Notifications_Avg_Fields = {
  __typename?: 'notifications_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "notifications". All fields are combined with a logical 'AND'. */
export type Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Notifications_Bool_Exp>>;
  _not?: InputMaybe<Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Notifications_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  target?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "notifications" */
export enum Notifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationsPkey = 'notifications_pkey',
  /** unique or primary key constraint on columns "uuid" */
  NotificationsUuidKey = 'notifications_uuid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Notifications_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Notifications_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Notifications_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "notifications" */
export type Notifications_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "notifications" */
export type Notifications_Insert_Input = {
  compliance?: InputMaybe<Compliance_Obj_Rel_Insert_Input>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  target?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Notifications_Max_Fields = {
  __typename?: 'notifications_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  target?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Notifications_Min_Fields = {
  __typename?: 'notifications_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  target?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "notifications" */
export type Notifications_Mutation_Response = {
  __typename?: 'notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notifications>;
};

/** on_conflict condition type for table "notifications" */
export type Notifications_On_Conflict = {
  constraint: Notifications_Constraint;
  update_columns?: Array<Notifications_Update_Column>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "notifications". */
export type Notifications_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notifications */
export type Notifications_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Notifications_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "notifications" */
export enum Notifications_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Target = 'target',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "notifications" */
export type Notifications_Set_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  target?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Notifications_Stddev_Fields = {
  __typename?: 'notifications_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Notifications_Stddev_Pop_Fields = {
  __typename?: 'notifications_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Notifications_Stddev_Samp_Fields = {
  __typename?: 'notifications_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "notifications" */
export type Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notifications_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  target?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Notifications_Sum_Fields = {
  __typename?: 'notifications_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "notifications" */
export enum Notifications_Update_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Target = 'target',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type Notifications_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Notifications_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Notifications_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Notifications_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Notifications_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notifications_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Notifications_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notifications_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notifications_Var_Pop_Fields = {
  __typename?: 'notifications_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Notifications_Var_Samp_Fields = {
  __typename?: 'notifications_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Notifications_Variance_Fields = {
  __typename?: 'notifications_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "phone_providers" */
export type Phone_Providers = {
  __typename?: 'phone_providers';
  friendly_name: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  phones: Array<Phones>;
  /** An aggregate relationship */
  phones_aggregate: Phones_Aggregate;
};


/** columns and relationships of "phone_providers" */
export type Phone_ProvidersPhonesArgs = {
  distinct_on?: InputMaybe<Array<Phones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phones_Order_By>>;
  where?: InputMaybe<Phones_Bool_Exp>;
};


/** columns and relationships of "phone_providers" */
export type Phone_ProvidersPhones_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phones_Order_By>>;
  where?: InputMaybe<Phones_Bool_Exp>;
};

/** aggregated selection of "phone_providers" */
export type Phone_Providers_Aggregate = {
  __typename?: 'phone_providers_aggregate';
  aggregate?: Maybe<Phone_Providers_Aggregate_Fields>;
  nodes: Array<Phone_Providers>;
};

/** aggregate fields of "phone_providers" */
export type Phone_Providers_Aggregate_Fields = {
  __typename?: 'phone_providers_aggregate_fields';
  avg?: Maybe<Phone_Providers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Phone_Providers_Max_Fields>;
  min?: Maybe<Phone_Providers_Min_Fields>;
  stddev?: Maybe<Phone_Providers_Stddev_Fields>;
  stddev_pop?: Maybe<Phone_Providers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Phone_Providers_Stddev_Samp_Fields>;
  sum?: Maybe<Phone_Providers_Sum_Fields>;
  var_pop?: Maybe<Phone_Providers_Var_Pop_Fields>;
  var_samp?: Maybe<Phone_Providers_Var_Samp_Fields>;
  variance?: Maybe<Phone_Providers_Variance_Fields>;
};


/** aggregate fields of "phone_providers" */
export type Phone_Providers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Phone_Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Phone_Providers_Avg_Fields = {
  __typename?: 'phone_providers_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "phone_providers". All fields are combined with a logical 'AND'. */
export type Phone_Providers_Bool_Exp = {
  _and?: InputMaybe<Array<Phone_Providers_Bool_Exp>>;
  _not?: InputMaybe<Phone_Providers_Bool_Exp>;
  _or?: InputMaybe<Array<Phone_Providers_Bool_Exp>>;
  friendly_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phones?: InputMaybe<Phones_Bool_Exp>;
  phones_aggregate?: InputMaybe<Phones_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "phone_providers" */
export enum Phone_Providers_Constraint {
  /** unique or primary key constraint on columns "id" */
  PhoneProvidersIdKey = 'phone_providers_id_key',
  /** unique or primary key constraint on columns "name" */
  PhoneProvidersNameKey = 'phone_providers_name_key',
  /** unique or primary key constraint on columns "id", "name" */
  PhoneProvidersPkey = 'phone_providers_pkey'
}

/** input type for incrementing numeric columns in table "phone_providers" */
export type Phone_Providers_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "phone_providers" */
export type Phone_Providers_Insert_Input = {
  friendly_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Phones_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Phone_Providers_Max_Fields = {
  __typename?: 'phone_providers_max_fields';
  friendly_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Phone_Providers_Min_Fields = {
  __typename?: 'phone_providers_min_fields';
  friendly_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "phone_providers" */
export type Phone_Providers_Mutation_Response = {
  __typename?: 'phone_providers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Phone_Providers>;
};

/** input type for inserting object relation for remote table "phone_providers" */
export type Phone_Providers_Obj_Rel_Insert_Input = {
  data: Phone_Providers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Phone_Providers_On_Conflict>;
};

/** on_conflict condition type for table "phone_providers" */
export type Phone_Providers_On_Conflict = {
  constraint: Phone_Providers_Constraint;
  update_columns?: Array<Phone_Providers_Update_Column>;
  where?: InputMaybe<Phone_Providers_Bool_Exp>;
};

/** Ordering options when selecting data from "phone_providers". */
export type Phone_Providers_Order_By = {
  friendly_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phones_aggregate?: InputMaybe<Phones_Aggregate_Order_By>;
};

/** primary key columns input for table: phone_providers */
export type Phone_Providers_Pk_Columns_Input = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** select columns of table "phone_providers" */
export enum Phone_Providers_Select_Column {
  /** column name */
  FriendlyName = 'friendly_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "phone_providers" */
export type Phone_Providers_Set_Input = {
  friendly_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Phone_Providers_Stddev_Fields = {
  __typename?: 'phone_providers_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Phone_Providers_Stddev_Pop_Fields = {
  __typename?: 'phone_providers_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Phone_Providers_Stddev_Samp_Fields = {
  __typename?: 'phone_providers_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "phone_providers" */
export type Phone_Providers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Phone_Providers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Phone_Providers_Stream_Cursor_Value_Input = {
  friendly_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Phone_Providers_Sum_Fields = {
  __typename?: 'phone_providers_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "phone_providers" */
export enum Phone_Providers_Update_Column {
  /** column name */
  FriendlyName = 'friendly_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Phone_Providers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Phone_Providers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Phone_Providers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Phone_Providers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Phone_Providers_Var_Pop_Fields = {
  __typename?: 'phone_providers_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Phone_Providers_Var_Samp_Fields = {
  __typename?: 'phone_providers_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Phone_Providers_Variance_Fields = {
  __typename?: 'phone_providers_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "phones" */
export type Phones = {
  __typename?: 'phones';
  /** An object relationship */
  duo?: Maybe<Duo>;
  ext_id: Scalars['String'];
  id: Scalars['Int'];
  phone: Scalars['String'];
  /** An object relationship */
  phone_provider: Phone_Providers;
  provider_name: Scalars['String'];
};

/** aggregated selection of "phones" */
export type Phones_Aggregate = {
  __typename?: 'phones_aggregate';
  aggregate?: Maybe<Phones_Aggregate_Fields>;
  nodes: Array<Phones>;
};

export type Phones_Aggregate_Bool_Exp = {
  count?: InputMaybe<Phones_Aggregate_Bool_Exp_Count>;
};

export type Phones_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Phones_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Phones_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "phones" */
export type Phones_Aggregate_Fields = {
  __typename?: 'phones_aggregate_fields';
  avg?: Maybe<Phones_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Phones_Max_Fields>;
  min?: Maybe<Phones_Min_Fields>;
  stddev?: Maybe<Phones_Stddev_Fields>;
  stddev_pop?: Maybe<Phones_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Phones_Stddev_Samp_Fields>;
  sum?: Maybe<Phones_Sum_Fields>;
  var_pop?: Maybe<Phones_Var_Pop_Fields>;
  var_samp?: Maybe<Phones_Var_Samp_Fields>;
  variance?: Maybe<Phones_Variance_Fields>;
};


/** aggregate fields of "phones" */
export type Phones_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Phones_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "phones" */
export type Phones_Aggregate_Order_By = {
  avg?: InputMaybe<Phones_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Phones_Max_Order_By>;
  min?: InputMaybe<Phones_Min_Order_By>;
  stddev?: InputMaybe<Phones_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Phones_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Phones_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Phones_Sum_Order_By>;
  var_pop?: InputMaybe<Phones_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Phones_Var_Samp_Order_By>;
  variance?: InputMaybe<Phones_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "phones" */
export type Phones_Arr_Rel_Insert_Input = {
  data: Array<Phones_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Phones_On_Conflict>;
};

/** aggregate avg on columns */
export type Phones_Avg_Fields = {
  __typename?: 'phones_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "phones" */
export type Phones_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "phones". All fields are combined with a logical 'AND'. */
export type Phones_Bool_Exp = {
  _and?: InputMaybe<Array<Phones_Bool_Exp>>;
  _not?: InputMaybe<Phones_Bool_Exp>;
  _or?: InputMaybe<Array<Phones_Bool_Exp>>;
  duo?: InputMaybe<Duo_Bool_Exp>;
  ext_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  phone_provider?: InputMaybe<Phone_Providers_Bool_Exp>;
  provider_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "phones" */
export enum Phones_Constraint {
  /** unique or primary key constraint on columns "ext_id" */
  PhonesExtIdKey = 'phones_ext_id_key',
  /** unique or primary key constraint on columns "id" */
  PhonesIdKey = 'phones_id_key',
  /** unique or primary key constraint on columns "phone" */
  PhonesPhoneKey = 'phones_phone_key',
  /** unique or primary key constraint on columns "phone", "id" */
  PhonesPkey = 'phones_pkey'
}

/** input type for incrementing numeric columns in table "phones" */
export type Phones_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "phones" */
export type Phones_Insert_Input = {
  duo?: InputMaybe<Duo_Obj_Rel_Insert_Input>;
  ext_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  phone_provider?: InputMaybe<Phone_Providers_Obj_Rel_Insert_Input>;
  provider_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Phones_Max_Fields = {
  __typename?: 'phones_max_fields';
  ext_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "phones" */
export type Phones_Max_Order_By = {
  ext_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  provider_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Phones_Min_Fields = {
  __typename?: 'phones_min_fields';
  ext_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "phones" */
export type Phones_Min_Order_By = {
  ext_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  provider_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "phones" */
export type Phones_Mutation_Response = {
  __typename?: 'phones_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Phones>;
};

/** input type for inserting object relation for remote table "phones" */
export type Phones_Obj_Rel_Insert_Input = {
  data: Phones_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Phones_On_Conflict>;
};

/** on_conflict condition type for table "phones" */
export type Phones_On_Conflict = {
  constraint: Phones_Constraint;
  update_columns?: Array<Phones_Update_Column>;
  where?: InputMaybe<Phones_Bool_Exp>;
};

/** Ordering options when selecting data from "phones". */
export type Phones_Order_By = {
  duo?: InputMaybe<Duo_Order_By>;
  ext_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  phone_provider?: InputMaybe<Phone_Providers_Order_By>;
  provider_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: phones */
export type Phones_Pk_Columns_Input = {
  id: Scalars['Int'];
  phone: Scalars['String'];
};

/** select columns of table "phones" */
export enum Phones_Select_Column {
  /** column name */
  ExtId = 'ext_id',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProviderName = 'provider_name'
}

/** input type for updating data in table "phones" */
export type Phones_Set_Input = {
  ext_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  provider_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Phones_Stddev_Fields = {
  __typename?: 'phones_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "phones" */
export type Phones_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Phones_Stddev_Pop_Fields = {
  __typename?: 'phones_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "phones" */
export type Phones_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Phones_Stddev_Samp_Fields = {
  __typename?: 'phones_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "phones" */
export type Phones_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "phones" */
export type Phones_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Phones_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Phones_Stream_Cursor_Value_Input = {
  ext_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  provider_name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Phones_Sum_Fields = {
  __typename?: 'phones_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "phones" */
export type Phones_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "phones" */
export enum Phones_Update_Column {
  /** column name */
  ExtId = 'ext_id',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProviderName = 'provider_name'
}

export type Phones_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Phones_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Phones_Set_Input>;
  /** filter the rows which have to be updated */
  where: Phones_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Phones_Var_Pop_Fields = {
  __typename?: 'phones_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "phones" */
export type Phones_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Phones_Var_Samp_Fields = {
  __typename?: 'phones_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "phones" */
export type Phones_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Phones_Variance_Fields = {
  __typename?: 'phones_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "phones" */
export type Phones_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "products" */
export type Products = {
  __typename?: 'products';
  /** An array relationship */
  duos: Array<Duo>;
  /** An aggregate relationship */
  duos_aggregate: Duo_Aggregate;
  friendly_name: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};


/** columns and relationships of "products" */
export type ProductsDuosArgs = {
  distinct_on?: InputMaybe<Array<Duo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Duo_Order_By>>;
  where?: InputMaybe<Duo_Bool_Exp>;
};


/** columns and relationships of "products" */
export type ProductsDuos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Duo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Duo_Order_By>>;
  where?: InputMaybe<Duo_Bool_Exp>;
};

/** aggregated selection of "products" */
export type Products_Aggregate = {
  __typename?: 'products_aggregate';
  aggregate?: Maybe<Products_Aggregate_Fields>;
  nodes: Array<Products>;
};

/** aggregate fields of "products" */
export type Products_Aggregate_Fields = {
  __typename?: 'products_aggregate_fields';
  avg?: Maybe<Products_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Products_Max_Fields>;
  min?: Maybe<Products_Min_Fields>;
  stddev?: Maybe<Products_Stddev_Fields>;
  stddev_pop?: Maybe<Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Products_Stddev_Samp_Fields>;
  sum?: Maybe<Products_Sum_Fields>;
  var_pop?: Maybe<Products_Var_Pop_Fields>;
  var_samp?: Maybe<Products_Var_Samp_Fields>;
  variance?: Maybe<Products_Variance_Fields>;
};


/** aggregate fields of "products" */
export type Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Products_Avg_Fields = {
  __typename?: 'products_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "products". All fields are combined with a logical 'AND'. */
export type Products_Bool_Exp = {
  _and?: InputMaybe<Array<Products_Bool_Exp>>;
  _not?: InputMaybe<Products_Bool_Exp>;
  _or?: InputMaybe<Array<Products_Bool_Exp>>;
  duos?: InputMaybe<Duo_Bool_Exp>;
  duos_aggregate?: InputMaybe<Duo_Aggregate_Bool_Exp>;
  friendly_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "products" */
export enum Products_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductsIdKey = 'products_id_key',
  /** unique or primary key constraint on columns "name" */
  ProductsNameKey = 'products_name_key',
  /** unique or primary key constraint on columns "id", "name" */
  ProductsPkey = 'products_pkey'
}

/** input type for incrementing numeric columns in table "products" */
export type Products_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "products" */
export type Products_Insert_Input = {
  duos?: InputMaybe<Duo_Arr_Rel_Insert_Input>;
  friendly_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Products_Max_Fields = {
  __typename?: 'products_max_fields';
  friendly_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Products_Min_Fields = {
  __typename?: 'products_min_fields';
  friendly_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "products" */
export type Products_Mutation_Response = {
  __typename?: 'products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Products>;
};

/** input type for inserting object relation for remote table "products" */
export type Products_Obj_Rel_Insert_Input = {
  data: Products_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Products_On_Conflict>;
};

/** on_conflict condition type for table "products" */
export type Products_On_Conflict = {
  constraint: Products_Constraint;
  update_columns?: Array<Products_Update_Column>;
  where?: InputMaybe<Products_Bool_Exp>;
};

/** Ordering options when selecting data from "products". */
export type Products_Order_By = {
  duos_aggregate?: InputMaybe<Duo_Aggregate_Order_By>;
  friendly_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: products */
export type Products_Pk_Columns_Input = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** select columns of table "products" */
export enum Products_Select_Column {
  /** column name */
  FriendlyName = 'friendly_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "products" */
export type Products_Set_Input = {
  friendly_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Products_Stddev_Fields = {
  __typename?: 'products_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Products_Stddev_Pop_Fields = {
  __typename?: 'products_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Products_Stddev_Samp_Fields = {
  __typename?: 'products_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "products" */
export type Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Products_Stream_Cursor_Value_Input = {
  friendly_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Products_Sum_Fields = {
  __typename?: 'products_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "products" */
export enum Products_Update_Column {
  /** column name */
  FriendlyName = 'friendly_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Products_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Products_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: Products_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Products_Var_Pop_Fields = {
  __typename?: 'products_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Products_Var_Samp_Fields = {
  __typename?: 'products_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Products_Variance_Fields = {
  __typename?: 'products_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "browser_sessions" */
  browser_sessions: Array<Browser_Sessions>;
  /** fetch aggregated fields from the table: "browser_sessions" */
  browser_sessions_aggregate: Browser_Sessions_Aggregate;
  /** fetch data from the table: "browser_sessions" using primary key columns */
  browser_sessions_by_pk?: Maybe<Browser_Sessions>;
  /** fetch data from the table: "chat_list" */
  chat_list: Array<Chat_List>;
  /** fetch aggregated fields from the table: "chat_list" */
  chat_list_aggregate: Chat_List_Aggregate;
  /** fetch data from the table: "chat_list" using primary key columns */
  chat_list_by_pk?: Maybe<Chat_List>;
  /** fetch data from the table: "compliance" */
  compliance: Array<Compliance>;
  /** fetch aggregated fields from the table: "compliance" */
  compliance_aggregate: Compliance_Aggregate;
  /** fetch data from the table: "compliance" using primary key columns */
  compliance_by_pk?: Maybe<Compliance>;
  /** fetch data from the table: "compliance_contacts" */
  compliance_contacts: Array<Compliance_Contacts>;
  /** fetch aggregated fields from the table: "compliance_contacts" */
  compliance_contacts_aggregate: Compliance_Contacts_Aggregate;
  /** fetch data from the table: "compliance_contacts_raw" */
  compliance_contacts_raw: Array<Compliance_Contacts_Raw>;
  /** fetch aggregated fields from the table: "compliance_contacts_raw" */
  compliance_contacts_raw_aggregate: Compliance_Contacts_Raw_Aggregate;
  /** fetch data from the table: "compliance_contacts_raw" using primary key columns */
  compliance_contacts_raw_by_pk?: Maybe<Compliance_Contacts_Raw>;
  /** fetch data from the table: "compliance_contacts_stats" */
  compliance_contacts_stats: Array<Compliance_Contacts_Stats>;
  /** fetch aggregated fields from the table: "compliance_contacts_stats" */
  compliance_contacts_stats_aggregate: Compliance_Contacts_Stats_Aggregate;
  /** execute function "compliance_contacts_stats_interval" which returns "compliance_contacts_stats_setof" */
  compliance_contacts_stats_interval: Array<Compliance_Contacts_Stats_Setof>;
  /** execute function "compliance_contacts_stats_interval" and query aggregates on result of table type "compliance_contacts_stats_setof" */
  compliance_contacts_stats_interval_aggregate: Compliance_Contacts_Stats_Setof_Aggregate;
  /** execute function "compliance_contacts_stats_json_interval" which returns "compliance_contacts_stats_json_setof" */
  compliance_contacts_stats_json_interval: Array<Compliance_Contacts_Stats_Json_Setof>;
  /** execute function "compliance_contacts_stats_json_interval" and query aggregates on result of table type "compliance_contacts_stats_json_setof" */
  compliance_contacts_stats_json_interval_aggregate: Compliance_Contacts_Stats_Json_Setof_Aggregate;
  /** fetch data from the table: "compliance_contacts_stats_json_setof" */
  compliance_contacts_stats_json_setof: Array<Compliance_Contacts_Stats_Json_Setof>;
  /** fetch aggregated fields from the table: "compliance_contacts_stats_json_setof" */
  compliance_contacts_stats_json_setof_aggregate: Compliance_Contacts_Stats_Json_Setof_Aggregate;
  /** fetch data from the table: "compliance_contacts_stats_overall" */
  compliance_contacts_stats_overall: Array<Compliance_Contacts_Stats_Overall>;
  /** fetch aggregated fields from the table: "compliance_contacts_stats_overall" */
  compliance_contacts_stats_overall_aggregate: Compliance_Contacts_Stats_Overall_Aggregate;
  /** fetch data from the table: "compliance_contacts_stats_setof" */
  compliance_contacts_stats_setof: Array<Compliance_Contacts_Stats_Setof>;
  /** fetch aggregated fields from the table: "compliance_contacts_stats_setof" */
  compliance_contacts_stats_setof_aggregate: Compliance_Contacts_Stats_Setof_Aggregate;
  /** fetch data from the table: "compliance_contacts_status" */
  compliance_contacts_status: Array<Compliance_Contacts_Status>;
  /** fetch aggregated fields from the table: "compliance_contacts_status" */
  compliance_contacts_status_aggregate: Compliance_Contacts_Status_Aggregate;
  /** An array relationship */
  compliance_events: Array<Compliance_Events>;
  /** An aggregate relationship */
  compliance_events_aggregate: Compliance_Events_Aggregate;
  /** fetch data from the table: "compliance_events" using primary key columns */
  compliance_events_by_pk?: Maybe<Compliance_Events>;
  /** fetch data from the table: "compliance_events_classification_goals" */
  compliance_events_classification_goals: Array<Compliance_Events_Classification_Goals>;
  /** fetch aggregated fields from the table: "compliance_events_classification_goals" */
  compliance_events_classification_goals_aggregate: Compliance_Events_Classification_Goals_Aggregate;
  /** fetch data from the table: "compliance_events_classification_goals" using primary key columns */
  compliance_events_classification_goals_by_pk?: Maybe<Compliance_Events_Classification_Goals>;
  /** fetch data from the table: "compliance_events_classification_resumes" */
  compliance_events_classification_resumes: Array<Compliance_Events_Classification_Resumes>;
  /** fetch aggregated fields from the table: "compliance_events_classification_resumes" */
  compliance_events_classification_resumes_aggregate: Compliance_Events_Classification_Resumes_Aggregate;
  /** fetch data from the table: "compliance_events_classification_resumes" using primary key columns */
  compliance_events_classification_resumes_by_pk?: Maybe<Compliance_Events_Classification_Resumes>;
  /** fetch data from the table: "compliance_events_daily" */
  compliance_events_daily: Array<Compliance_Events_Daily>;
  /** fetch aggregated fields from the table: "compliance_events_daily" */
  compliance_events_daily_aggregate: Compliance_Events_Daily_Aggregate;
  /** fetch data from the table: "compliance_events_hourly" */
  compliance_events_hourly: Array<Compliance_Events_Hourly>;
  /** fetch aggregated fields from the table: "compliance_events_hourly" */
  compliance_events_hourly_aggregate: Compliance_Events_Hourly_Aggregate;
  /** fetch data from the table: "compliance_events_hourly" using primary key columns */
  compliance_events_hourly_by_pk?: Maybe<Compliance_Events_Hourly>;
  /** fetch data from the table: "compliance_events_monthly" */
  compliance_events_monthly: Array<Compliance_Events_Monthly>;
  /** fetch aggregated fields from the table: "compliance_events_monthly" */
  compliance_events_monthly_aggregate: Compliance_Events_Monthly_Aggregate;
  /** fetch data from the table: "compliance_events_status_hourly" */
  compliance_events_status_hourly: Array<Compliance_Events_Status_Hourly>;
  /** fetch aggregated fields from the table: "compliance_events_status_hourly" */
  compliance_events_status_hourly_aggregate: Compliance_Events_Status_Hourly_Aggregate;
  /** fetch data from the table: "compliance_events_status_hourly" using primary key columns */
  compliance_events_status_hourly_by_pk?: Maybe<Compliance_Events_Status_Hourly>;
  /** fetch data from the table: "compliance_events_status_total" */
  compliance_events_status_total: Array<Compliance_Events_Status_Total>;
  /** fetch aggregated fields from the table: "compliance_events_status_total" */
  compliance_events_status_total_aggregate: Compliance_Events_Status_Total_Aggregate;
  /** fetch data from the table: "compliance_events_total" */
  compliance_events_total: Array<Compliance_Events_Total>;
  /** fetch aggregated fields from the table: "compliance_events_total" */
  compliance_events_total_aggregate: Compliance_Events_Total_Aggregate;
  /** fetch data from the table: "compliance_events_weekly" */
  compliance_events_weekly: Array<Compliance_Events_Weekly>;
  /** fetch aggregated fields from the table: "compliance_events_weekly" */
  compliance_events_weekly_aggregate: Compliance_Events_Weekly_Aggregate;
  /** fetch data from the table: "compliance_events_weekly_reports" */
  compliance_events_weekly_reports: Array<Compliance_Events_Weekly_Reports>;
  /** fetch aggregated fields from the table: "compliance_events_weekly_reports" */
  compliance_events_weekly_reports_aggregate: Compliance_Events_Weekly_Reports_Aggregate;
  /** fetch data from the table: "compliance_events_yearly" */
  compliance_events_yearly: Array<Compliance_Events_Yearly>;
  /** fetch aggregated fields from the table: "compliance_events_yearly" */
  compliance_events_yearly_aggregate: Compliance_Events_Yearly_Aggregate;
  /** An array relationship */
  compliance_group_contacts: Array<Compliance_Group_Contacts>;
  /** An aggregate relationship */
  compliance_group_contacts_aggregate: Compliance_Group_Contacts_Aggregate;
  /** fetch data from the table: "compliance_group_contacts" using primary key columns */
  compliance_group_contacts_by_pk?: Maybe<Compliance_Group_Contacts>;
  /** An array relationship */
  compliance_group_users: Array<Compliance_Group_Users>;
  /** An aggregate relationship */
  compliance_group_users_aggregate: Compliance_Group_Users_Aggregate;
  /** fetch data from the table: "compliance_group_users" using primary key columns */
  compliance_group_users_by_pk?: Maybe<Compliance_Group_Users>;
  /** An array relationship */
  compliance_groups: Array<Compliance_Groups>;
  /** An aggregate relationship */
  compliance_groups_aggregate: Compliance_Groups_Aggregate;
  /** fetch data from the table: "compliance_groups" using primary key columns */
  compliance_groups_by_pk?: Maybe<Compliance_Groups>;
  /** execute function "compliance_groups_with_events" which returns "compliance_groups" */
  compliance_groups_with_events: Array<Compliance_Groups>;
  /** execute function "compliance_groups_with_events" and query aggregates on result of table type "compliance_groups" */
  compliance_groups_with_events_aggregate: Compliance_Groups_Aggregate;
  /** An array relationship */
  compliance_messages: Array<Compliance_Messages>;
  /** An aggregate relationship */
  compliance_messages_aggregate: Compliance_Messages_Aggregate;
  /** fetch data from the table: "compliance_messages_daily" */
  compliance_messages_daily: Array<Compliance_Messages_Daily>;
  /** fetch aggregated fields from the table: "compliance_messages_daily" */
  compliance_messages_daily_aggregate: Compliance_Messages_Daily_Aggregate;
  /** fetch data from the table: "compliance_messages_hourly" */
  compliance_messages_hourly: Array<Compliance_Messages_Hourly>;
  /** fetch aggregated fields from the table: "compliance_messages_hourly" */
  compliance_messages_hourly_aggregate: Compliance_Messages_Hourly_Aggregate;
  /** fetch data from the table: "compliance_messages_hourly" using primary key columns */
  compliance_messages_hourly_by_pk?: Maybe<Compliance_Messages_Hourly>;
  /** fetch data from the table: "compliance_messages_monthly" */
  compliance_messages_monthly: Array<Compliance_Messages_Monthly>;
  /** fetch aggregated fields from the table: "compliance_messages_monthly" */
  compliance_messages_monthly_aggregate: Compliance_Messages_Monthly_Aggregate;
  /** fetch data from the table: "compliance_messages_total" */
  compliance_messages_total: Array<Compliance_Messages_Total>;
  /** fetch aggregated fields from the table: "compliance_messages_total" */
  compliance_messages_total_aggregate: Compliance_Messages_Total_Aggregate;
  /** fetch data from the table: "compliance_messages_weekly" */
  compliance_messages_weekly: Array<Compliance_Messages_Weekly>;
  /** fetch aggregated fields from the table: "compliance_messages_weekly" */
  compliance_messages_weekly_aggregate: Compliance_Messages_Weekly_Aggregate;
  /** fetch data from the table: "compliance_messages_yearly" */
  compliance_messages_yearly: Array<Compliance_Messages_Yearly>;
  /** fetch aggregated fields from the table: "compliance_messages_yearly" */
  compliance_messages_yearly_aggregate: Compliance_Messages_Yearly_Aggregate;
  /** fetch data from the table: "compliance_participants" */
  compliance_participants: Array<Compliance_Participants>;
  /** fetch aggregated fields from the table: "compliance_participants" */
  compliance_participants_aggregate: Compliance_Participants_Aggregate;
  /** An array relationship */
  compliance_policies: Array<Compliance_Policies>;
  /** An aggregate relationship */
  compliance_policies_aggregate: Compliance_Policies_Aggregate;
  /** fetch data from the table: "compliance_policies" using primary key columns */
  compliance_policies_by_pk?: Maybe<Compliance_Policies>;
  /** An array relationship */
  compliance_rules: Array<Compliance_Rules>;
  /** An aggregate relationship */
  compliance_rules_aggregate: Compliance_Rules_Aggregate;
  /** fetch data from the table: "compliance_rules" using primary key columns */
  compliance_rules_by_pk?: Maybe<Compliance_Rules>;
  /** fetch data from the table: "compliance_tags" */
  compliance_tags: Array<Compliance_Tags>;
  /** fetch aggregated fields from the table: "compliance_tags" */
  compliance_tags_aggregate: Compliance_Tags_Aggregate;
  /** fetch data from the table: "compliance_tags" using primary key columns */
  compliance_tags_by_pk?: Maybe<Compliance_Tags>;
  /** fetch data from the table: "consent" */
  consent: Array<Consent>;
  /** fetch aggregated fields from the table: "consent" */
  consent_aggregate: Consent_Aggregate;
  /** fetch data from the table: "consent" using primary key columns */
  consent_by_pk?: Maybe<Consent>;
  /** fetch data from the table: "contact_list" */
  contact_list: Array<Contact_List>;
  /** fetch aggregated fields from the table: "contact_list" */
  contact_list_aggregate: Contact_List_Aggregate;
  /** fetch data from the table: "contact_list" using primary key columns */
  contact_list_by_pk?: Maybe<Contact_List>;
  /** fetch data from the table: "duo" */
  duo: Array<Duo>;
  /** fetch aggregated fields from the table: "duo" */
  duo_aggregate: Duo_Aggregate;
  /** fetch data from the table: "duo" using primary key columns */
  duo_by_pk?: Maybe<Duo>;
  getAvailableNumbers: Array<Maybe<AvailableNumbersOutput>>;
  getCustomer?: Maybe<GetCustomerOutput>;
  getInvoices?: Maybe<Array<Maybe<GetInvoicesOutput>>>;
  getPlan?: Maybe<PlanOutput>;
  getSubscription: GetSubscriptionsOutput;
  getSubscriptions?: Maybe<Array<Maybe<GetSubscriptionsOutput>>>;
  getSubscriptionsByCustomer?: Maybe<Array<Maybe<GetSubscriptionsOutput>>>;
  getSubscriptionsByPlanIdentifier?: Maybe<Array<Maybe<GetSubscriptionsOutput>>>;
  /** An array relationship */
  groups: Array<Groups>;
  /** An aggregate relationship */
  groups_aggregate: Groups_Aggregate;
  /** fetch data from the table: "groups" using primary key columns */
  groups_by_pk?: Maybe<Groups>;
  /** An array relationship */
  groups_users: Array<Groups_Users>;
  /** An aggregate relationship */
  groups_users_aggregate: Groups_Users_Aggregate;
  /** fetch data from the table: "groups_users" using primary key columns */
  groups_users_by_pk?: Maybe<Groups_Users>;
  /** fetch data from the table: "invite_rules" */
  invite_rules: Array<Invite_Rules>;
  /** fetch aggregated fields from the table: "invite_rules" */
  invite_rules_aggregate: Invite_Rules_Aggregate;
  /** fetch data from the table: "invite_rules" using primary key columns */
  invite_rules_by_pk?: Maybe<Invite_Rules>;
  /** fetch data from the table: "invite_rules_recipients" */
  invite_rules_recipients: Array<Invite_Rules_Recipients>;
  /** fetch aggregated fields from the table: "invite_rules_recipients" */
  invite_rules_recipients_aggregate: Invite_Rules_Recipients_Aggregate;
  /** fetch data from the table: "invite_rules_recipients" using primary key columns */
  invite_rules_recipients_by_pk?: Maybe<Invite_Rules_Recipients>;
  /** fetch data from the table: "license_records" */
  license_records: Array<License_Records>;
  /** fetch aggregated fields from the table: "license_records" */
  license_records_aggregate: License_Records_Aggregate;
  /** fetch data from the table: "license_records" using primary key columns */
  license_records_by_pk?: Maybe<License_Records>;
  /** fetch data from the table: "link" */
  link: Array<Link>;
  /** fetch aggregated fields from the table: "link" */
  link_aggregate: Link_Aggregate;
  /** fetch data from the table: "link" using primary key columns */
  link_by_pk?: Maybe<Link>;
  /** fetch data from the table: "link_domains" */
  link_domains: Array<Link_Domains>;
  /** fetch aggregated fields from the table: "link_domains" */
  link_domains_aggregate: Link_Domains_Aggregate;
  /** fetch data from the table: "link_domains" using primary key columns */
  link_domains_by_pk?: Maybe<Link_Domains>;
  /** fetch data from the table: "logs" */
  logs: Array<Logs>;
  /** fetch aggregated fields from the table: "logs" */
  logs_aggregate: Logs_Aggregate;
  /** fetch data from the table: "logs" using primary key columns */
  logs_by_pk?: Maybe<Logs>;
  /** fetch data from the table: "notifications" */
  notifications: Array<Notifications>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table: "phone_providers" */
  phone_providers: Array<Phone_Providers>;
  /** fetch aggregated fields from the table: "phone_providers" */
  phone_providers_aggregate: Phone_Providers_Aggregate;
  /** fetch data from the table: "phone_providers" using primary key columns */
  phone_providers_by_pk?: Maybe<Phone_Providers>;
  /** An array relationship */
  phones: Array<Phones>;
  /** An aggregate relationship */
  phones_aggregate: Phones_Aggregate;
  /** fetch data from the table: "phones" using primary key columns */
  phones_by_pk?: Maybe<Phones>;
  /** fetch data from the table: "products" */
  products: Array<Products>;
  /** fetch aggregated fields from the table: "products" */
  products_aggregate: Products_Aggregate;
  /** fetch data from the table: "products" using primary key columns */
  products_by_pk?: Maybe<Products>;
  /** fetch data from the table: "relevant_contacts" */
  relevant_contacts: Array<Relevant_Contacts>;
  /** fetch aggregated fields from the table: "relevant_contacts" */
  relevant_contacts_aggregate: Relevant_Contacts_Aggregate;
  /** fetch data from the table: "relevant_contacts" using primary key columns */
  relevant_contacts_by_pk?: Maybe<Relevant_Contacts>;
  /** An array relationship */
  relevant_contacts_tags: Array<Relevant_Contacts_Tags>;
  /** An aggregate relationship */
  relevant_contacts_tags_aggregate: Relevant_Contacts_Tags_Aggregate;
  /** fetch data from the table: "relevant_contacts_tags" using primary key columns */
  relevant_contacts_tags_by_pk?: Maybe<Relevant_Contacts_Tags>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** An array relationship */
  roles_teams: Array<Roles_Teams>;
  /** An aggregate relationship */
  roles_teams_aggregate: Roles_Teams_Aggregate;
  /** fetch data from the table: "roles_teams" using primary key columns */
  roles_teams_by_pk?: Maybe<Roles_Teams>;
  /** An array relationship */
  roles_users: Array<Roles_Users>;
  /** An aggregate relationship */
  roles_users_aggregate: Roles_Users_Aggregate;
  /** fetch data from the table: "roles_users" using primary key columns */
  roles_users_by_pk?: Maybe<Roles_Users>;
  /** fetch data from the table: "rollups" */
  rollups: Array<Rollups>;
  /** fetch aggregated fields from the table: "rollups" */
  rollups_aggregate: Rollups_Aggregate;
  /** fetch data from the table: "rollups" using primary key columns */
  rollups_by_pk?: Maybe<Rollups>;
  /** execute function "select_incomplete_compliance_events" which returns "compliance_events" */
  select_incomplete_compliance_events: Array<Compliance_Events>;
  /** execute function "select_incomplete_compliance_events" and query aggregates on result of table type "compliance_events" */
  select_incomplete_compliance_events_aggregate: Compliance_Events_Aggregate;
  /** fetch data from the table: "subscription_providers" */
  subscription_providers: Array<Subscription_Providers>;
  /** fetch aggregated fields from the table: "subscription_providers" */
  subscription_providers_aggregate: Subscription_Providers_Aggregate;
  /** fetch data from the table: "subscription_providers" using primary key columns */
  subscription_providers_by_pk?: Maybe<Subscription_Providers>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** fetch data from the table: "subscriptions" using primary key columns */
  subscriptions_by_pk?: Maybe<Subscriptions>;
  /** fetch data from the table: "tags" */
  tags: Array<Tags>;
  /** fetch aggregated fields from the table: "tags" */
  tags_aggregate: Tags_Aggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk?: Maybe<Tags>;
  /** An array relationship */
  teams: Array<Teams>;
  /** An aggregate relationship */
  teams_aggregate: Teams_Aggregate;
  /** fetch data from the table: "teams" using primary key columns */
  teams_by_pk?: Maybe<Teams>;
  /** fetch data from the table: "teams_settings" */
  teams_settings: Array<Teams_Settings>;
  /** fetch aggregated fields from the table: "teams_settings" */
  teams_settings_aggregate: Teams_Settings_Aggregate;
  /** fetch data from the table: "teams_settings" using primary key columns */
  teams_settings_by_pk?: Maybe<Teams_Settings>;
  /** An array relationship */
  teams_templates: Array<Teams_Templates>;
  /** An aggregate relationship */
  teams_templates_aggregate: Teams_Templates_Aggregate;
  /** fetch data from the table: "teams_templates" using primary key columns */
  teams_templates_by_pk?: Maybe<Teams_Templates>;
  /** An array relationship */
  teams_users: Array<Teams_Users>;
  /** An aggregate relationship */
  teams_users_aggregate: Teams_Users_Aggregate;
  /** fetch data from the table: "teams_users" using primary key columns */
  teams_users_by_pk?: Maybe<Teams_Users>;
  /** fetch data from the table: "templates" */
  templates: Array<Templates>;
  /** fetch aggregated fields from the table: "templates" */
  templates_aggregate: Templates_Aggregate;
  /** fetch data from the table: "templates" using primary key columns */
  templates_by_pk?: Maybe<Templates>;
  /** fetch data from the table: "tenant" */
  tenant: Array<Tenant>;
  /** fetch aggregated fields from the table: "tenant" */
  tenant_aggregate: Tenant_Aggregate;
  /** fetch data from the table: "tenant" using primary key columns */
  tenant_by_pk?: Maybe<Tenant>;
  /** fetch data from the table: "tokens" */
  tokens: Array<Tokens>;
  /** fetch aggregated fields from the table: "tokens" */
  tokens_aggregate: Tokens_Aggregate;
  /** fetch data from the table: "tokens" using primary key columns */
  tokens_by_pk?: Maybe<Tokens>;
  /** fetch data from the table: "user_auth_codes" */
  user_auth_codes: Array<User_Auth_Codes>;
  /** fetch aggregated fields from the table: "user_auth_codes" */
  user_auth_codes_aggregate: User_Auth_Codes_Aggregate;
  /** fetch data from the table: "user_auth_codes" using primary key columns */
  user_auth_codes_by_pk?: Maybe<User_Auth_Codes>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "web_contacts" */
  web_contacts: Array<Web_Contacts>;
  /** fetch aggregated fields from the table: "web_contacts" */
  web_contacts_aggregate: Web_Contacts_Aggregate;
  /** fetch data from the table: "web_contacts" using primary key columns */
  web_contacts_by_pk?: Maybe<Web_Contacts>;
  /** fetch data from the table: "web_messages" */
  web_messages: Array<Web_Messages>;
  /** fetch aggregated fields from the table: "web_messages" */
  web_messages_aggregate: Web_Messages_Aggregate;
  /** fetch data from the table: "web_messages" using primary key columns */
  web_messages_by_pk?: Maybe<Web_Messages>;
  /** fetch data from the table: "web_qr_codes" */
  web_qr_codes: Array<Web_Qr_Codes>;
  /** fetch aggregated fields from the table: "web_qr_codes" */
  web_qr_codes_aggregate: Web_Qr_Codes_Aggregate;
  /** fetch data from the table: "web_qr_codes" using primary key columns */
  web_qr_codes_by_pk?: Maybe<Web_Qr_Codes>;
  /** fetch data from the table: "whatsapp._messageTomessage_update" */
  whatsapp__messageTomessage_update: Array<Whatsapp__MessageTomessage_Update>;
  /** fetch aggregated fields from the table: "whatsapp._messageTomessage_update" */
  whatsapp__messageTomessage_update_aggregate: Whatsapp__MessageTomessage_Update_Aggregate;
  /** fetch data from the table: "whatsapp.chat" */
  whatsapp_chat: Array<Whatsapp_Chat>;
  /** fetch aggregated fields from the table: "whatsapp.chat" */
  whatsapp_chat_aggregate: Whatsapp_Chat_Aggregate;
  /** fetch data from the table: "whatsapp.chat" using primary key columns */
  whatsapp_chat_by_pk?: Maybe<Whatsapp_Chat>;
  /** fetch data from the table: "whatsapp.contact" */
  whatsapp_contact: Array<Whatsapp_Contact>;
  /** fetch aggregated fields from the table: "whatsapp.contact" */
  whatsapp_contact_aggregate: Whatsapp_Contact_Aggregate;
  /** fetch data from the table: "whatsapp.contact" using primary key columns */
  whatsapp_contact_by_pk?: Maybe<Whatsapp_Contact>;
  /** fetch data from the table: "whatsapp.message" */
  whatsapp_message: Array<Whatsapp_Message>;
  /** fetch aggregated fields from the table: "whatsapp.message" */
  whatsapp_message_aggregate: Whatsapp_Message_Aggregate;
  /** fetch data from the table: "whatsapp.message" using primary key columns */
  whatsapp_message_by_pk?: Maybe<Whatsapp_Message>;
  /** fetch data from the table: "whatsapp.message_update" */
  whatsapp_message_update: Array<Whatsapp_Message_Update>;
  /** fetch aggregated fields from the table: "whatsapp.message_update" */
  whatsapp_message_update_aggregate: Whatsapp_Message_Update_Aggregate;
  /** fetch data from the table: "whatsapp.message_update" using primary key columns */
  whatsapp_message_update_by_pk?: Maybe<Whatsapp_Message_Update>;
  /** fetch data from the table: "whatsapp.session" */
  whatsapp_session: Array<Whatsapp_Session>;
  /** fetch aggregated fields from the table: "whatsapp.session" */
  whatsapp_session_aggregate: Whatsapp_Session_Aggregate;
  /** fetch data from the table: "whatsapp.session" using primary key columns */
  whatsapp_session_by_pk?: Maybe<Whatsapp_Session>;
  /** fetch data from the table: "whatsapp.session_credential" */
  whatsapp_session_credential: Array<Whatsapp_Session_Credential>;
  /** fetch aggregated fields from the table: "whatsapp.session_credential" */
  whatsapp_session_credential_aggregate: Whatsapp_Session_Credential_Aggregate;
  /** fetch data from the table: "whatsapp.session_credential" using primary key columns */
  whatsapp_session_credential_by_pk?: Maybe<Whatsapp_Session_Credential>;
  /** fetch data from the table: "whatsapp.session_history_sync" */
  whatsapp_session_history_sync: Array<Whatsapp_Session_History_Sync>;
  /** fetch aggregated fields from the table: "whatsapp.session_history_sync" */
  whatsapp_session_history_sync_aggregate: Whatsapp_Session_History_Sync_Aggregate;
  /** fetch data from the table: "whatsapp.session_history_sync" using primary key columns */
  whatsapp_session_history_sync_by_pk?: Maybe<Whatsapp_Session_History_Sync>;
  /** fetch data from the table: "whatsapp.session_key" */
  whatsapp_session_key: Array<Whatsapp_Session_Key>;
  /** fetch aggregated fields from the table: "whatsapp.session_key" */
  whatsapp_session_key_aggregate: Whatsapp_Session_Key_Aggregate;
  /** fetch data from the table: "wos_sync" */
  wos_sync: Array<Wos_Sync>;
  /** fetch aggregated fields from the table: "wos_sync" */
  wos_sync_aggregate: Wos_Sync_Aggregate;
  /** fetch data from the table: "wos_sync" using primary key columns */
  wos_sync_by_pk?: Maybe<Wos_Sync>;
  /** fetch data from the table: "ws_contacts" */
  ws_contacts: Array<Ws_Contacts>;
  /** fetch aggregated fields from the table: "ws_contacts" */
  ws_contacts_aggregate: Ws_Contacts_Aggregate;
  /** fetch data from the table: "ws_contacts" using primary key columns */
  ws_contacts_by_pk?: Maybe<Ws_Contacts>;
  /** fetch data from the table: "ws_history_sync" */
  ws_history_sync: Array<Ws_History_Sync>;
  /** fetch aggregated fields from the table: "ws_history_sync" */
  ws_history_sync_aggregate: Ws_History_Sync_Aggregate;
  /** fetch data from the table: "ws_history_sync" using primary key columns */
  ws_history_sync_by_pk?: Maybe<Ws_History_Sync>;
  /** An array relationship */
  ws_messages: Array<Ws_Messages>;
  /** An aggregate relationship */
  ws_messages_aggregate: Ws_Messages_Aggregate;
  /** fetch data from the table: "ws_messages" using primary key columns */
  ws_messages_by_pk?: Maybe<Ws_Messages>;
  /** fetch data from the table: "ws_servers" */
  ws_servers: Array<Ws_Servers>;
  /** fetch aggregated fields from the table: "ws_servers" */
  ws_servers_aggregate: Ws_Servers_Aggregate;
  /** fetch data from the table: "ws_servers" using primary key columns */
  ws_servers_by_pk?: Maybe<Ws_Servers>;
  /** fetch data from the table: "ws_sessions" */
  ws_sessions: Array<Ws_Sessions>;
  /** fetch aggregated fields from the table: "ws_sessions" */
  ws_sessions_aggregate: Ws_Sessions_Aggregate;
  /** fetch data from the table: "ws_sessions" using primary key columns */
  ws_sessions_by_pk?: Maybe<Ws_Sessions>;
  /** fetch data from the table: "ws_sessions_credentials" */
  ws_sessions_credentials: Array<Ws_Sessions_Credentials>;
  /** fetch aggregated fields from the table: "ws_sessions_credentials" */
  ws_sessions_credentials_aggregate: Ws_Sessions_Credentials_Aggregate;
  /** fetch data from the table: "ws_sessions_credentials" using primary key columns */
  ws_sessions_credentials_by_pk?: Maybe<Ws_Sessions_Credentials>;
  /** fetch data from the table: "ws_sessions_keys" */
  ws_sessions_keys: Array<Ws_Sessions_Keys>;
  /** fetch aggregated fields from the table: "ws_sessions_keys" */
  ws_sessions_keys_aggregate: Ws_Sessions_Keys_Aggregate;
  /** fetch data from the table: "ws_sessions_keys" using primary key columns */
  ws_sessions_keys_by_pk?: Maybe<Ws_Sessions_Keys>;
  /** fetch data from the table: "ws_sessions_signal_keys" */
  ws_sessions_signal_keys: Array<Ws_Sessions_Signal_Keys>;
  /** fetch aggregated fields from the table: "ws_sessions_signal_keys" */
  ws_sessions_signal_keys_aggregate: Ws_Sessions_Signal_Keys_Aggregate;
  /** fetch data from the table: "ws_sessions_signal_keys" using primary key columns */
  ws_sessions_signal_keys_by_pk?: Maybe<Ws_Sessions_Signal_Keys>;
  /** fetch data from the table: "ws_sessions_stats" */
  ws_sessions_stats: Array<Ws_Sessions_Stats>;
  /** fetch aggregated fields from the table: "ws_sessions_stats" */
  ws_sessions_stats_aggregate: Ws_Sessions_Stats_Aggregate;
  /** fetch data from the table: "ws_sessions_stats" using primary key columns */
  ws_sessions_stats_by_pk?: Maybe<Ws_Sessions_Stats>;
};


export type Query_RootBrowser_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Browser_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Browser_Sessions_Order_By>>;
  where?: InputMaybe<Browser_Sessions_Bool_Exp>;
};


export type Query_RootBrowser_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Browser_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Browser_Sessions_Order_By>>;
  where?: InputMaybe<Browser_Sessions_Bool_Exp>;
};


export type Query_RootBrowser_Sessions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootChat_ListArgs = {
  distinct_on?: InputMaybe<Array<Chat_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_List_Order_By>>;
  where?: InputMaybe<Chat_List_Bool_Exp>;
};


export type Query_RootChat_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_List_Order_By>>;
  where?: InputMaybe<Chat_List_Bool_Exp>;
};


export type Query_RootChat_List_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootComplianceArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Order_By>>;
  where?: InputMaybe<Compliance_Bool_Exp>;
};


export type Query_RootCompliance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Order_By>>;
  where?: InputMaybe<Compliance_Bool_Exp>;
};


export type Query_RootCompliance_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompliance_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_RawArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Raw_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_Raw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Raw_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_Raw_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompliance_Contacts_StatsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_Stats_IntervalArgs = {
  args: Compliance_Contacts_Stats_Interval_Args;
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Setof_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_Stats_Interval_AggregateArgs = {
  args: Compliance_Contacts_Stats_Interval_Args;
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Setof_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_Stats_Json_IntervalArgs = {
  args: Compliance_Contacts_Stats_Json_Interval_Args;
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_Stats_Json_Interval_AggregateArgs = {
  args: Compliance_Contacts_Stats_Json_Interval_Args;
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_Stats_Json_SetofArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_Stats_Json_Setof_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_Stats_OverallArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Overall_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Overall_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Overall_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_Stats_Overall_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Overall_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Overall_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Overall_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_Stats_SetofArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Setof_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_Stats_Setof_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Setof_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_StatusArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Status_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Status_Bool_Exp>;
};


export type Query_RootCompliance_Contacts_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Status_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Status_Bool_Exp>;
};


export type Query_RootCompliance_EventsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


export type Query_RootCompliance_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


export type Query_RootCompliance_Events_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompliance_Events_Classification_GoalsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Classification_Goals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Classification_Goals_Order_By>>;
  where?: InputMaybe<Compliance_Events_Classification_Goals_Bool_Exp>;
};


export type Query_RootCompliance_Events_Classification_Goals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Classification_Goals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Classification_Goals_Order_By>>;
  where?: InputMaybe<Compliance_Events_Classification_Goals_Bool_Exp>;
};


export type Query_RootCompliance_Events_Classification_Goals_By_PkArgs = {
  compliance_id: Scalars['Int'];
};


export type Query_RootCompliance_Events_Classification_ResumesArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Classification_Resumes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Classification_Resumes_Order_By>>;
  where?: InputMaybe<Compliance_Events_Classification_Resumes_Bool_Exp>;
};


export type Query_RootCompliance_Events_Classification_Resumes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Classification_Resumes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Classification_Resumes_Order_By>>;
  where?: InputMaybe<Compliance_Events_Classification_Resumes_Bool_Exp>;
};


export type Query_RootCompliance_Events_Classification_Resumes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompliance_Events_DailyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Daily_Order_By>>;
  where?: InputMaybe<Compliance_Events_Daily_Bool_Exp>;
};


export type Query_RootCompliance_Events_Daily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Daily_Order_By>>;
  where?: InputMaybe<Compliance_Events_Daily_Bool_Exp>;
};


export type Query_RootCompliance_Events_HourlyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Hourly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Hourly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Hourly_Bool_Exp>;
};


export type Query_RootCompliance_Events_Hourly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Hourly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Hourly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Hourly_Bool_Exp>;
};


export type Query_RootCompliance_Events_Hourly_By_PkArgs = {
  compliance_id: Scalars['Int'];
  hour: Scalars['timestamptz'];
};


export type Query_RootCompliance_Events_MonthlyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Monthly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Monthly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Monthly_Bool_Exp>;
};


export type Query_RootCompliance_Events_Monthly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Monthly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Monthly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Monthly_Bool_Exp>;
};


export type Query_RootCompliance_Events_Status_HourlyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Status_Hourly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Status_Hourly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Status_Hourly_Bool_Exp>;
};


export type Query_RootCompliance_Events_Status_Hourly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Status_Hourly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Status_Hourly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Status_Hourly_Bool_Exp>;
};


export type Query_RootCompliance_Events_Status_Hourly_By_PkArgs = {
  compliance_id: Scalars['Int'];
  hour: Scalars['timestamptz'];
  status: Scalars['String'];
};


export type Query_RootCompliance_Events_Status_TotalArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Status_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Status_Total_Order_By>>;
  where?: InputMaybe<Compliance_Events_Status_Total_Bool_Exp>;
};


export type Query_RootCompliance_Events_Status_Total_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Status_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Status_Total_Order_By>>;
  where?: InputMaybe<Compliance_Events_Status_Total_Bool_Exp>;
};


export type Query_RootCompliance_Events_TotalArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Total_Order_By>>;
  where?: InputMaybe<Compliance_Events_Total_Bool_Exp>;
};


export type Query_RootCompliance_Events_Total_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Total_Order_By>>;
  where?: InputMaybe<Compliance_Events_Total_Bool_Exp>;
};


export type Query_RootCompliance_Events_WeeklyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Weekly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Weekly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Weekly_Bool_Exp>;
};


export type Query_RootCompliance_Events_Weekly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Weekly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Weekly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Weekly_Bool_Exp>;
};


export type Query_RootCompliance_Events_Weekly_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Weekly_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Weekly_Reports_Order_By>>;
  where?: InputMaybe<Compliance_Events_Weekly_Reports_Bool_Exp>;
};


export type Query_RootCompliance_Events_Weekly_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Weekly_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Weekly_Reports_Order_By>>;
  where?: InputMaybe<Compliance_Events_Weekly_Reports_Bool_Exp>;
};


export type Query_RootCompliance_Events_YearlyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Yearly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Yearly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Yearly_Bool_Exp>;
};


export type Query_RootCompliance_Events_Yearly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Yearly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Yearly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Yearly_Bool_Exp>;
};


export type Query_RootCompliance_Group_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Group_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Group_Contacts_Order_By>>;
  where?: InputMaybe<Compliance_Group_Contacts_Bool_Exp>;
};


export type Query_RootCompliance_Group_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Group_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Group_Contacts_Order_By>>;
  where?: InputMaybe<Compliance_Group_Contacts_Bool_Exp>;
};


export type Query_RootCompliance_Group_Contacts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompliance_Group_UsersArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Group_Users_Order_By>>;
  where?: InputMaybe<Compliance_Group_Users_Bool_Exp>;
};


export type Query_RootCompliance_Group_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Group_Users_Order_By>>;
  where?: InputMaybe<Compliance_Group_Users_Bool_Exp>;
};


export type Query_RootCompliance_Group_Users_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompliance_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Groups_Order_By>>;
  where?: InputMaybe<Compliance_Groups_Bool_Exp>;
};


export type Query_RootCompliance_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Groups_Order_By>>;
  where?: InputMaybe<Compliance_Groups_Bool_Exp>;
};


export type Query_RootCompliance_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompliance_Groups_With_EventsArgs = {
  args: Compliance_Groups_With_Events_Args;
  distinct_on?: InputMaybe<Array<Compliance_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Groups_Order_By>>;
  where?: InputMaybe<Compliance_Groups_Bool_Exp>;
};


export type Query_RootCompliance_Groups_With_Events_AggregateArgs = {
  args: Compliance_Groups_With_Events_Args;
  distinct_on?: InputMaybe<Array<Compliance_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Groups_Order_By>>;
  where?: InputMaybe<Compliance_Groups_Bool_Exp>;
};


export type Query_RootCompliance_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Bool_Exp>;
};


export type Query_RootCompliance_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Bool_Exp>;
};


export type Query_RootCompliance_Messages_DailyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Daily_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Daily_Bool_Exp>;
};


export type Query_RootCompliance_Messages_Daily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Daily_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Daily_Bool_Exp>;
};


export type Query_RootCompliance_Messages_HourlyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Hourly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Hourly_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Hourly_Bool_Exp>;
};


export type Query_RootCompliance_Messages_Hourly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Hourly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Hourly_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Hourly_Bool_Exp>;
};


export type Query_RootCompliance_Messages_Hourly_By_PkArgs = {
  compliance_id: Scalars['Int'];
  hour: Scalars['timestamptz'];
};


export type Query_RootCompliance_Messages_MonthlyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Monthly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Monthly_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Monthly_Bool_Exp>;
};


export type Query_RootCompliance_Messages_Monthly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Monthly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Monthly_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Monthly_Bool_Exp>;
};


export type Query_RootCompliance_Messages_TotalArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Total_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Total_Bool_Exp>;
};


export type Query_RootCompliance_Messages_Total_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Total_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Total_Bool_Exp>;
};


export type Query_RootCompliance_Messages_WeeklyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Weekly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Weekly_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Weekly_Bool_Exp>;
};


export type Query_RootCompliance_Messages_Weekly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Weekly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Weekly_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Weekly_Bool_Exp>;
};


export type Query_RootCompliance_Messages_YearlyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Yearly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Yearly_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Yearly_Bool_Exp>;
};


export type Query_RootCompliance_Messages_Yearly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Yearly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Yearly_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Yearly_Bool_Exp>;
};


export type Query_RootCompliance_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Participants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Participants_Order_By>>;
  where?: InputMaybe<Compliance_Participants_Bool_Exp>;
};


export type Query_RootCompliance_Participants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Participants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Participants_Order_By>>;
  where?: InputMaybe<Compliance_Participants_Bool_Exp>;
};


export type Query_RootCompliance_PoliciesArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Policies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Policies_Order_By>>;
  where?: InputMaybe<Compliance_Policies_Bool_Exp>;
};


export type Query_RootCompliance_Policies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Policies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Policies_Order_By>>;
  where?: InputMaybe<Compliance_Policies_Bool_Exp>;
};


export type Query_RootCompliance_Policies_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompliance_RulesArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Rules_Order_By>>;
  where?: InputMaybe<Compliance_Rules_Bool_Exp>;
};


export type Query_RootCompliance_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Rules_Order_By>>;
  where?: InputMaybe<Compliance_Rules_Bool_Exp>;
};


export type Query_RootCompliance_Rules_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompliance_TagsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Tags_Order_By>>;
  where?: InputMaybe<Compliance_Tags_Bool_Exp>;
};


export type Query_RootCompliance_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Tags_Order_By>>;
  where?: InputMaybe<Compliance_Tags_Bool_Exp>;
};


export type Query_RootCompliance_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootConsentArgs = {
  distinct_on?: InputMaybe<Array<Consent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consent_Order_By>>;
  where?: InputMaybe<Consent_Bool_Exp>;
};


export type Query_RootConsent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consent_Order_By>>;
  where?: InputMaybe<Consent_Bool_Exp>;
};


export type Query_RootConsent_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootContact_ListArgs = {
  distinct_on?: InputMaybe<Array<Contact_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_List_Order_By>>;
  where?: InputMaybe<Contact_List_Bool_Exp>;
};


export type Query_RootContact_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_List_Order_By>>;
  where?: InputMaybe<Contact_List_Bool_Exp>;
};


export type Query_RootContact_List_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDuoArgs = {
  distinct_on?: InputMaybe<Array<Duo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Duo_Order_By>>;
  where?: InputMaybe<Duo_Bool_Exp>;
};


export type Query_RootDuo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Duo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Duo_Order_By>>;
  where?: InputMaybe<Duo_Bool_Exp>;
};


export type Query_RootDuo_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGetAvailableNumbersArgs = {
  object?: InputMaybe<AvailableNumbersInput>;
};


export type Query_RootGetCustomerArgs = {
  customer_id: Scalars['String'];
};


export type Query_RootGetPlanArgs = {
  identifier: Scalars['String'];
};


export type Query_RootGetSubscriptionArgs = {
  subscription_id: Scalars['String'];
};


export type Query_RootGetSubscriptionsArgs = {
  filters?: InputMaybe<SubscriptionFilters>;
};


export type Query_RootGetSubscriptionsByCustomerArgs = {
  customer_id: Scalars['String'];
};


export type Query_RootGetSubscriptionsByPlanIdentifierArgs = {
  plan_identifier: Scalars['String'];
};


export type Query_RootGroupsArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


export type Query_RootGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


export type Query_RootGroups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGroups_UsersArgs = {
  distinct_on?: InputMaybe<Array<Groups_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Users_Order_By>>;
  where?: InputMaybe<Groups_Users_Bool_Exp>;
};


export type Query_RootGroups_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Groups_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Users_Order_By>>;
  where?: InputMaybe<Groups_Users_Bool_Exp>;
};


export type Query_RootGroups_Users_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootInvite_RulesArgs = {
  distinct_on?: InputMaybe<Array<Invite_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Rules_Order_By>>;
  where?: InputMaybe<Invite_Rules_Bool_Exp>;
};


export type Query_RootInvite_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invite_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Rules_Order_By>>;
  where?: InputMaybe<Invite_Rules_Bool_Exp>;
};


export type Query_RootInvite_Rules_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootInvite_Rules_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Invite_Rules_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Rules_Recipients_Order_By>>;
  where?: InputMaybe<Invite_Rules_Recipients_Bool_Exp>;
};


export type Query_RootInvite_Rules_Recipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invite_Rules_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Rules_Recipients_Order_By>>;
  where?: InputMaybe<Invite_Rules_Recipients_Bool_Exp>;
};


export type Query_RootInvite_Rules_Recipients_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootLicense_RecordsArgs = {
  distinct_on?: InputMaybe<Array<License_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<License_Records_Order_By>>;
  where?: InputMaybe<License_Records_Bool_Exp>;
};


export type Query_RootLicense_Records_AggregateArgs = {
  distinct_on?: InputMaybe<Array<License_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<License_Records_Order_By>>;
  where?: InputMaybe<License_Records_Bool_Exp>;
};


export type Query_RootLicense_Records_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootLinkArgs = {
  distinct_on?: InputMaybe<Array<Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Order_By>>;
  where?: InputMaybe<Link_Bool_Exp>;
};


export type Query_RootLink_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Order_By>>;
  where?: InputMaybe<Link_Bool_Exp>;
};


export type Query_RootLink_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootLink_DomainsArgs = {
  distinct_on?: InputMaybe<Array<Link_Domains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Domains_Order_By>>;
  where?: InputMaybe<Link_Domains_Bool_Exp>;
};


export type Query_RootLink_Domains_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Link_Domains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Domains_Order_By>>;
  where?: InputMaybe<Link_Domains_Bool_Exp>;
};


export type Query_RootLink_Domains_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootLogsArgs = {
  distinct_on?: InputMaybe<Array<Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Logs_Order_By>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


export type Query_RootLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Logs_Order_By>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


export type Query_RootLogs_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPhone_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Phone_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phone_Providers_Order_By>>;
  where?: InputMaybe<Phone_Providers_Bool_Exp>;
};


export type Query_RootPhone_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phone_Providers_Order_By>>;
  where?: InputMaybe<Phone_Providers_Bool_Exp>;
};


export type Query_RootPhone_Providers_By_PkArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type Query_RootPhonesArgs = {
  distinct_on?: InputMaybe<Array<Phones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phones_Order_By>>;
  where?: InputMaybe<Phones_Bool_Exp>;
};


export type Query_RootPhones_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phones_Order_By>>;
  where?: InputMaybe<Phones_Bool_Exp>;
};


export type Query_RootPhones_By_PkArgs = {
  id: Scalars['Int'];
  phone: Scalars['String'];
};


export type Query_RootProductsArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootProducts_By_PkArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type Query_RootRelevant_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Contacts_Order_By>>;
  where?: InputMaybe<Relevant_Contacts_Bool_Exp>;
};


export type Query_RootRelevant_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Contacts_Order_By>>;
  where?: InputMaybe<Relevant_Contacts_Bool_Exp>;
};


export type Query_RootRelevant_Contacts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootRelevant_Contacts_TagsArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Contacts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Contacts_Tags_Order_By>>;
  where?: InputMaybe<Relevant_Contacts_Tags_Bool_Exp>;
};


export type Query_RootRelevant_Contacts_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Contacts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Contacts_Tags_Order_By>>;
  where?: InputMaybe<Relevant_Contacts_Tags_Bool_Exp>;
};


export type Query_RootRelevant_Contacts_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_By_PkArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type Query_RootRoles_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Roles_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Teams_Order_By>>;
  where?: InputMaybe<Roles_Teams_Bool_Exp>;
};


export type Query_RootRoles_Teams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Teams_Order_By>>;
  where?: InputMaybe<Roles_Teams_Bool_Exp>;
};


export type Query_RootRoles_Teams_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootRoles_UsersArgs = {
  distinct_on?: InputMaybe<Array<Roles_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Users_Order_By>>;
  where?: InputMaybe<Roles_Users_Bool_Exp>;
};


export type Query_RootRoles_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Users_Order_By>>;
  where?: InputMaybe<Roles_Users_Bool_Exp>;
};


export type Query_RootRoles_Users_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootRollupsArgs = {
  distinct_on?: InputMaybe<Array<Rollups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rollups_Order_By>>;
  where?: InputMaybe<Rollups_Bool_Exp>;
};


export type Query_RootRollups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rollups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rollups_Order_By>>;
  where?: InputMaybe<Rollups_Bool_Exp>;
};


export type Query_RootRollups_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootSelect_Incomplete_Compliance_EventsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


export type Query_RootSelect_Incomplete_Compliance_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


export type Query_RootSubscription_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Providers_Order_By>>;
  where?: InputMaybe<Subscription_Providers_Bool_Exp>;
};


export type Query_RootSubscription_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Providers_Order_By>>;
  where?: InputMaybe<Subscription_Providers_Bool_Exp>;
};


export type Query_RootSubscription_Providers_By_PkArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type Query_RootSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Query_RootSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Query_RootSubscriptions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Query_RootTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Query_RootTags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootTeams_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTeams_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Settings_Order_By>>;
  where?: InputMaybe<Teams_Settings_Bool_Exp>;
};


export type Query_RootTeams_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Settings_Order_By>>;
  where?: InputMaybe<Teams_Settings_Bool_Exp>;
};


export type Query_RootTeams_Settings_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTeams_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Teams_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Templates_Order_By>>;
  where?: InputMaybe<Teams_Templates_Bool_Exp>;
};


export type Query_RootTeams_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Templates_Order_By>>;
  where?: InputMaybe<Teams_Templates_Bool_Exp>;
};


export type Query_RootTeams_Templates_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTeams_UsersArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


export type Query_RootTeams_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


export type Query_RootTeams_Users_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTemplatesArgs = {
  distinct_on?: InputMaybe<Array<Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Templates_Order_By>>;
  where?: InputMaybe<Templates_Bool_Exp>;
};


export type Query_RootTemplates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Templates_Order_By>>;
  where?: InputMaybe<Templates_Bool_Exp>;
};


export type Query_RootTemplates_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTenantArgs = {
  distinct_on?: InputMaybe<Array<Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenant_Order_By>>;
  where?: InputMaybe<Tenant_Bool_Exp>;
};


export type Query_RootTenant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenant_Order_By>>;
  where?: InputMaybe<Tenant_Bool_Exp>;
};


export type Query_RootTenant_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootTokensArgs = {
  distinct_on?: InputMaybe<Array<Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tokens_Order_By>>;
  where?: InputMaybe<Tokens_Bool_Exp>;
};


export type Query_RootTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tokens_Order_By>>;
  where?: InputMaybe<Tokens_Bool_Exp>;
};


export type Query_RootTokens_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_Auth_CodesArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Codes_Order_By>>;
  where?: InputMaybe<User_Auth_Codes_Bool_Exp>;
};


export type Query_RootUser_Auth_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Codes_Order_By>>;
  where?: InputMaybe<User_Auth_Codes_Bool_Exp>;
};


export type Query_RootUser_Auth_Codes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootWeb_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Web_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Web_Contacts_Order_By>>;
  where?: InputMaybe<Web_Contacts_Bool_Exp>;
};


export type Query_RootWeb_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Web_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Web_Contacts_Order_By>>;
  where?: InputMaybe<Web_Contacts_Bool_Exp>;
};


export type Query_RootWeb_Contacts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootWeb_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Web_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Web_Messages_Order_By>>;
  where?: InputMaybe<Web_Messages_Bool_Exp>;
};


export type Query_RootWeb_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Web_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Web_Messages_Order_By>>;
  where?: InputMaybe<Web_Messages_Bool_Exp>;
};


export type Query_RootWeb_Messages_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootWeb_Qr_CodesArgs = {
  distinct_on?: InputMaybe<Array<Web_Qr_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Web_Qr_Codes_Order_By>>;
  where?: InputMaybe<Web_Qr_Codes_Bool_Exp>;
};


export type Query_RootWeb_Qr_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Web_Qr_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Web_Qr_Codes_Order_By>>;
  where?: InputMaybe<Web_Qr_Codes_Bool_Exp>;
};


export type Query_RootWeb_Qr_Codes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootWhatsapp__MessageTomessage_UpdateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp__MessageTomessage_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp__MessageTomessage_Update_Order_By>>;
  where?: InputMaybe<Whatsapp__MessageTomessage_Update_Bool_Exp>;
};


export type Query_RootWhatsapp__MessageTomessage_Update_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp__MessageTomessage_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp__MessageTomessage_Update_Order_By>>;
  where?: InputMaybe<Whatsapp__MessageTomessage_Update_Bool_Exp>;
};


export type Query_RootWhatsapp_ChatArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Chat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Chat_Order_By>>;
  where?: InputMaybe<Whatsapp_Chat_Bool_Exp>;
};


export type Query_RootWhatsapp_Chat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Chat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Chat_Order_By>>;
  where?: InputMaybe<Whatsapp_Chat_Bool_Exp>;
};


export type Query_RootWhatsapp_Chat_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootWhatsapp_ContactArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Contact_Order_By>>;
  where?: InputMaybe<Whatsapp_Contact_Bool_Exp>;
};


export type Query_RootWhatsapp_Contact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Contact_Order_By>>;
  where?: InputMaybe<Whatsapp_Contact_Bool_Exp>;
};


export type Query_RootWhatsapp_Contact_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootWhatsapp_MessageArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Message_Order_By>>;
  where?: InputMaybe<Whatsapp_Message_Bool_Exp>;
};


export type Query_RootWhatsapp_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Message_Order_By>>;
  where?: InputMaybe<Whatsapp_Message_Bool_Exp>;
};


export type Query_RootWhatsapp_Message_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootWhatsapp_Message_UpdateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Message_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Message_Update_Order_By>>;
  where?: InputMaybe<Whatsapp_Message_Update_Bool_Exp>;
};


export type Query_RootWhatsapp_Message_Update_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Message_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Message_Update_Order_By>>;
  where?: InputMaybe<Whatsapp_Message_Update_Bool_Exp>;
};


export type Query_RootWhatsapp_Message_Update_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootWhatsapp_SessionArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Session_Order_By>>;
  where?: InputMaybe<Whatsapp_Session_Bool_Exp>;
};


export type Query_RootWhatsapp_Session_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Session_Order_By>>;
  where?: InputMaybe<Whatsapp_Session_Bool_Exp>;
};


export type Query_RootWhatsapp_Session_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootWhatsapp_Session_CredentialArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Session_Credential_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Session_Credential_Order_By>>;
  where?: InputMaybe<Whatsapp_Session_Credential_Bool_Exp>;
};


export type Query_RootWhatsapp_Session_Credential_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Session_Credential_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Session_Credential_Order_By>>;
  where?: InputMaybe<Whatsapp_Session_Credential_Bool_Exp>;
};


export type Query_RootWhatsapp_Session_Credential_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootWhatsapp_Session_History_SyncArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Session_History_Sync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Session_History_Sync_Order_By>>;
  where?: InputMaybe<Whatsapp_Session_History_Sync_Bool_Exp>;
};


export type Query_RootWhatsapp_Session_History_Sync_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Session_History_Sync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Session_History_Sync_Order_By>>;
  where?: InputMaybe<Whatsapp_Session_History_Sync_Bool_Exp>;
};


export type Query_RootWhatsapp_Session_History_Sync_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootWhatsapp_Session_KeyArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Session_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Session_Key_Order_By>>;
  where?: InputMaybe<Whatsapp_Session_Key_Bool_Exp>;
};


export type Query_RootWhatsapp_Session_Key_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Session_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Session_Key_Order_By>>;
  where?: InputMaybe<Whatsapp_Session_Key_Bool_Exp>;
};


export type Query_RootWos_SyncArgs = {
  distinct_on?: InputMaybe<Array<Wos_Sync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wos_Sync_Order_By>>;
  where?: InputMaybe<Wos_Sync_Bool_Exp>;
};


export type Query_RootWos_Sync_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wos_Sync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wos_Sync_Order_By>>;
  where?: InputMaybe<Wos_Sync_Bool_Exp>;
};


export type Query_RootWos_Sync_By_PkArgs = {
  last_event_id: Scalars['String'];
};


export type Query_RootWs_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Ws_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Contacts_Order_By>>;
  where?: InputMaybe<Ws_Contacts_Bool_Exp>;
};


export type Query_RootWs_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Contacts_Order_By>>;
  where?: InputMaybe<Ws_Contacts_Bool_Exp>;
};


export type Query_RootWs_Contacts_By_PkArgs = {
  phone: Scalars['String'];
};


export type Query_RootWs_History_SyncArgs = {
  distinct_on?: InputMaybe<Array<Ws_History_Sync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_History_Sync_Order_By>>;
  where?: InputMaybe<Ws_History_Sync_Bool_Exp>;
};


export type Query_RootWs_History_Sync_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_History_Sync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_History_Sync_Order_By>>;
  where?: InputMaybe<Ws_History_Sync_Bool_Exp>;
};


export type Query_RootWs_History_Sync_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWs_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Ws_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Messages_Order_By>>;
  where?: InputMaybe<Ws_Messages_Bool_Exp>;
};


export type Query_RootWs_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Messages_Order_By>>;
  where?: InputMaybe<Ws_Messages_Bool_Exp>;
};


export type Query_RootWs_Messages_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootWs_ServersArgs = {
  distinct_on?: InputMaybe<Array<Ws_Servers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Servers_Order_By>>;
  where?: InputMaybe<Ws_Servers_Bool_Exp>;
};


export type Query_RootWs_Servers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Servers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Servers_Order_By>>;
  where?: InputMaybe<Ws_Servers_Bool_Exp>;
};


export type Query_RootWs_Servers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootWs_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Bool_Exp>;
};


export type Query_RootWs_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Bool_Exp>;
};


export type Query_RootWs_Sessions_By_PkArgs = {
  uuid: Scalars['uuid'];
};


export type Query_RootWs_Sessions_CredentialsArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Credentials_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Credentials_Bool_Exp>;
};


export type Query_RootWs_Sessions_Credentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Credentials_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Credentials_Bool_Exp>;
};


export type Query_RootWs_Sessions_Credentials_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootWs_Sessions_KeysArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Keys_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Keys_Bool_Exp>;
};


export type Query_RootWs_Sessions_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Keys_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Keys_Bool_Exp>;
};


export type Query_RootWs_Sessions_Keys_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootWs_Sessions_Signal_KeysArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Signal_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Signal_Keys_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Signal_Keys_Bool_Exp>;
};


export type Query_RootWs_Sessions_Signal_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Signal_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Signal_Keys_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Signal_Keys_Bool_Exp>;
};


export type Query_RootWs_Sessions_Signal_Keys_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootWs_Sessions_StatsArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Stats_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Stats_Bool_Exp>;
};


export type Query_RootWs_Sessions_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Stats_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Stats_Bool_Exp>;
};


export type Query_RootWs_Sessions_Stats_By_PkArgs = {
  id: Scalars['Int'];
};

/** columns and relationships of "relevant_contacts" */
export type Relevant_Contacts = {
  __typename?: 'relevant_contacts';
  /** An object relationship */
  compliance: Compliance;
  compliance_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  /** An array relationship */
  relevant_contacts_tags: Array<Relevant_Contacts_Tags>;
  /** An aggregate relationship */
  relevant_contacts_tags_aggregate: Relevant_Contacts_Tags_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "relevant_contacts" */
export type Relevant_ContactsRelevant_Contacts_TagsArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Contacts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Contacts_Tags_Order_By>>;
  where?: InputMaybe<Relevant_Contacts_Tags_Bool_Exp>;
};


/** columns and relationships of "relevant_contacts" */
export type Relevant_ContactsRelevant_Contacts_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Contacts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Contacts_Tags_Order_By>>;
  where?: InputMaybe<Relevant_Contacts_Tags_Bool_Exp>;
};

/** aggregated selection of "relevant_contacts" */
export type Relevant_Contacts_Aggregate = {
  __typename?: 'relevant_contacts_aggregate';
  aggregate?: Maybe<Relevant_Contacts_Aggregate_Fields>;
  nodes: Array<Relevant_Contacts>;
};

/** aggregate fields of "relevant_contacts" */
export type Relevant_Contacts_Aggregate_Fields = {
  __typename?: 'relevant_contacts_aggregate_fields';
  avg?: Maybe<Relevant_Contacts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Relevant_Contacts_Max_Fields>;
  min?: Maybe<Relevant_Contacts_Min_Fields>;
  stddev?: Maybe<Relevant_Contacts_Stddev_Fields>;
  stddev_pop?: Maybe<Relevant_Contacts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Relevant_Contacts_Stddev_Samp_Fields>;
  sum?: Maybe<Relevant_Contacts_Sum_Fields>;
  var_pop?: Maybe<Relevant_Contacts_Var_Pop_Fields>;
  var_samp?: Maybe<Relevant_Contacts_Var_Samp_Fields>;
  variance?: Maybe<Relevant_Contacts_Variance_Fields>;
};


/** aggregate fields of "relevant_contacts" */
export type Relevant_Contacts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Relevant_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Relevant_Contacts_Avg_Fields = {
  __typename?: 'relevant_contacts_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "relevant_contacts". All fields are combined with a logical 'AND'. */
export type Relevant_Contacts_Bool_Exp = {
  _and?: InputMaybe<Array<Relevant_Contacts_Bool_Exp>>;
  _not?: InputMaybe<Relevant_Contacts_Bool_Exp>;
  _or?: InputMaybe<Array<Relevant_Contacts_Bool_Exp>>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  relevant_contacts_tags?: InputMaybe<Relevant_Contacts_Tags_Bool_Exp>;
  relevant_contacts_tags_aggregate?: InputMaybe<Relevant_Contacts_Tags_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "relevant_contacts" */
export enum Relevant_Contacts_Constraint {
  /** unique or primary key constraint on columns "phone", "compliance_id" */
  RelevantContactsPhoneComplianceIdKey = 'relevant_contacts_phone_compliance_id_key',
  /** unique or primary key constraint on columns "id" */
  RelevantContactsPkey = 'relevant_contacts_pkey'
}

/** input type for incrementing numeric columns in table "relevant_contacts" */
export type Relevant_Contacts_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "relevant_contacts" */
export type Relevant_Contacts_Insert_Input = {
  compliance?: InputMaybe<Compliance_Obj_Rel_Insert_Input>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  relevant_contacts_tags?: InputMaybe<Relevant_Contacts_Tags_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Relevant_Contacts_Max_Fields = {
  __typename?: 'relevant_contacts_max_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Relevant_Contacts_Min_Fields = {
  __typename?: 'relevant_contacts_min_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "relevant_contacts" */
export type Relevant_Contacts_Mutation_Response = {
  __typename?: 'relevant_contacts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Relevant_Contacts>;
};

/** input type for inserting object relation for remote table "relevant_contacts" */
export type Relevant_Contacts_Obj_Rel_Insert_Input = {
  data: Relevant_Contacts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Relevant_Contacts_On_Conflict>;
};

/** on_conflict condition type for table "relevant_contacts" */
export type Relevant_Contacts_On_Conflict = {
  constraint: Relevant_Contacts_Constraint;
  update_columns?: Array<Relevant_Contacts_Update_Column>;
  where?: InputMaybe<Relevant_Contacts_Bool_Exp>;
};

/** Ordering options when selecting data from "relevant_contacts". */
export type Relevant_Contacts_Order_By = {
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  relevant_contacts_tags_aggregate?: InputMaybe<Relevant_Contacts_Tags_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: relevant_contacts */
export type Relevant_Contacts_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "relevant_contacts" */
export enum Relevant_Contacts_Select_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "relevant_contacts" */
export type Relevant_Contacts_Set_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Relevant_Contacts_Stddev_Fields = {
  __typename?: 'relevant_contacts_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Relevant_Contacts_Stddev_Pop_Fields = {
  __typename?: 'relevant_contacts_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Relevant_Contacts_Stddev_Samp_Fields = {
  __typename?: 'relevant_contacts_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "relevant_contacts" */
export type Relevant_Contacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Relevant_Contacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Relevant_Contacts_Stream_Cursor_Value_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Relevant_Contacts_Sum_Fields = {
  __typename?: 'relevant_contacts_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "relevant_contacts_tags" */
export type Relevant_Contacts_Tags = {
  __typename?: 'relevant_contacts_tags';
  id: Scalars['Int'];
  /** An object relationship */
  relevant_contact: Relevant_Contacts;
  relevant_contact_id: Scalars['Int'];
  /** An object relationship */
  tag: Tags;
  tag_id: Scalars['Int'];
};

/** aggregated selection of "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Aggregate = {
  __typename?: 'relevant_contacts_tags_aggregate';
  aggregate?: Maybe<Relevant_Contacts_Tags_Aggregate_Fields>;
  nodes: Array<Relevant_Contacts_Tags>;
};

export type Relevant_Contacts_Tags_Aggregate_Bool_Exp = {
  count?: InputMaybe<Relevant_Contacts_Tags_Aggregate_Bool_Exp_Count>;
};

export type Relevant_Contacts_Tags_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Relevant_Contacts_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Relevant_Contacts_Tags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Aggregate_Fields = {
  __typename?: 'relevant_contacts_tags_aggregate_fields';
  avg?: Maybe<Relevant_Contacts_Tags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Relevant_Contacts_Tags_Max_Fields>;
  min?: Maybe<Relevant_Contacts_Tags_Min_Fields>;
  stddev?: Maybe<Relevant_Contacts_Tags_Stddev_Fields>;
  stddev_pop?: Maybe<Relevant_Contacts_Tags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Relevant_Contacts_Tags_Stddev_Samp_Fields>;
  sum?: Maybe<Relevant_Contacts_Tags_Sum_Fields>;
  var_pop?: Maybe<Relevant_Contacts_Tags_Var_Pop_Fields>;
  var_samp?: Maybe<Relevant_Contacts_Tags_Var_Samp_Fields>;
  variance?: Maybe<Relevant_Contacts_Tags_Variance_Fields>;
};


/** aggregate fields of "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Relevant_Contacts_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Aggregate_Order_By = {
  avg?: InputMaybe<Relevant_Contacts_Tags_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Relevant_Contacts_Tags_Max_Order_By>;
  min?: InputMaybe<Relevant_Contacts_Tags_Min_Order_By>;
  stddev?: InputMaybe<Relevant_Contacts_Tags_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Relevant_Contacts_Tags_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Relevant_Contacts_Tags_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Relevant_Contacts_Tags_Sum_Order_By>;
  var_pop?: InputMaybe<Relevant_Contacts_Tags_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Relevant_Contacts_Tags_Var_Samp_Order_By>;
  variance?: InputMaybe<Relevant_Contacts_Tags_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Arr_Rel_Insert_Input = {
  data: Array<Relevant_Contacts_Tags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Relevant_Contacts_Tags_On_Conflict>;
};

/** aggregate avg on columns */
export type Relevant_Contacts_Tags_Avg_Fields = {
  __typename?: 'relevant_contacts_tags_avg_fields';
  id?: Maybe<Scalars['Float']>;
  relevant_contact_id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  relevant_contact_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "relevant_contacts_tags". All fields are combined with a logical 'AND'. */
export type Relevant_Contacts_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Relevant_Contacts_Tags_Bool_Exp>>;
  _not?: InputMaybe<Relevant_Contacts_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Relevant_Contacts_Tags_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  relevant_contact?: InputMaybe<Relevant_Contacts_Bool_Exp>;
  relevant_contact_id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<Tags_Bool_Exp>;
  tag_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "relevant_contacts_tags" */
export enum Relevant_Contacts_Tags_Constraint {
  /** unique or primary key constraint on columns "id" */
  RelevantContactsTagsPkey = 'relevant_contacts_tags_pkey',
  /** unique or primary key constraint on columns "relevant_contact_id", "tag_id" */
  RelevantContactsTagsRelevantContactIdTagIdKey = 'relevant_contacts_tags_relevant_contact_id_tag_id_key'
}

/** input type for incrementing numeric columns in table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  relevant_contact_id?: InputMaybe<Scalars['Int']>;
  tag_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  relevant_contact?: InputMaybe<Relevant_Contacts_Obj_Rel_Insert_Input>;
  relevant_contact_id?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Tags_Obj_Rel_Insert_Input>;
  tag_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Relevant_Contacts_Tags_Max_Fields = {
  __typename?: 'relevant_contacts_tags_max_fields';
  id?: Maybe<Scalars['Int']>;
  relevant_contact_id?: Maybe<Scalars['Int']>;
  tag_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  relevant_contact_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Relevant_Contacts_Tags_Min_Fields = {
  __typename?: 'relevant_contacts_tags_min_fields';
  id?: Maybe<Scalars['Int']>;
  relevant_contact_id?: Maybe<Scalars['Int']>;
  tag_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  relevant_contact_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Mutation_Response = {
  __typename?: 'relevant_contacts_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Relevant_Contacts_Tags>;
};

/** on_conflict condition type for table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_On_Conflict = {
  constraint: Relevant_Contacts_Tags_Constraint;
  update_columns?: Array<Relevant_Contacts_Tags_Update_Column>;
  where?: InputMaybe<Relevant_Contacts_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "relevant_contacts_tags". */
export type Relevant_Contacts_Tags_Order_By = {
  id?: InputMaybe<Order_By>;
  relevant_contact?: InputMaybe<Relevant_Contacts_Order_By>;
  relevant_contact_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Tags_Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: relevant_contacts_tags */
export type Relevant_Contacts_Tags_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "relevant_contacts_tags" */
export enum Relevant_Contacts_Tags_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RelevantContactId = 'relevant_contact_id',
  /** column name */
  TagId = 'tag_id'
}

/** input type for updating data in table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  relevant_contact_id?: InputMaybe<Scalars['Int']>;
  tag_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Relevant_Contacts_Tags_Stddev_Fields = {
  __typename?: 'relevant_contacts_tags_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  relevant_contact_id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  relevant_contact_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Relevant_Contacts_Tags_Stddev_Pop_Fields = {
  __typename?: 'relevant_contacts_tags_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  relevant_contact_id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  relevant_contact_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Relevant_Contacts_Tags_Stddev_Samp_Fields = {
  __typename?: 'relevant_contacts_tags_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  relevant_contact_id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  relevant_contact_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Relevant_Contacts_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Relevant_Contacts_Tags_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  relevant_contact_id?: InputMaybe<Scalars['Int']>;
  tag_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Relevant_Contacts_Tags_Sum_Fields = {
  __typename?: 'relevant_contacts_tags_sum_fields';
  id?: Maybe<Scalars['Int']>;
  relevant_contact_id?: Maybe<Scalars['Int']>;
  tag_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  relevant_contact_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** update columns of table "relevant_contacts_tags" */
export enum Relevant_Contacts_Tags_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RelevantContactId = 'relevant_contact_id',
  /** column name */
  TagId = 'tag_id'
}

export type Relevant_Contacts_Tags_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Relevant_Contacts_Tags_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Relevant_Contacts_Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Relevant_Contacts_Tags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Relevant_Contacts_Tags_Var_Pop_Fields = {
  __typename?: 'relevant_contacts_tags_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  relevant_contact_id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  relevant_contact_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Relevant_Contacts_Tags_Var_Samp_Fields = {
  __typename?: 'relevant_contacts_tags_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  relevant_contact_id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  relevant_contact_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Relevant_Contacts_Tags_Variance_Fields = {
  __typename?: 'relevant_contacts_tags_variance_fields';
  id?: Maybe<Scalars['Float']>;
  relevant_contact_id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "relevant_contacts_tags" */
export type Relevant_Contacts_Tags_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  relevant_contact_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** update columns of table "relevant_contacts" */
export enum Relevant_Contacts_Update_Column {
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Relevant_Contacts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Relevant_Contacts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Relevant_Contacts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Relevant_Contacts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Relevant_Contacts_Var_Pop_Fields = {
  __typename?: 'relevant_contacts_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Relevant_Contacts_Var_Samp_Fields = {
  __typename?: 'relevant_contacts_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Relevant_Contacts_Variance_Fields = {
  __typename?: 'relevant_contacts_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "roles" */
export type Roles = {
  __typename?: 'roles';
  alias: Scalars['String'];
  id: Scalars['Int'];
  is_default?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  permissions: Scalars['jsonb'];
  /** An object relationship */
  product?: Maybe<Products>;
  product_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  roles_teams: Array<Roles_Teams>;
  /** An aggregate relationship */
  roles_teams_aggregate: Roles_Teams_Aggregate;
  /** An array relationship */
  roles_users: Array<Roles_Users>;
  /** An aggregate relationship */
  roles_users_aggregate: Roles_Users_Aggregate;
};


/** columns and relationships of "roles" */
export type RolesPermissionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "roles" */
export type RolesRoles_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Roles_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Teams_Order_By>>;
  where?: InputMaybe<Roles_Teams_Bool_Exp>;
};


/** columns and relationships of "roles" */
export type RolesRoles_Teams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Teams_Order_By>>;
  where?: InputMaybe<Roles_Teams_Bool_Exp>;
};


/** columns and relationships of "roles" */
export type RolesRoles_UsersArgs = {
  distinct_on?: InputMaybe<Array<Roles_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Users_Order_By>>;
  where?: InputMaybe<Roles_Users_Bool_Exp>;
};


/** columns and relationships of "roles" */
export type RolesRoles_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Users_Order_By>>;
  where?: InputMaybe<Roles_Users_Bool_Exp>;
};

/** aggregated selection of "roles" */
export type Roles_Aggregate = {
  __typename?: 'roles_aggregate';
  aggregate?: Maybe<Roles_Aggregate_Fields>;
  nodes: Array<Roles>;
};

/** aggregate fields of "roles" */
export type Roles_Aggregate_Fields = {
  __typename?: 'roles_aggregate_fields';
  avg?: Maybe<Roles_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Roles_Max_Fields>;
  min?: Maybe<Roles_Min_Fields>;
  stddev?: Maybe<Roles_Stddev_Fields>;
  stddev_pop?: Maybe<Roles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Roles_Stddev_Samp_Fields>;
  sum?: Maybe<Roles_Sum_Fields>;
  var_pop?: Maybe<Roles_Var_Pop_Fields>;
  var_samp?: Maybe<Roles_Var_Samp_Fields>;
  variance?: Maybe<Roles_Variance_Fields>;
};


/** aggregate fields of "roles" */
export type Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Roles_Append_Input = {
  permissions?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Roles_Avg_Fields = {
  __typename?: 'roles_avg_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Roles_Bool_Exp>>;
  _not?: InputMaybe<Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Roles_Bool_Exp>>;
  alias?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  permissions?: InputMaybe<Jsonb_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  product_id?: InputMaybe<Int_Comparison_Exp>;
  roles_teams?: InputMaybe<Roles_Teams_Bool_Exp>;
  roles_teams_aggregate?: InputMaybe<Roles_Teams_Aggregate_Bool_Exp>;
  roles_users?: InputMaybe<Roles_Users_Bool_Exp>;
  roles_users_aggregate?: InputMaybe<Roles_Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "roles" */
export enum Roles_Constraint {
  /** unique or primary key constraint on columns "id" */
  RolesIdKey = 'roles_id_key',
  /** unique or primary key constraint on columns "name" */
  RolesNameKey = 'roles_name_key',
  /** unique or primary key constraint on columns "id", "name" */
  RolesPkey = 'roles_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Roles_Delete_At_Path_Input = {
  permissions?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Roles_Delete_Elem_Input = {
  permissions?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Roles_Delete_Key_Input = {
  permissions?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "roles" */
export type Roles_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "roles" */
export type Roles_Insert_Input = {
  alias?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['jsonb']>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['Int']>;
  roles_teams?: InputMaybe<Roles_Teams_Arr_Rel_Insert_Input>;
  roles_users?: InputMaybe<Roles_Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Roles_Max_Fields = {
  __typename?: 'roles_max_fields';
  alias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Roles_Min_Fields = {
  __typename?: 'roles_min_fields';
  alias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "roles" */
export type Roles_Mutation_Response = {
  __typename?: 'roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Roles>;
};

/** input type for inserting object relation for remote table "roles" */
export type Roles_Obj_Rel_Insert_Input = {
  data: Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};

/** on_conflict condition type for table "roles" */
export type Roles_On_Conflict = {
  constraint: Roles_Constraint;
  update_columns?: Array<Roles_Update_Column>;
  where?: InputMaybe<Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "roles". */
export type Roles_Order_By = {
  alias?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  permissions?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  product_id?: InputMaybe<Order_By>;
  roles_teams_aggregate?: InputMaybe<Roles_Teams_Aggregate_Order_By>;
  roles_users_aggregate?: InputMaybe<Roles_Users_Aggregate_Order_By>;
};

/** primary key columns input for table: roles */
export type Roles_Pk_Columns_Input = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Roles_Prepend_Input = {
  permissions?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "roles" */
export enum Roles_Select_Column {
  /** column name */
  Alias = 'alias',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Name = 'name',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  ProductId = 'product_id'
}

/** input type for updating data in table "roles" */
export type Roles_Set_Input = {
  alias?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['jsonb']>;
  product_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Roles_Stddev_Fields = {
  __typename?: 'roles_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Roles_Stddev_Pop_Fields = {
  __typename?: 'roles_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Roles_Stddev_Samp_Fields = {
  __typename?: 'roles_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "roles" */
export type Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Roles_Stream_Cursor_Value_Input = {
  alias?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['jsonb']>;
  product_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Roles_Sum_Fields = {
  __typename?: 'roles_sum_fields';
  id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "roles_teams" */
export type Roles_Teams = {
  __typename?: 'roles_teams';
  id: Scalars['Int'];
  /** An object relationship */
  role?: Maybe<Roles>;
  role_id: Scalars['Int'];
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id: Scalars['Int'];
};

/** aggregated selection of "roles_teams" */
export type Roles_Teams_Aggregate = {
  __typename?: 'roles_teams_aggregate';
  aggregate?: Maybe<Roles_Teams_Aggregate_Fields>;
  nodes: Array<Roles_Teams>;
};

export type Roles_Teams_Aggregate_Bool_Exp = {
  count?: InputMaybe<Roles_Teams_Aggregate_Bool_Exp_Count>;
};

export type Roles_Teams_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Roles_Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Roles_Teams_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "roles_teams" */
export type Roles_Teams_Aggregate_Fields = {
  __typename?: 'roles_teams_aggregate_fields';
  avg?: Maybe<Roles_Teams_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Roles_Teams_Max_Fields>;
  min?: Maybe<Roles_Teams_Min_Fields>;
  stddev?: Maybe<Roles_Teams_Stddev_Fields>;
  stddev_pop?: Maybe<Roles_Teams_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Roles_Teams_Stddev_Samp_Fields>;
  sum?: Maybe<Roles_Teams_Sum_Fields>;
  var_pop?: Maybe<Roles_Teams_Var_Pop_Fields>;
  var_samp?: Maybe<Roles_Teams_Var_Samp_Fields>;
  variance?: Maybe<Roles_Teams_Variance_Fields>;
};


/** aggregate fields of "roles_teams" */
export type Roles_Teams_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Roles_Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "roles_teams" */
export type Roles_Teams_Aggregate_Order_By = {
  avg?: InputMaybe<Roles_Teams_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Roles_Teams_Max_Order_By>;
  min?: InputMaybe<Roles_Teams_Min_Order_By>;
  stddev?: InputMaybe<Roles_Teams_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Roles_Teams_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Roles_Teams_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Roles_Teams_Sum_Order_By>;
  var_pop?: InputMaybe<Roles_Teams_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Roles_Teams_Var_Samp_Order_By>;
  variance?: InputMaybe<Roles_Teams_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "roles_teams" */
export type Roles_Teams_Arr_Rel_Insert_Input = {
  data: Array<Roles_Teams_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Roles_Teams_On_Conflict>;
};

/** aggregate avg on columns */
export type Roles_Teams_Avg_Fields = {
  __typename?: 'roles_teams_avg_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "roles_teams" */
export type Roles_Teams_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "roles_teams". All fields are combined with a logical 'AND'. */
export type Roles_Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Roles_Teams_Bool_Exp>>;
  _not?: InputMaybe<Roles_Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Roles_Teams_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  role_id?: InputMaybe<Int_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "roles_teams" */
export enum Roles_Teams_Constraint {
  /** unique or primary key constraint on columns "id" */
  RolesTeamsPkey = 'roles_teams_pkey'
}

/** input type for incrementing numeric columns in table "roles_teams" */
export type Roles_Teams_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  role_id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "roles_teams" */
export type Roles_Teams_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['Int']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Roles_Teams_Max_Fields = {
  __typename?: 'roles_teams_max_fields';
  id?: Maybe<Scalars['Int']>;
  role_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "roles_teams" */
export type Roles_Teams_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Roles_Teams_Min_Fields = {
  __typename?: 'roles_teams_min_fields';
  id?: Maybe<Scalars['Int']>;
  role_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "roles_teams" */
export type Roles_Teams_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "roles_teams" */
export type Roles_Teams_Mutation_Response = {
  __typename?: 'roles_teams_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Roles_Teams>;
};

/** on_conflict condition type for table "roles_teams" */
export type Roles_Teams_On_Conflict = {
  constraint: Roles_Teams_Constraint;
  update_columns?: Array<Roles_Teams_Update_Column>;
  where?: InputMaybe<Roles_Teams_Bool_Exp>;
};

/** Ordering options when selecting data from "roles_teams". */
export type Roles_Teams_Order_By = {
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  role_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roles_teams */
export type Roles_Teams_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "roles_teams" */
export enum Roles_Teams_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  TeamId = 'team_id'
}

/** input type for updating data in table "roles_teams" */
export type Roles_Teams_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  role_id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Roles_Teams_Stddev_Fields = {
  __typename?: 'roles_teams_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "roles_teams" */
export type Roles_Teams_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Roles_Teams_Stddev_Pop_Fields = {
  __typename?: 'roles_teams_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "roles_teams" */
export type Roles_Teams_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Roles_Teams_Stddev_Samp_Fields = {
  __typename?: 'roles_teams_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "roles_teams" */
export type Roles_Teams_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "roles_teams" */
export type Roles_Teams_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Roles_Teams_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Roles_Teams_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  role_id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Roles_Teams_Sum_Fields = {
  __typename?: 'roles_teams_sum_fields';
  id?: Maybe<Scalars['Int']>;
  role_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "roles_teams" */
export type Roles_Teams_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "roles_teams" */
export enum Roles_Teams_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  TeamId = 'team_id'
}

export type Roles_Teams_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Roles_Teams_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Roles_Teams_Set_Input>;
  /** filter the rows which have to be updated */
  where: Roles_Teams_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Roles_Teams_Var_Pop_Fields = {
  __typename?: 'roles_teams_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "roles_teams" */
export type Roles_Teams_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Roles_Teams_Var_Samp_Fields = {
  __typename?: 'roles_teams_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "roles_teams" */
export type Roles_Teams_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Roles_Teams_Variance_Fields = {
  __typename?: 'roles_teams_variance_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "roles_teams" */
export type Roles_Teams_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "roles" */
export enum Roles_Update_Column {
  /** column name */
  Alias = 'alias',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Name = 'name',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  ProductId = 'product_id'
}

export type Roles_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Roles_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Roles_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Roles_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Roles_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Roles_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Roles_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Roles_Bool_Exp;
};

/** columns and relationships of "roles_users" */
export type Roles_Users = {
  __typename?: 'roles_users';
  id: Scalars['Int'];
  /** An object relationship */
  role: Roles;
  role_id: Scalars['Int'];
  team_id: Scalars['Int'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
};

/** aggregated selection of "roles_users" */
export type Roles_Users_Aggregate = {
  __typename?: 'roles_users_aggregate';
  aggregate?: Maybe<Roles_Users_Aggregate_Fields>;
  nodes: Array<Roles_Users>;
};

export type Roles_Users_Aggregate_Bool_Exp = {
  count?: InputMaybe<Roles_Users_Aggregate_Bool_Exp_Count>;
};

export type Roles_Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Roles_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Roles_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "roles_users" */
export type Roles_Users_Aggregate_Fields = {
  __typename?: 'roles_users_aggregate_fields';
  avg?: Maybe<Roles_Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Roles_Users_Max_Fields>;
  min?: Maybe<Roles_Users_Min_Fields>;
  stddev?: Maybe<Roles_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Roles_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Roles_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Roles_Users_Sum_Fields>;
  var_pop?: Maybe<Roles_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Roles_Users_Var_Samp_Fields>;
  variance?: Maybe<Roles_Users_Variance_Fields>;
};


/** aggregate fields of "roles_users" */
export type Roles_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Roles_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "roles_users" */
export type Roles_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Roles_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Roles_Users_Max_Order_By>;
  min?: InputMaybe<Roles_Users_Min_Order_By>;
  stddev?: InputMaybe<Roles_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Roles_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Roles_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Roles_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Roles_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Roles_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Roles_Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "roles_users" */
export type Roles_Users_Arr_Rel_Insert_Input = {
  data: Array<Roles_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Roles_Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Roles_Users_Avg_Fields = {
  __typename?: 'roles_users_avg_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "roles_users" */
export type Roles_Users_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "roles_users". All fields are combined with a logical 'AND'. */
export type Roles_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Roles_Users_Bool_Exp>>;
  _not?: InputMaybe<Roles_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Roles_Users_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  role_id?: InputMaybe<Int_Comparison_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "roles_users" */
export enum Roles_Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  RolesUsersPkey = 'roles_users_pkey',
  /** unique or primary key constraint on columns "role_id", "user_id", "team_id" */
  RolesUsersRoleIdUserIdTeamIdKey = 'roles_users_role_id_user_id_team_id_key'
}

/** input type for incrementing numeric columns in table "roles_users" */
export type Roles_Users_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  role_id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "roles_users" */
export type Roles_Users_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Roles_Users_Max_Fields = {
  __typename?: 'roles_users_max_fields';
  id?: Maybe<Scalars['Int']>;
  role_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "roles_users" */
export type Roles_Users_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Roles_Users_Min_Fields = {
  __typename?: 'roles_users_min_fields';
  id?: Maybe<Scalars['Int']>;
  role_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "roles_users" */
export type Roles_Users_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "roles_users" */
export type Roles_Users_Mutation_Response = {
  __typename?: 'roles_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Roles_Users>;
};

/** on_conflict condition type for table "roles_users" */
export type Roles_Users_On_Conflict = {
  constraint: Roles_Users_Constraint;
  update_columns?: Array<Roles_Users_Update_Column>;
  where?: InputMaybe<Roles_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "roles_users". */
export type Roles_Users_Order_By = {
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roles_users */
export type Roles_Users_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "roles_users" */
export enum Roles_Users_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "roles_users" */
export type Roles_Users_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  role_id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Roles_Users_Stddev_Fields = {
  __typename?: 'roles_users_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "roles_users" */
export type Roles_Users_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Roles_Users_Stddev_Pop_Fields = {
  __typename?: 'roles_users_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "roles_users" */
export type Roles_Users_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Roles_Users_Stddev_Samp_Fields = {
  __typename?: 'roles_users_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "roles_users" */
export type Roles_Users_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "roles_users" */
export type Roles_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Roles_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Roles_Users_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  role_id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Roles_Users_Sum_Fields = {
  __typename?: 'roles_users_sum_fields';
  id?: Maybe<Scalars['Int']>;
  role_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "roles_users" */
export type Roles_Users_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "roles_users" */
export enum Roles_Users_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UserId = 'user_id'
}

export type Roles_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Roles_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Roles_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Roles_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Roles_Users_Var_Pop_Fields = {
  __typename?: 'roles_users_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "roles_users" */
export type Roles_Users_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Roles_Users_Var_Samp_Fields = {
  __typename?: 'roles_users_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "roles_users" */
export type Roles_Users_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Roles_Users_Variance_Fields = {
  __typename?: 'roles_users_variance_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "roles_users" */
export type Roles_Users_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Roles_Var_Pop_Fields = {
  __typename?: 'roles_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Roles_Var_Samp_Fields = {
  __typename?: 'roles_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Roles_Variance_Fields = {
  __typename?: 'roles_variance_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "rollups" */
export type Rollups = {
  __typename?: 'rollups';
  event_id_sequence_name: Scalars['String'];
  event_table_name: Scalars['String'];
  last_aggregated_id?: Maybe<Scalars['bigint']>;
  name: Scalars['String'];
};

/** aggregated selection of "rollups" */
export type Rollups_Aggregate = {
  __typename?: 'rollups_aggregate';
  aggregate?: Maybe<Rollups_Aggregate_Fields>;
  nodes: Array<Rollups>;
};

/** aggregate fields of "rollups" */
export type Rollups_Aggregate_Fields = {
  __typename?: 'rollups_aggregate_fields';
  avg?: Maybe<Rollups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Rollups_Max_Fields>;
  min?: Maybe<Rollups_Min_Fields>;
  stddev?: Maybe<Rollups_Stddev_Fields>;
  stddev_pop?: Maybe<Rollups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Rollups_Stddev_Samp_Fields>;
  sum?: Maybe<Rollups_Sum_Fields>;
  var_pop?: Maybe<Rollups_Var_Pop_Fields>;
  var_samp?: Maybe<Rollups_Var_Samp_Fields>;
  variance?: Maybe<Rollups_Variance_Fields>;
};


/** aggregate fields of "rollups" */
export type Rollups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rollups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Rollups_Avg_Fields = {
  __typename?: 'rollups_avg_fields';
  last_aggregated_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "rollups". All fields are combined with a logical 'AND'. */
export type Rollups_Bool_Exp = {
  _and?: InputMaybe<Array<Rollups_Bool_Exp>>;
  _not?: InputMaybe<Rollups_Bool_Exp>;
  _or?: InputMaybe<Array<Rollups_Bool_Exp>>;
  event_id_sequence_name?: InputMaybe<String_Comparison_Exp>;
  event_table_name?: InputMaybe<String_Comparison_Exp>;
  last_aggregated_id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "rollups" */
export enum Rollups_Constraint {
  /** unique or primary key constraint on columns "name" */
  RollupsPkey = 'rollups_pkey'
}

/** input type for incrementing numeric columns in table "rollups" */
export type Rollups_Inc_Input = {
  last_aggregated_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "rollups" */
export type Rollups_Insert_Input = {
  event_id_sequence_name?: InputMaybe<Scalars['String']>;
  event_table_name?: InputMaybe<Scalars['String']>;
  last_aggregated_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Rollups_Max_Fields = {
  __typename?: 'rollups_max_fields';
  event_id_sequence_name?: Maybe<Scalars['String']>;
  event_table_name?: Maybe<Scalars['String']>;
  last_aggregated_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Rollups_Min_Fields = {
  __typename?: 'rollups_min_fields';
  event_id_sequence_name?: Maybe<Scalars['String']>;
  event_table_name?: Maybe<Scalars['String']>;
  last_aggregated_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "rollups" */
export type Rollups_Mutation_Response = {
  __typename?: 'rollups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Rollups>;
};

/** on_conflict condition type for table "rollups" */
export type Rollups_On_Conflict = {
  constraint: Rollups_Constraint;
  update_columns?: Array<Rollups_Update_Column>;
  where?: InputMaybe<Rollups_Bool_Exp>;
};

/** Ordering options when selecting data from "rollups". */
export type Rollups_Order_By = {
  event_id_sequence_name?: InputMaybe<Order_By>;
  event_table_name?: InputMaybe<Order_By>;
  last_aggregated_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rollups */
export type Rollups_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "rollups" */
export enum Rollups_Select_Column {
  /** column name */
  EventIdSequenceName = 'event_id_sequence_name',
  /** column name */
  EventTableName = 'event_table_name',
  /** column name */
  LastAggregatedId = 'last_aggregated_id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "rollups" */
export type Rollups_Set_Input = {
  event_id_sequence_name?: InputMaybe<Scalars['String']>;
  event_table_name?: InputMaybe<Scalars['String']>;
  last_aggregated_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Rollups_Stddev_Fields = {
  __typename?: 'rollups_stddev_fields';
  last_aggregated_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Rollups_Stddev_Pop_Fields = {
  __typename?: 'rollups_stddev_pop_fields';
  last_aggregated_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Rollups_Stddev_Samp_Fields = {
  __typename?: 'rollups_stddev_samp_fields';
  last_aggregated_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "rollups" */
export type Rollups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rollups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rollups_Stream_Cursor_Value_Input = {
  event_id_sequence_name?: InputMaybe<Scalars['String']>;
  event_table_name?: InputMaybe<Scalars['String']>;
  last_aggregated_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Rollups_Sum_Fields = {
  __typename?: 'rollups_sum_fields';
  last_aggregated_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "rollups" */
export enum Rollups_Update_Column {
  /** column name */
  EventIdSequenceName = 'event_id_sequence_name',
  /** column name */
  EventTableName = 'event_table_name',
  /** column name */
  LastAggregatedId = 'last_aggregated_id',
  /** column name */
  Name = 'name'
}

export type Rollups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rollups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rollups_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rollups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Rollups_Var_Pop_Fields = {
  __typename?: 'rollups_var_pop_fields';
  last_aggregated_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Rollups_Var_Samp_Fields = {
  __typename?: 'rollups_var_samp_fields';
  last_aggregated_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Rollups_Variance_Fields = {
  __typename?: 'rollups_variance_fields';
  last_aggregated_id?: Maybe<Scalars['Float']>;
};

export type SubscriptionFilters = {
  created_at_from?: InputMaybe<Scalars['String']>;
  created_at_to?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  plan_identifier?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  status_filter?: InputMaybe<Scalars['String']>;
  updated_since?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "subscription_providers" */
export type Subscription_Providers = {
  __typename?: 'subscription_providers';
  friendly_name: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
};


/** columns and relationships of "subscription_providers" */
export type Subscription_ProvidersSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "subscription_providers" */
export type Subscription_ProvidersSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};

/** aggregated selection of "subscription_providers" */
export type Subscription_Providers_Aggregate = {
  __typename?: 'subscription_providers_aggregate';
  aggregate?: Maybe<Subscription_Providers_Aggregate_Fields>;
  nodes: Array<Subscription_Providers>;
};

/** aggregate fields of "subscription_providers" */
export type Subscription_Providers_Aggregate_Fields = {
  __typename?: 'subscription_providers_aggregate_fields';
  avg?: Maybe<Subscription_Providers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Subscription_Providers_Max_Fields>;
  min?: Maybe<Subscription_Providers_Min_Fields>;
  stddev?: Maybe<Subscription_Providers_Stddev_Fields>;
  stddev_pop?: Maybe<Subscription_Providers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscription_Providers_Stddev_Samp_Fields>;
  sum?: Maybe<Subscription_Providers_Sum_Fields>;
  var_pop?: Maybe<Subscription_Providers_Var_Pop_Fields>;
  var_samp?: Maybe<Subscription_Providers_Var_Samp_Fields>;
  variance?: Maybe<Subscription_Providers_Variance_Fields>;
};


/** aggregate fields of "subscription_providers" */
export type Subscription_Providers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Subscription_Providers_Avg_Fields = {
  __typename?: 'subscription_providers_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "subscription_providers". All fields are combined with a logical 'AND'. */
export type Subscription_Providers_Bool_Exp = {
  _and?: InputMaybe<Array<Subscription_Providers_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Providers_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Providers_Bool_Exp>>;
  friendly_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "subscription_providers" */
export enum Subscription_Providers_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentProvidersIdKey = 'payment_providers_id_key',
  /** unique or primary key constraint on columns "name" */
  PaymentProvidersNameKey = 'payment_providers_name_key',
  /** unique or primary key constraint on columns "id", "name" */
  PaymentProvidersPkey = 'payment_providers_pkey'
}

/** input type for incrementing numeric columns in table "subscription_providers" */
export type Subscription_Providers_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "subscription_providers" */
export type Subscription_Providers_Insert_Input = {
  friendly_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  subscriptions?: InputMaybe<Subscriptions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Subscription_Providers_Max_Fields = {
  __typename?: 'subscription_providers_max_fields';
  friendly_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Subscription_Providers_Min_Fields = {
  __typename?: 'subscription_providers_min_fields';
  friendly_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "subscription_providers" */
export type Subscription_Providers_Mutation_Response = {
  __typename?: 'subscription_providers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Providers>;
};

/** input type for inserting object relation for remote table "subscription_providers" */
export type Subscription_Providers_Obj_Rel_Insert_Input = {
  data: Subscription_Providers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_Providers_On_Conflict>;
};

/** on_conflict condition type for table "subscription_providers" */
export type Subscription_Providers_On_Conflict = {
  constraint: Subscription_Providers_Constraint;
  update_columns?: Array<Subscription_Providers_Update_Column>;
  where?: InputMaybe<Subscription_Providers_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_providers". */
export type Subscription_Providers_Order_By = {
  friendly_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
};

/** primary key columns input for table: subscription_providers */
export type Subscription_Providers_Pk_Columns_Input = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** select columns of table "subscription_providers" */
export enum Subscription_Providers_Select_Column {
  /** column name */
  FriendlyName = 'friendly_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "subscription_providers" */
export type Subscription_Providers_Set_Input = {
  friendly_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Subscription_Providers_Stddev_Fields = {
  __typename?: 'subscription_providers_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Subscription_Providers_Stddev_Pop_Fields = {
  __typename?: 'subscription_providers_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Subscription_Providers_Stddev_Samp_Fields = {
  __typename?: 'subscription_providers_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "subscription_providers" */
export type Subscription_Providers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscription_Providers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscription_Providers_Stream_Cursor_Value_Input = {
  friendly_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Subscription_Providers_Sum_Fields = {
  __typename?: 'subscription_providers_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "subscription_providers" */
export enum Subscription_Providers_Update_Column {
  /** column name */
  FriendlyName = 'friendly_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Subscription_Providers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscription_Providers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscription_Providers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscription_Providers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscription_Providers_Var_Pop_Fields = {
  __typename?: 'subscription_providers_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Subscription_Providers_Var_Samp_Fields = {
  __typename?: 'subscription_providers_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Subscription_Providers_Variance_Fields = {
  __typename?: 'subscription_providers_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "browser_sessions" */
  browser_sessions: Array<Browser_Sessions>;
  /** fetch aggregated fields from the table: "browser_sessions" */
  browser_sessions_aggregate: Browser_Sessions_Aggregate;
  /** fetch data from the table: "browser_sessions" using primary key columns */
  browser_sessions_by_pk?: Maybe<Browser_Sessions>;
  /** fetch data from the table in a streaming manner: "browser_sessions" */
  browser_sessions_stream: Array<Browser_Sessions>;
  /** fetch data from the table: "chat_list" */
  chat_list: Array<Chat_List>;
  /** fetch aggregated fields from the table: "chat_list" */
  chat_list_aggregate: Chat_List_Aggregate;
  /** fetch data from the table: "chat_list" using primary key columns */
  chat_list_by_pk?: Maybe<Chat_List>;
  /** fetch data from the table in a streaming manner: "chat_list" */
  chat_list_stream: Array<Chat_List>;
  /** fetch data from the table: "compliance" */
  compliance: Array<Compliance>;
  /** fetch aggregated fields from the table: "compliance" */
  compliance_aggregate: Compliance_Aggregate;
  /** fetch data from the table: "compliance" using primary key columns */
  compliance_by_pk?: Maybe<Compliance>;
  /** fetch data from the table: "compliance_contacts" */
  compliance_contacts: Array<Compliance_Contacts>;
  /** fetch aggregated fields from the table: "compliance_contacts" */
  compliance_contacts_aggregate: Compliance_Contacts_Aggregate;
  /** fetch data from the table: "compliance_contacts_raw" */
  compliance_contacts_raw: Array<Compliance_Contacts_Raw>;
  /** fetch aggregated fields from the table: "compliance_contacts_raw" */
  compliance_contacts_raw_aggregate: Compliance_Contacts_Raw_Aggregate;
  /** fetch data from the table: "compliance_contacts_raw" using primary key columns */
  compliance_contacts_raw_by_pk?: Maybe<Compliance_Contacts_Raw>;
  /** fetch data from the table in a streaming manner: "compliance_contacts_raw" */
  compliance_contacts_raw_stream: Array<Compliance_Contacts_Raw>;
  /** fetch data from the table: "compliance_contacts_stats" */
  compliance_contacts_stats: Array<Compliance_Contacts_Stats>;
  /** fetch aggregated fields from the table: "compliance_contacts_stats" */
  compliance_contacts_stats_aggregate: Compliance_Contacts_Stats_Aggregate;
  /** execute function "compliance_contacts_stats_interval" which returns "compliance_contacts_stats_setof" */
  compliance_contacts_stats_interval: Array<Compliance_Contacts_Stats_Setof>;
  /** execute function "compliance_contacts_stats_interval" and query aggregates on result of table type "compliance_contacts_stats_setof" */
  compliance_contacts_stats_interval_aggregate: Compliance_Contacts_Stats_Setof_Aggregate;
  /** execute function "compliance_contacts_stats_json_interval" which returns "compliance_contacts_stats_json_setof" */
  compliance_contacts_stats_json_interval: Array<Compliance_Contacts_Stats_Json_Setof>;
  /** execute function "compliance_contacts_stats_json_interval" and query aggregates on result of table type "compliance_contacts_stats_json_setof" */
  compliance_contacts_stats_json_interval_aggregate: Compliance_Contacts_Stats_Json_Setof_Aggregate;
  /** fetch data from the table: "compliance_contacts_stats_json_setof" */
  compliance_contacts_stats_json_setof: Array<Compliance_Contacts_Stats_Json_Setof>;
  /** fetch aggregated fields from the table: "compliance_contacts_stats_json_setof" */
  compliance_contacts_stats_json_setof_aggregate: Compliance_Contacts_Stats_Json_Setof_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance_contacts_stats_json_setof" */
  compliance_contacts_stats_json_setof_stream: Array<Compliance_Contacts_Stats_Json_Setof>;
  /** fetch data from the table: "compliance_contacts_stats_overall" */
  compliance_contacts_stats_overall: Array<Compliance_Contacts_Stats_Overall>;
  /** fetch aggregated fields from the table: "compliance_contacts_stats_overall" */
  compliance_contacts_stats_overall_aggregate: Compliance_Contacts_Stats_Overall_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance_contacts_stats_overall" */
  compliance_contacts_stats_overall_stream: Array<Compliance_Contacts_Stats_Overall>;
  /** fetch data from the table: "compliance_contacts_stats_setof" */
  compliance_contacts_stats_setof: Array<Compliance_Contacts_Stats_Setof>;
  /** fetch aggregated fields from the table: "compliance_contacts_stats_setof" */
  compliance_contacts_stats_setof_aggregate: Compliance_Contacts_Stats_Setof_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance_contacts_stats_setof" */
  compliance_contacts_stats_setof_stream: Array<Compliance_Contacts_Stats_Setof>;
  /** fetch data from the table in a streaming manner: "compliance_contacts_stats" */
  compliance_contacts_stats_stream: Array<Compliance_Contacts_Stats>;
  /** fetch data from the table: "compliance_contacts_status" */
  compliance_contacts_status: Array<Compliance_Contacts_Status>;
  /** fetch aggregated fields from the table: "compliance_contacts_status" */
  compliance_contacts_status_aggregate: Compliance_Contacts_Status_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance_contacts_status" */
  compliance_contacts_status_stream: Array<Compliance_Contacts_Status>;
  /** fetch data from the table in a streaming manner: "compliance_contacts" */
  compliance_contacts_stream: Array<Compliance_Contacts>;
  /** An array relationship */
  compliance_events: Array<Compliance_Events>;
  /** An aggregate relationship */
  compliance_events_aggregate: Compliance_Events_Aggregate;
  /** fetch data from the table: "compliance_events" using primary key columns */
  compliance_events_by_pk?: Maybe<Compliance_Events>;
  /** fetch data from the table: "compliance_events_classification_goals" */
  compliance_events_classification_goals: Array<Compliance_Events_Classification_Goals>;
  /** fetch aggregated fields from the table: "compliance_events_classification_goals" */
  compliance_events_classification_goals_aggregate: Compliance_Events_Classification_Goals_Aggregate;
  /** fetch data from the table: "compliance_events_classification_goals" using primary key columns */
  compliance_events_classification_goals_by_pk?: Maybe<Compliance_Events_Classification_Goals>;
  /** fetch data from the table in a streaming manner: "compliance_events_classification_goals" */
  compliance_events_classification_goals_stream: Array<Compliance_Events_Classification_Goals>;
  /** fetch data from the table: "compliance_events_classification_resumes" */
  compliance_events_classification_resumes: Array<Compliance_Events_Classification_Resumes>;
  /** fetch aggregated fields from the table: "compliance_events_classification_resumes" */
  compliance_events_classification_resumes_aggregate: Compliance_Events_Classification_Resumes_Aggregate;
  /** fetch data from the table: "compliance_events_classification_resumes" using primary key columns */
  compliance_events_classification_resumes_by_pk?: Maybe<Compliance_Events_Classification_Resumes>;
  /** fetch data from the table in a streaming manner: "compliance_events_classification_resumes" */
  compliance_events_classification_resumes_stream: Array<Compliance_Events_Classification_Resumes>;
  /** fetch data from the table: "compliance_events_daily" */
  compliance_events_daily: Array<Compliance_Events_Daily>;
  /** fetch aggregated fields from the table: "compliance_events_daily" */
  compliance_events_daily_aggregate: Compliance_Events_Daily_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance_events_daily" */
  compliance_events_daily_stream: Array<Compliance_Events_Daily>;
  /** fetch data from the table: "compliance_events_hourly" */
  compliance_events_hourly: Array<Compliance_Events_Hourly>;
  /** fetch aggregated fields from the table: "compliance_events_hourly" */
  compliance_events_hourly_aggregate: Compliance_Events_Hourly_Aggregate;
  /** fetch data from the table: "compliance_events_hourly" using primary key columns */
  compliance_events_hourly_by_pk?: Maybe<Compliance_Events_Hourly>;
  /** fetch data from the table in a streaming manner: "compliance_events_hourly" */
  compliance_events_hourly_stream: Array<Compliance_Events_Hourly>;
  /** fetch data from the table: "compliance_events_monthly" */
  compliance_events_monthly: Array<Compliance_Events_Monthly>;
  /** fetch aggregated fields from the table: "compliance_events_monthly" */
  compliance_events_monthly_aggregate: Compliance_Events_Monthly_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance_events_monthly" */
  compliance_events_monthly_stream: Array<Compliance_Events_Monthly>;
  /** fetch data from the table: "compliance_events_status_hourly" */
  compliance_events_status_hourly: Array<Compliance_Events_Status_Hourly>;
  /** fetch aggregated fields from the table: "compliance_events_status_hourly" */
  compliance_events_status_hourly_aggregate: Compliance_Events_Status_Hourly_Aggregate;
  /** fetch data from the table: "compliance_events_status_hourly" using primary key columns */
  compliance_events_status_hourly_by_pk?: Maybe<Compliance_Events_Status_Hourly>;
  /** fetch data from the table in a streaming manner: "compliance_events_status_hourly" */
  compliance_events_status_hourly_stream: Array<Compliance_Events_Status_Hourly>;
  /** fetch data from the table: "compliance_events_status_total" */
  compliance_events_status_total: Array<Compliance_Events_Status_Total>;
  /** fetch aggregated fields from the table: "compliance_events_status_total" */
  compliance_events_status_total_aggregate: Compliance_Events_Status_Total_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance_events_status_total" */
  compliance_events_status_total_stream: Array<Compliance_Events_Status_Total>;
  /** fetch data from the table in a streaming manner: "compliance_events" */
  compliance_events_stream: Array<Compliance_Events>;
  /** fetch data from the table: "compliance_events_total" */
  compliance_events_total: Array<Compliance_Events_Total>;
  /** fetch aggregated fields from the table: "compliance_events_total" */
  compliance_events_total_aggregate: Compliance_Events_Total_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance_events_total" */
  compliance_events_total_stream: Array<Compliance_Events_Total>;
  /** fetch data from the table: "compliance_events_weekly" */
  compliance_events_weekly: Array<Compliance_Events_Weekly>;
  /** fetch aggregated fields from the table: "compliance_events_weekly" */
  compliance_events_weekly_aggregate: Compliance_Events_Weekly_Aggregate;
  /** fetch data from the table: "compliance_events_weekly_reports" */
  compliance_events_weekly_reports: Array<Compliance_Events_Weekly_Reports>;
  /** fetch aggregated fields from the table: "compliance_events_weekly_reports" */
  compliance_events_weekly_reports_aggregate: Compliance_Events_Weekly_Reports_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance_events_weekly_reports" */
  compliance_events_weekly_reports_stream: Array<Compliance_Events_Weekly_Reports>;
  /** fetch data from the table in a streaming manner: "compliance_events_weekly" */
  compliance_events_weekly_stream: Array<Compliance_Events_Weekly>;
  /** fetch data from the table: "compliance_events_yearly" */
  compliance_events_yearly: Array<Compliance_Events_Yearly>;
  /** fetch aggregated fields from the table: "compliance_events_yearly" */
  compliance_events_yearly_aggregate: Compliance_Events_Yearly_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance_events_yearly" */
  compliance_events_yearly_stream: Array<Compliance_Events_Yearly>;
  /** An array relationship */
  compliance_group_contacts: Array<Compliance_Group_Contacts>;
  /** An aggregate relationship */
  compliance_group_contacts_aggregate: Compliance_Group_Contacts_Aggregate;
  /** fetch data from the table: "compliance_group_contacts" using primary key columns */
  compliance_group_contacts_by_pk?: Maybe<Compliance_Group_Contacts>;
  /** fetch data from the table in a streaming manner: "compliance_group_contacts" */
  compliance_group_contacts_stream: Array<Compliance_Group_Contacts>;
  /** An array relationship */
  compliance_group_users: Array<Compliance_Group_Users>;
  /** An aggregate relationship */
  compliance_group_users_aggregate: Compliance_Group_Users_Aggregate;
  /** fetch data from the table: "compliance_group_users" using primary key columns */
  compliance_group_users_by_pk?: Maybe<Compliance_Group_Users>;
  /** fetch data from the table in a streaming manner: "compliance_group_users" */
  compliance_group_users_stream: Array<Compliance_Group_Users>;
  /** An array relationship */
  compliance_groups: Array<Compliance_Groups>;
  /** An aggregate relationship */
  compliance_groups_aggregate: Compliance_Groups_Aggregate;
  /** fetch data from the table: "compliance_groups" using primary key columns */
  compliance_groups_by_pk?: Maybe<Compliance_Groups>;
  /** fetch data from the table in a streaming manner: "compliance_groups" */
  compliance_groups_stream: Array<Compliance_Groups>;
  /** execute function "compliance_groups_with_events" which returns "compliance_groups" */
  compliance_groups_with_events: Array<Compliance_Groups>;
  /** execute function "compliance_groups_with_events" and query aggregates on result of table type "compliance_groups" */
  compliance_groups_with_events_aggregate: Compliance_Groups_Aggregate;
  /** An array relationship */
  compliance_messages: Array<Compliance_Messages>;
  /** An aggregate relationship */
  compliance_messages_aggregate: Compliance_Messages_Aggregate;
  /** fetch data from the table: "compliance_messages_daily" */
  compliance_messages_daily: Array<Compliance_Messages_Daily>;
  /** fetch aggregated fields from the table: "compliance_messages_daily" */
  compliance_messages_daily_aggregate: Compliance_Messages_Daily_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance_messages_daily" */
  compliance_messages_daily_stream: Array<Compliance_Messages_Daily>;
  /** fetch data from the table: "compliance_messages_hourly" */
  compliance_messages_hourly: Array<Compliance_Messages_Hourly>;
  /** fetch aggregated fields from the table: "compliance_messages_hourly" */
  compliance_messages_hourly_aggregate: Compliance_Messages_Hourly_Aggregate;
  /** fetch data from the table: "compliance_messages_hourly" using primary key columns */
  compliance_messages_hourly_by_pk?: Maybe<Compliance_Messages_Hourly>;
  /** fetch data from the table in a streaming manner: "compliance_messages_hourly" */
  compliance_messages_hourly_stream: Array<Compliance_Messages_Hourly>;
  /** fetch data from the table: "compliance_messages_monthly" */
  compliance_messages_monthly: Array<Compliance_Messages_Monthly>;
  /** fetch aggregated fields from the table: "compliance_messages_monthly" */
  compliance_messages_monthly_aggregate: Compliance_Messages_Monthly_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance_messages_monthly" */
  compliance_messages_monthly_stream: Array<Compliance_Messages_Monthly>;
  /** fetch data from the table in a streaming manner: "compliance_messages" */
  compliance_messages_stream: Array<Compliance_Messages>;
  /** fetch data from the table: "compliance_messages_total" */
  compliance_messages_total: Array<Compliance_Messages_Total>;
  /** fetch aggregated fields from the table: "compliance_messages_total" */
  compliance_messages_total_aggregate: Compliance_Messages_Total_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance_messages_total" */
  compliance_messages_total_stream: Array<Compliance_Messages_Total>;
  /** fetch data from the table: "compliance_messages_weekly" */
  compliance_messages_weekly: Array<Compliance_Messages_Weekly>;
  /** fetch aggregated fields from the table: "compliance_messages_weekly" */
  compliance_messages_weekly_aggregate: Compliance_Messages_Weekly_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance_messages_weekly" */
  compliance_messages_weekly_stream: Array<Compliance_Messages_Weekly>;
  /** fetch data from the table: "compliance_messages_yearly" */
  compliance_messages_yearly: Array<Compliance_Messages_Yearly>;
  /** fetch aggregated fields from the table: "compliance_messages_yearly" */
  compliance_messages_yearly_aggregate: Compliance_Messages_Yearly_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance_messages_yearly" */
  compliance_messages_yearly_stream: Array<Compliance_Messages_Yearly>;
  /** fetch data from the table: "compliance_participants" */
  compliance_participants: Array<Compliance_Participants>;
  /** fetch aggregated fields from the table: "compliance_participants" */
  compliance_participants_aggregate: Compliance_Participants_Aggregate;
  /** fetch data from the table in a streaming manner: "compliance_participants" */
  compliance_participants_stream: Array<Compliance_Participants>;
  /** An array relationship */
  compliance_policies: Array<Compliance_Policies>;
  /** An aggregate relationship */
  compliance_policies_aggregate: Compliance_Policies_Aggregate;
  /** fetch data from the table: "compliance_policies" using primary key columns */
  compliance_policies_by_pk?: Maybe<Compliance_Policies>;
  /** fetch data from the table in a streaming manner: "compliance_policies" */
  compliance_policies_stream: Array<Compliance_Policies>;
  /** An array relationship */
  compliance_rules: Array<Compliance_Rules>;
  /** An aggregate relationship */
  compliance_rules_aggregate: Compliance_Rules_Aggregate;
  /** fetch data from the table: "compliance_rules" using primary key columns */
  compliance_rules_by_pk?: Maybe<Compliance_Rules>;
  /** fetch data from the table in a streaming manner: "compliance_rules" */
  compliance_rules_stream: Array<Compliance_Rules>;
  /** fetch data from the table in a streaming manner: "compliance" */
  compliance_stream: Array<Compliance>;
  /** fetch data from the table: "compliance_tags" */
  compliance_tags: Array<Compliance_Tags>;
  /** fetch aggregated fields from the table: "compliance_tags" */
  compliance_tags_aggregate: Compliance_Tags_Aggregate;
  /** fetch data from the table: "compliance_tags" using primary key columns */
  compliance_tags_by_pk?: Maybe<Compliance_Tags>;
  /** fetch data from the table in a streaming manner: "compliance_tags" */
  compliance_tags_stream: Array<Compliance_Tags>;
  /** fetch data from the table: "consent" */
  consent: Array<Consent>;
  /** fetch aggregated fields from the table: "consent" */
  consent_aggregate: Consent_Aggregate;
  /** fetch data from the table: "consent" using primary key columns */
  consent_by_pk?: Maybe<Consent>;
  /** fetch data from the table in a streaming manner: "consent" */
  consent_stream: Array<Consent>;
  /** fetch data from the table: "contact_list" */
  contact_list: Array<Contact_List>;
  /** fetch aggregated fields from the table: "contact_list" */
  contact_list_aggregate: Contact_List_Aggregate;
  /** fetch data from the table: "contact_list" using primary key columns */
  contact_list_by_pk?: Maybe<Contact_List>;
  /** fetch data from the table in a streaming manner: "contact_list" */
  contact_list_stream: Array<Contact_List>;
  /** fetch data from the table: "duo" */
  duo: Array<Duo>;
  /** fetch aggregated fields from the table: "duo" */
  duo_aggregate: Duo_Aggregate;
  /** fetch data from the table: "duo" using primary key columns */
  duo_by_pk?: Maybe<Duo>;
  /** fetch data from the table in a streaming manner: "duo" */
  duo_stream: Array<Duo>;
  /** An array relationship */
  groups: Array<Groups>;
  /** An aggregate relationship */
  groups_aggregate: Groups_Aggregate;
  /** fetch data from the table: "groups" using primary key columns */
  groups_by_pk?: Maybe<Groups>;
  /** fetch data from the table in a streaming manner: "groups" */
  groups_stream: Array<Groups>;
  /** An array relationship */
  groups_users: Array<Groups_Users>;
  /** An aggregate relationship */
  groups_users_aggregate: Groups_Users_Aggregate;
  /** fetch data from the table: "groups_users" using primary key columns */
  groups_users_by_pk?: Maybe<Groups_Users>;
  /** fetch data from the table in a streaming manner: "groups_users" */
  groups_users_stream: Array<Groups_Users>;
  /** fetch data from the table: "invite_rules" */
  invite_rules: Array<Invite_Rules>;
  /** fetch aggregated fields from the table: "invite_rules" */
  invite_rules_aggregate: Invite_Rules_Aggregate;
  /** fetch data from the table: "invite_rules" using primary key columns */
  invite_rules_by_pk?: Maybe<Invite_Rules>;
  /** fetch data from the table: "invite_rules_recipients" */
  invite_rules_recipients: Array<Invite_Rules_Recipients>;
  /** fetch aggregated fields from the table: "invite_rules_recipients" */
  invite_rules_recipients_aggregate: Invite_Rules_Recipients_Aggregate;
  /** fetch data from the table: "invite_rules_recipients" using primary key columns */
  invite_rules_recipients_by_pk?: Maybe<Invite_Rules_Recipients>;
  /** fetch data from the table in a streaming manner: "invite_rules_recipients" */
  invite_rules_recipients_stream: Array<Invite_Rules_Recipients>;
  /** fetch data from the table in a streaming manner: "invite_rules" */
  invite_rules_stream: Array<Invite_Rules>;
  /** fetch data from the table: "license_records" */
  license_records: Array<License_Records>;
  /** fetch aggregated fields from the table: "license_records" */
  license_records_aggregate: License_Records_Aggregate;
  /** fetch data from the table: "license_records" using primary key columns */
  license_records_by_pk?: Maybe<License_Records>;
  /** fetch data from the table in a streaming manner: "license_records" */
  license_records_stream: Array<License_Records>;
  /** fetch data from the table: "link" */
  link: Array<Link>;
  /** fetch aggregated fields from the table: "link" */
  link_aggregate: Link_Aggregate;
  /** fetch data from the table: "link" using primary key columns */
  link_by_pk?: Maybe<Link>;
  /** fetch data from the table: "link_domains" */
  link_domains: Array<Link_Domains>;
  /** fetch aggregated fields from the table: "link_domains" */
  link_domains_aggregate: Link_Domains_Aggregate;
  /** fetch data from the table: "link_domains" using primary key columns */
  link_domains_by_pk?: Maybe<Link_Domains>;
  /** fetch data from the table in a streaming manner: "link_domains" */
  link_domains_stream: Array<Link_Domains>;
  /** fetch data from the table in a streaming manner: "link" */
  link_stream: Array<Link>;
  /** fetch data from the table: "logs" */
  logs: Array<Logs>;
  /** fetch aggregated fields from the table: "logs" */
  logs_aggregate: Logs_Aggregate;
  /** fetch data from the table: "logs" using primary key columns */
  logs_by_pk?: Maybe<Logs>;
  /** fetch data from the table in a streaming manner: "logs" */
  logs_stream: Array<Logs>;
  /** fetch data from the table: "notifications" */
  notifications: Array<Notifications>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table in a streaming manner: "notifications" */
  notifications_stream: Array<Notifications>;
  /** fetch data from the table: "phone_providers" */
  phone_providers: Array<Phone_Providers>;
  /** fetch aggregated fields from the table: "phone_providers" */
  phone_providers_aggregate: Phone_Providers_Aggregate;
  /** fetch data from the table: "phone_providers" using primary key columns */
  phone_providers_by_pk?: Maybe<Phone_Providers>;
  /** fetch data from the table in a streaming manner: "phone_providers" */
  phone_providers_stream: Array<Phone_Providers>;
  /** An array relationship */
  phones: Array<Phones>;
  /** An aggregate relationship */
  phones_aggregate: Phones_Aggregate;
  /** fetch data from the table: "phones" using primary key columns */
  phones_by_pk?: Maybe<Phones>;
  /** fetch data from the table in a streaming manner: "phones" */
  phones_stream: Array<Phones>;
  /** fetch data from the table: "products" */
  products: Array<Products>;
  /** fetch aggregated fields from the table: "products" */
  products_aggregate: Products_Aggregate;
  /** fetch data from the table: "products" using primary key columns */
  products_by_pk?: Maybe<Products>;
  /** fetch data from the table in a streaming manner: "products" */
  products_stream: Array<Products>;
  /** fetch data from the table: "relevant_contacts" */
  relevant_contacts: Array<Relevant_Contacts>;
  /** fetch aggregated fields from the table: "relevant_contacts" */
  relevant_contacts_aggregate: Relevant_Contacts_Aggregate;
  /** fetch data from the table: "relevant_contacts" using primary key columns */
  relevant_contacts_by_pk?: Maybe<Relevant_Contacts>;
  /** fetch data from the table in a streaming manner: "relevant_contacts" */
  relevant_contacts_stream: Array<Relevant_Contacts>;
  /** An array relationship */
  relevant_contacts_tags: Array<Relevant_Contacts_Tags>;
  /** An aggregate relationship */
  relevant_contacts_tags_aggregate: Relevant_Contacts_Tags_Aggregate;
  /** fetch data from the table: "relevant_contacts_tags" using primary key columns */
  relevant_contacts_tags_by_pk?: Maybe<Relevant_Contacts_Tags>;
  /** fetch data from the table in a streaming manner: "relevant_contacts_tags" */
  relevant_contacts_tags_stream: Array<Relevant_Contacts_Tags>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table in a streaming manner: "roles" */
  roles_stream: Array<Roles>;
  /** An array relationship */
  roles_teams: Array<Roles_Teams>;
  /** An aggregate relationship */
  roles_teams_aggregate: Roles_Teams_Aggregate;
  /** fetch data from the table: "roles_teams" using primary key columns */
  roles_teams_by_pk?: Maybe<Roles_Teams>;
  /** fetch data from the table in a streaming manner: "roles_teams" */
  roles_teams_stream: Array<Roles_Teams>;
  /** An array relationship */
  roles_users: Array<Roles_Users>;
  /** An aggregate relationship */
  roles_users_aggregate: Roles_Users_Aggregate;
  /** fetch data from the table: "roles_users" using primary key columns */
  roles_users_by_pk?: Maybe<Roles_Users>;
  /** fetch data from the table in a streaming manner: "roles_users" */
  roles_users_stream: Array<Roles_Users>;
  /** fetch data from the table: "rollups" */
  rollups: Array<Rollups>;
  /** fetch aggregated fields from the table: "rollups" */
  rollups_aggregate: Rollups_Aggregate;
  /** fetch data from the table: "rollups" using primary key columns */
  rollups_by_pk?: Maybe<Rollups>;
  /** fetch data from the table in a streaming manner: "rollups" */
  rollups_stream: Array<Rollups>;
  /** execute function "select_incomplete_compliance_events" which returns "compliance_events" */
  select_incomplete_compliance_events: Array<Compliance_Events>;
  /** execute function "select_incomplete_compliance_events" and query aggregates on result of table type "compliance_events" */
  select_incomplete_compliance_events_aggregate: Compliance_Events_Aggregate;
  /** fetch data from the table: "subscription_providers" */
  subscription_providers: Array<Subscription_Providers>;
  /** fetch aggregated fields from the table: "subscription_providers" */
  subscription_providers_aggregate: Subscription_Providers_Aggregate;
  /** fetch data from the table: "subscription_providers" using primary key columns */
  subscription_providers_by_pk?: Maybe<Subscription_Providers>;
  /** fetch data from the table in a streaming manner: "subscription_providers" */
  subscription_providers_stream: Array<Subscription_Providers>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** fetch data from the table: "subscriptions" using primary key columns */
  subscriptions_by_pk?: Maybe<Subscriptions>;
  /** fetch data from the table in a streaming manner: "subscriptions" */
  subscriptions_stream: Array<Subscriptions>;
  /** fetch data from the table: "tags" */
  tags: Array<Tags>;
  /** fetch aggregated fields from the table: "tags" */
  tags_aggregate: Tags_Aggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk?: Maybe<Tags>;
  /** fetch data from the table in a streaming manner: "tags" */
  tags_stream: Array<Tags>;
  /** An array relationship */
  teams: Array<Teams>;
  /** An aggregate relationship */
  teams_aggregate: Teams_Aggregate;
  /** fetch data from the table: "teams" using primary key columns */
  teams_by_pk?: Maybe<Teams>;
  /** fetch data from the table: "teams_settings" */
  teams_settings: Array<Teams_Settings>;
  /** fetch aggregated fields from the table: "teams_settings" */
  teams_settings_aggregate: Teams_Settings_Aggregate;
  /** fetch data from the table: "teams_settings" using primary key columns */
  teams_settings_by_pk?: Maybe<Teams_Settings>;
  /** fetch data from the table in a streaming manner: "teams_settings" */
  teams_settings_stream: Array<Teams_Settings>;
  /** fetch data from the table in a streaming manner: "teams" */
  teams_stream: Array<Teams>;
  /** An array relationship */
  teams_templates: Array<Teams_Templates>;
  /** An aggregate relationship */
  teams_templates_aggregate: Teams_Templates_Aggregate;
  /** fetch data from the table: "teams_templates" using primary key columns */
  teams_templates_by_pk?: Maybe<Teams_Templates>;
  /** fetch data from the table in a streaming manner: "teams_templates" */
  teams_templates_stream: Array<Teams_Templates>;
  /** An array relationship */
  teams_users: Array<Teams_Users>;
  /** An aggregate relationship */
  teams_users_aggregate: Teams_Users_Aggregate;
  /** fetch data from the table: "teams_users" using primary key columns */
  teams_users_by_pk?: Maybe<Teams_Users>;
  /** fetch data from the table in a streaming manner: "teams_users" */
  teams_users_stream: Array<Teams_Users>;
  /** fetch data from the table: "templates" */
  templates: Array<Templates>;
  /** fetch aggregated fields from the table: "templates" */
  templates_aggregate: Templates_Aggregate;
  /** fetch data from the table: "templates" using primary key columns */
  templates_by_pk?: Maybe<Templates>;
  /** fetch data from the table in a streaming manner: "templates" */
  templates_stream: Array<Templates>;
  /** fetch data from the table: "tenant" */
  tenant: Array<Tenant>;
  /** fetch aggregated fields from the table: "tenant" */
  tenant_aggregate: Tenant_Aggregate;
  /** fetch data from the table: "tenant" using primary key columns */
  tenant_by_pk?: Maybe<Tenant>;
  /** fetch data from the table in a streaming manner: "tenant" */
  tenant_stream: Array<Tenant>;
  /** fetch data from the table: "tokens" */
  tokens: Array<Tokens>;
  /** fetch aggregated fields from the table: "tokens" */
  tokens_aggregate: Tokens_Aggregate;
  /** fetch data from the table: "tokens" using primary key columns */
  tokens_by_pk?: Maybe<Tokens>;
  /** fetch data from the table in a streaming manner: "tokens" */
  tokens_stream: Array<Tokens>;
  /** fetch data from the table: "user_auth_codes" */
  user_auth_codes: Array<User_Auth_Codes>;
  /** fetch aggregated fields from the table: "user_auth_codes" */
  user_auth_codes_aggregate: User_Auth_Codes_Aggregate;
  /** fetch data from the table: "user_auth_codes" using primary key columns */
  user_auth_codes_by_pk?: Maybe<User_Auth_Codes>;
  /** fetch data from the table in a streaming manner: "user_auth_codes" */
  user_auth_codes_stream: Array<User_Auth_Codes>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "web_contacts" */
  web_contacts: Array<Web_Contacts>;
  /** fetch aggregated fields from the table: "web_contacts" */
  web_contacts_aggregate: Web_Contacts_Aggregate;
  /** fetch data from the table: "web_contacts" using primary key columns */
  web_contacts_by_pk?: Maybe<Web_Contacts>;
  /** fetch data from the table in a streaming manner: "web_contacts" */
  web_contacts_stream: Array<Web_Contacts>;
  /** fetch data from the table: "web_messages" */
  web_messages: Array<Web_Messages>;
  /** fetch aggregated fields from the table: "web_messages" */
  web_messages_aggregate: Web_Messages_Aggregate;
  /** fetch data from the table: "web_messages" using primary key columns */
  web_messages_by_pk?: Maybe<Web_Messages>;
  /** fetch data from the table in a streaming manner: "web_messages" */
  web_messages_stream: Array<Web_Messages>;
  /** fetch data from the table: "web_qr_codes" */
  web_qr_codes: Array<Web_Qr_Codes>;
  /** fetch aggregated fields from the table: "web_qr_codes" */
  web_qr_codes_aggregate: Web_Qr_Codes_Aggregate;
  /** fetch data from the table: "web_qr_codes" using primary key columns */
  web_qr_codes_by_pk?: Maybe<Web_Qr_Codes>;
  /** fetch data from the table in a streaming manner: "web_qr_codes" */
  web_qr_codes_stream: Array<Web_Qr_Codes>;
  /** fetch data from the table: "whatsapp._messageTomessage_update" */
  whatsapp__messageTomessage_update: Array<Whatsapp__MessageTomessage_Update>;
  /** fetch aggregated fields from the table: "whatsapp._messageTomessage_update" */
  whatsapp__messageTomessage_update_aggregate: Whatsapp__MessageTomessage_Update_Aggregate;
  /** fetch data from the table in a streaming manner: "whatsapp._messageTomessage_update" */
  whatsapp__messageTomessage_update_stream: Array<Whatsapp__MessageTomessage_Update>;
  /** fetch data from the table: "whatsapp.chat" */
  whatsapp_chat: Array<Whatsapp_Chat>;
  /** fetch aggregated fields from the table: "whatsapp.chat" */
  whatsapp_chat_aggregate: Whatsapp_Chat_Aggregate;
  /** fetch data from the table: "whatsapp.chat" using primary key columns */
  whatsapp_chat_by_pk?: Maybe<Whatsapp_Chat>;
  /** fetch data from the table in a streaming manner: "whatsapp.chat" */
  whatsapp_chat_stream: Array<Whatsapp_Chat>;
  /** fetch data from the table: "whatsapp.contact" */
  whatsapp_contact: Array<Whatsapp_Contact>;
  /** fetch aggregated fields from the table: "whatsapp.contact" */
  whatsapp_contact_aggregate: Whatsapp_Contact_Aggregate;
  /** fetch data from the table: "whatsapp.contact" using primary key columns */
  whatsapp_contact_by_pk?: Maybe<Whatsapp_Contact>;
  /** fetch data from the table in a streaming manner: "whatsapp.contact" */
  whatsapp_contact_stream: Array<Whatsapp_Contact>;
  /** fetch data from the table: "whatsapp.message" */
  whatsapp_message: Array<Whatsapp_Message>;
  /** fetch aggregated fields from the table: "whatsapp.message" */
  whatsapp_message_aggregate: Whatsapp_Message_Aggregate;
  /** fetch data from the table: "whatsapp.message" using primary key columns */
  whatsapp_message_by_pk?: Maybe<Whatsapp_Message>;
  /** fetch data from the table in a streaming manner: "whatsapp.message" */
  whatsapp_message_stream: Array<Whatsapp_Message>;
  /** fetch data from the table: "whatsapp.message_update" */
  whatsapp_message_update: Array<Whatsapp_Message_Update>;
  /** fetch aggregated fields from the table: "whatsapp.message_update" */
  whatsapp_message_update_aggregate: Whatsapp_Message_Update_Aggregate;
  /** fetch data from the table: "whatsapp.message_update" using primary key columns */
  whatsapp_message_update_by_pk?: Maybe<Whatsapp_Message_Update>;
  /** fetch data from the table in a streaming manner: "whatsapp.message_update" */
  whatsapp_message_update_stream: Array<Whatsapp_Message_Update>;
  /** fetch data from the table: "whatsapp.session" */
  whatsapp_session: Array<Whatsapp_Session>;
  /** fetch aggregated fields from the table: "whatsapp.session" */
  whatsapp_session_aggregate: Whatsapp_Session_Aggregate;
  /** fetch data from the table: "whatsapp.session" using primary key columns */
  whatsapp_session_by_pk?: Maybe<Whatsapp_Session>;
  /** fetch data from the table: "whatsapp.session_credential" */
  whatsapp_session_credential: Array<Whatsapp_Session_Credential>;
  /** fetch aggregated fields from the table: "whatsapp.session_credential" */
  whatsapp_session_credential_aggregate: Whatsapp_Session_Credential_Aggregate;
  /** fetch data from the table: "whatsapp.session_credential" using primary key columns */
  whatsapp_session_credential_by_pk?: Maybe<Whatsapp_Session_Credential>;
  /** fetch data from the table in a streaming manner: "whatsapp.session_credential" */
  whatsapp_session_credential_stream: Array<Whatsapp_Session_Credential>;
  /** fetch data from the table: "whatsapp.session_history_sync" */
  whatsapp_session_history_sync: Array<Whatsapp_Session_History_Sync>;
  /** fetch aggregated fields from the table: "whatsapp.session_history_sync" */
  whatsapp_session_history_sync_aggregate: Whatsapp_Session_History_Sync_Aggregate;
  /** fetch data from the table: "whatsapp.session_history_sync" using primary key columns */
  whatsapp_session_history_sync_by_pk?: Maybe<Whatsapp_Session_History_Sync>;
  /** fetch data from the table in a streaming manner: "whatsapp.session_history_sync" */
  whatsapp_session_history_sync_stream: Array<Whatsapp_Session_History_Sync>;
  /** fetch data from the table: "whatsapp.session_key" */
  whatsapp_session_key: Array<Whatsapp_Session_Key>;
  /** fetch aggregated fields from the table: "whatsapp.session_key" */
  whatsapp_session_key_aggregate: Whatsapp_Session_Key_Aggregate;
  /** fetch data from the table in a streaming manner: "whatsapp.session_key" */
  whatsapp_session_key_stream: Array<Whatsapp_Session_Key>;
  /** fetch data from the table in a streaming manner: "whatsapp.session" */
  whatsapp_session_stream: Array<Whatsapp_Session>;
  /** fetch data from the table: "wos_sync" */
  wos_sync: Array<Wos_Sync>;
  /** fetch aggregated fields from the table: "wos_sync" */
  wos_sync_aggregate: Wos_Sync_Aggregate;
  /** fetch data from the table: "wos_sync" using primary key columns */
  wos_sync_by_pk?: Maybe<Wos_Sync>;
  /** fetch data from the table in a streaming manner: "wos_sync" */
  wos_sync_stream: Array<Wos_Sync>;
  /** fetch data from the table: "ws_contacts" */
  ws_contacts: Array<Ws_Contacts>;
  /** fetch aggregated fields from the table: "ws_contacts" */
  ws_contacts_aggregate: Ws_Contacts_Aggregate;
  /** fetch data from the table: "ws_contacts" using primary key columns */
  ws_contacts_by_pk?: Maybe<Ws_Contacts>;
  /** fetch data from the table in a streaming manner: "ws_contacts" */
  ws_contacts_stream: Array<Ws_Contacts>;
  /** fetch data from the table: "ws_history_sync" */
  ws_history_sync: Array<Ws_History_Sync>;
  /** fetch aggregated fields from the table: "ws_history_sync" */
  ws_history_sync_aggregate: Ws_History_Sync_Aggregate;
  /** fetch data from the table: "ws_history_sync" using primary key columns */
  ws_history_sync_by_pk?: Maybe<Ws_History_Sync>;
  /** fetch data from the table in a streaming manner: "ws_history_sync" */
  ws_history_sync_stream: Array<Ws_History_Sync>;
  /** An array relationship */
  ws_messages: Array<Ws_Messages>;
  /** An aggregate relationship */
  ws_messages_aggregate: Ws_Messages_Aggregate;
  /** fetch data from the table: "ws_messages" using primary key columns */
  ws_messages_by_pk?: Maybe<Ws_Messages>;
  /** fetch data from the table in a streaming manner: "ws_messages" */
  ws_messages_stream: Array<Ws_Messages>;
  /** fetch data from the table: "ws_servers" */
  ws_servers: Array<Ws_Servers>;
  /** fetch aggregated fields from the table: "ws_servers" */
  ws_servers_aggregate: Ws_Servers_Aggregate;
  /** fetch data from the table: "ws_servers" using primary key columns */
  ws_servers_by_pk?: Maybe<Ws_Servers>;
  /** fetch data from the table in a streaming manner: "ws_servers" */
  ws_servers_stream: Array<Ws_Servers>;
  /** fetch data from the table: "ws_sessions" */
  ws_sessions: Array<Ws_Sessions>;
  /** fetch aggregated fields from the table: "ws_sessions" */
  ws_sessions_aggregate: Ws_Sessions_Aggregate;
  /** fetch data from the table: "ws_sessions" using primary key columns */
  ws_sessions_by_pk?: Maybe<Ws_Sessions>;
  /** fetch data from the table: "ws_sessions_credentials" */
  ws_sessions_credentials: Array<Ws_Sessions_Credentials>;
  /** fetch aggregated fields from the table: "ws_sessions_credentials" */
  ws_sessions_credentials_aggregate: Ws_Sessions_Credentials_Aggregate;
  /** fetch data from the table: "ws_sessions_credentials" using primary key columns */
  ws_sessions_credentials_by_pk?: Maybe<Ws_Sessions_Credentials>;
  /** fetch data from the table in a streaming manner: "ws_sessions_credentials" */
  ws_sessions_credentials_stream: Array<Ws_Sessions_Credentials>;
  /** fetch data from the table: "ws_sessions_keys" */
  ws_sessions_keys: Array<Ws_Sessions_Keys>;
  /** fetch aggregated fields from the table: "ws_sessions_keys" */
  ws_sessions_keys_aggregate: Ws_Sessions_Keys_Aggregate;
  /** fetch data from the table: "ws_sessions_keys" using primary key columns */
  ws_sessions_keys_by_pk?: Maybe<Ws_Sessions_Keys>;
  /** fetch data from the table in a streaming manner: "ws_sessions_keys" */
  ws_sessions_keys_stream: Array<Ws_Sessions_Keys>;
  /** fetch data from the table: "ws_sessions_signal_keys" */
  ws_sessions_signal_keys: Array<Ws_Sessions_Signal_Keys>;
  /** fetch aggregated fields from the table: "ws_sessions_signal_keys" */
  ws_sessions_signal_keys_aggregate: Ws_Sessions_Signal_Keys_Aggregate;
  /** fetch data from the table: "ws_sessions_signal_keys" using primary key columns */
  ws_sessions_signal_keys_by_pk?: Maybe<Ws_Sessions_Signal_Keys>;
  /** fetch data from the table in a streaming manner: "ws_sessions_signal_keys" */
  ws_sessions_signal_keys_stream: Array<Ws_Sessions_Signal_Keys>;
  /** fetch data from the table: "ws_sessions_stats" */
  ws_sessions_stats: Array<Ws_Sessions_Stats>;
  /** fetch aggregated fields from the table: "ws_sessions_stats" */
  ws_sessions_stats_aggregate: Ws_Sessions_Stats_Aggregate;
  /** fetch data from the table: "ws_sessions_stats" using primary key columns */
  ws_sessions_stats_by_pk?: Maybe<Ws_Sessions_Stats>;
  /** fetch data from the table in a streaming manner: "ws_sessions_stats" */
  ws_sessions_stats_stream: Array<Ws_Sessions_Stats>;
  /** fetch data from the table in a streaming manner: "ws_sessions" */
  ws_sessions_stream: Array<Ws_Sessions>;
};


export type Subscription_RootBrowser_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Browser_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Browser_Sessions_Order_By>>;
  where?: InputMaybe<Browser_Sessions_Bool_Exp>;
};


export type Subscription_RootBrowser_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Browser_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Browser_Sessions_Order_By>>;
  where?: InputMaybe<Browser_Sessions_Bool_Exp>;
};


export type Subscription_RootBrowser_Sessions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBrowser_Sessions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Browser_Sessions_Stream_Cursor_Input>>;
  where?: InputMaybe<Browser_Sessions_Bool_Exp>;
};


export type Subscription_RootChat_ListArgs = {
  distinct_on?: InputMaybe<Array<Chat_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_List_Order_By>>;
  where?: InputMaybe<Chat_List_Bool_Exp>;
};


export type Subscription_RootChat_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_List_Order_By>>;
  where?: InputMaybe<Chat_List_Bool_Exp>;
};


export type Subscription_RootChat_List_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootChat_List_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Chat_List_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_List_Bool_Exp>;
};


export type Subscription_RootComplianceArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Order_By>>;
  where?: InputMaybe<Compliance_Bool_Exp>;
};


export type Subscription_RootCompliance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Order_By>>;
  where?: InputMaybe<Compliance_Bool_Exp>;
};


export type Subscription_RootCompliance_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompliance_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_RawArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Raw_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Raw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Raw_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Raw_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompliance_Contacts_Raw_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Contacts_Raw_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_StatsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Stats_IntervalArgs = {
  args: Compliance_Contacts_Stats_Interval_Args;
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Setof_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Stats_Interval_AggregateArgs = {
  args: Compliance_Contacts_Stats_Interval_Args;
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Setof_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Stats_Json_IntervalArgs = {
  args: Compliance_Contacts_Stats_Json_Interval_Args;
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Stats_Json_Interval_AggregateArgs = {
  args: Compliance_Contacts_Stats_Json_Interval_Args;
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Stats_Json_SetofArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Stats_Json_Setof_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Json_Setof_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Stats_Json_Setof_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Contacts_Stats_Json_Setof_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Json_Setof_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Stats_OverallArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Overall_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Overall_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Overall_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Stats_Overall_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Overall_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Overall_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Overall_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Stats_Overall_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Contacts_Stats_Overall_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Overall_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Stats_SetofArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Setof_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Stats_Setof_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Stats_Setof_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Setof_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Stats_Setof_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Contacts_Stats_Setof_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Setof_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Stats_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Contacts_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Contacts_Stats_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_StatusArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Status_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Status_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Status_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Status_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Contacts_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Contacts_Status_Bool_Exp>;
};


export type Subscription_RootCompliance_Contacts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Contacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Contacts_Bool_Exp>;
};


export type Subscription_RootCompliance_EventsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompliance_Events_Classification_GoalsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Classification_Goals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Classification_Goals_Order_By>>;
  where?: InputMaybe<Compliance_Events_Classification_Goals_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Classification_Goals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Classification_Goals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Classification_Goals_Order_By>>;
  where?: InputMaybe<Compliance_Events_Classification_Goals_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Classification_Goals_By_PkArgs = {
  compliance_id: Scalars['Int'];
};


export type Subscription_RootCompliance_Events_Classification_Goals_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Events_Classification_Goals_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Events_Classification_Goals_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Classification_ResumesArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Classification_Resumes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Classification_Resumes_Order_By>>;
  where?: InputMaybe<Compliance_Events_Classification_Resumes_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Classification_Resumes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Classification_Resumes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Classification_Resumes_Order_By>>;
  where?: InputMaybe<Compliance_Events_Classification_Resumes_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Classification_Resumes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompliance_Events_Classification_Resumes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Events_Classification_Resumes_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Events_Classification_Resumes_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_DailyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Daily_Order_By>>;
  where?: InputMaybe<Compliance_Events_Daily_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Daily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Daily_Order_By>>;
  where?: InputMaybe<Compliance_Events_Daily_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Daily_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Events_Daily_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Events_Daily_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_HourlyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Hourly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Hourly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Hourly_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Hourly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Hourly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Hourly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Hourly_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Hourly_By_PkArgs = {
  compliance_id: Scalars['Int'];
  hour: Scalars['timestamptz'];
};


export type Subscription_RootCompliance_Events_Hourly_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Events_Hourly_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Events_Hourly_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_MonthlyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Monthly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Monthly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Monthly_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Monthly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Monthly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Monthly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Monthly_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Monthly_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Events_Monthly_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Events_Monthly_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Status_HourlyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Status_Hourly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Status_Hourly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Status_Hourly_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Status_Hourly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Status_Hourly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Status_Hourly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Status_Hourly_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Status_Hourly_By_PkArgs = {
  compliance_id: Scalars['Int'];
  hour: Scalars['timestamptz'];
  status: Scalars['String'];
};


export type Subscription_RootCompliance_Events_Status_Hourly_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Events_Status_Hourly_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Events_Status_Hourly_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Status_TotalArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Status_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Status_Total_Order_By>>;
  where?: InputMaybe<Compliance_Events_Status_Total_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Status_Total_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Status_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Status_Total_Order_By>>;
  where?: InputMaybe<Compliance_Events_Status_Total_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Status_Total_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Events_Status_Total_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Events_Status_Total_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_TotalArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Total_Order_By>>;
  where?: InputMaybe<Compliance_Events_Total_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Total_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Total_Order_By>>;
  where?: InputMaybe<Compliance_Events_Total_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Total_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Events_Total_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Events_Total_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_WeeklyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Weekly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Weekly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Weekly_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Weekly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Weekly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Weekly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Weekly_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Weekly_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Weekly_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Weekly_Reports_Order_By>>;
  where?: InputMaybe<Compliance_Events_Weekly_Reports_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Weekly_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Weekly_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Weekly_Reports_Order_By>>;
  where?: InputMaybe<Compliance_Events_Weekly_Reports_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Weekly_Reports_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Events_Weekly_Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Events_Weekly_Reports_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Weekly_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Events_Weekly_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Events_Weekly_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_YearlyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Yearly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Yearly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Yearly_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Yearly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Yearly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Yearly_Order_By>>;
  where?: InputMaybe<Compliance_Events_Yearly_Bool_Exp>;
};


export type Subscription_RootCompliance_Events_Yearly_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Events_Yearly_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Events_Yearly_Bool_Exp>;
};


export type Subscription_RootCompliance_Group_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Group_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Group_Contacts_Order_By>>;
  where?: InputMaybe<Compliance_Group_Contacts_Bool_Exp>;
};


export type Subscription_RootCompliance_Group_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Group_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Group_Contacts_Order_By>>;
  where?: InputMaybe<Compliance_Group_Contacts_Bool_Exp>;
};


export type Subscription_RootCompliance_Group_Contacts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompliance_Group_Contacts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Group_Contacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Group_Contacts_Bool_Exp>;
};


export type Subscription_RootCompliance_Group_UsersArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Group_Users_Order_By>>;
  where?: InputMaybe<Compliance_Group_Users_Bool_Exp>;
};


export type Subscription_RootCompliance_Group_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Group_Users_Order_By>>;
  where?: InputMaybe<Compliance_Group_Users_Bool_Exp>;
};


export type Subscription_RootCompliance_Group_Users_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompliance_Group_Users_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Group_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Group_Users_Bool_Exp>;
};


export type Subscription_RootCompliance_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Groups_Order_By>>;
  where?: InputMaybe<Compliance_Groups_Bool_Exp>;
};


export type Subscription_RootCompliance_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Groups_Order_By>>;
  where?: InputMaybe<Compliance_Groups_Bool_Exp>;
};


export type Subscription_RootCompliance_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompliance_Groups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Groups_Bool_Exp>;
};


export type Subscription_RootCompliance_Groups_With_EventsArgs = {
  args: Compliance_Groups_With_Events_Args;
  distinct_on?: InputMaybe<Array<Compliance_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Groups_Order_By>>;
  where?: InputMaybe<Compliance_Groups_Bool_Exp>;
};


export type Subscription_RootCompliance_Groups_With_Events_AggregateArgs = {
  args: Compliance_Groups_With_Events_Args;
  distinct_on?: InputMaybe<Array<Compliance_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Groups_Order_By>>;
  where?: InputMaybe<Compliance_Groups_Bool_Exp>;
};


export type Subscription_RootCompliance_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_DailyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Daily_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Daily_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_Daily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Daily_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Daily_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_Daily_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Messages_Daily_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Messages_Daily_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_HourlyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Hourly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Hourly_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Hourly_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_Hourly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Hourly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Hourly_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Hourly_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_Hourly_By_PkArgs = {
  compliance_id: Scalars['Int'];
  hour: Scalars['timestamptz'];
};


export type Subscription_RootCompliance_Messages_Hourly_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Messages_Hourly_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Messages_Hourly_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_MonthlyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Monthly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Monthly_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Monthly_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_Monthly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Monthly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Monthly_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Monthly_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_Monthly_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Messages_Monthly_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Messages_Monthly_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Messages_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_TotalArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Total_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Total_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_Total_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Total_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Total_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_Total_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Messages_Total_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Messages_Total_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_WeeklyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Weekly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Weekly_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Weekly_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_Weekly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Weekly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Weekly_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Weekly_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_Weekly_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Messages_Weekly_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Messages_Weekly_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_YearlyArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Yearly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Yearly_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Yearly_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_Yearly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Messages_Yearly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Messages_Yearly_Order_By>>;
  where?: InputMaybe<Compliance_Messages_Yearly_Bool_Exp>;
};


export type Subscription_RootCompliance_Messages_Yearly_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Messages_Yearly_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Messages_Yearly_Bool_Exp>;
};


export type Subscription_RootCompliance_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Participants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Participants_Order_By>>;
  where?: InputMaybe<Compliance_Participants_Bool_Exp>;
};


export type Subscription_RootCompliance_Participants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Participants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Participants_Order_By>>;
  where?: InputMaybe<Compliance_Participants_Bool_Exp>;
};


export type Subscription_RootCompliance_Participants_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Participants_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Participants_Bool_Exp>;
};


export type Subscription_RootCompliance_PoliciesArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Policies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Policies_Order_By>>;
  where?: InputMaybe<Compliance_Policies_Bool_Exp>;
};


export type Subscription_RootCompliance_Policies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Policies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Policies_Order_By>>;
  where?: InputMaybe<Compliance_Policies_Bool_Exp>;
};


export type Subscription_RootCompliance_Policies_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompliance_Policies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Policies_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Policies_Bool_Exp>;
};


export type Subscription_RootCompliance_RulesArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Rules_Order_By>>;
  where?: InputMaybe<Compliance_Rules_Bool_Exp>;
};


export type Subscription_RootCompliance_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Rules_Order_By>>;
  where?: InputMaybe<Compliance_Rules_Bool_Exp>;
};


export type Subscription_RootCompliance_Rules_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompliance_Rules_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Rules_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Rules_Bool_Exp>;
};


export type Subscription_RootCompliance_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Bool_Exp>;
};


export type Subscription_RootCompliance_TagsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Tags_Order_By>>;
  where?: InputMaybe<Compliance_Tags_Bool_Exp>;
};


export type Subscription_RootCompliance_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Tags_Order_By>>;
  where?: InputMaybe<Compliance_Tags_Bool_Exp>;
};


export type Subscription_RootCompliance_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompliance_Tags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Compliance_Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Tags_Bool_Exp>;
};


export type Subscription_RootConsentArgs = {
  distinct_on?: InputMaybe<Array<Consent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consent_Order_By>>;
  where?: InputMaybe<Consent_Bool_Exp>;
};


export type Subscription_RootConsent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consent_Order_By>>;
  where?: InputMaybe<Consent_Bool_Exp>;
};


export type Subscription_RootConsent_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootConsent_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Consent_Stream_Cursor_Input>>;
  where?: InputMaybe<Consent_Bool_Exp>;
};


export type Subscription_RootContact_ListArgs = {
  distinct_on?: InputMaybe<Array<Contact_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_List_Order_By>>;
  where?: InputMaybe<Contact_List_Bool_Exp>;
};


export type Subscription_RootContact_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_List_Order_By>>;
  where?: InputMaybe<Contact_List_Bool_Exp>;
};


export type Subscription_RootContact_List_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootContact_List_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Contact_List_Stream_Cursor_Input>>;
  where?: InputMaybe<Contact_List_Bool_Exp>;
};


export type Subscription_RootDuoArgs = {
  distinct_on?: InputMaybe<Array<Duo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Duo_Order_By>>;
  where?: InputMaybe<Duo_Bool_Exp>;
};


export type Subscription_RootDuo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Duo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Duo_Order_By>>;
  where?: InputMaybe<Duo_Bool_Exp>;
};


export type Subscription_RootDuo_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDuo_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Duo_Stream_Cursor_Input>>;
  where?: InputMaybe<Duo_Bool_Exp>;
};


export type Subscription_RootGroupsArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


export type Subscription_RootGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


export type Subscription_RootGroups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGroups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


export type Subscription_RootGroups_UsersArgs = {
  distinct_on?: InputMaybe<Array<Groups_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Users_Order_By>>;
  where?: InputMaybe<Groups_Users_Bool_Exp>;
};


export type Subscription_RootGroups_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Groups_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Users_Order_By>>;
  where?: InputMaybe<Groups_Users_Bool_Exp>;
};


export type Subscription_RootGroups_Users_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGroups_Users_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Groups_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Groups_Users_Bool_Exp>;
};


export type Subscription_RootInvite_RulesArgs = {
  distinct_on?: InputMaybe<Array<Invite_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Rules_Order_By>>;
  where?: InputMaybe<Invite_Rules_Bool_Exp>;
};


export type Subscription_RootInvite_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invite_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Rules_Order_By>>;
  where?: InputMaybe<Invite_Rules_Bool_Exp>;
};


export type Subscription_RootInvite_Rules_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootInvite_Rules_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Invite_Rules_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Rules_Recipients_Order_By>>;
  where?: InputMaybe<Invite_Rules_Recipients_Bool_Exp>;
};


export type Subscription_RootInvite_Rules_Recipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invite_Rules_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Rules_Recipients_Order_By>>;
  where?: InputMaybe<Invite_Rules_Recipients_Bool_Exp>;
};


export type Subscription_RootInvite_Rules_Recipients_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootInvite_Rules_Recipients_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invite_Rules_Recipients_Stream_Cursor_Input>>;
  where?: InputMaybe<Invite_Rules_Recipients_Bool_Exp>;
};


export type Subscription_RootInvite_Rules_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invite_Rules_Stream_Cursor_Input>>;
  where?: InputMaybe<Invite_Rules_Bool_Exp>;
};


export type Subscription_RootLicense_RecordsArgs = {
  distinct_on?: InputMaybe<Array<License_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<License_Records_Order_By>>;
  where?: InputMaybe<License_Records_Bool_Exp>;
};


export type Subscription_RootLicense_Records_AggregateArgs = {
  distinct_on?: InputMaybe<Array<License_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<License_Records_Order_By>>;
  where?: InputMaybe<License_Records_Bool_Exp>;
};


export type Subscription_RootLicense_Records_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootLicense_Records_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<License_Records_Stream_Cursor_Input>>;
  where?: InputMaybe<License_Records_Bool_Exp>;
};


export type Subscription_RootLinkArgs = {
  distinct_on?: InputMaybe<Array<Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Order_By>>;
  where?: InputMaybe<Link_Bool_Exp>;
};


export type Subscription_RootLink_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Order_By>>;
  where?: InputMaybe<Link_Bool_Exp>;
};


export type Subscription_RootLink_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootLink_DomainsArgs = {
  distinct_on?: InputMaybe<Array<Link_Domains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Domains_Order_By>>;
  where?: InputMaybe<Link_Domains_Bool_Exp>;
};


export type Subscription_RootLink_Domains_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Link_Domains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Domains_Order_By>>;
  where?: InputMaybe<Link_Domains_Bool_Exp>;
};


export type Subscription_RootLink_Domains_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootLink_Domains_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Link_Domains_Stream_Cursor_Input>>;
  where?: InputMaybe<Link_Domains_Bool_Exp>;
};


export type Subscription_RootLink_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Link_Stream_Cursor_Input>>;
  where?: InputMaybe<Link_Bool_Exp>;
};


export type Subscription_RootLogsArgs = {
  distinct_on?: InputMaybe<Array<Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Logs_Order_By>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


export type Subscription_RootLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Logs_Order_By>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


export type Subscription_RootLogs_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootLogs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


export type Subscription_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootNotifications_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootPhone_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Phone_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phone_Providers_Order_By>>;
  where?: InputMaybe<Phone_Providers_Bool_Exp>;
};


export type Subscription_RootPhone_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phone_Providers_Order_By>>;
  where?: InputMaybe<Phone_Providers_Bool_Exp>;
};


export type Subscription_RootPhone_Providers_By_PkArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type Subscription_RootPhone_Providers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Phone_Providers_Stream_Cursor_Input>>;
  where?: InputMaybe<Phone_Providers_Bool_Exp>;
};


export type Subscription_RootPhonesArgs = {
  distinct_on?: InputMaybe<Array<Phones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phones_Order_By>>;
  where?: InputMaybe<Phones_Bool_Exp>;
};


export type Subscription_RootPhones_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phones_Order_By>>;
  where?: InputMaybe<Phones_Bool_Exp>;
};


export type Subscription_RootPhones_By_PkArgs = {
  id: Scalars['Int'];
  phone: Scalars['String'];
};


export type Subscription_RootPhones_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Phones_Stream_Cursor_Input>>;
  where?: InputMaybe<Phones_Bool_Exp>;
};


export type Subscription_RootProductsArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProducts_By_PkArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type Subscription_RootProducts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootRelevant_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Contacts_Order_By>>;
  where?: InputMaybe<Relevant_Contacts_Bool_Exp>;
};


export type Subscription_RootRelevant_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Contacts_Order_By>>;
  where?: InputMaybe<Relevant_Contacts_Bool_Exp>;
};


export type Subscription_RootRelevant_Contacts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootRelevant_Contacts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Relevant_Contacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Relevant_Contacts_Bool_Exp>;
};


export type Subscription_RootRelevant_Contacts_TagsArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Contacts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Contacts_Tags_Order_By>>;
  where?: InputMaybe<Relevant_Contacts_Tags_Bool_Exp>;
};


export type Subscription_RootRelevant_Contacts_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Contacts_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Contacts_Tags_Order_By>>;
  where?: InputMaybe<Relevant_Contacts_Tags_Bool_Exp>;
};


export type Subscription_RootRelevant_Contacts_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootRelevant_Contacts_Tags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Relevant_Contacts_Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Relevant_Contacts_Tags_Bool_Exp>;
};


export type Subscription_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_By_PkArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type Subscription_RootRoles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Roles_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Teams_Order_By>>;
  where?: InputMaybe<Roles_Teams_Bool_Exp>;
};


export type Subscription_RootRoles_Teams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Teams_Order_By>>;
  where?: InputMaybe<Roles_Teams_Bool_Exp>;
};


export type Subscription_RootRoles_Teams_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootRoles_Teams_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Roles_Teams_Stream_Cursor_Input>>;
  where?: InputMaybe<Roles_Teams_Bool_Exp>;
};


export type Subscription_RootRoles_UsersArgs = {
  distinct_on?: InputMaybe<Array<Roles_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Users_Order_By>>;
  where?: InputMaybe<Roles_Users_Bool_Exp>;
};


export type Subscription_RootRoles_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Users_Order_By>>;
  where?: InputMaybe<Roles_Users_Bool_Exp>;
};


export type Subscription_RootRoles_Users_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootRoles_Users_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Roles_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Roles_Users_Bool_Exp>;
};


export type Subscription_RootRollupsArgs = {
  distinct_on?: InputMaybe<Array<Rollups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rollups_Order_By>>;
  where?: InputMaybe<Rollups_Bool_Exp>;
};


export type Subscription_RootRollups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rollups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rollups_Order_By>>;
  where?: InputMaybe<Rollups_Bool_Exp>;
};


export type Subscription_RootRollups_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootRollups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Rollups_Stream_Cursor_Input>>;
  where?: InputMaybe<Rollups_Bool_Exp>;
};


export type Subscription_RootSelect_Incomplete_Compliance_EventsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


export type Subscription_RootSelect_Incomplete_Compliance_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Events_Order_By>>;
  where?: InputMaybe<Compliance_Events_Bool_Exp>;
};


export type Subscription_RootSubscription_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Providers_Order_By>>;
  where?: InputMaybe<Subscription_Providers_Bool_Exp>;
};


export type Subscription_RootSubscription_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Providers_Order_By>>;
  where?: InputMaybe<Subscription_Providers_Bool_Exp>;
};


export type Subscription_RootSubscription_Providers_By_PkArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type Subscription_RootSubscription_Providers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Subscription_Providers_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscription_Providers_Bool_Exp>;
};


export type Subscription_RootSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootSubscriptions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSubscriptions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Subscriptions_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootTags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTeams_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Settings_Order_By>>;
  where?: InputMaybe<Teams_Settings_Bool_Exp>;
};


export type Subscription_RootTeams_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Settings_Order_By>>;
  where?: InputMaybe<Teams_Settings_Bool_Exp>;
};


export type Subscription_RootTeams_Settings_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTeams_Settings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Teams_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Teams_Settings_Bool_Exp>;
};


export type Subscription_RootTeams_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Teams_Stream_Cursor_Input>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Teams_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Templates_Order_By>>;
  where?: InputMaybe<Teams_Templates_Bool_Exp>;
};


export type Subscription_RootTeams_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Templates_Order_By>>;
  where?: InputMaybe<Teams_Templates_Bool_Exp>;
};


export type Subscription_RootTeams_Templates_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTeams_Templates_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Teams_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Teams_Templates_Bool_Exp>;
};


export type Subscription_RootTeams_UsersArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


export type Subscription_RootTeams_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


export type Subscription_RootTeams_Users_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTeams_Users_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Teams_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


export type Subscription_RootTemplatesArgs = {
  distinct_on?: InputMaybe<Array<Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Templates_Order_By>>;
  where?: InputMaybe<Templates_Bool_Exp>;
};


export type Subscription_RootTemplates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Templates_Order_By>>;
  where?: InputMaybe<Templates_Bool_Exp>;
};


export type Subscription_RootTemplates_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTemplates_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Templates_Bool_Exp>;
};


export type Subscription_RootTenantArgs = {
  distinct_on?: InputMaybe<Array<Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenant_Order_By>>;
  where?: InputMaybe<Tenant_Bool_Exp>;
};


export type Subscription_RootTenant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenant_Order_By>>;
  where?: InputMaybe<Tenant_Bool_Exp>;
};


export type Subscription_RootTenant_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootTenant_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tenant_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenant_Bool_Exp>;
};


export type Subscription_RootTokensArgs = {
  distinct_on?: InputMaybe<Array<Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tokens_Order_By>>;
  where?: InputMaybe<Tokens_Bool_Exp>;
};


export type Subscription_RootTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tokens_Order_By>>;
  where?: InputMaybe<Tokens_Bool_Exp>;
};


export type Subscription_RootTokens_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTokens_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<Tokens_Bool_Exp>;
};


export type Subscription_RootUser_Auth_CodesArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Codes_Order_By>>;
  where?: InputMaybe<User_Auth_Codes_Bool_Exp>;
};


export type Subscription_RootUser_Auth_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Codes_Order_By>>;
  where?: InputMaybe<User_Auth_Codes_Bool_Exp>;
};


export type Subscription_RootUser_Auth_Codes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Auth_Codes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Auth_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Auth_Codes_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootWeb_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Web_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Web_Contacts_Order_By>>;
  where?: InputMaybe<Web_Contacts_Bool_Exp>;
};


export type Subscription_RootWeb_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Web_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Web_Contacts_Order_By>>;
  where?: InputMaybe<Web_Contacts_Bool_Exp>;
};


export type Subscription_RootWeb_Contacts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootWeb_Contacts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Web_Contacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Web_Contacts_Bool_Exp>;
};


export type Subscription_RootWeb_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Web_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Web_Messages_Order_By>>;
  where?: InputMaybe<Web_Messages_Bool_Exp>;
};


export type Subscription_RootWeb_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Web_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Web_Messages_Order_By>>;
  where?: InputMaybe<Web_Messages_Bool_Exp>;
};


export type Subscription_RootWeb_Messages_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootWeb_Messages_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Web_Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Web_Messages_Bool_Exp>;
};


export type Subscription_RootWeb_Qr_CodesArgs = {
  distinct_on?: InputMaybe<Array<Web_Qr_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Web_Qr_Codes_Order_By>>;
  where?: InputMaybe<Web_Qr_Codes_Bool_Exp>;
};


export type Subscription_RootWeb_Qr_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Web_Qr_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Web_Qr_Codes_Order_By>>;
  where?: InputMaybe<Web_Qr_Codes_Bool_Exp>;
};


export type Subscription_RootWeb_Qr_Codes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootWeb_Qr_Codes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Web_Qr_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Web_Qr_Codes_Bool_Exp>;
};


export type Subscription_RootWhatsapp__MessageTomessage_UpdateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp__MessageTomessage_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp__MessageTomessage_Update_Order_By>>;
  where?: InputMaybe<Whatsapp__MessageTomessage_Update_Bool_Exp>;
};


export type Subscription_RootWhatsapp__MessageTomessage_Update_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp__MessageTomessage_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp__MessageTomessage_Update_Order_By>>;
  where?: InputMaybe<Whatsapp__MessageTomessage_Update_Bool_Exp>;
};


export type Subscription_RootWhatsapp__MessageTomessage_Update_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Whatsapp__MessageTomessage_Update_Stream_Cursor_Input>>;
  where?: InputMaybe<Whatsapp__MessageTomessage_Update_Bool_Exp>;
};


export type Subscription_RootWhatsapp_ChatArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Chat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Chat_Order_By>>;
  where?: InputMaybe<Whatsapp_Chat_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Chat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Chat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Chat_Order_By>>;
  where?: InputMaybe<Whatsapp_Chat_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Chat_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootWhatsapp_Chat_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Whatsapp_Chat_Stream_Cursor_Input>>;
  where?: InputMaybe<Whatsapp_Chat_Bool_Exp>;
};


export type Subscription_RootWhatsapp_ContactArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Contact_Order_By>>;
  where?: InputMaybe<Whatsapp_Contact_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Contact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Contact_Order_By>>;
  where?: InputMaybe<Whatsapp_Contact_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Contact_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootWhatsapp_Contact_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Whatsapp_Contact_Stream_Cursor_Input>>;
  where?: InputMaybe<Whatsapp_Contact_Bool_Exp>;
};


export type Subscription_RootWhatsapp_MessageArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Message_Order_By>>;
  where?: InputMaybe<Whatsapp_Message_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Message_Order_By>>;
  where?: InputMaybe<Whatsapp_Message_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Message_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootWhatsapp_Message_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Whatsapp_Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Whatsapp_Message_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Message_UpdateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Message_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Message_Update_Order_By>>;
  where?: InputMaybe<Whatsapp_Message_Update_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Message_Update_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Message_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Message_Update_Order_By>>;
  where?: InputMaybe<Whatsapp_Message_Update_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Message_Update_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootWhatsapp_Message_Update_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Whatsapp_Message_Update_Stream_Cursor_Input>>;
  where?: InputMaybe<Whatsapp_Message_Update_Bool_Exp>;
};


export type Subscription_RootWhatsapp_SessionArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Session_Order_By>>;
  where?: InputMaybe<Whatsapp_Session_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Session_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Session_Order_By>>;
  where?: InputMaybe<Whatsapp_Session_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Session_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootWhatsapp_Session_CredentialArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Session_Credential_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Session_Credential_Order_By>>;
  where?: InputMaybe<Whatsapp_Session_Credential_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Session_Credential_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Session_Credential_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Session_Credential_Order_By>>;
  where?: InputMaybe<Whatsapp_Session_Credential_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Session_Credential_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootWhatsapp_Session_Credential_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Whatsapp_Session_Credential_Stream_Cursor_Input>>;
  where?: InputMaybe<Whatsapp_Session_Credential_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Session_History_SyncArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Session_History_Sync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Session_History_Sync_Order_By>>;
  where?: InputMaybe<Whatsapp_Session_History_Sync_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Session_History_Sync_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Session_History_Sync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Session_History_Sync_Order_By>>;
  where?: InputMaybe<Whatsapp_Session_History_Sync_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Session_History_Sync_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootWhatsapp_Session_History_Sync_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Whatsapp_Session_History_Sync_Stream_Cursor_Input>>;
  where?: InputMaybe<Whatsapp_Session_History_Sync_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Session_KeyArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Session_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Session_Key_Order_By>>;
  where?: InputMaybe<Whatsapp_Session_Key_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Session_Key_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Whatsapp_Session_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Whatsapp_Session_Key_Order_By>>;
  where?: InputMaybe<Whatsapp_Session_Key_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Session_Key_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Whatsapp_Session_Key_Stream_Cursor_Input>>;
  where?: InputMaybe<Whatsapp_Session_Key_Bool_Exp>;
};


export type Subscription_RootWhatsapp_Session_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Whatsapp_Session_Stream_Cursor_Input>>;
  where?: InputMaybe<Whatsapp_Session_Bool_Exp>;
};


export type Subscription_RootWos_SyncArgs = {
  distinct_on?: InputMaybe<Array<Wos_Sync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wos_Sync_Order_By>>;
  where?: InputMaybe<Wos_Sync_Bool_Exp>;
};


export type Subscription_RootWos_Sync_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wos_Sync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wos_Sync_Order_By>>;
  where?: InputMaybe<Wos_Sync_Bool_Exp>;
};


export type Subscription_RootWos_Sync_By_PkArgs = {
  last_event_id: Scalars['String'];
};


export type Subscription_RootWos_Sync_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Wos_Sync_Stream_Cursor_Input>>;
  where?: InputMaybe<Wos_Sync_Bool_Exp>;
};


export type Subscription_RootWs_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Ws_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Contacts_Order_By>>;
  where?: InputMaybe<Ws_Contacts_Bool_Exp>;
};


export type Subscription_RootWs_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Contacts_Order_By>>;
  where?: InputMaybe<Ws_Contacts_Bool_Exp>;
};


export type Subscription_RootWs_Contacts_By_PkArgs = {
  phone: Scalars['String'];
};


export type Subscription_RootWs_Contacts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ws_Contacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Ws_Contacts_Bool_Exp>;
};


export type Subscription_RootWs_History_SyncArgs = {
  distinct_on?: InputMaybe<Array<Ws_History_Sync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_History_Sync_Order_By>>;
  where?: InputMaybe<Ws_History_Sync_Bool_Exp>;
};


export type Subscription_RootWs_History_Sync_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_History_Sync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_History_Sync_Order_By>>;
  where?: InputMaybe<Ws_History_Sync_Bool_Exp>;
};


export type Subscription_RootWs_History_Sync_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWs_History_Sync_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ws_History_Sync_Stream_Cursor_Input>>;
  where?: InputMaybe<Ws_History_Sync_Bool_Exp>;
};


export type Subscription_RootWs_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Ws_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Messages_Order_By>>;
  where?: InputMaybe<Ws_Messages_Bool_Exp>;
};


export type Subscription_RootWs_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Messages_Order_By>>;
  where?: InputMaybe<Ws_Messages_Bool_Exp>;
};


export type Subscription_RootWs_Messages_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootWs_Messages_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ws_Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Ws_Messages_Bool_Exp>;
};


export type Subscription_RootWs_ServersArgs = {
  distinct_on?: InputMaybe<Array<Ws_Servers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Servers_Order_By>>;
  where?: InputMaybe<Ws_Servers_Bool_Exp>;
};


export type Subscription_RootWs_Servers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Servers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Servers_Order_By>>;
  where?: InputMaybe<Ws_Servers_Bool_Exp>;
};


export type Subscription_RootWs_Servers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootWs_Servers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ws_Servers_Stream_Cursor_Input>>;
  where?: InputMaybe<Ws_Servers_Bool_Exp>;
};


export type Subscription_RootWs_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Bool_Exp>;
};


export type Subscription_RootWs_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Bool_Exp>;
};


export type Subscription_RootWs_Sessions_By_PkArgs = {
  uuid: Scalars['uuid'];
};


export type Subscription_RootWs_Sessions_CredentialsArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Credentials_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Credentials_Bool_Exp>;
};


export type Subscription_RootWs_Sessions_Credentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Credentials_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Credentials_Bool_Exp>;
};


export type Subscription_RootWs_Sessions_Credentials_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootWs_Sessions_Credentials_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ws_Sessions_Credentials_Stream_Cursor_Input>>;
  where?: InputMaybe<Ws_Sessions_Credentials_Bool_Exp>;
};


export type Subscription_RootWs_Sessions_KeysArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Keys_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Keys_Bool_Exp>;
};


export type Subscription_RootWs_Sessions_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Keys_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Keys_Bool_Exp>;
};


export type Subscription_RootWs_Sessions_Keys_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootWs_Sessions_Keys_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ws_Sessions_Keys_Stream_Cursor_Input>>;
  where?: InputMaybe<Ws_Sessions_Keys_Bool_Exp>;
};


export type Subscription_RootWs_Sessions_Signal_KeysArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Signal_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Signal_Keys_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Signal_Keys_Bool_Exp>;
};


export type Subscription_RootWs_Sessions_Signal_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Signal_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Signal_Keys_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Signal_Keys_Bool_Exp>;
};


export type Subscription_RootWs_Sessions_Signal_Keys_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootWs_Sessions_Signal_Keys_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ws_Sessions_Signal_Keys_Stream_Cursor_Input>>;
  where?: InputMaybe<Ws_Sessions_Signal_Keys_Bool_Exp>;
};


export type Subscription_RootWs_Sessions_StatsArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Stats_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Stats_Bool_Exp>;
};


export type Subscription_RootWs_Sessions_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Stats_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Stats_Bool_Exp>;
};


export type Subscription_RootWs_Sessions_Stats_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootWs_Sessions_Stats_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ws_Sessions_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<Ws_Sessions_Stats_Bool_Exp>;
};


export type Subscription_RootWs_Sessions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ws_Sessions_Stream_Cursor_Input>>;
  where?: InputMaybe<Ws_Sessions_Bool_Exp>;
};

/** columns and relationships of "subscriptions" */
export type Subscriptions = {
  __typename?: 'subscriptions';
  /** An array relationship */
  duos: Array<Duo>;
  /** An aggregate relationship */
  duos_aggregate: Duo_Aggregate;
  ext_id: Scalars['String'];
  id: Scalars['Int'];
  /** An array relationship */
  links: Array<Link>;
  /** An aggregate relationship */
  links_aggregate: Link_Aggregate;
  provider_name: Scalars['String'];
  /** An object relationship */
  subscription_provider: Subscription_Providers;
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
  uuid: Scalars['uuid'];
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsDuosArgs = {
  distinct_on?: InputMaybe<Array<Duo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Duo_Order_By>>;
  where?: InputMaybe<Duo_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsDuos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Duo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Duo_Order_By>>;
  where?: InputMaybe<Duo_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsLinksArgs = {
  distinct_on?: InputMaybe<Array<Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Order_By>>;
  where?: InputMaybe<Link_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsLinks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Order_By>>;
  where?: InputMaybe<Link_Bool_Exp>;
};

/** aggregated selection of "subscriptions" */
export type Subscriptions_Aggregate = {
  __typename?: 'subscriptions_aggregate';
  aggregate?: Maybe<Subscriptions_Aggregate_Fields>;
  nodes: Array<Subscriptions>;
};

export type Subscriptions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Subscriptions_Aggregate_Bool_Exp_Count>;
};

export type Subscriptions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Subscriptions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subscriptions" */
export type Subscriptions_Aggregate_Fields = {
  __typename?: 'subscriptions_aggregate_fields';
  avg?: Maybe<Subscriptions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Subscriptions_Max_Fields>;
  min?: Maybe<Subscriptions_Min_Fields>;
  stddev?: Maybe<Subscriptions_Stddev_Fields>;
  stddev_pop?: Maybe<Subscriptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscriptions_Stddev_Samp_Fields>;
  sum?: Maybe<Subscriptions_Sum_Fields>;
  var_pop?: Maybe<Subscriptions_Var_Pop_Fields>;
  var_samp?: Maybe<Subscriptions_Var_Samp_Fields>;
  variance?: Maybe<Subscriptions_Variance_Fields>;
};


/** aggregate fields of "subscriptions" */
export type Subscriptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "subscriptions" */
export type Subscriptions_Aggregate_Order_By = {
  avg?: InputMaybe<Subscriptions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscriptions_Max_Order_By>;
  min?: InputMaybe<Subscriptions_Min_Order_By>;
  stddev?: InputMaybe<Subscriptions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscriptions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscriptions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscriptions_Sum_Order_By>;
  var_pop?: InputMaybe<Subscriptions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscriptions_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscriptions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscriptions" */
export type Subscriptions_Arr_Rel_Insert_Input = {
  data: Array<Subscriptions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};

/** aggregate avg on columns */
export type Subscriptions_Avg_Fields = {
  __typename?: 'subscriptions_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "subscriptions" */
export type Subscriptions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscriptions". All fields are combined with a logical 'AND'. */
export type Subscriptions_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Bool_Exp>>;
  duos?: InputMaybe<Duo_Bool_Exp>;
  duos_aggregate?: InputMaybe<Duo_Aggregate_Bool_Exp>;
  ext_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  links?: InputMaybe<Link_Bool_Exp>;
  links_aggregate?: InputMaybe<Link_Aggregate_Bool_Exp>;
  provider_name?: InputMaybe<String_Comparison_Exp>;
  subscription_provider?: InputMaybe<Subscription_Providers_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscriptions" */
export enum Subscriptions_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionsPkey = 'subscriptions_pkey',
  /** unique or primary key constraint on columns "ext_id" */
  SubscriptionsSubscriptionIdKey = 'subscriptions_subscription_id_key',
  /** unique or primary key constraint on columns "uuid" */
  SubscriptionsUuidKey = 'subscriptions_uuid_key'
}

/** input type for incrementing numeric columns in table "subscriptions" */
export type Subscriptions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "subscriptions" */
export type Subscriptions_Insert_Input = {
  duos?: InputMaybe<Duo_Arr_Rel_Insert_Input>;
  ext_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  links?: InputMaybe<Link_Arr_Rel_Insert_Input>;
  provider_name?: InputMaybe<Scalars['String']>;
  subscription_provider?: InputMaybe<Subscription_Providers_Obj_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Subscriptions_Max_Fields = {
  __typename?: 'subscriptions_max_fields';
  ext_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  provider_name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "subscriptions" */
export type Subscriptions_Max_Order_By = {
  ext_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider_name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscriptions_Min_Fields = {
  __typename?: 'subscriptions_min_fields';
  ext_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  provider_name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "subscriptions" */
export type Subscriptions_Min_Order_By = {
  ext_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider_name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscriptions" */
export type Subscriptions_Mutation_Response = {
  __typename?: 'subscriptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions>;
};

/** input type for inserting object relation for remote table "subscriptions" */
export type Subscriptions_Obj_Rel_Insert_Input = {
  data: Subscriptions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};

/** on_conflict condition type for table "subscriptions" */
export type Subscriptions_On_Conflict = {
  constraint: Subscriptions_Constraint;
  update_columns?: Array<Subscriptions_Update_Column>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions". */
export type Subscriptions_Order_By = {
  duos_aggregate?: InputMaybe<Duo_Aggregate_Order_By>;
  ext_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  links_aggregate?: InputMaybe<Link_Aggregate_Order_By>;
  provider_name?: InputMaybe<Order_By>;
  subscription_provider?: InputMaybe<Subscription_Providers_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions */
export type Subscriptions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "subscriptions" */
export enum Subscriptions_Select_Column {
  /** column name */
  ExtId = 'ext_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderName = 'provider_name',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "subscriptions" */
export type Subscriptions_Set_Input = {
  ext_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  provider_name?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Subscriptions_Stddev_Fields = {
  __typename?: 'subscriptions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "subscriptions" */
export type Subscriptions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscriptions_Stddev_Pop_Fields = {
  __typename?: 'subscriptions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "subscriptions" */
export type Subscriptions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscriptions_Stddev_Samp_Fields = {
  __typename?: 'subscriptions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "subscriptions" */
export type Subscriptions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscriptions" */
export type Subscriptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Stream_Cursor_Value_Input = {
  ext_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  provider_name?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Subscriptions_Sum_Fields = {
  __typename?: 'subscriptions_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "subscriptions" */
export type Subscriptions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "subscriptions" */
export enum Subscriptions_Update_Column {
  /** column name */
  ExtId = 'ext_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderName = 'provider_name',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type Subscriptions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscriptions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscriptions_Var_Pop_Fields = {
  __typename?: 'subscriptions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "subscriptions" */
export type Subscriptions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscriptions_Var_Samp_Fields = {
  __typename?: 'subscriptions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "subscriptions" */
export type Subscriptions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscriptions_Variance_Fields = {
  __typename?: 'subscriptions_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "subscriptions" */
export type Subscriptions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "tags" */
export type Tags = {
  __typename?: 'tags';
  color?: Maybe<Scalars['String']>;
  /** An object relationship */
  compliance: Compliance;
  compliance_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  permissions?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
  uuid: Scalars['uuid'];
};


/** columns and relationships of "tags" */
export type TagsPermissionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "tags" */
export type Tags_Aggregate = {
  __typename?: 'tags_aggregate';
  aggregate?: Maybe<Tags_Aggregate_Fields>;
  nodes: Array<Tags>;
};

/** aggregate fields of "tags" */
export type Tags_Aggregate_Fields = {
  __typename?: 'tags_aggregate_fields';
  avg?: Maybe<Tags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tags_Max_Fields>;
  min?: Maybe<Tags_Min_Fields>;
  stddev?: Maybe<Tags_Stddev_Fields>;
  stddev_pop?: Maybe<Tags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tags_Stddev_Samp_Fields>;
  sum?: Maybe<Tags_Sum_Fields>;
  var_pop?: Maybe<Tags_Var_Pop_Fields>;
  var_samp?: Maybe<Tags_Var_Samp_Fields>;
  variance?: Maybe<Tags_Variance_Fields>;
};


/** aggregate fields of "tags" */
export type Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tags_Append_Input = {
  permissions?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Tags_Avg_Fields = {
  __typename?: 'tags_avg_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "tags". All fields are combined with a logical 'AND'. */
export type Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Tags_Bool_Exp>>;
  _not?: InputMaybe<Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Tags_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  compliance?: InputMaybe<Compliance_Bool_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  permissions?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "tags" */
export enum Tags_Constraint {
  /** unique or primary key constraint on columns "compliance_id", "name" */
  TagsNameComplianceIdKey = 'tags_name_compliance_id_key',
  /** unique or primary key constraint on columns "id" */
  TagsPkey = 'tags_pkey',
  /** unique or primary key constraint on columns "uuid" */
  TagsUuidKey = 'tags_uuid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tags_Delete_At_Path_Input = {
  permissions?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tags_Delete_Elem_Input = {
  permissions?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tags_Delete_Key_Input = {
  permissions?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "tags" */
export type Tags_Inc_Input = {
  compliance_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "tags" */
export type Tags_Insert_Input = {
  color?: InputMaybe<Scalars['String']>;
  compliance?: InputMaybe<Compliance_Obj_Rel_Insert_Input>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Tags_Max_Fields = {
  __typename?: 'tags_max_fields';
  color?: Maybe<Scalars['String']>;
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Tags_Min_Fields = {
  __typename?: 'tags_min_fields';
  color?: Maybe<Scalars['String']>;
  compliance_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "tags" */
export type Tags_Mutation_Response = {
  __typename?: 'tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tags>;
};

/** input type for inserting object relation for remote table "tags" */
export type Tags_Obj_Rel_Insert_Input = {
  data: Tags_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};

/** on_conflict condition type for table "tags" */
export type Tags_On_Conflict = {
  constraint: Tags_Constraint;
  update_columns?: Array<Tags_Update_Column>;
  where?: InputMaybe<Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "tags". */
export type Tags_Order_By = {
  color?: InputMaybe<Order_By>;
  compliance?: InputMaybe<Compliance_Order_By>;
  compliance_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  permissions?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tags */
export type Tags_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tags_Prepend_Input = {
  permissions?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "tags" */
export enum Tags_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "tags" */
export type Tags_Set_Input = {
  color?: InputMaybe<Scalars['String']>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Tags_Stddev_Fields = {
  __typename?: 'tags_stddev_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Tags_Stddev_Pop_Fields = {
  __typename?: 'tags_stddev_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Tags_Stddev_Samp_Fields = {
  __typename?: 'tags_stddev_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "tags" */
export type Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tags_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']>;
  compliance_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Tags_Sum_Fields = {
  __typename?: 'tags_sum_fields';
  compliance_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "tags" */
export enum Tags_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  ComplianceId = 'compliance_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Tags_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tags_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tags_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tags_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tags_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tags_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tags_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tags_Var_Pop_Fields = {
  __typename?: 'tags_var_pop_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Tags_Var_Samp_Fields = {
  __typename?: 'tags_var_samp_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Tags_Variance_Fields = {
  __typename?: 'tags_variance_fields';
  compliance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "teams" */
export type Teams = {
  __typename?: 'teams';
  active_license: Scalars['Boolean'];
  /** An array relationship */
  compliances: Array<Compliance>;
  /** An aggregate relationship */
  compliances_aggregate: Compliance_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  ext_id?: Maybe<Scalars['String']>;
  ext_updated_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  groups: Array<Groups>;
  /** An aggregate relationship */
  groups_aggregate: Groups_Aggregate;
  id: Scalars['Int'];
  is_personal: Scalars['Boolean'];
  metadata?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  owner_user_id: Scalars['Int'];
  /** An object relationship */
  settings?: Maybe<Teams_Settings>;
  /** An array relationship */
  teams_users: Array<Teams_Users>;
  /** An aggregate relationship */
  teams_users_aggregate: Teams_Users_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "teams" */
export type TeamsCompliancesArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Order_By>>;
  where?: InputMaybe<Compliance_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsCompliances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Order_By>>;
  where?: InputMaybe<Compliance_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsGroupsArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "teams" */
export type TeamsTeams_UsersArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsTeams_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};

/** aggregated selection of "teams" */
export type Teams_Aggregate = {
  __typename?: 'teams_aggregate';
  aggregate?: Maybe<Teams_Aggregate_Fields>;
  nodes: Array<Teams>;
};

export type Teams_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Teams_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Teams_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Teams_Aggregate_Bool_Exp_Count>;
};

export type Teams_Aggregate_Bool_Exp_Bool_And = {
  arguments: Teams_Select_Column_Teams_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Teams_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Teams_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Teams_Select_Column_Teams_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Teams_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Teams_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Teams_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "teams" */
export type Teams_Aggregate_Fields = {
  __typename?: 'teams_aggregate_fields';
  avg?: Maybe<Teams_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Teams_Max_Fields>;
  min?: Maybe<Teams_Min_Fields>;
  stddev?: Maybe<Teams_Stddev_Fields>;
  stddev_pop?: Maybe<Teams_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Teams_Stddev_Samp_Fields>;
  sum?: Maybe<Teams_Sum_Fields>;
  var_pop?: Maybe<Teams_Var_Pop_Fields>;
  var_samp?: Maybe<Teams_Var_Samp_Fields>;
  variance?: Maybe<Teams_Variance_Fields>;
};


/** aggregate fields of "teams" */
export type Teams_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "teams" */
export type Teams_Aggregate_Order_By = {
  avg?: InputMaybe<Teams_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teams_Max_Order_By>;
  min?: InputMaybe<Teams_Min_Order_By>;
  stddev?: InputMaybe<Teams_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Teams_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Teams_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Teams_Sum_Order_By>;
  var_pop?: InputMaybe<Teams_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Teams_Var_Samp_Order_By>;
  variance?: InputMaybe<Teams_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Teams_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "teams" */
export type Teams_Arr_Rel_Insert_Input = {
  data: Array<Teams_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};

/** aggregate avg on columns */
export type Teams_Avg_Fields = {
  __typename?: 'teams_avg_fields';
  id?: Maybe<Scalars['Float']>;
  owner_user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "teams" */
export type Teams_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  owner_user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "teams". All fields are combined with a logical 'AND'. */
export type Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Bool_Exp>>;
  _not?: InputMaybe<Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Bool_Exp>>;
  active_license?: InputMaybe<Boolean_Comparison_Exp>;
  compliances?: InputMaybe<Compliance_Bool_Exp>;
  compliances_aggregate?: InputMaybe<Compliance_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ext_id?: InputMaybe<String_Comparison_Exp>;
  ext_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  groups?: InputMaybe<Groups_Bool_Exp>;
  groups_aggregate?: InputMaybe<Groups_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_personal?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner_user_id?: InputMaybe<Int_Comparison_Exp>;
  settings?: InputMaybe<Teams_Settings_Bool_Exp>;
  teams_users?: InputMaybe<Teams_Users_Bool_Exp>;
  teams_users_aggregate?: InputMaybe<Teams_Users_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "teams" */
export enum Teams_Constraint {
  /** unique or primary key constraint on columns "ext_id" */
  TeamsExtIdKey = 'teams_ext_id_key',
  /** unique or primary key constraint on columns "id" */
  TeamsPkey = 'teams_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Teams_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Teams_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Teams_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "teams" */
export type Teams_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  owner_user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "teams" */
export type Teams_Insert_Input = {
  active_license?: InputMaybe<Scalars['Boolean']>;
  compliances?: InputMaybe<Compliance_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  ext_id?: InputMaybe<Scalars['String']>;
  ext_updated_at?: InputMaybe<Scalars['timestamptz']>;
  groups?: InputMaybe<Groups_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_personal?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  owner_user_id?: InputMaybe<Scalars['Int']>;
  settings?: InputMaybe<Teams_Settings_Obj_Rel_Insert_Input>;
  teams_users?: InputMaybe<Teams_Users_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Teams_Max_Fields = {
  __typename?: 'teams_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  ext_id?: Maybe<Scalars['String']>;
  ext_updated_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  owner_user_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "teams" */
export type Teams_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  ext_id?: InputMaybe<Order_By>;
  ext_updated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Teams_Min_Fields = {
  __typename?: 'teams_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  ext_id?: Maybe<Scalars['String']>;
  ext_updated_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  owner_user_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "teams" */
export type Teams_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  ext_id?: InputMaybe<Order_By>;
  ext_updated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "teams" */
export type Teams_Mutation_Response = {
  __typename?: 'teams_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Teams>;
};

/** input type for inserting object relation for remote table "teams" */
export type Teams_Obj_Rel_Insert_Input = {
  data: Teams_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};

/** on_conflict condition type for table "teams" */
export type Teams_On_Conflict = {
  constraint: Teams_Constraint;
  update_columns?: Array<Teams_Update_Column>;
  where?: InputMaybe<Teams_Bool_Exp>;
};

/** Ordering options when selecting data from "teams". */
export type Teams_Order_By = {
  active_license?: InputMaybe<Order_By>;
  compliances_aggregate?: InputMaybe<Compliance_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  ext_id?: InputMaybe<Order_By>;
  ext_updated_at?: InputMaybe<Order_By>;
  groups_aggregate?: InputMaybe<Groups_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_personal?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner_user_id?: InputMaybe<Order_By>;
  settings?: InputMaybe<Teams_Settings_Order_By>;
  teams_users_aggregate?: InputMaybe<Teams_Users_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: teams */
export type Teams_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Teams_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "teams" */
export enum Teams_Select_Column {
  /** column name */
  ActiveLicense = 'active_license',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExtId = 'ext_id',
  /** column name */
  ExtUpdatedAt = 'ext_updated_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsPersonal = 'is_personal',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerUserId = 'owner_user_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "teams_aggregate_bool_exp_bool_and_arguments_columns" columns of table "teams" */
export enum Teams_Select_Column_Teams_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ActiveLicense = 'active_license',
  /** column name */
  IsPersonal = 'is_personal'
}

/** select "teams_aggregate_bool_exp_bool_or_arguments_columns" columns of table "teams" */
export enum Teams_Select_Column_Teams_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ActiveLicense = 'active_license',
  /** column name */
  IsPersonal = 'is_personal'
}

/** input type for updating data in table "teams" */
export type Teams_Set_Input = {
  active_license?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  ext_id?: InputMaybe<Scalars['String']>;
  ext_updated_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_personal?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  owner_user_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "teams_settings" */
export type Teams_Settings = {
  __typename?: 'teams_settings';
  data: Scalars['jsonb'];
  id: Scalars['Int'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int'];
};


/** columns and relationships of "teams_settings" */
export type Teams_SettingsDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "teams_settings" */
export type Teams_Settings_Aggregate = {
  __typename?: 'teams_settings_aggregate';
  aggregate?: Maybe<Teams_Settings_Aggregate_Fields>;
  nodes: Array<Teams_Settings>;
};

/** aggregate fields of "teams_settings" */
export type Teams_Settings_Aggregate_Fields = {
  __typename?: 'teams_settings_aggregate_fields';
  avg?: Maybe<Teams_Settings_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Teams_Settings_Max_Fields>;
  min?: Maybe<Teams_Settings_Min_Fields>;
  stddev?: Maybe<Teams_Settings_Stddev_Fields>;
  stddev_pop?: Maybe<Teams_Settings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Teams_Settings_Stddev_Samp_Fields>;
  sum?: Maybe<Teams_Settings_Sum_Fields>;
  var_pop?: Maybe<Teams_Settings_Var_Pop_Fields>;
  var_samp?: Maybe<Teams_Settings_Var_Samp_Fields>;
  variance?: Maybe<Teams_Settings_Variance_Fields>;
};


/** aggregate fields of "teams_settings" */
export type Teams_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teams_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Teams_Settings_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Teams_Settings_Avg_Fields = {
  __typename?: 'teams_settings_avg_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "teams_settings". All fields are combined with a logical 'AND'. */
export type Teams_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Settings_Bool_Exp>>;
  _not?: InputMaybe<Teams_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Settings_Bool_Exp>>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "teams_settings" */
export enum Teams_Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamsSettingsPkey = 'teams_settings_pkey',
  /** unique or primary key constraint on columns "team_id" */
  TeamsSettingsTeamIdKey = 'teams_settings_team_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Teams_Settings_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Teams_Settings_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Teams_Settings_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "teams_settings" */
export type Teams_Settings_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "teams_settings" */
export type Teams_Settings_Insert_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Teams_Settings_Max_Fields = {
  __typename?: 'teams_settings_max_fields';
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Teams_Settings_Min_Fields = {
  __typename?: 'teams_settings_min_fields';
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "teams_settings" */
export type Teams_Settings_Mutation_Response = {
  __typename?: 'teams_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Teams_Settings>;
};

/** input type for inserting object relation for remote table "teams_settings" */
export type Teams_Settings_Obj_Rel_Insert_Input = {
  data: Teams_Settings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_Settings_On_Conflict>;
};

/** on_conflict condition type for table "teams_settings" */
export type Teams_Settings_On_Conflict = {
  constraint: Teams_Settings_Constraint;
  update_columns?: Array<Teams_Settings_Update_Column>;
  where?: InputMaybe<Teams_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "teams_settings". */
export type Teams_Settings_Order_By = {
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: teams_settings */
export type Teams_Settings_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Teams_Settings_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "teams_settings" */
export enum Teams_Settings_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id'
}

/** input type for updating data in table "teams_settings" */
export type Teams_Settings_Set_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Teams_Settings_Stddev_Fields = {
  __typename?: 'teams_settings_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Teams_Settings_Stddev_Pop_Fields = {
  __typename?: 'teams_settings_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Teams_Settings_Stddev_Samp_Fields = {
  __typename?: 'teams_settings_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "teams_settings" */
export type Teams_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teams_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teams_Settings_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Teams_Settings_Sum_Fields = {
  __typename?: 'teams_settings_sum_fields';
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "teams_settings" */
export enum Teams_Settings_Update_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id'
}

export type Teams_Settings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Teams_Settings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Teams_Settings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Teams_Settings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Teams_Settings_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Teams_Settings_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Teams_Settings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teams_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teams_Settings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Teams_Settings_Var_Pop_Fields = {
  __typename?: 'teams_settings_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Teams_Settings_Var_Samp_Fields = {
  __typename?: 'teams_settings_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Teams_Settings_Variance_Fields = {
  __typename?: 'teams_settings_variance_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Teams_Stddev_Fields = {
  __typename?: 'teams_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  owner_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "teams" */
export type Teams_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  owner_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Teams_Stddev_Pop_Fields = {
  __typename?: 'teams_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  owner_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "teams" */
export type Teams_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  owner_user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Teams_Stddev_Samp_Fields = {
  __typename?: 'teams_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  owner_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "teams" */
export type Teams_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  owner_user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "teams" */
export type Teams_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teams_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teams_Stream_Cursor_Value_Input = {
  active_license?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  ext_id?: InputMaybe<Scalars['String']>;
  ext_updated_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_personal?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  owner_user_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Teams_Sum_Fields = {
  __typename?: 'teams_sum_fields';
  id?: Maybe<Scalars['Int']>;
  owner_user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "teams" */
export type Teams_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  owner_user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "teams_templates" */
export type Teams_Templates = {
  __typename?: 'teams_templates';
  id: Scalars['Int'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int'];
  /** An object relationship */
  template: Templates;
  template_id: Scalars['Int'];
};

/** aggregated selection of "teams_templates" */
export type Teams_Templates_Aggregate = {
  __typename?: 'teams_templates_aggregate';
  aggregate?: Maybe<Teams_Templates_Aggregate_Fields>;
  nodes: Array<Teams_Templates>;
};

export type Teams_Templates_Aggregate_Bool_Exp = {
  count?: InputMaybe<Teams_Templates_Aggregate_Bool_Exp_Count>;
};

export type Teams_Templates_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Teams_Templates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Teams_Templates_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "teams_templates" */
export type Teams_Templates_Aggregate_Fields = {
  __typename?: 'teams_templates_aggregate_fields';
  avg?: Maybe<Teams_Templates_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Teams_Templates_Max_Fields>;
  min?: Maybe<Teams_Templates_Min_Fields>;
  stddev?: Maybe<Teams_Templates_Stddev_Fields>;
  stddev_pop?: Maybe<Teams_Templates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Teams_Templates_Stddev_Samp_Fields>;
  sum?: Maybe<Teams_Templates_Sum_Fields>;
  var_pop?: Maybe<Teams_Templates_Var_Pop_Fields>;
  var_samp?: Maybe<Teams_Templates_Var_Samp_Fields>;
  variance?: Maybe<Teams_Templates_Variance_Fields>;
};


/** aggregate fields of "teams_templates" */
export type Teams_Templates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teams_Templates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "teams_templates" */
export type Teams_Templates_Aggregate_Order_By = {
  avg?: InputMaybe<Teams_Templates_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teams_Templates_Max_Order_By>;
  min?: InputMaybe<Teams_Templates_Min_Order_By>;
  stddev?: InputMaybe<Teams_Templates_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Teams_Templates_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Teams_Templates_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Teams_Templates_Sum_Order_By>;
  var_pop?: InputMaybe<Teams_Templates_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Teams_Templates_Var_Samp_Order_By>;
  variance?: InputMaybe<Teams_Templates_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "teams_templates" */
export type Teams_Templates_Arr_Rel_Insert_Input = {
  data: Array<Teams_Templates_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_Templates_On_Conflict>;
};

/** aggregate avg on columns */
export type Teams_Templates_Avg_Fields = {
  __typename?: 'teams_templates_avg_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "teams_templates" */
export type Teams_Templates_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "teams_templates". All fields are combined with a logical 'AND'. */
export type Teams_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Templates_Bool_Exp>>;
  _not?: InputMaybe<Teams_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Templates_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  template?: InputMaybe<Templates_Bool_Exp>;
  template_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "teams_templates" */
export enum Teams_Templates_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamsTemplatesPkey = 'teams_templates_pkey'
}

/** input type for incrementing numeric columns in table "teams_templates" */
export type Teams_Templates_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  template_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "teams_templates" */
export type Teams_Templates_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Templates_Obj_Rel_Insert_Input>;
  template_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Teams_Templates_Max_Fields = {
  __typename?: 'teams_templates_max_fields';
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  template_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "teams_templates" */
export type Teams_Templates_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Teams_Templates_Min_Fields = {
  __typename?: 'teams_templates_min_fields';
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  template_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "teams_templates" */
export type Teams_Templates_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "teams_templates" */
export type Teams_Templates_Mutation_Response = {
  __typename?: 'teams_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Teams_Templates>;
};

/** on_conflict condition type for table "teams_templates" */
export type Teams_Templates_On_Conflict = {
  constraint: Teams_Templates_Constraint;
  update_columns?: Array<Teams_Templates_Update_Column>;
  where?: InputMaybe<Teams_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "teams_templates". */
export type Teams_Templates_Order_By = {
  id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  template?: InputMaybe<Templates_Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: teams_templates */
export type Teams_Templates_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "teams_templates" */
export enum Teams_Templates_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TemplateId = 'template_id'
}

/** input type for updating data in table "teams_templates" */
export type Teams_Templates_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  template_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Teams_Templates_Stddev_Fields = {
  __typename?: 'teams_templates_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "teams_templates" */
export type Teams_Templates_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Teams_Templates_Stddev_Pop_Fields = {
  __typename?: 'teams_templates_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "teams_templates" */
export type Teams_Templates_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Teams_Templates_Stddev_Samp_Fields = {
  __typename?: 'teams_templates_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "teams_templates" */
export type Teams_Templates_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "teams_templates" */
export type Teams_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teams_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teams_Templates_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  template_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Teams_Templates_Sum_Fields = {
  __typename?: 'teams_templates_sum_fields';
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  template_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "teams_templates" */
export type Teams_Templates_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** update columns of table "teams_templates" */
export enum Teams_Templates_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TemplateId = 'template_id'
}

export type Teams_Templates_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Teams_Templates_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teams_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teams_Templates_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Teams_Templates_Var_Pop_Fields = {
  __typename?: 'teams_templates_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "teams_templates" */
export type Teams_Templates_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Teams_Templates_Var_Samp_Fields = {
  __typename?: 'teams_templates_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "teams_templates" */
export type Teams_Templates_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Teams_Templates_Variance_Fields = {
  __typename?: 'teams_templates_variance_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "teams_templates" */
export type Teams_Templates_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** update columns of table "teams" */
export enum Teams_Update_Column {
  /** column name */
  ActiveLicense = 'active_license',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExtId = 'ext_id',
  /** column name */
  ExtUpdatedAt = 'ext_updated_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsPersonal = 'is_personal',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerUserId = 'owner_user_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Teams_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Teams_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Teams_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Teams_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Teams_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Teams_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Teams_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teams_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teams_Bool_Exp;
};

/** columns and relationships of "teams_users" */
export type Teams_Users = {
  __typename?: 'teams_users';
  id: Scalars['Int'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
};

/** aggregated selection of "teams_users" */
export type Teams_Users_Aggregate = {
  __typename?: 'teams_users_aggregate';
  aggregate?: Maybe<Teams_Users_Aggregate_Fields>;
  nodes: Array<Teams_Users>;
};

export type Teams_Users_Aggregate_Bool_Exp = {
  count?: InputMaybe<Teams_Users_Aggregate_Bool_Exp_Count>;
};

export type Teams_Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Teams_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Teams_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "teams_users" */
export type Teams_Users_Aggregate_Fields = {
  __typename?: 'teams_users_aggregate_fields';
  avg?: Maybe<Teams_Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Teams_Users_Max_Fields>;
  min?: Maybe<Teams_Users_Min_Fields>;
  stddev?: Maybe<Teams_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Teams_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Teams_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Teams_Users_Sum_Fields>;
  var_pop?: Maybe<Teams_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Teams_Users_Var_Samp_Fields>;
  variance?: Maybe<Teams_Users_Variance_Fields>;
};


/** aggregate fields of "teams_users" */
export type Teams_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teams_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "teams_users" */
export type Teams_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Teams_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teams_Users_Max_Order_By>;
  min?: InputMaybe<Teams_Users_Min_Order_By>;
  stddev?: InputMaybe<Teams_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Teams_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Teams_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Teams_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Teams_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Teams_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Teams_Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "teams_users" */
export type Teams_Users_Arr_Rel_Insert_Input = {
  data: Array<Teams_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Teams_Users_Avg_Fields = {
  __typename?: 'teams_users_avg_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "teams_users" */
export type Teams_Users_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "teams_users". All fields are combined with a logical 'AND'. */
export type Teams_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Users_Bool_Exp>>;
  _not?: InputMaybe<Teams_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Users_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "teams_users" */
export enum Teams_Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamsUsersPkey = 'teams_users_pkey',
  /** unique or primary key constraint on columns "user_id", "team_id" */
  TeamsUsersUserIdTeamIdKey = 'teams_users_user_id_team_id_key'
}

/** input type for incrementing numeric columns in table "teams_users" */
export type Teams_Users_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "teams_users" */
export type Teams_Users_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Teams_Users_Max_Fields = {
  __typename?: 'teams_users_max_fields';
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "teams_users" */
export type Teams_Users_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Teams_Users_Min_Fields = {
  __typename?: 'teams_users_min_fields';
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "teams_users" */
export type Teams_Users_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "teams_users" */
export type Teams_Users_Mutation_Response = {
  __typename?: 'teams_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Teams_Users>;
};

/** on_conflict condition type for table "teams_users" */
export type Teams_Users_On_Conflict = {
  constraint: Teams_Users_Constraint;
  update_columns?: Array<Teams_Users_Update_Column>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "teams_users". */
export type Teams_Users_Order_By = {
  id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: teams_users */
export type Teams_Users_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "teams_users" */
export enum Teams_Users_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "teams_users" */
export type Teams_Users_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Teams_Users_Stddev_Fields = {
  __typename?: 'teams_users_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "teams_users" */
export type Teams_Users_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Teams_Users_Stddev_Pop_Fields = {
  __typename?: 'teams_users_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "teams_users" */
export type Teams_Users_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Teams_Users_Stddev_Samp_Fields = {
  __typename?: 'teams_users_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "teams_users" */
export type Teams_Users_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "teams_users" */
export type Teams_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teams_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teams_Users_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Teams_Users_Sum_Fields = {
  __typename?: 'teams_users_sum_fields';
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "teams_users" */
export type Teams_Users_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "teams_users" */
export enum Teams_Users_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UserId = 'user_id'
}

export type Teams_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Teams_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teams_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teams_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Teams_Users_Var_Pop_Fields = {
  __typename?: 'teams_users_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "teams_users" */
export type Teams_Users_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Teams_Users_Var_Samp_Fields = {
  __typename?: 'teams_users_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "teams_users" */
export type Teams_Users_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Teams_Users_Variance_Fields = {
  __typename?: 'teams_users_variance_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "teams_users" */
export type Teams_Users_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Teams_Var_Pop_Fields = {
  __typename?: 'teams_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  owner_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "teams" */
export type Teams_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  owner_user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Teams_Var_Samp_Fields = {
  __typename?: 'teams_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  owner_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "teams" */
export type Teams_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  owner_user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Teams_Variance_Fields = {
  __typename?: 'teams_variance_fields';
  id?: Maybe<Scalars['Float']>;
  owner_user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "teams" */
export type Teams_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  owner_user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "templates" */
export type Templates = {
  __typename?: 'templates';
  content?: Maybe<Scalars['jsonb']>;
  id: Scalars['Int'];
  is_default: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  teams_templates: Array<Teams_Templates>;
  /** An aggregate relationship */
  teams_templates_aggregate: Teams_Templates_Aggregate;
};


/** columns and relationships of "templates" */
export type TemplatesContentArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "templates" */
export type TemplatesTeams_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Teams_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Templates_Order_By>>;
  where?: InputMaybe<Teams_Templates_Bool_Exp>;
};


/** columns and relationships of "templates" */
export type TemplatesTeams_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Templates_Order_By>>;
  where?: InputMaybe<Teams_Templates_Bool_Exp>;
};

/** aggregated selection of "templates" */
export type Templates_Aggregate = {
  __typename?: 'templates_aggregate';
  aggregate?: Maybe<Templates_Aggregate_Fields>;
  nodes: Array<Templates>;
};

/** aggregate fields of "templates" */
export type Templates_Aggregate_Fields = {
  __typename?: 'templates_aggregate_fields';
  avg?: Maybe<Templates_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Templates_Max_Fields>;
  min?: Maybe<Templates_Min_Fields>;
  stddev?: Maybe<Templates_Stddev_Fields>;
  stddev_pop?: Maybe<Templates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Templates_Stddev_Samp_Fields>;
  sum?: Maybe<Templates_Sum_Fields>;
  var_pop?: Maybe<Templates_Var_Pop_Fields>;
  var_samp?: Maybe<Templates_Var_Samp_Fields>;
  variance?: Maybe<Templates_Variance_Fields>;
};


/** aggregate fields of "templates" */
export type Templates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Templates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Templates_Append_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Templates_Avg_Fields = {
  __typename?: 'templates_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "templates". All fields are combined with a logical 'AND'. */
export type Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Templates_Bool_Exp>>;
  _not?: InputMaybe<Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Templates_Bool_Exp>>;
  content?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  teams_templates?: InputMaybe<Teams_Templates_Bool_Exp>;
  teams_templates_aggregate?: InputMaybe<Teams_Templates_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "templates" */
export enum Templates_Constraint {
  /** unique or primary key constraint on columns "name" */
  TemplatesIdxPartialNameIsDefault = 'templates_idx_partial_name_is_default',
  /** unique or primary key constraint on columns "id" */
  TemplatesPkey = 'templates_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Templates_Delete_At_Path_Input = {
  content?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Templates_Delete_Elem_Input = {
  content?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Templates_Delete_Key_Input = {
  content?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "templates" */
export type Templates_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "templates" */
export type Templates_Insert_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  teams_templates?: InputMaybe<Teams_Templates_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Templates_Max_Fields = {
  __typename?: 'templates_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Templates_Min_Fields = {
  __typename?: 'templates_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "templates" */
export type Templates_Mutation_Response = {
  __typename?: 'templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Templates>;
};

/** input type for inserting object relation for remote table "templates" */
export type Templates_Obj_Rel_Insert_Input = {
  data: Templates_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Templates_On_Conflict>;
};

/** on_conflict condition type for table "templates" */
export type Templates_On_Conflict = {
  constraint: Templates_Constraint;
  update_columns?: Array<Templates_Update_Column>;
  where?: InputMaybe<Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "templates". */
export type Templates_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  teams_templates_aggregate?: InputMaybe<Teams_Templates_Aggregate_Order_By>;
};

/** primary key columns input for table: templates */
export type Templates_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Templates_Prepend_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "templates" */
export enum Templates_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "templates" */
export type Templates_Set_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Templates_Stddev_Fields = {
  __typename?: 'templates_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Templates_Stddev_Pop_Fields = {
  __typename?: 'templates_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Templates_Stddev_Samp_Fields = {
  __typename?: 'templates_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "templates" */
export type Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Templates_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Templates_Sum_Fields = {
  __typename?: 'templates_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "templates" */
export enum Templates_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Name = 'name'
}

export type Templates_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Templates_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Templates_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Templates_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Templates_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Templates_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Templates_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Templates_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Templates_Var_Pop_Fields = {
  __typename?: 'templates_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Templates_Var_Samp_Fields = {
  __typename?: 'templates_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Templates_Variance_Fields = {
  __typename?: 'templates_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "tenant" */
export type Tenant = {
  __typename?: 'tenant';
  created_at: Scalars['timestamp'];
  id: Scalars['String'];
  name: Scalars['String'];
  updated_at: Scalars['timestamp'];
};

/** aggregated selection of "tenant" */
export type Tenant_Aggregate = {
  __typename?: 'tenant_aggregate';
  aggregate?: Maybe<Tenant_Aggregate_Fields>;
  nodes: Array<Tenant>;
};

/** aggregate fields of "tenant" */
export type Tenant_Aggregate_Fields = {
  __typename?: 'tenant_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tenant_Max_Fields>;
  min?: Maybe<Tenant_Min_Fields>;
};


/** aggregate fields of "tenant" */
export type Tenant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "tenant". All fields are combined with a logical 'AND'. */
export type Tenant_Bool_Exp = {
  _and?: InputMaybe<Array<Tenant_Bool_Exp>>;
  _not?: InputMaybe<Tenant_Bool_Exp>;
  _or?: InputMaybe<Array<Tenant_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenant" */
export enum Tenant_Constraint {
  /** unique or primary key constraint on columns "id" */
  TenantIdKey = 'tenant_id_key',
  /** unique or primary key constraint on columns "id" */
  TenantPkey = 'tenant_pkey'
}

/** input type for inserting data into table "tenant" */
export type Tenant_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Tenant_Max_Fields = {
  __typename?: 'tenant_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Tenant_Min_Fields = {
  __typename?: 'tenant_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "tenant" */
export type Tenant_Mutation_Response = {
  __typename?: 'tenant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenant>;
};

/** on_conflict condition type for table "tenant" */
export type Tenant_On_Conflict = {
  constraint: Tenant_Constraint;
  update_columns?: Array<Tenant_Update_Column>;
  where?: InputMaybe<Tenant_Bool_Exp>;
};

/** Ordering options when selecting data from "tenant". */
export type Tenant_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenant */
export type Tenant_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "tenant" */
export enum Tenant_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "tenant" */
export type Tenant_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "tenant" */
export type Tenant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenant_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "tenant" */
export enum Tenant_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Tenant_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenant_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenant_Bool_Exp;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']>;
  _gt?: InputMaybe<Scalars['time']>;
  _gte?: InputMaybe<Scalars['time']>;
  _in?: InputMaybe<Array<Scalars['time']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['time']>;
  _lte?: InputMaybe<Scalars['time']>;
  _neq?: InputMaybe<Scalars['time']>;
  _nin?: InputMaybe<Array<Scalars['time']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "tokens" */
export type Tokens = {
  __typename?: 'tokens';
  created_at: Scalars['date'];
  id: Scalars['Int'];
  token: Scalars['String'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
  verified: Scalars['Boolean'];
};

/** aggregated selection of "tokens" */
export type Tokens_Aggregate = {
  __typename?: 'tokens_aggregate';
  aggregate?: Maybe<Tokens_Aggregate_Fields>;
  nodes: Array<Tokens>;
};

/** aggregate fields of "tokens" */
export type Tokens_Aggregate_Fields = {
  __typename?: 'tokens_aggregate_fields';
  avg?: Maybe<Tokens_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tokens_Max_Fields>;
  min?: Maybe<Tokens_Min_Fields>;
  stddev?: Maybe<Tokens_Stddev_Fields>;
  stddev_pop?: Maybe<Tokens_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tokens_Stddev_Samp_Fields>;
  sum?: Maybe<Tokens_Sum_Fields>;
  var_pop?: Maybe<Tokens_Var_Pop_Fields>;
  var_samp?: Maybe<Tokens_Var_Samp_Fields>;
  variance?: Maybe<Tokens_Variance_Fields>;
};


/** aggregate fields of "tokens" */
export type Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Tokens_Avg_Fields = {
  __typename?: 'tokens_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "tokens". All fields are combined with a logical 'AND'. */
export type Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Tokens_Bool_Exp>>;
  _not?: InputMaybe<Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Tokens_Bool_Exp>>;
  created_at?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "tokens" */
export enum Tokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  TokensPkey = 'tokens_pkey',
  /** unique or primary key constraint on columns "user_id" */
  TokensUserIdKey = 'tokens_user_id_key'
}

/** input type for incrementing numeric columns in table "tokens" */
export type Tokens_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "tokens" */
export type Tokens_Insert_Input = {
  created_at?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Tokens_Max_Fields = {
  __typename?: 'tokens_max_fields';
  created_at?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Tokens_Min_Fields = {
  __typename?: 'tokens_min_fields';
  created_at?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "tokens" */
export type Tokens_Mutation_Response = {
  __typename?: 'tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tokens>;
};

/** input type for inserting object relation for remote table "tokens" */
export type Tokens_Obj_Rel_Insert_Input = {
  data: Tokens_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tokens_On_Conflict>;
};

/** on_conflict condition type for table "tokens" */
export type Tokens_On_Conflict = {
  constraint: Tokens_Constraint;
  update_columns?: Array<Tokens_Update_Column>;
  where?: InputMaybe<Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "tokens". */
export type Tokens_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tokens */
export type Tokens_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "tokens" */
export enum Tokens_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Token = 'token',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "tokens" */
export type Tokens_Set_Input = {
  created_at?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Tokens_Stddev_Fields = {
  __typename?: 'tokens_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Tokens_Stddev_Pop_Fields = {
  __typename?: 'tokens_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Tokens_Stddev_Samp_Fields = {
  __typename?: 'tokens_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "tokens" */
export type Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tokens_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Tokens_Sum_Fields = {
  __typename?: 'tokens_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "tokens" */
export enum Tokens_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Token = 'token',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

export type Tokens_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tokens_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tokens_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tokens_Var_Pop_Fields = {
  __typename?: 'tokens_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Tokens_Var_Samp_Fields = {
  __typename?: 'tokens_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Tokens_Variance_Fields = {
  __typename?: 'tokens_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "unit_type". All fields are combined with logical 'AND'. */
export type Unit_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['unit_type']>;
  _gt?: InputMaybe<Scalars['unit_type']>;
  _gte?: InputMaybe<Scalars['unit_type']>;
  _in?: InputMaybe<Array<Scalars['unit_type']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['unit_type']>;
  _lte?: InputMaybe<Scalars['unit_type']>;
  _neq?: InputMaybe<Scalars['unit_type']>;
  _nin?: InputMaybe<Array<Scalars['unit_type']>>;
};

/** columns and relationships of "user_auth_codes" */
export type User_Auth_Codes = {
  __typename?: 'user_auth_codes';
  code: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  mode: Scalars['String'];
  user_id: Scalars['Int'];
  verified: Scalars['Boolean'];
};

/** aggregated selection of "user_auth_codes" */
export type User_Auth_Codes_Aggregate = {
  __typename?: 'user_auth_codes_aggregate';
  aggregate?: Maybe<User_Auth_Codes_Aggregate_Fields>;
  nodes: Array<User_Auth_Codes>;
};

/** aggregate fields of "user_auth_codes" */
export type User_Auth_Codes_Aggregate_Fields = {
  __typename?: 'user_auth_codes_aggregate_fields';
  avg?: Maybe<User_Auth_Codes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Auth_Codes_Max_Fields>;
  min?: Maybe<User_Auth_Codes_Min_Fields>;
  stddev?: Maybe<User_Auth_Codes_Stddev_Fields>;
  stddev_pop?: Maybe<User_Auth_Codes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Auth_Codes_Stddev_Samp_Fields>;
  sum?: Maybe<User_Auth_Codes_Sum_Fields>;
  var_pop?: Maybe<User_Auth_Codes_Var_Pop_Fields>;
  var_samp?: Maybe<User_Auth_Codes_Var_Samp_Fields>;
  variance?: Maybe<User_Auth_Codes_Variance_Fields>;
};


/** aggregate fields of "user_auth_codes" */
export type User_Auth_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Auth_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Auth_Codes_Avg_Fields = {
  __typename?: 'user_auth_codes_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_auth_codes". All fields are combined with a logical 'AND'. */
export type User_Auth_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<User_Auth_Codes_Bool_Exp>>;
  _not?: InputMaybe<User_Auth_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<User_Auth_Codes_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  mode?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_auth_codes" */
export enum User_Auth_Codes_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAuthCodesPkey = 'user_auth_codes_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UserAuthCodesUserIdKey = 'user_auth_codes_user_id_key'
}

/** input type for incrementing numeric columns in table "user_auth_codes" */
export type User_Auth_Codes_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_auth_codes" */
export type User_Auth_Codes_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type User_Auth_Codes_Max_Fields = {
  __typename?: 'user_auth_codes_max_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mode?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type User_Auth_Codes_Min_Fields = {
  __typename?: 'user_auth_codes_min_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mode?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "user_auth_codes" */
export type User_Auth_Codes_Mutation_Response = {
  __typename?: 'user_auth_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Auth_Codes>;
};

/** on_conflict condition type for table "user_auth_codes" */
export type User_Auth_Codes_On_Conflict = {
  constraint: User_Auth_Codes_Constraint;
  update_columns?: Array<User_Auth_Codes_Update_Column>;
  where?: InputMaybe<User_Auth_Codes_Bool_Exp>;
};

/** Ordering options when selecting data from "user_auth_codes". */
export type User_Auth_Codes_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_auth_codes */
export type User_Auth_Codes_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_auth_codes" */
export enum User_Auth_Codes_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Mode = 'mode',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "user_auth_codes" */
export type User_Auth_Codes_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type User_Auth_Codes_Stddev_Fields = {
  __typename?: 'user_auth_codes_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Auth_Codes_Stddev_Pop_Fields = {
  __typename?: 'user_auth_codes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Auth_Codes_Stddev_Samp_Fields = {
  __typename?: 'user_auth_codes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_auth_codes" */
export type User_Auth_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Auth_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Auth_Codes_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type User_Auth_Codes_Sum_Fields = {
  __typename?: 'user_auth_codes_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_auth_codes" */
export enum User_Auth_Codes_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Mode = 'mode',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

export type User_Auth_Codes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Auth_Codes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Auth_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Auth_Codes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Auth_Codes_Var_Pop_Fields = {
  __typename?: 'user_auth_codes_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Auth_Codes_Var_Samp_Fields = {
  __typename?: 'user_auth_codes_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Auth_Codes_Variance_Fields = {
  __typename?: 'user_auth_codes_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  /** An array relationship */
  compliance_group_users: Array<Compliance_Group_Users>;
  /** An aggregate relationship */
  compliance_group_users_aggregate: Compliance_Group_Users_Aggregate;
  cpf_cnpj?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  ext_id?: Maybe<Scalars['String']>;
  ext_updated_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  groups_users: Array<Groups_Users>;
  /** An aggregate relationship */
  groups_users_aggregate: Groups_Users_Aggregate;
  id: Scalars['Int'];
  jwt_refresh_token?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  passwordless: Scalars['Boolean'];
  payment_status?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** An array relationship */
  roles_users: Array<Roles_Users>;
  /** An aggregate relationship */
  roles_users_aggregate: Roles_Users_Aggregate;
  /** email | whatsapp */
  source: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** An array relationship */
  teams: Array<Teams>;
  /** An aggregate relationship */
  teams_aggregate: Teams_Aggregate;
  /** An array relationship */
  teams_users: Array<Teams_Users>;
  /** An aggregate relationship */
  teams_users_aggregate: Teams_Users_Aggregate;
  /** An object relationship */
  token?: Maybe<Tokens>;
  two_factor_authentication: Scalars['Boolean'];
  zip_code?: Maybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersCompliance_Group_UsersArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Group_Users_Order_By>>;
  where?: InputMaybe<Compliance_Group_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCompliance_Group_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Group_Users_Order_By>>;
  where?: InputMaybe<Compliance_Group_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersGroups_UsersArgs = {
  distinct_on?: InputMaybe<Array<Groups_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Users_Order_By>>;
  where?: InputMaybe<Groups_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersGroups_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Groups_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Users_Order_By>>;
  where?: InputMaybe<Groups_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRoles_UsersArgs = {
  distinct_on?: InputMaybe<Array<Roles_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Users_Order_By>>;
  where?: InputMaybe<Roles_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRoles_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Users_Order_By>>;
  where?: InputMaybe<Roles_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTeams_UsersArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTeams_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  complement?: InputMaybe<String_Comparison_Exp>;
  compliance_group_users?: InputMaybe<Compliance_Group_Users_Bool_Exp>;
  compliance_group_users_aggregate?: InputMaybe<Compliance_Group_Users_Aggregate_Bool_Exp>;
  cpf_cnpj?: InputMaybe<String_Comparison_Exp>;
  customer_id?: InputMaybe<String_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  ext_id?: InputMaybe<String_Comparison_Exp>;
  ext_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  groups_users?: InputMaybe<Groups_Users_Bool_Exp>;
  groups_users_aggregate?: InputMaybe<Groups_Users_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  jwt_refresh_token?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  passwordless?: InputMaybe<Boolean_Comparison_Exp>;
  payment_status?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  roles_users?: InputMaybe<Roles_Users_Bool_Exp>;
  roles_users_aggregate?: InputMaybe<Roles_Users_Aggregate_Bool_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
  teams?: InputMaybe<Teams_Bool_Exp>;
  teams_aggregate?: InputMaybe<Teams_Aggregate_Bool_Exp>;
  teams_users?: InputMaybe<Teams_Users_Bool_Exp>;
  teams_users_aggregate?: InputMaybe<Teams_Users_Aggregate_Bool_Exp>;
  token?: InputMaybe<Tokens_Bool_Exp>;
  two_factor_authentication?: InputMaybe<Boolean_Comparison_Exp>;
  zip_code?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "cpf_cnpj" */
  UsersCpfCnpjKey = 'users_cpf_cnpj_key',
  /** unique or primary key constraint on columns "customer_id" */
  UsersCustomerIdKey = 'users_customer_id_key',
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "phone", "email" */
  UsersEmailPhoneNumberKey = 'users_email_phone_number_key',
  /** unique or primary key constraint on columns "ext_id" */
  UsersExtIdKey = 'users_ext_id_key',
  /** unique or primary key constraint on columns "id" */
  UsersIdKey = 'users_id_key',
  /** unique or primary key constraint on columns "phone" */
  UsersPhoneNumberKey = 'users_phone_number_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  complement?: InputMaybe<Scalars['String']>;
  compliance_group_users?: InputMaybe<Compliance_Group_Users_Arr_Rel_Insert_Input>;
  cpf_cnpj?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  ext_id?: InputMaybe<Scalars['String']>;
  ext_updated_at?: InputMaybe<Scalars['timestamptz']>;
  groups_users?: InputMaybe<Groups_Users_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  jwt_refresh_token?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  passwordless?: InputMaybe<Scalars['Boolean']>;
  payment_status?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  roles_users?: InputMaybe<Roles_Users_Arr_Rel_Insert_Input>;
  /** email | whatsapp */
  source?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  subscriptions?: InputMaybe<Subscriptions_Arr_Rel_Insert_Input>;
  teams?: InputMaybe<Teams_Arr_Rel_Insert_Input>;
  teams_users?: InputMaybe<Teams_Users_Arr_Rel_Insert_Input>;
  token?: InputMaybe<Tokens_Obj_Rel_Insert_Input>;
  two_factor_authentication?: InputMaybe<Scalars['Boolean']>;
  zip_code?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  cpf_cnpj?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  ext_id?: Maybe<Scalars['String']>;
  ext_updated_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  jwt_refresh_token?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  payment_status?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** email | whatsapp */
  source?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  cpf_cnpj?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  ext_id?: Maybe<Scalars['String']>;
  ext_updated_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  jwt_refresh_token?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  payment_status?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** email | whatsapp */
  source?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  complement?: InputMaybe<Order_By>;
  compliance_group_users_aggregate?: InputMaybe<Compliance_Group_Users_Aggregate_Order_By>;
  cpf_cnpj?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  ext_id?: InputMaybe<Order_By>;
  ext_updated_at?: InputMaybe<Order_By>;
  groups_users_aggregate?: InputMaybe<Groups_Users_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  jwt_refresh_token?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  passwordless?: InputMaybe<Order_By>;
  payment_status?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  roles_users_aggregate?: InputMaybe<Roles_Users_Aggregate_Order_By>;
  source?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
  teams_aggregate?: InputMaybe<Teams_Aggregate_Order_By>;
  teams_users_aggregate?: InputMaybe<Teams_Users_Aggregate_Order_By>;
  token?: InputMaybe<Tokens_Order_By>;
  two_factor_authentication?: InputMaybe<Order_By>;
  zip_code?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  Complement = 'complement',
  /** column name */
  CpfCnpj = 'cpf_cnpj',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  District = 'district',
  /** column name */
  Email = 'email',
  /** column name */
  ExtId = 'ext_id',
  /** column name */
  ExtUpdatedAt = 'ext_updated_at',
  /** column name */
  Id = 'id',
  /** column name */
  JwtRefreshToken = 'jwt_refresh_token',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  Password = 'password',
  /** column name */
  Passwordless = 'passwordless',
  /** column name */
  PaymentStatus = 'payment_status',
  /** column name */
  Phone = 'phone',
  /** column name */
  Source = 'source',
  /** column name */
  State = 'state',
  /** column name */
  Street = 'street',
  /** column name */
  TwoFactorAuthentication = 'two_factor_authentication',
  /** column name */
  ZipCode = 'zip_code'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  complement?: InputMaybe<Scalars['String']>;
  cpf_cnpj?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  ext_id?: InputMaybe<Scalars['String']>;
  ext_updated_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  jwt_refresh_token?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  passwordless?: InputMaybe<Scalars['Boolean']>;
  payment_status?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** email | whatsapp */
  source?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  two_factor_authentication?: InputMaybe<Scalars['Boolean']>;
  zip_code?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  complement?: InputMaybe<Scalars['String']>;
  cpf_cnpj?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  ext_id?: InputMaybe<Scalars['String']>;
  ext_updated_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  jwt_refresh_token?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  passwordless?: InputMaybe<Scalars['Boolean']>;
  payment_status?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** email | whatsapp */
  source?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  two_factor_authentication?: InputMaybe<Scalars['Boolean']>;
  zip_code?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  Complement = 'complement',
  /** column name */
  CpfCnpj = 'cpf_cnpj',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  District = 'district',
  /** column name */
  Email = 'email',
  /** column name */
  ExtId = 'ext_id',
  /** column name */
  ExtUpdatedAt = 'ext_updated_at',
  /** column name */
  Id = 'id',
  /** column name */
  JwtRefreshToken = 'jwt_refresh_token',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  Password = 'password',
  /** column name */
  Passwordless = 'passwordless',
  /** column name */
  PaymentStatus = 'payment_status',
  /** column name */
  Phone = 'phone',
  /** column name */
  Source = 'source',
  /** column name */
  State = 'state',
  /** column name */
  Street = 'street',
  /** column name */
  TwoFactorAuthentication = 'two_factor_authentication',
  /** column name */
  ZipCode = 'zip_code'
}

export type Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "web_contacts" */
export type Web_Contacts = {
  __typename?: 'web_contacts';
  authenticated: Scalars['Boolean'];
  browser_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  browser_session?: Maybe<Browser_Sessions>;
  contact_name?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  keys?: Maybe<Scalars['String']>;
  /** An array relationship */
  messages: Array<Web_Messages>;
  /** An aggregate relationship */
  messages_aggregate: Web_Messages_Aggregate;
  phone: Scalars['String'];
  profile_pic?: Maybe<Scalars['String']>;
};


/** columns and relationships of "web_contacts" */
export type Web_ContactsMessagesArgs = {
  distinct_on?: InputMaybe<Array<Web_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Web_Messages_Order_By>>;
  where?: InputMaybe<Web_Messages_Bool_Exp>;
};


/** columns and relationships of "web_contacts" */
export type Web_ContactsMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Web_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Web_Messages_Order_By>>;
  where?: InputMaybe<Web_Messages_Bool_Exp>;
};

/** aggregated selection of "web_contacts" */
export type Web_Contacts_Aggregate = {
  __typename?: 'web_contacts_aggregate';
  aggregate?: Maybe<Web_Contacts_Aggregate_Fields>;
  nodes: Array<Web_Contacts>;
};

/** aggregate fields of "web_contacts" */
export type Web_Contacts_Aggregate_Fields = {
  __typename?: 'web_contacts_aggregate_fields';
  avg?: Maybe<Web_Contacts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Web_Contacts_Max_Fields>;
  min?: Maybe<Web_Contacts_Min_Fields>;
  stddev?: Maybe<Web_Contacts_Stddev_Fields>;
  stddev_pop?: Maybe<Web_Contacts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Web_Contacts_Stddev_Samp_Fields>;
  sum?: Maybe<Web_Contacts_Sum_Fields>;
  var_pop?: Maybe<Web_Contacts_Var_Pop_Fields>;
  var_samp?: Maybe<Web_Contacts_Var_Samp_Fields>;
  variance?: Maybe<Web_Contacts_Variance_Fields>;
};


/** aggregate fields of "web_contacts" */
export type Web_Contacts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Web_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Web_Contacts_Avg_Fields = {
  __typename?: 'web_contacts_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "web_contacts". All fields are combined with a logical 'AND'. */
export type Web_Contacts_Bool_Exp = {
  _and?: InputMaybe<Array<Web_Contacts_Bool_Exp>>;
  _not?: InputMaybe<Web_Contacts_Bool_Exp>;
  _or?: InputMaybe<Array<Web_Contacts_Bool_Exp>>;
  authenticated?: InputMaybe<Boolean_Comparison_Exp>;
  browser_id?: InputMaybe<Uuid_Comparison_Exp>;
  browser_session?: InputMaybe<Browser_Sessions_Bool_Exp>;
  contact_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  keys?: InputMaybe<String_Comparison_Exp>;
  messages?: InputMaybe<Web_Messages_Bool_Exp>;
  messages_aggregate?: InputMaybe<Web_Messages_Aggregate_Bool_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  profile_pic?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "web_contacts" */
export enum Web_Contacts_Constraint {
  /** unique or primary key constraint on columns "id" */
  WebContactsPkey = 'web_contacts_pkey'
}

/** input type for incrementing numeric columns in table "web_contacts" */
export type Web_Contacts_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "web_contacts" */
export type Web_Contacts_Insert_Input = {
  authenticated?: InputMaybe<Scalars['Boolean']>;
  browser_id?: InputMaybe<Scalars['uuid']>;
  browser_session?: InputMaybe<Browser_Sessions_Obj_Rel_Insert_Input>;
  contact_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Web_Messages_Arr_Rel_Insert_Input>;
  phone?: InputMaybe<Scalars['String']>;
  profile_pic?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Web_Contacts_Max_Fields = {
  __typename?: 'web_contacts_max_fields';
  browser_id?: Maybe<Scalars['uuid']>;
  contact_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  keys?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_pic?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Web_Contacts_Min_Fields = {
  __typename?: 'web_contacts_min_fields';
  browser_id?: Maybe<Scalars['uuid']>;
  contact_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  keys?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_pic?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "web_contacts" */
export type Web_Contacts_Mutation_Response = {
  __typename?: 'web_contacts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Web_Contacts>;
};

/** input type for inserting object relation for remote table "web_contacts" */
export type Web_Contacts_Obj_Rel_Insert_Input = {
  data: Web_Contacts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Web_Contacts_On_Conflict>;
};

/** on_conflict condition type for table "web_contacts" */
export type Web_Contacts_On_Conflict = {
  constraint: Web_Contacts_Constraint;
  update_columns?: Array<Web_Contacts_Update_Column>;
  where?: InputMaybe<Web_Contacts_Bool_Exp>;
};

/** Ordering options when selecting data from "web_contacts". */
export type Web_Contacts_Order_By = {
  authenticated?: InputMaybe<Order_By>;
  browser_id?: InputMaybe<Order_By>;
  browser_session?: InputMaybe<Browser_Sessions_Order_By>;
  contact_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  keys?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Web_Messages_Aggregate_Order_By>;
  phone?: InputMaybe<Order_By>;
  profile_pic?: InputMaybe<Order_By>;
};

/** primary key columns input for table: web_contacts */
export type Web_Contacts_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "web_contacts" */
export enum Web_Contacts_Select_Column {
  /** column name */
  Authenticated = 'authenticated',
  /** column name */
  BrowserId = 'browser_id',
  /** column name */
  ContactName = 'contact_name',
  /** column name */
  Id = 'id',
  /** column name */
  Keys = 'keys',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProfilePic = 'profile_pic'
}

/** input type for updating data in table "web_contacts" */
export type Web_Contacts_Set_Input = {
  authenticated?: InputMaybe<Scalars['Boolean']>;
  browser_id?: InputMaybe<Scalars['uuid']>;
  contact_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profile_pic?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Web_Contacts_Stddev_Fields = {
  __typename?: 'web_contacts_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Web_Contacts_Stddev_Pop_Fields = {
  __typename?: 'web_contacts_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Web_Contacts_Stddev_Samp_Fields = {
  __typename?: 'web_contacts_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "web_contacts" */
export type Web_Contacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Web_Contacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Web_Contacts_Stream_Cursor_Value_Input = {
  authenticated?: InputMaybe<Scalars['Boolean']>;
  browser_id?: InputMaybe<Scalars['uuid']>;
  contact_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profile_pic?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Web_Contacts_Sum_Fields = {
  __typename?: 'web_contacts_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "web_contacts" */
export enum Web_Contacts_Update_Column {
  /** column name */
  Authenticated = 'authenticated',
  /** column name */
  BrowserId = 'browser_id',
  /** column name */
  ContactName = 'contact_name',
  /** column name */
  Id = 'id',
  /** column name */
  Keys = 'keys',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProfilePic = 'profile_pic'
}

export type Web_Contacts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Web_Contacts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Web_Contacts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Web_Contacts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Web_Contacts_Var_Pop_Fields = {
  __typename?: 'web_contacts_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Web_Contacts_Var_Samp_Fields = {
  __typename?: 'web_contacts_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Web_Contacts_Variance_Fields = {
  __typename?: 'web_contacts_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "web_messages" */
export type Web_Messages = {
  __typename?: 'web_messages';
  author?: Maybe<Scalars['jsonb']>;
  body?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  /** An object relationship */
  contact?: Maybe<Web_Contacts>;
  contact_id: Scalars['Int'];
  from?: Maybe<Scalars['jsonb']>;
  from_me?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  is_group_msg?: Maybe<Scalars['Boolean']>;
  message_id: Scalars['String'];
  mime_type?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['jsonb']>;
  type?: Maybe<Scalars['String']>;
  unix_timestamp: Scalars['Int'];
};


/** columns and relationships of "web_messages" */
export type Web_MessagesAuthorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "web_messages" */
export type Web_MessagesFromArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "web_messages" */
export type Web_MessagesToArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "web_messages" */
export type Web_Messages_Aggregate = {
  __typename?: 'web_messages_aggregate';
  aggregate?: Maybe<Web_Messages_Aggregate_Fields>;
  nodes: Array<Web_Messages>;
};

export type Web_Messages_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Web_Messages_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Web_Messages_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Web_Messages_Aggregate_Bool_Exp_Count>;
};

export type Web_Messages_Aggregate_Bool_Exp_Bool_And = {
  arguments: Web_Messages_Select_Column_Web_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Web_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Web_Messages_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Web_Messages_Select_Column_Web_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Web_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Web_Messages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Web_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Web_Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "web_messages" */
export type Web_Messages_Aggregate_Fields = {
  __typename?: 'web_messages_aggregate_fields';
  avg?: Maybe<Web_Messages_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Web_Messages_Max_Fields>;
  min?: Maybe<Web_Messages_Min_Fields>;
  stddev?: Maybe<Web_Messages_Stddev_Fields>;
  stddev_pop?: Maybe<Web_Messages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Web_Messages_Stddev_Samp_Fields>;
  sum?: Maybe<Web_Messages_Sum_Fields>;
  var_pop?: Maybe<Web_Messages_Var_Pop_Fields>;
  var_samp?: Maybe<Web_Messages_Var_Samp_Fields>;
  variance?: Maybe<Web_Messages_Variance_Fields>;
};


/** aggregate fields of "web_messages" */
export type Web_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Web_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "web_messages" */
export type Web_Messages_Aggregate_Order_By = {
  avg?: InputMaybe<Web_Messages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Web_Messages_Max_Order_By>;
  min?: InputMaybe<Web_Messages_Min_Order_By>;
  stddev?: InputMaybe<Web_Messages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Web_Messages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Web_Messages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Web_Messages_Sum_Order_By>;
  var_pop?: InputMaybe<Web_Messages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Web_Messages_Var_Samp_Order_By>;
  variance?: InputMaybe<Web_Messages_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Web_Messages_Append_Input = {
  author?: InputMaybe<Scalars['jsonb']>;
  from?: InputMaybe<Scalars['jsonb']>;
  to?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "web_messages" */
export type Web_Messages_Arr_Rel_Insert_Input = {
  data: Array<Web_Messages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Web_Messages_On_Conflict>;
};

/** aggregate avg on columns */
export type Web_Messages_Avg_Fields = {
  __typename?: 'web_messages_avg_fields';
  contact_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "web_messages" */
export type Web_Messages_Avg_Order_By = {
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "web_messages". All fields are combined with a logical 'AND'. */
export type Web_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Web_Messages_Bool_Exp>>;
  _not?: InputMaybe<Web_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Web_Messages_Bool_Exp>>;
  author?: InputMaybe<Jsonb_Comparison_Exp>;
  body?: InputMaybe<String_Comparison_Exp>;
  caption?: InputMaybe<String_Comparison_Exp>;
  contact?: InputMaybe<Web_Contacts_Bool_Exp>;
  contact_id?: InputMaybe<Int_Comparison_Exp>;
  from?: InputMaybe<Jsonb_Comparison_Exp>;
  from_me?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_group_msg?: InputMaybe<Boolean_Comparison_Exp>;
  message_id?: InputMaybe<String_Comparison_Exp>;
  mime_type?: InputMaybe<String_Comparison_Exp>;
  to?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  unix_timestamp?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "web_messages" */
export enum Web_Messages_Constraint {
  /** unique or primary key constraint on columns "contact_id", "message_id" */
  WebMessagesContactIdMessageIdKey = 'web_messages_contact_id_message_id_key',
  /** unique or primary key constraint on columns "id" */
  WebMessagesPkey = 'web_messages_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Web_Messages_Delete_At_Path_Input = {
  author?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Array<Scalars['String']>>;
  to?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Web_Messages_Delete_Elem_Input = {
  author?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Web_Messages_Delete_Key_Input = {
  author?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "web_messages" */
export type Web_Messages_Inc_Input = {
  contact_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  unix_timestamp?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "web_messages" */
export type Web_Messages_Insert_Input = {
  author?: InputMaybe<Scalars['jsonb']>;
  body?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Web_Contacts_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['jsonb']>;
  from_me?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_group_msg?: InputMaybe<Scalars['Boolean']>;
  message_id?: InputMaybe<Scalars['String']>;
  mime_type?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  unix_timestamp?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Web_Messages_Max_Fields = {
  __typename?: 'web_messages_max_fields';
  body?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  contact_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  message_id?: Maybe<Scalars['String']>;
  mime_type?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unix_timestamp?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "web_messages" */
export type Web_Messages_Max_Order_By = {
  body?: InputMaybe<Order_By>;
  caption?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Web_Messages_Min_Fields = {
  __typename?: 'web_messages_min_fields';
  body?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  contact_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  message_id?: Maybe<Scalars['String']>;
  mime_type?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unix_timestamp?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "web_messages" */
export type Web_Messages_Min_Order_By = {
  body?: InputMaybe<Order_By>;
  caption?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "web_messages" */
export type Web_Messages_Mutation_Response = {
  __typename?: 'web_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Web_Messages>;
};

/** on_conflict condition type for table "web_messages" */
export type Web_Messages_On_Conflict = {
  constraint: Web_Messages_Constraint;
  update_columns?: Array<Web_Messages_Update_Column>;
  where?: InputMaybe<Web_Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "web_messages". */
export type Web_Messages_Order_By = {
  author?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  caption?: InputMaybe<Order_By>;
  contact?: InputMaybe<Web_Contacts_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  from_me?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_group_msg?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: web_messages */
export type Web_Messages_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Web_Messages_Prepend_Input = {
  author?: InputMaybe<Scalars['jsonb']>;
  from?: InputMaybe<Scalars['jsonb']>;
  to?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "web_messages" */
export enum Web_Messages_Select_Column {
  /** column name */
  Author = 'author',
  /** column name */
  Body = 'body',
  /** column name */
  Caption = 'caption',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  From = 'from',
  /** column name */
  FromMe = 'from_me',
  /** column name */
  Id = 'id',
  /** column name */
  IsGroupMsg = 'is_group_msg',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  MimeType = 'mime_type',
  /** column name */
  To = 'to',
  /** column name */
  Type = 'type',
  /** column name */
  UnixTimestamp = 'unix_timestamp'
}

/** select "web_messages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "web_messages" */
export enum Web_Messages_Select_Column_Web_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  FromMe = 'from_me',
  /** column name */
  IsGroupMsg = 'is_group_msg'
}

/** select "web_messages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "web_messages" */
export enum Web_Messages_Select_Column_Web_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  FromMe = 'from_me',
  /** column name */
  IsGroupMsg = 'is_group_msg'
}

/** input type for updating data in table "web_messages" */
export type Web_Messages_Set_Input = {
  author?: InputMaybe<Scalars['jsonb']>;
  body?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  contact_id?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['jsonb']>;
  from_me?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_group_msg?: InputMaybe<Scalars['Boolean']>;
  message_id?: InputMaybe<Scalars['String']>;
  mime_type?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  unix_timestamp?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Web_Messages_Stddev_Fields = {
  __typename?: 'web_messages_stddev_fields';
  contact_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "web_messages" */
export type Web_Messages_Stddev_Order_By = {
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Web_Messages_Stddev_Pop_Fields = {
  __typename?: 'web_messages_stddev_pop_fields';
  contact_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "web_messages" */
export type Web_Messages_Stddev_Pop_Order_By = {
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Web_Messages_Stddev_Samp_Fields = {
  __typename?: 'web_messages_stddev_samp_fields';
  contact_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "web_messages" */
export type Web_Messages_Stddev_Samp_Order_By = {
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "web_messages" */
export type Web_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Web_Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Web_Messages_Stream_Cursor_Value_Input = {
  author?: InputMaybe<Scalars['jsonb']>;
  body?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  contact_id?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['jsonb']>;
  from_me?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_group_msg?: InputMaybe<Scalars['Boolean']>;
  message_id?: InputMaybe<Scalars['String']>;
  mime_type?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  unix_timestamp?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Web_Messages_Sum_Fields = {
  __typename?: 'web_messages_sum_fields';
  contact_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  unix_timestamp?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "web_messages" */
export type Web_Messages_Sum_Order_By = {
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** update columns of table "web_messages" */
export enum Web_Messages_Update_Column {
  /** column name */
  Author = 'author',
  /** column name */
  Body = 'body',
  /** column name */
  Caption = 'caption',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  From = 'from',
  /** column name */
  FromMe = 'from_me',
  /** column name */
  Id = 'id',
  /** column name */
  IsGroupMsg = 'is_group_msg',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  MimeType = 'mime_type',
  /** column name */
  To = 'to',
  /** column name */
  Type = 'type',
  /** column name */
  UnixTimestamp = 'unix_timestamp'
}

export type Web_Messages_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Web_Messages_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Web_Messages_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Web_Messages_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Web_Messages_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Web_Messages_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Web_Messages_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Web_Messages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Web_Messages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Web_Messages_Var_Pop_Fields = {
  __typename?: 'web_messages_var_pop_fields';
  contact_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "web_messages" */
export type Web_Messages_Var_Pop_Order_By = {
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Web_Messages_Var_Samp_Fields = {
  __typename?: 'web_messages_var_samp_fields';
  contact_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "web_messages" */
export type Web_Messages_Var_Samp_Order_By = {
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Web_Messages_Variance_Fields = {
  __typename?: 'web_messages_variance_fields';
  contact_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "web_messages" */
export type Web_Messages_Variance_Order_By = {
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** columns and relationships of "web_qr_codes" */
export type Web_Qr_Codes = {
  __typename?: 'web_qr_codes';
  browser_id: Scalars['uuid'];
  /** An object relationship */
  contact?: Maybe<Web_Contacts>;
  id: Scalars['Int'];
  qr_code: Scalars['String'];
  uuid: Scalars['uuid'];
};

/** aggregated selection of "web_qr_codes" */
export type Web_Qr_Codes_Aggregate = {
  __typename?: 'web_qr_codes_aggregate';
  aggregate?: Maybe<Web_Qr_Codes_Aggregate_Fields>;
  nodes: Array<Web_Qr_Codes>;
};

/** aggregate fields of "web_qr_codes" */
export type Web_Qr_Codes_Aggregate_Fields = {
  __typename?: 'web_qr_codes_aggregate_fields';
  avg?: Maybe<Web_Qr_Codes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Web_Qr_Codes_Max_Fields>;
  min?: Maybe<Web_Qr_Codes_Min_Fields>;
  stddev?: Maybe<Web_Qr_Codes_Stddev_Fields>;
  stddev_pop?: Maybe<Web_Qr_Codes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Web_Qr_Codes_Stddev_Samp_Fields>;
  sum?: Maybe<Web_Qr_Codes_Sum_Fields>;
  var_pop?: Maybe<Web_Qr_Codes_Var_Pop_Fields>;
  var_samp?: Maybe<Web_Qr_Codes_Var_Samp_Fields>;
  variance?: Maybe<Web_Qr_Codes_Variance_Fields>;
};


/** aggregate fields of "web_qr_codes" */
export type Web_Qr_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Web_Qr_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Web_Qr_Codes_Avg_Fields = {
  __typename?: 'web_qr_codes_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "web_qr_codes". All fields are combined with a logical 'AND'. */
export type Web_Qr_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Web_Qr_Codes_Bool_Exp>>;
  _not?: InputMaybe<Web_Qr_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Web_Qr_Codes_Bool_Exp>>;
  browser_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact?: InputMaybe<Web_Contacts_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  qr_code?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "web_qr_codes" */
export enum Web_Qr_Codes_Constraint {
  /** unique or primary key constraint on columns "id" */
  WebQrCodesPkey = 'web_qr_codes_pkey',
  /** unique or primary key constraint on columns "uuid", "browser_id" */
  WebQrCodesUuidBrowserIdKey = 'web_qr_codes_uuid_browser_id_key'
}

/** input type for incrementing numeric columns in table "web_qr_codes" */
export type Web_Qr_Codes_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "web_qr_codes" */
export type Web_Qr_Codes_Insert_Input = {
  browser_id?: InputMaybe<Scalars['uuid']>;
  contact?: InputMaybe<Web_Contacts_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  qr_code?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Web_Qr_Codes_Max_Fields = {
  __typename?: 'web_qr_codes_max_fields';
  browser_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  qr_code?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Web_Qr_Codes_Min_Fields = {
  __typename?: 'web_qr_codes_min_fields';
  browser_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  qr_code?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "web_qr_codes" */
export type Web_Qr_Codes_Mutation_Response = {
  __typename?: 'web_qr_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Web_Qr_Codes>;
};

/** on_conflict condition type for table "web_qr_codes" */
export type Web_Qr_Codes_On_Conflict = {
  constraint: Web_Qr_Codes_Constraint;
  update_columns?: Array<Web_Qr_Codes_Update_Column>;
  where?: InputMaybe<Web_Qr_Codes_Bool_Exp>;
};

/** Ordering options when selecting data from "web_qr_codes". */
export type Web_Qr_Codes_Order_By = {
  browser_id?: InputMaybe<Order_By>;
  contact?: InputMaybe<Web_Contacts_Order_By>;
  id?: InputMaybe<Order_By>;
  qr_code?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: web_qr_codes */
export type Web_Qr_Codes_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "web_qr_codes" */
export enum Web_Qr_Codes_Select_Column {
  /** column name */
  BrowserId = 'browser_id',
  /** column name */
  Id = 'id',
  /** column name */
  QrCode = 'qr_code',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "web_qr_codes" */
export type Web_Qr_Codes_Set_Input = {
  browser_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  qr_code?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Web_Qr_Codes_Stddev_Fields = {
  __typename?: 'web_qr_codes_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Web_Qr_Codes_Stddev_Pop_Fields = {
  __typename?: 'web_qr_codes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Web_Qr_Codes_Stddev_Samp_Fields = {
  __typename?: 'web_qr_codes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "web_qr_codes" */
export type Web_Qr_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Web_Qr_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Web_Qr_Codes_Stream_Cursor_Value_Input = {
  browser_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  qr_code?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Web_Qr_Codes_Sum_Fields = {
  __typename?: 'web_qr_codes_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "web_qr_codes" */
export enum Web_Qr_Codes_Update_Column {
  /** column name */
  BrowserId = 'browser_id',
  /** column name */
  Id = 'id',
  /** column name */
  QrCode = 'qr_code',
  /** column name */
  Uuid = 'uuid'
}

export type Web_Qr_Codes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Web_Qr_Codes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Web_Qr_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Web_Qr_Codes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Web_Qr_Codes_Var_Pop_Fields = {
  __typename?: 'web_qr_codes_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Web_Qr_Codes_Var_Samp_Fields = {
  __typename?: 'web_qr_codes_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Web_Qr_Codes_Variance_Fields = {
  __typename?: 'web_qr_codes_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "whatsapp._messageTomessage_update" */
export type Whatsapp__MessageTomessage_Update = {
  __typename?: 'whatsapp__messageTomessage_update';
  A: Scalars['String'];
  B: Scalars['String'];
};

/** aggregated selection of "whatsapp._messageTomessage_update" */
export type Whatsapp__MessageTomessage_Update_Aggregate = {
  __typename?: 'whatsapp__messageTomessage_update_aggregate';
  aggregate?: Maybe<Whatsapp__MessageTomessage_Update_Aggregate_Fields>;
  nodes: Array<Whatsapp__MessageTomessage_Update>;
};

/** aggregate fields of "whatsapp._messageTomessage_update" */
export type Whatsapp__MessageTomessage_Update_Aggregate_Fields = {
  __typename?: 'whatsapp__messageTomessage_update_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Whatsapp__MessageTomessage_Update_Max_Fields>;
  min?: Maybe<Whatsapp__MessageTomessage_Update_Min_Fields>;
};


/** aggregate fields of "whatsapp._messageTomessage_update" */
export type Whatsapp__MessageTomessage_Update_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Whatsapp__MessageTomessage_Update_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "whatsapp._messageTomessage_update". All fields are combined with a logical 'AND'. */
export type Whatsapp__MessageTomessage_Update_Bool_Exp = {
  A?: InputMaybe<String_Comparison_Exp>;
  B?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Whatsapp__MessageTomessage_Update_Bool_Exp>>;
  _not?: InputMaybe<Whatsapp__MessageTomessage_Update_Bool_Exp>;
  _or?: InputMaybe<Array<Whatsapp__MessageTomessage_Update_Bool_Exp>>;
};

/** unique or primary key constraints on table "whatsapp._messageTomessage_update" */
export enum Whatsapp__MessageTomessage_Update_Constraint {
  /** unique or primary key constraint on columns "B", "A" */
  MessageTomessageUpdateAbUnique = '_messageTomessage_update_AB_unique'
}

/** input type for inserting data into table "whatsapp._messageTomessage_update" */
export type Whatsapp__MessageTomessage_Update_Insert_Input = {
  A?: InputMaybe<Scalars['String']>;
  B?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Whatsapp__MessageTomessage_Update_Max_Fields = {
  __typename?: 'whatsapp__messageTomessage_update_max_fields';
  A?: Maybe<Scalars['String']>;
  B?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Whatsapp__MessageTomessage_Update_Min_Fields = {
  __typename?: 'whatsapp__messageTomessage_update_min_fields';
  A?: Maybe<Scalars['String']>;
  B?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "whatsapp._messageTomessage_update" */
export type Whatsapp__MessageTomessage_Update_Mutation_Response = {
  __typename?: 'whatsapp__messageTomessage_update_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Whatsapp__MessageTomessage_Update>;
};

/** on_conflict condition type for table "whatsapp._messageTomessage_update" */
export type Whatsapp__MessageTomessage_Update_On_Conflict = {
  constraint: Whatsapp__MessageTomessage_Update_Constraint;
  update_columns?: Array<Whatsapp__MessageTomessage_Update_Update_Column>;
  where?: InputMaybe<Whatsapp__MessageTomessage_Update_Bool_Exp>;
};

/** Ordering options when selecting data from "whatsapp._messageTomessage_update". */
export type Whatsapp__MessageTomessage_Update_Order_By = {
  A?: InputMaybe<Order_By>;
  B?: InputMaybe<Order_By>;
};

/** select columns of table "whatsapp._messageTomessage_update" */
export enum Whatsapp__MessageTomessage_Update_Select_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

/** input type for updating data in table "whatsapp._messageTomessage_update" */
export type Whatsapp__MessageTomessage_Update_Set_Input = {
  A?: InputMaybe<Scalars['String']>;
  B?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "whatsapp__messageTomessage_update" */
export type Whatsapp__MessageTomessage_Update_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whatsapp__MessageTomessage_Update_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whatsapp__MessageTomessage_Update_Stream_Cursor_Value_Input = {
  A?: InputMaybe<Scalars['String']>;
  B?: InputMaybe<Scalars['String']>;
};

/** update columns of table "whatsapp._messageTomessage_update" */
export enum Whatsapp__MessageTomessage_Update_Update_Column {
  /** column name */
  A = 'A',
  /** column name */
  B = 'B'
}

export type Whatsapp__MessageTomessage_Update_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Whatsapp__MessageTomessage_Update_Set_Input>;
  /** filter the rows which have to be updated */
  where: Whatsapp__MessageTomessage_Update_Bool_Exp;
};

/** columns and relationships of "whatsapp.chat" */
export type Whatsapp_Chat = {
  __typename?: 'whatsapp_chat';
  archive: Scalars['Boolean'];
  contact_phone: Scalars['String'];
  created_at: Scalars['timestamp'];
  id: Scalars['String'];
  mute_timestamp?: Maybe<Scalars['timestamp']>;
  pin_timestamp?: Maybe<Scalars['timestamp']>;
  session_id: Scalars['String'];
  tenant_id: Scalars['String'];
  timestamp: Scalars['timestamp'];
  unread_count: Scalars['Int'];
  updated_at: Scalars['timestamp'];
};

/** aggregated selection of "whatsapp.chat" */
export type Whatsapp_Chat_Aggregate = {
  __typename?: 'whatsapp_chat_aggregate';
  aggregate?: Maybe<Whatsapp_Chat_Aggregate_Fields>;
  nodes: Array<Whatsapp_Chat>;
};

/** aggregate fields of "whatsapp.chat" */
export type Whatsapp_Chat_Aggregate_Fields = {
  __typename?: 'whatsapp_chat_aggregate_fields';
  avg?: Maybe<Whatsapp_Chat_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Whatsapp_Chat_Max_Fields>;
  min?: Maybe<Whatsapp_Chat_Min_Fields>;
  stddev?: Maybe<Whatsapp_Chat_Stddev_Fields>;
  stddev_pop?: Maybe<Whatsapp_Chat_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Whatsapp_Chat_Stddev_Samp_Fields>;
  sum?: Maybe<Whatsapp_Chat_Sum_Fields>;
  var_pop?: Maybe<Whatsapp_Chat_Var_Pop_Fields>;
  var_samp?: Maybe<Whatsapp_Chat_Var_Samp_Fields>;
  variance?: Maybe<Whatsapp_Chat_Variance_Fields>;
};


/** aggregate fields of "whatsapp.chat" */
export type Whatsapp_Chat_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Whatsapp_Chat_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Whatsapp_Chat_Avg_Fields = {
  __typename?: 'whatsapp_chat_avg_fields';
  unread_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "whatsapp.chat". All fields are combined with a logical 'AND'. */
export type Whatsapp_Chat_Bool_Exp = {
  _and?: InputMaybe<Array<Whatsapp_Chat_Bool_Exp>>;
  _not?: InputMaybe<Whatsapp_Chat_Bool_Exp>;
  _or?: InputMaybe<Array<Whatsapp_Chat_Bool_Exp>>;
  archive?: InputMaybe<Boolean_Comparison_Exp>;
  contact_phone?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  mute_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  pin_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  unread_count?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "whatsapp.chat" */
export enum Whatsapp_Chat_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChatIdKey = 'chat_id_key',
  /** unique or primary key constraint on columns "id" */
  ChatPkey = 'chat_pkey'
}

/** input type for incrementing numeric columns in table "whatsapp.chat" */
export type Whatsapp_Chat_Inc_Input = {
  unread_count?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "whatsapp.chat" */
export type Whatsapp_Chat_Insert_Input = {
  archive?: InputMaybe<Scalars['Boolean']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  mute_timestamp?: InputMaybe<Scalars['timestamp']>;
  pin_timestamp?: InputMaybe<Scalars['timestamp']>;
  session_id?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
  unread_count?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Whatsapp_Chat_Max_Fields = {
  __typename?: 'whatsapp_chat_max_fields';
  contact_phone?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  mute_timestamp?: Maybe<Scalars['timestamp']>;
  pin_timestamp?: Maybe<Scalars['timestamp']>;
  session_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamp']>;
  unread_count?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Whatsapp_Chat_Min_Fields = {
  __typename?: 'whatsapp_chat_min_fields';
  contact_phone?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  mute_timestamp?: Maybe<Scalars['timestamp']>;
  pin_timestamp?: Maybe<Scalars['timestamp']>;
  session_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamp']>;
  unread_count?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "whatsapp.chat" */
export type Whatsapp_Chat_Mutation_Response = {
  __typename?: 'whatsapp_chat_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Whatsapp_Chat>;
};

/** on_conflict condition type for table "whatsapp.chat" */
export type Whatsapp_Chat_On_Conflict = {
  constraint: Whatsapp_Chat_Constraint;
  update_columns?: Array<Whatsapp_Chat_Update_Column>;
  where?: InputMaybe<Whatsapp_Chat_Bool_Exp>;
};

/** Ordering options when selecting data from "whatsapp.chat". */
export type Whatsapp_Chat_Order_By = {
  archive?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mute_timestamp?: InputMaybe<Order_By>;
  pin_timestamp?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  unread_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: whatsapp.chat */
export type Whatsapp_Chat_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "whatsapp.chat" */
export enum Whatsapp_Chat_Select_Column {
  /** column name */
  Archive = 'archive',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MuteTimestamp = 'mute_timestamp',
  /** column name */
  PinTimestamp = 'pin_timestamp',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UnreadCount = 'unread_count',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "whatsapp.chat" */
export type Whatsapp_Chat_Set_Input = {
  archive?: InputMaybe<Scalars['Boolean']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  mute_timestamp?: InputMaybe<Scalars['timestamp']>;
  pin_timestamp?: InputMaybe<Scalars['timestamp']>;
  session_id?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
  unread_count?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Whatsapp_Chat_Stddev_Fields = {
  __typename?: 'whatsapp_chat_stddev_fields';
  unread_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Whatsapp_Chat_Stddev_Pop_Fields = {
  __typename?: 'whatsapp_chat_stddev_pop_fields';
  unread_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Whatsapp_Chat_Stddev_Samp_Fields = {
  __typename?: 'whatsapp_chat_stddev_samp_fields';
  unread_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "whatsapp_chat" */
export type Whatsapp_Chat_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whatsapp_Chat_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whatsapp_Chat_Stream_Cursor_Value_Input = {
  archive?: InputMaybe<Scalars['Boolean']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  mute_timestamp?: InputMaybe<Scalars['timestamp']>;
  pin_timestamp?: InputMaybe<Scalars['timestamp']>;
  session_id?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
  unread_count?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Whatsapp_Chat_Sum_Fields = {
  __typename?: 'whatsapp_chat_sum_fields';
  unread_count?: Maybe<Scalars['Int']>;
};

/** update columns of table "whatsapp.chat" */
export enum Whatsapp_Chat_Update_Column {
  /** column name */
  Archive = 'archive',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MuteTimestamp = 'mute_timestamp',
  /** column name */
  PinTimestamp = 'pin_timestamp',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UnreadCount = 'unread_count',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Whatsapp_Chat_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Whatsapp_Chat_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Whatsapp_Chat_Set_Input>;
  /** filter the rows which have to be updated */
  where: Whatsapp_Chat_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Whatsapp_Chat_Var_Pop_Fields = {
  __typename?: 'whatsapp_chat_var_pop_fields';
  unread_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Whatsapp_Chat_Var_Samp_Fields = {
  __typename?: 'whatsapp_chat_var_samp_fields';
  unread_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Whatsapp_Chat_Variance_Fields = {
  __typename?: 'whatsapp_chat_variance_fields';
  unread_count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "whatsapp.contact" */
export type Whatsapp_Contact = {
  __typename?: 'whatsapp_contact';
  created_at: Scalars['timestamp'];
  id: Scalars['String'];
  is_group: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  profile_pic?: Maybe<Scalars['String']>;
  session_id: Scalars['String'];
  tenant_id: Scalars['String'];
  updated_at: Scalars['timestamp'];
};

/** aggregated selection of "whatsapp.contact" */
export type Whatsapp_Contact_Aggregate = {
  __typename?: 'whatsapp_contact_aggregate';
  aggregate?: Maybe<Whatsapp_Contact_Aggregate_Fields>;
  nodes: Array<Whatsapp_Contact>;
};

/** aggregate fields of "whatsapp.contact" */
export type Whatsapp_Contact_Aggregate_Fields = {
  __typename?: 'whatsapp_contact_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Whatsapp_Contact_Max_Fields>;
  min?: Maybe<Whatsapp_Contact_Min_Fields>;
};


/** aggregate fields of "whatsapp.contact" */
export type Whatsapp_Contact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Whatsapp_Contact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "whatsapp.contact". All fields are combined with a logical 'AND'. */
export type Whatsapp_Contact_Bool_Exp = {
  _and?: InputMaybe<Array<Whatsapp_Contact_Bool_Exp>>;
  _not?: InputMaybe<Whatsapp_Contact_Bool_Exp>;
  _or?: InputMaybe<Array<Whatsapp_Contact_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_group?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  profile_pic?: InputMaybe<String_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "whatsapp.contact" */
export enum Whatsapp_Contact_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContactIdKey = 'contact_id_key',
  /** unique or primary key constraint on columns "session_id", "phone" */
  ContactPhoneSessionIdKey = 'contact_phone_session_id_key',
  /** unique or primary key constraint on columns "id" */
  ContactPkey = 'contact_pkey'
}

/** input type for inserting data into table "whatsapp.contact" */
export type Whatsapp_Contact_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  is_group?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profile_pic?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Whatsapp_Contact_Max_Fields = {
  __typename?: 'whatsapp_contact_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_pic?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Whatsapp_Contact_Min_Fields = {
  __typename?: 'whatsapp_contact_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_pic?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "whatsapp.contact" */
export type Whatsapp_Contact_Mutation_Response = {
  __typename?: 'whatsapp_contact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Whatsapp_Contact>;
};

/** on_conflict condition type for table "whatsapp.contact" */
export type Whatsapp_Contact_On_Conflict = {
  constraint: Whatsapp_Contact_Constraint;
  update_columns?: Array<Whatsapp_Contact_Update_Column>;
  where?: InputMaybe<Whatsapp_Contact_Bool_Exp>;
};

/** Ordering options when selecting data from "whatsapp.contact". */
export type Whatsapp_Contact_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_group?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  profile_pic?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: whatsapp.contact */
export type Whatsapp_Contact_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "whatsapp.contact" */
export enum Whatsapp_Contact_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsGroup = 'is_group',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProfilePic = 'profile_pic',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "whatsapp.contact" */
export type Whatsapp_Contact_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  is_group?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profile_pic?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "whatsapp_contact" */
export type Whatsapp_Contact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whatsapp_Contact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whatsapp_Contact_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  is_group?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profile_pic?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "whatsapp.contact" */
export enum Whatsapp_Contact_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsGroup = 'is_group',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProfilePic = 'profile_pic',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Whatsapp_Contact_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Whatsapp_Contact_Set_Input>;
  /** filter the rows which have to be updated */
  where: Whatsapp_Contact_Bool_Exp;
};

/** columns and relationships of "whatsapp.message" */
export type Whatsapp_Message = {
  __typename?: 'whatsapp_message';
  body?: Maybe<Scalars['String']>;
  broadcast?: Maybe<Scalars['Boolean']>;
  caption?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamp'];
  forwarding_score?: Maybe<Scalars['Int']>;
  from: Scalars['String'];
  from_me: Scalars['Boolean'];
  id: Scalars['String'];
  is_forwarded: Scalars['Boolean'];
  is_group: Scalars['Boolean'];
  message_key: Scalars['String'];
  metadata: Scalars['jsonb'];
  participant?: Maybe<Scalars['String']>;
  played_timestamp?: Maybe<Scalars['timestamp']>;
  quote_id?: Maybe<Scalars['String']>;
  read_timestamp?: Maybe<Scalars['timestamp']>;
  receipt_timestamp?: Maybe<Scalars['timestamp']>;
  recipient_timestamp?: Maybe<Scalars['timestamp']>;
  revoked_timestamp?: Maybe<Scalars['timestamp']>;
  sender_timestamp?: Maybe<Scalars['timestamp']>;
  sent_timestamp?: Maybe<Scalars['timestamp']>;
  session_id: Scalars['String'];
  starred?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  tenant_id: Scalars['String'];
  to: Scalars['String'];
  type: Scalars['String'];
  updated_at: Scalars['timestamp'];
};


/** columns and relationships of "whatsapp.message" */
export type Whatsapp_MessageMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "whatsapp.message" */
export type Whatsapp_Message_Aggregate = {
  __typename?: 'whatsapp_message_aggregate';
  aggregate?: Maybe<Whatsapp_Message_Aggregate_Fields>;
  nodes: Array<Whatsapp_Message>;
};

/** aggregate fields of "whatsapp.message" */
export type Whatsapp_Message_Aggregate_Fields = {
  __typename?: 'whatsapp_message_aggregate_fields';
  avg?: Maybe<Whatsapp_Message_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Whatsapp_Message_Max_Fields>;
  min?: Maybe<Whatsapp_Message_Min_Fields>;
  stddev?: Maybe<Whatsapp_Message_Stddev_Fields>;
  stddev_pop?: Maybe<Whatsapp_Message_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Whatsapp_Message_Stddev_Samp_Fields>;
  sum?: Maybe<Whatsapp_Message_Sum_Fields>;
  var_pop?: Maybe<Whatsapp_Message_Var_Pop_Fields>;
  var_samp?: Maybe<Whatsapp_Message_Var_Samp_Fields>;
  variance?: Maybe<Whatsapp_Message_Variance_Fields>;
};


/** aggregate fields of "whatsapp.message" */
export type Whatsapp_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Whatsapp_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Whatsapp_Message_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Whatsapp_Message_Avg_Fields = {
  __typename?: 'whatsapp_message_avg_fields';
  forwarding_score?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "whatsapp.message". All fields are combined with a logical 'AND'. */
export type Whatsapp_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Whatsapp_Message_Bool_Exp>>;
  _not?: InputMaybe<Whatsapp_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Whatsapp_Message_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  broadcast?: InputMaybe<Boolean_Comparison_Exp>;
  caption?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  forwarding_score?: InputMaybe<Int_Comparison_Exp>;
  from?: InputMaybe<String_Comparison_Exp>;
  from_me?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_forwarded?: InputMaybe<Boolean_Comparison_Exp>;
  is_group?: InputMaybe<Boolean_Comparison_Exp>;
  message_key?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  participant?: InputMaybe<String_Comparison_Exp>;
  played_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  quote_id?: InputMaybe<String_Comparison_Exp>;
  read_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  receipt_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  recipient_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  revoked_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  sender_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  sent_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  starred?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  to?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "whatsapp.message" */
export enum Whatsapp_Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessageIdKey = 'message_id_key',
  /** unique or primary key constraint on columns "session_id", "message_key" */
  MessageMessageKeySessionIdKey = 'message_message_key_session_id_key',
  /** unique or primary key constraint on columns "id" */
  MessagePkey = 'message_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Whatsapp_Message_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Whatsapp_Message_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Whatsapp_Message_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "whatsapp.message" */
export type Whatsapp_Message_Inc_Input = {
  forwarding_score?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "whatsapp.message" */
export type Whatsapp_Message_Insert_Input = {
  body?: InputMaybe<Scalars['String']>;
  broadcast?: InputMaybe<Scalars['Boolean']>;
  caption?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  forwarding_score?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  from_me?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  is_forwarded?: InputMaybe<Scalars['Boolean']>;
  is_group?: InputMaybe<Scalars['Boolean']>;
  message_key?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  participant?: InputMaybe<Scalars['String']>;
  played_timestamp?: InputMaybe<Scalars['timestamp']>;
  quote_id?: InputMaybe<Scalars['String']>;
  read_timestamp?: InputMaybe<Scalars['timestamp']>;
  receipt_timestamp?: InputMaybe<Scalars['timestamp']>;
  recipient_timestamp?: InputMaybe<Scalars['timestamp']>;
  revoked_timestamp?: InputMaybe<Scalars['timestamp']>;
  sender_timestamp?: InputMaybe<Scalars['timestamp']>;
  sent_timestamp?: InputMaybe<Scalars['timestamp']>;
  session_id?: InputMaybe<Scalars['String']>;
  starred?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Whatsapp_Message_Max_Fields = {
  __typename?: 'whatsapp_message_max_fields';
  body?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  forwarding_score?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  message_key?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['String']>;
  played_timestamp?: Maybe<Scalars['timestamp']>;
  quote_id?: Maybe<Scalars['String']>;
  read_timestamp?: Maybe<Scalars['timestamp']>;
  receipt_timestamp?: Maybe<Scalars['timestamp']>;
  recipient_timestamp?: Maybe<Scalars['timestamp']>;
  revoked_timestamp?: Maybe<Scalars['timestamp']>;
  sender_timestamp?: Maybe<Scalars['timestamp']>;
  sent_timestamp?: Maybe<Scalars['timestamp']>;
  session_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Whatsapp_Message_Min_Fields = {
  __typename?: 'whatsapp_message_min_fields';
  body?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  forwarding_score?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  message_key?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['String']>;
  played_timestamp?: Maybe<Scalars['timestamp']>;
  quote_id?: Maybe<Scalars['String']>;
  read_timestamp?: Maybe<Scalars['timestamp']>;
  receipt_timestamp?: Maybe<Scalars['timestamp']>;
  recipient_timestamp?: Maybe<Scalars['timestamp']>;
  revoked_timestamp?: Maybe<Scalars['timestamp']>;
  sender_timestamp?: Maybe<Scalars['timestamp']>;
  sent_timestamp?: Maybe<Scalars['timestamp']>;
  session_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "whatsapp.message" */
export type Whatsapp_Message_Mutation_Response = {
  __typename?: 'whatsapp_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Whatsapp_Message>;
};

/** on_conflict condition type for table "whatsapp.message" */
export type Whatsapp_Message_On_Conflict = {
  constraint: Whatsapp_Message_Constraint;
  update_columns?: Array<Whatsapp_Message_Update_Column>;
  where?: InputMaybe<Whatsapp_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "whatsapp.message". */
export type Whatsapp_Message_Order_By = {
  body?: InputMaybe<Order_By>;
  broadcast?: InputMaybe<Order_By>;
  caption?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  forwarding_score?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  from_me?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_forwarded?: InputMaybe<Order_By>;
  is_group?: InputMaybe<Order_By>;
  message_key?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  participant?: InputMaybe<Order_By>;
  played_timestamp?: InputMaybe<Order_By>;
  quote_id?: InputMaybe<Order_By>;
  read_timestamp?: InputMaybe<Order_By>;
  receipt_timestamp?: InputMaybe<Order_By>;
  recipient_timestamp?: InputMaybe<Order_By>;
  revoked_timestamp?: InputMaybe<Order_By>;
  sender_timestamp?: InputMaybe<Order_By>;
  sent_timestamp?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  starred?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: whatsapp.message */
export type Whatsapp_Message_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Whatsapp_Message_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "whatsapp.message" */
export enum Whatsapp_Message_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Broadcast = 'broadcast',
  /** column name */
  Caption = 'caption',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ForwardingScore = 'forwarding_score',
  /** column name */
  From = 'from',
  /** column name */
  FromMe = 'from_me',
  /** column name */
  Id = 'id',
  /** column name */
  IsForwarded = 'is_forwarded',
  /** column name */
  IsGroup = 'is_group',
  /** column name */
  MessageKey = 'message_key',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Participant = 'participant',
  /** column name */
  PlayedTimestamp = 'played_timestamp',
  /** column name */
  QuoteId = 'quote_id',
  /** column name */
  ReadTimestamp = 'read_timestamp',
  /** column name */
  ReceiptTimestamp = 'receipt_timestamp',
  /** column name */
  RecipientTimestamp = 'recipient_timestamp',
  /** column name */
  RevokedTimestamp = 'revoked_timestamp',
  /** column name */
  SenderTimestamp = 'sender_timestamp',
  /** column name */
  SentTimestamp = 'sent_timestamp',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Starred = 'starred',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  To = 'to',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "whatsapp.message" */
export type Whatsapp_Message_Set_Input = {
  body?: InputMaybe<Scalars['String']>;
  broadcast?: InputMaybe<Scalars['Boolean']>;
  caption?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  forwarding_score?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  from_me?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  is_forwarded?: InputMaybe<Scalars['Boolean']>;
  is_group?: InputMaybe<Scalars['Boolean']>;
  message_key?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  participant?: InputMaybe<Scalars['String']>;
  played_timestamp?: InputMaybe<Scalars['timestamp']>;
  quote_id?: InputMaybe<Scalars['String']>;
  read_timestamp?: InputMaybe<Scalars['timestamp']>;
  receipt_timestamp?: InputMaybe<Scalars['timestamp']>;
  recipient_timestamp?: InputMaybe<Scalars['timestamp']>;
  revoked_timestamp?: InputMaybe<Scalars['timestamp']>;
  sender_timestamp?: InputMaybe<Scalars['timestamp']>;
  sent_timestamp?: InputMaybe<Scalars['timestamp']>;
  session_id?: InputMaybe<Scalars['String']>;
  starred?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Whatsapp_Message_Stddev_Fields = {
  __typename?: 'whatsapp_message_stddev_fields';
  forwarding_score?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Whatsapp_Message_Stddev_Pop_Fields = {
  __typename?: 'whatsapp_message_stddev_pop_fields';
  forwarding_score?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Whatsapp_Message_Stddev_Samp_Fields = {
  __typename?: 'whatsapp_message_stddev_samp_fields';
  forwarding_score?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "whatsapp_message" */
export type Whatsapp_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whatsapp_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whatsapp_Message_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']>;
  broadcast?: InputMaybe<Scalars['Boolean']>;
  caption?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  forwarding_score?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  from_me?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  is_forwarded?: InputMaybe<Scalars['Boolean']>;
  is_group?: InputMaybe<Scalars['Boolean']>;
  message_key?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  participant?: InputMaybe<Scalars['String']>;
  played_timestamp?: InputMaybe<Scalars['timestamp']>;
  quote_id?: InputMaybe<Scalars['String']>;
  read_timestamp?: InputMaybe<Scalars['timestamp']>;
  receipt_timestamp?: InputMaybe<Scalars['timestamp']>;
  recipient_timestamp?: InputMaybe<Scalars['timestamp']>;
  revoked_timestamp?: InputMaybe<Scalars['timestamp']>;
  sender_timestamp?: InputMaybe<Scalars['timestamp']>;
  sent_timestamp?: InputMaybe<Scalars['timestamp']>;
  session_id?: InputMaybe<Scalars['String']>;
  starred?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Whatsapp_Message_Sum_Fields = {
  __typename?: 'whatsapp_message_sum_fields';
  forwarding_score?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "whatsapp.message_update" */
export type Whatsapp_Message_Update = {
  __typename?: 'whatsapp_message_update';
  contact_phone: Scalars['String'];
  created_at: Scalars['timestamp'];
  id: Scalars['String'];
  message_key: Scalars['String'];
  session_id: Scalars['String'];
  status: Scalars['String'];
  tenant_id: Scalars['String'];
  timestamp: Scalars['timestamp'];
  updated_at: Scalars['timestamp'];
};

/** aggregated selection of "whatsapp.message_update" */
export type Whatsapp_Message_Update_Aggregate = {
  __typename?: 'whatsapp_message_update_aggregate';
  aggregate?: Maybe<Whatsapp_Message_Update_Aggregate_Fields>;
  nodes: Array<Whatsapp_Message_Update>;
};

/** aggregate fields of "whatsapp.message_update" */
export type Whatsapp_Message_Update_Aggregate_Fields = {
  __typename?: 'whatsapp_message_update_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Whatsapp_Message_Update_Max_Fields>;
  min?: Maybe<Whatsapp_Message_Update_Min_Fields>;
};


/** aggregate fields of "whatsapp.message_update" */
export type Whatsapp_Message_Update_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Whatsapp_Message_Update_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "whatsapp.message_update". All fields are combined with a logical 'AND'. */
export type Whatsapp_Message_Update_Bool_Exp = {
  _and?: InputMaybe<Array<Whatsapp_Message_Update_Bool_Exp>>;
  _not?: InputMaybe<Whatsapp_Message_Update_Bool_Exp>;
  _or?: InputMaybe<Array<Whatsapp_Message_Update_Bool_Exp>>;
  contact_phone?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  message_key?: InputMaybe<String_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** update columns of table "whatsapp.message" */
export enum Whatsapp_Message_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Broadcast = 'broadcast',
  /** column name */
  Caption = 'caption',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ForwardingScore = 'forwarding_score',
  /** column name */
  From = 'from',
  /** column name */
  FromMe = 'from_me',
  /** column name */
  Id = 'id',
  /** column name */
  IsForwarded = 'is_forwarded',
  /** column name */
  IsGroup = 'is_group',
  /** column name */
  MessageKey = 'message_key',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Participant = 'participant',
  /** column name */
  PlayedTimestamp = 'played_timestamp',
  /** column name */
  QuoteId = 'quote_id',
  /** column name */
  ReadTimestamp = 'read_timestamp',
  /** column name */
  ReceiptTimestamp = 'receipt_timestamp',
  /** column name */
  RecipientTimestamp = 'recipient_timestamp',
  /** column name */
  RevokedTimestamp = 'revoked_timestamp',
  /** column name */
  SenderTimestamp = 'sender_timestamp',
  /** column name */
  SentTimestamp = 'sent_timestamp',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Starred = 'starred',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  To = 'to',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** unique or primary key constraints on table "whatsapp.message_update" */
export enum Whatsapp_Message_Update_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessageUpdateIdKey = 'message_update_id_key',
  /** unique or primary key constraint on columns "id" */
  MessageUpdatePkey = 'message_update_pkey'
}

/** input type for inserting data into table "whatsapp.message_update" */
export type Whatsapp_Message_Update_Insert_Input = {
  contact_phone?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  message_key?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Whatsapp_Message_Update_Max_Fields = {
  __typename?: 'whatsapp_message_update_max_fields';
  contact_phone?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  message_key?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamp']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Whatsapp_Message_Update_Min_Fields = {
  __typename?: 'whatsapp_message_update_min_fields';
  contact_phone?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  message_key?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamp']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "whatsapp.message_update" */
export type Whatsapp_Message_Update_Mutation_Response = {
  __typename?: 'whatsapp_message_update_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Whatsapp_Message_Update>;
};

/** on_conflict condition type for table "whatsapp.message_update" */
export type Whatsapp_Message_Update_On_Conflict = {
  constraint: Whatsapp_Message_Update_Constraint;
  update_columns?: Array<Whatsapp_Message_Update_Update_Column>;
  where?: InputMaybe<Whatsapp_Message_Update_Bool_Exp>;
};

/** Ordering options when selecting data from "whatsapp.message_update". */
export type Whatsapp_Message_Update_Order_By = {
  contact_phone?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_key?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: whatsapp.message_update */
export type Whatsapp_Message_Update_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "whatsapp.message_update" */
export enum Whatsapp_Message_Update_Select_Column {
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MessageKey = 'message_key',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "whatsapp.message_update" */
export type Whatsapp_Message_Update_Set_Input = {
  contact_phone?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  message_key?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "whatsapp_message_update" */
export type Whatsapp_Message_Update_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whatsapp_Message_Update_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whatsapp_Message_Update_Stream_Cursor_Value_Input = {
  contact_phone?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  message_key?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "whatsapp.message_update" */
export enum Whatsapp_Message_Update_Update_Column {
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MessageKey = 'message_key',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Whatsapp_Message_Update_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Whatsapp_Message_Update_Set_Input>;
  /** filter the rows which have to be updated */
  where: Whatsapp_Message_Update_Bool_Exp;
};

export type Whatsapp_Message_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Whatsapp_Message_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Whatsapp_Message_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Whatsapp_Message_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Whatsapp_Message_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Whatsapp_Message_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Whatsapp_Message_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Whatsapp_Message_Set_Input>;
  /** filter the rows which have to be updated */
  where: Whatsapp_Message_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Whatsapp_Message_Var_Pop_Fields = {
  __typename?: 'whatsapp_message_var_pop_fields';
  forwarding_score?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Whatsapp_Message_Var_Samp_Fields = {
  __typename?: 'whatsapp_message_var_samp_fields';
  forwarding_score?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Whatsapp_Message_Variance_Fields = {
  __typename?: 'whatsapp_message_variance_fields';
  forwarding_score?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "whatsapp.session" */
export type Whatsapp_Session = {
  __typename?: 'whatsapp_session';
  created_at: Scalars['timestamp'];
  id: Scalars['String'];
  is_multi_device?: Maybe<Scalars['Boolean']>;
  last_reconnect_attempt?: Maybe<Scalars['timestamp']>;
  phone: Scalars['String'];
  qr_code?: Maybe<Scalars['String']>;
  qr_code_timestamp?: Maybe<Scalars['timestamp']>;
  reconnect_attempts?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  tenant_id: Scalars['String'];
  updated_at: Scalars['timestamp'];
  uuid: Scalars['uuid'];
};

/** aggregated selection of "whatsapp.session" */
export type Whatsapp_Session_Aggregate = {
  __typename?: 'whatsapp_session_aggregate';
  aggregate?: Maybe<Whatsapp_Session_Aggregate_Fields>;
  nodes: Array<Whatsapp_Session>;
};

/** aggregate fields of "whatsapp.session" */
export type Whatsapp_Session_Aggregate_Fields = {
  __typename?: 'whatsapp_session_aggregate_fields';
  avg?: Maybe<Whatsapp_Session_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Whatsapp_Session_Max_Fields>;
  min?: Maybe<Whatsapp_Session_Min_Fields>;
  stddev?: Maybe<Whatsapp_Session_Stddev_Fields>;
  stddev_pop?: Maybe<Whatsapp_Session_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Whatsapp_Session_Stddev_Samp_Fields>;
  sum?: Maybe<Whatsapp_Session_Sum_Fields>;
  var_pop?: Maybe<Whatsapp_Session_Var_Pop_Fields>;
  var_samp?: Maybe<Whatsapp_Session_Var_Samp_Fields>;
  variance?: Maybe<Whatsapp_Session_Variance_Fields>;
};


/** aggregate fields of "whatsapp.session" */
export type Whatsapp_Session_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Whatsapp_Session_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Whatsapp_Session_Avg_Fields = {
  __typename?: 'whatsapp_session_avg_fields';
  reconnect_attempts?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "whatsapp.session". All fields are combined with a logical 'AND'. */
export type Whatsapp_Session_Bool_Exp = {
  _and?: InputMaybe<Array<Whatsapp_Session_Bool_Exp>>;
  _not?: InputMaybe<Whatsapp_Session_Bool_Exp>;
  _or?: InputMaybe<Array<Whatsapp_Session_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_multi_device?: InputMaybe<Boolean_Comparison_Exp>;
  last_reconnect_attempt?: InputMaybe<Timestamp_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  qr_code?: InputMaybe<String_Comparison_Exp>;
  qr_code_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  reconnect_attempts?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "whatsapp.session" */
export enum Whatsapp_Session_Constraint {
  /** unique or primary key constraint on columns "id" */
  SessionIdKey = 'session_id_key',
  /** unique or primary key constraint on columns "phone" */
  SessionPhoneKey = 'session_phone_key',
  /** unique or primary key constraint on columns "id" */
  SessionPkey = 'session_pkey',
  /** unique or primary key constraint on columns "uuid" */
  SessionUuidKey = 'session_uuid_key'
}

/** columns and relationships of "whatsapp.session_credential" */
export type Whatsapp_Session_Credential = {
  __typename?: 'whatsapp_session_credential';
  created_at: Scalars['timestamp'];
  credentials: Scalars['jsonb'];
  id: Scalars['String'];
  session_id: Scalars['String'];
  tenant_id: Scalars['String'];
  updated_at: Scalars['timestamp'];
};


/** columns and relationships of "whatsapp.session_credential" */
export type Whatsapp_Session_CredentialCredentialsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "whatsapp.session_credential" */
export type Whatsapp_Session_Credential_Aggregate = {
  __typename?: 'whatsapp_session_credential_aggregate';
  aggregate?: Maybe<Whatsapp_Session_Credential_Aggregate_Fields>;
  nodes: Array<Whatsapp_Session_Credential>;
};

/** aggregate fields of "whatsapp.session_credential" */
export type Whatsapp_Session_Credential_Aggregate_Fields = {
  __typename?: 'whatsapp_session_credential_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Whatsapp_Session_Credential_Max_Fields>;
  min?: Maybe<Whatsapp_Session_Credential_Min_Fields>;
};


/** aggregate fields of "whatsapp.session_credential" */
export type Whatsapp_Session_Credential_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Whatsapp_Session_Credential_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Whatsapp_Session_Credential_Append_Input = {
  credentials?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "whatsapp.session_credential". All fields are combined with a logical 'AND'. */
export type Whatsapp_Session_Credential_Bool_Exp = {
  _and?: InputMaybe<Array<Whatsapp_Session_Credential_Bool_Exp>>;
  _not?: InputMaybe<Whatsapp_Session_Credential_Bool_Exp>;
  _or?: InputMaybe<Array<Whatsapp_Session_Credential_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  credentials?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "whatsapp.session_credential" */
export enum Whatsapp_Session_Credential_Constraint {
  /** unique or primary key constraint on columns "id" */
  SessionCredentialIdKey = 'session_credential_id_key',
  /** unique or primary key constraint on columns "id" */
  SessionCredentialPkey = 'session_credential_pkey',
  /** unique or primary key constraint on columns "session_id" */
  SessionCredentialSessionIdKey = 'session_credential_session_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Whatsapp_Session_Credential_Delete_At_Path_Input = {
  credentials?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Whatsapp_Session_Credential_Delete_Elem_Input = {
  credentials?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Whatsapp_Session_Credential_Delete_Key_Input = {
  credentials?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "whatsapp.session_credential" */
export type Whatsapp_Session_Credential_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  credentials?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Whatsapp_Session_Credential_Max_Fields = {
  __typename?: 'whatsapp_session_credential_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Whatsapp_Session_Credential_Min_Fields = {
  __typename?: 'whatsapp_session_credential_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "whatsapp.session_credential" */
export type Whatsapp_Session_Credential_Mutation_Response = {
  __typename?: 'whatsapp_session_credential_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Whatsapp_Session_Credential>;
};

/** on_conflict condition type for table "whatsapp.session_credential" */
export type Whatsapp_Session_Credential_On_Conflict = {
  constraint: Whatsapp_Session_Credential_Constraint;
  update_columns?: Array<Whatsapp_Session_Credential_Update_Column>;
  where?: InputMaybe<Whatsapp_Session_Credential_Bool_Exp>;
};

/** Ordering options when selecting data from "whatsapp.session_credential". */
export type Whatsapp_Session_Credential_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credentials?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: whatsapp.session_credential */
export type Whatsapp_Session_Credential_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Whatsapp_Session_Credential_Prepend_Input = {
  credentials?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "whatsapp.session_credential" */
export enum Whatsapp_Session_Credential_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credentials = 'credentials',
  /** column name */
  Id = 'id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "whatsapp.session_credential" */
export type Whatsapp_Session_Credential_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  credentials?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "whatsapp_session_credential" */
export type Whatsapp_Session_Credential_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whatsapp_Session_Credential_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whatsapp_Session_Credential_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  credentials?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "whatsapp.session_credential" */
export enum Whatsapp_Session_Credential_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credentials = 'credentials',
  /** column name */
  Id = 'id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Whatsapp_Session_Credential_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Whatsapp_Session_Credential_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Whatsapp_Session_Credential_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Whatsapp_Session_Credential_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Whatsapp_Session_Credential_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Whatsapp_Session_Credential_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Whatsapp_Session_Credential_Set_Input>;
  /** filter the rows which have to be updated */
  where: Whatsapp_Session_Credential_Bool_Exp;
};

/** columns and relationships of "whatsapp.session_history_sync" */
export type Whatsapp_Session_History_Sync = {
  __typename?: 'whatsapp_session_history_sync';
  created_at: Scalars['timestamp'];
  finished_at?: Maybe<Scalars['timestamp']>;
  id: Scalars['String'];
  progress_chats?: Maybe<Scalars['Int']>;
  progress_contacts?: Maybe<Scalars['Int']>;
  progress_messages?: Maybe<Scalars['Int']>;
  session_id: Scalars['String'];
  total_chats?: Maybe<Scalars['Int']>;
  total_contacts?: Maybe<Scalars['Int']>;
  total_messages?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamp'];
};

/** aggregated selection of "whatsapp.session_history_sync" */
export type Whatsapp_Session_History_Sync_Aggregate = {
  __typename?: 'whatsapp_session_history_sync_aggregate';
  aggregate?: Maybe<Whatsapp_Session_History_Sync_Aggregate_Fields>;
  nodes: Array<Whatsapp_Session_History_Sync>;
};

/** aggregate fields of "whatsapp.session_history_sync" */
export type Whatsapp_Session_History_Sync_Aggregate_Fields = {
  __typename?: 'whatsapp_session_history_sync_aggregate_fields';
  avg?: Maybe<Whatsapp_Session_History_Sync_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Whatsapp_Session_History_Sync_Max_Fields>;
  min?: Maybe<Whatsapp_Session_History_Sync_Min_Fields>;
  stddev?: Maybe<Whatsapp_Session_History_Sync_Stddev_Fields>;
  stddev_pop?: Maybe<Whatsapp_Session_History_Sync_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Whatsapp_Session_History_Sync_Stddev_Samp_Fields>;
  sum?: Maybe<Whatsapp_Session_History_Sync_Sum_Fields>;
  var_pop?: Maybe<Whatsapp_Session_History_Sync_Var_Pop_Fields>;
  var_samp?: Maybe<Whatsapp_Session_History_Sync_Var_Samp_Fields>;
  variance?: Maybe<Whatsapp_Session_History_Sync_Variance_Fields>;
};


/** aggregate fields of "whatsapp.session_history_sync" */
export type Whatsapp_Session_History_Sync_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Whatsapp_Session_History_Sync_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Whatsapp_Session_History_Sync_Avg_Fields = {
  __typename?: 'whatsapp_session_history_sync_avg_fields';
  progress_chats?: Maybe<Scalars['Float']>;
  progress_contacts?: Maybe<Scalars['Float']>;
  progress_messages?: Maybe<Scalars['Float']>;
  total_chats?: Maybe<Scalars['Float']>;
  total_contacts?: Maybe<Scalars['Float']>;
  total_messages?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "whatsapp.session_history_sync". All fields are combined with a logical 'AND'. */
export type Whatsapp_Session_History_Sync_Bool_Exp = {
  _and?: InputMaybe<Array<Whatsapp_Session_History_Sync_Bool_Exp>>;
  _not?: InputMaybe<Whatsapp_Session_History_Sync_Bool_Exp>;
  _or?: InputMaybe<Array<Whatsapp_Session_History_Sync_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  finished_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  progress_chats?: InputMaybe<Int_Comparison_Exp>;
  progress_contacts?: InputMaybe<Int_Comparison_Exp>;
  progress_messages?: InputMaybe<Int_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  total_chats?: InputMaybe<Int_Comparison_Exp>;
  total_contacts?: InputMaybe<Int_Comparison_Exp>;
  total_messages?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "whatsapp.session_history_sync" */
export enum Whatsapp_Session_History_Sync_Constraint {
  /** unique or primary key constraint on columns "id" */
  SessionHistorySyncIdKey = 'session_history_sync_id_key',
  /** unique or primary key constraint on columns "session_id", "id" */
  SessionHistorySyncIdSessionIdKey = 'session_history_sync_id_session_id_key',
  /** unique or primary key constraint on columns "id" */
  SessionHistorySyncPkey = 'session_history_sync_pkey'
}

/** input type for incrementing numeric columns in table "whatsapp.session_history_sync" */
export type Whatsapp_Session_History_Sync_Inc_Input = {
  progress_chats?: InputMaybe<Scalars['Int']>;
  progress_contacts?: InputMaybe<Scalars['Int']>;
  progress_messages?: InputMaybe<Scalars['Int']>;
  total_chats?: InputMaybe<Scalars['Int']>;
  total_contacts?: InputMaybe<Scalars['Int']>;
  total_messages?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "whatsapp.session_history_sync" */
export type Whatsapp_Session_History_Sync_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  finished_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  progress_chats?: InputMaybe<Scalars['Int']>;
  progress_contacts?: InputMaybe<Scalars['Int']>;
  progress_messages?: InputMaybe<Scalars['Int']>;
  session_id?: InputMaybe<Scalars['String']>;
  total_chats?: InputMaybe<Scalars['Int']>;
  total_contacts?: InputMaybe<Scalars['Int']>;
  total_messages?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Whatsapp_Session_History_Sync_Max_Fields = {
  __typename?: 'whatsapp_session_history_sync_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  finished_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  progress_chats?: Maybe<Scalars['Int']>;
  progress_contacts?: Maybe<Scalars['Int']>;
  progress_messages?: Maybe<Scalars['Int']>;
  session_id?: Maybe<Scalars['String']>;
  total_chats?: Maybe<Scalars['Int']>;
  total_contacts?: Maybe<Scalars['Int']>;
  total_messages?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Whatsapp_Session_History_Sync_Min_Fields = {
  __typename?: 'whatsapp_session_history_sync_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  finished_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  progress_chats?: Maybe<Scalars['Int']>;
  progress_contacts?: Maybe<Scalars['Int']>;
  progress_messages?: Maybe<Scalars['Int']>;
  session_id?: Maybe<Scalars['String']>;
  total_chats?: Maybe<Scalars['Int']>;
  total_contacts?: Maybe<Scalars['Int']>;
  total_messages?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "whatsapp.session_history_sync" */
export type Whatsapp_Session_History_Sync_Mutation_Response = {
  __typename?: 'whatsapp_session_history_sync_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Whatsapp_Session_History_Sync>;
};

/** on_conflict condition type for table "whatsapp.session_history_sync" */
export type Whatsapp_Session_History_Sync_On_Conflict = {
  constraint: Whatsapp_Session_History_Sync_Constraint;
  update_columns?: Array<Whatsapp_Session_History_Sync_Update_Column>;
  where?: InputMaybe<Whatsapp_Session_History_Sync_Bool_Exp>;
};

/** Ordering options when selecting data from "whatsapp.session_history_sync". */
export type Whatsapp_Session_History_Sync_Order_By = {
  created_at?: InputMaybe<Order_By>;
  finished_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  progress_chats?: InputMaybe<Order_By>;
  progress_contacts?: InputMaybe<Order_By>;
  progress_messages?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  total_chats?: InputMaybe<Order_By>;
  total_contacts?: InputMaybe<Order_By>;
  total_messages?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: whatsapp.session_history_sync */
export type Whatsapp_Session_History_Sync_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "whatsapp.session_history_sync" */
export enum Whatsapp_Session_History_Sync_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FinishedAt = 'finished_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProgressChats = 'progress_chats',
  /** column name */
  ProgressContacts = 'progress_contacts',
  /** column name */
  ProgressMessages = 'progress_messages',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TotalChats = 'total_chats',
  /** column name */
  TotalContacts = 'total_contacts',
  /** column name */
  TotalMessages = 'total_messages',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "whatsapp.session_history_sync" */
export type Whatsapp_Session_History_Sync_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  finished_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  progress_chats?: InputMaybe<Scalars['Int']>;
  progress_contacts?: InputMaybe<Scalars['Int']>;
  progress_messages?: InputMaybe<Scalars['Int']>;
  session_id?: InputMaybe<Scalars['String']>;
  total_chats?: InputMaybe<Scalars['Int']>;
  total_contacts?: InputMaybe<Scalars['Int']>;
  total_messages?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Whatsapp_Session_History_Sync_Stddev_Fields = {
  __typename?: 'whatsapp_session_history_sync_stddev_fields';
  progress_chats?: Maybe<Scalars['Float']>;
  progress_contacts?: Maybe<Scalars['Float']>;
  progress_messages?: Maybe<Scalars['Float']>;
  total_chats?: Maybe<Scalars['Float']>;
  total_contacts?: Maybe<Scalars['Float']>;
  total_messages?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Whatsapp_Session_History_Sync_Stddev_Pop_Fields = {
  __typename?: 'whatsapp_session_history_sync_stddev_pop_fields';
  progress_chats?: Maybe<Scalars['Float']>;
  progress_contacts?: Maybe<Scalars['Float']>;
  progress_messages?: Maybe<Scalars['Float']>;
  total_chats?: Maybe<Scalars['Float']>;
  total_contacts?: Maybe<Scalars['Float']>;
  total_messages?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Whatsapp_Session_History_Sync_Stddev_Samp_Fields = {
  __typename?: 'whatsapp_session_history_sync_stddev_samp_fields';
  progress_chats?: Maybe<Scalars['Float']>;
  progress_contacts?: Maybe<Scalars['Float']>;
  progress_messages?: Maybe<Scalars['Float']>;
  total_chats?: Maybe<Scalars['Float']>;
  total_contacts?: Maybe<Scalars['Float']>;
  total_messages?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "whatsapp_session_history_sync" */
export type Whatsapp_Session_History_Sync_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whatsapp_Session_History_Sync_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whatsapp_Session_History_Sync_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  finished_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  progress_chats?: InputMaybe<Scalars['Int']>;
  progress_contacts?: InputMaybe<Scalars['Int']>;
  progress_messages?: InputMaybe<Scalars['Int']>;
  session_id?: InputMaybe<Scalars['String']>;
  total_chats?: InputMaybe<Scalars['Int']>;
  total_contacts?: InputMaybe<Scalars['Int']>;
  total_messages?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Whatsapp_Session_History_Sync_Sum_Fields = {
  __typename?: 'whatsapp_session_history_sync_sum_fields';
  progress_chats?: Maybe<Scalars['Int']>;
  progress_contacts?: Maybe<Scalars['Int']>;
  progress_messages?: Maybe<Scalars['Int']>;
  total_chats?: Maybe<Scalars['Int']>;
  total_contacts?: Maybe<Scalars['Int']>;
  total_messages?: Maybe<Scalars['Int']>;
};

/** update columns of table "whatsapp.session_history_sync" */
export enum Whatsapp_Session_History_Sync_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FinishedAt = 'finished_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProgressChats = 'progress_chats',
  /** column name */
  ProgressContacts = 'progress_contacts',
  /** column name */
  ProgressMessages = 'progress_messages',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TotalChats = 'total_chats',
  /** column name */
  TotalContacts = 'total_contacts',
  /** column name */
  TotalMessages = 'total_messages',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Whatsapp_Session_History_Sync_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Whatsapp_Session_History_Sync_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Whatsapp_Session_History_Sync_Set_Input>;
  /** filter the rows which have to be updated */
  where: Whatsapp_Session_History_Sync_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Whatsapp_Session_History_Sync_Var_Pop_Fields = {
  __typename?: 'whatsapp_session_history_sync_var_pop_fields';
  progress_chats?: Maybe<Scalars['Float']>;
  progress_contacts?: Maybe<Scalars['Float']>;
  progress_messages?: Maybe<Scalars['Float']>;
  total_chats?: Maybe<Scalars['Float']>;
  total_contacts?: Maybe<Scalars['Float']>;
  total_messages?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Whatsapp_Session_History_Sync_Var_Samp_Fields = {
  __typename?: 'whatsapp_session_history_sync_var_samp_fields';
  progress_chats?: Maybe<Scalars['Float']>;
  progress_contacts?: Maybe<Scalars['Float']>;
  progress_messages?: Maybe<Scalars['Float']>;
  total_chats?: Maybe<Scalars['Float']>;
  total_contacts?: Maybe<Scalars['Float']>;
  total_messages?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Whatsapp_Session_History_Sync_Variance_Fields = {
  __typename?: 'whatsapp_session_history_sync_variance_fields';
  progress_chats?: Maybe<Scalars['Float']>;
  progress_contacts?: Maybe<Scalars['Float']>;
  progress_messages?: Maybe<Scalars['Float']>;
  total_chats?: Maybe<Scalars['Float']>;
  total_contacts?: Maybe<Scalars['Float']>;
  total_messages?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "whatsapp.session" */
export type Whatsapp_Session_Inc_Input = {
  reconnect_attempts?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "whatsapp.session" */
export type Whatsapp_Session_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  is_multi_device?: InputMaybe<Scalars['Boolean']>;
  last_reconnect_attempt?: InputMaybe<Scalars['timestamp']>;
  phone?: InputMaybe<Scalars['String']>;
  qr_code?: InputMaybe<Scalars['String']>;
  qr_code_timestamp?: InputMaybe<Scalars['timestamp']>;
  reconnect_attempts?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "whatsapp.session_key" */
export type Whatsapp_Session_Key = {
  __typename?: 'whatsapp_session_key';
  created_at: Scalars['timestamp'];
  id: Scalars['String'];
  session_id: Scalars['String'];
  signal_data?: Maybe<Scalars['jsonb']>;
  signal_id: Scalars['String'];
  signal_type: Scalars['String'];
  tenant_id: Scalars['String'];
  updated_at: Scalars['timestamp'];
};


/** columns and relationships of "whatsapp.session_key" */
export type Whatsapp_Session_KeySignal_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "whatsapp.session_key" */
export type Whatsapp_Session_Key_Aggregate = {
  __typename?: 'whatsapp_session_key_aggregate';
  aggregate?: Maybe<Whatsapp_Session_Key_Aggregate_Fields>;
  nodes: Array<Whatsapp_Session_Key>;
};

/** aggregate fields of "whatsapp.session_key" */
export type Whatsapp_Session_Key_Aggregate_Fields = {
  __typename?: 'whatsapp_session_key_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Whatsapp_Session_Key_Max_Fields>;
  min?: Maybe<Whatsapp_Session_Key_Min_Fields>;
};


/** aggregate fields of "whatsapp.session_key" */
export type Whatsapp_Session_Key_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Whatsapp_Session_Key_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Whatsapp_Session_Key_Append_Input = {
  signal_data?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "whatsapp.session_key". All fields are combined with a logical 'AND'. */
export type Whatsapp_Session_Key_Bool_Exp = {
  _and?: InputMaybe<Array<Whatsapp_Session_Key_Bool_Exp>>;
  _not?: InputMaybe<Whatsapp_Session_Key_Bool_Exp>;
  _or?: InputMaybe<Array<Whatsapp_Session_Key_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  signal_data?: InputMaybe<Jsonb_Comparison_Exp>;
  signal_id?: InputMaybe<String_Comparison_Exp>;
  signal_type?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "whatsapp.session_key" */
export enum Whatsapp_Session_Key_Constraint {
  /** unique or primary key constraint on columns "session_id", "signal_type", "signal_id" */
  SessionKeySessionIdSignalTypeSignalIdKey = 'session_key_session_id_signal_type_signal_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Whatsapp_Session_Key_Delete_At_Path_Input = {
  signal_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Whatsapp_Session_Key_Delete_Elem_Input = {
  signal_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Whatsapp_Session_Key_Delete_Key_Input = {
  signal_data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "whatsapp.session_key" */
export type Whatsapp_Session_Key_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['String']>;
  signal_data?: InputMaybe<Scalars['jsonb']>;
  signal_id?: InputMaybe<Scalars['String']>;
  signal_type?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Whatsapp_Session_Key_Max_Fields = {
  __typename?: 'whatsapp_session_key_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['String']>;
  signal_id?: Maybe<Scalars['String']>;
  signal_type?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Whatsapp_Session_Key_Min_Fields = {
  __typename?: 'whatsapp_session_key_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['String']>;
  signal_id?: Maybe<Scalars['String']>;
  signal_type?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "whatsapp.session_key" */
export type Whatsapp_Session_Key_Mutation_Response = {
  __typename?: 'whatsapp_session_key_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Whatsapp_Session_Key>;
};

/** on_conflict condition type for table "whatsapp.session_key" */
export type Whatsapp_Session_Key_On_Conflict = {
  constraint: Whatsapp_Session_Key_Constraint;
  update_columns?: Array<Whatsapp_Session_Key_Update_Column>;
  where?: InputMaybe<Whatsapp_Session_Key_Bool_Exp>;
};

/** Ordering options when selecting data from "whatsapp.session_key". */
export type Whatsapp_Session_Key_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  signal_data?: InputMaybe<Order_By>;
  signal_id?: InputMaybe<Order_By>;
  signal_type?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Whatsapp_Session_Key_Prepend_Input = {
  signal_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "whatsapp.session_key" */
export enum Whatsapp_Session_Key_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  SignalData = 'signal_data',
  /** column name */
  SignalId = 'signal_id',
  /** column name */
  SignalType = 'signal_type',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "whatsapp.session_key" */
export type Whatsapp_Session_Key_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['String']>;
  signal_data?: InputMaybe<Scalars['jsonb']>;
  signal_id?: InputMaybe<Scalars['String']>;
  signal_type?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "whatsapp_session_key" */
export type Whatsapp_Session_Key_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whatsapp_Session_Key_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whatsapp_Session_Key_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['String']>;
  signal_data?: InputMaybe<Scalars['jsonb']>;
  signal_id?: InputMaybe<Scalars['String']>;
  signal_type?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "whatsapp.session_key" */
export enum Whatsapp_Session_Key_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  SignalData = 'signal_data',
  /** column name */
  SignalId = 'signal_id',
  /** column name */
  SignalType = 'signal_type',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Whatsapp_Session_Key_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Whatsapp_Session_Key_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Whatsapp_Session_Key_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Whatsapp_Session_Key_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Whatsapp_Session_Key_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Whatsapp_Session_Key_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Whatsapp_Session_Key_Set_Input>;
  /** filter the rows which have to be updated */
  where: Whatsapp_Session_Key_Bool_Exp;
};

/** aggregate max on columns */
export type Whatsapp_Session_Max_Fields = {
  __typename?: 'whatsapp_session_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  last_reconnect_attempt?: Maybe<Scalars['timestamp']>;
  phone?: Maybe<Scalars['String']>;
  qr_code?: Maybe<Scalars['String']>;
  qr_code_timestamp?: Maybe<Scalars['timestamp']>;
  reconnect_attempts?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Whatsapp_Session_Min_Fields = {
  __typename?: 'whatsapp_session_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  last_reconnect_attempt?: Maybe<Scalars['timestamp']>;
  phone?: Maybe<Scalars['String']>;
  qr_code?: Maybe<Scalars['String']>;
  qr_code_timestamp?: Maybe<Scalars['timestamp']>;
  reconnect_attempts?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "whatsapp.session" */
export type Whatsapp_Session_Mutation_Response = {
  __typename?: 'whatsapp_session_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Whatsapp_Session>;
};

/** on_conflict condition type for table "whatsapp.session" */
export type Whatsapp_Session_On_Conflict = {
  constraint: Whatsapp_Session_Constraint;
  update_columns?: Array<Whatsapp_Session_Update_Column>;
  where?: InputMaybe<Whatsapp_Session_Bool_Exp>;
};

/** Ordering options when selecting data from "whatsapp.session". */
export type Whatsapp_Session_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_multi_device?: InputMaybe<Order_By>;
  last_reconnect_attempt?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  qr_code?: InputMaybe<Order_By>;
  qr_code_timestamp?: InputMaybe<Order_By>;
  reconnect_attempts?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: whatsapp.session */
export type Whatsapp_Session_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "whatsapp.session" */
export enum Whatsapp_Session_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsMultiDevice = 'is_multi_device',
  /** column name */
  LastReconnectAttempt = 'last_reconnect_attempt',
  /** column name */
  Phone = 'phone',
  /** column name */
  QrCode = 'qr_code',
  /** column name */
  QrCodeTimestamp = 'qr_code_timestamp',
  /** column name */
  ReconnectAttempts = 'reconnect_attempts',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "whatsapp.session" */
export type Whatsapp_Session_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  is_multi_device?: InputMaybe<Scalars['Boolean']>;
  last_reconnect_attempt?: InputMaybe<Scalars['timestamp']>;
  phone?: InputMaybe<Scalars['String']>;
  qr_code?: InputMaybe<Scalars['String']>;
  qr_code_timestamp?: InputMaybe<Scalars['timestamp']>;
  reconnect_attempts?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Whatsapp_Session_Stddev_Fields = {
  __typename?: 'whatsapp_session_stddev_fields';
  reconnect_attempts?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Whatsapp_Session_Stddev_Pop_Fields = {
  __typename?: 'whatsapp_session_stddev_pop_fields';
  reconnect_attempts?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Whatsapp_Session_Stddev_Samp_Fields = {
  __typename?: 'whatsapp_session_stddev_samp_fields';
  reconnect_attempts?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "whatsapp_session" */
export type Whatsapp_Session_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Whatsapp_Session_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Whatsapp_Session_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  is_multi_device?: InputMaybe<Scalars['Boolean']>;
  last_reconnect_attempt?: InputMaybe<Scalars['timestamp']>;
  phone?: InputMaybe<Scalars['String']>;
  qr_code?: InputMaybe<Scalars['String']>;
  qr_code_timestamp?: InputMaybe<Scalars['timestamp']>;
  reconnect_attempts?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Whatsapp_Session_Sum_Fields = {
  __typename?: 'whatsapp_session_sum_fields';
  reconnect_attempts?: Maybe<Scalars['Int']>;
};

/** update columns of table "whatsapp.session" */
export enum Whatsapp_Session_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsMultiDevice = 'is_multi_device',
  /** column name */
  LastReconnectAttempt = 'last_reconnect_attempt',
  /** column name */
  Phone = 'phone',
  /** column name */
  QrCode = 'qr_code',
  /** column name */
  QrCodeTimestamp = 'qr_code_timestamp',
  /** column name */
  ReconnectAttempts = 'reconnect_attempts',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uuid = 'uuid'
}

export type Whatsapp_Session_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Whatsapp_Session_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Whatsapp_Session_Set_Input>;
  /** filter the rows which have to be updated */
  where: Whatsapp_Session_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Whatsapp_Session_Var_Pop_Fields = {
  __typename?: 'whatsapp_session_var_pop_fields';
  reconnect_attempts?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Whatsapp_Session_Var_Samp_Fields = {
  __typename?: 'whatsapp_session_var_samp_fields';
  reconnect_attempts?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Whatsapp_Session_Variance_Fields = {
  __typename?: 'whatsapp_session_variance_fields';
  reconnect_attempts?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "wos_sync" */
export type Wos_Sync = {
  __typename?: 'wos_sync';
  last_event_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "wos_sync" */
export type Wos_Sync_Aggregate = {
  __typename?: 'wos_sync_aggregate';
  aggregate?: Maybe<Wos_Sync_Aggregate_Fields>;
  nodes: Array<Wos_Sync>;
};

/** aggregate fields of "wos_sync" */
export type Wos_Sync_Aggregate_Fields = {
  __typename?: 'wos_sync_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Wos_Sync_Max_Fields>;
  min?: Maybe<Wos_Sync_Min_Fields>;
};


/** aggregate fields of "wos_sync" */
export type Wos_Sync_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Wos_Sync_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "wos_sync". All fields are combined with a logical 'AND'. */
export type Wos_Sync_Bool_Exp = {
  _and?: InputMaybe<Array<Wos_Sync_Bool_Exp>>;
  _not?: InputMaybe<Wos_Sync_Bool_Exp>;
  _or?: InputMaybe<Array<Wos_Sync_Bool_Exp>>;
  last_event_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "wos_sync" */
export enum Wos_Sync_Constraint {
  /** unique or primary key constraint on columns "last_event_id" */
  WosSyncPkey = 'wos_sync_pkey'
}

/** input type for inserting data into table "wos_sync" */
export type Wos_Sync_Insert_Input = {
  last_event_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Wos_Sync_Max_Fields = {
  __typename?: 'wos_sync_max_fields';
  last_event_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Wos_Sync_Min_Fields = {
  __typename?: 'wos_sync_min_fields';
  last_event_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "wos_sync" */
export type Wos_Sync_Mutation_Response = {
  __typename?: 'wos_sync_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Wos_Sync>;
};

/** on_conflict condition type for table "wos_sync" */
export type Wos_Sync_On_Conflict = {
  constraint: Wos_Sync_Constraint;
  update_columns?: Array<Wos_Sync_Update_Column>;
  where?: InputMaybe<Wos_Sync_Bool_Exp>;
};

/** Ordering options when selecting data from "wos_sync". */
export type Wos_Sync_Order_By = {
  last_event_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: wos_sync */
export type Wos_Sync_Pk_Columns_Input = {
  last_event_id: Scalars['String'];
};

/** select columns of table "wos_sync" */
export enum Wos_Sync_Select_Column {
  /** column name */
  LastEventId = 'last_event_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "wos_sync" */
export type Wos_Sync_Set_Input = {
  last_event_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "wos_sync" */
export type Wos_Sync_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Wos_Sync_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Wos_Sync_Stream_Cursor_Value_Input = {
  last_event_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "wos_sync" */
export enum Wos_Sync_Update_Column {
  /** column name */
  LastEventId = 'last_event_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Wos_Sync_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Wos_Sync_Set_Input>;
  /** filter the rows which have to be updated */
  where: Wos_Sync_Bool_Exp;
};

/** columns and relationships of "ws_contacts" */
export type Ws_Contacts = {
  __typename?: 'ws_contacts';
  /** An array relationship */
  consents: Array<Consent>;
  /** An aggregate relationship */
  consents_aggregate: Consent_Aggregate;
  id: Scalars['Int'];
  is_group: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  profile_pic?: Maybe<Scalars['String']>;
};


/** columns and relationships of "ws_contacts" */
export type Ws_ContactsConsentsArgs = {
  distinct_on?: InputMaybe<Array<Consent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consent_Order_By>>;
  where?: InputMaybe<Consent_Bool_Exp>;
};


/** columns and relationships of "ws_contacts" */
export type Ws_ContactsConsents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consent_Order_By>>;
  where?: InputMaybe<Consent_Bool_Exp>;
};

/** aggregated selection of "ws_contacts" */
export type Ws_Contacts_Aggregate = {
  __typename?: 'ws_contacts_aggregate';
  aggregate?: Maybe<Ws_Contacts_Aggregate_Fields>;
  nodes: Array<Ws_Contacts>;
};

/** aggregate fields of "ws_contacts" */
export type Ws_Contacts_Aggregate_Fields = {
  __typename?: 'ws_contacts_aggregate_fields';
  avg?: Maybe<Ws_Contacts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ws_Contacts_Max_Fields>;
  min?: Maybe<Ws_Contacts_Min_Fields>;
  stddev?: Maybe<Ws_Contacts_Stddev_Fields>;
  stddev_pop?: Maybe<Ws_Contacts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ws_Contacts_Stddev_Samp_Fields>;
  sum?: Maybe<Ws_Contacts_Sum_Fields>;
  var_pop?: Maybe<Ws_Contacts_Var_Pop_Fields>;
  var_samp?: Maybe<Ws_Contacts_Var_Samp_Fields>;
  variance?: Maybe<Ws_Contacts_Variance_Fields>;
};


/** aggregate fields of "ws_contacts" */
export type Ws_Contacts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ws_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Ws_Contacts_Avg_Fields = {
  __typename?: 'ws_contacts_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ws_contacts". All fields are combined with a logical 'AND'. */
export type Ws_Contacts_Bool_Exp = {
  _and?: InputMaybe<Array<Ws_Contacts_Bool_Exp>>;
  _not?: InputMaybe<Ws_Contacts_Bool_Exp>;
  _or?: InputMaybe<Array<Ws_Contacts_Bool_Exp>>;
  consents?: InputMaybe<Consent_Bool_Exp>;
  consents_aggregate?: InputMaybe<Consent_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_group?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  profile_pic?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ws_contacts" */
export enum Ws_Contacts_Constraint {
  /** unique or primary key constraint on columns "phone" */
  WsContactsPkey = 'ws_contacts_pkey'
}

/** input type for incrementing numeric columns in table "ws_contacts" */
export type Ws_Contacts_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ws_contacts" */
export type Ws_Contacts_Insert_Input = {
  consents?: InputMaybe<Consent_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_group?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profile_pic?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ws_Contacts_Max_Fields = {
  __typename?: 'ws_contacts_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_pic?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ws_Contacts_Min_Fields = {
  __typename?: 'ws_contacts_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_pic?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ws_contacts" */
export type Ws_Contacts_Mutation_Response = {
  __typename?: 'ws_contacts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ws_Contacts>;
};

/** input type for inserting object relation for remote table "ws_contacts" */
export type Ws_Contacts_Obj_Rel_Insert_Input = {
  data: Ws_Contacts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ws_Contacts_On_Conflict>;
};

/** on_conflict condition type for table "ws_contacts" */
export type Ws_Contacts_On_Conflict = {
  constraint: Ws_Contacts_Constraint;
  update_columns?: Array<Ws_Contacts_Update_Column>;
  where?: InputMaybe<Ws_Contacts_Bool_Exp>;
};

/** Ordering options when selecting data from "ws_contacts". */
export type Ws_Contacts_Order_By = {
  consents_aggregate?: InputMaybe<Consent_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_group?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  profile_pic?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ws_contacts */
export type Ws_Contacts_Pk_Columns_Input = {
  phone: Scalars['String'];
};

/** select columns of table "ws_contacts" */
export enum Ws_Contacts_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsGroup = 'is_group',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProfilePic = 'profile_pic'
}

/** input type for updating data in table "ws_contacts" */
export type Ws_Contacts_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  is_group?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profile_pic?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Ws_Contacts_Stddev_Fields = {
  __typename?: 'ws_contacts_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ws_Contacts_Stddev_Pop_Fields = {
  __typename?: 'ws_contacts_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ws_Contacts_Stddev_Samp_Fields = {
  __typename?: 'ws_contacts_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ws_contacts" */
export type Ws_Contacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ws_Contacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ws_Contacts_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  is_group?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profile_pic?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Ws_Contacts_Sum_Fields = {
  __typename?: 'ws_contacts_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "ws_contacts" */
export enum Ws_Contacts_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsGroup = 'is_group',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProfilePic = 'profile_pic'
}

export type Ws_Contacts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ws_Contacts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ws_Contacts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ws_Contacts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ws_Contacts_Var_Pop_Fields = {
  __typename?: 'ws_contacts_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ws_Contacts_Var_Samp_Fields = {
  __typename?: 'ws_contacts_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ws_Contacts_Variance_Fields = {
  __typename?: 'ws_contacts_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ws_history_sync" */
export type Ws_History_Sync = {
  __typename?: 'ws_history_sync';
  created_at: Scalars['timestamptz'];
  finished_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  progress_chats?: Maybe<Scalars['Int']>;
  progress_contacts?: Maybe<Scalars['Int']>;
  progress_messages?: Maybe<Scalars['Int']>;
  session_uuid: Scalars['uuid'];
  total_chats?: Maybe<Scalars['Int']>;
  total_contacts?: Maybe<Scalars['Int']>;
  total_messages?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "ws_history_sync" */
export type Ws_History_Sync_Aggregate = {
  __typename?: 'ws_history_sync_aggregate';
  aggregate?: Maybe<Ws_History_Sync_Aggregate_Fields>;
  nodes: Array<Ws_History_Sync>;
};

/** aggregate fields of "ws_history_sync" */
export type Ws_History_Sync_Aggregate_Fields = {
  __typename?: 'ws_history_sync_aggregate_fields';
  avg?: Maybe<Ws_History_Sync_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ws_History_Sync_Max_Fields>;
  min?: Maybe<Ws_History_Sync_Min_Fields>;
  stddev?: Maybe<Ws_History_Sync_Stddev_Fields>;
  stddev_pop?: Maybe<Ws_History_Sync_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ws_History_Sync_Stddev_Samp_Fields>;
  sum?: Maybe<Ws_History_Sync_Sum_Fields>;
  var_pop?: Maybe<Ws_History_Sync_Var_Pop_Fields>;
  var_samp?: Maybe<Ws_History_Sync_Var_Samp_Fields>;
  variance?: Maybe<Ws_History_Sync_Variance_Fields>;
};


/** aggregate fields of "ws_history_sync" */
export type Ws_History_Sync_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ws_History_Sync_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Ws_History_Sync_Avg_Fields = {
  __typename?: 'ws_history_sync_avg_fields';
  progress_chats?: Maybe<Scalars['Float']>;
  progress_contacts?: Maybe<Scalars['Float']>;
  progress_messages?: Maybe<Scalars['Float']>;
  total_chats?: Maybe<Scalars['Float']>;
  total_contacts?: Maybe<Scalars['Float']>;
  total_messages?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ws_history_sync". All fields are combined with a logical 'AND'. */
export type Ws_History_Sync_Bool_Exp = {
  _and?: InputMaybe<Array<Ws_History_Sync_Bool_Exp>>;
  _not?: InputMaybe<Ws_History_Sync_Bool_Exp>;
  _or?: InputMaybe<Array<Ws_History_Sync_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  finished_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  progress_chats?: InputMaybe<Int_Comparison_Exp>;
  progress_contacts?: InputMaybe<Int_Comparison_Exp>;
  progress_messages?: InputMaybe<Int_Comparison_Exp>;
  session_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  total_chats?: InputMaybe<Int_Comparison_Exp>;
  total_contacts?: InputMaybe<Int_Comparison_Exp>;
  total_messages?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ws_history_sync" */
export enum Ws_History_Sync_Constraint {
  /** unique or primary key constraint on columns "session_uuid", "id" */
  WsHistorySyncIdSessionUuidKey = 'ws_history_sync_id_session_uuid_key',
  /** unique or primary key constraint on columns "id" */
  WsHistorySyncPkey = 'ws_history_sync_pkey'
}

/** input type for incrementing numeric columns in table "ws_history_sync" */
export type Ws_History_Sync_Inc_Input = {
  progress_chats?: InputMaybe<Scalars['Int']>;
  progress_contacts?: InputMaybe<Scalars['Int']>;
  progress_messages?: InputMaybe<Scalars['Int']>;
  total_chats?: InputMaybe<Scalars['Int']>;
  total_contacts?: InputMaybe<Scalars['Int']>;
  total_messages?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ws_history_sync" */
export type Ws_History_Sync_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  finished_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  progress_chats?: InputMaybe<Scalars['Int']>;
  progress_contacts?: InputMaybe<Scalars['Int']>;
  progress_messages?: InputMaybe<Scalars['Int']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  total_chats?: InputMaybe<Scalars['Int']>;
  total_contacts?: InputMaybe<Scalars['Int']>;
  total_messages?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Ws_History_Sync_Max_Fields = {
  __typename?: 'ws_history_sync_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  progress_chats?: Maybe<Scalars['Int']>;
  progress_contacts?: Maybe<Scalars['Int']>;
  progress_messages?: Maybe<Scalars['Int']>;
  session_uuid?: Maybe<Scalars['uuid']>;
  total_chats?: Maybe<Scalars['Int']>;
  total_contacts?: Maybe<Scalars['Int']>;
  total_messages?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Ws_History_Sync_Min_Fields = {
  __typename?: 'ws_history_sync_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  progress_chats?: Maybe<Scalars['Int']>;
  progress_contacts?: Maybe<Scalars['Int']>;
  progress_messages?: Maybe<Scalars['Int']>;
  session_uuid?: Maybe<Scalars['uuid']>;
  total_chats?: Maybe<Scalars['Int']>;
  total_contacts?: Maybe<Scalars['Int']>;
  total_messages?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "ws_history_sync" */
export type Ws_History_Sync_Mutation_Response = {
  __typename?: 'ws_history_sync_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ws_History_Sync>;
};

/** on_conflict condition type for table "ws_history_sync" */
export type Ws_History_Sync_On_Conflict = {
  constraint: Ws_History_Sync_Constraint;
  update_columns?: Array<Ws_History_Sync_Update_Column>;
  where?: InputMaybe<Ws_History_Sync_Bool_Exp>;
};

/** Ordering options when selecting data from "ws_history_sync". */
export type Ws_History_Sync_Order_By = {
  created_at?: InputMaybe<Order_By>;
  finished_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  progress_chats?: InputMaybe<Order_By>;
  progress_contacts?: InputMaybe<Order_By>;
  progress_messages?: InputMaybe<Order_By>;
  session_uuid?: InputMaybe<Order_By>;
  total_chats?: InputMaybe<Order_By>;
  total_contacts?: InputMaybe<Order_By>;
  total_messages?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ws_history_sync */
export type Ws_History_Sync_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ws_history_sync" */
export enum Ws_History_Sync_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FinishedAt = 'finished_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProgressChats = 'progress_chats',
  /** column name */
  ProgressContacts = 'progress_contacts',
  /** column name */
  ProgressMessages = 'progress_messages',
  /** column name */
  SessionUuid = 'session_uuid',
  /** column name */
  TotalChats = 'total_chats',
  /** column name */
  TotalContacts = 'total_contacts',
  /** column name */
  TotalMessages = 'total_messages',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ws_history_sync" */
export type Ws_History_Sync_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  finished_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  progress_chats?: InputMaybe<Scalars['Int']>;
  progress_contacts?: InputMaybe<Scalars['Int']>;
  progress_messages?: InputMaybe<Scalars['Int']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  total_chats?: InputMaybe<Scalars['Int']>;
  total_contacts?: InputMaybe<Scalars['Int']>;
  total_messages?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Ws_History_Sync_Stddev_Fields = {
  __typename?: 'ws_history_sync_stddev_fields';
  progress_chats?: Maybe<Scalars['Float']>;
  progress_contacts?: Maybe<Scalars['Float']>;
  progress_messages?: Maybe<Scalars['Float']>;
  total_chats?: Maybe<Scalars['Float']>;
  total_contacts?: Maybe<Scalars['Float']>;
  total_messages?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ws_History_Sync_Stddev_Pop_Fields = {
  __typename?: 'ws_history_sync_stddev_pop_fields';
  progress_chats?: Maybe<Scalars['Float']>;
  progress_contacts?: Maybe<Scalars['Float']>;
  progress_messages?: Maybe<Scalars['Float']>;
  total_chats?: Maybe<Scalars['Float']>;
  total_contacts?: Maybe<Scalars['Float']>;
  total_messages?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ws_History_Sync_Stddev_Samp_Fields = {
  __typename?: 'ws_history_sync_stddev_samp_fields';
  progress_chats?: Maybe<Scalars['Float']>;
  progress_contacts?: Maybe<Scalars['Float']>;
  progress_messages?: Maybe<Scalars['Float']>;
  total_chats?: Maybe<Scalars['Float']>;
  total_contacts?: Maybe<Scalars['Float']>;
  total_messages?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ws_history_sync" */
export type Ws_History_Sync_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ws_History_Sync_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ws_History_Sync_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  finished_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  progress_chats?: InputMaybe<Scalars['Int']>;
  progress_contacts?: InputMaybe<Scalars['Int']>;
  progress_messages?: InputMaybe<Scalars['Int']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  total_chats?: InputMaybe<Scalars['Int']>;
  total_contacts?: InputMaybe<Scalars['Int']>;
  total_messages?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Ws_History_Sync_Sum_Fields = {
  __typename?: 'ws_history_sync_sum_fields';
  progress_chats?: Maybe<Scalars['Int']>;
  progress_contacts?: Maybe<Scalars['Int']>;
  progress_messages?: Maybe<Scalars['Int']>;
  total_chats?: Maybe<Scalars['Int']>;
  total_contacts?: Maybe<Scalars['Int']>;
  total_messages?: Maybe<Scalars['Int']>;
};

/** update columns of table "ws_history_sync" */
export enum Ws_History_Sync_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FinishedAt = 'finished_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProgressChats = 'progress_chats',
  /** column name */
  ProgressContacts = 'progress_contacts',
  /** column name */
  ProgressMessages = 'progress_messages',
  /** column name */
  SessionUuid = 'session_uuid',
  /** column name */
  TotalChats = 'total_chats',
  /** column name */
  TotalContacts = 'total_contacts',
  /** column name */
  TotalMessages = 'total_messages',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ws_History_Sync_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ws_History_Sync_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ws_History_Sync_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ws_History_Sync_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ws_History_Sync_Var_Pop_Fields = {
  __typename?: 'ws_history_sync_var_pop_fields';
  progress_chats?: Maybe<Scalars['Float']>;
  progress_contacts?: Maybe<Scalars['Float']>;
  progress_messages?: Maybe<Scalars['Float']>;
  total_chats?: Maybe<Scalars['Float']>;
  total_contacts?: Maybe<Scalars['Float']>;
  total_messages?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ws_History_Sync_Var_Samp_Fields = {
  __typename?: 'ws_history_sync_var_samp_fields';
  progress_chats?: Maybe<Scalars['Float']>;
  progress_contacts?: Maybe<Scalars['Float']>;
  progress_messages?: Maybe<Scalars['Float']>;
  total_chats?: Maybe<Scalars['Float']>;
  total_contacts?: Maybe<Scalars['Float']>;
  total_messages?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ws_History_Sync_Variance_Fields = {
  __typename?: 'ws_history_sync_variance_fields';
  progress_chats?: Maybe<Scalars['Float']>;
  progress_contacts?: Maybe<Scalars['Float']>;
  progress_messages?: Maybe<Scalars['Float']>;
  total_chats?: Maybe<Scalars['Float']>;
  total_contacts?: Maybe<Scalars['Float']>;
  total_messages?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ws_messages" */
export type Ws_Messages = {
  __typename?: 'ws_messages';
  body?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  forwarding_score: Scalars['Int'];
  from: Scalars['String'];
  /** An object relationship */
  from_contact?: Maybe<Ws_Contacts>;
  from_me: Scalars['Boolean'];
  id: Scalars['Int'];
  is_deleted: Scalars['Boolean'];
  is_forward: Scalars['Boolean'];
  is_group_msg?: Maybe<Scalars['Boolean']>;
  message_key: Scalars['String'];
  metadata?: Maybe<Scalars['jsonb']>;
  mime_type?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['String']>;
  /** An object relationship */
  participant_contact?: Maybe<Ws_Contacts>;
  session_uuid: Scalars['uuid'];
  to: Scalars['String'];
  /** An object relationship */
  to_contact?: Maybe<Ws_Contacts>;
  transcription?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  unix_timestamp: Scalars['Int'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ws_session: Ws_Sessions;
};


/** columns and relationships of "ws_messages" */
export type Ws_MessagesMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ws_messages" */
export type Ws_Messages_Aggregate = {
  __typename?: 'ws_messages_aggregate';
  aggregate?: Maybe<Ws_Messages_Aggregate_Fields>;
  nodes: Array<Ws_Messages>;
};

export type Ws_Messages_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Ws_Messages_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Ws_Messages_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Ws_Messages_Aggregate_Bool_Exp_Count>;
};

export type Ws_Messages_Aggregate_Bool_Exp_Bool_And = {
  arguments: Ws_Messages_Select_Column_Ws_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ws_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ws_Messages_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Ws_Messages_Select_Column_Ws_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ws_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ws_Messages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ws_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ws_Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ws_messages" */
export type Ws_Messages_Aggregate_Fields = {
  __typename?: 'ws_messages_aggregate_fields';
  avg?: Maybe<Ws_Messages_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ws_Messages_Max_Fields>;
  min?: Maybe<Ws_Messages_Min_Fields>;
  stddev?: Maybe<Ws_Messages_Stddev_Fields>;
  stddev_pop?: Maybe<Ws_Messages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ws_Messages_Stddev_Samp_Fields>;
  sum?: Maybe<Ws_Messages_Sum_Fields>;
  var_pop?: Maybe<Ws_Messages_Var_Pop_Fields>;
  var_samp?: Maybe<Ws_Messages_Var_Samp_Fields>;
  variance?: Maybe<Ws_Messages_Variance_Fields>;
};


/** aggregate fields of "ws_messages" */
export type Ws_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ws_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ws_messages" */
export type Ws_Messages_Aggregate_Order_By = {
  avg?: InputMaybe<Ws_Messages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ws_Messages_Max_Order_By>;
  min?: InputMaybe<Ws_Messages_Min_Order_By>;
  stddev?: InputMaybe<Ws_Messages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ws_Messages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ws_Messages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ws_Messages_Sum_Order_By>;
  var_pop?: InputMaybe<Ws_Messages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ws_Messages_Var_Samp_Order_By>;
  variance?: InputMaybe<Ws_Messages_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ws_Messages_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "ws_messages" */
export type Ws_Messages_Arr_Rel_Insert_Input = {
  data: Array<Ws_Messages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ws_Messages_On_Conflict>;
};

/** aggregate avg on columns */
export type Ws_Messages_Avg_Fields = {
  __typename?: 'ws_messages_avg_fields';
  forwarding_score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ws_messages" */
export type Ws_Messages_Avg_Order_By = {
  forwarding_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ws_messages". All fields are combined with a logical 'AND'. */
export type Ws_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Ws_Messages_Bool_Exp>>;
  _not?: InputMaybe<Ws_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Ws_Messages_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  caption?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  forwarding_score?: InputMaybe<Int_Comparison_Exp>;
  from?: InputMaybe<String_Comparison_Exp>;
  from_contact?: InputMaybe<Ws_Contacts_Bool_Exp>;
  from_me?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_forward?: InputMaybe<Boolean_Comparison_Exp>;
  is_group_msg?: InputMaybe<Boolean_Comparison_Exp>;
  message_key?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mime_type?: InputMaybe<String_Comparison_Exp>;
  participant?: InputMaybe<String_Comparison_Exp>;
  participant_contact?: InputMaybe<Ws_Contacts_Bool_Exp>;
  session_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  to?: InputMaybe<String_Comparison_Exp>;
  to_contact?: InputMaybe<Ws_Contacts_Bool_Exp>;
  transcription?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  unix_timestamp?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ws_session?: InputMaybe<Ws_Sessions_Bool_Exp>;
};

/** unique or primary key constraints on table "ws_messages" */
export enum Ws_Messages_Constraint {
  /** unique or primary key constraint on columns "id" */
  WsMessagesIdKey = 'ws_messages_id_key',
  /** unique or primary key constraint on columns "id" */
  WsMessagesPkey = 'ws_messages_pkey',
  /** unique or primary key constraint on columns "from", "to", "session_uuid", "type", "message_key", "unix_timestamp" */
  WsMessagesToFromMessageKeySessionUuidUnixTimestampTyp = 'ws_messages_to_from_message_key_session_uuid_unix_timestamp_typ'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ws_Messages_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ws_Messages_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ws_Messages_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "ws_messages" */
export type Ws_Messages_Inc_Input = {
  forwarding_score?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  unix_timestamp?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ws_messages" */
export type Ws_Messages_Insert_Input = {
  body?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  forwarding_score?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  from_contact?: InputMaybe<Ws_Contacts_Obj_Rel_Insert_Input>;
  from_me?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_forward?: InputMaybe<Scalars['Boolean']>;
  is_group_msg?: InputMaybe<Scalars['Boolean']>;
  message_key?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  mime_type?: InputMaybe<Scalars['String']>;
  participant?: InputMaybe<Scalars['String']>;
  participant_contact?: InputMaybe<Ws_Contacts_Obj_Rel_Insert_Input>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  to?: InputMaybe<Scalars['String']>;
  to_contact?: InputMaybe<Ws_Contacts_Obj_Rel_Insert_Input>;
  transcription?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  unix_timestamp?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  ws_session?: InputMaybe<Ws_Sessions_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ws_Messages_Max_Fields = {
  __typename?: 'ws_messages_max_fields';
  body?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  forwarding_score?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  message_key?: Maybe<Scalars['String']>;
  mime_type?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['String']>;
  session_uuid?: Maybe<Scalars['uuid']>;
  to?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unix_timestamp?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ws_messages" */
export type Ws_Messages_Max_Order_By = {
  body?: InputMaybe<Order_By>;
  caption?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  forwarding_score?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_key?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
  participant?: InputMaybe<Order_By>;
  session_uuid?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
  transcription?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ws_Messages_Min_Fields = {
  __typename?: 'ws_messages_min_fields';
  body?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  forwarding_score?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  message_key?: Maybe<Scalars['String']>;
  mime_type?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['String']>;
  session_uuid?: Maybe<Scalars['uuid']>;
  to?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unix_timestamp?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ws_messages" */
export type Ws_Messages_Min_Order_By = {
  body?: InputMaybe<Order_By>;
  caption?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  forwarding_score?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_key?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
  participant?: InputMaybe<Order_By>;
  session_uuid?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
  transcription?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ws_messages" */
export type Ws_Messages_Mutation_Response = {
  __typename?: 'ws_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ws_Messages>;
};

/** on_conflict condition type for table "ws_messages" */
export type Ws_Messages_On_Conflict = {
  constraint: Ws_Messages_Constraint;
  update_columns?: Array<Ws_Messages_Update_Column>;
  where?: InputMaybe<Ws_Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "ws_messages". */
export type Ws_Messages_Order_By = {
  body?: InputMaybe<Order_By>;
  caption?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  forwarding_score?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  from_contact?: InputMaybe<Ws_Contacts_Order_By>;
  from_me?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_forward?: InputMaybe<Order_By>;
  is_group_msg?: InputMaybe<Order_By>;
  message_key?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
  participant?: InputMaybe<Order_By>;
  participant_contact?: InputMaybe<Ws_Contacts_Order_By>;
  session_uuid?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
  to_contact?: InputMaybe<Ws_Contacts_Order_By>;
  transcription?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  ws_session?: InputMaybe<Ws_Sessions_Order_By>;
};

/** primary key columns input for table: ws_messages */
export type Ws_Messages_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ws_Messages_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ws_messages" */
export enum Ws_Messages_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Caption = 'caption',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ForwardingScore = 'forwarding_score',
  /** column name */
  From = 'from',
  /** column name */
  FromMe = 'from_me',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsForward = 'is_forward',
  /** column name */
  IsGroupMsg = 'is_group_msg',
  /** column name */
  MessageKey = 'message_key',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mime_type',
  /** column name */
  Participant = 'participant',
  /** column name */
  SessionUuid = 'session_uuid',
  /** column name */
  To = 'to',
  /** column name */
  Transcription = 'transcription',
  /** column name */
  Type = 'type',
  /** column name */
  UnixTimestamp = 'unix_timestamp',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "ws_messages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ws_messages" */
export enum Ws_Messages_Select_Column_Ws_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  FromMe = 'from_me',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsForward = 'is_forward',
  /** column name */
  IsGroupMsg = 'is_group_msg'
}

/** select "ws_messages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ws_messages" */
export enum Ws_Messages_Select_Column_Ws_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  FromMe = 'from_me',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsForward = 'is_forward',
  /** column name */
  IsGroupMsg = 'is_group_msg'
}

/** input type for updating data in table "ws_messages" */
export type Ws_Messages_Set_Input = {
  body?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  forwarding_score?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  from_me?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_forward?: InputMaybe<Scalars['Boolean']>;
  is_group_msg?: InputMaybe<Scalars['Boolean']>;
  message_key?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  mime_type?: InputMaybe<Scalars['String']>;
  participant?: InputMaybe<Scalars['String']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  to?: InputMaybe<Scalars['String']>;
  transcription?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  unix_timestamp?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Ws_Messages_Stddev_Fields = {
  __typename?: 'ws_messages_stddev_fields';
  forwarding_score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ws_messages" */
export type Ws_Messages_Stddev_Order_By = {
  forwarding_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ws_Messages_Stddev_Pop_Fields = {
  __typename?: 'ws_messages_stddev_pop_fields';
  forwarding_score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ws_messages" */
export type Ws_Messages_Stddev_Pop_Order_By = {
  forwarding_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ws_Messages_Stddev_Samp_Fields = {
  __typename?: 'ws_messages_stddev_samp_fields';
  forwarding_score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ws_messages" */
export type Ws_Messages_Stddev_Samp_Order_By = {
  forwarding_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ws_messages" */
export type Ws_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ws_Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ws_Messages_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  forwarding_score?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  from_me?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_forward?: InputMaybe<Scalars['Boolean']>;
  is_group_msg?: InputMaybe<Scalars['Boolean']>;
  message_key?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  mime_type?: InputMaybe<Scalars['String']>;
  participant?: InputMaybe<Scalars['String']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  to?: InputMaybe<Scalars['String']>;
  transcription?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  unix_timestamp?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Ws_Messages_Sum_Fields = {
  __typename?: 'ws_messages_sum_fields';
  forwarding_score?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  unix_timestamp?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ws_messages" */
export type Ws_Messages_Sum_Order_By = {
  forwarding_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** update columns of table "ws_messages" */
export enum Ws_Messages_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Caption = 'caption',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ForwardingScore = 'forwarding_score',
  /** column name */
  From = 'from',
  /** column name */
  FromMe = 'from_me',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsForward = 'is_forward',
  /** column name */
  IsGroupMsg = 'is_group_msg',
  /** column name */
  MessageKey = 'message_key',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mime_type',
  /** column name */
  Participant = 'participant',
  /** column name */
  SessionUuid = 'session_uuid',
  /** column name */
  To = 'to',
  /** column name */
  Transcription = 'transcription',
  /** column name */
  Type = 'type',
  /** column name */
  UnixTimestamp = 'unix_timestamp',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ws_Messages_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ws_Messages_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ws_Messages_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ws_Messages_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ws_Messages_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ws_Messages_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ws_Messages_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ws_Messages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ws_Messages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ws_Messages_Var_Pop_Fields = {
  __typename?: 'ws_messages_var_pop_fields';
  forwarding_score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ws_messages" */
export type Ws_Messages_Var_Pop_Order_By = {
  forwarding_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ws_Messages_Var_Samp_Fields = {
  __typename?: 'ws_messages_var_samp_fields';
  forwarding_score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ws_messages" */
export type Ws_Messages_Var_Samp_Order_By = {
  forwarding_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ws_Messages_Variance_Fields = {
  __typename?: 'ws_messages_variance_fields';
  forwarding_score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  unix_timestamp?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ws_messages" */
export type Ws_Messages_Variance_Order_By = {
  forwarding_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unix_timestamp?: InputMaybe<Order_By>;
};

/** columns and relationships of "ws_servers" */
export type Ws_Servers = {
  __typename?: 'ws_servers';
  ack?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  identifier: Scalars['uuid'];
  instance_id: Scalars['String'];
  /** An array relationship */
  sessions: Array<Ws_Sessions>;
  /** An aggregate relationship */
  sessions_aggregate: Ws_Sessions_Aggregate;
  sockets: Scalars['Int'];
};


/** columns and relationships of "ws_servers" */
export type Ws_ServersSessionsArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Bool_Exp>;
};


/** columns and relationships of "ws_servers" */
export type Ws_ServersSessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Bool_Exp>;
};

/** aggregated selection of "ws_servers" */
export type Ws_Servers_Aggregate = {
  __typename?: 'ws_servers_aggregate';
  aggregate?: Maybe<Ws_Servers_Aggregate_Fields>;
  nodes: Array<Ws_Servers>;
};

/** aggregate fields of "ws_servers" */
export type Ws_Servers_Aggregate_Fields = {
  __typename?: 'ws_servers_aggregate_fields';
  avg?: Maybe<Ws_Servers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ws_Servers_Max_Fields>;
  min?: Maybe<Ws_Servers_Min_Fields>;
  stddev?: Maybe<Ws_Servers_Stddev_Fields>;
  stddev_pop?: Maybe<Ws_Servers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ws_Servers_Stddev_Samp_Fields>;
  sum?: Maybe<Ws_Servers_Sum_Fields>;
  var_pop?: Maybe<Ws_Servers_Var_Pop_Fields>;
  var_samp?: Maybe<Ws_Servers_Var_Samp_Fields>;
  variance?: Maybe<Ws_Servers_Variance_Fields>;
};


/** aggregate fields of "ws_servers" */
export type Ws_Servers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ws_Servers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Ws_Servers_Avg_Fields = {
  __typename?: 'ws_servers_avg_fields';
  id?: Maybe<Scalars['Float']>;
  sockets?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ws_servers". All fields are combined with a logical 'AND'. */
export type Ws_Servers_Bool_Exp = {
  _and?: InputMaybe<Array<Ws_Servers_Bool_Exp>>;
  _not?: InputMaybe<Ws_Servers_Bool_Exp>;
  _or?: InputMaybe<Array<Ws_Servers_Bool_Exp>>;
  ack?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  identifier?: InputMaybe<Uuid_Comparison_Exp>;
  instance_id?: InputMaybe<String_Comparison_Exp>;
  sessions?: InputMaybe<Ws_Sessions_Bool_Exp>;
  sessions_aggregate?: InputMaybe<Ws_Sessions_Aggregate_Bool_Exp>;
  sockets?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "ws_servers" */
export enum Ws_Servers_Constraint {
  /** unique or primary key constraint on columns "instance_id", "identifier" */
  WsServersIdentifierInstanceIdKey = 'ws_servers_identifier_instance_id_key',
  /** unique or primary key constraint on columns "identifier" */
  WsServersIdentifierKey = 'ws_servers_identifier_key',
  /** unique or primary key constraint on columns "id" */
  WsServersPkey = 'ws_servers_pkey'
}

/** input type for incrementing numeric columns in table "ws_servers" */
export type Ws_Servers_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  sockets?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ws_servers" */
export type Ws_Servers_Insert_Input = {
  ack?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['uuid']>;
  instance_id?: InputMaybe<Scalars['String']>;
  sessions?: InputMaybe<Ws_Sessions_Arr_Rel_Insert_Input>;
  sockets?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Ws_Servers_Max_Fields = {
  __typename?: 'ws_servers_max_fields';
  ack?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  identifier?: Maybe<Scalars['uuid']>;
  instance_id?: Maybe<Scalars['String']>;
  sockets?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Ws_Servers_Min_Fields = {
  __typename?: 'ws_servers_min_fields';
  ack?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  identifier?: Maybe<Scalars['uuid']>;
  instance_id?: Maybe<Scalars['String']>;
  sockets?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "ws_servers" */
export type Ws_Servers_Mutation_Response = {
  __typename?: 'ws_servers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ws_Servers>;
};

/** input type for inserting object relation for remote table "ws_servers" */
export type Ws_Servers_Obj_Rel_Insert_Input = {
  data: Ws_Servers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ws_Servers_On_Conflict>;
};

/** on_conflict condition type for table "ws_servers" */
export type Ws_Servers_On_Conflict = {
  constraint: Ws_Servers_Constraint;
  update_columns?: Array<Ws_Servers_Update_Column>;
  where?: InputMaybe<Ws_Servers_Bool_Exp>;
};

/** Ordering options when selecting data from "ws_servers". */
export type Ws_Servers_Order_By = {
  ack?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  instance_id?: InputMaybe<Order_By>;
  sessions_aggregate?: InputMaybe<Ws_Sessions_Aggregate_Order_By>;
  sockets?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ws_servers */
export type Ws_Servers_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "ws_servers" */
export enum Ws_Servers_Select_Column {
  /** column name */
  Ack = 'ack',
  /** column name */
  Id = 'id',
  /** column name */
  Identifier = 'identifier',
  /** column name */
  InstanceId = 'instance_id',
  /** column name */
  Sockets = 'sockets'
}

/** input type for updating data in table "ws_servers" */
export type Ws_Servers_Set_Input = {
  ack?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['uuid']>;
  instance_id?: InputMaybe<Scalars['String']>;
  sockets?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Ws_Servers_Stddev_Fields = {
  __typename?: 'ws_servers_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  sockets?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ws_Servers_Stddev_Pop_Fields = {
  __typename?: 'ws_servers_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sockets?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ws_Servers_Stddev_Samp_Fields = {
  __typename?: 'ws_servers_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sockets?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ws_servers" */
export type Ws_Servers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ws_Servers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ws_Servers_Stream_Cursor_Value_Input = {
  ack?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['uuid']>;
  instance_id?: InputMaybe<Scalars['String']>;
  sockets?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Ws_Servers_Sum_Fields = {
  __typename?: 'ws_servers_sum_fields';
  id?: Maybe<Scalars['Int']>;
  sockets?: Maybe<Scalars['Int']>;
};

/** update columns of table "ws_servers" */
export enum Ws_Servers_Update_Column {
  /** column name */
  Ack = 'ack',
  /** column name */
  Id = 'id',
  /** column name */
  Identifier = 'identifier',
  /** column name */
  InstanceId = 'instance_id',
  /** column name */
  Sockets = 'sockets'
}

export type Ws_Servers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ws_Servers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ws_Servers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ws_Servers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ws_Servers_Var_Pop_Fields = {
  __typename?: 'ws_servers_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sockets?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ws_Servers_Var_Samp_Fields = {
  __typename?: 'ws_servers_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sockets?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ws_Servers_Variance_Fields = {
  __typename?: 'ws_servers_variance_fields';
  id?: Maybe<Scalars['Float']>;
  sockets?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ws_sessions" */
export type Ws_Sessions = {
  __typename?: 'ws_sessions';
  authenticated: Scalars['Boolean'];
  /** An array relationship */
  chat_lists: Array<Chat_List>;
  /** An aggregate relationship */
  chat_lists_aggregate: Chat_List_Aggregate;
  /** An object relationship */
  compliance_contact?: Maybe<Compliance_Contacts_Raw>;
  /** An array relationship */
  compliance_contacts: Array<Compliance_Contacts_Raw>;
  /** An aggregate relationship */
  compliance_contacts_aggregate: Compliance_Contacts_Raw_Aggregate;
  connected_at: Scalars['timestamptz'];
  /** An object relationship */
  contact?: Maybe<Ws_Contacts>;
  /** An object relationship */
  credential?: Maybe<Ws_Sessions_Credentials>;
  id: Scalars['Int'];
  is_multi_device: Scalars['Boolean'];
  keys?: Maybe<Scalars['String']>;
  last_connected_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_pic?: Maybe<Scalars['String']>;
  qr_code?: Maybe<Scalars['String']>;
  qr_code_timestamp?: Maybe<Scalars['timestamptz']>;
  reconnect_attempts: Scalars['Int'];
  /** An object relationship */
  server?: Maybe<Ws_Servers>;
  server_identifier?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  session_keys?: Maybe<Ws_Sessions_Keys>;
  /** An array relationship */
  signal_keys: Array<Ws_Sessions_Signal_Keys>;
  /** An aggregate relationship */
  signal_keys_aggregate: Ws_Sessions_Signal_Keys_Aggregate;
  status?: Maybe<Scalars['String']>;
  uuid: Scalars['uuid'];
  /** An array relationship */
  ws_messages: Array<Ws_Messages>;
  /** An aggregate relationship */
  ws_messages_aggregate: Ws_Messages_Aggregate;
};


/** columns and relationships of "ws_sessions" */
export type Ws_SessionsChat_ListsArgs = {
  distinct_on?: InputMaybe<Array<Chat_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_List_Order_By>>;
  where?: InputMaybe<Chat_List_Bool_Exp>;
};


/** columns and relationships of "ws_sessions" */
export type Ws_SessionsChat_Lists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_List_Order_By>>;
  where?: InputMaybe<Chat_List_Bool_Exp>;
};


/** columns and relationships of "ws_sessions" */
export type Ws_SessionsCompliance_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Raw_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
};


/** columns and relationships of "ws_sessions" */
export type Ws_SessionsCompliance_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Contacts_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Compliance_Contacts_Raw_Order_By>>;
  where?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
};


/** columns and relationships of "ws_sessions" */
export type Ws_SessionsSignal_KeysArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Signal_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Signal_Keys_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Signal_Keys_Bool_Exp>;
};


/** columns and relationships of "ws_sessions" */
export type Ws_SessionsSignal_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Sessions_Signal_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Sessions_Signal_Keys_Order_By>>;
  where?: InputMaybe<Ws_Sessions_Signal_Keys_Bool_Exp>;
};


/** columns and relationships of "ws_sessions" */
export type Ws_SessionsWs_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Ws_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Messages_Order_By>>;
  where?: InputMaybe<Ws_Messages_Bool_Exp>;
};


/** columns and relationships of "ws_sessions" */
export type Ws_SessionsWs_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ws_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ws_Messages_Order_By>>;
  where?: InputMaybe<Ws_Messages_Bool_Exp>;
};

/** aggregated selection of "ws_sessions" */
export type Ws_Sessions_Aggregate = {
  __typename?: 'ws_sessions_aggregate';
  aggregate?: Maybe<Ws_Sessions_Aggregate_Fields>;
  nodes: Array<Ws_Sessions>;
};

export type Ws_Sessions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Ws_Sessions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Ws_Sessions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Ws_Sessions_Aggregate_Bool_Exp_Count>;
};

export type Ws_Sessions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Ws_Sessions_Select_Column_Ws_Sessions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ws_Sessions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ws_Sessions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Ws_Sessions_Select_Column_Ws_Sessions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ws_Sessions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ws_Sessions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ws_Sessions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ws_Sessions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ws_sessions" */
export type Ws_Sessions_Aggregate_Fields = {
  __typename?: 'ws_sessions_aggregate_fields';
  avg?: Maybe<Ws_Sessions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ws_Sessions_Max_Fields>;
  min?: Maybe<Ws_Sessions_Min_Fields>;
  stddev?: Maybe<Ws_Sessions_Stddev_Fields>;
  stddev_pop?: Maybe<Ws_Sessions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ws_Sessions_Stddev_Samp_Fields>;
  sum?: Maybe<Ws_Sessions_Sum_Fields>;
  var_pop?: Maybe<Ws_Sessions_Var_Pop_Fields>;
  var_samp?: Maybe<Ws_Sessions_Var_Samp_Fields>;
  variance?: Maybe<Ws_Sessions_Variance_Fields>;
};


/** aggregate fields of "ws_sessions" */
export type Ws_Sessions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ws_Sessions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ws_sessions" */
export type Ws_Sessions_Aggregate_Order_By = {
  avg?: InputMaybe<Ws_Sessions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ws_Sessions_Max_Order_By>;
  min?: InputMaybe<Ws_Sessions_Min_Order_By>;
  stddev?: InputMaybe<Ws_Sessions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ws_Sessions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ws_Sessions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ws_Sessions_Sum_Order_By>;
  var_pop?: InputMaybe<Ws_Sessions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ws_Sessions_Var_Samp_Order_By>;
  variance?: InputMaybe<Ws_Sessions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ws_sessions" */
export type Ws_Sessions_Arr_Rel_Insert_Input = {
  data: Array<Ws_Sessions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ws_Sessions_On_Conflict>;
};

/** aggregate avg on columns */
export type Ws_Sessions_Avg_Fields = {
  __typename?: 'ws_sessions_avg_fields';
  id?: Maybe<Scalars['Float']>;
  reconnect_attempts?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ws_sessions" */
export type Ws_Sessions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  reconnect_attempts?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ws_sessions". All fields are combined with a logical 'AND'. */
export type Ws_Sessions_Bool_Exp = {
  _and?: InputMaybe<Array<Ws_Sessions_Bool_Exp>>;
  _not?: InputMaybe<Ws_Sessions_Bool_Exp>;
  _or?: InputMaybe<Array<Ws_Sessions_Bool_Exp>>;
  authenticated?: InputMaybe<Boolean_Comparison_Exp>;
  chat_lists?: InputMaybe<Chat_List_Bool_Exp>;
  chat_lists_aggregate?: InputMaybe<Chat_List_Aggregate_Bool_Exp>;
  compliance_contact?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
  compliance_contacts?: InputMaybe<Compliance_Contacts_Raw_Bool_Exp>;
  compliance_contacts_aggregate?: InputMaybe<Compliance_Contacts_Raw_Aggregate_Bool_Exp>;
  connected_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  contact?: InputMaybe<Ws_Contacts_Bool_Exp>;
  credential?: InputMaybe<Ws_Sessions_Credentials_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_multi_device?: InputMaybe<Boolean_Comparison_Exp>;
  keys?: InputMaybe<String_Comparison_Exp>;
  last_connected_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  profile_pic?: InputMaybe<String_Comparison_Exp>;
  qr_code?: InputMaybe<String_Comparison_Exp>;
  qr_code_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  reconnect_attempts?: InputMaybe<Int_Comparison_Exp>;
  server?: InputMaybe<Ws_Servers_Bool_Exp>;
  server_identifier?: InputMaybe<Uuid_Comparison_Exp>;
  session_keys?: InputMaybe<Ws_Sessions_Keys_Bool_Exp>;
  signal_keys?: InputMaybe<Ws_Sessions_Signal_Keys_Bool_Exp>;
  signal_keys_aggregate?: InputMaybe<Ws_Sessions_Signal_Keys_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  ws_messages?: InputMaybe<Ws_Messages_Bool_Exp>;
  ws_messages_aggregate?: InputMaybe<Ws_Messages_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "ws_sessions" */
export enum Ws_Sessions_Constraint {
  /** unique or primary key constraint on columns "id" */
  WsSessionsIdKey = 'ws_sessions_id_key',
  /** unique or primary key constraint on columns "uuid" */
  WsSessionsPkey = 'ws_sessions_pkey',
  /** unique or primary key constraint on columns "uuid" */
  WsSessionsUuidKey = 'ws_sessions_uuid_key'
}

/** columns and relationships of "ws_sessions_credentials" */
export type Ws_Sessions_Credentials = {
  __typename?: 'ws_sessions_credentials';
  created_at?: Maybe<Scalars['timestamptz']>;
  credentials: Scalars['jsonb'];
  id: Scalars['Int'];
  session_uuid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  ws_session: Ws_Sessions;
};


/** columns and relationships of "ws_sessions_credentials" */
export type Ws_Sessions_CredentialsCredentialsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ws_sessions_credentials" */
export type Ws_Sessions_Credentials_Aggregate = {
  __typename?: 'ws_sessions_credentials_aggregate';
  aggregate?: Maybe<Ws_Sessions_Credentials_Aggregate_Fields>;
  nodes: Array<Ws_Sessions_Credentials>;
};

/** aggregate fields of "ws_sessions_credentials" */
export type Ws_Sessions_Credentials_Aggregate_Fields = {
  __typename?: 'ws_sessions_credentials_aggregate_fields';
  avg?: Maybe<Ws_Sessions_Credentials_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ws_Sessions_Credentials_Max_Fields>;
  min?: Maybe<Ws_Sessions_Credentials_Min_Fields>;
  stddev?: Maybe<Ws_Sessions_Credentials_Stddev_Fields>;
  stddev_pop?: Maybe<Ws_Sessions_Credentials_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ws_Sessions_Credentials_Stddev_Samp_Fields>;
  sum?: Maybe<Ws_Sessions_Credentials_Sum_Fields>;
  var_pop?: Maybe<Ws_Sessions_Credentials_Var_Pop_Fields>;
  var_samp?: Maybe<Ws_Sessions_Credentials_Var_Samp_Fields>;
  variance?: Maybe<Ws_Sessions_Credentials_Variance_Fields>;
};


/** aggregate fields of "ws_sessions_credentials" */
export type Ws_Sessions_Credentials_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ws_Sessions_Credentials_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ws_Sessions_Credentials_Append_Input = {
  credentials?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Ws_Sessions_Credentials_Avg_Fields = {
  __typename?: 'ws_sessions_credentials_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ws_sessions_credentials". All fields are combined with a logical 'AND'. */
export type Ws_Sessions_Credentials_Bool_Exp = {
  _and?: InputMaybe<Array<Ws_Sessions_Credentials_Bool_Exp>>;
  _not?: InputMaybe<Ws_Sessions_Credentials_Bool_Exp>;
  _or?: InputMaybe<Array<Ws_Sessions_Credentials_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credentials?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  session_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ws_session?: InputMaybe<Ws_Sessions_Bool_Exp>;
};

/** unique or primary key constraints on table "ws_sessions_credentials" */
export enum Ws_Sessions_Credentials_Constraint {
  /** unique or primary key constraint on columns "id" */
  WsSessionCredentialsPkey = 'ws_session_credentials_pkey',
  /** unique or primary key constraint on columns "session_uuid" */
  WsSessionCredentialsSessionUuidKey = 'ws_session_credentials_session_uuid_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ws_Sessions_Credentials_Delete_At_Path_Input = {
  credentials?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ws_Sessions_Credentials_Delete_Elem_Input = {
  credentials?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ws_Sessions_Credentials_Delete_Key_Input = {
  credentials?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "ws_sessions_credentials" */
export type Ws_Sessions_Credentials_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ws_sessions_credentials" */
export type Ws_Sessions_Credentials_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credentials?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  ws_session?: InputMaybe<Ws_Sessions_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ws_Sessions_Credentials_Max_Fields = {
  __typename?: 'ws_sessions_credentials_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  session_uuid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Ws_Sessions_Credentials_Min_Fields = {
  __typename?: 'ws_sessions_credentials_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  session_uuid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "ws_sessions_credentials" */
export type Ws_Sessions_Credentials_Mutation_Response = {
  __typename?: 'ws_sessions_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ws_Sessions_Credentials>;
};

/** input type for inserting object relation for remote table "ws_sessions_credentials" */
export type Ws_Sessions_Credentials_Obj_Rel_Insert_Input = {
  data: Ws_Sessions_Credentials_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ws_Sessions_Credentials_On_Conflict>;
};

/** on_conflict condition type for table "ws_sessions_credentials" */
export type Ws_Sessions_Credentials_On_Conflict = {
  constraint: Ws_Sessions_Credentials_Constraint;
  update_columns?: Array<Ws_Sessions_Credentials_Update_Column>;
  where?: InputMaybe<Ws_Sessions_Credentials_Bool_Exp>;
};

/** Ordering options when selecting data from "ws_sessions_credentials". */
export type Ws_Sessions_Credentials_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credentials?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  ws_session?: InputMaybe<Ws_Sessions_Order_By>;
};

/** primary key columns input for table: ws_sessions_credentials */
export type Ws_Sessions_Credentials_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ws_Sessions_Credentials_Prepend_Input = {
  credentials?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ws_sessions_credentials" */
export enum Ws_Sessions_Credentials_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credentials = 'credentials',
  /** column name */
  Id = 'id',
  /** column name */
  SessionUuid = 'session_uuid',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ws_sessions_credentials" */
export type Ws_Sessions_Credentials_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credentials?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Ws_Sessions_Credentials_Stddev_Fields = {
  __typename?: 'ws_sessions_credentials_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ws_Sessions_Credentials_Stddev_Pop_Fields = {
  __typename?: 'ws_sessions_credentials_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ws_Sessions_Credentials_Stddev_Samp_Fields = {
  __typename?: 'ws_sessions_credentials_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ws_sessions_credentials" */
export type Ws_Sessions_Credentials_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ws_Sessions_Credentials_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ws_Sessions_Credentials_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credentials?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Ws_Sessions_Credentials_Sum_Fields = {
  __typename?: 'ws_sessions_credentials_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "ws_sessions_credentials" */
export enum Ws_Sessions_Credentials_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credentials = 'credentials',
  /** column name */
  Id = 'id',
  /** column name */
  SessionUuid = 'session_uuid',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ws_Sessions_Credentials_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ws_Sessions_Credentials_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ws_Sessions_Credentials_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ws_Sessions_Credentials_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ws_Sessions_Credentials_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ws_Sessions_Credentials_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ws_Sessions_Credentials_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ws_Sessions_Credentials_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ws_Sessions_Credentials_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ws_Sessions_Credentials_Var_Pop_Fields = {
  __typename?: 'ws_sessions_credentials_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ws_Sessions_Credentials_Var_Samp_Fields = {
  __typename?: 'ws_sessions_credentials_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ws_Sessions_Credentials_Variance_Fields = {
  __typename?: 'ws_sessions_credentials_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "ws_sessions" */
export type Ws_Sessions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  reconnect_attempts?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ws_sessions" */
export type Ws_Sessions_Insert_Input = {
  authenticated?: InputMaybe<Scalars['Boolean']>;
  chat_lists?: InputMaybe<Chat_List_Arr_Rel_Insert_Input>;
  compliance_contact?: InputMaybe<Compliance_Contacts_Raw_Obj_Rel_Insert_Input>;
  compliance_contacts?: InputMaybe<Compliance_Contacts_Raw_Arr_Rel_Insert_Input>;
  connected_at?: InputMaybe<Scalars['timestamptz']>;
  contact?: InputMaybe<Ws_Contacts_Obj_Rel_Insert_Input>;
  credential?: InputMaybe<Ws_Sessions_Credentials_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_multi_device?: InputMaybe<Scalars['Boolean']>;
  keys?: InputMaybe<Scalars['String']>;
  last_connected_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profile_pic?: InputMaybe<Scalars['String']>;
  qr_code?: InputMaybe<Scalars['String']>;
  qr_code_timestamp?: InputMaybe<Scalars['timestamptz']>;
  reconnect_attempts?: InputMaybe<Scalars['Int']>;
  server?: InputMaybe<Ws_Servers_Obj_Rel_Insert_Input>;
  server_identifier?: InputMaybe<Scalars['uuid']>;
  session_keys?: InputMaybe<Ws_Sessions_Keys_Obj_Rel_Insert_Input>;
  signal_keys?: InputMaybe<Ws_Sessions_Signal_Keys_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
  ws_messages?: InputMaybe<Ws_Messages_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "ws_sessions_keys" */
export type Ws_Sessions_Keys = {
  __typename?: 'ws_sessions_keys';
  auth_credentials?: Maybe<Scalars['String']>;
  auth_keys?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  session_uuid: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  ws_session: Ws_Sessions;
};

/** aggregated selection of "ws_sessions_keys" */
export type Ws_Sessions_Keys_Aggregate = {
  __typename?: 'ws_sessions_keys_aggregate';
  aggregate?: Maybe<Ws_Sessions_Keys_Aggregate_Fields>;
  nodes: Array<Ws_Sessions_Keys>;
};

/** aggregate fields of "ws_sessions_keys" */
export type Ws_Sessions_Keys_Aggregate_Fields = {
  __typename?: 'ws_sessions_keys_aggregate_fields';
  avg?: Maybe<Ws_Sessions_Keys_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ws_Sessions_Keys_Max_Fields>;
  min?: Maybe<Ws_Sessions_Keys_Min_Fields>;
  stddev?: Maybe<Ws_Sessions_Keys_Stddev_Fields>;
  stddev_pop?: Maybe<Ws_Sessions_Keys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ws_Sessions_Keys_Stddev_Samp_Fields>;
  sum?: Maybe<Ws_Sessions_Keys_Sum_Fields>;
  var_pop?: Maybe<Ws_Sessions_Keys_Var_Pop_Fields>;
  var_samp?: Maybe<Ws_Sessions_Keys_Var_Samp_Fields>;
  variance?: Maybe<Ws_Sessions_Keys_Variance_Fields>;
};


/** aggregate fields of "ws_sessions_keys" */
export type Ws_Sessions_Keys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ws_Sessions_Keys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Ws_Sessions_Keys_Avg_Fields = {
  __typename?: 'ws_sessions_keys_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ws_sessions_keys". All fields are combined with a logical 'AND'. */
export type Ws_Sessions_Keys_Bool_Exp = {
  _and?: InputMaybe<Array<Ws_Sessions_Keys_Bool_Exp>>;
  _not?: InputMaybe<Ws_Sessions_Keys_Bool_Exp>;
  _or?: InputMaybe<Array<Ws_Sessions_Keys_Bool_Exp>>;
  auth_credentials?: InputMaybe<String_Comparison_Exp>;
  auth_keys?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  session_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ws_session?: InputMaybe<Ws_Sessions_Bool_Exp>;
};

/** unique or primary key constraints on table "ws_sessions_keys" */
export enum Ws_Sessions_Keys_Constraint {
  /** unique or primary key constraint on columns "id" */
  WsSessionsKeysPkey = 'ws_sessions_keys_pkey',
  /** unique or primary key constraint on columns "session_uuid" */
  WsSessionsKeysSessionUuidKey = 'ws_sessions_keys_session_uuid_key'
}

/** input type for incrementing numeric columns in table "ws_sessions_keys" */
export type Ws_Sessions_Keys_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ws_sessions_keys" */
export type Ws_Sessions_Keys_Insert_Input = {
  auth_credentials?: InputMaybe<Scalars['String']>;
  auth_keys?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  ws_session?: InputMaybe<Ws_Sessions_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ws_Sessions_Keys_Max_Fields = {
  __typename?: 'ws_sessions_keys_max_fields';
  auth_credentials?: Maybe<Scalars['String']>;
  auth_keys?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  session_uuid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Ws_Sessions_Keys_Min_Fields = {
  __typename?: 'ws_sessions_keys_min_fields';
  auth_credentials?: Maybe<Scalars['String']>;
  auth_keys?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  session_uuid?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "ws_sessions_keys" */
export type Ws_Sessions_Keys_Mutation_Response = {
  __typename?: 'ws_sessions_keys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ws_Sessions_Keys>;
};

/** input type for inserting object relation for remote table "ws_sessions_keys" */
export type Ws_Sessions_Keys_Obj_Rel_Insert_Input = {
  data: Ws_Sessions_Keys_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ws_Sessions_Keys_On_Conflict>;
};

/** on_conflict condition type for table "ws_sessions_keys" */
export type Ws_Sessions_Keys_On_Conflict = {
  constraint: Ws_Sessions_Keys_Constraint;
  update_columns?: Array<Ws_Sessions_Keys_Update_Column>;
  where?: InputMaybe<Ws_Sessions_Keys_Bool_Exp>;
};

/** Ordering options when selecting data from "ws_sessions_keys". */
export type Ws_Sessions_Keys_Order_By = {
  auth_credentials?: InputMaybe<Order_By>;
  auth_keys?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_uuid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  ws_session?: InputMaybe<Ws_Sessions_Order_By>;
};

/** primary key columns input for table: ws_sessions_keys */
export type Ws_Sessions_Keys_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "ws_sessions_keys" */
export enum Ws_Sessions_Keys_Select_Column {
  /** column name */
  AuthCredentials = 'auth_credentials',
  /** column name */
  AuthKeys = 'auth_keys',
  /** column name */
  Id = 'id',
  /** column name */
  SessionUuid = 'session_uuid',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ws_sessions_keys" */
export type Ws_Sessions_Keys_Set_Input = {
  auth_credentials?: InputMaybe<Scalars['String']>;
  auth_keys?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Ws_Sessions_Keys_Stddev_Fields = {
  __typename?: 'ws_sessions_keys_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ws_Sessions_Keys_Stddev_Pop_Fields = {
  __typename?: 'ws_sessions_keys_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ws_Sessions_Keys_Stddev_Samp_Fields = {
  __typename?: 'ws_sessions_keys_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ws_sessions_keys" */
export type Ws_Sessions_Keys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ws_Sessions_Keys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ws_Sessions_Keys_Stream_Cursor_Value_Input = {
  auth_credentials?: InputMaybe<Scalars['String']>;
  auth_keys?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Ws_Sessions_Keys_Sum_Fields = {
  __typename?: 'ws_sessions_keys_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "ws_sessions_keys" */
export enum Ws_Sessions_Keys_Update_Column {
  /** column name */
  AuthCredentials = 'auth_credentials',
  /** column name */
  AuthKeys = 'auth_keys',
  /** column name */
  Id = 'id',
  /** column name */
  SessionUuid = 'session_uuid',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ws_Sessions_Keys_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ws_Sessions_Keys_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ws_Sessions_Keys_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ws_Sessions_Keys_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ws_Sessions_Keys_Var_Pop_Fields = {
  __typename?: 'ws_sessions_keys_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ws_Sessions_Keys_Var_Samp_Fields = {
  __typename?: 'ws_sessions_keys_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ws_Sessions_Keys_Variance_Fields = {
  __typename?: 'ws_sessions_keys_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Ws_Sessions_Max_Fields = {
  __typename?: 'ws_sessions_max_fields';
  connected_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  keys?: Maybe<Scalars['String']>;
  last_connected_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_pic?: Maybe<Scalars['String']>;
  qr_code?: Maybe<Scalars['String']>;
  qr_code_timestamp?: Maybe<Scalars['timestamptz']>;
  reconnect_attempts?: Maybe<Scalars['Int']>;
  server_identifier?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ws_sessions" */
export type Ws_Sessions_Max_Order_By = {
  connected_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  keys?: InputMaybe<Order_By>;
  last_connected_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  profile_pic?: InputMaybe<Order_By>;
  qr_code?: InputMaybe<Order_By>;
  qr_code_timestamp?: InputMaybe<Order_By>;
  reconnect_attempts?: InputMaybe<Order_By>;
  server_identifier?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ws_Sessions_Min_Fields = {
  __typename?: 'ws_sessions_min_fields';
  connected_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  keys?: Maybe<Scalars['String']>;
  last_connected_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_pic?: Maybe<Scalars['String']>;
  qr_code?: Maybe<Scalars['String']>;
  qr_code_timestamp?: Maybe<Scalars['timestamptz']>;
  reconnect_attempts?: Maybe<Scalars['Int']>;
  server_identifier?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ws_sessions" */
export type Ws_Sessions_Min_Order_By = {
  connected_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  keys?: InputMaybe<Order_By>;
  last_connected_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  profile_pic?: InputMaybe<Order_By>;
  qr_code?: InputMaybe<Order_By>;
  qr_code_timestamp?: InputMaybe<Order_By>;
  reconnect_attempts?: InputMaybe<Order_By>;
  server_identifier?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ws_sessions" */
export type Ws_Sessions_Mutation_Response = {
  __typename?: 'ws_sessions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ws_Sessions>;
};

/** input type for inserting object relation for remote table "ws_sessions" */
export type Ws_Sessions_Obj_Rel_Insert_Input = {
  data: Ws_Sessions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ws_Sessions_On_Conflict>;
};

/** on_conflict condition type for table "ws_sessions" */
export type Ws_Sessions_On_Conflict = {
  constraint: Ws_Sessions_Constraint;
  update_columns?: Array<Ws_Sessions_Update_Column>;
  where?: InputMaybe<Ws_Sessions_Bool_Exp>;
};

/** Ordering options when selecting data from "ws_sessions". */
export type Ws_Sessions_Order_By = {
  authenticated?: InputMaybe<Order_By>;
  chat_lists_aggregate?: InputMaybe<Chat_List_Aggregate_Order_By>;
  compliance_contact?: InputMaybe<Compliance_Contacts_Raw_Order_By>;
  compliance_contacts_aggregate?: InputMaybe<Compliance_Contacts_Raw_Aggregate_Order_By>;
  connected_at?: InputMaybe<Order_By>;
  contact?: InputMaybe<Ws_Contacts_Order_By>;
  credential?: InputMaybe<Ws_Sessions_Credentials_Order_By>;
  id?: InputMaybe<Order_By>;
  is_multi_device?: InputMaybe<Order_By>;
  keys?: InputMaybe<Order_By>;
  last_connected_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  profile_pic?: InputMaybe<Order_By>;
  qr_code?: InputMaybe<Order_By>;
  qr_code_timestamp?: InputMaybe<Order_By>;
  reconnect_attempts?: InputMaybe<Order_By>;
  server?: InputMaybe<Ws_Servers_Order_By>;
  server_identifier?: InputMaybe<Order_By>;
  session_keys?: InputMaybe<Ws_Sessions_Keys_Order_By>;
  signal_keys_aggregate?: InputMaybe<Ws_Sessions_Signal_Keys_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  ws_messages_aggregate?: InputMaybe<Ws_Messages_Aggregate_Order_By>;
};

/** primary key columns input for table: ws_sessions */
export type Ws_Sessions_Pk_Columns_Input = {
  uuid: Scalars['uuid'];
};

/** select columns of table "ws_sessions" */
export enum Ws_Sessions_Select_Column {
  /** column name */
  Authenticated = 'authenticated',
  /** column name */
  ConnectedAt = 'connected_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsMultiDevice = 'is_multi_device',
  /** column name */
  Keys = 'keys',
  /** column name */
  LastConnectedAt = 'last_connected_at',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProfilePic = 'profile_pic',
  /** column name */
  QrCode = 'qr_code',
  /** column name */
  QrCodeTimestamp = 'qr_code_timestamp',
  /** column name */
  ReconnectAttempts = 'reconnect_attempts',
  /** column name */
  ServerIdentifier = 'server_identifier',
  /** column name */
  Status = 'status',
  /** column name */
  Uuid = 'uuid'
}

/** select "ws_sessions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ws_sessions" */
export enum Ws_Sessions_Select_Column_Ws_Sessions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Authenticated = 'authenticated',
  /** column name */
  IsMultiDevice = 'is_multi_device'
}

/** select "ws_sessions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ws_sessions" */
export enum Ws_Sessions_Select_Column_Ws_Sessions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Authenticated = 'authenticated',
  /** column name */
  IsMultiDevice = 'is_multi_device'
}

/** input type for updating data in table "ws_sessions" */
export type Ws_Sessions_Set_Input = {
  authenticated?: InputMaybe<Scalars['Boolean']>;
  connected_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_multi_device?: InputMaybe<Scalars['Boolean']>;
  keys?: InputMaybe<Scalars['String']>;
  last_connected_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profile_pic?: InputMaybe<Scalars['String']>;
  qr_code?: InputMaybe<Scalars['String']>;
  qr_code_timestamp?: InputMaybe<Scalars['timestamptz']>;
  reconnect_attempts?: InputMaybe<Scalars['Int']>;
  server_identifier?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys = {
  __typename?: 'ws_sessions_signal_keys';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  session_uuid: Scalars['uuid'];
  signal_data: Scalars['jsonb'];
  signal_id: Scalars['String'];
  signal_type: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ws_session: Ws_Sessions;
};


/** columns and relationships of "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_KeysSignal_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Aggregate = {
  __typename?: 'ws_sessions_signal_keys_aggregate';
  aggregate?: Maybe<Ws_Sessions_Signal_Keys_Aggregate_Fields>;
  nodes: Array<Ws_Sessions_Signal_Keys>;
};

export type Ws_Sessions_Signal_Keys_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ws_Sessions_Signal_Keys_Aggregate_Bool_Exp_Count>;
};

export type Ws_Sessions_Signal_Keys_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ws_Sessions_Signal_Keys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ws_Sessions_Signal_Keys_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Aggregate_Fields = {
  __typename?: 'ws_sessions_signal_keys_aggregate_fields';
  avg?: Maybe<Ws_Sessions_Signal_Keys_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ws_Sessions_Signal_Keys_Max_Fields>;
  min?: Maybe<Ws_Sessions_Signal_Keys_Min_Fields>;
  stddev?: Maybe<Ws_Sessions_Signal_Keys_Stddev_Fields>;
  stddev_pop?: Maybe<Ws_Sessions_Signal_Keys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ws_Sessions_Signal_Keys_Stddev_Samp_Fields>;
  sum?: Maybe<Ws_Sessions_Signal_Keys_Sum_Fields>;
  var_pop?: Maybe<Ws_Sessions_Signal_Keys_Var_Pop_Fields>;
  var_samp?: Maybe<Ws_Sessions_Signal_Keys_Var_Samp_Fields>;
  variance?: Maybe<Ws_Sessions_Signal_Keys_Variance_Fields>;
};


/** aggregate fields of "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ws_Sessions_Signal_Keys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Aggregate_Order_By = {
  avg?: InputMaybe<Ws_Sessions_Signal_Keys_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ws_Sessions_Signal_Keys_Max_Order_By>;
  min?: InputMaybe<Ws_Sessions_Signal_Keys_Min_Order_By>;
  stddev?: InputMaybe<Ws_Sessions_Signal_Keys_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ws_Sessions_Signal_Keys_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ws_Sessions_Signal_Keys_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ws_Sessions_Signal_Keys_Sum_Order_By>;
  var_pop?: InputMaybe<Ws_Sessions_Signal_Keys_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ws_Sessions_Signal_Keys_Var_Samp_Order_By>;
  variance?: InputMaybe<Ws_Sessions_Signal_Keys_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ws_Sessions_Signal_Keys_Append_Input = {
  signal_data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Arr_Rel_Insert_Input = {
  data: Array<Ws_Sessions_Signal_Keys_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ws_Sessions_Signal_Keys_On_Conflict>;
};

/** aggregate avg on columns */
export type Ws_Sessions_Signal_Keys_Avg_Fields = {
  __typename?: 'ws_sessions_signal_keys_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ws_sessions_signal_keys". All fields are combined with a logical 'AND'. */
export type Ws_Sessions_Signal_Keys_Bool_Exp = {
  _and?: InputMaybe<Array<Ws_Sessions_Signal_Keys_Bool_Exp>>;
  _not?: InputMaybe<Ws_Sessions_Signal_Keys_Bool_Exp>;
  _or?: InputMaybe<Array<Ws_Sessions_Signal_Keys_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  session_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  signal_data?: InputMaybe<Jsonb_Comparison_Exp>;
  signal_id?: InputMaybe<String_Comparison_Exp>;
  signal_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ws_session?: InputMaybe<Ws_Sessions_Bool_Exp>;
};

/** unique or primary key constraints on table "ws_sessions_signal_keys" */
export enum Ws_Sessions_Signal_Keys_Constraint {
  /** unique or primary key constraint on columns "id" */
  WsSessionsSignalKeysPkey = 'ws_sessions_signal_keys_pkey',
  /** unique or primary key constraint on columns "session_uuid", "signal_type", "signal_id" */
  WsSessionsSignalKeysSessionUuidSignalTypeSignalIdKey = 'ws_sessions_signal_keys_session_uuid_signal_type_signal_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ws_Sessions_Signal_Keys_Delete_At_Path_Input = {
  signal_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ws_Sessions_Signal_Keys_Delete_Elem_Input = {
  signal_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ws_Sessions_Signal_Keys_Delete_Key_Input = {
  signal_data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  signal_data?: InputMaybe<Scalars['jsonb']>;
  signal_id?: InputMaybe<Scalars['String']>;
  signal_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  ws_session?: InputMaybe<Ws_Sessions_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ws_Sessions_Signal_Keys_Max_Fields = {
  __typename?: 'ws_sessions_signal_keys_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  session_uuid?: Maybe<Scalars['uuid']>;
  signal_id?: Maybe<Scalars['String']>;
  signal_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_uuid?: InputMaybe<Order_By>;
  signal_id?: InputMaybe<Order_By>;
  signal_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ws_Sessions_Signal_Keys_Min_Fields = {
  __typename?: 'ws_sessions_signal_keys_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  session_uuid?: Maybe<Scalars['uuid']>;
  signal_id?: Maybe<Scalars['String']>;
  signal_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_uuid?: InputMaybe<Order_By>;
  signal_id?: InputMaybe<Order_By>;
  signal_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Mutation_Response = {
  __typename?: 'ws_sessions_signal_keys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ws_Sessions_Signal_Keys>;
};

/** on_conflict condition type for table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_On_Conflict = {
  constraint: Ws_Sessions_Signal_Keys_Constraint;
  update_columns?: Array<Ws_Sessions_Signal_Keys_Update_Column>;
  where?: InputMaybe<Ws_Sessions_Signal_Keys_Bool_Exp>;
};

/** Ordering options when selecting data from "ws_sessions_signal_keys". */
export type Ws_Sessions_Signal_Keys_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_uuid?: InputMaybe<Order_By>;
  signal_data?: InputMaybe<Order_By>;
  signal_id?: InputMaybe<Order_By>;
  signal_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  ws_session?: InputMaybe<Ws_Sessions_Order_By>;
};

/** primary key columns input for table: ws_sessions_signal_keys */
export type Ws_Sessions_Signal_Keys_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ws_Sessions_Signal_Keys_Prepend_Input = {
  signal_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ws_sessions_signal_keys" */
export enum Ws_Sessions_Signal_Keys_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SessionUuid = 'session_uuid',
  /** column name */
  SignalData = 'signal_data',
  /** column name */
  SignalId = 'signal_id',
  /** column name */
  SignalType = 'signal_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  signal_data?: InputMaybe<Scalars['jsonb']>;
  signal_id?: InputMaybe<Scalars['String']>;
  signal_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Ws_Sessions_Signal_Keys_Stddev_Fields = {
  __typename?: 'ws_sessions_signal_keys_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ws_Sessions_Signal_Keys_Stddev_Pop_Fields = {
  __typename?: 'ws_sessions_signal_keys_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ws_Sessions_Signal_Keys_Stddev_Samp_Fields = {
  __typename?: 'ws_sessions_signal_keys_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ws_Sessions_Signal_Keys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ws_Sessions_Signal_Keys_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  session_uuid?: InputMaybe<Scalars['uuid']>;
  signal_data?: InputMaybe<Scalars['jsonb']>;
  signal_id?: InputMaybe<Scalars['String']>;
  signal_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Ws_Sessions_Signal_Keys_Sum_Fields = {
  __typename?: 'ws_sessions_signal_keys_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "ws_sessions_signal_keys" */
export enum Ws_Sessions_Signal_Keys_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SessionUuid = 'session_uuid',
  /** column name */
  SignalData = 'signal_data',
  /** column name */
  SignalId = 'signal_id',
  /** column name */
  SignalType = 'signal_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ws_Sessions_Signal_Keys_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ws_Sessions_Signal_Keys_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ws_Sessions_Signal_Keys_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ws_Sessions_Signal_Keys_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ws_Sessions_Signal_Keys_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ws_Sessions_Signal_Keys_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ws_Sessions_Signal_Keys_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ws_Sessions_Signal_Keys_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ws_Sessions_Signal_Keys_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ws_Sessions_Signal_Keys_Var_Pop_Fields = {
  __typename?: 'ws_sessions_signal_keys_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ws_Sessions_Signal_Keys_Var_Samp_Fields = {
  __typename?: 'ws_sessions_signal_keys_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ws_Sessions_Signal_Keys_Variance_Fields = {
  __typename?: 'ws_sessions_signal_keys_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ws_sessions_signal_keys" */
export type Ws_Sessions_Signal_Keys_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ws_sessions_stats" */
export type Ws_Sessions_Stats = {
  __typename?: 'ws_sessions_stats';
  id: Scalars['Int'];
  status: Scalars['String'];
  timestamp: Scalars['timestamptz'];
  ws_session_id: Scalars['Int'];
};

/** aggregated selection of "ws_sessions_stats" */
export type Ws_Sessions_Stats_Aggregate = {
  __typename?: 'ws_sessions_stats_aggregate';
  aggregate?: Maybe<Ws_Sessions_Stats_Aggregate_Fields>;
  nodes: Array<Ws_Sessions_Stats>;
};

/** aggregate fields of "ws_sessions_stats" */
export type Ws_Sessions_Stats_Aggregate_Fields = {
  __typename?: 'ws_sessions_stats_aggregate_fields';
  avg?: Maybe<Ws_Sessions_Stats_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ws_Sessions_Stats_Max_Fields>;
  min?: Maybe<Ws_Sessions_Stats_Min_Fields>;
  stddev?: Maybe<Ws_Sessions_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Ws_Sessions_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ws_Sessions_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Ws_Sessions_Stats_Sum_Fields>;
  var_pop?: Maybe<Ws_Sessions_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Ws_Sessions_Stats_Var_Samp_Fields>;
  variance?: Maybe<Ws_Sessions_Stats_Variance_Fields>;
};


/** aggregate fields of "ws_sessions_stats" */
export type Ws_Sessions_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ws_Sessions_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Ws_Sessions_Stats_Avg_Fields = {
  __typename?: 'ws_sessions_stats_avg_fields';
  id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ws_sessions_stats". All fields are combined with a logical 'AND'. */
export type Ws_Sessions_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Ws_Sessions_Stats_Bool_Exp>>;
  _not?: InputMaybe<Ws_Sessions_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Ws_Sessions_Stats_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ws_session_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "ws_sessions_stats" */
export enum Ws_Sessions_Stats_Constraint {
  /** unique or primary key constraint on columns "id" */
  WsSessionsStatsPkey = 'ws_sessions_stats_pkey'
}

/** input type for incrementing numeric columns in table "ws_sessions_stats" */
export type Ws_Sessions_Stats_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  ws_session_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ws_sessions_stats" */
export type Ws_Sessions_Stats_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  ws_session_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Ws_Sessions_Stats_Max_Fields = {
  __typename?: 'ws_sessions_stats_max_fields';
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  ws_session_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Ws_Sessions_Stats_Min_Fields = {
  __typename?: 'ws_sessions_stats_min_fields';
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  ws_session_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "ws_sessions_stats" */
export type Ws_Sessions_Stats_Mutation_Response = {
  __typename?: 'ws_sessions_stats_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ws_Sessions_Stats>;
};

/** on_conflict condition type for table "ws_sessions_stats" */
export type Ws_Sessions_Stats_On_Conflict = {
  constraint: Ws_Sessions_Stats_Constraint;
  update_columns?: Array<Ws_Sessions_Stats_Update_Column>;
  where?: InputMaybe<Ws_Sessions_Stats_Bool_Exp>;
};

/** Ordering options when selecting data from "ws_sessions_stats". */
export type Ws_Sessions_Stats_Order_By = {
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  ws_session_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ws_sessions_stats */
export type Ws_Sessions_Stats_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "ws_sessions_stats" */
export enum Ws_Sessions_Stats_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  WsSessionId = 'ws_session_id'
}

/** input type for updating data in table "ws_sessions_stats" */
export type Ws_Sessions_Stats_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  ws_session_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Ws_Sessions_Stats_Stddev_Fields = {
  __typename?: 'ws_sessions_stats_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ws_Sessions_Stats_Stddev_Pop_Fields = {
  __typename?: 'ws_sessions_stats_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ws_Sessions_Stats_Stddev_Samp_Fields = {
  __typename?: 'ws_sessions_stats_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ws_sessions_stats" */
export type Ws_Sessions_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ws_Sessions_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ws_Sessions_Stats_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  ws_session_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Ws_Sessions_Stats_Sum_Fields = {
  __typename?: 'ws_sessions_stats_sum_fields';
  id?: Maybe<Scalars['Int']>;
  ws_session_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "ws_sessions_stats" */
export enum Ws_Sessions_Stats_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  WsSessionId = 'ws_session_id'
}

export type Ws_Sessions_Stats_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ws_Sessions_Stats_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ws_Sessions_Stats_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ws_Sessions_Stats_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ws_Sessions_Stats_Var_Pop_Fields = {
  __typename?: 'ws_sessions_stats_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ws_Sessions_Stats_Var_Samp_Fields = {
  __typename?: 'ws_sessions_stats_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ws_Sessions_Stats_Variance_Fields = {
  __typename?: 'ws_sessions_stats_variance_fields';
  id?: Maybe<Scalars['Float']>;
  ws_session_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Ws_Sessions_Stddev_Fields = {
  __typename?: 'ws_sessions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  reconnect_attempts?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ws_sessions" */
export type Ws_Sessions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  reconnect_attempts?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ws_Sessions_Stddev_Pop_Fields = {
  __typename?: 'ws_sessions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  reconnect_attempts?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ws_sessions" */
export type Ws_Sessions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  reconnect_attempts?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ws_Sessions_Stddev_Samp_Fields = {
  __typename?: 'ws_sessions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  reconnect_attempts?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ws_sessions" */
export type Ws_Sessions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  reconnect_attempts?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ws_sessions" */
export type Ws_Sessions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ws_Sessions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ws_Sessions_Stream_Cursor_Value_Input = {
  authenticated?: InputMaybe<Scalars['Boolean']>;
  connected_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_multi_device?: InputMaybe<Scalars['Boolean']>;
  keys?: InputMaybe<Scalars['String']>;
  last_connected_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profile_pic?: InputMaybe<Scalars['String']>;
  qr_code?: InputMaybe<Scalars['String']>;
  qr_code_timestamp?: InputMaybe<Scalars['timestamptz']>;
  reconnect_attempts?: InputMaybe<Scalars['Int']>;
  server_identifier?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Ws_Sessions_Sum_Fields = {
  __typename?: 'ws_sessions_sum_fields';
  id?: Maybe<Scalars['Int']>;
  reconnect_attempts?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ws_sessions" */
export type Ws_Sessions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  reconnect_attempts?: InputMaybe<Order_By>;
};

/** update columns of table "ws_sessions" */
export enum Ws_Sessions_Update_Column {
  /** column name */
  Authenticated = 'authenticated',
  /** column name */
  ConnectedAt = 'connected_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsMultiDevice = 'is_multi_device',
  /** column name */
  Keys = 'keys',
  /** column name */
  LastConnectedAt = 'last_connected_at',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProfilePic = 'profile_pic',
  /** column name */
  QrCode = 'qr_code',
  /** column name */
  QrCodeTimestamp = 'qr_code_timestamp',
  /** column name */
  ReconnectAttempts = 'reconnect_attempts',
  /** column name */
  ServerIdentifier = 'server_identifier',
  /** column name */
  Status = 'status',
  /** column name */
  Uuid = 'uuid'
}

export type Ws_Sessions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ws_Sessions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ws_Sessions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ws_Sessions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ws_Sessions_Var_Pop_Fields = {
  __typename?: 'ws_sessions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  reconnect_attempts?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ws_sessions" */
export type Ws_Sessions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  reconnect_attempts?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ws_Sessions_Var_Samp_Fields = {
  __typename?: 'ws_sessions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  reconnect_attempts?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ws_sessions" */
export type Ws_Sessions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  reconnect_attempts?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ws_Sessions_Variance_Fields = {
  __typename?: 'ws_sessions_variance_fields';
  id?: Maybe<Scalars['Float']>;
  reconnect_attempts?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ws_sessions" */
export type Ws_Sessions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  reconnect_attempts?: InputMaybe<Order_By>;
};

export type ImportCsvManagersGQlQueryVariables = Exact<{
  complianceId: Scalars['Int'];
}>;


export type ImportCsvManagersGQlQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: number, email?: string | null, name?: string | null, phone?: string | null }>, compliance_groups: Array<{ __typename?: 'compliance_groups', id: number, name: string, compliance_group_users: Array<{ __typename?: 'compliance_group_users', user: { __typename?: 'users', id: number, email?: string | null, name?: string | null, phone?: string | null } }> }> };

export type UpsertUsersGqlMutationVariables = Exact<{
  objects: Array<Users_Insert_Input> | Users_Insert_Input;
}>;


export type UpsertUsersGqlMutation = { __typename?: 'mutation_root', insert_users?: { __typename?: 'users_mutation_response', returning: Array<{ __typename?: 'users', email?: string | null, id: number, phone?: string | null, name?: string | null }> } | null };

export type ComplianceGroupsAndUsersQueryVariables = Exact<{
  complianceId: Scalars['Int'];
}>;


export type ComplianceGroupsAndUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: number, email?: string | null, name?: string | null }>, compliance_contacts_raw: Array<{ __typename?: 'compliance_contacts_raw', email?: string | null, id: number, name?: string | null, phone?: string | null, deleted: boolean, status: string, compliance_group_contact?: { __typename?: 'compliance_group_contacts', compliance_group?: { __typename?: 'compliance_groups', name: string, id: number } | null } | null }>, compliance_groups: Array<{ __typename?: 'compliance_groups', id: number, name: string }> };

export type ComplianceGroupsInsertApigqlMutationVariables = Exact<{
  objects: Array<Compliance_Groups_Insert_Input> | Compliance_Groups_Insert_Input;
}>;


export type ComplianceGroupsInsertApigqlMutation = { __typename?: 'mutation_root', insert_compliance_groups?: { __typename?: 'compliance_groups_mutation_response', returning: Array<{ __typename?: 'compliance_groups', id: number, name: string }> } | null };

export type ComplianceContactsUpsertApigqlMutationVariables = Exact<{
  objects: Array<Compliance_Contacts_Raw_Insert_Input> | Compliance_Contacts_Raw_Insert_Input;
}>;


export type ComplianceContactsUpsertApigqlMutation = { __typename?: 'mutation_root', insert_compliance_contacts_raw?: { __typename?: 'compliance_contacts_raw_mutation_response', returning: Array<{ __typename?: 'compliance_contacts_raw', id: number, name?: string | null, email?: string | null, phone?: string | null, status: string }> } | null };

export type InsertComplianceContactsGqlMutationVariables = Exact<{
  insertComplianceContactData: Array<InsertComplianceContactsInput> | InsertComplianceContactsInput;
}>;


export type InsertComplianceContactsGqlMutation = { __typename?: 'mutation_root', insertComplianceContacts?: { __typename?: 'InsertComplianceContactsOutput', inserted_compliance_contacts: Array<{ __typename?: 'InsertedComplianceContact', created_at: string, email?: string | null, id: number, invite_counter: number, name?: string | null, phone?: string | null, status: string, updated_at: string }> } | null };

export type ComplianceContactGroupUsertApigqlMutationVariables = Exact<{
  objects: Array<Compliance_Group_Contacts_Insert_Input> | Compliance_Group_Contacts_Insert_Input;
}>;


export type ComplianceContactGroupUsertApigqlMutation = { __typename?: 'mutation_root', insert_compliance_group_contacts?: { __typename?: 'compliance_group_contacts_mutation_response', returning: Array<{ __typename?: 'compliance_group_contacts', id: number, compliance_contact?: { __typename?: 'compliance_contacts_raw', id: number, name?: string | null, email?: string | null, phone?: string | null, status: string } | null, compliance_group?: { __typename?: 'compliance_groups', name: string, id: number } | null }> } | null };

export type DeleteComplianceGroupContactsGqlMutationVariables = Exact<{
  objects?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type DeleteComplianceGroupContactsGqlMutation = { __typename?: 'mutation_root', delete_compliance_group_contacts?: { __typename?: 'compliance_group_contacts_mutation_response', returning: Array<{ __typename?: 'compliance_group_contacts', id: number }> } | null };

export type InsertUsersApigqlMutationVariables = Exact<{
  objects: Array<UsersInsert> | UsersInsert;
}>;


export type InsertUsersApigqlMutation = { __typename?: 'mutation_root', insertUsers?: { __typename?: 'UsersInsertOutput', inserted_users: Array<{ __typename?: 'InsertedUser', id: number, email: string, name?: string | null }> } | null };

export type InsertComplianceGroupUsersApigqlMutationVariables = Exact<{
  objects: Array<Compliance_Group_Users_Insert_Input> | Compliance_Group_Users_Insert_Input;
}>;


export type InsertComplianceGroupUsersApigqlMutation = { __typename?: 'mutation_root', insert_compliance_group_users?: { __typename?: 'compliance_group_users_mutation_response', affected_rows: number } | null };

export type DeleteComplianceGroupUsersCsvImportGqlMutationVariables = Exact<{
  userId: Scalars['Int'];
  groupId: Scalars['Int'];
}>;


export type DeleteComplianceGroupUsersCsvImportGqlMutation = { __typename?: 'mutation_root', delete_compliance_group_users?: { __typename?: 'compliance_group_users_mutation_response', affected_rows: number } | null };

export type ComplianceContactsDisableApigqlMutationVariables = Exact<{
  objects?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ComplianceContactsDisableApigqlMutation = { __typename?: 'mutation_root', update_compliance_contacts?: { __typename?: 'compliance_contacts_mutation_response', returning: Array<{ __typename?: 'compliance_contacts', id?: number | null }> } | null };

export type ComplianceContactsReinviteApigqlMutationVariables = Exact<{
  contacts: Array<ReinviteContact> | ReinviteContact;
  message?: InputMaybe<Scalars['String']>;
}>;


export type ComplianceContactsReinviteApigqlMutation = { __typename?: 'mutation_root', reinviteContacts?: Array<{ __typename?: 'ReinviteContactsOutput', id?: number | null, invite_counter?: number | null, status?: string | null, updated_at?: string | null, deleted?: boolean | null, email?: string | null } | null> | null };

export type InviteUsersApigqlMutationVariables = Exact<{
  users: Array<UsersInvite> | UsersInvite;
}>;


export type InviteUsersApigqlMutation = { __typename?: 'mutation_root', inviteUsers?: { __typename?: 'UsersInviteOutput', invited_users: Array<string> } | null };

export type CompliancePoliciesApigqlQueryVariables = Exact<{
  complianceId: Scalars['Int'];
}>;


export type CompliancePoliciesApigqlQuery = { __typename?: 'query_root', compliance_policies: Array<{ __typename?: 'compliance_policies', id: number, name: string, description?: string | null }>, compliance_rules: Array<{ __typename?: 'compliance_rules', id: number, name: string, description?: string | null, rule: string, created_at?: any | null, updated_at?: any | null, risk: string, enable?: boolean | null, compliance_policy?: { __typename?: 'compliance_policies', id: number, name: string } | null }> };

export type InsertCompliancePoliciesApigqlMutationVariables = Exact<{
  objects: Array<Compliance_Policies_Insert_Input> | Compliance_Policies_Insert_Input;
}>;


export type InsertCompliancePoliciesApigqlMutation = { __typename?: 'mutation_root', insert_compliance_policies?: { __typename?: 'compliance_policies_mutation_response', returning: Array<{ __typename?: 'compliance_policies', id: number, name: string, description?: string | null }> } | null };

export type InsertComplianceRulesApigqlMutationVariables = Exact<{
  objects: Array<Compliance_Rules_Insert_Input> | Compliance_Rules_Insert_Input;
}>;


export type InsertComplianceRulesApigqlMutation = { __typename?: 'mutation_root', insert_compliance_rules?: { __typename?: 'compliance_rules_mutation_response', returning: Array<{ __typename?: 'compliance_rules', id: number, name: string, description?: string | null, rule: string, created_at?: any | null, updated_at?: any | null, risk: string, enable?: boolean | null, compliance_policy?: { __typename?: 'compliance_policies', name: string, id: number } | null }> } | null };

export type DisableComplianceRulesApigqlMutationVariables = Exact<{
  objects: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type DisableComplianceRulesApigqlMutation = { __typename?: 'mutation_root', update_compliance_rules?: { __typename?: 'compliance_rules_mutation_response', returning: Array<{ __typename?: 'compliance_rules', id: number }> } | null };

export type ComplianceGroupUpdateGqlMutationVariables = Exact<{
  id: Scalars['Int'];
  columns?: InputMaybe<Compliance_Groups_Set_Input>;
}>;


export type ComplianceGroupUpdateGqlMutation = { __typename?: 'mutation_root', update_compliance_groups_by_pk?: { __typename?: 'compliance_groups', updated_at?: any | null } | null };

export type ComplianceGroupDeleteGqlMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ComplianceGroupDeleteGqlMutation = { __typename?: 'mutation_root', delete_compliance_groups_by_pk?: { __typename?: 'compliance_groups', id: number } | null };

export type ComplianceGroupDeleteWithMembersGqlMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ComplianceGroupDeleteWithMembersGqlMutation = { __typename?: 'mutation_root', delete_compliance_group_users?: { __typename?: 'compliance_group_users_mutation_response', affected_rows: number } | null, delete_compliance_group_contacts?: { __typename?: 'compliance_group_contacts_mutation_response', affected_rows: number } | null, delete_compliance_groups_by_pk?: { __typename?: 'compliance_groups', id: number } | null };

export type UserGqlQueryVariables = Exact<{ [key: string]: never; }>;


export type UserGqlQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: number, email?: string | null, name?: string | null, phone?: string | null, roles_users: Array<{ __typename?: 'roles_users', role: { __typename?: 'roles', name: string } }> }>, compliance_group_users: Array<{ __typename?: 'compliance_group_users', compliance_group: { __typename?: 'compliance_groups', name: string, id: number }, user: { __typename?: 'users', id: number, email?: string | null, name?: string | null, phone?: string | null, roles_users: Array<{ __typename?: 'roles_users', role: { __typename?: 'roles', name: string } }> } }> };

export type ComplianceRulesGqlQueryVariables = Exact<{
  compliance_id: Scalars['Int'];
}>;


export type ComplianceRulesGqlQuery = { __typename?: 'query_root', compliance_rules: Array<{ __typename?: 'compliance_rules', id: number, name: string, description?: string | null, type: string, rule: string, risk: string, created_at?: any | null, updated_at?: any | null, enable?: boolean | null, policy?: { __typename?: 'compliance_policies', id: number, name: string, description?: string | null } | null }> };

export type ComplianceContactsUpdateFromSettingsGqlMutationVariables = Exact<{
  id: Scalars['Int'];
  columns?: InputMaybe<Compliance_Contacts_Raw_Set_Input>;
}>;


export type ComplianceContactsUpdateFromSettingsGqlMutation = { __typename?: 'mutation_root', update_compliance_contacts_raw_by_pk?: { __typename?: 'compliance_contacts_raw', id: number, name?: string | null, email?: string | null, phone?: string | null, tags?: any | null, status: string, created_at: any, updated_at: any } | null };

export type ComplianceContactGroupUsertFromSettingsGqlMutationVariables = Exact<{
  object: Compliance_Group_Contacts_Insert_Input;
}>;


export type ComplianceContactGroupUsertFromSettingsGqlMutation = { __typename?: 'mutation_root', insert_compliance_group_contacts_one?: { __typename?: 'compliance_group_contacts', id: number, compliance_group_id: number, compliance_contact_id: number, created_at?: any | null, updated_at?: any | null } | null };

export type ComplianceContactsReinviteMutationVariables = Exact<{
  contacts: Array<ReinviteContact> | ReinviteContact;
  message?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<CurrentUser>;
  ignoreConnecteds?: InputMaybe<Scalars['Boolean']>;
  complianceId?: InputMaybe<Scalars['Int']>;
  teamId?: InputMaybe<Scalars['Int']>;
  useTemporal?: InputMaybe<Scalars['Boolean']>;
}>;


export type ComplianceContactsReinviteMutation = { __typename?: 'mutation_root', reinviteContacts?: Array<{ __typename?: 'ReinviteContactsOutput', id?: number | null, invite_counter?: number | null, status?: string | null, updated_at?: string | null, deleted?: boolean | null, email?: string | null } | null> | null };

export type ComplianceContactsRemovePhoneFromSettingsGqlMutationVariables = Exact<{
  phones: Array<Scalars['String']> | Scalars['String'];
}>;


export type ComplianceContactsRemovePhoneFromSettingsGqlMutation = { __typename?: 'mutation_root', update_compliance_contacts_raw?: { __typename?: 'compliance_contacts_raw_mutation_response', affected_rows: number } | null };

export type RefreshJwtTokenMutationVariables = Exact<{
  team_id?: InputMaybe<Scalars['Int']>;
}>;


export type RefreshJwtTokenMutation = { __typename?: 'mutation_root', refreshJwtToken?: { __typename?: 'RefreshJwtOutput', token?: string | null } | null };

export type ContactsQueryQueryVariables = Exact<{
  complianceId: Scalars['Int'];
}>;


export type ContactsQueryQuery = { __typename?: 'query_root', compliance_contacts: Array<{ __typename?: 'compliance_contacts', id?: number | null, status?: string | null, deleted?: boolean | null }> };

export type ComplianceEventsDailyQueryQueryVariables = Exact<{
  where?: InputMaybe<Compliance_Events_Daily_Bool_Exp>;
}>;


export type ComplianceEventsDailyQueryQuery = { __typename?: 'query_root', compliance_events_daily: Array<{ __typename?: 'compliance_events_daily', event_count?: any | null, day?: any | null, compliance_id?: number | null }> };

export type ComplianceEventsHourlyQueryQueryVariables = Exact<{
  where?: InputMaybe<Compliance_Events_Hourly_Bool_Exp>;
}>;


export type ComplianceEventsHourlyQueryQuery = { __typename?: 'query_root', compliance_events_hourly: Array<{ __typename?: 'compliance_events_hourly', event_count?: any | null, hour: any, compliance_id: number }> };

export type ComplianceEventsMonthQueryQueryVariables = Exact<{
  where?: InputMaybe<Compliance_Events_Monthly_Bool_Exp>;
}>;


export type ComplianceEventsMonthQueryQuery = { __typename?: 'query_root', compliance_events_monthly: Array<{ __typename?: 'compliance_events_monthly', event_count?: any | null, month?: any | null, compliance_id?: number | null }> };

export type ComplianceEventsWeekQueryQueryVariables = Exact<{
  where?: InputMaybe<Compliance_Events_Weekly_Bool_Exp>;
}>;


export type ComplianceEventsWeekQueryQuery = { __typename?: 'query_root', compliance_events_weekly: Array<{ __typename?: 'compliance_events_weekly', event_count?: any | null, week?: any | null, compliance_id?: number | null }> };

export type ComplianceEventsYearQueryQueryVariables = Exact<{
  where?: InputMaybe<Compliance_Events_Yearly_Bool_Exp>;
}>;


export type ComplianceEventsYearQueryQuery = { __typename?: 'query_root', compliance_events_yearly: Array<{ __typename?: 'compliance_events_yearly', event_count?: any | null, year?: any | null, compliance_id?: number | null }> };

export type ComplianceEventsStatusHourlyQueryQueryVariables = Exact<{
  where?: InputMaybe<Compliance_Events_Status_Hourly_Bool_Exp>;
}>;


export type ComplianceEventsStatusHourlyQueryQuery = { __typename?: 'query_root', compliance_events_status_hourly: Array<{ __typename?: 'compliance_events_status_hourly', event_count?: any | null, status: string, hour: any, compliance_id: number }> };

export type QueryComplianceEventsStatusTotalQueryVariables = Exact<{
  complianceId?: InputMaybe<Scalars['Int']>;
}>;


export type QueryComplianceEventsStatusTotalQuery = { __typename?: 'query_root', compliance_events_status_total: Array<{ __typename?: 'compliance_events_status_total', compliance_id?: number | null, event_status_count?: any | null, status?: string | null }> };

export type QueryTotalEventsQueryVariables = Exact<{
  complianceId: Scalars['Int'];
}>;


export type QueryTotalEventsQuery = { __typename?: 'query_root', compliance_events_total: Array<{ __typename?: 'compliance_events_total', compliance_id?: number | null, event_count?: any | null }> };

export type ComplianceMessagesDailyQueryQueryVariables = Exact<{
  where?: InputMaybe<Compliance_Messages_Daily_Bool_Exp>;
}>;


export type ComplianceMessagesDailyQueryQuery = { __typename?: 'query_root', compliance_messages_daily: Array<{ __typename?: 'compliance_messages_daily', message_count?: any | null, day?: any | null, compliance_id?: number | null }> };

export type ComplianceMessagesHourlyQueryQueryVariables = Exact<{
  where?: InputMaybe<Compliance_Messages_Hourly_Bool_Exp>;
}>;


export type ComplianceMessagesHourlyQueryQuery = { __typename?: 'query_root', compliance_messages_hourly: Array<{ __typename?: 'compliance_messages_hourly', message_count?: any | null, hour: any, compliance_id: number }> };

export type ComplianceMessagesMonthlyQueryQueryVariables = Exact<{
  where?: InputMaybe<Compliance_Messages_Monthly_Bool_Exp>;
}>;


export type ComplianceMessagesMonthlyQueryQuery = { __typename?: 'query_root', compliance_messages_monthly: Array<{ __typename?: 'compliance_messages_monthly', message_count?: any | null, month?: any | null, compliance_id?: number | null }> };

export type ComplianceMessagesWeekQueryQueryVariables = Exact<{
  where?: InputMaybe<Compliance_Messages_Weekly_Bool_Exp>;
}>;


export type ComplianceMessagesWeekQueryQuery = { __typename?: 'query_root', compliance_messages_weekly: Array<{ __typename?: 'compliance_messages_weekly', message_count?: any | null, week?: any | null, compliance_id?: number | null }> };

export type ComplianceMessagesYearlyQueryQueryVariables = Exact<{
  where?: InputMaybe<Compliance_Messages_Yearly_Bool_Exp>;
}>;


export type ComplianceMessagesYearlyQueryQuery = { __typename?: 'query_root', compliance_messages_yearly: Array<{ __typename?: 'compliance_messages_yearly', message_count?: any | null, year?: any | null, compliance_id?: number | null }> };

export type QueryTotalMessagesQueryVariables = Exact<{
  complianceId: Scalars['Int'];
}>;


export type QueryTotalMessagesQuery = { __typename?: 'query_root', compliance_messages_total: Array<{ __typename?: 'compliance_messages_total', compliance_id?: number | null, message_count?: any | null }> };

export type ChatListQueryQueryVariables = Exact<{
  complianceContactId: Scalars['Int'];
  complianceId: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ChatListQueryQuery = { __typename?: 'query_root', chat_list: Array<{ __typename?: 'chat_list', archived: boolean, id: number, is_group: boolean, last_message_is_from_me: boolean, last_message_text?: string | null, last_message_timestamp: number, last_message_type?: string | null, muted: boolean, name: string, phone: string, pinned: boolean, session_uuid: any, unread_count: number, contact?: { __typename?: 'contact_list', id: number, name?: string | null, phone: string, contact?: { __typename?: 'ws_contacts', profile_pic?: string | null } | null } | null, session: { __typename?: 'ws_sessions', phone?: string | null } }> };

export type ChatListSubscriptionSubscriptionVariables = Exact<{
  complianceContactId: Scalars['Int'];
  complianceId: Scalars['Int'];
  cursor: Scalars['Int'];
}>;


export type ChatListSubscriptionSubscription = { __typename?: 'subscription_root', chat_list: Array<{ __typename?: 'chat_list', archived: boolean, id: number, is_group: boolean, last_message_is_from_me: boolean, last_message_text?: string | null, last_message_timestamp: number, last_message_type?: string | null, muted: boolean, name: string, phone: string, pinned: boolean, session_uuid: any, unread_count: number, contact?: { __typename?: 'contact_list', id: number, name?: string | null, phone: string, contact?: { __typename?: 'ws_contacts', profile_pic?: string | null } | null } | null, session: { __typename?: 'ws_sessions', phone?: string | null } }> };

export type AdminComplianceContactsQueryVariables = Exact<{
  compliance_id: Scalars['Int'];
  contact_filter: Compliance_Contacts_Raw_Bool_Exp;
}>;


export type AdminComplianceContactsQuery = { __typename?: 'query_root', compliance_by_pk?: { __typename?: 'compliance', compliance_contacts: Array<{ __typename?: 'compliance_contacts_raw', id: number, name?: string | null, email?: string | null, phone?: string | null, status: string, invite_counter: number, tags?: any | null, deleted: boolean, created_at: any, updated_at: any, ws_session?: { __typename?: 'ws_sessions', profile_pic?: string | null, uuid: any, last_connected_at?: any | null, phone?: string | null, chat_lists: Array<{ __typename?: 'chat_list', last_message_timestamp: number }> } | null, compliance_group_contact?: { __typename?: 'compliance_group_contacts', compliance_group?: { __typename?: 'compliance_groups', id: number, name: string, description?: string | null, tags?: any | null } | null } | null }> } | null };

export type AnalystComplianceContactsQueryVariables = Exact<{
  compliance_id: Scalars['Int'];
  user_id: Scalars['Int'];
  contact_filter: Compliance_Contacts_Raw_Bool_Exp;
}>;


export type AnalystComplianceContactsQuery = { __typename?: 'query_root', compliance_by_pk?: { __typename?: 'compliance', compliance_groups: Array<{ __typename?: 'compliance_groups', compliance_group_users: Array<{ __typename?: 'compliance_group_users', compliance_group: { __typename?: 'compliance_groups', id: number, name: string, description?: string | null, tags?: any | null, compliance_group_contacts: Array<{ __typename?: 'compliance_group_contacts', compliance_contact?: { __typename?: 'compliance_contacts_raw', id: number, name?: string | null, email?: string | null, phone?: string | null, status: string, invite_counter: number, tags?: any | null, deleted: boolean, created_at: any, updated_at: any, ws_session?: { __typename?: 'ws_sessions', profile_pic?: string | null, uuid: any, last_connected_at?: any | null, phone?: string | null, chat_lists: Array<{ __typename?: 'chat_list', last_message_timestamp: number }> } | null } | null }> } }> }> } | null };

export type ComplianceContactsDisableMutationVariables = Exact<{
  contacts?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type ComplianceContactsDisableMutation = { __typename?: 'mutation_root', update_compliance_contacts?: { __typename?: 'compliance_contacts_mutation_response', returning: Array<{ __typename?: 'compliance_contacts', id?: number | null }> } | null, delete_compliance_group_contacts?: { __typename?: 'compliance_group_contacts_mutation_response', returning: Array<{ __typename?: 'compliance_group_contacts', id: number }> } | null };

export type ComplianceEventsGqlQueryVariables = Exact<{
  where: Compliance_Events_Bool_Exp;
  compliance_id: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type ComplianceEventsGqlQuery = { __typename?: 'query_root', compliance?: { __typename?: 'compliance', compliance_events: Array<{ __typename?: 'compliance_events', id: number, data?: any | null, status: string, comment?: string | null, created_at?: any | null, compliance_message?: { __typename?: 'compliance_messages', id?: number | null, compliance_id?: number | null, from_me?: boolean | null, is_group_msg?: boolean | null, message_key?: string | null, mime_type?: string | null, participant?: string | null, to?: string | null, type?: string | null, unix_timestamp?: number | null, timestamp?: any | null, from?: string | null, body?: string | null, caption?: string | null, metadata?: any | null, transcription?: string | null, is_deleted?: boolean | null, ws_session?: { __typename?: 'ws_sessions', profile_pic?: string | null, name?: string | null, phone?: string | null } | null, compliance_contact?: { __typename?: 'compliance_contacts_raw', name?: string | null, ws_session_ref?: any | null } | null, from_contact?: { __typename?: 'ws_contacts', phone: string, name?: string | null, profile_pic?: string | null } | null, participant_contact?: { __typename?: 'ws_contacts', phone: string, name?: string | null, profile_pic?: string | null } | null, to_contact?: { __typename?: 'ws_contacts', phone: string, name?: string | null, profile_pic?: string | null } | null } | null, compliance_contact: { __typename?: 'compliance_contacts_raw', id: number, name?: string | null, email?: string | null, phone?: string | null, ws_session?: { __typename?: 'ws_sessions', profile_pic?: string | null } | null }, compliance_rule: { __typename?: 'compliance_rules', id: number, name: string, description?: string | null, type: string, rule: string, risk: string, compliance_policy?: { __typename?: 'compliance_policies', name: string, description?: string | null } | null } }> } | null };

export type ComplianceEventsSubscriptionGqlSubscriptionVariables = Exact<{
  where: Compliance_Events_Bool_Exp;
  compliance_id: Scalars['Int'];
}>;


export type ComplianceEventsSubscriptionGqlSubscription = { __typename?: 'subscription_root', compliance?: { __typename?: 'compliance', compliance_events: Array<{ __typename?: 'compliance_events', id: number, data?: any | null, status: string, comment?: string | null, created_at?: any | null, compliance_message?: { __typename?: 'compliance_messages', id?: number | null, compliance_id?: number | null, from_me?: boolean | null, is_group_msg?: boolean | null, message_key?: string | null, mime_type?: string | null, participant?: string | null, to?: string | null, type?: string | null, unix_timestamp?: number | null, timestamp?: any | null, from?: string | null, body?: string | null, caption?: string | null, metadata?: any | null, transcription?: string | null, is_deleted?: boolean | null, ws_session?: { __typename?: 'ws_sessions', profile_pic?: string | null, name?: string | null, phone?: string | null } | null, compliance_contact?: { __typename?: 'compliance_contacts_raw', name?: string | null, ws_session_ref?: any | null } | null, from_contact?: { __typename?: 'ws_contacts', phone: string, name?: string | null, profile_pic?: string | null } | null, participant_contact?: { __typename?: 'ws_contacts', phone: string, name?: string | null, profile_pic?: string | null } | null, to_contact?: { __typename?: 'ws_contacts', phone: string, name?: string | null, profile_pic?: string | null } | null } | null, compliance_contact: { __typename?: 'compliance_contacts_raw', id: number, name?: string | null, email?: string | null, phone?: string | null, ws_session?: { __typename?: 'ws_sessions', profile_pic?: string | null } | null }, compliance_rule: { __typename?: 'compliance_rules', id: number, name: string, description?: string | null, type: string, rule: string, risk: string, compliance_policy?: { __typename?: 'compliance_policies', name: string, description?: string | null } | null } }> } | null };

export type ComplianceEventsClassificationCountGqlQueryVariables = Exact<{
  start: Scalars['timestamptz'];
  final: Scalars['timestamptz'];
  complianceId: Scalars['Int'];
}>;


export type ComplianceEventsClassificationCountGqlQuery = { __typename?: 'query_root', week_total_low: { __typename?: 'compliance_events_aggregate', aggregate?: { __typename?: 'compliance_events_aggregate_fields', count: number } | null }, week_total_moderate: { __typename?: 'compliance_events_aggregate', aggregate?: { __typename?: 'compliance_events_aggregate_fields', count: number } | null }, week_total_high: { __typename?: 'compliance_events_aggregate', aggregate?: { __typename?: 'compliance_events_aggregate_fields', count: number } | null }, week_rated_low: { __typename?: 'compliance_events_aggregate', aggregate?: { __typename?: 'compliance_events_aggregate_fields', count: number } | null }, week_rated_moderate: { __typename?: 'compliance_events_aggregate', aggregate?: { __typename?: 'compliance_events_aggregate_fields', count: number } | null }, week_rated_high: { __typename?: 'compliance_events_aggregate', aggregate?: { __typename?: 'compliance_events_aggregate_fields', count: number } | null } };

export type ComplianceEventsClassificationGoalsByComplianceIdGqlQueryVariables = Exact<{
  complianceId: Scalars['Int'];
}>;


export type ComplianceEventsClassificationGoalsByComplianceIdGqlQuery = { __typename?: 'query_root', compliance_events_classification_goals_by_pk?: { __typename?: 'compliance_events_classification_goals', low: number, moderate: number, high: number, created_at: any, updated_at: any, enable: boolean } | null };

export type ComplianceEventsClassificationGroupsResumeGqlQueryVariables = Exact<{
  start: Scalars['timestamptz'];
  final: Scalars['timestamptz'];
  complianceId: Scalars['Int'];
}>;


export type ComplianceEventsClassificationGroupsResumeGqlQuery = { __typename?: 'query_root', compliance_contacts: Array<{ __typename?: 'compliance_contacts', email?: string | null, compliance_group_contact?: { __typename?: 'compliance_group_contacts', compliance_group?: { __typename?: 'compliance_groups', name: string, id: number } | null } | null, week_total_low: { __typename?: 'compliance_events_aggregate', aggregate?: { __typename?: 'compliance_events_aggregate_fields', count: number } | null }, week_total_moderate: { __typename?: 'compliance_events_aggregate', aggregate?: { __typename?: 'compliance_events_aggregate_fields', count: number } | null }, week_total_high: { __typename?: 'compliance_events_aggregate', aggregate?: { __typename?: 'compliance_events_aggregate_fields', count: number } | null }, week_rated_low: { __typename?: 'compliance_events_aggregate', aggregate?: { __typename?: 'compliance_events_aggregate_fields', count: number } | null }, week_rated_moderate: { __typename?: 'compliance_events_aggregate', aggregate?: { __typename?: 'compliance_events_aggregate_fields', count: number } | null }, week_rated_high: { __typename?: 'compliance_events_aggregate', aggregate?: { __typename?: 'compliance_events_aggregate_fields', count: number } | null } }> };

export type ComplianceEventsClassificationResumeGqlQueryVariables = Exact<{
  complianceId: Scalars['Int'];
}>;


export type ComplianceEventsClassificationResumeGqlQuery = { __typename?: 'query_root', compliance_events_classification_resumes: Array<{ __typename?: 'compliance_events_classification_resumes', created_at: any, data: any, final_date: any, id: number, initial_date: any, uuid: any }> };

export type CompliancePoliciesQueryVariables = Exact<{
  compliance_id: Scalars['Int'];
}>;


export type CompliancePoliciesQuery = { __typename?: 'query_root', compliance_by_pk?: { __typename?: 'compliance', compliance_policies: Array<{ __typename?: 'compliance_policies', id: number, name: string }> } | null };

export type ComplianceGroupsGqlQueryVariables = Exact<{
  compliance_id: Scalars['Int'];
}>;


export type ComplianceGroupsGqlQuery = { __typename?: 'query_root', compliance_groups: Array<{ __typename?: 'compliance_groups', id: number, name: string, description?: string | null, updated_at?: any | null, created_at?: any | null, compliance_group_contacts: Array<{ __typename?: 'compliance_group_contacts', id: number }>, compliance_group_users: Array<{ __typename?: 'compliance_group_users', id: number }> }> };

export type ComplianceGroupsWithEventsQueryVariables = Exact<{
  complianceId: Scalars['Int'];
  endDate: Scalars['Int'];
  startDate: Scalars['Int'];
}>;


export type ComplianceGroupsWithEventsQuery = { __typename?: 'query_root', compliance_groups_with_events: Array<{ __typename?: 'compliance_groups', id: number }> };

export type ComplianceGroupsInsertGqlMutationVariables = Exact<{
  objects: Array<Compliance_Groups_Insert_Input> | Compliance_Groups_Insert_Input;
}>;


export type ComplianceGroupsInsertGqlMutation = { __typename?: 'mutation_root', insert_compliance_groups?: { __typename?: 'compliance_groups_mutation_response', returning: Array<{ __typename?: 'compliance_groups', id: number, name: string, description?: string | null, created_at?: any | null, updated_at?: any | null }> } | null };

export type GetComplianceMessageMetadataQueryVariables = Exact<{
  messageId: Scalars['Int'];
}>;


export type GetComplianceMessageMetadataQuery = { __typename?: 'query_root', compliance_messages: Array<{ __typename?: 'compliance_messages', metadata?: any | null }> };

export type ComplianceContactsParticipantsQueryQueryVariables = Exact<{
  compliance_contact_id?: InputMaybe<Int_Comparison_Exp>;
  compliance_id?: InputMaybe<Int_Comparison_Exp>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type ComplianceContactsParticipantsQueryQuery = { __typename?: 'query_root', compliance_participants: Array<{ __typename?: 'compliance_participants', name?: string | null, phone?: string | null, profile_pic?: string | null, compliance_contact_id?: number | null, message_id?: number | null, message_body?: string | null, message_from_me?: boolean | null, ws_session_phone?: string | null }> };

export type CompliancePoliciesGqlQueryVariables = Exact<{
  compliance_id: Scalars['Int'];
}>;


export type CompliancePoliciesGqlQuery = { __typename?: 'query_root', compliance_policies: Array<{ __typename?: 'compliance_policies', id: number, name: string, cc_emails?: any | null, description?: string | null, created_at?: any | null, updated_at?: any | null }> };

export type CompliancePoliciesInsertGqlMutationVariables = Exact<{
  object: Compliance_Policies_Insert_Input;
}>;


export type CompliancePoliciesInsertGqlMutation = { __typename?: 'mutation_root', insert_compliance_policies_one?: { __typename?: 'compliance_policies', id: number, name: string, description?: string | null, created_at?: any | null, updated_at?: any | null, cc_emails?: any | null } | null };

export type CompliancePoliciesUpdateGqlMutationVariables = Exact<{
  id: Scalars['Int'];
  columns?: InputMaybe<Compliance_Policies_Set_Input>;
}>;


export type CompliancePoliciesUpdateGqlMutation = { __typename?: 'mutation_root', update_compliance_policies_by_pk?: { __typename?: 'compliance_policies', id: number, name: string, cc_emails?: any | null, description?: string | null, created_at?: any | null, updated_at?: any | null } | null };

export type ComplianceRulesInsertGqlMutationVariables = Exact<{
  object: Compliance_Rules_Insert_Input;
}>;


export type ComplianceRulesInsertGqlMutation = { __typename?: 'mutation_root', insert_compliance_rules_one?: { __typename?: 'compliance_rules', id: number, name: string, description?: string | null, type: string, rule: string, created_at?: any | null, updated_at?: any | null, enable?: boolean | null, risk: string, policy?: { __typename?: 'compliance_policies', id: number, name: string, description?: string | null } | null } | null };

export type ComplianceRulesUpdateGqlMutationVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
  columns?: InputMaybe<Compliance_Rules_Set_Input>;
}>;


export type ComplianceRulesUpdateGqlMutation = { __typename?: 'mutation_root', update_compliance_rules?: { __typename?: 'compliance_rules_mutation_response', returning: Array<{ __typename?: 'compliance_rules', id: number, name: string, description?: string | null, type: string, rule: string, risk: string, created_at?: any | null, updated_at?: any | null, enable?: boolean | null, policy?: { __typename?: 'compliance_policies', id: number, name: string, description?: string | null } | null }> } | null };

export type ComplianceContactsUpsertGqlMutationVariables = Exact<{
  objects: Array<Compliance_Contacts_Raw_Insert_Input> | Compliance_Contacts_Raw_Insert_Input;
}>;


export type ComplianceContactsUpsertGqlMutation = { __typename?: 'mutation_root', insert_compliance_contacts_raw?: { __typename?: 'compliance_contacts_raw_mutation_response', returning: Array<{ __typename?: 'compliance_contacts_raw', id: number, name?: string | null, email?: string | null, phone?: string | null, tags?: any | null, status: string, created_at: any, updated_at: any, invite_counter: number }> } | null };

export type ComplianceContactGroupUsertGqlMutationVariables = Exact<{
  objects: Array<Compliance_Group_Contacts_Insert_Input> | Compliance_Group_Contacts_Insert_Input;
}>;


export type ComplianceContactGroupUsertGqlMutation = { __typename?: 'mutation_root', insert_compliance_group_contacts?: { __typename?: 'compliance_group_contacts_mutation_response', returning: Array<{ __typename?: 'compliance_group_contacts', id: number, compliance_group_id: number, compliance_contact_id: number, created_at?: any | null, updated_at?: any | null, compliance_contact?: { __typename?: 'compliance_contacts_raw', id: number, name?: string | null } | null, compliance_group?: { __typename?: 'compliance_groups', name: string, id: number } | null }> } | null };

export type ComplianceGqlQueryVariables = Exact<{
  active_team_id: Scalars['Int'];
}>;


export type ComplianceGqlQuery = { __typename?: 'query_root', compliance: Array<{ __typename?: 'compliance', id: number, name: string, team_id: number }> };

export type DeleteComplianceGroupUsersGqlMutationVariables = Exact<{
  userId: Scalars['Int'];
  groupId: Scalars['Int'];
}>;


export type DeleteComplianceGroupUsersGqlMutation = { __typename?: 'mutation_root', delete_compliance_group_users?: { __typename?: 'compliance_group_users_mutation_response', returning: Array<{ __typename?: 'compliance_group_users', id: number, user_id: number, compliance_group_id: number }> } | null };

export type DeleteRelevantContactsMutationVariables = Exact<{
  relevantContactsIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  complianceId: Scalars['Int'];
}>;


export type DeleteRelevantContactsMutation = { __typename?: 'mutation_root', delete_relevant_contacts?: { __typename?: 'relevant_contacts_mutation_response', returning: Array<{ __typename?: 'relevant_contacts', id: number }> } | null };

export type DeleteTagsGqlMutationVariables = Exact<{
  tagsIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  complianceId: Scalars['Int'];
}>;


export type DeleteTagsGqlMutation = { __typename?: 'mutation_root', delete_tags?: { __typename?: 'tags_mutation_response', returning: Array<{ __typename?: 'tags', id: number }> } | null };

export type ImportCsvGqlMutationVariables = Exact<{
  csvDataRows: Array<InputMaybe<CsvDataRowInput>> | InputMaybe<CsvDataRowInput>;
  complianceId: Scalars['Int'];
  disableContacts?: InputMaybe<Scalars['Boolean']>;
  roleId: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type ImportCsvGqlMutation = { __typename?: 'mutation_root', importCsv?: { __typename?: 'ImportCsvOutput', success: boolean } | null };

export type ImportCsvDiffGqlMutationVariables = Exact<{
  complianceId: Scalars['Int'];
  csvDataRows: Array<InputMaybe<CsvDataRowInput>> | InputMaybe<CsvDataRowInput>;
}>;


export type ImportCsvDiffGqlMutation = { __typename?: 'mutation_root', importCsvDiff?: { __typename?: 'ImportCsvDiffOutput', groupsToCreate: Array<string | null>, diffConflicts: Array<{ __typename?: 'DiffConflict', type?: string | null, contact?: { __typename?: 'DiffContact', email?: string | null, group?: string | null, id: number, name?: string | null, phone?: string | null } | null, csvDataRows?: Array<{ __typename?: 'CsvDataRow', email?: string | null, group?: string | null, send_contact_invite?: boolean | null, send_manager_invite?: boolean | null, manager?: string | null, name?: string | null, phone?: string | null } | null> | null } | null>, diffRows: Array<{ __typename?: 'DiffRow', action?: string | null, email?: string | null, status?: string | null, disabled?: boolean | null, send_contact_invite?: boolean | null, send_manager_invite?: boolean | null, manager?: string | null, group?: { __typename?: 'Diff', new?: string | null, old?: string | null } | null, name?: { __typename?: 'Diff', new?: string | null, old?: string | null } | null, phone?: { __typename?: 'Diff', new?: string | null, old?: string | null } | null } | null>, usersToInsert: Array<{ __typename?: 'DiffUser', email?: string | null, id?: number | null, name?: string | null } | null> } | null };

export type ImportCsvManagersGqlMutationVariables = Exact<{
  complianceId: Scalars['Int'];
  roleId: Scalars['Int'];
  teamId: Scalars['Int'];
  csvRows: Array<CsvManagerRow> | CsvManagerRow;
}>;


export type ImportCsvManagersGqlMutation = { __typename?: 'mutation_root', importCsvManagers?: { __typename?: 'ImportCsvManagersOutput', success: boolean } | null };

export type ImportCsvManagersDiffMutationVariables = Exact<{
  csvRows: Array<InputMaybe<CsvManagerRow>> | InputMaybe<CsvManagerRow>;
  complianceId: Scalars['Int'];
}>;


export type ImportCsvManagersDiffMutation = { __typename?: 'mutation_root', importCsvManagersDiff?: { __typename?: 'ImportCsvManagersDiffOutput', diffManagerRows: Array<{ __typename?: 'DiffManagerRow', action: string, email: string, invite?: boolean | null, group?: { __typename?: 'Diff', new?: string | null, old?: string | null } | null, name?: { __typename?: 'Diff', new?: string | null, old?: string | null } | null, phone?: { __typename?: 'Diff', new?: string | null, old?: string | null } | null } | null> } | null };

export type ImportCsvRelevantContactsGqlMutationVariables = Exact<{
  complianceId: Scalars['Int'];
  relevantContactsCsvRows: Array<RelevantContactsCsvRow> | RelevantContactsCsvRow;
  removeContacts?: InputMaybe<Scalars['Boolean']>;
  teamId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type ImportCsvRelevantContactsGqlMutation = { __typename?: 'mutation_root', importCsvRelevantContacts?: { __typename?: 'ImportCsvRelevantContactsOutput', success: boolean } | null };

export type ImportCsvRelevantContactsDiffGqlMutationVariables = Exact<{
  complianceId: Scalars['Int'];
  relevantContactsCsvRows: Array<RelevantContactsCsvRow> | RelevantContactsCsvRow;
}>;


export type ImportCsvRelevantContactsDiffGqlMutation = { __typename?: 'mutation_root', importCsvRelevantContactsDiff?: { __typename?: 'ImportCsvRelevantContactsDiffOutput', relevantContactsDiff: Array<{ __typename?: 'RelevantContactDiff', action: string, name?: { __typename?: 'Diff', new?: string | null, old?: string | null } | null, phone?: { __typename?: 'Diff', new?: string | null, old?: string | null } | null, tags?: { __typename?: 'Diff', new?: string | null, old?: string | null } | null }> } | null };

export type ImportCsvRulesGqlMutationVariables = Exact<{
  complianceId: Scalars['Int'];
  csvRuleRows: Array<CsvRuleRow> | CsvRuleRow;
  disableRules: Scalars['Boolean'];
}>;


export type ImportCsvRulesGqlMutation = { __typename?: 'mutation_root', importCsvRules?: { __typename?: 'ImportCsvRulesOutput', disabledRules: Array<number>, insertedRules: Array<{ __typename?: 'ExistingRule', description?: string | null, id: number, name: string, policy_id?: number | null, policy_name?: string | null, rule: string, created_at: string, updated_at: string, enable: boolean, risk: string }> } | null };

export type ImportCsvRulesDiffGqlMutationVariables = Exact<{
  complianceId: Scalars['Int'];
  csvRuleRows: Array<InputMaybe<CsvRuleRow>> | InputMaybe<CsvRuleRow>;
}>;


export type ImportCsvRulesDiffGqlMutation = { __typename?: 'mutation_root', importCsvRulesDiff?: { __typename?: 'ImportCsvRulesDiffOutput', policiesToInsert: Array<string>, rulesToInsert: Array<string>, diffRuleRows: Array<{ __typename?: 'DiffRuleRow', action: string, description?: { __typename?: 'Diff', new?: string | null, old?: string | null } | null, name?: { __typename?: 'Diff', new?: string | null, old?: string | null } | null, policy?: { __typename?: 'Diff', new?: string | null, old?: string | null } | null, rule?: { __typename?: 'Diff', new?: string | null, old?: string | null } | null, risk?: { __typename?: 'Diff', old?: string | null, new?: string | null } | null }> } | null };

export type InsertComplianceGroupUsersGqlMutationVariables = Exact<{
  objects: Array<Compliance_Group_Users_Insert_Input> | Compliance_Group_Users_Insert_Input;
}>;


export type InsertComplianceGroupUsersGqlMutation = { __typename?: 'mutation_root', insert_compliance_group_users?: { __typename?: 'compliance_group_users_mutation_response', returning: Array<{ __typename?: 'compliance_group_users', id: number, user_id: number, compliance_group_id: number }> } | null };

export type InsertRelevantContactGqlMutationVariables = Exact<{
  object: Relevant_Contacts_Insert_Input;
}>;


export type InsertRelevantContactGqlMutation = { __typename?: 'mutation_root', insert_relevant_contacts_one?: { __typename?: 'relevant_contacts', created_at: any, id: number, name?: string | null, phone: string, updated_at: any } | null };

export type InsertTagGqlMutationVariables = Exact<{
  object: Tags_Insert_Input;
}>;


export type InsertTagGqlMutation = { __typename?: 'mutation_root', insert_tags_one?: { __typename?: 'tags', color?: string | null, created_at: any, description?: string | null, id: number, name: string, permissions?: any | null } | null };

export type InsertUsersGqlMutationVariables = Exact<{
  users: Array<UsersInsert> | UsersInsert;
}>;


export type InsertUsersGqlMutation = { __typename?: 'mutation_root', insertUsers?: { __typename?: 'UsersInsertOutput', inserted_users: Array<{ __typename?: 'InsertedUser', id: number, email: string, name?: string | null }> } | null };

export type InviteUsersGqlMutationVariables = Exact<{
  invitingUser: InvitingUser;
  users: Array<UsersInvite> | UsersInvite;
}>;


export type InviteUsersGqlMutation = { __typename?: 'mutation_root', inviteUsers?: { __typename?: 'UsersInviteOutput', invited_users: Array<string> } | null };

export type LogoutDashboardMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutDashboardMutation = { __typename?: 'mutation_root', logout?: { __typename?: 'LogoutOutput', logout: boolean } | null };

export type ComplianceMessagesQueryQueryVariables = Exact<{
  where: Compliance_Messages_Bool_Exp;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  order: Order_By;
}>;


export type ComplianceMessagesQueryQuery = { __typename?: 'query_root', compliance_messages: Array<{ __typename?: 'compliance_messages', id?: number | null, compliance_id?: number | null, from_me?: boolean | null, is_group_msg?: boolean | null, message_key?: string | null, mime_type?: string | null, participant?: string | null, to?: string | null, type?: string | null, unix_timestamp?: number | null, from?: string | null, body?: string | null, caption?: string | null, metadata?: any | null, transcription?: string | null, is_deleted?: boolean | null, ws_session?: { __typename?: 'ws_sessions', profile_pic?: string | null, name?: string | null, phone?: string | null } | null, compliance_contact?: { __typename?: 'compliance_contacts_raw', name?: string | null, ws_session_ref?: any | null } | null, from_contact?: { __typename?: 'ws_contacts', phone: string, name?: string | null, profile_pic?: string | null } | null, participant_contact?: { __typename?: 'ws_contacts', phone: string, name?: string | null, profile_pic?: string | null } | null, to_contact?: { __typename?: 'ws_contacts', phone: string, name?: string | null, profile_pic?: string | null } | null }> };

export type ComplianceMessagesSubscriptionSubscriptionVariables = Exact<{
  where: Compliance_Messages_Bool_Exp;
}>;


export type ComplianceMessagesSubscriptionSubscription = { __typename?: 'subscription_root', compliance_messages: Array<{ __typename?: 'compliance_messages', id?: number | null, compliance_id?: number | null, from_me?: boolean | null, is_group_msg?: boolean | null, message_key?: string | null, mime_type?: string | null, participant?: string | null, to?: string | null, type?: string | null, unix_timestamp?: number | null, from?: string | null, body?: string | null, caption?: string | null, metadata?: any | null, transcription?: string | null, is_deleted?: boolean | null, ws_session?: { __typename?: 'ws_sessions', profile_pic?: string | null, name?: string | null, phone?: string | null } | null, compliance_contact?: { __typename?: 'compliance_contacts_raw', name?: string | null, ws_session_ref?: any | null } | null, from_contact?: { __typename?: 'ws_contacts', phone: string, name?: string | null, profile_pic?: string | null } | null, participant_contact?: { __typename?: 'ws_contacts', phone: string, name?: string | null, profile_pic?: string | null } | null, to_contact?: { __typename?: 'ws_contacts', phone: string, name?: string | null, profile_pic?: string | null } | null }> };

export type GetMessagesAnalysisMutationVariables = Exact<{
  complianceId: Scalars['Int'];
  agentIdentifier: Scalars['String'];
  contactPhone: Scalars['String'];
  startDate: Scalars['Int'];
  endDate: Scalars['Int'];
  analysisType?: InputMaybe<Scalars['String']>;
  agentPhone: Scalars['String'];
}>;


export type GetMessagesAnalysisMutation = { __typename?: 'mutation_root', getMessagesAnalysis: { __typename?: 'GetMessagesAnalysisOutput', messagesAnalised?: string | null } };

export type NotificationsGqlQueryVariables = Exact<{
  complianceId: Scalars['Int'];
  teamId: Scalars['Int'];
  userId: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type NotificationsGqlQuery = { __typename?: 'query_root', notifications: Array<{ __typename?: 'notifications', created_at: any, data?: any | null, description: string, id: number, target: string, title: string, type: string, compliance: { __typename?: 'compliance', name: string }, team: { __typename?: 'teams', name: string }, user: { __typename?: 'users', email?: string | null } }> };

export type NotificationsSubscriptionGqlSubscriptionVariables = Exact<{
  complianceId: Scalars['Int'];
  teamId: Scalars['Int'];
  userId: Scalars['Int'];
  id: Scalars['Int'];
}>;


export type NotificationsSubscriptionGqlSubscription = { __typename?: 'subscription_root', notifications: Array<{ __typename?: 'notifications', created_at: any, data?: any | null, description: string, id: number, target: string, title: string, type: string, compliance: { __typename?: 'compliance', name: string }, team: { __typename?: 'teams', name: string }, user: { __typename?: 'users', email?: string | null } }> };

export type ComplianceUserRoleGqlQueryVariables = Exact<{
  user_id: Scalars['Int'];
  team_id: Scalars['Int'];
}>;


export type ComplianceUserRoleGqlQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', roles_users: Array<{ __typename?: 'roles_users', id: number, team_id: number, role: { __typename?: 'roles', permissions: any } }> }> };

export type RelevantContactsGqlQueryVariables = Exact<{
  complianceId: Scalars['Int'];
}>;


export type RelevantContactsGqlQuery = { __typename?: 'query_root', relevant_contacts: Array<{ __typename?: 'relevant_contacts', id: number, name?: string | null, phone: string, created_at: any, relevant_contacts_tags: Array<{ __typename?: 'relevant_contacts_tags', tag: { __typename?: 'tags', color?: string | null, name: string, description?: string | null } }> }> };

export type RemoveMembersFromTeamGqlMutationVariables = Exact<{
  teamId: Scalars['Int'];
  membersIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type RemoveMembersFromTeamGqlMutation = { __typename?: 'mutation_root', delete_teams_users?: { __typename?: 'teams_users_mutation_response', returning: Array<{ __typename?: 'teams_users', team_id: number }> } | null, delete_roles_users?: { __typename?: 'roles_users_mutation_response', returning: Array<{ __typename?: 'roles_users', user_id: number }> } | null, delete_compliance_group_users?: { __typename?: 'compliance_group_users_mutation_response', returning: Array<{ __typename?: 'compliance_group_users', compliance_group_id: number }> } | null };

export type RolesByProductIdGqlQueryVariables = Exact<{
  productId?: InputMaybe<Scalars['Int']>;
}>;


export type RolesByProductIdGqlQuery = { __typename?: 'query_root', roles: Array<{ __typename?: 'roles', id: number, is_default?: boolean | null, name: string }> };

export type TagsGqlQueryVariables = Exact<{
  complianceId?: InputMaybe<Scalars['Int']>;
  contains?: InputMaybe<Scalars['jsonb']>;
}>;


export type TagsGqlQuery = { __typename?: 'query_root', tags: Array<{ __typename?: 'tags', color?: string | null, created_at: any, description?: string | null, id: number, name: string, permissions?: any | null, updated_at: any, uuid: any }> };

export type UpdateUserGroupMutationVariables = Exact<{
  userId: Scalars['Int'];
  groupId: Scalars['Int'];
}>;


export type UpdateUserGroupMutation = { __typename?: 'mutation_root', delete_compliance_group_users?: { __typename?: 'compliance_group_users_mutation_response', affected_rows: number } | null, insert_compliance_group_users?: { __typename?: 'compliance_group_users_mutation_response', affected_rows: number } | null };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['Int'];
  columns?: InputMaybe<Users_Set_Input>;
}>;


export type UpdateUserMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', returning: Array<{ __typename?: 'users', id: number, phone?: string | null, name?: string | null }> } | null };

export type UpsertComplianceEventsMutationVariables = Exact<{
  events: Array<Compliance_Events_Insert_Input> | Compliance_Events_Insert_Input;
}>;


export type UpsertComplianceEventsMutation = { __typename?: 'mutation_root', insert_compliance_events?: { __typename?: 'compliance_events_mutation_response', returning: Array<{ __typename?: 'compliance_events', id: number, status: string, comment?: string | null }> } | null };

export type UpsertComplianceEventsClassificationGoalGqlMutationVariables = Exact<{
  goals: Compliance_Events_Classification_Goals_Insert_Input;
}>;


export type UpsertComplianceEventsClassificationGoalGqlMutation = { __typename?: 'mutation_root', insert_compliance_events_classification_goals_one?: { __typename?: 'compliance_events_classification_goals', compliance_id: number, created_at: any, enable: boolean, high: number, low: number, moderate: number, updated_at: any } | null };

export type CurrentUserQueryGqlQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CurrentUserQueryGqlQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', name?: string | null, email?: string | null, roles_users: Array<{ __typename?: 'roles_users', role: { __typename?: 'roles', alias: string } }>, teams_users: Array<{ __typename?: 'teams_users', team: { __typename?: 'teams', id: number, name: string, settings?: { __typename?: 'teams_settings', data: any } | null } }> } | null };

export type VerifyWhatsAppMutationVariables = Exact<{
  phone: Scalars['String'];
  token: Scalars['String'];
  mode: Scalars['String'];
}>;


export type VerifyWhatsAppMutation = { __typename?: 'mutation_root', twilioVerifyWhatsApp?: { __typename?: 'VerifyWhatsAppOutput', id: string, status: string, error?: string | null } | null };

export type InsertTokenMutationVariables = Exact<{
  user_id: Scalars['Int'];
  token: Scalars['String'];
}>;


export type InsertTokenMutation = { __typename?: 'mutation_root', insert_tokens_one?: { __typename?: 'tokens', id: number, user_id: number, token: string, created_at: any, verified: boolean } | null };

export type DeleteUserMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type DeleteUserMutation = { __typename?: 'mutation_root', delete_users?: { __typename?: 'users_mutation_response', returning: Array<{ __typename?: 'users', id: number, email?: string | null }> } | null };

export type EditUserMutationVariables = Exact<{
  email: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  cpf_cnpj?: InputMaybe<Scalars['String']>;
  zip_code?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  complement?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['String']>;
}>;


export type EditUserMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', returning: Array<{ __typename?: 'users', id: number, email?: string | null, name?: string | null, phone?: string | null, cpf_cnpj?: string | null, zip_code?: string | null, number?: string | null, street?: string | null, city?: string | null, state?: string | null, district?: string | null, complement?: string | null, customer_id?: string | null }> } | null };

export type FindUserByExtIdQueryVariables = Exact<{
  ext_id: Scalars['String'];
}>;


export type FindUserByExtIdQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: number, email?: string | null, password?: string | null, name?: string | null, phone?: string | null, cpf_cnpj?: string | null, zip_code?: string | null, number?: string | null, street?: string | null, city?: string | null, state?: string | null, district?: string | null, complement?: string | null, customer_id?: string | null, source: string, two_factor_authentication: boolean, passwordless: boolean, ext_id?: string | null, roles_users: Array<{ __typename?: 'roles_users', role: { __typename?: 'roles', name: string, alias: string, permissions: any } }>, teams: Array<{ __typename?: 'teams', id: number, name: string, is_personal: boolean }>, teams_users: Array<{ __typename?: 'teams_users', team: { __typename?: 'teams', id: number, name: string, is_personal: boolean } }> }> };

export type FindUserByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type FindUserByEmailQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: number, email?: string | null, password?: string | null, name?: string | null, phone?: string | null, cpf_cnpj?: string | null, zip_code?: string | null, number?: string | null, street?: string | null, city?: string | null, state?: string | null, district?: string | null, complement?: string | null, customer_id?: string | null, source: string, two_factor_authentication: boolean, passwordless: boolean, roles_users: Array<{ __typename?: 'roles_users', role: { __typename?: 'roles', name: string, alias: string, permissions: any } }>, teams: Array<{ __typename?: 'teams', id: number, name: string, is_personal: boolean }>, teams_users: Array<{ __typename?: 'teams_users', team: { __typename?: 'teams', id: number, name: string, is_personal: boolean } }> }> };

export type FindUserByPhoneQueryVariables = Exact<{
  phone?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
}>;


export type FindUserByPhoneQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: number, email?: string | null, password?: string | null, name?: string | null, phone?: string | null, cpf_cnpj?: string | null, zip_code?: string | null, number?: string | null, street?: string | null, city?: string | null, state?: string | null, district?: string | null, complement?: string | null, customer_id?: string | null, source: string, two_factor_authentication: boolean, passwordless: boolean, roles_users: Array<{ __typename?: 'roles_users', role: { __typename?: 'roles', name: string, alias: string, permissions: any } }>, teams: Array<{ __typename?: 'teams', id: number, is_personal: boolean }>, teams_users: Array<{ __typename?: 'teams_users', team: { __typename?: 'teams', id: number, is_personal: boolean } }> }> };

export type InsertUserMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  source: Scalars['String'];
  passwordless?: InputMaybe<Scalars['Boolean']>;
}>;


export type InsertUserMutation = { __typename?: 'mutation_root', insert_users?: { __typename?: 'users_mutation_response', returning: Array<{ __typename?: 'users', id: number, email?: string | null, password?: string | null, name?: string | null, phone?: string | null, cpf_cnpj?: string | null, zip_code?: string | null, number?: string | null, street?: string | null, city?: string | null, state?: string | null, district?: string | null, complement?: string | null, customer_id?: string | null, source: string, two_factor_authentication: boolean, passwordless: boolean, teams: Array<{ __typename?: 'teams', id: number }> }> } | null };

export type ResetUserPasswordMutationVariables = Exact<{
  email: Scalars['String'];
  old_password_hash_string_comparison_exp?: InputMaybe<String_Comparison_Exp>;
  new_password: Scalars['String'];
}>;


export type ResetUserPasswordMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', returning: Array<{ __typename?: 'users', id: number, email?: string | null }> } | null };

export type FindUserByRefreshTokenQueryQueryVariables = Exact<{
  refresh_token: Scalars['String'];
}>;


export type FindUserByRefreshTokenQueryQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: number, teams_users: Array<{ __typename?: 'teams_users', team: { __typename?: 'teams', id: number, is_personal: boolean } }> }> };

export type UpdateUserRefreshTokenGqlMutationVariables = Exact<{
  user_id: Scalars['Int'];
  token: Scalars['String'];
}>;


export type UpdateUserRefreshTokenGqlMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: number, jwt_refresh_token?: string | null } | null };

export type GetUserAuthCodeQueryVariables = Exact<{
  user_id: Scalars['Int'];
}>;


export type GetUserAuthCodeQuery = { __typename?: 'query_root', user_auth_codes: Array<{ __typename?: 'user_auth_codes', code: string, created_at: any }> };

export type TokenSubscriptionSubscriptionVariables = Exact<{
  token: Scalars['String'];
}>;


export type TokenSubscriptionSubscription = { __typename?: 'subscription_root', users: Array<{ __typename?: 'users', token?: { __typename?: 'tokens', verified: boolean } | null }> };

export type GetAuthDashboardTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetAuthDashboardTokenMutation = { __typename?: 'mutation_root', authDashboardToken: { __typename?: 'AuthDashboardTokenOutput', id: number, token: string, dashboard_token: string } };

export type FindRulesQueryVariables = Exact<{
  compliance_id: Scalars['Int'];
}>;


export type FindRulesQuery = { __typename?: 'query_root', compliance_rules: Array<{ __typename?: 'compliance_rules', id: number, rule: string, name: string, description?: string | null, compliance_policy?: { __typename?: 'compliance_policies', id: number, name: string, description?: string | null, cc_emails?: any | null } | null }> };

export type FindComplianceContactFromSessionQueryVariables = Exact<{
  session_uuid: Scalars['uuid'];
}>;


export type FindComplianceContactFromSessionQuery = { __typename?: 'query_root', compliance_contacts: Array<{ __typename?: 'compliance_contacts', id?: number | null, name?: string | null, email?: string | null, phone?: string | null, compliance_id?: number | null, compliance_group_contact?: { __typename?: 'compliance_group_contacts', compliance_group?: { __typename?: 'compliance_groups', compliance_group_users: Array<{ __typename?: 'compliance_group_users', user: { __typename?: 'users', email?: string | null } }> } | null } | null }> };

export type InsertEventMutationMutationVariables = Exact<{
  object?: Compliance_Events_Insert_Input;
}>;


export type InsertEventMutationMutation = { __typename?: 'mutation_root', insert_compliance_events_one?: { __typename?: 'compliance_events', id: number } | null };

export type FindPreviousEventMessagesQueryVariables = Exact<{
  compliance_contact_id: Scalars['Int'];
  timestamp: Scalars['Int'];
  from: Scalars['String'];
  to: Scalars['String'];
}>;


export type FindPreviousEventMessagesQuery = { __typename?: 'query_root', compliance_messages: Array<{ __typename?: 'compliance_messages', message_key?: string | null, body?: string | null, caption?: string | null, type?: string | null, mime_type?: string | null, is_group_msg?: boolean | null, from_me?: boolean | null, from?: string | null, to?: string | null, participant?: string | null, unix_timestamp?: number | null }> };

export type ComplianceFilterGroupsGqlQueryVariables = Exact<{
  search: Scalars['String'];
  compliance: Scalars['Int'];
}>;


export type ComplianceFilterGroupsGqlQuery = { __typename?: 'query_root', compliance_groups: Array<{ __typename?: 'compliance_groups', id: number, name: string, description?: string | null }> };

export type ComplianceFilterContactsGqlQueryVariables = Exact<{
  search: Scalars['String'];
  compliance_id: Scalars['Int'];
}>;


export type ComplianceFilterContactsGqlQuery = { __typename?: 'query_root', compliance_contacts: Array<{ __typename?: 'compliance_contacts', id?: number | null, email?: string | null, name?: string | null, phone?: string | null }> };

export type ComplianceFilterMembersGqlQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type ComplianceFilterMembersGqlQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: number, email?: string | null, name?: string | null, phone?: string | null }> };

export type ComplianceFilterPoliciesGqlQueryVariables = Exact<{
  search: Scalars['String'];
  compliance: Scalars['Int'];
}>;


export type ComplianceFilterPoliciesGqlQuery = { __typename?: 'query_root', compliance_policies: Array<{ __typename?: 'compliance_policies', id: number, name: string, description?: string | null }> };

export type ComplianceTagsFilterGqlQueryVariables = Exact<{
  compliance_id: Scalars['Int'];
  search: Scalars['String'];
}>;


export type ComplianceTagsFilterGqlQuery = { __typename?: 'query_root', compliance_tags: Array<{ __typename?: 'compliance_tags', id: number, name: string, description?: string | null }> };

export type ComplianceContactsInsertGqlMutationVariables = Exact<{
  objects: Array<Compliance_Contacts_Raw_Insert_Input> | Compliance_Contacts_Raw_Insert_Input;
}>;


export type ComplianceContactsInsertGqlMutation = { __typename?: 'mutation_root', insert_compliance_contacts_raw?: { __typename?: 'compliance_contacts_raw_mutation_response', returning: Array<{ __typename?: 'compliance_contacts_raw', id: number, name?: string | null, email?: string | null, phone?: string | null, tags?: any | null, status: string, created_at: any, updated_at: any, invite_counter: number }> } | null };

export type InsertWsSessionsGqlMutationVariables = Exact<{
  sessions: Array<Ws_Sessions_Insert_Input> | Ws_Sessions_Insert_Input;
}>;


export type InsertWsSessionsGqlMutation = { __typename?: 'mutation_root', insert_ws_sessions?: { __typename?: 'ws_sessions_mutation_response', returning: Array<{ __typename?: 'ws_sessions', id: number, uuid: any, status?: string | null }> } | null };

export type InviteRulesRecipientsGqlQueryVariables = Exact<{
  inviteRuleId?: InputMaybe<Scalars['bigint']>;
}>;


export type InviteRulesRecipientsGqlQuery = { __typename?: 'query_root', invite_rules_recipients: Array<{ __typename?: 'invite_rules_recipients', id: any, invite_rule_id?: any | null, send_to: string, template: string }> };

export type InviteRulesGqlQueryVariables = Exact<{
  teamId?: InputMaybe<Scalars['bigint']>;
}>;


export type InviteRulesGqlQuery = { __typename?: 'query_root', invite_rules: Array<{ __typename?: 'invite_rules', id: any, disconnection_period_start: any, disconnection_period_end?: any | null, unit: any, invite_time?: any | null, is_default: boolean, team_id?: any | null, invite_until_accepted: boolean, is_disabled: boolean }> };

export type InviteRulesDefaultGqlQueryVariables = Exact<{ [key: string]: never; }>;


export type InviteRulesDefaultGqlQuery = { __typename?: 'query_root', invite_rules: Array<{ __typename?: 'invite_rules', id: any, disconnection_period_start: any, disconnection_period_end?: any | null, unit: any, invite_time?: any | null, is_default: boolean, team_id?: any | null, invite_until_accepted: boolean, is_disabled: boolean }> };

export type SelectUnauthenticatedSessionsGqlQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectUnauthenticatedSessionsGqlQuery = { __typename?: 'query_root', ws_sessions: Array<{ __typename?: 'ws_sessions', uuid: any, status?: string | null, last_connected_at?: any | null, connected_at: any, compliance_contact?: { __typename?: 'compliance_contacts_raw', id: number, email?: string | null, name?: string | null, invite_counter: number, compliance: { __typename?: 'compliance', id: number, name: string, team_id: number, team: { __typename?: 'teams', metadata?: any | null } }, compliance_contacts_status?: { __typename?: 'compliance_contacts_status', manager_email?: string | null } | null, compliance_group_contact?: { __typename?: 'compliance_group_contacts', compliance_group?: { __typename?: 'compliance_groups', metadata?: any | null } | null } | null } | null }> };

export type UpdateComplianceContactsWsSessionRefGqlMutationVariables = Exact<{
  objects: Array<Compliance_Contacts_Raw_Insert_Input> | Compliance_Contacts_Raw_Insert_Input;
}>;


export type UpdateComplianceContactsWsSessionRefGqlMutation = { __typename?: 'mutation_root', insert_compliance_contacts_raw?: { __typename?: 'compliance_contacts_raw_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'compliance_contacts_raw', id: number, name?: string | null, status: string, compliance_id: number }> } | null };

export type UpdateLastConnectedAtSessionTimeMutationVariables = Exact<{
  uuid: Scalars['uuid'];
  lastConnectedAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type UpdateLastConnectedAtSessionTimeMutation = { __typename?: 'mutation_root', update_ws_sessions_by_pk?: { __typename?: 'ws_sessions', uuid: any, name?: string | null, status?: string | null, last_connected_at?: any | null } | null };

export type InsertLogsMutationVariables = Exact<{
  objects: Array<Logs_Insert_Input> | Logs_Insert_Input;
}>;


export type InsertLogsMutation = { __typename?: 'mutation_root', insert_logs?: { __typename?: 'logs_mutation_response', affected_rows: number } | null };

export type FindUserQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindUserQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: number, name?: string | null, cpf_cnpj?: string | null, email?: string | null, password?: string | null, phone?: string | null, zip_code?: string | null, number?: string | null, street?: string | null, city?: string | null, state?: string | null, district?: string | null, complement?: string | null, customer_id?: string | null, source: string, teams: Array<{ __typename?: 'teams', id: number }> } | null };

export type MyMutationMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type MyMutationMutation = { __typename?: 'mutation_root', delete_tokens?: { __typename?: 'tokens_mutation_response', returning: Array<{ __typename?: 'tokens', id: number }> } | null };

export type FindUserWithPersonalTeamsByRefreshTokenQueryQueryVariables = Exact<{
  refresh_token: Scalars['String'];
}>;


export type FindUserWithPersonalTeamsByRefreshTokenQueryQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: number, email?: string | null, teams: Array<{ __typename?: 'teams', id: number }> }> };

export type AuthForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type AuthForgotPasswordMutation = { __typename?: 'mutation_root', authForgotPassword?: { __typename?: 'forgotPasswordOutput', message: string } | null };

export type SendAuthCodeMutationVariables = Exact<{
  phone: Scalars['String'];
  user_id: Scalars['Int'];
  mode: Scalars['String'];
}>;


export type SendAuthCodeMutation = { __typename?: 'mutation_root', twilioSendAuthCode?: { __typename?: 'SendWhatsAppAuthCodeOutput', id: string, status: string, error?: string | null } | null };

export type UpdateTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type UpdateTokenMutation = { __typename?: 'mutation_root', update_tokens?: { __typename?: 'tokens_mutation_response', returning: Array<{ __typename?: 'tokens', id: number, token: string, verified: boolean }> } | null };

export type ComplianceContactsStatusQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ComplianceContactsStatusQueryQuery = { __typename?: 'query_root', compliance_contacts_status: Array<{ __typename?: 'compliance_contacts_status', email?: string | null, group?: string | null, name?: string | null, phone?: string | null, status?: string | null, uuid?: any | null, manager_email?: string | null }> };

export type WeeklyEventsQueryQueryVariables = Exact<{
  where?: InputMaybe<Compliance_Events_Weekly_Reports_Bool_Exp>;
}>;


export type WeeklyEventsQueryQuery = { __typename?: 'query_root', compliance_events_weekly_reports: Array<{ __typename?: 'compliance_events_weekly_reports', email?: string | null, name?: string | null, message?: string | null, event_status?: string | null, created_at?: any | null, policy?: string | null, risk?: string | null, rule?: string | null, rule_name?: string | null, status?: string | null, contact_email?: string | null, contact_name?: string | null }> };

export type UpdateStatusMutationVariables = Exact<{
  id: Scalars['Int'];
  status: Scalars['String'];
}>;


export type UpdateStatusMutation = { __typename?: 'mutation_root', update_compliance_contacts?: { __typename?: 'compliance_contacts_mutation_response', returning: Array<{ __typename?: 'compliance_contacts', id?: number | null, status?: string | null, ws_session?: { __typename?: 'ws_sessions', id: number } | null }> } | null };

export type UpdateStatsMutationVariables = Exact<{
  stats: Ws_Sessions_Stats_Insert_Input;
}>;


export type UpdateStatsMutation = { __typename?: 'mutation_root', insert_ws_sessions_stats_one?: { __typename?: 'ws_sessions_stats', id: number } | null };

export type GetLastMessageToAnalysisQueryVariables = Exact<{
  complianceId: Scalars['Int'];
  agentIdentifier: Scalars['String'];
  contactPhone: Scalars['String'];
  agentPhone: Scalars['String'];
}>;


export type GetLastMessageToAnalysisQuery = { __typename?: 'query_root', compliance_messages: Array<{ __typename?: 'compliance_messages', body?: string | null, from?: string | null, to?: string | null, unix_timestamp?: number | null }> };

export type GetMessagesToAnalysisQueryVariables = Exact<{
  complianceId: Scalars['Int'];
  agentIdentifier: Scalars['String'];
  contactPhone: Scalars['String'];
  startDate: Scalars['Int'];
  endDate: Scalars['Int'];
  agentPhone: Scalars['String'];
}>;


export type GetMessagesToAnalysisQuery = { __typename?: 'query_root', compliance_messages: Array<{ __typename?: 'compliance_messages', body?: string | null, from?: string | null, to?: string | null }> };

export type UsersGqlQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersGqlQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', email?: string | null }> };

export type CurrentContactGqlQueryVariables = Exact<{
  uuid: Scalars['uuid'];
}>;


export type CurrentContactGqlQuery = { __typename?: 'query_root', ws_sessions_by_pk?: { __typename?: 'ws_sessions', id: number, uuid: any, compliance_contact?: { __typename?: 'compliance_contacts_raw', email?: string | null, phone?: string | null, compliance: { __typename?: 'compliance', id: number, name: string, team_id: number, team: { __typename?: 'teams', name: string } } } | null } | null };

export type UpdateComplianceContactsDataAfterInviteMutationVariables = Exact<{
  objects: Array<Compliance_Contacts_Raw_Insert_Input> | Compliance_Contacts_Raw_Insert_Input;
}>;


export type UpdateComplianceContactsDataAfterInviteMutation = { __typename?: 'mutation_root', insert_compliance_contacts_raw?: { __typename?: 'compliance_contacts_raw_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'compliance_contacts_raw', id: number, email?: string | null, status: string, updated_at: any, invite_counter: number, deleted: boolean }> } | null };

export type ContactsToInviteGqlQueryVariables = Exact<{
  contacts_ids: Array<Scalars['Int']> | Scalars['Int'];
  contacts_emails: Array<Scalars['String']> | Scalars['String'];
}>;


export type ContactsToInviteGqlQuery = { __typename?: 'query_root', compliance_contacts_raw: Array<{ __typename?: 'compliance_contacts_raw', id: number, email?: string | null, invite_counter: number, status: string, deleted: boolean, compliance: { __typename?: 'compliance', id: number, name: string, team_id: number }, ws_session?: { __typename?: 'ws_sessions', id: number, uuid: any, status?: string | null } | null }> };

export type UpdateComplianceContactsSessionRefToInviteMutationVariables = Exact<{
  objects: Array<Compliance_Contacts_Raw_Insert_Input> | Compliance_Contacts_Raw_Insert_Input;
}>;


export type UpdateComplianceContactsSessionRefToInviteMutation = { __typename?: 'mutation_root', insert_compliance_contacts_raw?: { __typename?: 'compliance_contacts_raw_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'compliance_contacts_raw', id: number, status: string, updated_at: any, invite_counter: number, deleted: boolean, ws_session?: { __typename?: 'ws_sessions', id: number, uuid: any, status?: string | null } | null }> } | null };

export type FindMessagesByMinutesQueryVariables = Exact<{
  timestamp: Scalars['Int'];
}>;


export type FindMessagesByMinutesQuery = { __typename?: 'query_root', compliance_messages: Array<{ __typename?: 'compliance_messages', id?: number | null, body?: string | null, unix_timestamp?: number | null, session_uuid?: any | null, from_contact?: { __typename?: 'ws_contacts', id: number } | null, to_contact?: { __typename?: 'ws_contacts', id: number } | null }> };

export type InsertComplianceUsersGqlMutationVariables = Exact<{
  objects: Array<Users_Insert_Input> | Users_Insert_Input;
}>;


export type InsertComplianceUsersGqlMutation = { __typename?: 'mutation_root', insert_users?: { __typename?: 'users_mutation_response', returning: Array<{ __typename?: 'users', id: number, email?: string | null, name?: string | null, phone?: string | null }> } | null };

export type InsertUserAuthCodeMutationVariables = Exact<{
  code: Scalars['String'];
  mode: Scalars['String'];
  user_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
}>;


export type InsertUserAuthCodeMutation = { __typename?: 'mutation_root', insert_user_auth_codes_one?: { __typename?: 'user_auth_codes', id: number } | null };

export type UserDetailsGqlQueryVariables = Exact<{
  id: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type UserDetailsGqlQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', email?: string | null, roles_users: Array<{ __typename?: 'roles_users', role: { __typename?: 'roles', alias: string } }> } | null };

export type GetCompliancesQueryVariables = Exact<{
  active_team_id: Scalars['Int'];
}>;


export type GetCompliancesQuery = { __typename?: 'query_root', compliance: Array<{ __typename?: 'compliance', id: number, name: string, description: string, compliance_events: Array<{ __typename?: 'compliance_events', id: number }> }> };

export type LogsGqlQueryVariables = Exact<{
  teamId?: InputMaybe<Scalars['Int']>;
}>;


export type LogsGqlQuery = { __typename?: 'query_root', logs: Array<{ __typename?: 'logs', id: number, name: string, description: string, data: any, created_at: any }> };

export type VerifyMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyMutation = { __typename?: 'mutation_root', authVerifyToken: { __typename?: 'AuthVerifyTokenOutput', token: string, verified: boolean } };

export type AuthSignInOrSignUpMutationVariables = Exact<{
  object: AuthSignInOrSignUpInput;
}>;


export type AuthSignInOrSignUpMutation = { __typename?: 'mutation_root', authSignInOrSignUp: { __typename?: 'AuthSignInOrSignUpOutput', id: number, token?: string | null, dashboard_token?: string | null, name?: string | null, email?: string | null, phone?: string | null, source: string, mode: string, two_factor_authentication: boolean, passwordless: boolean, team_id: number, team_name: string } };

export type CheckConsentGivenQueryVariables = Exact<{
  agent_uuid?: InputMaybe<Scalars['uuid']>;
  contact_phone?: InputMaybe<Scalars['String']>;
}>;


export type CheckConsentGivenQuery = { __typename?: 'query_root', consent: Array<{ __typename?: 'consent', id: number }> };

export type InsertConsentMutationVariables = Exact<{
  agent_uuid?: InputMaybe<Scalars['uuid']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  crm?: InputMaybe<Scalars['String']>;
}>;


export type InsertConsentMutation = { __typename?: 'mutation_root', insert_consent_one?: { __typename?: 'consent', id: number } | null };

export type GetContactsConsentsQueryVariables = Exact<{
  ws_session_ref?: InputMaybe<Scalars['uuid']>;
}>;


export type GetContactsConsentsQuery = { __typename?: 'query_root', consent: Array<{ __typename?: 'consent', contact_phone: string, pending: boolean, crm?: string | null, source?: string | null, external_name?: string | null, external_crm?: string | null, contact?: { __typename?: 'ws_contacts', name?: string | null, phone: string, profile_pic?: string | null } | null }>, compliance_messages: Array<{ __typename?: 'compliance_messages', to?: string | null, from?: string | null, to_contact?: { __typename?: 'ws_contacts', name?: string | null, phone: string, profile_pic?: string | null, consents: Array<{ __typename?: 'consent', id: number, external_name?: string | null, external_crm?: string | null, pending: boolean, crm?: string | null }> } | null }> };

export type LogScanPageMutationVariables = Exact<{
  object: ScanPageOpenInput;
}>;


export type LogScanPageMutation = { __typename?: 'mutation_root', logScanPageOpen?: { __typename?: 'ScanPageOpenOutput', success?: boolean | null } | null };

export type LogScanQrcodeMutationVariables = Exact<{
  object: ScanQrcodeInput;
}>;


export type LogScanQrcodeMutation = { __typename?: 'mutation_root', logScanQrcode?: { __typename?: 'ScanQrcodeOutput', success?: boolean | null } | null };

export type GetUsersTeamQueryVariables = Exact<{
  team_id: Scalars['Int'];
}>;


export type GetUsersTeamQuery = { __typename?: 'query_root', teams: Array<{ __typename?: 'teams', is_personal: boolean }>, teams_users: Array<{ __typename?: 'teams_users', user: { __typename?: 'users', id: number, email?: string | null, phone?: string | null } }> };

export type UserTeamsGqlQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTeamsGqlQuery = { __typename?: 'query_root', teams: Array<{ __typename?: 'teams', id: number, is_personal: boolean, name: string }> };

export type CreateTeamGqlMutationVariables = Exact<{
  group_name: Scalars['String'];
  user_id: Scalars['Int'];
}>;


export type CreateTeamGqlMutation = { __typename?: 'mutation_root', insert_teams_one?: { __typename?: 'teams', id: number, name: string, is_personal: boolean } | null };


export const ImportCsvManagersGQlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ImportCsvManagersGQl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_group_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ImportCsvManagersGQlQuery, ImportCsvManagersGQlQueryVariables>;
export const UpsertUsersGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertUsersGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"users_email_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"phone"},{"kind":"EnumValue","value":"name"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertUsersGqlMutation, UpsertUsersGqlMutationVariables>;
export const ComplianceGroupsAndUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceGroupsAndUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_contacts_raw"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_group_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ComplianceGroupsAndUsersQuery, ComplianceGroupsAndUsersQueryVariables>;
export const ComplianceGroupsInsertApigqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceGroupsInsertAPIGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_groups_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceGroupsInsertApigqlMutation, ComplianceGroupsInsertApigqlMutationVariables>;
export const ComplianceContactsUpsertApigqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceContactsUpsertAPIGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_contacts_raw_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_contacts_raw"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"compliance_contacts_compliance_id_email_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"phone"},{"kind":"EnumValue","value":"deleted"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceContactsUpsertApigqlMutation, ComplianceContactsUpsertApigqlMutationVariables>;
export const InsertComplianceContactsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertComplianceContactsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"insertComplianceContactData"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertComplianceContactsInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertComplianceContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"compliance_contacts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"insertComplianceContactData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inserted_compliance_contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invite_counter"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]} as unknown as DocumentNode<InsertComplianceContactsGqlMutation, InsertComplianceContactsGqlMutationVariables>;
export const ComplianceContactGroupUsertApigqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceContactGroupUsertAPIGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_group_contacts_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_group_contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"compliance_group_contacts_compliance_contact_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"compliance_group_id"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceContactGroupUsertApigqlMutation, ComplianceContactGroupUsertApigqlMutationVariables>;
export const DeleteComplianceGroupContactsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteComplianceGroupContactsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_compliance_group_contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_contact_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteComplianceGroupContactsGqlMutation, DeleteComplianceGroupContactsGqlMutationVariables>;
export const InsertUsersApigqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUsersAPIGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersInsert"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inserted_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<InsertUsersApigqlMutation, InsertUsersApigqlMutationVariables>;
export const InsertComplianceGroupUsersApigqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertComplianceGroupUsersAPIGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_group_users_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_group_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertComplianceGroupUsersApigqlMutation, InsertComplianceGroupUsersApigqlMutationVariables>;
export const DeleteComplianceGroupUsersCsvImportGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteComplianceGroupUsersCsvImportGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_compliance_group_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteComplianceGroupUsersCsvImportGqlMutation, DeleteComplianceGroupUsersCsvImportGqlMutationVariables>;
export const ComplianceContactsDisableApigqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceContactsDisableAPIGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_compliance_contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceContactsDisableApigqlMutation, ComplianceContactsDisableApigqlMutationVariables>;
export const ComplianceContactsReinviteApigqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceContactsReinviteAPIGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contacts"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReinviteContact"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reinviteContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contacts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contacts"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invite_counter"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<ComplianceContactsReinviteApigqlMutation, ComplianceContactsReinviteApigqlMutationVariables>;
export const InviteUsersApigqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InviteUsersAPIGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersInvite"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invited_users"}}]}}]}}]} as unknown as DocumentNode<InviteUsersApigqlMutation, InviteUsersApigqlMutationVariables>;
export const CompliancePoliciesApigqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompliancePoliciesAPIGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_policies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_rules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"risk"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enable"}}]}}]}}]} as unknown as DocumentNode<CompliancePoliciesApigqlQuery, CompliancePoliciesApigqlQueryVariables>;
export const InsertCompliancePoliciesApigqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertCompliancePoliciesAPIGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_policies_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_policies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<InsertCompliancePoliciesApigqlMutation, InsertCompliancePoliciesApigqlMutationVariables>;
export const InsertComplianceRulesApigqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertComplianceRulesAPIGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_rules_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_rules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"compliance_rules_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"risk"},{"kind":"EnumValue","value":"compliance_policy_id"},{"kind":"EnumValue","value":"enable"},{"kind":"EnumValue","value":"description"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"risk"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enable"}}]}}]}}]}}]} as unknown as DocumentNode<InsertComplianceRulesApigqlMutation, InsertComplianceRulesApigqlMutationVariables>;
export const DisableComplianceRulesApigqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisableComplianceRulesAPIGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_compliance_rules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"enable"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DisableComplianceRulesApigqlMutation, DisableComplianceRulesApigqlMutationVariables>;
export const ComplianceGroupUpdateGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceGroupUpdateGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"columns"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_groups_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_compliance_groups_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"columns"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<ComplianceGroupUpdateGqlMutation, ComplianceGroupUpdateGqlMutationVariables>;
export const ComplianceGroupDeleteGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceGroupDeleteGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_compliance_groups_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ComplianceGroupDeleteGqlMutation, ComplianceGroupDeleteGqlMutationVariables>;
export const ComplianceGroupDeleteWithMembersGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceGroupDeleteWithMembersGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_compliance_group_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_compliance_group_contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_compliance_groups_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ComplianceGroupDeleteWithMembersGqlMutation, ComplianceGroupDeleteWithMembersGqlMutationVariables>;
export const UserGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserGQL"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"roles_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_group_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"roles_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserGqlQuery, UserGqlQueryVariables>;
export const ComplianceRulesGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceRulesGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_rules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"risk"}},{"kind":"Field","alias":{"kind":"Name","value":"policy"},"name":{"kind":"Name","value":"compliance_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"enable"}}]}}]}}]} as unknown as DocumentNode<ComplianceRulesGqlQuery, ComplianceRulesGqlQueryVariables>;
export const ComplianceContactsUpdateFromSettingsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceContactsUpdateFromSettingsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"columns"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_contacts_raw_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_compliance_contacts_raw_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"columns"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<ComplianceContactsUpdateFromSettingsGqlMutation, ComplianceContactsUpdateFromSettingsGqlMutationVariables>;
export const ComplianceContactGroupUsertFromSettingsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceContactGroupUsertFromSettingsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_group_contacts_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_group_contacts_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"compliance_group_contacts_compliance_contact_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"compliance_group_id"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_group_id"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_contact_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<ComplianceContactGroupUsertFromSettingsGqlMutation, ComplianceContactGroupUsertFromSettingsGqlMutationVariables>;
export const ComplianceContactsReinviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceContactsReinvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contacts"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReinviteContact"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CurrentUser"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ignoreConnecteds"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useTemporal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reinviteContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contacts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contacts"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"Argument","name":{"kind":"Name","value":"ignoreConnecteds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ignoreConnecteds"}}},{"kind":"Argument","name":{"kind":"Name","value":"complianceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"useTemporal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useTemporal"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invite_counter"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<ComplianceContactsReinviteMutation, ComplianceContactsReinviteMutationVariables>;
export const ComplianceContactsRemovePhoneFromSettingsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceContactsRemovePhoneFromSettingsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phones"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_compliance_contacts_raw"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"NullValue"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phones"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<ComplianceContactsRemovePhoneFromSettingsGqlMutation, ComplianceContactsRemovePhoneFromSettingsGqlMutationVariables>;
export const RefreshJwtTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"refreshJwtToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshJwtToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]} as unknown as DocumentNode<RefreshJwtTokenMutation, RefreshJwtTokenMutationVariables>;
export const ContactsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContactsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}}]}}]}}]} as unknown as DocumentNode<ContactsQueryQuery, ContactsQueryQueryVariables>;
export const ComplianceEventsDailyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceEventsDailyQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_events_daily_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_events_daily"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event_count"}},{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}}]}}]}}]} as unknown as DocumentNode<ComplianceEventsDailyQueryQuery, ComplianceEventsDailyQueryQueryVariables>;
export const ComplianceEventsHourlyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceEventsHourlyQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_events_hourly_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_events_hourly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event_count"}},{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}}]}}]}}]} as unknown as DocumentNode<ComplianceEventsHourlyQueryQuery, ComplianceEventsHourlyQueryQueryVariables>;
export const ComplianceEventsMonthQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceEventsMonthQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_events_monthly_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_events_monthly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event_count"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}}]}}]}}]} as unknown as DocumentNode<ComplianceEventsMonthQueryQuery, ComplianceEventsMonthQueryQueryVariables>;
export const ComplianceEventsWeekQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceEventsWeekQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_events_weekly_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_events_weekly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event_count"}},{"kind":"Field","name":{"kind":"Name","value":"week"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}}]}}]}}]} as unknown as DocumentNode<ComplianceEventsWeekQueryQuery, ComplianceEventsWeekQueryQueryVariables>;
export const ComplianceEventsYearQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceEventsYearQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_events_yearly_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_events_yearly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event_count"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}}]}}]}}]} as unknown as DocumentNode<ComplianceEventsYearQueryQuery, ComplianceEventsYearQueryQueryVariables>;
export const ComplianceEventsStatusHourlyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceEventsStatusHourlyQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_events_status_hourly_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_events_status_hourly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event_count"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}}]}}]}}]} as unknown as DocumentNode<ComplianceEventsStatusHourlyQueryQuery, ComplianceEventsStatusHourlyQueryQueryVariables>;
export const QueryComplianceEventsStatusTotalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryComplianceEventsStatusTotal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_events_status_total"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_status_count"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<QueryComplianceEventsStatusTotalQuery, QueryComplianceEventsStatusTotalQueryVariables>;
export const QueryTotalEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryTotalEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_events_total"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_count"}}]}}]}}]} as unknown as DocumentNode<QueryTotalEventsQuery, QueryTotalEventsQueryVariables>;
export const ComplianceMessagesDailyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceMessagesDailyQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_messages_daily_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_messages_daily"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message_count"}},{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}}]}}]}}]} as unknown as DocumentNode<ComplianceMessagesDailyQueryQuery, ComplianceMessagesDailyQueryQueryVariables>;
export const ComplianceMessagesHourlyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceMessagesHourlyQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_messages_hourly_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_messages_hourly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message_count"}},{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}}]}}]}}]} as unknown as DocumentNode<ComplianceMessagesHourlyQueryQuery, ComplianceMessagesHourlyQueryQueryVariables>;
export const ComplianceMessagesMonthlyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceMessagesMonthlyQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_messages_monthly_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_messages_monthly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message_count"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}}]}}]}}]} as unknown as DocumentNode<ComplianceMessagesMonthlyQueryQuery, ComplianceMessagesMonthlyQueryQueryVariables>;
export const ComplianceMessagesWeekQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceMessagesWeekQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_messages_weekly_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_messages_weekly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message_count"}},{"kind":"Field","name":{"kind":"Name","value":"week"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}}]}}]}}]} as unknown as DocumentNode<ComplianceMessagesWeekQueryQuery, ComplianceMessagesWeekQueryQueryVariables>;
export const ComplianceMessagesYearlyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceMessagesYearlyQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_messages_yearly_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_messages_yearly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message_count"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}}]}}]}}]} as unknown as DocumentNode<ComplianceMessagesYearlyQueryQuery, ComplianceMessagesYearlyQueryQueryVariables>;
export const QueryTotalMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryTotalMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_messages_total"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}},{"kind":"Field","name":{"kind":"Name","value":"message_count"}}]}}]}}]} as unknown as DocumentNode<QueryTotalMessagesQuery, QueryTotalMessagesQueryVariables>;
export const ChatListQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatListQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceContactId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chat_list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"last_message_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"status","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"session"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_contact"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceContactId"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_group"}},{"kind":"Field","name":{"kind":"Name","value":"last_message_is_from_me"}},{"kind":"Field","name":{"kind":"Name","value":"last_message_text"}},{"kind":"Field","name":{"kind":"Name","value":"last_message_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"last_message_type"}},{"kind":"Field","name":{"kind":"Name","value":"muted"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}},{"kind":"Field","name":{"kind":"Name","value":"session_uuid"}},{"kind":"Field","name":{"kind":"Name","value":"unread_count"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}}]} as unknown as DocumentNode<ChatListQueryQuery, ChatListQueryQueryVariables>;
export const ChatListSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ChatListSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceContactId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chat_list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"last_message_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"status","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"last_message_timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"session"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_contact"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceContactId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_group"}},{"kind":"Field","name":{"kind":"Name","value":"last_message_is_from_me"}},{"kind":"Field","name":{"kind":"Name","value":"last_message_text"}},{"kind":"Field","name":{"kind":"Name","value":"last_message_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"last_message_type"}},{"kind":"Field","name":{"kind":"Name","value":"muted"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}},{"kind":"Field","name":{"kind":"Name","value":"session_uuid"}},{"kind":"Field","name":{"kind":"Name","value":"unread_count"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}}]} as unknown as DocumentNode<ChatListSubscriptionSubscription, ChatListSubscriptionSubscriptionVariables>;
export const AdminComplianceContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminComplianceContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contact_filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_contacts_raw_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contact_filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"invite_counter"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"ws_session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"last_connected_at"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"chat_lists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"last_message_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"last_message_timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_group_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminComplianceContactsQuery, AdminComplianceContactsQueryVariables>;
export const AnalystComplianceContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AnalystComplianceContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contact_filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_contacts_raw_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_group_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_group_contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_contact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contact_filter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"invite_counter"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"ws_session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"last_connected_at"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"chat_lists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"last_message_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"last_message_timestamp"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AnalystComplianceContactsQuery, AnalystComplianceContactsQueryVariables>;
export const ComplianceContactsDisableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceContactsDisable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contacts"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_compliance_contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contacts"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"StringValue","value":"disconnected","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_compliance_group_contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_contact_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contacts"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceContactsDisableMutation, ComplianceContactsDisableMutationVariables>;
export const ComplianceEventsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceEventsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_events_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"compliance"},"name":{"kind":"Name","value":"compliance_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_me"}},{"kind":"Field","name":{"kind":"Name","value":"is_group_msg"}},{"kind":"Field","name":{"kind":"Name","value":"message_key"}},{"kind":"Field","name":{"kind":"Name","value":"mime_type"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unix_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"transcription"}},{"kind":"Field","name":{"kind":"Name","value":"is_deleted"}},{"kind":"Field","name":{"kind":"Name","value":"ws_session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ws_session_ref"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participant_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"ws_session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_rule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceEventsGqlQuery, ComplianceEventsGqlQueryVariables>;
export const ComplianceEventsSubscriptionGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ComplianceEventsSubscriptionGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_events_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"compliance"},"name":{"kind":"Name","value":"compliance_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_me"}},{"kind":"Field","name":{"kind":"Name","value":"is_group_msg"}},{"kind":"Field","name":{"kind":"Name","value":"message_key"}},{"kind":"Field","name":{"kind":"Name","value":"mime_type"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unix_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"transcription"}},{"kind":"Field","name":{"kind":"Name","value":"is_deleted"}},{"kind":"Field","name":{"kind":"Name","value":"ws_session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ws_session_ref"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participant_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"ws_session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_rule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceEventsSubscriptionGqlSubscription, ComplianceEventsSubscriptionGqlSubscriptionVariables>;
export const ComplianceEventsClassificationCountGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceEventsClassificationCountGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"final"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"week_total_low"},"name":{"kind":"Name","value":"compliance_events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_rule"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"risk"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"low","block":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"final"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"week_total_moderate"},"name":{"kind":"Name","value":"compliance_events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_rule"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"risk"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"moderate","block":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"final"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"week_total_high"},"name":{"kind":"Name","value":"compliance_events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_rule"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"risk"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"high","block":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"final"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"week_rated_low"},"name":{"kind":"Name","value":"compliance_events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_rule"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"risk"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"low","block":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"new","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"final"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"week_rated_moderate"},"name":{"kind":"Name","value":"compliance_events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_rule"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"risk"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"moderate","block":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"new","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"final"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"week_rated_high"},"name":{"kind":"Name","value":"compliance_events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_rule"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"risk"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"high","block":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"new","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"final"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceEventsClassificationCountGqlQuery, ComplianceEventsClassificationCountGqlQueryVariables>;
export const ComplianceEventsClassificationGoalsByComplianceIdGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceEventsClassificationGoalsByComplianceIdGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_events_classification_goals_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"moderate"}},{"kind":"Field","name":{"kind":"Name","value":"high"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"enable"}}]}}]}}]} as unknown as DocumentNode<ComplianceEventsClassificationGoalsByComplianceIdGqlQuery, ComplianceEventsClassificationGoalsByComplianceIdGqlQueryVariables>;
export const ComplianceEventsClassificationGroupsResumeGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceEventsClassificationGroupsResumeGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"final"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_group_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"week_total_low"},"name":{"kind":"Name","value":"compliance_events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_rule"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"risk"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"low","block":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"final"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"week_total_moderate"},"name":{"kind":"Name","value":"compliance_events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_rule"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"risk"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"moderate","block":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"final"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"week_total_high"},"name":{"kind":"Name","value":"compliance_events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_rule"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"risk"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"high","block":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"final"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"week_rated_low"},"name":{"kind":"Name","value":"compliance_events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_rule"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"risk"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"low","block":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"new","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"final"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"week_rated_moderate"},"name":{"kind":"Name","value":"compliance_events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_rule"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"risk"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"moderate","block":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"new","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"final"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"week_rated_high"},"name":{"kind":"Name","value":"compliance_events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_rule"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"risk"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"high","block":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"new","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"final"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceEventsClassificationGroupsResumeGqlQuery, ComplianceEventsClassificationGroupsResumeGqlQueryVariables>;
export const ComplianceEventsClassificationResumeGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceEventsClassificationResumeGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_events_classification_resumes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"final_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initial_date"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]} as unknown as DocumentNode<ComplianceEventsClassificationResumeGqlQuery, ComplianceEventsClassificationResumeGqlQueryVariables>;
export const CompliancePoliciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompliancePolicies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_policies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CompliancePoliciesQuery, CompliancePoliciesQueryVariables>;
export const ComplianceGroupsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceGroupsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_group_contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_group_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceGroupsGqlQuery, ComplianceGroupsGqlQueryVariables>;
export const ComplianceGroupsWithEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceGroupsWithEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_groups_with_events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"start_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ComplianceGroupsWithEventsQuery, ComplianceGroupsWithEventsQueryVariables>;
export const ComplianceGroupsInsertGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceGroupsInsertGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_groups_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceGroupsInsertGqlMutation, ComplianceGroupsInsertGqlMutationVariables>;
export const GetComplianceMessageMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComplianceMessageMetadata"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]} as unknown as DocumentNode<GetComplianceMessageMetadataQuery, GetComplianceMessageMetadataQueryVariables>;
export const ComplianceContactsParticipantsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceContactsParticipantsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compliance_contact_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int_comparison_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int_comparison_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_contact_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compliance_contact_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_contact_id"}},{"kind":"Field","name":{"kind":"Name","value":"message_id"}},{"kind":"Field","name":{"kind":"Name","value":"message_body"}},{"kind":"Field","name":{"kind":"Name","value":"message_from_me"}},{"kind":"Field","name":{"kind":"Name","value":"ws_session_phone"}}]}}]}}]} as unknown as DocumentNode<ComplianceContactsParticipantsQueryQuery, ComplianceContactsParticipantsQueryQueryVariables>;
export const CompliancePoliciesGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompliancePoliciesGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_policies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc_emails"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<CompliancePoliciesGqlQuery, CompliancePoliciesGqlQueryVariables>;
export const CompliancePoliciesInsertGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompliancePoliciesInsertGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_policies_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_policies_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"cc_emails"}}]}}]}}]} as unknown as DocumentNode<CompliancePoliciesInsertGqlMutation, CompliancePoliciesInsertGqlMutationVariables>;
export const CompliancePoliciesUpdateGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompliancePoliciesUpdateGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"columns"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_policies_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_compliance_policies_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"columns"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc_emails"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<CompliancePoliciesUpdateGqlMutation, CompliancePoliciesUpdateGqlMutationVariables>;
export const ComplianceRulesInsertGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceRulesInsertGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_rules_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_rules_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","alias":{"kind":"Name","value":"policy"},"name":{"kind":"Name","value":"compliance_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"enable"}},{"kind":"Field","name":{"kind":"Name","value":"risk"}}]}}]}}]} as unknown as DocumentNode<ComplianceRulesInsertGqlMutation, ComplianceRulesInsertGqlMutationVariables>;
export const ComplianceRulesUpdateGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceRulesUpdateGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"columns"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_rules_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_compliance_rules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"columns"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","alias":{"kind":"Name","value":"policy"},"name":{"kind":"Name","value":"compliance_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"enable"}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceRulesUpdateGqlMutation, ComplianceRulesUpdateGqlMutationVariables>;
export const ComplianceContactsUpsertGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceContactsUpsertGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_contacts_raw_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_contacts_raw"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"compliance_contacts_compliance_id_email_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"phone"},{"kind":"EnumValue","value":"deleted"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"invite_counter"}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceContactsUpsertGqlMutation, ComplianceContactsUpsertGqlMutationVariables>;
export const ComplianceContactGroupUsertGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceContactGroupUsertGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_group_contacts_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_group_contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"compliance_group_contacts_compliance_contact_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"compliance_group_id"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_group_id"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_contact_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceContactGroupUsertGqlMutation, ComplianceContactGroupUsertGqlMutationVariables>;
export const ComplianceGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active_team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active_team_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]} as unknown as DocumentNode<ComplianceGqlQuery, ComplianceGqlQueryVariables>;
export const DeleteComplianceGroupUsersGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteComplianceGroupUsersGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_compliance_group_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_group_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteComplianceGroupUsersGqlMutation, DeleteComplianceGroupUsersGqlMutationVariables>;
export const DeleteRelevantContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRelevantContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"relevantContactsIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_relevant_contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"relevantContactsIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteRelevantContactsMutation, DeleteRelevantContactsMutationVariables>;
export const DeleteTagsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTagsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagsIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagsIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteTagsGqlMutation, DeleteTagsGqlMutationVariables>;
export const ImportCsvGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportCsvGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvDataRows"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvDataRowInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disableContacts"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importCsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"complianceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"csvDataRows"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvDataRows"}}},{"kind":"Argument","name":{"kind":"Name","value":"disableContacts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disableContacts"}}},{"kind":"Argument","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ImportCsvGqlMutation, ImportCsvGqlMutationVariables>;
export const ImportCsvDiffGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportCsvDiffGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvDataRows"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvDataRowInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importCsvDiff"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"complianceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"csvDataRows"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvDataRows"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diffConflicts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"csvDataRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"send_contact_invite"}},{"kind":"Field","name":{"kind":"Name","value":"send_manager_invite"}},{"kind":"Field","name":{"kind":"Name","value":"manager"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diffRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"new"}},{"kind":"Field","name":{"kind":"Name","value":"old"}}]}},{"kind":"Field","name":{"kind":"Name","value":"send_contact_invite"}},{"kind":"Field","name":{"kind":"Name","value":"send_manager_invite"}},{"kind":"Field","name":{"kind":"Name","value":"manager"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"new"}},{"kind":"Field","name":{"kind":"Name","value":"old"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"new"}},{"kind":"Field","name":{"kind":"Name","value":"old"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupsToCreate"}},{"kind":"Field","name":{"kind":"Name","value":"usersToInsert"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ImportCsvDiffGqlMutation, ImportCsvDiffGqlMutationVariables>;
export const ImportCsvManagersGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportCsvManagersGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvRows"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvManagerRow"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importCsvManagers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"complianceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"csvRows"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvRows"}}},{"kind":"Argument","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ImportCsvManagersGqlMutation, ImportCsvManagersGqlMutationVariables>;
export const ImportCsvManagersDiffDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportCsvManagersDiff"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvRows"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvManagerRow"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importCsvManagersDiff"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"csvRows"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvRows"}}},{"kind":"Argument","name":{"kind":"Name","value":"complianceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diffManagerRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"new"}},{"kind":"Field","name":{"kind":"Name","value":"old"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"new"}},{"kind":"Field","name":{"kind":"Name","value":"old"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"new"}},{"kind":"Field","name":{"kind":"Name","value":"old"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invite"}}]}}]}}]}}]} as unknown as DocumentNode<ImportCsvManagersDiffMutation, ImportCsvManagersDiffMutationVariables>;
export const ImportCsvRelevantContactsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportCsvRelevantContactsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"relevantContactsCsvRows"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RelevantContactsCsvRow"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removeContacts"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importCsvRelevantContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"complianceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"relevantContactsCsvRows"},"value":{"kind":"Variable","name":{"kind":"Name","value":"relevantContactsCsvRows"}}},{"kind":"Argument","name":{"kind":"Name","value":"removeContacts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removeContacts"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ImportCsvRelevantContactsGqlMutation, ImportCsvRelevantContactsGqlMutationVariables>;
export const ImportCsvRelevantContactsDiffGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportCsvRelevantContactsDiffGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"relevantContactsCsvRows"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RelevantContactsCsvRow"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importCsvRelevantContactsDiff"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"complianceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"relevantContactsCsvRows"},"value":{"kind":"Variable","name":{"kind":"Name","value":"relevantContactsCsvRows"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relevantContactsDiff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"new"}},{"kind":"Field","name":{"kind":"Name","value":"old"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"new"}},{"kind":"Field","name":{"kind":"Name","value":"old"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"new"}},{"kind":"Field","name":{"kind":"Name","value":"old"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ImportCsvRelevantContactsDiffGqlMutation, ImportCsvRelevantContactsDiffGqlMutationVariables>;
export const ImportCsvRulesGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportCsvRulesGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvRuleRows"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvRuleRow"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disableRules"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importCsvRules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"complianceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"csvRuleRows"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvRuleRows"}}},{"kind":"Argument","name":{"kind":"Name","value":"disableRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disableRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertedRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"policy_id"}},{"kind":"Field","name":{"kind":"Name","value":"policy_name"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"enable"}},{"kind":"Field","name":{"kind":"Name","value":"risk"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabledRules"}}]}}]}}]} as unknown as DocumentNode<ImportCsvRulesGqlMutation, ImportCsvRulesGqlMutationVariables>;
export const ImportCsvRulesDiffGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportCsvRulesDiffGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvRuleRows"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvRuleRow"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importCsvRulesDiff"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"complianceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"csvRuleRows"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvRuleRows"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diffRuleRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"new"}},{"kind":"Field","name":{"kind":"Name","value":"old"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"new"}},{"kind":"Field","name":{"kind":"Name","value":"old"}}]}},{"kind":"Field","name":{"kind":"Name","value":"policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"new"}},{"kind":"Field","name":{"kind":"Name","value":"old"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"new"}},{"kind":"Field","name":{"kind":"Name","value":"old"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"old"}},{"kind":"Field","name":{"kind":"Name","value":"new"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"policiesToInsert"}},{"kind":"Field","name":{"kind":"Name","value":"rulesToInsert"}}]}}]}}]} as unknown as DocumentNode<ImportCsvRulesDiffGqlMutation, ImportCsvRulesDiffGqlMutationVariables>;
export const InsertComplianceGroupUsersGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertComplianceGroupUsersGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_group_users_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_group_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_group_id"}}]}}]}}]}}]} as unknown as DocumentNode<InsertComplianceGroupUsersGqlMutation, InsertComplianceGroupUsersGqlMutationVariables>;
export const InsertRelevantContactGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertRelevantContactGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"relevant_contacts_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_relevant_contacts_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<InsertRelevantContactGqlMutation, InsertRelevantContactGqlMutationVariables>;
export const InsertTagGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertTagGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tags_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_tags_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}}]}}]}}]} as unknown as DocumentNode<InsertTagGqlMutation, InsertTagGqlMutationVariables>;
export const InsertUsersGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUsersGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersInsert"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inserted_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<InsertUsersGqlMutation, InsertUsersGqlMutationVariables>;
export const InviteUsersGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InviteUsersGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitingUser"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvitingUser"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersInvite"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invitingUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitingUser"}}},{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invited_users"}}]}}]}}]} as unknown as DocumentNode<InviteUsersGqlMutation, InviteUsersGqlMutationVariables>;
export const LogoutDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LogoutDashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"}}]}}]}}]} as unknown as DocumentNode<LogoutDashboardMutation, LogoutDashboardMutationVariables>;
export const ComplianceMessagesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceMessagesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_messages_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"order_by"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"unix_timestamp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_me"}},{"kind":"Field","name":{"kind":"Name","value":"is_group_msg"}},{"kind":"Field","name":{"kind":"Name","value":"message_key"}},{"kind":"Field","name":{"kind":"Name","value":"mime_type"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unix_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"transcription"}},{"kind":"Field","name":{"kind":"Name","value":"is_deleted"}},{"kind":"Field","name":{"kind":"Name","value":"ws_session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ws_session_ref"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participant_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceMessagesQueryQuery, ComplianceMessagesQueryQueryVariables>;
export const ComplianceMessagesSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ComplianceMessagesSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_messages_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"unix_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_me"}},{"kind":"Field","name":{"kind":"Name","value":"is_group_msg"}},{"kind":"Field","name":{"kind":"Name","value":"message_key"}},{"kind":"Field","name":{"kind":"Name","value":"mime_type"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unix_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"transcription"}},{"kind":"Field","name":{"kind":"Name","value":"is_deleted"}},{"kind":"Field","name":{"kind":"Name","value":"ws_session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ws_session_ref"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participant_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceMessagesSubscriptionSubscription, ComplianceMessagesSubscriptionSubscriptionVariables>;
export const GetMessagesAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetMessagesAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentIdentifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactPhone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"analysisType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentPhone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMessagesAnalysis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"complianceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"agentIdentifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentIdentifier"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contactPhone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactPhone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"analysisType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"analysisType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"agentPhone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentPhone"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messagesAnalised"}}]}}]}}]} as unknown as DocumentNode<GetMessagesAnalysisMutation, GetMessagesAnalysisMutationVariables>;
export const NotificationsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NotificationsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"target"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"compliance","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"target"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"team","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"target"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"user","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<NotificationsGqlQuery, NotificationsGqlQueryVariables>;
export const NotificationsSubscriptionGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"NotificationsSubscriptionGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"target"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"compliance","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"target"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"team","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"target"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"user","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<NotificationsSubscriptionGqlSubscription, NotificationsSubscriptionGqlSubscriptionVariables>;
export const ComplianceUserRoleGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceUserRoleGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"compliance_role","block":false}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceUserRoleGqlQuery, ComplianceUserRoleGqlQueryVariables>;
export const RelevantContactsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RelevantContactsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relevant_contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"relevant_contacts_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RelevantContactsGqlQuery, RelevantContactsGqlQueryVariables>;
export const RemoveMembersFromTeamGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMembersFromTeamGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"membersIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"membersIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roles_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_roles_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"membersIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"role_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_compliance_group_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"membersIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roles_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_group_id"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveMembersFromTeamGqlMutation, RemoveMembersFromTeamGqlMutationVariables>;
export const RolesByProductIdGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RolesByProductIdGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<RolesByProductIdGqlQuery, RolesByProductIdGqlQueryVariables>;
export const TagsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TagsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contains"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"permissions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contains"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]} as unknown as DocumentNode<TagsGqlQuery, TagsGqlQueryVariables>;
export const UpdateUserGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_compliance_group_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_group_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"columns"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"users_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"columns"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpsertComplianceEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertComplianceEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"events"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_events_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"events"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"compliance_events_compliance_rule_id_compliance_contact_id_comp"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"status"},{"kind":"EnumValue","value":"comment"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertComplianceEventsMutation, UpsertComplianceEventsMutationVariables>;
export const UpsertComplianceEventsClassificationGoalGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertComplianceEventsClassificationGoalGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"goals"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_events_classification_goals_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_events_classification_goals_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"goals"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"compliance_events_classification_goals_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"enable"},{"kind":"EnumValue","value":"high"},{"kind":"EnumValue","value":"low"},{"kind":"EnumValue","value":"moderate"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"enable"}},{"kind":"Field","name":{"kind":"Name","value":"high"}},{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"moderate"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpsertComplianceEventsClassificationGoalGqlMutation, UpsertComplianceEventsClassificationGoalGqlMutationVariables>;
export const CurrentUserQueryGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUserQueryGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CurrentUserQueryGqlQuery, CurrentUserQueryGqlQueryVariables>;
export const VerifyWhatsAppDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"verifyWhatsApp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"twilioVerifyWhatsApp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<VerifyWhatsAppMutation, VerifyWhatsAppMutationVariables>;
export const InsertTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_tokens_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"tokens_user_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"token"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<InsertTokenMutation, InsertTokenMutationVariables>;
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const EditUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cpf_cnpj"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zip_code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"number"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"street"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"district"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complement"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cpf_cnpj"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cpf_cnpj"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"zip_code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zip_code"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"street"},"value":{"kind":"Variable","name":{"kind":"Name","value":"street"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"district"},"value":{"kind":"Variable","name":{"kind":"Name","value":"district"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"complement"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complement"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customer_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"cpf_cnpj"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"district"}},{"kind":"Field","name":{"kind":"Name","value":"complement"}},{"kind":"Field","name":{"kind":"Name","value":"customer_id"}}]}}]}}]}}]} as unknown as DocumentNode<EditUserMutation, EditUserMutationVariables>;
export const FindUserByExtIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findUserByExtId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ext_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ext_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ext_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"cpf_cnpj"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"district"}},{"kind":"Field","name":{"kind":"Name","value":"complement"}},{"kind":"Field","name":{"kind":"Name","value":"customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"two_factor_authentication"}},{"kind":"Field","name":{"kind":"Name","value":"passwordless"}},{"kind":"Field","name":{"kind":"Name","value":"ext_id"}},{"kind":"Field","name":{"kind":"Name","value":"roles_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_personal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_personal"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindUserByExtIdQuery, FindUserByExtIdQueryVariables>;
export const FindUserByEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findUserByEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"cpf_cnpj"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"district"}},{"kind":"Field","name":{"kind":"Name","value":"complement"}},{"kind":"Field","name":{"kind":"Name","value":"customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"two_factor_authentication"}},{"kind":"Field","name":{"kind":"Name","value":"passwordless"}},{"kind":"Field","name":{"kind":"Name","value":"roles_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_personal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_personal"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindUserByEmailQuery, FindUserByEmailQueryVariables>;
export const FindUserByPhoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findUserByPhone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"cpf_cnpj"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"district"}},{"kind":"Field","name":{"kind":"Name","value":"complement"}},{"kind":"Field","name":{"kind":"Name","value":"customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"two_factor_authentication"}},{"kind":"Field","name":{"kind":"Name","value":"passwordless"}},{"kind":"Field","name":{"kind":"Name","value":"roles_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_personal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_personal"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindUserByPhoneQuery, FindUserByPhoneQueryVariables>;
export const InsertUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"passwordless"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"passwordless"},"value":{"kind":"Variable","name":{"kind":"Name","value":"passwordless"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"cpf_cnpj"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"district"}},{"kind":"Field","name":{"kind":"Name","value":"complement"}},{"kind":"Field","name":{"kind":"Name","value":"customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"two_factor_authentication"}},{"kind":"Field","name":{"kind":"Name","value":"passwordless"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_personal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InsertUserMutation, InsertUserMutationVariables>;
export const ResetUserPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resetUserPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"old_password_hash_string_comparison_exp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String_comparison_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"new_password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"old_password_hash_string_comparison_exp"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"new_password"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const FindUserByRefreshTokenQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findUserByRefreshTokenQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refresh_token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jwt_refresh_token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refresh_token"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_personal"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindUserByRefreshTokenQueryQuery, FindUserByRefreshTokenQueryQueryVariables>;
export const UpdateUserRefreshTokenGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserRefreshTokenGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jwt_refresh_token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jwt_refresh_token"}}]}}]}}]} as unknown as DocumentNode<UpdateUserRefreshTokenGqlMutation, UpdateUserRefreshTokenGqlMutationVariables>;
export const GetUserAuthCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserAuthCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_auth_codes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<GetUserAuthCodeQuery, GetUserAuthCodeQueryVariables>;
export const TokenSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"tokenSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]}}]} as unknown as DocumentNode<TokenSubscriptionSubscription, TokenSubscriptionSubscriptionVariables>;
export const GetAuthDashboardTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetAuthDashboardToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authDashboardToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"dashboard_token"}}]}}]}}]} as unknown as DocumentNode<GetAuthDashboardTokenMutation, GetAuthDashboardTokenMutationVariables>;
export const FindRulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindRules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_rules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"cc_emails"}}]}}]}}]}}]} as unknown as DocumentNode<FindRulesQuery, FindRulesQueryVariables>;
export const FindComplianceContactFromSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindComplianceContactFromSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"session_uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ws_session_ref"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"session_uuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_group_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_group_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindComplianceContactFromSessionQuery, FindComplianceContactFromSessionQueryVariables>;
export const InsertEventMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertEventMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_events_insert_input"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_events_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"compliance_events_compliance_rule_id_compliance_contact_id_comp"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertEventMutationMutation, InsertEventMutationMutationVariables>;
export const FindPreviousEventMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindPreviousEventMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compliance_contact_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"30"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"unix_timestamp"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_contact_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compliance_contact_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"unix_timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message_key"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"mime_type"}},{"kind":"Field","name":{"kind":"Name","value":"is_group_msg"}},{"kind":"Field","name":{"kind":"Name","value":"from_me"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"unix_timestamp"}}]}}]}}]} as unknown as DocumentNode<FindPreviousEventMessagesQuery, FindPreviousEventMessagesQueryVariables>;
export const ComplianceFilterGroupsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceFilterGroupsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compliance"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compliance"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<ComplianceFilterGroupsGqlQuery, ComplianceFilterGroupsGqlQueryVariables>;
export const ComplianceFilterContactsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceFilterContactsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]} as unknown as DocumentNode<ComplianceFilterContactsGqlQuery, ComplianceFilterContactsGqlQueryVariables>;
export const ComplianceFilterMembersGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceFilterMembersGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]} as unknown as DocumentNode<ComplianceFilterMembersGqlQuery, ComplianceFilterMembersGqlQueryVariables>;
export const ComplianceFilterPoliciesGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceFilterPoliciesGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compliance"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_policies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compliance"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<ComplianceFilterPoliciesGqlQuery, ComplianceFilterPoliciesGqlQueryVariables>;
export const ComplianceTagsFilterGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComplianceTagsFilterGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"compliance_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<ComplianceTagsFilterGqlQuery, ComplianceTagsFilterGqlQueryVariables>;
export const ComplianceContactsInsertGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ComplianceContactsInsertGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_contacts_raw_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_contacts_raw"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"invite_counter"}}]}}]}}]}}]} as unknown as DocumentNode<ComplianceContactsInsertGqlMutation, ComplianceContactsInsertGqlMutationVariables>;
export const InsertWsSessionsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertWsSessionsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessions"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ws_sessions_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_ws_sessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<InsertWsSessionsGqlMutation, InsertWsSessionsGqlMutationVariables>;
export const InviteRulesRecipientsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InviteRulesRecipientsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteRuleId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invite_rules_recipients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invite_rule_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteRuleId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invite_rule_id"}},{"kind":"Field","name":{"kind":"Name","value":"send_to"}},{"kind":"Field","name":{"kind":"Name","value":"template"}}]}}]}}]} as unknown as DocumentNode<InviteRulesRecipientsGqlQuery, InviteRulesRecipientsGqlQueryVariables>;
export const InviteRulesGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InviteRulesGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invite_rules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"disconnection_period_start"}},{"kind":"Field","name":{"kind":"Name","value":"disconnection_period_end"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"invite_time"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"invite_until_accepted"}},{"kind":"Field","name":{"kind":"Name","value":"is_disabled"}}]}}]}}]} as unknown as DocumentNode<InviteRulesGqlQuery, InviteRulesGqlQueryVariables>;
export const InviteRulesDefaultGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InviteRulesDefaultGQL"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invite_rules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_default"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"disconnection_period_start"}},{"kind":"Field","name":{"kind":"Name","value":"disconnection_period_end"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"invite_time"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"invite_until_accepted"}},{"kind":"Field","name":{"kind":"Name","value":"is_disabled"}}]}}]}}]} as unknown as DocumentNode<InviteRulesDefaultGqlQuery, InviteRulesDefaultGqlQueryVariables>;
export const SelectUnauthenticatedSessionsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectUnauthenticatedSessionsGQL"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ws_sessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_contact"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"disconnected","block":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_contact"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"invited","block":false}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_contact"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"last_connected_at"}},{"kind":"Field","name":{"kind":"Name","value":"connected_at"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"invite_counter"}},{"kind":"Field","name":{"kind":"Name","value":"compliance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_contacts_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manager_email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_group_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SelectUnauthenticatedSessionsGqlQuery, SelectUnauthenticatedSessionsGqlQueryVariables>;
export const UpdateComplianceContactsWsSessionRefGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateComplianceContactsWSSessionRefGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_contacts_raw_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_contacts_raw"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"compliance_contacts_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"status"},{"kind":"EnumValue","value":"invite_counter"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateComplianceContactsWsSessionRefGqlMutation, UpdateComplianceContactsWsSessionRefGqlMutationVariables>;
export const UpdateLastConnectedAtSessionTimeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLastConnectedAtSessionTime"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastConnectedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_ws_sessions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"last_connected_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastConnectedAt"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"last_connected_at"}}]}}]}}]} as unknown as DocumentNode<UpdateLastConnectedAtSessionTimeMutation, UpdateLastConnectedAtSessionTimeMutationVariables>;
export const InsertLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"logs_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_logs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertLogsMutation, InsertLogsMutationVariables>;
export const FindUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cpf_cnpj"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"district"}},{"kind":"Field","name":{"kind":"Name","value":"complement"}},{"kind":"Field","name":{"kind":"Name","value":"customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_personal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<FindUserQuery, FindUserQueryVariables>;
export const MyMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MyMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<MyMutationMutation, MyMutationMutationVariables>;
export const FindUserWithPersonalTeamsByRefreshTokenQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findUserWithPersonalTeamsByRefreshTokenQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refresh_token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jwt_refresh_token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refresh_token"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_personal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<FindUserWithPersonalTeamsByRefreshTokenQueryQuery, FindUserWithPersonalTeamsByRefreshTokenQueryQueryVariables>;
export const AuthForgotPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthForgotPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authForgotPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<AuthForgotPasswordMutation, AuthForgotPasswordMutationVariables>;
export const SendAuthCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendAuthCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"twilioSendAuthCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<SendAuthCodeMutation, SendAuthCodeMutationVariables>;
export const UpdateTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTokenMutation, UpdateTokenMutationVariables>;
export const ComplianceContactsStatusQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"complianceContactsStatusQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_contacts_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"manager_email"}}]}}]}}]} as unknown as DocumentNode<ComplianceContactsStatusQueryQuery, ComplianceContactsStatusQueryQueryVariables>;
export const WeeklyEventsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"weeklyEventsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_events_weekly_reports_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_events_weekly_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"event_status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"policy"}},{"kind":"Field","name":{"kind":"Name","value":"risk"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"rule_name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"contact_email"}},{"kind":"Field","name":{"kind":"Name","value":"contact_name"}}]}}]}}]} as unknown as DocumentNode<WeeklyEventsQueryQuery, WeeklyEventsQueryQueryVariables>;
export const UpdateStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_compliance_contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ws_session"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"ws_session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateStatusMutation, UpdateStatusMutationVariables>;
export const UpdateStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stats"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ws_sessions_stats_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_ws_sessions_stats_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stats"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateStatsMutation, UpdateStatsMutationVariables>;
export const GetLastMessageToAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLastMessageToAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentIdentifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactPhone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentPhone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_contact"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentIdentifier"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"body"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactPhone"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentPhone"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentPhone"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactPhone"}}}]}}]}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"unix_timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"unix_timestamp"}}]}}]}}]} as unknown as DocumentNode<GetLastMessageToAnalysisQuery, GetLastMessageToAnalysisQueryVariables>;
export const GetMessagesToAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMessagesToAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentIdentifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactPhone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentPhone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"complianceId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_contact"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentIdentifier"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"body"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactPhone"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentPhone"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentPhone"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactPhone"}}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"unix_timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"unix_timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]} as unknown as DocumentNode<GetMessagesToAnalysisQuery, GetMessagesToAnalysisQueryVariables>;
export const UsersGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsersGQL"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<UsersGqlQuery, UsersGqlQueryVariables>;
export const CurrentContactGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentContactGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ws_sessions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"compliance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CurrentContactGqlQuery, CurrentContactGqlQueryVariables>;
export const UpdateComplianceContactsDataAfterInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateComplianceContactsDataAfterInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_contacts_raw_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_contacts_raw"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"compliance_contacts_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"status"},{"kind":"EnumValue","value":"invite_counter"},{"kind":"EnumValue","value":"deleted"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"invite_counter"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateComplianceContactsDataAfterInviteMutation, UpdateComplianceContactsDataAfterInviteMutationVariables>;
export const ContactsToInviteGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContactsToInviteGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contacts_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contacts_emails"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_contacts_raw"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contacts_ids"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contacts_emails"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"invite_counter"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"compliance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ws_session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<ContactsToInviteGqlQuery, ContactsToInviteGqlQueryVariables>;
export const UpdateComplianceContactsSessionRefToInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateComplianceContactsSessionRefToInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_contacts_raw_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_compliance_contacts_raw"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"compliance_contacts_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ws_session_ref"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"invite_counter"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"ws_session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateComplianceContactsSessionRefToInviteMutation, UpdateComplianceContactsSessionRefToInviteMutationVariables>;
export const FindMessagesByMinutesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindMessagesByMinutes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"unix_timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","alias":{"kind":"Name","value":"session_uuid"},"name":{"kind":"Name","value":"ws_session_ref"}},{"kind":"Field","name":{"kind":"Name","value":"from_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unix_timestamp"}}]}}]}}]} as unknown as DocumentNode<FindMessagesByMinutesQuery, FindMessagesByMinutesQueryVariables>;
export const InsertComplianceUsersGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertComplianceUsersGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}}]} as unknown as DocumentNode<InsertComplianceUsersGqlMutation, InsertComplianceUsersGqlMutationVariables>;
export const InsertUserAuthCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUserAuthCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"created_at"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_auth_codes_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"created_at"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_auth_codes_user_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"code"},{"kind":"EnumValue","value":"mode"},{"kind":"EnumValue","value":"created_at"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertUserAuthCodeMutation, InsertUserAuthCodeMutationVariables>;
export const UserDetailsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserDetailsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserDetailsGqlQuery, UserDetailsGqlQueryVariables>;
export const GetCompliancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCompliances"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active_team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active_team_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"compliance_events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetCompliancesQuery, GetCompliancesQueryVariables>;
export const LogsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LogsGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teamId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<LogsGqlQuery, LogsGqlQueryVariables>;
export const VerifyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"verify"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authVerifyToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<VerifyMutation, VerifyMutationVariables>;
export const AuthSignInOrSignUpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthSignInOrSignUp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthSignInOrSignUpInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authSignInOrSignUp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"dashboard_token"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"two_factor_authentication"}},{"kind":"Field","name":{"kind":"Name","value":"passwordless"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_name"}}]}}]}}]} as unknown as DocumentNode<AuthSignInOrSignUpMutation, AuthSignInOrSignUpMutationVariables>;
export const CheckConsentGivenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"checkConsentGiven"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_uuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contact_phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contact_phone"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contact_phone"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"agent_uuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_uuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pending"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CheckConsentGivenQuery, CheckConsentGivenQueryVariables>;
export const InsertConsentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertConsent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_uuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contact_phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"crm"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_consent_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agent_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_uuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contact_phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contact_phone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"compliance_id"},"value":{"kind":"IntValue","value":"2"}},{"kind":"ObjectField","name":{"kind":"Name","value":"crm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"crm"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"consent_at"},"value":{"kind":"StringValue","value":"now()","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"pending"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"consent_contact_phone_agent_uuid_compliance_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"crm"},{"kind":"EnumValue","value":"pending"},{"kind":"EnumValue","value":"consent_at"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertConsentMutation, InsertConsentMutationVariables>;
export const GetContactsConsentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getContactsConsents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ws_session_ref"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agent_uuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ws_session_ref"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pending"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact_phone"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"crm"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"external_name"}},{"kind":"Field","name":{"kind":"Name","value":"external_crm"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliance_messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"to"}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ws_session_ref"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ws_session_ref"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_group_msg"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"from_me"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"profile_pic"}},{"kind":"Field","name":{"kind":"Name","value":"consents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"external_name"}},{"kind":"Field","name":{"kind":"Name","value":"external_crm"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"crm"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetContactsConsentsQuery, GetContactsConsentsQueryVariables>;
export const LogScanPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LogScanPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScanPageOpenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logScanPageOpen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<LogScanPageMutation, LogScanPageMutationVariables>;
export const LogScanQrcodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LogScanQrcode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScanQrcodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logScanQrcode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<LogScanQrcodeMutation, LogScanQrcodeMutationVariables>;
export const GetUsersTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_personal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}}]} as unknown as DocumentNode<GetUsersTeamQuery, GetUsersTeamQueryVariables>;
export const UserTeamsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserTeamsGQL"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_personal"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UserTeamsGqlQuery, UserTeamsGqlQueryVariables>;
export const CreateTeamGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTeamGQL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"group_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_teams_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"group_name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner_user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_personal"}}]}}]}}]} as unknown as DocumentNode<CreateTeamGqlMutation, CreateTeamGqlMutationVariables>;